import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Injectable, TemplateRef, Directive, ContentChild, ContentChildren, NgModule, EventEmitter, Output, ViewChild, HostListener, Inject, ViewChildren, Pipe, InjectionToken, Optional, inject, SecurityContext, HostBinding, ElementRef, forwardRef, ViewContainerRef, Injector, APP_INITIALIZER } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, DatePipe, DecimalPipe } from '@angular/common';
import * as i2 from '@angular/material/table';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import * as i3 from '@ngx-translate/core';
import { TranslateModule, TranslateStore, TranslateService, TranslateLoader } from '@ngx-translate/core';
import * as i10 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule, HttpHeaders, HTTP_INTERCEPTORS, HttpClientXsrfModule } from '@angular/common/http';
import { map, distinctUntilChanged, take, delay, catchError, skipWhile, takeUntil, filter, first, tap, share, mergeMap, pairwise, buffer, debounceTime, switchMap, retry, startWith, shareReplay } from 'rxjs/operators';
import { Subject, fromEvent, ReplaySubject, BehaviorSubject, Observable, from, throwError, merge, combineLatest, of, forkJoin, EMPTY } from 'rxjs';
import * as i2$1 from '@alfresco/adf-extensions';
import { mergeObjects, ExtensionsModule } from '@alfresco/adf-extensions';
import * as i2$2 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i2$7 from '@angular/material/core';
import { DateAdapter, MatNativeDateModule, MatOptionModule, MatRippleModule, MAT_DATE_FORMATS, MatLineModule } from '@angular/material/core';
import moment, { isMoment } from 'moment';
import * as i11$1 from '@mat-datetimepicker/core';
import { MatDatetimepickerModule, MatNativeDatetimeModule, DatetimeAdapter, MAT_DATETIME_FORMATS } from '@mat-datetimepicker/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i3$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$5 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i10$1 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i5$2 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$4 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import * as i1$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7$1 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i3$2 from '@angular/material/menu';
import { MatMenuModule, MatMenuTrigger, MatMenuItem } from '@angular/material/menu';
import * as i8 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i5 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import * as i1$6 from '@angular/material/select';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import * as i2$8 from '@angular/material/sidenav';
import { MatSidenavModule, MatSidenav } from '@angular/material/sidenav';
import * as i6$2 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i1$7 from '@angular/material/snack-bar';
import { MatSnackBarModule, MAT_SNACK_BAR_DATA, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import * as i2$6 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i2$3 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i6$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i11$2 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i1$2 from '@angular/platform-browser';
import Cropper from 'cropperjs';
import * as i7 from '@angular/forms';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i6 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UP_ARROW, DOWN_ARROW, TAB, ESCAPE, ENTER } from '@angular/cdk/keycodes';
import * as i11 from '@angular/cdk/a11y';
import { FocusKeyManager, A11yModule } from '@angular/cdk/a11y';
import { AlfrescoApiConfig, AlfrescoApi, PeopleApi, UserProfileApi } from '@alfresco/js-api';
import * as i2$4 from '@angular/router';
import { RouterModule, Router } from '@angular/router';
import * as i1$5 from '@angular/cdk/overlay';
import { OverlayModule, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { trigger, transition, style, animate, state, sequence, query, group } from '@angular/animations';
import * as i12 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i4$1 from '@angular/material/divider';
import * as i5$1 from '@angular/cdk/text-field';
import { MomentDatetimeAdapter, MAT_MOMENT_DATETIME_FORMATS } from '@mat-datetimepicker/moment';
import * as i1$8 from '@angular/cdk/layout';
import { TestBed } from '@angular/core/testing';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RouterTestingModule } from '@angular/router/testing';
import * as i2$9 from '@angular/cdk/bidi';
import * as i3$3 from '@alfresco/adf-core/api';
import { API_CLIENT_FACTORY_TOKEN, AlfrescoJsClientsModule } from '@alfresco/adf-core/api';
import { AuthenticationInterceptor, Authentication } from '@alfresco/adf-core/auth';
import * as i1$9 from 'angular-oauth2-oidc';
import { OAuthStorage, OAuthService, AUTH_CONFIG, OAuthModule } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutExtensionListComponent {
    constructor() {
        this.columns = [
            {
                columnDef: 'name',
                header: 'ABOUT.PLUGINS.NAME',
                cell: (row) => `${row.$name}`
            },
            {
                columnDef: 'version',
                header: 'ABOUT.PLUGINS.VERSION',
                cell: (row) => `${row.$version}`
            }
        ];
        this.displayedColumns = this.columns.map((x) => x.columnDef);
        this.data = [];
    }
}
AboutExtensionListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutExtensionListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutExtensionListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutExtensionListComponent, selector: "adf-about-extension-list", inputs: { data: "data" }, ngImport: i0, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutExtensionListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-extension-list', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutGithubLinkComponent {
    constructor() {
        /** Commit corresponding to the version of ADF to be used. */
        this.url = 'https://github.com/Alfresco/alfresco-ng2-components/commits/';
        /** Current version of the app running */
        this.version = '';
        /** Title of app running */
        this.application = '';
    }
}
AboutGithubLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutGithubLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutGithubLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutGithubLinkComponent, selector: "adf-about-github-link", inputs: { url: "url", version: "version", application: "application" }, ngImport: i0, template: "<div class=\"adf-github-link-container\">\n    <header data-automation-id=\"adf-github-source-code-title\">{{ 'ABOUT.SOURCE_CODE.TITLE' | translate }}</header>\n    <mat-card class=\"mat-elevation-z0\">\n        <h3 data-automation-id=\"adf-github-app-title\">{{application}}</h3>\n        <p *ngIf=\"version\" data-automation-id=\"adf-github-version\">{{ 'ABOUT.VERSION' | translate }}: {{ version }}</p>\n\n        <div *ngIf=\"url\">\n            <small>{{ 'ABOUT.SOURCE_CODE.DESCRIPTION' | translate }}</small>\n            <div data-automation-id=\"adf-github-url\">\n                <a [href]=\"url\" target=\"_blank\">{{url}}</a>\n            </div>\n        </div>\n    </mat-card>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i10.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutGithubLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-github-link', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-github-link-container\">\n    <header data-automation-id=\"adf-github-source-code-title\">{{ 'ABOUT.SOURCE_CODE.TITLE' | translate }}</header>\n    <mat-card class=\"mat-elevation-z0\">\n        <h3 data-automation-id=\"adf-github-app-title\">{{application}}</h3>\n        <p *ngIf=\"version\" data-automation-id=\"adf-github-version\">{{ 'ABOUT.VERSION' | translate }}: {{ version }}</p>\n\n        <div *ngIf=\"url\">\n            <small>{{ 'ABOUT.SOURCE_CODE.DESCRIPTION' | translate }}</small>\n            <div data-automation-id=\"adf-github-url\">\n                <a [href]=\"url\" target=\"_blank\">{{url}}</a>\n            </div>\n        </div>\n    </mat-card>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { url: [{
                type: Input
            }], version: [{
                type: Input
            }], application: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutLicenseListComponent {
    constructor() {
        this.columns = [
            {
                columnDef: 'property',
                header: 'ABOUT.LICENSE.PROPERTY',
                cell: (row) => `${row.property}`
            },
            {
                columnDef: 'value',
                header: 'ABOUT.LICENSE.VALUE',
                cell: (row) => `${row.value}`
            }
        ];
        this.displayedColumns = this.columns.map((x) => x.columnDef);
        this.data = [];
    }
}
AboutLicenseListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutLicenseListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutLicenseListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutLicenseListComponent, selector: "adf-about-license-list", inputs: { data: "data" }, ngImport: i0, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\" [innerHTML]=\"column.cell(row)\"></mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n", styles: ["mat-cell{white-space:pre-line;line-height:30px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutLicenseListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-license-list', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\" [innerHTML]=\"column.cell(row)\"></mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n", styles: ["mat-cell{white-space:pre-line;line-height:30px}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ModuleListComponent {
    constructor() {
        this.columns = [
            {
                columnDef: 'title',
                header: 'ABOUT.MODULES.NAME',
                cell: (row) => `${row.title}`
            },
            {
                columnDef: 'version',
                header: 'ABOUT.MODULES.VERSION',
                cell: (row) => `${row.version}`
            }
        ];
        this.displayedColumns = this.columns.map((x) => x.columnDef);
        this.data = [];
    }
}
ModuleListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ModuleListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ModuleListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ModuleListComponent, selector: "adf-about-module-list", inputs: { data: "data" }, ngImport: i0, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ModuleListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-module-list', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PackageListComponent {
    constructor() {
        this.columns = [
            {
                columnDef: 'title',
                header: 'ABOUT.PACKAGES.NAME',
                cell: (row) => `${row.name}`
            },
            {
                columnDef: 'version',
                header: 'ABOUT.PACKAGES.VERSION',
                cell: (row) => `${row.version}`
            }
        ];
        this.displayedColumns = this.columns.map((x) => x.columnDef);
        this.data = [];
    }
    ngOnInit() {
        const regexp = new RegExp('^(@alfresco)');
        if (this.dependencies) {
            const libs = Object.keys(this.dependencies).filter((val) => regexp.test(val));
            this.data = [];
            libs.forEach((val) => {
                this.data.push({
                    name: val,
                    version: (this.dependencies[val])
                });
            });
        }
    }
}
PackageListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PackageListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PackageListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PackageListComponent, selector: "adf-about-package-list", inputs: { dependencies: "dependencies", data: "data" }, ngImport: i0, template: "<mat-table [dataSource]=\"data\" class=\"adf-package-list-table\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef class=\"adf-package-list-table__header-cell\">\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\" class=\"adf-package-list-table__row-cell\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\" class=\"adf-package-list-table__header-row\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\" class=\"adf-package-list-table__row\"></mat-row>\n</mat-table>\n", styles: [".adf-package-list-table{background:var(--adf-package-list-table-background)}.adf-package-list-table__header-row{border-bottom-color:var(--adf-package-list-table-header-border-bottom-color);border-style:var(--adf-package-list-table-header-border-style);border-width:var(--adf-package-list-table-header-border-width);border-bottom-width:var(--adf-package-list-table-header-border-bottom-width);min-height:var(--adf-package-list-table-header-min-height)}.adf-package-list-table__header-cell{color:var(--adf-package-list-table-header-cell-color)}.adf-package-list-table__row{border-bottom-color:var(--adf-package-list-table-row-border-bottom-color);border-style:var(--adf-package-list-table-row-border-style);border-width:var(--adf-package-list-table-row-border-width);border-bottom-width:var(--adf-package-list-table-row-border-bottom-width);min-height:var(--adf-package-list-table-row-min-height)}.adf-package-list-table__row-cell{color:var(--adf-package-list-table-row-cell-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PackageListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-package-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-table [dataSource]=\"data\" class=\"adf-package-list-table\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef class=\"adf-package-list-table__header-cell\">\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\" class=\"adf-package-list-table__row-cell\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\" class=\"adf-package-list-table__header-row\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\" class=\"adf-package-list-table__row\"></mat-row>\n</mat-table>\n", styles: [".adf-package-list-table{background:var(--adf-package-list-table-background)}.adf-package-list-table__header-row{border-bottom-color:var(--adf-package-list-table-header-border-bottom-color);border-style:var(--adf-package-list-table-header-border-style);border-width:var(--adf-package-list-table-header-border-width);border-bottom-width:var(--adf-package-list-table-header-border-bottom-width);min-height:var(--adf-package-list-table-header-min-height)}.adf-package-list-table__header-cell{color:var(--adf-package-list-table-header-cell-color)}.adf-package-list-table__row{border-bottom-color:var(--adf-package-list-table-row-border-bottom-color);border-style:var(--adf-package-list-table-row-border-style);border-width:var(--adf-package-list-table-row-border-width);border-bottom-width:var(--adf-package-list-table-row-border-bottom-width);min-height:var(--adf-package-list-table-row-min-height)}.adf-package-list-table__row-cell{color:var(--adf-package-list-table-row-cell-color)}\n"] }]
        }], propDecorators: { dependencies: [{
                type: Input
            }], data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BpmProductVersionModel {
    constructor(obj) {
        if (obj) {
            this.edition = obj.edition || null;
            this.majorVersion = obj.majorVersion || null;
            this.revisionVersion = obj.revisionVersion || null;
            this.minorVersion = obj.minorVersion || null;
            this.type = obj.type || null;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ObjectUtils {
    /**
     * Gets a value from an object by composed key
     * ObjectUtils.getValue({ item: { nodeType: 'cm:folder' }}, 'item.nodeType') ==> 'cm:folder'
     *
     * @param target
     * @param key
     */
    static getValue(target, key) {
        if (!target) {
            return undefined;
        }
        const keys = key.split('.');
        key = '';
        do {
            key += keys.shift();
            const value = target[key];
            if (value !== undefined && (typeof value === 'object' || !keys.length)) {
                target = value;
                key = '';
            }
            else if (!keys.length) {
                target = undefined;
            }
            else {
                key += '.';
            }
        } while (keys.length);
        return target;
    }
    static merge(...objects) {
        const result = {};
        objects.forEach((source) => {
            Object.keys(source).forEach((prop) => {
                if (prop in result && Array.isArray(result[prop])) {
                    result[prop] = result[prop].concat(source[prop]);
                }
                else if (prop in result && typeof result[prop] === 'object') {
                    result[prop] = ObjectUtils.merge(result[prop], source[prop]);
                }
                else {
                    result[prop] = source[prop];
                }
            });
        });
        return result;
    }
    static isObject(target) {
        return target === Object(target);
    }
    static isEmpty(target) {
        return target && Object.keys(target).length === 0 && Object.getPrototypeOf(target) === Object.prototype;
    }
    static hasKeys(target) {
        return target && Object.keys(target).length > 0;
    }
    static isBooleanObject(target) {
        return Object.values(target).every(value => typeof value === 'boolean');
    }
    static booleanPrettify(target, enhancer) {
        if (!target ||
            ObjectUtils.isEmpty(target) ||
            !ObjectUtils.isBooleanObject(target)) {
            return '';
        }
        if (!ObjectUtils.isObject(target) ||
            !ObjectUtils.hasKeys(target)) {
            return target.toString();
        }
        const greenBorderWhiteCheckSymbol = '&#9989';
        const redCrossSymbol = '&#10060';
        target = Object.keys(target).map((key) => {
            if (target[key]) {
                if (enhancer) {
                    return `${greenBorderWhiteCheckSymbol} ${enhancer(key)}`;
                }
                else {
                    return `${greenBorderWhiteCheckSymbol} ${key}`;
                }
            }
            if (enhancer) {
                return `${redCrossSymbol} ${enhancer(key)}`;
            }
            else {
                return `${redCrossSymbol} ${key}`;
            }
        }).join('\n');
        return target;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* spellchecker: disable */
// eslint-disable-next-line no-shadow
var AppConfigValues;
(function (AppConfigValues) {
    AppConfigValues["APP_CONFIG_LANGUAGES_KEY"] = "languages";
    AppConfigValues["PROVIDERS"] = "providers";
    AppConfigValues["OAUTHCONFIG"] = "oauth2";
    AppConfigValues["ECMHOST"] = "ecmHost";
    AppConfigValues["BASESHAREURL"] = "baseShareUrl";
    AppConfigValues["BPMHOST"] = "bpmHost";
    AppConfigValues["IDENTITY_HOST"] = "identityHost";
    AppConfigValues["AUTHTYPE"] = "authType";
    AppConfigValues["CONTEXTROOTECM"] = "contextRootEcm";
    AppConfigValues["CONTEXTROOTBPM"] = "contextRootBpm";
    AppConfigValues["ALFRESCO_REPOSITORY_NAME"] = "alfrescoRepositoryName";
    AppConfigValues["LOG_LEVEL"] = "logLevel";
    AppConfigValues["LOGIN_ROUTE"] = "loginRoute";
    AppConfigValues["DISABLECSRF"] = "disableCSRF";
    AppConfigValues["AUTH_WITH_CREDENTIALS"] = "auth.withCredentials";
    AppConfigValues["APPLICATION"] = "application";
    AppConfigValues["STORAGE_PREFIX"] = "application.storagePrefix";
    AppConfigValues["NOTIFY_DURATION"] = "notificationDefaultDuration";
})(AppConfigValues || (AppConfigValues = {}));
// eslint-disable-next-line no-shadow
var Status;
(function (Status) {
    Status["INIT"] = "init";
    Status["LOADING"] = "loading";
    Status["LOADED"] = "loaded";
})(Status || (Status = {}));
/* spellchecker: enable */
class AppConfigService {
    constructor(http, extensionService) {
        this.http = http;
        this.extensionService = extensionService;
        this.config = {
            application: {
                name: 'Alfresco ADF Application'
            },
            ecmHost: 'http://{hostname}{:port}/ecm',
            bpmHost: 'http://{hostname}{:port}/bpm',
            logLevel: 'silent'
        };
        this.status = Status.INIT;
        this.onLoadSubject = new Subject();
        this.onLoad = this.onLoadSubject.asObservable();
        extensionService.setup$.subscribe((config) => {
            this.onExtensionsLoaded(config);
        });
    }
    /**
     * Requests notification of a property value when it is loaded.
     *
     * @param property The desired property value
     * @returns Property value, when loaded
     */
    select(property) {
        return this.onLoadSubject
            .pipe(map((config) => config[property]), distinctUntilChanged());
    }
    /**
     * Gets the value of a named property.
     *
     * @param key Name of the property
     * @param defaultValue Value to return if the key is not found
     * @returns Value of the property
     */
    get(key, defaultValue) {
        let result = ObjectUtils.getValue(this.config, key);
        if (typeof result === 'string') {
            const keywords = new Map();
            keywords.set('hostname', this.getLocationHostname());
            keywords.set(':port', this.getLocationPort(':'));
            keywords.set('port', this.getLocationPort());
            keywords.set('protocol', this.getLocationProtocol());
            result = this.formatString(result, keywords);
        }
        if (typeof result === 'object') {
            result = JSON.parse(JSON.stringify(result).replace('{hostname}', this.getLocationHostname()));
            result = JSON.parse(JSON.stringify(result).replace('{:port}', this.getLocationPort(':')));
            result = JSON.parse(JSON.stringify(result).replace('{protocol}', this.getLocationProtocol()));
        }
        if (result === undefined) {
            return defaultValue;
        }
        return result;
    }
    /**
     * Gets the location.protocol value.
     *
     * @returns The location.protocol string
     */
    getLocationProtocol() {
        return location.protocol;
    }
    /**
     * Gets the location.hostname property.
     *
     * @returns Value of the property
     */
    getLocationHostname() {
        return location.hostname;
    }
    /**
     * Gets the location.port property.
     *
     * @param prefix Text added before port value
     * @returns Port with prefix
     */
    getLocationPort(prefix = '') {
        return location.port ? prefix + location.port : '';
    }
    onLoaded() {
        this.onLoadSubject.next(this.config);
    }
    onDataLoaded(data) {
        this.config = Object.assign({}, this.config, data || {});
        this.onLoadSubject.next(this.config);
        this.extensionService.setup$
            .pipe(take(1))
            .subscribe((config) => this.onExtensionsLoaded(config));
    }
    onExtensionsLoaded(config) {
        if (config) {
            const customConfig = config.appConfig;
            if (customConfig) {
                this.config = mergeObjects(this.config, customConfig);
            }
        }
    }
    /**
     * Loads the config file.
     *
     * @returns Notification when loading is complete
     */
    load() {
        return new Promise(async (resolve) => {
            const configUrl = `app.config.json?v=${Date.now()}`;
            if (this.status === Status.INIT) {
                this.status = Status.LOADING;
                this.http.get(configUrl).subscribe((data) => {
                    this.status = Status.LOADED;
                    resolve(data);
                    this.onDataLoaded(data);
                }, () => {
                    // eslint-disable-next-line no-console
                    console.error('app.config.json contains validation errors');
                    resolve(this.config);
                });
            }
            else if (this.status === Status.LOADED) {
                resolve(this.config);
            }
            else if (this.status === Status.LOADING) {
                this.onLoad.subscribe(() => {
                    resolve(this.config);
                });
            }
        });
    }
    /**
     * Call the discovery API to fetch configuration
     *
     * @returns Discovery configuration
     */
    loadWellKnown(hostIdp) {
        return new Promise(async (resolve, reject) => {
            this.http
                .get(`${hostIdp}/.well-known/openid-configuration`)
                .subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }
    /**
     * OAuth2 configuration
     */
    get oauth2() {
        const config = this.get(AppConfigValues.OAUTHCONFIG, {});
        const implicitFlow = config['implicitFlow'] === true || config['implicitFlow'] === 'true';
        const silentLogin = config['silentLogin'] === true || config['silentLogin'] === 'true';
        const codeFlow = config['codeFlow'] === true || config['codeFlow'] === 'true';
        return {
            ...config,
            implicitFlow,
            silentLogin,
            codeFlow
        };
    }
    formatString(str, keywords) {
        let result = str;
        keywords.forEach((value, key) => {
            const expr = new RegExp('{' + key + '}', 'gm');
            result = result.replace(expr, value);
        });
        return result;
    }
}
AppConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigService, deps: [{ token: i1$1.HttpClient }, { token: i2$1.ExtensionService }], target: i0.ɵɵFactoryTarget.Injectable });
AppConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i2$1.ExtensionService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AaeInfoService {
    constructor(httpClient, appConfigService) {
        this.httpClient = httpClient;
        this.appConfigService = appConfigService;
        this.contextRoot = '';
        this.contextRoot = appConfigService.get('bpmHost', '');
    }
    getServiceVersion(serviceName) {
        return this.httpClient.get(`${this.contextRoot}/${serviceName}/actuator/info`).pipe(map((response) => {
            let activitiVersion = 'N/A';
            if (response.build.activiti) {
                activitiVersion = response.build.activiti.version;
            }
            return {
                artifact: response.build.artifact,
                version: response.build.version,
                activiti: activitiVersion
            };
        }));
    }
}
AaeInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AaeInfoService, deps: [{ token: i1$1.HttpClient }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
AaeInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AaeInfoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AaeInfoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutPlatformVersionComponent {
    constructor(aaeInfoService, appConfigService) {
        this.aaeInfoService = aaeInfoService;
        this.appConfigService = appConfigService;
        /** repository info. */
        this.repository = null;
        /** process info. */
        this.process = null;
        this.modelingInfo();
        this.deploymentInfo();
        this.rbInfo();
    }
    modelingInfo() {
        this.modeling$ = this.aaeInfoService.getServiceVersion('modeling-service');
    }
    deploymentInfo() {
        this.deployment$ = this.aaeInfoService.getServiceVersion('deployment-service');
    }
    rbInfo() {
        this.rb$ = this.aaeInfoService.getServiceVersion(`${this.appConfigService.get('oauth2.clientId')}/rb`);
    }
    queryInfo() {
        this.query$ = this.aaeInfoService.getServiceVersion(`${this.appConfigService.get('oauth2.clientId')}/query`);
    }
}
AboutPlatformVersionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutPlatformVersionComponent, deps: [{ token: AaeInfoService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
AboutPlatformVersionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutPlatformVersionComponent, selector: "adf-about-platform-version", inputs: { repository: "repository", process: "process" }, ngImport: i0, template: "<ng-container *ngIf=\"process\">\n    <article>\n    <div>{{ 'ABOUT.VERSIONS.PROCESS_SERVICE' | translate }}</div>\n    <p>\n        {{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ process.majorVersion }}.{{process.minorVersion }}.{{ process.revisionVersion }}\n    </p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"repository\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.CONTENT_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.EDITION' | translate }}: {{ repository.edition }}</p>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ repository.version.display }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"modeling$ | async as modeling\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.MODELING_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ modeling.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"deployment$| async as deployment\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.DEPLOYMENT_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ deployment.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"rb$ | async as rb\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.RB' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.EDITION' | translate }}: {{ rb.artifact }}</p>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ rb.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"query$ | async as query\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.QUERY_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ query.version }}</p>\n    </article>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutPlatformVersionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-platform-version', encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"process\">\n    <article>\n    <div>{{ 'ABOUT.VERSIONS.PROCESS_SERVICE' | translate }}</div>\n    <p>\n        {{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ process.majorVersion }}.{{process.minorVersion }}.{{ process.revisionVersion }}\n    </p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"repository\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.CONTENT_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.EDITION' | translate }}: {{ repository.edition }}</p>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ repository.version.display }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"modeling$ | async as modeling\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.MODELING_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ modeling.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"deployment$| async as deployment\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.DEPLOYMENT_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ deployment.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"rb$ | async as rb\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.RB' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.EDITION' | translate }}: {{ rb.artifact }}</p>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ rb.version }}</p>\n    </article>\n</ng-container>\n\n<ng-container *ngIf=\"query$ | async as query\">\n    <article>\n        <div>{{ 'ABOUT.VERSIONS.QUERY_SERVICE' | translate }}</div>\n        <p>{{ 'ABOUT.VERSIONS.LABELS.VERSION' | translate }}: {{ query.version }}</p>\n    </article>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: AaeInfoService }, { type: AppConfigService }]; }, propDecorators: { repository: [{
                type: Input
            }], process: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutServerSettingsComponent {
    constructor(appConfig) {
        this.appConfig = appConfig;
        this.ecmHost = '';
        this.bpmHost = '';
    }
    ngOnInit() {
        this.ecmHost = this.appConfig.get(AppConfigValues.ECMHOST);
        this.bpmHost = this.appConfig.get(AppConfigValues.BPMHOST);
    }
}
AboutServerSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutServerSettingsComponent, deps: [{ token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
AboutServerSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutServerSettingsComponent, selector: "adf-about-server-settings", ngImport: i0, template: "<div class=\"adf-about-server-settings\">\n    <mat-card class=\"mat-elevation-z0 adf-about-server-settings__card\">\n        <p data-automation-id=\"adf-process-service-host\">\n            {{ 'ABOUT.SERVER_SETTINGS.PROCESS_SERVICE_HOST' | translate: {value: bpmHost} }}\n        </p>\n        <p data-automation-id=\"adf-content-service-host\">\n            {{ 'ABOUT.SERVER_SETTINGS.CONTENT_SERVICE_HOST' | translate: {value: ecmHost} }}\n        </p>\n    </mat-card>\n</div>\n", styles: [".adf-about-server-settings__card{background:var(--adf-about-server-settings-background);color:var(--adf-about-server-settings-color);border-radius:var(--adf-about-server-settings-border-radius);padding:var(--adf-about-server-settings-padding)}\n"], dependencies: [{ kind: "component", type: i10.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutServerSettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-server-settings', template: "<div class=\"adf-about-server-settings\">\n    <mat-card class=\"mat-elevation-z0 adf-about-server-settings__card\">\n        <p data-automation-id=\"adf-process-service-host\">\n            {{ 'ABOUT.SERVER_SETTINGS.PROCESS_SERVICE_HOST' | translate: {value: bpmHost} }}\n        </p>\n        <p data-automation-id=\"adf-content-service-host\">\n            {{ 'ABOUT.SERVER_SETTINGS.CONTENT_SERVICE_HOST' | translate: {value: ecmHost} }}\n        </p>\n    </mat-card>\n</div>\n", styles: [".adf-about-server-settings__card{background:var(--adf-about-server-settings-background);color:var(--adf-about-server-settings-color);border-radius:var(--adf-about-server-settings-border-radius);padding:var(--adf-about-server-settings-padding)}\n"] }]
        }], ctorParameters: function () { return [{ type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutStatusListComponent {
    constructor() {
        this.columns = [
            {
                columnDef: 'property',
                header: 'ABOUT.STATUS.PROPERTY',
                cell: (row) => `${row.property}`
            },
            {
                columnDef: 'value',
                header: 'ABOUT.STATUS.VALUE',
                cell: (row) => `${row.value}`
            }
        ];
        this.displayedColumns = this.columns.map((x) => x.columnDef);
        this.data = [];
    }
}
AboutStatusListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutStatusListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutStatusListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutStatusListComponent, selector: "adf-about-status-list", inputs: { data: "data" }, ngImport: i0, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutStatusListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-status-list', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-table [dataSource]=\"data\">\n  <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.columnDef\">\n    <mat-header-cell *matHeaderCellDef>\n      {{ column.header | translate }}\n    </mat-header-cell>\n    <mat-cell *matCellDef=\"let row\">{{ column.cell(row) }}</mat-cell>\n  </ng-container>\n\n  <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n  <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n</mat-table>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutPanelDirective {
}
AboutPanelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutPanelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AboutPanelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: AboutPanelDirective, selector: "adf-about-panel", inputs: { label: "label" }, queries: [{ propertyName: "layoutTemplate", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutPanelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-about-panel'
                }]
        }], propDecorators: { label: [{
                type: Input
            }], layoutTemplate: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutComponent {
}
AboutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutComponent, selector: "adf-about", queries: [{ propertyName: "panels", predicate: AboutPanelDirective }], ngImport: i0, template: "<mat-accordion [togglePosition]=\"'before'\" class=\"adf-about-panel\">\n    <ng-container *ngFor=\"let panel of panels\">\n        <mat-expansion-panel>\n            <mat-expansion-panel-header class=\"adf-about-panel-header\">\n                <mat-panel-title class=\"adf-about-panel-header__title\">{{panel.label}}</mat-panel-title>\n            </mat-expansion-panel-header>\n            <ng-container *ngTemplateOutlet=\"panel.layoutTemplate\"></ng-container>\n        </mat-expansion-panel>\n    </ng-container>\n</mat-accordion>\n", styles: [".adf-about-panel-header{height:var(--adf-about-panel-header-height)}.adf-about-panel-header__title{color:var(--adf-about-panel-header-title-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$2.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i2$2.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i2$2.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i2$2.MatExpansionPanelTitle, selector: "mat-panel-title" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about', encapsulation: ViewEncapsulation.None, template: "<mat-accordion [togglePosition]=\"'before'\" class=\"adf-about-panel\">\n    <ng-container *ngFor=\"let panel of panels\">\n        <mat-expansion-panel>\n            <mat-expansion-panel-header class=\"adf-about-panel-header\">\n                <mat-panel-title class=\"adf-about-panel-header__title\">{{panel.label}}</mat-panel-title>\n            </mat-expansion-panel-header>\n            <ng-container *ngTemplateOutlet=\"panel.layoutTemplate\"></ng-container>\n        </mat-expansion-panel>\n    </ng-container>\n</mat-accordion>\n", styles: [".adf-about-panel-header{height:var(--adf-about-panel-header-height)}.adf-about-panel-header__title{color:var(--adf-about-panel-header-title-color)}\n"] }]
        }], propDecorators: { panels: [{
                type: ContentChildren,
                args: [AboutPanelDirective]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUtils {
    static flatten(folder) {
        const reader = folder.createReader();
        const files = [];
        return new Promise((resolve) => {
            const iterations = [];
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            (function traverse() {
                reader.readEntries((entries) => {
                    if (!entries.length) {
                        Promise.all(iterations).then(() => resolve(files));
                    }
                    else {
                        iterations.push(Promise.all(entries.map((entry) => {
                            if (entry.isFile) {
                                return new Promise((resolveFile) => {
                                    entry.file((file) => {
                                        files.push({
                                            entry,
                                            file,
                                            relativeFolder: entry.fullPath.replace(/\/[^\/]*$/, '')
                                        });
                                        resolveFile();
                                    });
                                });
                            }
                            else {
                                return FileUtils.flatten(entry).then((result) => {
                                    files.push(...result);
                                });
                            }
                        })));
                        // Try calling traverse() again for the same dir, according to spec
                        traverse();
                    }
                });
            })();
        });
    }
    static toFileArray(fileList) {
        const result = [];
        if (fileList && fileList.length > 0) {
            for (let i = 0; i < fileList.length; i++) {
                result.push(fileList[i]);
            }
        }
        return result;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MOMENT_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM Y',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM Y'
    }
};
const dateNames = [];
for (let date = 1; date <= 31; date++) {
    dateNames.push(String(date));
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MomentDateAdapter extends DateAdapter {
    constructor() {
        super(...arguments);
        this.localeData = moment.localeData();
    }
    getYear(date) {
        return date.year();
    }
    getMonth(date) {
        return date.month();
    }
    getDate(date) {
        return date.date();
    }
    getDayOfWeek(date) {
        return date.day();
    }
    getMonthNames(style) {
        switch (style) {
            case 'long':
                return this.localeData.months();
            case 'short':
                return this.localeData.monthsShort();
            case 'narrow':
                return this.localeData.monthsShort().map((month) => month[0]);
            default:
                return [];
        }
    }
    getDateNames() {
        const dateNames = [];
        for (let date = 1; date <= 31; date++) {
            dateNames.push(String(date));
        }
        return dateNames;
    }
    getDayOfWeekNames(style) {
        switch (style) {
            case 'long':
                return this.localeData.weekdays();
            case 'short':
                return this.localeData.weekdaysShort();
            case 'narrow':
                return this.localeData.weekdaysShort();
            default:
                return [];
        }
    }
    getYearName(date) {
        return String(date.year());
    }
    getFirstDayOfWeek() {
        return this.localeData.firstDayOfWeek();
    }
    getNumDaysInMonth(date) {
        return date.daysInMonth();
    }
    clone(date) {
        const locale = this.locale || 'en';
        return date.clone().locale(locale);
    }
    createDate(year, month, date) {
        return moment([year, month, date]);
    }
    today() {
        const locale = this.locale || 'en';
        return moment().locale(locale);
    }
    parse(value, parseFormat) {
        const locale = this.locale || 'en';
        if (value && typeof value === 'string') {
            let m = moment(value, parseFormat, locale, true);
            if (!m.isValid()) {
                // use strict parsing because Moment's parser is very forgiving, and this can lead to undesired behavior.
                m = moment(value, this.overrideDisplayFormat, locale, true);
            }
            if (m.isValid()) {
                // if user omits year, it defaults to 2001, so check for that issue.
                if (m.year() === 2001 && value.indexOf('2001') === -1) {
                    // if 2001 not actually in the value string, change to current year
                    const currentYear = new Date().getFullYear();
                    m.set('year', currentYear);
                    // if date is in the future, set previous year
                    if (m.isAfter(moment())) {
                        m.set('year', currentYear - 1);
                    }
                }
            }
            return m;
        }
        return value ? moment(value).locale(locale) : null;
    }
    format(date, displayFormat) {
        date = this.clone(date);
        displayFormat = this.overrideDisplayFormat ? this.overrideDisplayFormat : displayFormat;
        if (date && date.format) {
            return date.utc().local().format(displayFormat);
        }
        else {
            return '';
        }
    }
    addCalendarYears(date, years) {
        return date.clone().add(years, 'y');
    }
    addCalendarMonths(date, months) {
        return date.clone().add(months, 'M');
    }
    addCalendarDays(date, days) {
        return date.clone().add(days, 'd');
    }
    getISODateString(date) {
        return date.toISOString();
    }
    setLocale(locale) {
        super.setLocale(locale);
        this.localeData = moment.localeData(locale);
    }
    compareDate(first, second) {
        return first.diff(second, 'seconds', true);
    }
    sameDate(first, second) {
        if (first == null) {
            // same if both null
            return second == null;
        }
        else if (isMoment(first)) {
            return first.isSame(second);
        }
        else {
            const isSame = super.sameDate(first, second);
            return isSame;
        }
    }
    clampDate(date, min, max) {
        if (min && date.isBefore(min)) {
            return min;
        }
        else if (max && date.isAfter(max)) {
            return max;
        }
        else {
            return date;
        }
    }
    isDateInstance(date) {
        let isValidDateInstance = false;
        if (date) {
            // eslint-disable-next-line no-underscore-dangle
            isValidDateInstance = date._isAMomentObject;
        }
        return isValidDateInstance;
    }
    isValid(date) {
        return date.isValid();
    }
    toIso8601(date) {
        return this.clone(date).format();
    }
    fromIso8601(iso8601String) {
        const locale = this.locale || 'en';
        const d = moment(iso8601String, moment.ISO_8601).locale(locale);
        return this.isValid(d) ? d : null;
    }
    invalid() {
        return moment.invalid();
    }
}
MomentDateAdapter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDateAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MomentDateAdapter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDateAdapter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDateAdapter, decorators: [{
            type: Injectable
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class StringUtils {
    static capitalize(target) {
        return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase();
    }
    static replaceAll(target, delimiters) {
        if (!ObjectUtils.isObject(delimiters)) {
            return target;
        }
        Object.keys(delimiters).forEach((key) => {
            target = target.replace(key, delimiters[key]);
        });
        return target;
    }
    static removeAll(target, ...delimiters) {
        const delimiterObj = {};
        delimiters.forEach(delimiter => {
            delimiterObj[delimiter] = '';
        });
        return StringUtils.replaceAll(target, delimiterObj);
    }
    static prettifyBooleanEnabled(target) {
        const redactedTarget = StringUtils.removeAll(target.toLowerCase(), 'is', 'enabled');
        const bagOfWords = redactedTarget.split(' ');
        const capitalizedBagOfWords = bagOfWords.map((word) => StringUtils.capitalize(word));
        return capitalizedBagOfWords.join(' ');
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutRepositoryInfoComponent {
    ngOnInit() {
        if (this.data) {
            const repository = this.data;
            this.statusEntries = Object.keys(repository.status).map((key) => ({
                property: key,
                value: repository.status[key]
            }));
            if (repository.license) {
                this.licenseEntries = Object.keys(repository.license).map((key) => {
                    if (ObjectUtils.isObject(repository.license[key])) {
                        return {
                            property: key,
                            value: ObjectUtils.booleanPrettify(repository.license[key], StringUtils.prettifyBooleanEnabled)
                        };
                    }
                    ;
                    return {
                        property: key,
                        value: repository.license[key]
                    };
                });
            }
        }
    }
}
AboutRepositoryInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutRepositoryInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AboutRepositoryInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AboutRepositoryInfoComponent, selector: "adf-about-repository-info", inputs: { data: "data" }, ngImport: i0, template: "<div>\n    <article *ngIf=\"licenseEntries\">\n        <header>{{ 'ABOUT.LICENSE.TITLE' | translate }}</header>\n        <adf-about-license-list [data]=\"licenseEntries\"></adf-about-license-list>\n    </article>\n\n    <article *ngIf=\"statusEntries\">\n        <header>{{ 'ABOUT.STATUS.TITLE' | translate }}</header>\n        <adf-about-status-list [data]=\"statusEntries\"></adf-about-status-list>\n    </article>\n\n    <article *ngIf=\"data?.modules\">\n        <header>{{ 'ABOUT.MODULES.TITLE' | translate }}</header>\n        <adf-about-module-list [data]=\"data.modules\"></adf-about-module-list>\n    </article>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AboutLicenseListComponent, selector: "adf-about-license-list", inputs: ["data"] }, { kind: "component", type: AboutStatusListComponent, selector: "adf-about-status-list", inputs: ["data"] }, { kind: "component", type: ModuleListComponent, selector: "adf-about-module-list", inputs: ["data"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutRepositoryInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-about-repository-info', template: "<div>\n    <article *ngIf=\"licenseEntries\">\n        <header>{{ 'ABOUT.LICENSE.TITLE' | translate }}</header>\n        <adf-about-license-list [data]=\"licenseEntries\"></adf-about-license-list>\n    </article>\n\n    <article *ngIf=\"statusEntries\">\n        <header>{{ 'ABOUT.STATUS.TITLE' | translate }}</header>\n        <adf-about-status-list [data]=\"statusEntries\"></adf-about-status-list>\n    </article>\n\n    <article *ngIf=\"data?.modules\">\n        <header>{{ 'ABOUT.MODULES.TITLE' | translate }}</header>\n        <adf-about-module-list [data]=\"data.modules\"></adf-about-module-list>\n    </article>\n</div>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MaterialModule {
}
MaterialModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MaterialModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, imports: [MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule], exports: [MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule] });
MaterialModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, imports: [MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule, MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
                        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
                        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
                        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
                        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
                        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule
                    ],
                    exports: [
                        MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule,
                        MatChipsModule, MatDatepickerModule, MatDialogModule, MatGridListModule, MatIconModule,
                        MatInputModule, MatListModule, MatNativeDateModule, MatOptionModule, MatProgressSpinnerModule, MatRadioModule,
                        MatRippleModule, MatSelectModule, MatSlideToggleModule, MatTableModule, MatTabsModule,
                        MatMenuModule, MatProgressBarModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule,
                        MatTooltipModule, MatDatetimepickerModule, MatNativeDatetimeModule, MatExpansionModule, MatBadgeModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AboutModule {
}
AboutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AboutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AboutModule, declarations: [AboutComponent,
        AboutPanelDirective,
        AboutRepositoryInfoComponent,
        AboutPlatformVersionComponent,
        AboutGithubLinkComponent,
        AboutServerSettingsComponent,
        AboutExtensionListComponent,
        AboutLicenseListComponent,
        PackageListComponent,
        AboutStatusListComponent,
        ModuleListComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        MatExpansionModule], exports: [AboutComponent,
        AboutPanelDirective,
        AboutRepositoryInfoComponent,
        AboutPlatformVersionComponent,
        AboutGithubLinkComponent,
        AboutServerSettingsComponent,
        AboutExtensionListComponent,
        AboutLicenseListComponent,
        PackageListComponent,
        AboutStatusListComponent,
        ModuleListComponent] });
AboutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        MatExpansionModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AboutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        MatExpansionModule
                    ],
                    declarations: [
                        AboutComponent,
                        AboutPanelDirective,
                        AboutRepositoryInfoComponent,
                        AboutPlatformVersionComponent,
                        AboutGithubLinkComponent,
                        AboutServerSettingsComponent,
                        AboutExtensionListComponent,
                        AboutLicenseListComponent,
                        PackageListComponent,
                        AboutStatusListComponent,
                        ModuleListComponent
                    ],
                    exports: [
                        AboutComponent,
                        AboutPanelDirective,
                        AboutRepositoryInfoComponent,
                        AboutPlatformVersionComponent,
                        AboutGithubLinkComponent,
                        AboutServerSettingsComponent,
                        AboutExtensionListComponent,
                        AboutLicenseListComponent,
                        PackageListComponent,
                        AboutStatusListComponent,
                        ModuleListComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewUtilService {
    constructor(extensionService) {
        this.extensionService = extensionService;
        // Extensions that are supported by the Viewer without conversion
        this.extensions = {
            image: ['png', 'jpg', 'jpeg', 'gif', 'bpm', 'svg'],
            media: ['wav', 'mp4', 'mp3', 'webm', 'ogg'],
            text: ['txt', 'xml', 'html', 'json', 'ts', 'css', 'md'],
            pdf: ['pdf']
        };
        // Mime types that are supported by the Viewer without conversion
        this.mimeTypes = {
            text: ['text/plain', 'text/csv', 'text/xml', 'text/html', 'application/x-javascript'],
            pdf: ['application/pdf'],
            image: ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/svg+xml'],
            media: ['video/mp4', 'video/webm', 'video/ogg', 'audio/mpeg', 'audio/mp3', 'audio/ogg', 'audio/wav']
        };
    }
    /**
     * Returns a list of the active Viewer content extensions.
     */
    get viewerExtensions() {
        return this.extensionService.getViewerExtensions();
    }
    /**
     * Provides a list of file extensions supported by external plugins.
     */
    get externalExtensions() {
        return this.viewerExtensions.map(ext => ext.fileExtension);
    }
    /**
     * get File name from url
     *
     * @param  url - url file
     */
    getFilenameFromUrl(url) {
        const anchor = url.indexOf('#');
        const query = url.indexOf('?');
        const end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
        return url.substring(url.lastIndexOf('/', end) + 1, end);
    }
    /**
     * Get file extension from the string.
     * Supports the URL formats like:
     * http://localhost/test.jpg?cache=1000
     * http://localhost/test.jpg#cache=1000
     *
     * @param fileName - file name
     */
    getFileExtension(fileName) {
        if (fileName) {
            const match = fileName.match(/\.([^\./\?\#]+)($|\?|\#)/);
            return match ? match[1] : null;
        }
        return null;
    }
    getViewerType(extension, mimeType) {
        let viewerType = this.getViewerTypeByExtension(extension);
        if (viewerType === 'unknown') {
            viewerType = this.getViewerTypeByMimeType(mimeType);
        }
        return viewerType;
    }
    getViewerTypeByMimeType(mimeType) {
        if (mimeType) {
            mimeType = mimeType.toLowerCase();
            const editorTypes = Object.keys(this.mimeTypes);
            for (const type of editorTypes) {
                if (this.mimeTypes[type].indexOf(mimeType) >= 0) {
                    return type;
                }
            }
        }
        return 'unknown';
    }
    getViewerTypeByExtension(extension) {
        if (extension) {
            extension = extension.toLowerCase();
        }
        if (this.isExternalViewer()) {
            return 'external';
        }
        if (this.isCustomViewerExtension(extension)) {
            return 'custom';
        }
        if (this.extensions.image.indexOf(extension) >= 0) {
            return 'image';
        }
        if (this.extensions.media.indexOf(extension) >= 0) {
            return 'media';
        }
        if (this.extensions.text.indexOf(extension) >= 0) {
            return 'text';
        }
        if (this.extensions.pdf.indexOf(extension) >= 0) {
            return 'pdf';
        }
        return 'unknown';
    }
    isExternalViewer() {
        return !!this.viewerExtensions.find(ext => ext.fileExtension === '*');
    }
    isCustomViewerExtension(extension) {
        const extensions = this.externalExtensions || [];
        if (extension && extensions.length > 0) {
            extension = extension.toLowerCase();
            return extensions.flat().indexOf(extension) >= 0;
        }
        return false;
    }
}
ViewUtilService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewUtilService, deps: [{ token: i2$1.AppExtensionService }], target: i0.ɵɵFactoryTarget.Injectable });
ViewUtilService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewUtilService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewUtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2$1.AppExtensionService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UrlService {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * Creates a trusted object URL from the Blob.
     * WARNING: calling this method with untrusted user data exposes your application to XSS security risks!
     *
     * @param  blob Data to wrap into object URL
     * @returns URL string
     */
    createTrustedUrl(blob) {
        const url = window.URL.createObjectURL(blob);
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
UrlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UrlService, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
UrlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UrlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UrlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ToolbarComponent {
    constructor() {
        /** Toolbar title. */
        this.title = '';
    }
}
ToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ToolbarComponent, selector: "adf-toolbar", inputs: { title: "title", color: "color" }, host: { classAttribute: "adf-toolbar" }, ngImport: i0, template: "<mat-toolbar [color]=\"color\">\n    <span class=\"adf-toolbar-title\" *ngIf=\"title\">{{ title | translate }}</span>\n    <ng-content select=\"adf-toolbar-title\"></ng-content>\n    <ng-content></ng-content>\n</mat-toolbar>\n", styles: [".adf-toolbar--spacer{flex:1 1 auto}.adf-toolbar-title{overflow:hidden;display:flex;width:100%}.adf-toolbar .mat-toolbar{min-height:48px;border:1px solid var(--adf-theme-foreground-text-color-007);color:var(--adf-theme-foreground-text-color-054)}.adf-toolbar .mat-toolbar-row{height:48px;font-size:var(--theme-body-1-font-size);white-space:normal}.adf-toolbar .mat-toolbar-single-row{padding:0 16px;height:64px}.adf-toolbar.adf-toolbar--inline .mat-toolbar{background-color:inherit;border:none!important;padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-toolbar', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: { class: 'adf-toolbar' }, template: "<mat-toolbar [color]=\"color\">\n    <span class=\"adf-toolbar-title\" *ngIf=\"title\">{{ title | translate }}</span>\n    <ng-content select=\"adf-toolbar-title\"></ng-content>\n    <ng-content></ng-content>\n</mat-toolbar>\n", styles: [".adf-toolbar--spacer{flex:1 1 auto}.adf-toolbar-title{overflow:hidden;display:flex;width:100%}.adf-toolbar .mat-toolbar{min-height:48px;border:1px solid var(--adf-theme-foreground-text-color-007);color:var(--adf-theme-foreground-text-color-054)}.adf-toolbar .mat-toolbar-row{height:48px;font-size:var(--theme-body-1-font-size);white-space:normal}.adf-toolbar .mat-toolbar-single-row{padding:0 16px;height:64px}.adf-toolbar.adf-toolbar--inline .mat-toolbar{background-color:inherit;border:none!important;padding:0}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ImgViewerComponent {
    constructor(appConfigService, urlService) {
        this.appConfigService = appConfigService;
        this.urlService = urlService;
        this.showToolbar = true;
        this.readOnly = true;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.error = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.submit = new EventEmitter();
        this.isSaving = new EventEmitter();
        this.scale = 1.0;
        this.isEditing = false;
        this.initializeScaling();
    }
    get currentScaleText() {
        return Math.round(this.scale * 100) + '%';
    }
    initializeScaling() {
        const scaling = this.appConfigService.get('adf-viewer-render.image-viewer-scaling', undefined) / 100;
        if (scaling) {
            this.scale = scaling;
        }
    }
    ngAfterViewInit() {
        this.cropper = new Cropper(this.imageElement.nativeElement, {
            autoCrop: false,
            dragMode: 'move',
            background: false,
            scalable: true,
            zoomOnWheel: false,
            toggleDragModeOnDblclick: false,
            viewMode: 1,
            checkCrossOrigin: false,
            ready: () => {
                this.updateCanvasContainer();
            }
        });
    }
    ngOnDestroy() {
        this.cropper.destroy();
    }
    onKeyDown(event) {
        switch (event.key) {
            case 'ArrowLeft':
                event.preventDefault();
                this.cropper.move(-3, 0);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.cropper.move(0, -3);
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.cropper.move(3, 0);
                break;
            case 'ArrowDown':
                event.preventDefault();
                this.cropper.move(0, 3);
                break;
            case 'i':
                this.zoomIn();
                break;
            case 'o':
                this.zoomOut();
                break;
            case 'r':
                this.rotateImage();
                break;
            default:
        }
    }
    fullScreenChangeHandler() {
        if (document.fullscreenElement) {
            this.reset();
        }
    }
    ngOnChanges(changes) {
        const blobFile = changes['blobFile'];
        if (blobFile && blobFile.currentValue) {
            this.urlFile = this.urlService.createTrustedUrl(this.blobFile);
            return;
        }
        if (!changes['urlFile'].firstChange && changes['fileName']) {
            if (changes['fileName'].previousValue !== changes['fileName'].currentValue) {
                this.cropper.replace(changes['urlFile'].currentValue);
            }
        }
        if (!this.urlFile && !this.blobFile) {
            throw new Error('Attribute urlFile or blobFile is required');
        }
    }
    zoomIn() {
        this.cropper.zoom(0.2);
        this.scale = +((this.scale + 0.2).toFixed(1));
    }
    zoomOut() {
        if (this.scale > 0.2) {
            this.cropper.zoom(-0.2);
            this.scale = +((this.scale - 0.2).toFixed(1));
        }
    }
    rotateImage() {
        this.isEditing = true;
        this.cropper.rotate(-90);
    }
    cropImage() {
        this.isEditing = true;
        this.cropper.setDragMode('crop');
        this.cropper.crop();
    }
    save() {
        this.isSaving.emit(true);
        this.isEditing = false;
        this.cropper.setDragMode('move');
        this.cropper.getCroppedCanvas().toBlob((blob) => {
            this.submit.emit(blob);
            this.cropper.replace(this.cropper.getCroppedCanvas().toDataURL());
            this.cropper.clear();
            this.isSaving.emit(false);
        });
    }
    reset() {
        this.isEditing = false;
        this.cropper.clear();
        this.cropper.reset();
        this.cropper.setDragMode('move');
        this.scale = 1.0;
        this.updateCanvasContainer();
    }
    updateCanvasContainer() {
        if (this.imageElement.nativeElement.width < this.cropper.getContainerData().width) {
            const width = this.imageElement.nativeElement.width;
            const height = this.imageElement.nativeElement.height;
            const top = (this.cropper.getContainerData().height - this.imageElement.nativeElement.height) / 2;
            const left = (this.cropper.getContainerData().width - this.imageElement.nativeElement.width) / 2;
            this.cropper.setCanvasData({
                width,
                height,
                top,
                left
            });
        }
    }
    onImageError() {
        this.error.emit();
    }
}
ImgViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ImgViewerComponent, deps: [{ token: AppConfigService }, { token: UrlService }], target: i0.ɵɵFactoryTarget.Component });
ImgViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ImgViewerComponent, selector: "adf-img-viewer", inputs: { showToolbar: "showToolbar", readOnly: "readOnly", urlFile: "urlFile", blobFile: "blobFile", fileName: "fileName" }, outputs: { error: "error", submit: "submit", isSaving: "isSaving" }, host: { listeners: { "document:keydown": "onKeyDown($event)", "document:fullscreenchange": "fullScreenChangeHandler()" }, classAttribute: "adf-image-viewer" }, viewQueries: [{ propertyName: "imageElement", first: true, predicate: ["image"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div id=\"adf-image-container\" (keydown)=\"onKeyDown($event)\" class=\"adf-image-container\" tabindex=\"0\" role=\"img\" [attr.aria-label]=\"fileName\" data-automation-id=\"adf-image-container\">\n    <img #image id=\"viewer-image\" [src]=\"urlFile\" [alt]=\"fileName\" (error)=\"onImageError()\" />\n</div>\n\n<div class=\"adf-image-viewer__toolbar\" *ngIf=\"showToolbar\">\n    <adf-toolbar class=\"adf-main-toolbar\">\n        <button\n            id=\"viewer-zoom-out-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomOut()\">\n            <mat-icon>zoom_out</mat-icon>\n        </button>\n\n        <div class=\"adf-image-viewer__toolbar-page-scale\" data-automation-id=\"adf-page-scale\">\n            {{ currentScaleText }}\n        </div>\n\n        <button\n            id=\"viewer-zoom-in-button\"\n            mat-icon-button\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            (click)=\"zoomIn()\">\n            <mat-icon>zoom_in</mat-icon>\n        </button>\n\n        <button\n            *ngIf=\"!readOnly\" id=\"viewer-rotate-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ROTATE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ROTATE' | translate }}\"\n            mat-icon-button\n            (click)=\"rotateImage()\">\n            <mat-icon>rotate_left</mat-icon>\n        </button>\n        <button\n            *ngIf=\"!readOnly\" id=\"viewer-crop-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.CROP' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.CROP' | translate }}\"\n            mat-icon-button\n            (click)=\"cropImage()\">\n            <mat-icon>crop</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-reset-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.RESET' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.RESET' | translate }}\"\n            mat-icon-button\n            (click)=\"reset()\">\n            <mat-icon>zoom_out_map</mat-icon>\n        </button>\n\n    </adf-toolbar>\n\n    <adf-toolbar class=\"adf-secondary-toolbar\" *ngIf=\"!readOnly && isEditing\">\n        <button\n            id=\"viewer-cancel-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.CANCEL' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.CANCEL' | translate }}\"\n            mat-icon-button\n            (click)=\"reset()\">\n            <mat-icon>close</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-save-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.SAVE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.SAVE' | translate }}\"\n            mat-icon-button\n            (click)=\"save()\">\n            <mat-icon>check</mat-icon>\n        </button>\n\n    </adf-toolbar>\n</div>\n", styles: [".adf-image-viewer{width:100%}.adf-image-viewer .adf-image-container{display:flex;height:90vh;align-items:center;justify-content:center}.adf-image-viewer .adf-image-container:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-image-viewer .adf-image-container img{max-height:100%;max-width:100%}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-image-viewer .adf-image-container img{height:100%}}.adf-image-viewer__toolbar{position:absolute;bottom:5px;left:50%;transform:translate(-50%)}.adf-image-viewer__toolbar .adf-toolbar .mat-toolbar{max-height:48px;background-color:var(--adf-theme-background-card-color);border-width:0;border-radius:2px;box-shadow:0 2px 2px #0000003d,0 0 2px #0000001f}.adf-image-viewer__toolbar .adf-main-toolbar{display:inline-block}.adf-image-viewer__toolbar .adf-secondary-toolbar{display:inline-block;margin-left:10px}.adf-image-viewer__toolbar-page-scale{cursor:default;width:79px;height:24px;font-size:var(--theme-body-1-font-size);border:1px solid var(--adf-theme-foreground-text-color-007);text-align:center;line-height:24px;margin-left:4px;margin-right:4px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: ToolbarComponent, selector: "adf-toolbar", inputs: ["title", "color"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ImgViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-img-viewer', host: { class: 'adf-image-viewer' }, encapsulation: ViewEncapsulation.None, template: "<div id=\"adf-image-container\" (keydown)=\"onKeyDown($event)\" class=\"adf-image-container\" tabindex=\"0\" role=\"img\" [attr.aria-label]=\"fileName\" data-automation-id=\"adf-image-container\">\n    <img #image id=\"viewer-image\" [src]=\"urlFile\" [alt]=\"fileName\" (error)=\"onImageError()\" />\n</div>\n\n<div class=\"adf-image-viewer__toolbar\" *ngIf=\"showToolbar\">\n    <adf-toolbar class=\"adf-main-toolbar\">\n        <button\n            id=\"viewer-zoom-out-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomOut()\">\n            <mat-icon>zoom_out</mat-icon>\n        </button>\n\n        <div class=\"adf-image-viewer__toolbar-page-scale\" data-automation-id=\"adf-page-scale\">\n            {{ currentScaleText }}\n        </div>\n\n        <button\n            id=\"viewer-zoom-in-button\"\n            mat-icon-button\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            (click)=\"zoomIn()\">\n            <mat-icon>zoom_in</mat-icon>\n        </button>\n\n        <button\n            *ngIf=\"!readOnly\" id=\"viewer-rotate-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ROTATE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ROTATE' | translate }}\"\n            mat-icon-button\n            (click)=\"rotateImage()\">\n            <mat-icon>rotate_left</mat-icon>\n        </button>\n        <button\n            *ngIf=\"!readOnly\" id=\"viewer-crop-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.CROP' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.CROP' | translate }}\"\n            mat-icon-button\n            (click)=\"cropImage()\">\n            <mat-icon>crop</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-reset-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.RESET' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.RESET' | translate }}\"\n            mat-icon-button\n            (click)=\"reset()\">\n            <mat-icon>zoom_out_map</mat-icon>\n        </button>\n\n    </adf-toolbar>\n\n    <adf-toolbar class=\"adf-secondary-toolbar\" *ngIf=\"!readOnly && isEditing\">\n        <button\n            id=\"viewer-cancel-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.CANCEL' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.CANCEL' | translate }}\"\n            mat-icon-button\n            (click)=\"reset()\">\n            <mat-icon>close</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-save-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.SAVE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.SAVE' | translate }}\"\n            mat-icon-button\n            (click)=\"save()\">\n            <mat-icon>check</mat-icon>\n        </button>\n\n    </adf-toolbar>\n</div>\n", styles: [".adf-image-viewer{width:100%}.adf-image-viewer .adf-image-container{display:flex;height:90vh;align-items:center;justify-content:center}.adf-image-viewer .adf-image-container:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-image-viewer .adf-image-container img{max-height:100%;max-width:100%}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-image-viewer .adf-image-container img{height:100%}}.adf-image-viewer__toolbar{position:absolute;bottom:5px;left:50%;transform:translate(-50%)}.adf-image-viewer__toolbar .adf-toolbar .mat-toolbar{max-height:48px;background-color:var(--adf-theme-background-card-color);border-width:0;border-radius:2px;box-shadow:0 2px 2px #0000003d,0 0 2px #0000001f}.adf-image-viewer__toolbar .adf-main-toolbar{display:inline-block}.adf-image-viewer__toolbar .adf-secondary-toolbar{display:inline-block;margin-left:10px}.adf-image-viewer__toolbar-page-scale{cursor:default;width:79px;height:24px;font-size:var(--theme-body-1-font-size);border:1px solid var(--adf-theme-foreground-text-color-007);text-align:center;line-height:24px;margin-left:4px;margin-right:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: UrlService }]; }, propDecorators: { showToolbar: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }], fileName: [{
                type: Input
            }], error: [{
                type: Output
            }], submit: [{
                type: Output
            }], isSaving: [{
                type: Output
            }], imageElement: [{
                type: ViewChild,
                args: ['image', { static: false }]
            }], onKeyDown: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }], fullScreenChangeHandler: [{
                type: HostListener,
                args: ['document:fullscreenchange']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MediaPlayerComponent {
    constructor(urlService) {
        this.urlService = urlService;
        /** media subtitles for the media player*/
        this.tracks = [];
        this.error = new EventEmitter();
    }
    ngOnChanges(changes) {
        const blobFile = changes['blobFile'];
        if (blobFile && blobFile.currentValue) {
            this.urlFile = this.urlService.createTrustedUrl(this.blobFile);
            return;
        }
        if (!this.urlFile && !this.blobFile) {
            throw new Error('Attribute urlFile or blobFile is required');
        }
    }
    onMediaPlayerError(event) {
        this.error.emit(event);
    }
}
MediaPlayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MediaPlayerComponent, deps: [{ token: UrlService }], target: i0.ɵɵFactoryTarget.Component });
MediaPlayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: MediaPlayerComponent, selector: "adf-media-player", inputs: { urlFile: "urlFile", blobFile: "blobFile", mimeType: "mimeType", fileName: "fileName", tracks: "tracks" }, outputs: { error: "error" }, host: { classAttribute: "adf-media-player" }, usesOnChanges: true, ngImport: i0, template: "<video controls [ngClass]=\"{'adf-audio-file': mimeType && mimeType.startsWith('audio')}\">\n    <source [src]=\"urlFile\" [type]=\"mimeType\" (error)=\"onMediaPlayerError($event)\"/>\n    <track *ngFor=\"let track of tracks\" [kind]=\"track.kind\" [label]=\"track.label\" [srclang]=\"track.srclang\" [src]=\"track.src\"/>\n</video>\n", styles: [".adf-media-player{display:flex}.adf-media-player video{display:flex;flex:1;max-height:90vh;max-width:100%}.adf-media-player video.adf-audio-file::-webkit-media-text-track-container{transform:translateY(-50%)!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MediaPlayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-media-player', host: { class: 'adf-media-player' }, encapsulation: ViewEncapsulation.None, template: "<video controls [ngClass]=\"{'adf-audio-file': mimeType && mimeType.startsWith('audio')}\">\n    <source [src]=\"urlFile\" [type]=\"mimeType\" (error)=\"onMediaPlayerError($event)\"/>\n    <track *ngFor=\"let track of tracks\" [kind]=\"track.kind\" [label]=\"track.label\" [srclang]=\"track.srclang\" [src]=\"track.src\"/>\n</video>\n", styles: [".adf-media-player{display:flex}.adf-media-player video{display:flex;flex:1;max-height:90vh;max-width:100%}.adf-media-player video.adf-audio-file::-webkit-media-text-track-container{transform:translateY(-50%)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: UrlService }]; }, propDecorators: { urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }], mimeType: [{
                type: Input
            }], fileName: [{
                type: Input
            }], tracks: [{
                type: Input
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PdfPasswordDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() {
        this.passwordFormControl = new UntypedFormControl('', [Validators.required]);
    }
    isError() {
        return this.data.reason === pdfjsLib.PasswordResponses.INCORRECT_PASSWORD;
    }
    isValid() {
        return !this.passwordFormControl.hasError('required');
    }
    submit() {
        this.dialogRef.close(this.passwordFormControl.value);
    }
}
PdfPasswordDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfPasswordDialogComponent, deps: [{ token: i1$4.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
PdfPasswordDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PdfPasswordDialogComponent, selector: "adf-pdf-viewer-password-dialog", ngImport: i0, template: "<div mat-dialog-title>\n    <mat-icon>lock</mat-icon>\n</div>\n\n<mat-dialog-content>\n    <form (submit)=\"submit()\">\n        <mat-form-field class=\"adf-full-width\">\n            <input matInput\n                   data-automation-id='adf-password-dialog-input'\n                   type=\"password\"\n                   placeholder=\"{{ 'ADF_VIEWER.PDF_DIALOG.PLACEHOLDER' | translate }}\"\n                   [formControl]=\"passwordFormControl\" />\n        </mat-form-field>\n\n        <mat-error *ngIf=\"isError()\" data-automation-id='adf-password-dialog-error'>{{ 'ADF_VIEWER.PDF_DIALOG.ERROR' | translate }}</mat-error>\n    </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button mat-button mat-dialog-close data-automation-id='adf-password-dialog-close'>{{ 'ADF_VIEWER.PDF_DIALOG.CLOSE' | translate }}</button>\n\n    <button mat-button\n            data-automation-id='adf-password-dialog-submit'\n            class=\"adf-dialog-action-button\"\n            [disabled]=\"!isValid()\"\n            (click)=\"submit()\">\n        {{ 'ADF_VIEWER.PDF_DIALOG.SUBMIT' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-fill-remaining-space{flex:1 1 auto}.adf-full-width{width:100%}.adf-dialog-buttons button{text-transform:uppercase}.adf-dialog-action-button:enabled{color:var(--theme-primary-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$4.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$4.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i7.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i7.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfPasswordDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-pdf-viewer-password-dialog', encapsulation: ViewEncapsulation.None, template: "<div mat-dialog-title>\n    <mat-icon>lock</mat-icon>\n</div>\n\n<mat-dialog-content>\n    <form (submit)=\"submit()\">\n        <mat-form-field class=\"adf-full-width\">\n            <input matInput\n                   data-automation-id='adf-password-dialog-input'\n                   type=\"password\"\n                   placeholder=\"{{ 'ADF_VIEWER.PDF_DIALOG.PLACEHOLDER' | translate }}\"\n                   [formControl]=\"passwordFormControl\" />\n        </mat-form-field>\n\n        <mat-error *ngIf=\"isError()\" data-automation-id='adf-password-dialog-error'>{{ 'ADF_VIEWER.PDF_DIALOG.ERROR' | translate }}</mat-error>\n    </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button mat-button mat-dialog-close data-automation-id='adf-password-dialog-close'>{{ 'ADF_VIEWER.PDF_DIALOG.CLOSE' | translate }}</button>\n\n    <button mat-button\n            data-automation-id='adf-password-dialog-submit'\n            class=\"adf-dialog-action-button\"\n            [disabled]=\"!isValid()\"\n            (click)=\"submit()\">\n        {{ 'ADF_VIEWER.PDF_DIALOG.SUBMIT' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-fill-remaining-space{flex:1 1 auto}.adf-full-width{width:100%}.adf-dialog-buttons button{text-transform:uppercase}.adf-dialog-action-button:enabled{color:var(--theme-primary-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LogLevelsEnum extends Number {
}
LogLevelsEnum.TRACE = 5;
LogLevelsEnum.DEBUG = 4;
LogLevelsEnum.INFO = 3;
LogLevelsEnum.WARN = 2;
LogLevelsEnum.ERROR = 1;
LogLevelsEnum.SILENT = 0;
const logLevels = [
    { level: LogLevelsEnum.TRACE, name: 'TRACE' },
    { level: LogLevelsEnum.DEBUG, name: 'DEBUG' },
    { level: LogLevelsEnum.INFO, name: 'INFO' },
    { level: LogLevelsEnum.WARN, name: 'WARN' },
    { level: LogLevelsEnum.ERROR, name: 'ERROR' },
    { level: LogLevelsEnum.SILENT, name: 'SILENT' }
];

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LogService {
    constructor(appConfig) {
        this.appConfig = appConfig;
        this.onMessage = new Subject();
    }
    get currentLogLevel() {
        const configLevel = this.appConfig.get(AppConfigValues.LOG_LEVEL);
        if (configLevel) {
            return this.getLogLevel(configLevel);
        }
        return LogLevelsEnum.TRACE;
    }
    /**
     * Logs a message at the "ERROR" level.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    error(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.ERROR) {
            this.messageBus(message, 'ERROR');
            console.error(message, ...optionalParams);
        }
    }
    /**
     * Logs a message at the "DEBUG" level.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    debug(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.DEBUG) {
            this.messageBus(message, 'DEBUG');
            console.debug(message, ...optionalParams);
        }
    }
    /**
     * Logs a message at the "INFO" level.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    info(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.INFO) {
            this.messageBus(message, 'INFO');
            console.info(message, ...optionalParams);
        }
    }
    /**
     * Logs a message at any level from "TRACE" upwards.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    log(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.TRACE) {
            this.messageBus(message, 'LOG');
            console.log(message, ...optionalParams);
        }
    }
    /**
     * Logs a message at the "TRACE" level.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    trace(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.TRACE) {
            this.messageBus(message, 'TRACE');
            console.trace(message, ...optionalParams);
        }
    }
    /**
     * Logs a message at the "WARN" level.
     *
     * @param message Message to log
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    warn(message, ...optionalParams) {
        if (this.currentLogLevel >= LogLevelsEnum.WARN) {
            this.messageBus(message, 'WARN');
            console.warn(message, ...optionalParams);
        }
    }
    /**
     * Logs a message if a boolean test fails.
     *
     * @param test Test value (typically a boolean expression)
     * @param message Message to show if test is false
     * @param optionalParams Interpolation values for the message in "printf" format
     */
    assert(test, message, ...optionalParams) {
        if (this.currentLogLevel !== LogLevelsEnum.SILENT) {
            this.messageBus(message, 'ASSERT');
            console.assert(test, message, ...optionalParams);
        }
    }
    /**
     * Starts an indented group of log messages.
     *
     * @param groupTitle Title shown at the start of the group
     * @param optionalParams Interpolation values for the title in "printf" format
     */
    group(groupTitle, ...optionalParams) {
        if (this.currentLogLevel !== LogLevelsEnum.SILENT) {
            console.group(groupTitle, ...optionalParams);
        }
    }
    /**
     * Ends a indented group of log messages.
     */
    groupEnd() {
        if (this.currentLogLevel !== LogLevelsEnum.SILENT) {
            console.groupEnd();
        }
    }
    /**
     * Converts a log level name string into its numeric equivalent.
     *
     * @param level Level name
     * @returns Numeric log level
     */
    getLogLevel(level) {
        const referencedLevel = logLevels.find((currentLevel) => currentLevel.name.toLocaleLowerCase() === level.toLocaleLowerCase());
        return referencedLevel ? referencedLevel.level : 5;
    }
    /**
     * Triggers notification callback for log messages.
     *
     * @param text Message text
     * @param logLevel Log level for the message
     */
    messageBus(text, logLevel) {
        this.onMessage.next({ text, type: logLevel });
    }
}
LogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LogService, deps: [{ token: AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
LogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * RenderingQueueServices rendering of the views for pages and thumbnails.
 *
 */
class RenderingQueueServices {
    constructor() {
        this.renderingStates = {
            INITIAL: 0,
            RUNNING: 1,
            PAUSED: 2,
            FINISHED: 3
        };
        this.CLEANUP_TIMEOUT = 30000;
        this.pdfViewer = null;
        this.pdfThumbnailViewer = null;
        this.onIdle = null;
        this.highestPriorityPage = null;
        this.idleTimeout = null;
        this.printing = false;
        this.isThumbnailViewEnabled = false;
    }
    /**
     * @param pdfViewer
     */
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    /**
     * @param pdfThumbnailViewer
     */
    setThumbnailViewer(pdfThumbnailViewer) {
        this.pdfThumbnailViewer = pdfThumbnailViewer;
    }
    /**
     * @param  view
     */
    isHighestPriority(view) {
        return this.highestPriorityPage === view.renderingId;
    }
    renderHighestPriority(currentlyVisiblePages) {
        if (this.idleTimeout) {
            clearTimeout(this.idleTimeout);
            this.idleTimeout = null;
        }
        // Pages have a higher priority than thumbnails, so check them first.
        if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
            return;
        }
        // No pages needed rendering so check thumbnails.
        if (this.pdfThumbnailViewer && this.isThumbnailViewEnabled) {
            if (this.pdfThumbnailViewer.forceRendering()) {
                return;
            }
        }
        if (this.printing) {
            // If printing is currently ongoing do not reschedule cleanup.
            return;
        }
        if (this.onIdle) {
            this.idleTimeout = setTimeout(this.onIdle.bind(this), this.CLEANUP_TIMEOUT);
        }
    }
    getHighestPriority(visible, views, scrolledDown) {
        // The state has changed figure out which page has the highest priority to
        // render next (if any).
        // Priority:
        // 1 visible pages
        // 2 if last scrolled down page after the visible pages
        // 2 if last scrolled up page before the visible pages
        const visibleViews = visible.views;
        const numVisible = visibleViews.length;
        if (numVisible === 0) {
            return false;
        }
        for (let i = 0; i < numVisible; ++i) {
            const view = visibleViews[i].view;
            if (!this.isViewFinished(view)) {
                return view;
            }
        }
        // All the visible views have rendered, try to render next/previous pages.
        if (scrolledDown) {
            const nextPageIndex = visible.last.id;
            // ID's start at 1 so no need to add 1.
            if (views[nextPageIndex] && !this.isViewFinished(views[nextPageIndex])) {
                return views[nextPageIndex];
            }
        }
        else {
            const previousPageIndex = visible.first.id - 2;
            if (views[previousPageIndex] && !this.isViewFinished(views[previousPageIndex])) {
                return views[previousPageIndex];
            }
        }
        // Everything that needs to be rendered has been.
        return null;
    }
    hasViewer() {
        return !!this.pdfViewer;
    }
    /**
     * @param view
     */
    isViewFinished(view) {
        return view.renderingState === this.renderingStates.FINISHED;
    }
    /**
     * Render a page or thumbnail view. This calls the appropriate function
     * based on the views state. If the view is already rendered it will return
     * false.
     *
     * @param view
     */
    renderView(view) {
        const state = view.renderingState;
        switch (state) {
            case this.renderingStates.FINISHED:
                return false;
            case this.renderingStates.PAUSED:
                this.highestPriorityPage = view.renderingId;
                view.resume();
                break;
            case this.renderingStates.RUNNING:
                this.highestPriorityPage = view.renderingId;
                break;
            case this.renderingStates.INITIAL:
                this.highestPriorityPage = view.renderingId;
                const continueRendering = function () {
                    this.renderHighestPriority();
                }.bind(this);
                view.draw().then(continueRendering, continueRendering);
                break;
            default:
                break;
        }
        return true;
    }
}
RenderingQueueServices.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenderingQueueServices, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RenderingQueueServices.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenderingQueueServices });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenderingQueueServices, decorators: [{
            type: Injectable
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ToolbarDividerComponent {
}
ToolbarDividerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ToolbarDividerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ToolbarDividerComponent, selector: "adf-toolbar-divider", host: { classAttribute: "adf-toolbar-divider" }, ngImport: i0, template: '<div></div>', isInline: true, styles: [".adf-toolbar-divider>div{height:24px;width:1px;background:rgba(0,0,0,.26);margin-left:5px;margin-right:5px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-toolbar-divider', template: '<div></div>', host: { class: 'adf-toolbar-divider' }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".adf-toolbar-divider>div{height:24px;width:1px;background:rgba(0,0,0,.26);margin-left:5px;margin-right:5px}\n"] }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PdfThumbComponent {
    constructor(sanitizer, element) {
        this.sanitizer = sanitizer;
        this.element = element;
        this.page = null;
    }
    ngOnInit() {
        this.image$ = this.page.getPage().then((page) => this.getThumb(page));
    }
    focus() {
        this.element.nativeElement.focus();
    }
    getThumb(page) {
        const viewport = page.getViewport({ scale: 1 });
        const canvas = this.getCanvas();
        const scale = Math.min((canvas.height / viewport.height), (canvas.width / viewport.width));
        return page.render({
            canvasContext: canvas.getContext('2d'),
            viewport: page.getViewport({ scale })
        }).promise.then(() => {
            const imageSource = canvas.toDataURL();
            return this.sanitizer.bypassSecurityTrustUrl(imageSource);
        });
    }
    getCanvas() {
        const canvas = document.createElement('canvas');
        canvas.width = this.page.getWidth();
        canvas.height = this.page.getHeight();
        return canvas;
    }
}
PdfThumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfThumbComponent, deps: [{ token: i1$2.DomSanitizer }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
PdfThumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PdfThumbComponent, selector: "adf-pdf-thumb", inputs: { page: "page" }, host: { attributes: { "tabindex": "0" } }, ngImport: i0, template: "<ng-container *ngIf=\"image$ | async as image\">\n    <img [src]=\"image\" role=\"button\"\n        [alt]=\"'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id }\"\n        title=\"{{ 'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id } }}\"\n        [attr.aria-label]=\"'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id }\">\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfThumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-pdf-thumb', encapsulation: ViewEncapsulation.None, host: { tabindex: '0' }, template: "<ng-container *ngIf=\"image$ | async as image\">\n    <img [src]=\"image\" role=\"button\"\n        [alt]=\"'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id }\"\n        title=\"{{ 'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id } }}\"\n        [attr.aria-label]=\"'ADF_VIEWER.SIDEBAR.THUMBNAILS.PAGE' | translate: { pageNum: page.id }\">\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }, { type: i0.ElementRef }]; }, propDecorators: { page: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PdfThumbListComponent {
    constructor(element, document) {
        this.element = element;
        this.document = document;
        this.close = new EventEmitter();
        this.virtualHeight = 0;
        this.translateY = 0;
        this.renderItems = [];
        this.width = 91;
        this.currentHeight = 0;
        this.items = [];
        this.margin = 15;
        this.itemHeight = 114 + this.margin;
        this.previouslyFocusedElement = null;
        this.calculateItems = this.calculateItems.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
    }
    onKeydown(event) {
        const keyCode = event.keyCode;
        if (keyCode === UP_ARROW && this.canSelectPreviousItem()) {
            this.pdfViewer.currentPageNumber -= 1;
        }
        if (keyCode === DOWN_ARROW && this.canSelectNextItem()) {
            this.pdfViewer.currentPageNumber += 1;
        }
        if (keyCode === TAB) {
            if (this.canSelectNextItem()) {
                this.pdfViewer.currentPageNumber += 1;
            }
            else {
                this.close.emit();
            }
        }
        if (keyCode === ESCAPE) {
            this.close.emit();
        }
        this.keyManager.setFocusOrigin('keyboard');
        event.preventDefault();
    }
    onResize() {
        this.calculateItems();
    }
    ngOnInit() {
        /* cspell:disable-next-line */
        this.pdfViewer.eventBus.on('pagechanging', this.onPageChange);
        this.element.nativeElement.addEventListener('scroll', this.calculateItems, true);
        this.setHeight(this.pdfViewer.currentPageNumber);
        this.items = this.getPages();
        this.calculateItems();
        this.previouslyFocusedElement = this.document.activeElement;
    }
    ngAfterViewInit() {
        this.keyManager = new FocusKeyManager(this.thumbsList);
        this.thumbsList.changes
            .pipe(delay(0))
            .subscribe(() => this.keyManager.setActiveItem(this.getPageIndex(this.pdfViewer.currentPageNumber)));
        setTimeout(() => {
            this.scrollInto(this.pdfViewer.currentPageNumber);
            this.keyManager.setActiveItem(this.getPageIndex(this.pdfViewer.currentPageNumber));
        }, 0);
    }
    ngOnDestroy() {
        this.element.nativeElement.removeEventListener('scroll', this.calculateItems, true);
        /* cspell:disable-next-line */
        this.pdfViewer.eventBus.on('pagechanging', this.onPageChange);
        if (this.previouslyFocusedElement) {
            this.previouslyFocusedElement.focus();
            this.previouslyFocusedElement = null;
        }
    }
    trackByFn(_, item) {
        return item.id;
    }
    isSelected(pageNumber) {
        return this.pdfViewer.currentPageNumber === pageNumber;
    }
    goTo(pageNumber) {
        this.pdfViewer.currentPageNumber = pageNumber;
    }
    scrollInto(pageNumber) {
        if (this.items.length) {
            const index = this.items.findIndex((element) => element.id === pageNumber);
            if (index < 0 || index >= this.items.length) {
                return;
            }
            this.element.nativeElement.scrollTop = index * this.itemHeight;
            this.calculateItems();
        }
    }
    getPages() {
        // eslint-disable-next-line no-underscore-dangle
        return this.pdfViewer._pages.map((page) => ({
            id: page.id,
            getWidth: () => this.width,
            getHeight: () => this.currentHeight,
            getPage: () => this.pdfViewer.pdfDocument.getPage(page.id)
        }));
    }
    setHeight(id) {
        const height = this.pdfViewer.pdfDocument.getPage(id).then((page) => this.calculateHeight(page));
        return height;
    }
    calculateHeight(page) {
        const viewport = page.getViewport({ scale: 1 });
        const pageRatio = viewport.width / viewport.height;
        const height = Math.floor(this.width / pageRatio);
        this.currentHeight = height;
        this.itemHeight = height + this.margin;
    }
    calculateItems() {
        const { element, viewPort, itemsInView } = this.getContainerSetup();
        const indexByScrollTop = element.scrollTop / viewPort * this.items.length / itemsInView;
        const start = Math.floor(indexByScrollTop);
        const end = Math.ceil(indexByScrollTop) + (itemsInView);
        this.translateY = this.itemHeight * Math.ceil(start);
        this.virtualHeight = this.itemHeight * this.items.length - this.translateY;
        this.renderItems = this.items.slice(start, end);
    }
    getContainerSetup() {
        const element = this.element.nativeElement;
        const elementRec = element.getBoundingClientRect();
        const itemsInView = Math.ceil(elementRec.height / this.itemHeight);
        const viewPort = (this.itemHeight * this.items.length) / itemsInView;
        return {
            element,
            viewPort,
            itemsInView
        };
    }
    onPageChange(event) {
        const index = this.renderItems.findIndex((element) => element.id === event.pageNumber);
        if (index < 0) {
            this.scrollInto(event.pageNumber);
        }
        if (index >= this.renderItems.length - 1) {
            this.element.nativeElement.scrollTop += this.itemHeight;
        }
        this.keyManager.setActiveItem(this.getPageIndex(event.pageNumber));
    }
    getPageIndex(pageNumber) {
        const thumbsListArray = this.thumbsList.toArray();
        return thumbsListArray.findIndex(el => el.page.id === pageNumber);
    }
    canSelectNextItem() {
        return this.pdfViewer.currentPageNumber !== this.pdfViewer.pagesCount;
    }
    canSelectPreviousItem() {
        return this.pdfViewer.currentPageNumber !== 1;
    }
}
PdfThumbListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfThumbListComponent, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
PdfThumbListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PdfThumbListComponent, selector: "adf-pdf-thumbnails", inputs: { pdfViewer: "pdfViewer" }, outputs: { close: "close" }, host: { listeners: { "keydown": "onKeydown($event)", "window:resize": "onResize()" }, classAttribute: "adf-pdf-thumbnails" }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "thumbsList", predicate: PdfThumbComponent, descendants: true }], ngImport: i0, template: "<div class=\"adf-pdf-thumbnails__content\"\n    data-automation-id='adf-thumbnails-content'\n    [style.height.px]=\"virtualHeight\"\n    [style.transform]=\"'translate(-50%, ' + translateY + 'px)'\">\n    <adf-pdf-thumb *ngFor=\"let page of renderItems; trackBy: trackByFn\"\n        class=\"adf-pdf-thumbnails__thumb\"\n        [id]=\"page.id\"\n        [ngClass]=\"{'adf-pdf-thumbnails__thumb--selected' : isSelected(page.id)}\"\n        [page]=\"page\"\n        (click)=\"goTo(page.id)\">\n    </adf-pdf-thumb>\n</div>\n", styles: [".adf-pdf-thumbnails{display:block;overflow:hidden;overflow-y:auto;height:100%;position:relative}.adf-pdf-thumbnails__content{top:5px;left:50%;height:0;position:absolute}.adf-pdf-thumbnails__thumb{cursor:pointer;display:block;width:91px;background:var(--theme-background-color);margin-bottom:15px}.adf-pdf-thumbnails__thumb:hover{box-shadow:0 0 5px 0 var(--adf-theme-foreground-text-color-087)}.adf-pdf-thumbnails__thumb--selected{border:2px solid var(--theme-accent-color-a200)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: PdfThumbComponent, selector: "adf-pdf-thumb", inputs: ["page"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfThumbListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-pdf-thumbnails', host: { class: 'adf-pdf-thumbnails' }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-pdf-thumbnails__content\"\n    data-automation-id='adf-thumbnails-content'\n    [style.height.px]=\"virtualHeight\"\n    [style.transform]=\"'translate(-50%, ' + translateY + 'px)'\">\n    <adf-pdf-thumb *ngFor=\"let page of renderItems; trackBy: trackByFn\"\n        class=\"adf-pdf-thumbnails__thumb\"\n        [id]=\"page.id\"\n        [ngClass]=\"{'adf-pdf-thumbnails__thumb--selected' : isSelected(page.id)}\"\n        [page]=\"page\"\n        (click)=\"goTo(page.id)\">\n    </adf-pdf-thumb>\n</div>\n", styles: [".adf-pdf-thumbnails{display:block;overflow:hidden;overflow-y:auto;height:100%;position:relative}.adf-pdf-thumbnails__content{top:5px;left:50%;height:0;position:absolute}.adf-pdf-thumbnails__thumb{cursor:pointer;display:block;width:91px;background:var(--theme-background-color);margin-bottom:15px}.adf-pdf-thumbnails__thumb:hover{box-shadow:0 0 5px 0 var(--adf-theme-foreground-text-color-087)}.adf-pdf-thumbnails__thumb--selected{border:2px solid var(--theme-accent-color-a200)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { pdfViewer: [{
                type: Input
            }], close: [{
                type: Output
            }], template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], thumbsList: [{
                type: ViewChildren,
                args: [PdfThumbComponent]
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PdfViewerComponent {
    constructor(dialog, renderingQueueServices, logService, appConfigService) {
        this.dialog = dialog;
        this.renderingQueueServices = renderingQueueServices;
        this.logService = logService;
        this.appConfigService = appConfigService;
        this.showToolbar = true;
        this.allowThumbnails = false;
        this.thumbnailsTemplate = null;
        this.cacheType = '';
        this.rendered = new EventEmitter();
        this.error = new EventEmitter();
        this.close = new EventEmitter();
        this.currentScaleMode = 'init';
        this.MAX_AUTO_SCALE = 1.25;
        this.DEFAULT_SCALE_DELTA = 1.1;
        this.MIN_SCALE = 0.25;
        this.MAX_SCALE = 10.0;
        this.isPanelDisabled = true;
        this.showThumbnails = false;
        this.pdfThumbnailsContext = { viewer: null };
        this.eventBus = new pdfjsViewer.EventBus();
        this.pdfjsDefaultOptions = {
            disableAutoFetch: true,
            disableStream: true,
            cMapUrl: './cmaps/',
            cMapPacked: true
        };
        this.pdfjsWorkerDestroy$ = new Subject();
        this.onDestroy$ = new Subject();
        // needed to preserve "this" context
        this.onPageChange = this.onPageChange.bind(this);
        this.onPagesLoaded = this.onPagesLoaded.bind(this);
        this.onPageRendered = this.onPageRendered.bind(this);
        this.randomPdfId = this.generateUuid();
        this.pdfjsWorkerDestroy$.pipe(catchError(() => null), delay(700)).subscribe(() => this.destroyPdJsWorker());
    }
    get currentScaleText() {
        return this.pdfViewer?.currentScaleValue ? Math.round(this.pdfViewer.currentScaleValue * 100) + '%' : '';
    }
    getUserScaling() {
        let scaleConfig = this.appConfigService.get('adf-viewer.pdf-viewer-scaling', undefined);
        if (scaleConfig) {
            scaleConfig = scaleConfig / 100;
            scaleConfig = this.checkLimits(scaleConfig);
        }
        return scaleConfig;
    }
    checkLimits(scaleConfig) {
        if (scaleConfig > this.MAX_SCALE) {
            return this.MAX_SCALE;
        }
        else if (scaleConfig < this.MIN_SCALE) {
            return this.MIN_SCALE;
        }
        else {
            return scaleConfig;
        }
    }
    ngOnChanges(changes) {
        const blobFile = changes['blobFile'];
        if (blobFile && blobFile.currentValue) {
            const reader = new FileReader();
            reader.onload = async () => {
                const pdfOptions = {
                    ...this.pdfjsDefaultOptions,
                    data: reader.result,
                    withCredentials: this.appConfigService.get('auth.withCredentials', undefined)
                };
                this.executePdf(pdfOptions);
            };
            reader.readAsArrayBuffer(blobFile.currentValue);
        }
        const urlFile = changes['urlFile'];
        if (urlFile && urlFile.currentValue) {
            const pdfOptions = {
                ...this.pdfjsDefaultOptions,
                url: urlFile.currentValue,
                withCredentials: this.appConfigService.get('auth.withCredentials', undefined)
            };
            if (this.cacheType) {
                // @ts-ignore
                pdfOptions.httpHeaders = {
                    'Cache-Control': this.cacheType
                };
            }
            this.executePdf(pdfOptions);
        }
        if (!this.urlFile && !this.blobFile) {
            throw new Error('Attribute urlFile or blobFile is required');
        }
    }
    executePdf(pdfOptions) {
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';
        this.loadingTask = pdfjsLib.getDocument(pdfOptions);
        this.loadingTask.onPassword = (callback, reason) => {
            this.onPdfPassword(callback, reason);
        };
        this.loadingTask.onProgress = (progressData) => {
            const level = progressData.loaded / progressData.total;
            this.loadingPercent = Math.round(level * 100);
        };
        this.loadingTask.promise.then((pdfDocument) => {
            this.totalPages = pdfDocument.numPages;
            this.page = 1;
            this.displayPage = 1;
            this.initPDFViewer(pdfDocument);
            return pdfDocument.getPage(1);
        })
            .then(() => this.scalePage('init'))
            .catch(() => this.error.emit());
    }
    initPDFViewer(pdfDocument) {
        const viewer = this.getViewer();
        const container = this.getDocumentContainer();
        if (viewer && container) {
            this.pdfViewer = new pdfjsViewer.PDFViewer({
                container,
                viewer,
                renderingQueue: this.renderingQueueServices,
                eventBus: this.eventBus
            });
            // cspell: disable-next
            this.eventBus.on('pagechanging', this.onPageChange);
            // cspell: disable-next
            this.eventBus.on('pagesloaded', this.onPagesLoaded);
            // cspell: disable-next
            this.eventBus.on('textlayerrendered', this.onPageRendered);
            this.renderingQueueServices.setViewer(this.pdfViewer);
            this.pdfViewer.setDocument(pdfDocument);
            this.pdfThumbnailsContext.viewer = this.pdfViewer;
        }
    }
    ngOnDestroy() {
        if (this.pdfViewer) {
            // cspell: disable-next
            this.eventBus.off('pagechanging');
            // cspell: disable-next
            this.eventBus.off('pagesloaded');
            // cspell: disable-next
            this.eventBus.off('textlayerrendered');
        }
        if (this.loadingTask) {
            this.pdfjsWorkerDestroy$.next();
        }
        this.onDestroy$.next();
        this.pdfjsWorkerDestroy$.complete();
        this.onDestroy$.complete();
    }
    destroyPdJsWorker() {
        this.loadingTask.destroy();
        this.loadingTask = null;
    }
    toggleThumbnails() {
        this.showThumbnails = !this.showThumbnails;
    }
    /**
     * Method to scale the page current support implementation
     *
     * @param scaleMode - new scale mode
     */
    scalePage(scaleMode) {
        this.currentScaleMode = scaleMode;
        const viewerContainer = document.getElementById(`${this.randomPdfId}-viewer-main-container`);
        const documentContainer = this.getDocumentContainer();
        if (this.pdfViewer && documentContainer) {
            let widthContainer;
            let heightContainer;
            if (viewerContainer && viewerContainer.clientWidth <= documentContainer.clientWidth) {
                widthContainer = viewerContainer.clientWidth;
                heightContainer = viewerContainer.clientHeight;
            }
            else {
                widthContainer = documentContainer.clientWidth;
                heightContainer = documentContainer.clientHeight;
            }
            const currentPage = this.pdfViewer._pages[this.pdfViewer._currentPageNumber - 1];
            const padding = 20;
            const pageWidthScale = (widthContainer - padding) / currentPage.width * currentPage.scale;
            const pageHeightScale = (heightContainer - padding) / currentPage.width * currentPage.scale;
            let scale;
            switch (this.currentScaleMode) {
                case 'init':
                    scale = this.getUserScaling();
                    if (!scale) {
                        scale = this.autoScaling(pageHeightScale, pageWidthScale);
                    }
                    break;
                case 'page-actual':
                    scale = 1;
                    break;
                case 'page-width':
                    scale = pageWidthScale;
                    break;
                case 'page-height':
                    scale = pageHeightScale;
                    break;
                case 'page-fit':
                    scale = this.getUserScaling();
                    if (!scale) {
                        scale = this.autoScaling(pageHeightScale, pageWidthScale);
                    }
                    break;
                case 'auto':
                    scale = this.autoScaling(pageHeightScale, pageWidthScale);
                    break;
                default:
                    this.logService.error('pdfViewSetScale: \'' + scaleMode + '\' is an unknown zoom value.');
                    return;
            }
            this.setScaleUpdatePages(scale);
        }
    }
    autoScaling(pageHeightScale, pageWidthScale) {
        let horizontalScale;
        if (this.isLandscape) {
            horizontalScale = Math.min(pageHeightScale, pageWidthScale);
        }
        else {
            horizontalScale = pageWidthScale;
        }
        horizontalScale = Math.round(horizontalScale);
        const scale = Math.min(this.MAX_AUTO_SCALE, horizontalScale);
        return this.checkPageFitInContainer(scale);
    }
    getDocumentContainer() {
        return document.getElementById(`${this.randomPdfId}-viewer-pdf-viewer`);
    }
    getViewer() {
        return document.getElementById(`${this.randomPdfId}-viewer-viewerPdf`);
    }
    checkPageFitInContainer(scale) {
        const documentContainerSize = this.getDocumentContainer();
        const page = this.pdfViewer._pages[this.pdfViewer._currentPageNumber - 1];
        if (page.width > documentContainerSize.clientWidth) {
            scale = Math.fround((documentContainerSize.clientWidth - 20) / page.width);
            if (scale < this.MIN_SCALE) {
                scale = this.MIN_SCALE;
            }
        }
        return scale;
    }
    /**
     * Update all the pages with the newScale scale
     *
     * @param newScale - new scale page
     */
    setScaleUpdatePages(newScale) {
        if (this.pdfViewer) {
            if (!this.isSameScale(this.pdfViewer.currentScaleValue, newScale)) {
                this.pdfViewer.currentScaleValue = newScale;
            }
            this.pdfViewer.update();
        }
    }
    /**
     * Check if the request scale of the page is the same for avoid useless re-rendering
     *
     * @param oldScale - old scale page
     * @param newScale - new scale page
     *
     */
    isSameScale(oldScale, newScale) {
        return (newScale === oldScale);
    }
    /**
     * Check if is a land scape view
     *
     * @param width
     * @param height
     */
    isLandscape(width, height) {
        return (width > height);
    }
    /**
     * Method triggered when the page is resized
     */
    onResize() {
        this.scalePage(this.currentScaleMode);
    }
    /**
     * toggle the fit page pdf
     */
    pageFit() {
        if (this.currentScaleMode !== 'page-fit') {
            this.scalePage('page-fit');
        }
        else {
            this.scalePage('auto');
        }
    }
    /**
     * zoom in page pdf
     *
     * @param ticks
     */
    zoomIn(ticks) {
        let newScale = this.pdfViewer.currentScaleValue;
        do {
            newScale = (newScale * this.DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.ceil(newScale * 10) / 10;
            newScale = Math.min(this.MAX_SCALE, newScale);
        } while (--ticks > 0 && newScale < this.MAX_SCALE);
        this.currentScaleMode = 'auto';
        this.setScaleUpdatePages(newScale);
    }
    /**
     * zoom out page pdf
     *
     * @param ticks
     */
    zoomOut(ticks) {
        let newScale = this.pdfViewer.currentScaleValue;
        do {
            newScale = (newScale / this.DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.floor(newScale * 10) / 10;
            newScale = Math.max(this.MIN_SCALE, newScale);
        } while (--ticks > 0 && newScale > this.MIN_SCALE);
        this.currentScaleMode = 'auto';
        this.setScaleUpdatePages(newScale);
    }
    /**
     * load the previous page
     */
    previousPage() {
        if (this.pdfViewer && this.page > 1) {
            this.page--;
            this.displayPage = this.page;
            this.pdfViewer.currentPageNumber = this.page;
        }
    }
    /**
     * load the next page
     */
    nextPage() {
        if (this.pdfViewer && this.page < this.totalPages) {
            this.page++;
            this.displayPage = this.page;
            this.pdfViewer.currentPageNumber = this.page;
        }
    }
    /**
     * load the page in input
     *
     * @param page to load
     */
    inputPage(page) {
        const pageInput = parseInt(page, 10);
        if (!isNaN(pageInput) && pageInput > 0 && pageInput <= this.totalPages) {
            this.page = pageInput;
            this.displayPage = this.page;
            this.pdfViewer.currentPageNumber = this.page;
        }
        else {
            this.displayPage = this.page;
        }
    }
    /**
     * Page Change Event
     *
     * @param event
     */
    onPageChange(event) {
        if (event.source && event.source.container.id === `${this.randomPdfId}-viewer-pdf-viewer`) {
            this.page = event.pageNumber;
            this.displayPage = event.pageNumber;
        }
    }
    onPdfPassword(callback, reason) {
        this.dialog
            .open(PdfPasswordDialogComponent, {
            width: '400px',
            data: { reason }
        })
            .afterClosed().subscribe((password) => {
            if (password) {
                callback(password);
            }
            else {
                this.close.emit();
            }
        });
    }
    /**
     * Page Rendered Event
     */
    onPageRendered() {
        this.rendered.emit();
    }
    /**
     * Pages Loaded Event
     *
     * @param event
     */
    onPagesLoaded() {
        this.isPanelDisabled = false;
    }
    /**
     * Keyboard Event Listener
     *
     * @param KeyboardEvent event
     */
    handleKeyboardEvent(event) {
        const key = event.keyCode;
        if (key === 39) { // right arrow
            this.nextPage();
        }
        else if (key === 37) { // left arrow
            this.previousPage();
        }
    }
    generateUuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
PdfViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfViewerComponent, deps: [{ token: i1$4.MatDialog }, { token: RenderingQueueServices }, { token: LogService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
PdfViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PdfViewerComponent, selector: "adf-pdf-viewer", inputs: { urlFile: "urlFile", blobFile: "blobFile", fileName: "fileName", showToolbar: "showToolbar", allowThumbnails: "allowThumbnails", thumbnailsTemplate: "thumbnailsTemplate", cacheType: "cacheType" }, outputs: { rendered: "rendered", error: "error", close: "close" }, host: { listeners: { "document:keydown": "handleKeyboardEvent($event)" }, classAttribute: "adf-pdf-viewer" }, providers: [RenderingQueueServices], usesOnChanges: true, ngImport: i0, template: "<div class=\"adf-pdf-viewer__container\">\n    <ng-container *ngIf=\"showThumbnails\">\n        <div class=\"adf-pdf-viewer__thumbnails\">\n            <div class=\"adf-thumbnails-template__container\">\n                <div class=\"adf-thumbnails-template__buttons\">\n                    <button\n                        mat-icon-button\n                        data-automation-id='adf-thumbnails-close'\n                        (click)=\"toggleThumbnails()\"\n                        [attr.aria-label]=\"'ADF_VIEWER.ARIA.THUMBNAILS_PANLEL_CLOSE' | translate\"\n                        title=\"{{ 'ADF_VIEWER.ACTIONS.CLOSE' | translate }}\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </div>\n\n                <ng-container *ngIf=\"thumbnailsTemplate\">\n                    <ng-container *ngTemplateOutlet=\"thumbnailsTemplate;context:pdfThumbnailsContext\"></ng-container>\n                </ng-container>\n\n                <ng-container *ngIf=\"!thumbnailsTemplate\">\n                    <adf-pdf-thumbnails (close)=\"toggleThumbnails()\" [pdfViewer]=\"pdfViewer\"></adf-pdf-thumbnails>\n                </ng-container>\n            </div>\n        </div>\n    </ng-container>\n\n    <div class=\"adf-pdf-viewer__content\">\n        <div [id]=\"randomPdfId+'-viewer-pdf-viewer'\" class=\"adf-viewer-pdf-viewer\" (window:resize)=\"onResize()\">\n            <div [id]=\"randomPdfId+'-viewer-viewerPdf'\" class=\"adf-pdfViewer\" role=\"document\" tabindex=\"0\" aria-expanded=\"true\">\n                <div id=\"loader-container\" class=\"adf-loader-container\">\n                    <div class=\"adf-loader-item\">\n                        <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"adf-pdf-viewer__toolbar\" *ngIf=\"showToolbar\">\n    <adf-toolbar>\n\n        <ng-container *ngIf=\"allowThumbnails\">\n            <button mat-icon-button\n                    [attr.aria-label]=\"'ADF_VIEWER.ARIA.THUMBNAILS' | translate\"\n                    [attr.aria-expanded]=\"showThumbnails\"\n                    data-automation-id=\"adf-thumbnails-button\"\n                    [disabled]=\"isPanelDisabled\"\n                    (click)=\"toggleThumbnails()\">\n                <mat-icon>dashboard</mat-icon>\n            </button>\n            <adf-toolbar-divider></adf-toolbar-divider>\n        </ng-container>\n\n        <button\n            id=\"viewer-previous-page-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.PREVIOUS_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.PREVIOUS_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"previousPage()\">\n            <mat-icon>keyboard_arrow_up</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-next-page-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.NEXT_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.NEXT_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"nextPage()\">\n            <mat-icon>keyboard_arrow_down</mat-icon>\n        </button>\n\n        <div class=\"adf-pdf-viewer__toolbar-page-selector\">\n            <label for=\"page-selector\">{{ 'ADF_VIEWER.PAGE_LABEL.SHOWING' | translate }}</label>\n            <input #page\n                   id=\"page-selector\"\n                   type=\"text\"\n                   data-automation-id=\"adf-page-selector\"\n                   pattern=\"-?[0-9]*(\\.[0-9]+)?\"\n                   value=\"{{ displayPage }}\"\n                   [attr.aria-label]=\"'ADF_VIEWER.PAGE_LABEL.PAGE_SELECTOR_LABEL' | translate\"\n                   (keyup.enter)=\"inputPage(page.value)\">\n            <span>{{ 'ADF_VIEWER.PAGE_LABEL.OF' | translate }} {{ totalPages }}</span>\n        </div>\n\n        <div class=\"adf-pdf-viewer__toolbar-page-scale\" data-automation-id=\"adf-page-scale\">\n            {{ currentScaleText }}\n        </div>\n\n        <button\n            id=\"viewer-zoom-in-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomIn()\">\n            <mat-icon>zoom_in</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-zoom-out-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomOut()\">\n            <mat-icon>zoom_out</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-scale-page-button\"\n            role=\"button\" aria-pressed=\"true\"\n            title=\"{{ 'ADF_VIEWER.ARIA.FIT_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.FIT_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"pageFit()\">\n            <mat-icon>zoom_out_map</mat-icon>\n        </button>\n\n    </adf-toolbar>\n</div>\n", styles: [".adf-pdf-viewer .textLayer{position:absolute;inset:0;overflow:hidden;opacity:.2;line-height:1;border:1px solid gray}.adf-pdf-viewer .textLayer>div{color:transparent;position:absolute;white-space:pre;cursor:text;transform-origin:0 0}.adf-pdf-viewer .textLayer .adf-highlight{margin:-1px;padding:1px;background-color:#b400aa;border-radius:4px}.adf-pdf-viewer .textLayer .adf-highlight.adf-begin{border-radius:4px 0 0 4px}.adf-pdf-viewer .textLayer .adf-highlight.adf-end{border-radius:0 4px 4px 0}.adf-pdf-viewer .textLayer .adf-highlight.adf-middle{border-radius:0}.adf-pdf-viewer .textLayer .adf-highlight.adf-selected{background-color:#006400}.adf-pdf-viewer .textLayer::selection{background:rgb(0,0,255)}.adf-pdf-viewer .textLayer::-moz-selection{background:rgb(0,0,255)}.adf-pdf-viewer .textLayer .adf-endOfContent{display:block;position:absolute;inset:100% 0 0;z-index:-1;cursor:default;user-select:none;-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none}.adf-pdf-viewer .textLayer .adf-endOfContent.adf-active{top:0}.adf-pdf-viewer .adf-annotationLayer section{position:absolute}.adf-pdf-viewer .adf-annotationLayer .adf-linkAnnotation>a{position:absolute;font-size:1em;top:0;left:0;width:100%;height:100%;background:url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7) 0 0 repeat}.adf-pdf-viewer .adf-annotationLayer .adf-linkAnnotation>a:hover{opacity:.2;background:#ff0;box-shadow:0 2px 10px #ff0}.adf-pdf-viewer .adf-annotationLayer .adf-textAnnotation img{position:absolute;cursor:pointer}.adf-pdf-viewer .adf-annotationLayer .adf-popupWrapper{position:absolute;width:20em}.adf-pdf-viewer .adf-annotationLayer .adf-popup{position:absolute;z-index:200;max-width:20em;background-color:#ff9;box-shadow:0 2px 5px #333;border-radius:2px;padding:.6em;margin-left:5px;cursor:pointer;word-wrap:break-word}.adf-pdf-viewer .adf-annotationLayer .adf-popup h1{font-size:1em;border-bottom:1px solid #000000;padding-bottom:.2em}.adf-pdf-viewer .adf-annotationLayer .adf-popup p{padding-top:.2em}.adf-pdf-viewer .adf-annotationLayer .adf-highlightAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-underlineAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-squigglyAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-strikeoutAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-fileAttachmentAnnotation{cursor:pointer}.adf-pdf-viewer .adf-pdfViewer .canvasWrapper{overflow:hidden}.adf-pdf-viewer .adf-pdfViewer .page{direction:ltr;width:816px;height:1056px;margin:1px auto -8px;position:relative;overflow:visible;border:9px solid transparent;background-clip:content-box;background-color:#fff}.adf-pdf-viewer .adf-pdfViewer .page canvas{margin:0;display:block}.adf-pdf-viewer .adf-pdfViewer .page .adf-loadingIcon{position:absolute;display:block;inset:0}.adf-pdf-viewer .adf-pdfViewer .page *{padding:0;margin:0}.adf-pdf-viewer .adf-pdfViewer.adf-removePageBorders .adf-page{margin:0 auto 10px;border:none}.adf-pdf-viewer .adf-pdfViewer .adf-loadingIcon{width:100px;height:100px;left:50%!important;top:50%!important;margin-top:-50px;margin-left:-50px;font-size:5px;text-indent:-9999em;border-top:1.1em solid rgba(3,0,2,.2);border-right:1.1em solid rgba(3,0,2,.2);border-bottom:1.1em solid rgba(3,0,2,.2);border-left:1.1em solid #030002;transform:translateZ(0);animation:load8 1.1s infinite linear;border-radius:50%}.adf-pdf-viewer .adf-pdfViewer .adf-loadingIcon:after{border-radius:50%}.adf-pdf-viewer .adf-hidden,.adf-pdf-viewer [hidden]{display:none!important}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.adf-viewer-pdf-viewer{overflow:auto;-webkit-overflow-scrolling:touch;position:absolute;inset:0;outline:none}html[dir=ltr] .adf-viewer-pdf-viewer{box-shadow:inset 1px 0 #ffffff0d}html[dir=rtl] .adf-viewer-pdf-viewer{box-shadow:inset -1px 0 #ffffff0d}\n", ".adf-pdf-viewer{width:100%;height:100%;margin:0}.adf-pdf-viewer .adf-loader-container{display:flex;flex-direction:row;height:100%}.adf-pdf-viewer__thumbnails{position:relative;height:100%;width:190px;background-color:#0000001f;display:flex;flex-direction:column;padding:0}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout{display:flex;flex-direction:column;flex:1;background:#e6e6e6}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-header{margin-bottom:0}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-content{padding:0;height:100%;overflow:hidden}.adf-pdf-viewer__thumbnails .adf-info-drawer-content{height:100%}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-content>*:last-child{height:100%;overflow:hidden}.adf-pdf-viewer .adf-thumbnails-template__container{display:flex;flex-direction:column;height:100%}.adf-pdf-viewer .adf-thumbnails-template__buttons{height:45px;justify-content:flex-end;align-items:flex-end;display:flex;color:var(--adf-theme-foreground-text-color-054)}.adf-pdf-viewer__container{display:flex;height:100vh}.adf-pdf-viewer__content{flex:1 1 auto;position:relative}.adf-pdf-viewer .adf-loader-item{margin:auto;max-height:100px;max-width:300px}.adf-pdf-viewer .adf-loader-item .mat-progress-bar{max-width:300px;margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.adf-pdf-viewer__toolbar{z-index:100;position:absolute;bottom:5px;left:50%;transform:translate(-50%)}.adf-pdf-viewer__toolbar .adf-toolbar .mat-toolbar{max-height:48px;background-color:var(--adf-theme-background-card-color);border-width:0;border-radius:2px;box-shadow:0 2px 2px #000,0 0 2px #0000001f}.adf-pdf-viewer__toolbar-page-selector{padding-left:10px;padding-right:10px;font-size:var(--theme-body-1-font-size)}.adf-pdf-viewer__toolbar-page-selector>input{border:1px solid var(--adf-theme-foreground-text-color-007);background-color:var(--adf-theme-background-card-color);color:inherit;font-size:var(--theme-body-1-font-size);padding:5px;height:24px;line-height:24px;text-align:right;width:33px;margin-right:4px;outline-width:1px;outline-color:gray}.adf-pdf-viewer__toolbar-page-scale{cursor:default;width:79px;height:24px;font-size:var(--theme-body-1-font-size);border:1px solid var(--adf-theme-foreground-text-color-007);text-align:center;line-height:24px;margin-left:4px;margin-right:4px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i8.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: ToolbarComponent, selector: "adf-toolbar", inputs: ["title", "color"] }, { kind: "component", type: ToolbarDividerComponent, selector: "adf-toolbar-divider" }, { kind: "component", type: PdfThumbListComponent, selector: "adf-pdf-thumbnails", inputs: ["pdfViewer"], outputs: ["close"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PdfViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-pdf-viewer', providers: [RenderingQueueServices], host: { class: 'adf-pdf-viewer' }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-pdf-viewer__container\">\n    <ng-container *ngIf=\"showThumbnails\">\n        <div class=\"adf-pdf-viewer__thumbnails\">\n            <div class=\"adf-thumbnails-template__container\">\n                <div class=\"adf-thumbnails-template__buttons\">\n                    <button\n                        mat-icon-button\n                        data-automation-id='adf-thumbnails-close'\n                        (click)=\"toggleThumbnails()\"\n                        [attr.aria-label]=\"'ADF_VIEWER.ARIA.THUMBNAILS_PANLEL_CLOSE' | translate\"\n                        title=\"{{ 'ADF_VIEWER.ACTIONS.CLOSE' | translate }}\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </div>\n\n                <ng-container *ngIf=\"thumbnailsTemplate\">\n                    <ng-container *ngTemplateOutlet=\"thumbnailsTemplate;context:pdfThumbnailsContext\"></ng-container>\n                </ng-container>\n\n                <ng-container *ngIf=\"!thumbnailsTemplate\">\n                    <adf-pdf-thumbnails (close)=\"toggleThumbnails()\" [pdfViewer]=\"pdfViewer\"></adf-pdf-thumbnails>\n                </ng-container>\n            </div>\n        </div>\n    </ng-container>\n\n    <div class=\"adf-pdf-viewer__content\">\n        <div [id]=\"randomPdfId+'-viewer-pdf-viewer'\" class=\"adf-viewer-pdf-viewer\" (window:resize)=\"onResize()\">\n            <div [id]=\"randomPdfId+'-viewer-viewerPdf'\" class=\"adf-pdfViewer\" role=\"document\" tabindex=\"0\" aria-expanded=\"true\">\n                <div id=\"loader-container\" class=\"adf-loader-container\">\n                    <div class=\"adf-loader-item\">\n                        <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"adf-pdf-viewer__toolbar\" *ngIf=\"showToolbar\">\n    <adf-toolbar>\n\n        <ng-container *ngIf=\"allowThumbnails\">\n            <button mat-icon-button\n                    [attr.aria-label]=\"'ADF_VIEWER.ARIA.THUMBNAILS' | translate\"\n                    [attr.aria-expanded]=\"showThumbnails\"\n                    data-automation-id=\"adf-thumbnails-button\"\n                    [disabled]=\"isPanelDisabled\"\n                    (click)=\"toggleThumbnails()\">\n                <mat-icon>dashboard</mat-icon>\n            </button>\n            <adf-toolbar-divider></adf-toolbar-divider>\n        </ng-container>\n\n        <button\n            id=\"viewer-previous-page-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.PREVIOUS_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.PREVIOUS_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"previousPage()\">\n            <mat-icon>keyboard_arrow_up</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-next-page-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.NEXT_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.NEXT_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"nextPage()\">\n            <mat-icon>keyboard_arrow_down</mat-icon>\n        </button>\n\n        <div class=\"adf-pdf-viewer__toolbar-page-selector\">\n            <label for=\"page-selector\">{{ 'ADF_VIEWER.PAGE_LABEL.SHOWING' | translate }}</label>\n            <input #page\n                   id=\"page-selector\"\n                   type=\"text\"\n                   data-automation-id=\"adf-page-selector\"\n                   pattern=\"-?[0-9]*(\\.[0-9]+)?\"\n                   value=\"{{ displayPage }}\"\n                   [attr.aria-label]=\"'ADF_VIEWER.PAGE_LABEL.PAGE_SELECTOR_LABEL' | translate\"\n                   (keyup.enter)=\"inputPage(page.value)\">\n            <span>{{ 'ADF_VIEWER.PAGE_LABEL.OF' | translate }} {{ totalPages }}</span>\n        </div>\n\n        <div class=\"adf-pdf-viewer__toolbar-page-scale\" data-automation-id=\"adf-page-scale\">\n            {{ currentScaleText }}\n        </div>\n\n        <button\n            id=\"viewer-zoom-in-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_IN' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomIn()\">\n            <mat-icon>zoom_in</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-zoom-out-button\"\n            title=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.ZOOM_OUT' | translate }}\"\n            mat-icon-button\n            (click)=\"zoomOut()\">\n            <mat-icon>zoom_out</mat-icon>\n        </button>\n\n        <button\n            id=\"viewer-scale-page-button\"\n            role=\"button\" aria-pressed=\"true\"\n            title=\"{{ 'ADF_VIEWER.ARIA.FIT_PAGE' | translate }}\"\n            attr.aria-label=\"{{ 'ADF_VIEWER.ARIA.FIT_PAGE' | translate }}\"\n            mat-icon-button\n            (click)=\"pageFit()\">\n            <mat-icon>zoom_out_map</mat-icon>\n        </button>\n\n    </adf-toolbar>\n</div>\n", styles: [".adf-pdf-viewer .textLayer{position:absolute;inset:0;overflow:hidden;opacity:.2;line-height:1;border:1px solid gray}.adf-pdf-viewer .textLayer>div{color:transparent;position:absolute;white-space:pre;cursor:text;transform-origin:0 0}.adf-pdf-viewer .textLayer .adf-highlight{margin:-1px;padding:1px;background-color:#b400aa;border-radius:4px}.adf-pdf-viewer .textLayer .adf-highlight.adf-begin{border-radius:4px 0 0 4px}.adf-pdf-viewer .textLayer .adf-highlight.adf-end{border-radius:0 4px 4px 0}.adf-pdf-viewer .textLayer .adf-highlight.adf-middle{border-radius:0}.adf-pdf-viewer .textLayer .adf-highlight.adf-selected{background-color:#006400}.adf-pdf-viewer .textLayer::selection{background:rgb(0,0,255)}.adf-pdf-viewer .textLayer::-moz-selection{background:rgb(0,0,255)}.adf-pdf-viewer .textLayer .adf-endOfContent{display:block;position:absolute;inset:100% 0 0;z-index:-1;cursor:default;user-select:none;-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none}.adf-pdf-viewer .textLayer .adf-endOfContent.adf-active{top:0}.adf-pdf-viewer .adf-annotationLayer section{position:absolute}.adf-pdf-viewer .adf-annotationLayer .adf-linkAnnotation>a{position:absolute;font-size:1em;top:0;left:0;width:100%;height:100%;background:url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7) 0 0 repeat}.adf-pdf-viewer .adf-annotationLayer .adf-linkAnnotation>a:hover{opacity:.2;background:#ff0;box-shadow:0 2px 10px #ff0}.adf-pdf-viewer .adf-annotationLayer .adf-textAnnotation img{position:absolute;cursor:pointer}.adf-pdf-viewer .adf-annotationLayer .adf-popupWrapper{position:absolute;width:20em}.adf-pdf-viewer .adf-annotationLayer .adf-popup{position:absolute;z-index:200;max-width:20em;background-color:#ff9;box-shadow:0 2px 5px #333;border-radius:2px;padding:.6em;margin-left:5px;cursor:pointer;word-wrap:break-word}.adf-pdf-viewer .adf-annotationLayer .adf-popup h1{font-size:1em;border-bottom:1px solid #000000;padding-bottom:.2em}.adf-pdf-viewer .adf-annotationLayer .adf-popup p{padding-top:.2em}.adf-pdf-viewer .adf-annotationLayer .adf-highlightAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-underlineAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-squigglyAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-strikeoutAnnotation,.adf-pdf-viewer .adf-annotationLayer .adf-fileAttachmentAnnotation{cursor:pointer}.adf-pdf-viewer .adf-pdfViewer .canvasWrapper{overflow:hidden}.adf-pdf-viewer .adf-pdfViewer .page{direction:ltr;width:816px;height:1056px;margin:1px auto -8px;position:relative;overflow:visible;border:9px solid transparent;background-clip:content-box;background-color:#fff}.adf-pdf-viewer .adf-pdfViewer .page canvas{margin:0;display:block}.adf-pdf-viewer .adf-pdfViewer .page .adf-loadingIcon{position:absolute;display:block;inset:0}.adf-pdf-viewer .adf-pdfViewer .page *{padding:0;margin:0}.adf-pdf-viewer .adf-pdfViewer.adf-removePageBorders .adf-page{margin:0 auto 10px;border:none}.adf-pdf-viewer .adf-pdfViewer .adf-loadingIcon{width:100px;height:100px;left:50%!important;top:50%!important;margin-top:-50px;margin-left:-50px;font-size:5px;text-indent:-9999em;border-top:1.1em solid rgba(3,0,2,.2);border-right:1.1em solid rgba(3,0,2,.2);border-bottom:1.1em solid rgba(3,0,2,.2);border-left:1.1em solid #030002;transform:translateZ(0);animation:load8 1.1s infinite linear;border-radius:50%}.adf-pdf-viewer .adf-pdfViewer .adf-loadingIcon:after{border-radius:50%}.adf-pdf-viewer .adf-hidden,.adf-pdf-viewer [hidden]{display:none!important}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.adf-viewer-pdf-viewer{overflow:auto;-webkit-overflow-scrolling:touch;position:absolute;inset:0;outline:none}html[dir=ltr] .adf-viewer-pdf-viewer{box-shadow:inset 1px 0 #ffffff0d}html[dir=rtl] .adf-viewer-pdf-viewer{box-shadow:inset -1px 0 #ffffff0d}\n", ".adf-pdf-viewer{width:100%;height:100%;margin:0}.adf-pdf-viewer .adf-loader-container{display:flex;flex-direction:row;height:100%}.adf-pdf-viewer__thumbnails{position:relative;height:100%;width:190px;background-color:#0000001f;display:flex;flex-direction:column;padding:0}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout{display:flex;flex-direction:column;flex:1;background:#e6e6e6}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-header{margin-bottom:0}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-content{padding:0;height:100%;overflow:hidden}.adf-pdf-viewer__thumbnails .adf-info-drawer-content{height:100%}.adf-pdf-viewer__thumbnails .adf-info-drawer-layout-content>*:last-child{height:100%;overflow:hidden}.adf-pdf-viewer .adf-thumbnails-template__container{display:flex;flex-direction:column;height:100%}.adf-pdf-viewer .adf-thumbnails-template__buttons{height:45px;justify-content:flex-end;align-items:flex-end;display:flex;color:var(--adf-theme-foreground-text-color-054)}.adf-pdf-viewer__container{display:flex;height:100vh}.adf-pdf-viewer__content{flex:1 1 auto;position:relative}.adf-pdf-viewer .adf-loader-item{margin:auto;max-height:100px;max-width:300px}.adf-pdf-viewer .adf-loader-item .mat-progress-bar{max-width:300px;margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.adf-pdf-viewer__toolbar{z-index:100;position:absolute;bottom:5px;left:50%;transform:translate(-50%)}.adf-pdf-viewer__toolbar .adf-toolbar .mat-toolbar{max-height:48px;background-color:var(--adf-theme-background-card-color);border-width:0;border-radius:2px;box-shadow:0 2px 2px #000,0 0 2px #0000001f}.adf-pdf-viewer__toolbar-page-selector{padding-left:10px;padding-right:10px;font-size:var(--theme-body-1-font-size)}.adf-pdf-viewer__toolbar-page-selector>input{border:1px solid var(--adf-theme-foreground-text-color-007);background-color:var(--adf-theme-background-card-color);color:inherit;font-size:var(--theme-body-1-font-size);padding:5px;height:24px;line-height:24px;text-align:right;width:33px;margin-right:4px;outline-width:1px;outline-color:gray}.adf-pdf-viewer__toolbar-page-scale{cursor:default;width:79px;height:24px;font-size:var(--theme-body-1-font-size);border:1px solid var(--adf-theme-foreground-text-color-007);text-align:center;line-height:24px;margin-left:4px;margin-right:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialog }, { type: RenderingQueueServices }, { type: LogService }, { type: AppConfigService }]; }, propDecorators: { urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }], fileName: [{
                type: Input
            }], showToolbar: [{
                type: Input
            }], allowThumbnails: [{
                type: Input
            }], thumbnailsTemplate: [{
                type: Input
            }], cacheType: [{
                type: Input
            }], rendered: [{
                type: Output
            }], error: [{
                type: Output
            }], close: [{
                type: Output
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TxtViewerComponent {
    constructor(http, appConfigService) {
        this.http = http;
        this.appConfigService = appConfigService;
    }
    ngOnChanges(changes) {
        const blobFile = changes['blobFile'];
        if (blobFile && blobFile.currentValue) {
            return this.readBlob(blobFile.currentValue);
        }
        const urlFile = changes['urlFile'];
        if (urlFile && urlFile.currentValue) {
            return this.getUrlContent(urlFile.currentValue);
        }
        if (!this.urlFile && !this.blobFile) {
            throw new Error('Attribute urlFile or blobFile is required');
        }
        return Promise.resolve();
    }
    getUrlContent(url) {
        const withCredentialsMode = this.appConfigService.get('auth.withCredentials', false);
        return new Promise((resolve, reject) => {
            this.http.get(url, { responseType: 'text', withCredentials: withCredentialsMode }).subscribe((res) => {
                this.content = res;
                resolve();
            }, (event) => {
                reject(event);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                this.content = reader.result;
                resolve();
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsText(blob);
        });
    }
}
TxtViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TxtViewerComponent, deps: [{ token: i1$1.HttpClient }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
TxtViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TxtViewerComponent, selector: "adf-txt-viewer", inputs: { urlFile: "urlFile", blobFile: "blobFile" }, host: { classAttribute: "adf-txt-viewer" }, usesOnChanges: true, ngImport: i0, template: "<pre class=\"adf-txt-viewer-content\">\n    {{content}}\n</pre>\n", styles: [".adf-txt-viewer{background-color:var(--theme-background-color);overflow:auto;height:100%;width:100%}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TxtViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-txt-viewer', host: { class: 'adf-txt-viewer' }, encapsulation: ViewEncapsulation.None, template: "<pre class=\"adf-txt-viewer-content\">\n    {{content}}\n</pre>\n", styles: [".adf-txt-viewer{background-color:var(--theme-background-color);overflow:auto;height:100%;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: AppConfigService }]; }, propDecorators: { urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UnknownFormatComponent {
}
UnknownFormatComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UnknownFormatComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
UnknownFormatComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UnknownFormatComponent, selector: "adf-viewer-unknown-format", ngImport: i0, template: "<div class=\"adf-viewer__unknown-format-view\">\n    <div>\n        <mat-icon class=\"icon\">error</mat-icon>\n        <div class=\"adf-viewer__unknown-label\">{{ 'ADF_VIEWER.UNKNOWN_FORMAT' | translate }}</div>\n    </div>\n</div>\n", styles: [".adf-viewer__unknown-format-view{height:90vh;text-align:center;display:flex;flex:1;flex-direction:column;justify-content:center;color:var(--adf-theme-foreground-text-color)}\n"], dependencies: [{ kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UnknownFormatComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-viewer-unknown-format', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-viewer__unknown-format-view\">\n    <div>\n        <mat-icon class=\"icon\">error</mat-icon>\n        <div class=\"adf-viewer__unknown-label\">{{ 'ADF_VIEWER.UNKNOWN_FORMAT' | translate }}</div>\n    </div>\n</div>\n", styles: [".adf-viewer__unknown-format-view{height:90vh;text-align:center;display:flex;flex:1;flex-direction:column;justify-content:center;color:var(--adf-theme-foreground-text-color)}\n"] }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerMoreActionsComponent {
}
ViewerMoreActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerMoreActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerMoreActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerMoreActionsComponent, selector: "adf-viewer-more-actions", host: { classAttribute: "adf-viewer-more-actions" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerMoreActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-more-actions',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-more-actions' },
                    template: `<ng-content></ng-content>`
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerOpenWithComponent {
}
ViewerOpenWithComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerOpenWithComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerOpenWithComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerOpenWithComponent, selector: "adf-viewer-open-with", host: { classAttribute: "adf-viewer-open-with" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerOpenWithComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-open-with',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-open-with' },
                    template: `<ng-content></ng-content>`
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerSidebarComponent {
    onKeyDown(event) {
        event.stopPropagation();
    }
    onKeyUp(event) {
        event.stopPropagation();
    }
}
ViewerSidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerSidebarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerSidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerSidebarComponent, selector: "adf-viewer-sidebar", host: { listeners: { "keydown": "onKeyDown($event)", "keyup": "onKeyUp($event)" }, classAttribute: "adf-viewer-sidebar" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerSidebarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-sidebar',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-sidebar' },
                    template: `<ng-content></ng-content>`
                }]
        }], propDecorators: { onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onKeyUp: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerToolbarComponent {
}
ViewerToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerToolbarComponent, selector: "adf-viewer-toolbar", host: { classAttribute: "adf-viewer-toolbar" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-toolbar',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-toolbar' },
                    template: `<ng-content></ng-content>`
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerToolbarActionsComponent {
}
ViewerToolbarActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerToolbarActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerToolbarActionsComponent, selector: "adf-viewer-toolbar-actions", host: { classAttribute: "adf-viewer-toolbar-actions" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-toolbar-actions',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-toolbar-actions' },
                    template: `<ng-content></ng-content>`
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerToolbarCustomActionsComponent {
}
ViewerToolbarCustomActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarCustomActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ViewerToolbarCustomActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerToolbarCustomActionsComponent, selector: "adf-viewer-toolbar-custom-actions", host: { classAttribute: "adf-viewer-toolbar-custom-actions" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerToolbarCustomActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-viewer-toolbar-custom-actions',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { class: 'adf-viewer-toolbar-custom-actions' },
                    template: `<ng-content></ng-content>`
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerRenderComponent {
    constructor(viewUtilService, extensionService, dialog) {
        this.viewUtilService = viewUtilService;
        this.extensionService = extensionService;
        this.dialog = dialog;
        /** If you want to load an external file that does not come from ACS you
         * can use this URL to specify where to load the file from.
         */
        this.urlFile = '';
        /** Toggles the 'Full Screen' feature. */
        this.allowFullScreen = true;
        /** Toggles PDF thumbnails. */
        this.allowThumbnails = true;
        /** The template for the pdf thumbnails. */
        this.thumbnailsTemplate = null;
        /** Override loading status */
        this.isLoading = false;
        /** Enable when where is possible the editing functionalities  */
        this.readOnly = true;
        /** media subtitles for the media player*/
        this.tracks = [];
        /** Emitted when the filename extension changes. */
        this.extensionChange = new EventEmitter();
        /** Emitted when the img is submitted in the img viewer. */
        this.submitFile = new EventEmitter();
        /** Emitted when the img is submitted in the img viewer. */
        this.close = new EventEmitter();
        /** Emitted when the img is saving. */
        this.isSaving = new EventEmitter();
        this.extensionTemplates = [];
        this.viewerType = 'unknown';
        this.cacheTypeForContent = '';
        this.onDestroy$ = new Subject();
    }
    /**
     * Returns a list of the active Viewer content extensions.
     */
    get viewerExtensions() {
        return this.extensionService.getViewerExtensions();
    }
    /**
     * Provides a list of file extensions supported by external plugins.
     */
    get externalExtensions() {
        return this.viewerExtensions.map(ext => ext.fileExtension);
    }
    get externalViewer() {
        if (!this._externalViewer) {
            this._externalViewer = this.viewerExtensions.find(ext => ext.fileExtension === '*');
        }
        return this._externalViewer;
    }
    ngOnInit() {
        this.cacheTypeForContent = '';
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    ngOnChanges() {
        this.isLoading = !this.blobFile && !this.urlFile;
        if (this.blobFile) {
            this.setUpBlobData();
        }
        else if (this.urlFile) {
            this.setUpUrlFile();
        }
    }
    setUpBlobData() {
        this.internalFileName = this.fileName;
        this.viewerType = this.viewUtilService.getViewerTypeByMimeType(this.blobFile.type);
        this.extensionChange.emit(this.blobFile.type);
        this.scrollTop();
    }
    setUpUrlFile() {
        this.internalFileName = this.fileName ? this.fileName : this.viewUtilService.getFilenameFromUrl(this.urlFile);
        this.extension = this.viewUtilService.getFileExtension(this.internalFileName);
        this.viewerType = this.viewUtilService.getViewerType(this.extension, this.mimeType);
        this.extensionChange.emit(this.extension);
        this.scrollTop();
    }
    scrollTop() {
        window.scrollTo(0, 1);
    }
    checkExtensions(extensionAllowed) {
        if (typeof extensionAllowed === 'string') {
            return this.extension.toLowerCase() === extensionAllowed.toLowerCase();
        }
        else if (extensionAllowed.length > 0) {
            return extensionAllowed.find((currentExtension) => this.extension.toLowerCase() === currentExtension.toLowerCase());
        }
    }
    onSubmitFile(newImageBlob) {
        this.submitFile.next(newImageBlob);
    }
    onUnsupportedFile() {
        this.viewerType = 'unknown';
    }
    onClose() {
        this.close.next(true);
    }
}
ViewerRenderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerRenderComponent, deps: [{ token: ViewUtilService }, { token: i2$1.AppExtensionService }, { token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
ViewerRenderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerRenderComponent, selector: "adf-viewer-render", inputs: { urlFile: "urlFile", blobFile: "blobFile", allowFullScreen: "allowFullScreen", allowThumbnails: "allowThumbnails", thumbnailsTemplate: "thumbnailsTemplate", mimeType: "mimeType", fileName: "fileName", isLoading: "isLoading", readOnly: "readOnly", tracks: "tracks" }, outputs: { extensionChange: "extensionChange", submitFile: "submitFile", close: "close", isSaving: "isSaving" }, host: { classAttribute: "adf-viewer-render" }, providers: [ViewUtilService], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"isLoading\"\n     class=\"adf-viewer-render-main\">\n    <div class=\"adf-viewer-render-layout-content adf-viewer__fullscreen-container\">\n        <div class=\"adf-viewer-render-content-container\">\n            <ng-container *ngIf=\"isLoading\">\n                <div class=\"adf-viewer-render__loading-screen\">\n                    <h2>{{ 'ADF_VIEWER.LOADING' | translate }}</h2>\n                    <div>\n                        <mat-spinner></mat-spinner>\n                    </div>\n                </div>\n            </ng-container>\n\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"!isLoading\"\n     class=\"adf-viewer-render-main\">\n    <div class=\"adf-viewer-render-layout-content adf-viewer__fullscreen-container\">\n        <div class=\"adf-viewer-render-content-container\" [ngSwitch]=\"viewerType\">\n            <ng-container *ngSwitchCase=\"'external'\">\n                <adf-preview-extension\n                    *ngIf=\"!!externalViewer\"\n                    [id]=\"externalViewer.component\"\n                    [url]=\"urlFile\"\n                    [extension]=\"externalViewer.fileExtension\"\n                    [attr.data-automation-id]=\"externalViewer.component\">\n                </adf-preview-extension>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'pdf'\">\n                <adf-pdf-viewer [thumbnailsTemplate]=\"thumbnailsTemplate\"\n                                [allowThumbnails]=\"allowThumbnails\"\n                                [blobFile]=\"blobFile\"\n                                [urlFile]=\"urlFile\"\n                                [fileName]=\"internalFileName\"\n                                [cacheType]=\"cacheTypeForContent\"\n                                (close)=\"onClose()\"\n                                (error)=\"onUnsupportedFile()\">\n                </adf-pdf-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'image'\">\n                <adf-img-viewer [urlFile]=\"urlFile\"\n                                [readOnly]=\"readOnly\"\n                                [fileName]=\"internalFileName\"\n                                [blobFile]=\"blobFile\"\n                                (error)=\"onUnsupportedFile()\"\n                                (submit)=\"onSubmitFile($event)\"\n                                (isSaving)=\"isSaving.emit($event)\"\n                ></adf-img-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'media'\">\n                <adf-media-player id=\"adf-mdedia-player\"\n                                  [urlFile]=\"urlFile\"\n                                  [tracks]=\"tracks\"\n                                  [mimeType]=\"mimeType\"\n                                  [blobFile]=\"blobFile\"\n                                  [fileName]=\"internalFileName\"\n                                  (error)=\"onUnsupportedFile()\">\n                </adf-media-player>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'text'\">\n                <adf-txt-viewer [urlFile]=\"urlFile\"\n                                [blobFile]=\"blobFile\">\n                </adf-txt-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'custom'\">\n                <ng-container *ngFor=\"let ext of viewerExtensions\">\n                    <adf-preview-extension *ngIf=\"checkExtensions(ext.fileExtension)\"\n                                           [id]=\"ext.component\"\n                                           [url]=\"urlFile\"\n                                           [extension]=\"extension\"\n                                           [attr.data-automation-id]=\"ext.component\">\n                    </adf-preview-extension>\n                </ng-container>\n\n                <span class=\"adf-viewer-render-custom-content\"\n                      *ngFor=\"let extensionTemplate of extensionTemplates\">\n                                <ng-template *ngIf=\"extensionTemplate.isVisible\"\n                                             [ngTemplateOutlet]=\"extensionTemplate.template\"\n                                             [ngTemplateOutletContext]=\"{ urlFile: urlFile, extension:extension }\">\n                                </ng-template>\n                            </span>\n            </ng-container>\n\n            <ng-container *ngSwitchDefault>\n                <adf-viewer-unknown-format></adf-viewer-unknown-format>\n            </ng-container>\n        </div>\n    </div>\n</div>\n", styles: [".adf-full-screen,.adf-viewer-render-layout-content{width:100%;height:100%;background-color:var(--adf-theme-background-card-color)}.adf-viewer-render-main{width:0;order:1;flex:1 1 auto}.adf-viewer-render-content-container{display:flex;justify-content:center}.adf-viewer-render-layout-content{position:relative;overflow-y:hidden;overflow-x:hidden;z-index:1;background-color:var(--theme-background-color);display:flex;flex-flow:row wrap;flex:1}.adf-viewer-render-layout-content>div{display:flex;flex-flow:row wrap;margin:0 auto;align-items:stretch;height:93vh;width:100%}.adf-viewer-render-overlay-container .adf-viewer-render-content{position:fixed;top:0;left:0;z-index:1000}.adf-viewer-render__loading-screen{display:flex;flex:1 1 auto;align-items:center;justify-content:center;flex-direction:column;height:85vh}.adf-viewer-render__loading-screen .mat-spinner{margin:0 auto}.adf-viewer-render-custom-content{width:100vw}.adf-viewer-render-unknown-content{align-items:center;display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i5.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i2$1.PreviewExtensionComponent, selector: "adf-preview-extension", inputs: ["id", "url", "extension"] }, { kind: "component", type: ImgViewerComponent, selector: "adf-img-viewer", inputs: ["showToolbar", "readOnly", "urlFile", "blobFile", "fileName"], outputs: ["error", "submit", "isSaving"] }, { kind: "component", type: TxtViewerComponent, selector: "adf-txt-viewer", inputs: ["urlFile", "blobFile"] }, { kind: "component", type: MediaPlayerComponent, selector: "adf-media-player", inputs: ["urlFile", "blobFile", "mimeType", "fileName", "tracks"], outputs: ["error"] }, { kind: "component", type: PdfViewerComponent, selector: "adf-pdf-viewer", inputs: ["urlFile", "blobFile", "fileName", "showToolbar", "allowThumbnails", "thumbnailsTemplate", "cacheType"], outputs: ["rendered", "error", "close"] }, { kind: "component", type: UnknownFormatComponent, selector: "adf-viewer-unknown-format" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerRenderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-viewer-render', host: { class: 'adf-viewer-render' }, encapsulation: ViewEncapsulation.None, providers: [ViewUtilService], template: "<div *ngIf=\"isLoading\"\n     class=\"adf-viewer-render-main\">\n    <div class=\"adf-viewer-render-layout-content adf-viewer__fullscreen-container\">\n        <div class=\"adf-viewer-render-content-container\">\n            <ng-container *ngIf=\"isLoading\">\n                <div class=\"adf-viewer-render__loading-screen\">\n                    <h2>{{ 'ADF_VIEWER.LOADING' | translate }}</h2>\n                    <div>\n                        <mat-spinner></mat-spinner>\n                    </div>\n                </div>\n            </ng-container>\n\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"!isLoading\"\n     class=\"adf-viewer-render-main\">\n    <div class=\"adf-viewer-render-layout-content adf-viewer__fullscreen-container\">\n        <div class=\"adf-viewer-render-content-container\" [ngSwitch]=\"viewerType\">\n            <ng-container *ngSwitchCase=\"'external'\">\n                <adf-preview-extension\n                    *ngIf=\"!!externalViewer\"\n                    [id]=\"externalViewer.component\"\n                    [url]=\"urlFile\"\n                    [extension]=\"externalViewer.fileExtension\"\n                    [attr.data-automation-id]=\"externalViewer.component\">\n                </adf-preview-extension>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'pdf'\">\n                <adf-pdf-viewer [thumbnailsTemplate]=\"thumbnailsTemplate\"\n                                [allowThumbnails]=\"allowThumbnails\"\n                                [blobFile]=\"blobFile\"\n                                [urlFile]=\"urlFile\"\n                                [fileName]=\"internalFileName\"\n                                [cacheType]=\"cacheTypeForContent\"\n                                (close)=\"onClose()\"\n                                (error)=\"onUnsupportedFile()\">\n                </adf-pdf-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'image'\">\n                <adf-img-viewer [urlFile]=\"urlFile\"\n                                [readOnly]=\"readOnly\"\n                                [fileName]=\"internalFileName\"\n                                [blobFile]=\"blobFile\"\n                                (error)=\"onUnsupportedFile()\"\n                                (submit)=\"onSubmitFile($event)\"\n                                (isSaving)=\"isSaving.emit($event)\"\n                ></adf-img-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'media'\">\n                <adf-media-player id=\"adf-mdedia-player\"\n                                  [urlFile]=\"urlFile\"\n                                  [tracks]=\"tracks\"\n                                  [mimeType]=\"mimeType\"\n                                  [blobFile]=\"blobFile\"\n                                  [fileName]=\"internalFileName\"\n                                  (error)=\"onUnsupportedFile()\">\n                </adf-media-player>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'text'\">\n                <adf-txt-viewer [urlFile]=\"urlFile\"\n                                [blobFile]=\"blobFile\">\n                </adf-txt-viewer>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'custom'\">\n                <ng-container *ngFor=\"let ext of viewerExtensions\">\n                    <adf-preview-extension *ngIf=\"checkExtensions(ext.fileExtension)\"\n                                           [id]=\"ext.component\"\n                                           [url]=\"urlFile\"\n                                           [extension]=\"extension\"\n                                           [attr.data-automation-id]=\"ext.component\">\n                    </adf-preview-extension>\n                </ng-container>\n\n                <span class=\"adf-viewer-render-custom-content\"\n                      *ngFor=\"let extensionTemplate of extensionTemplates\">\n                                <ng-template *ngIf=\"extensionTemplate.isVisible\"\n                                             [ngTemplateOutlet]=\"extensionTemplate.template\"\n                                             [ngTemplateOutletContext]=\"{ urlFile: urlFile, extension:extension }\">\n                                </ng-template>\n                            </span>\n            </ng-container>\n\n            <ng-container *ngSwitchDefault>\n                <adf-viewer-unknown-format></adf-viewer-unknown-format>\n            </ng-container>\n        </div>\n    </div>\n</div>\n", styles: [".adf-full-screen,.adf-viewer-render-layout-content{width:100%;height:100%;background-color:var(--adf-theme-background-card-color)}.adf-viewer-render-main{width:0;order:1;flex:1 1 auto}.adf-viewer-render-content-container{display:flex;justify-content:center}.adf-viewer-render-layout-content{position:relative;overflow-y:hidden;overflow-x:hidden;z-index:1;background-color:var(--theme-background-color);display:flex;flex-flow:row wrap;flex:1}.adf-viewer-render-layout-content>div{display:flex;flex-flow:row wrap;margin:0 auto;align-items:stretch;height:93vh;width:100%}.adf-viewer-render-overlay-container .adf-viewer-render-content{position:fixed;top:0;left:0;z-index:1000}.adf-viewer-render__loading-screen{display:flex;flex:1 1 auto;align-items:center;justify-content:center;flex-direction:column;height:85vh}.adf-viewer-render__loading-screen .mat-spinner{margin:0 auto}.adf-viewer-render-custom-content{width:100vw}.adf-viewer-render-unknown-content{align-items:center;display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: ViewUtilService }, { type: i2$1.AppExtensionService }, { type: i1$4.MatDialog }]; }, propDecorators: { urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }], allowFullScreen: [{
                type: Input
            }], allowThumbnails: [{
                type: Input
            }], thumbnailsTemplate: [{
                type: Input
            }], mimeType: [{
                type: Input
            }], fileName: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], tracks: [{
                type: Input
            }], extensionChange: [{
                type: Output
            }], submitFile: [{
                type: Output
            }], close: [{
                type: Output
            }], isSaving: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* Enum listing the allowed actions that can be emitted from the NonResponsivePreview dialog component */
var DownloadPromptActions;
(function (DownloadPromptActions) {
    DownloadPromptActions[DownloadPromptActions["WAIT"] = 0] = "WAIT";
    DownloadPromptActions[DownloadPromptActions["DOWNLOAD"] = 1] = "DOWNLOAD";
})(DownloadPromptActions || (DownloadPromptActions = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DownloadPromptDialogComponent {
    constructor() {
        this.DownloadPromptActions = DownloadPromptActions;
    }
}
DownloadPromptDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadPromptDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DownloadPromptDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DownloadPromptDialogComponent, selector: "adf-download-prompt-dialog", ngImport: i0, template: "<div mat-dialog-title>\n    <h3>{{ 'ADF_VIEWER.NON_RESPONSIVE_DIALOG.HEADER' | translate }}</h3>\n</div>\n<mat-dialog-content>\n    {{ 'ADF_VIEWER.NON_RESPONSIVE_DIALOG.LABEL' | translate }}\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button\n        id=\"downloadButton\"\n        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate\"\n        [mat-dialog-close]=\"DownloadPromptActions.DOWNLOAD\">\n        {{ 'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate }}\n    </button>\n    <button\n        mat-button\n        id=\"waitButton\"\n        color=\"primary\"\n        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.WAIT' | translate\"\n        [mat-dialog-close]=\"DownloadPromptActions.WAIT\">\n        {{ 'ADF_VIEWER.ACTIONS.WAIT' | translate }}\n    </button>\n</mat-dialog-actions>\n", dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$4.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$4.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadPromptDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-download-prompt-dialog', template: "<div mat-dialog-title>\n    <h3>{{ 'ADF_VIEWER.NON_RESPONSIVE_DIALOG.HEADER' | translate }}</h3>\n</div>\n<mat-dialog-content>\n    {{ 'ADF_VIEWER.NON_RESPONSIVE_DIALOG.LABEL' | translate }}\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button\n        id=\"downloadButton\"\n        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate\"\n        [mat-dialog-close]=\"DownloadPromptActions.DOWNLOAD\">\n        {{ 'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate }}\n    </button>\n    <button\n        mat-button\n        id=\"waitButton\"\n        color=\"primary\"\n        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.WAIT' | translate\"\n        [mat-dialog-close]=\"DownloadPromptActions.WAIT\">\n        {{ 'ADF_VIEWER.ACTIONS.WAIT' | translate }}\n    </button>\n</mat-dialog-actions>\n" }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class StorageService {
    constructor() {
        this.memoryStore = {};
        this.useLocalStorage = false;
        this._prefix = '';
        this.useLocalStorage = this.storageAvailable('localStorage');
    }
    get prefix() {
        return this._prefix;
    }
    set prefix(prefix) {
        this._prefix = prefix ? prefix + '_' : '';
    }
    /**
     * Gets an item.
     *
     * @param key Key to identify the item
     * @returns The item (if any) retrieved by the key
     */
    getItem(key) {
        if (this.useLocalStorage) {
            return localStorage.getItem(this.prefix + key);
        }
        else {
            return this.memoryStore.hasOwnProperty(this.prefix + key) ? this.memoryStore[this.prefix + key] : null;
        }
    }
    /**
     * Stores an item
     *
     * @param key Key to identify the item
     * @param data Data to store
     */
    setItem(key, data) {
        if (this.useLocalStorage) {
            localStorage.setItem(this.prefix + key, data);
        }
        else {
            this.memoryStore[this.prefix + key] = data.toString();
        }
    }
    /** Removes all currently stored items. */
    clear() {
        if (this.useLocalStorage) {
            localStorage.clear();
        }
        else {
            this.memoryStore = {};
        }
    }
    /**
     * Removes a single item.
     *
     * @param key Key to identify the item
     */
    removeItem(key) {
        if (this.useLocalStorage) {
            localStorage.removeItem(this.prefix + key);
        }
        else {
            delete this.memoryStore[this.prefix + key];
        }
    }
    /**
     * Is any item currently stored under `key`?
     *
     * @param key Key identifying item to check
     * @returns True if key retrieves an item, false otherwise
     */
    hasItem(key) {
        if (this.useLocalStorage) {
            return localStorage.getItem(this.prefix + key) ? true : false;
        }
        else {
            return this.memoryStore.hasOwnProperty(key);
        }
    }
    storageAvailable(type) {
        try {
            const storage = window[type];
            const key = '__storage_test__';
            storage.setItem(key, key);
            storage.removeItem(key, key);
            return true;
        }
        catch (e) {
            return false;
        }
    }
}
StorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: StorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: StorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DebugAppConfigService extends AppConfigService {
    constructor(storage, http, extensionService) {
        super(http, extensionService);
        this.storage = storage;
    }
    /** @override */
    get(key, defaultValue) {
        if (key === AppConfigValues.OAUTHCONFIG) {
            return (JSON.parse(this.storage.getItem(key)) || super.get(key, defaultValue));
        }
        else if (key === AppConfigValues.APPLICATION) {
            return undefined;
        }
        else {
            return (this.storage.getItem(key) || super.get(key, defaultValue));
        }
    }
}
DebugAppConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DebugAppConfigService, deps: [{ token: StorageService }, { token: i1$1.HttpClient }, { token: i2$1.ExtensionService }], target: i0.ɵɵFactoryTarget.Injectable });
DebugAppConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DebugAppConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DebugAppConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StorageService }, { type: i1$1.HttpClient }, { type: i2$1.ExtensionService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AppConfigPipe {
    constructor(config) {
        this.config = config;
    }
    transform(value, fallback) {
        return this.config.get(value, fallback);
    }
}
AppConfigPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigPipe, deps: [{ token: AppConfigService }], target: i0.ɵɵFactoryTarget.Pipe });
AppConfigPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AppConfigPipe, name: "adfAppConfig" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfAppConfig'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AppConfigModule {
}
AppConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AppConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AppConfigModule, declarations: [AppConfigPipe], imports: [HttpClientModule], exports: [AppConfigPipe] });
AppConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigModule, imports: [HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        HttpClientModule
                    ],
                    declarations: [
                        AppConfigPipe
                    ],
                    exports: [
                        AppConfigPipe
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ToolbarTitleComponent {
}
ToolbarTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ToolbarTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ToolbarTitleComponent, selector: "adf-toolbar-title", host: { classAttribute: "adf-toolbar-title" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarTitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-toolbar-title',
                    template: '<ng-content></ng-content>',
                    host: { class: 'adf-toolbar-title' }
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ICON = './assets/images/ft_ic_miscellaneous.svg';
class ThumbnailService {
    constructor(matIconRegistry, sanitizer) {
        this.mimeTypeIcons = {
            'image/png': './assets/images/ft_ic_raster_image.svg',
            'image/jpeg': './assets/images/ft_ic_raster_image.svg',
            'image/gif': './assets/images/ft_ic_raster_image.svg',
            'image/bmp': './assets/images/ft_ic_raster_image.svg',
            'image/cgm': './assets/images/ft_ic_raster_image.svg',
            'image/ief': './assets/images/ft_ic_raster_image.svg',
            'image/jp2': './assets/images/ft_ic_raster_image.svg',
            'image/tiff': './assets/images/ft_ic_raster_image.svg',
            'image/vnd.adobe.photoshop': './assets/images/ft_ic_raster_image.svg',
            'image/vnd.adobe.premiere': './assets/images/ft_ic_raster_image.svg',
            'image/x-cmu-raster': './assets/images/ft_ic_raster_image.svg',
            'image/x-dwt': './assets/images/ft_ic_raster_image.svg',
            'image/x-portable-anymap': './assets/images/ft_ic_raster_image.svg',
            'image/x-portable-bitmap': './assets/images/ft_ic_raster_image.svg',
            'image/x-portable-graymap': './assets/images/ft_ic_raster_image.svg',
            'image/x-portable-pixmap': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-adobe': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-canon': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-fuji': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-hasselblad': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-kodak': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-leica': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-minolta': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-nikon': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-olympus': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-panasonic': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-pentax': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-red': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-sigma': './assets/images/ft_ic_raster_image.svg',
            'image/x-raw-sony': './assets/images/ft_ic_raster_image.svg',
            'image/x-xbitmap': './assets/images/ft_ic_raster_image.svg',
            'image/x-xpixmap': './assets/images/ft_ic_raster_image.svg',
            'image/x-xwindowdump': './assets/images/ft_ic_raster_image.svg',
            'image/svg+xml': './assets/images/ft_ic_vector_image.svg',
            'application/eps': './assets/images/ft_ic_raster_image.svg',
            'application/illustrator': './assets/images/ft_ic_raster_image.svg',
            'application/pdf': './assets/images/ft_ic_pdf.svg',
            'application/vnd.ms-excel': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-excel.addin.macroenabled.12': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-excel.sheet.binary.macroenabled.12': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-excel.sheet.macroenabled.12': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-excel.template.macroenabled.12': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.sun.xml.calc': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.sun.xml.calc.template': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-outlook': './assets/images/ft_ic_document.svg',
            'application/msword': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.ms-word.document.macroenabled.12': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.ms-word.template.macroenabled.12': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.sun.xml.writer': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.sun.xml.writer.template': './assets/images/ft_ic_ms_word.svg',
            'application/rtf': './assets/images/ft_ic_ms_word.svg',
            'text/rtf': './assets/images/ft_ic_ms_word.svg',
            'application/vnd.ms-powerpoint': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.openxmlformats-officedocument.presentationml.template': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.oasis.opendocument.presentation': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.oasis.opendocument.presentation-template': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.openxmlformats-officedocument.presentationml.slide': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.sun.xml.impress': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.sun.xml.impress.template': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.oasis.opendocument.spreadsheet': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.oasis.opendocument.spreadsheet-template': './assets/images/ft_ic_ms_excel.svg',
            'application/vnd.ms-powerpoint.addin.macroenabled.12': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.ms-powerpoint.slide.macroenabled.12': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12': './assets/images/ft_ic_ms_powerpoint.svg',
            'application/vnd.ms-powerpoint.template.macroenabled.12': './assets/images/ft_ic_ms_powerpoint.svg',
            'video/mp4': './assets/images/ft_ic_video.svg',
            'video/3gpp': './assets/images/ft_ic_video.svg',
            'video/3gpp2': './assets/images/ft_ic_video.svg',
            'video/mp2t': './assets/images/ft_ic_video.svg',
            'video/mpeg': './assets/images/ft_ic_video.svg',
            'video/mpeg2': './assets/images/ft_ic_video.svg',
            'video/ogg': './assets/images/ft_ic_video.svg',
            'video/quicktime': './assets/images/ft_ic_video.svg',
            'video/webm': './assets/images/ft_ic_video.svg',
            'video/x-flv': './assets/images/ft_ic_video.svg',
            'video/x-m4v': './assets/images/ft_ic_video.svg',
            'video/x-ms-asf': './assets/images/ft_ic_video.svg',
            'video/x-ms-wmv': './assets/images/ft_ic_video.svg',
            'video/x-msvideo': './assets/images/ft_ic_video.svg',
            'video/x-rad-screenplay': './assets/images/ft_ic_video.svg',
            'video/x-sgi-movie': './assets/images/ft_ic_video.svg',
            'video/x-matroska': './assets/images/ft_ic_video.svg',
            'audio/mpeg': './assets/images/ft_ic_audio.svg',
            'audio/ogg': './assets/images/ft_ic_audio.svg',
            'audio/wav': './assets/images/ft_ic_audio.svg',
            'audio/basic': './assets/images/ft_ic_audio.svg',
            'audio/mp3': './assets/images/ft_ic_audio.svg',
            'audio/mp4': './assets/images/ft_ic_audio.svg',
            'audio/vnd.adobe.soundbooth': './assets/images/ft_ic_audio.svg',
            'audio/vorbis': './assets/images/ft_ic_audio.svg',
            'audio/x-aiff': './assets/images/ft_ic_audio.svg',
            'audio/x-flac': './assets/images/ft_ic_audio.svg',
            'audio/x-ms-wma': './assets/images/ft_ic_audio.svg',
            'audio/x-wav': './assets/images/ft_ic_audio.svg',
            'x-world/x-vrml': './assets/images/ft_ic_video.svg',
            'text/plain': './assets/images/ft_ic_document.svg',
            'application/vnd.oasis.opendocument.text': './assets/images/ft_ic_document.svg',
            'application/vnd.oasis.opendocument.text-template': './assets/images/ft_ic_document.svg',
            'application/x-javascript': './assets/images/ft_ic_document.svg',
            'application/json': './assets/images/ft_ic_document.svg',
            'text/csv': './assets/images/ft_ic_document.svg',
            'text/xml': './assets/images/ft_ic_document.svg',
            'text/html': './assets/images/ft_ic_website.svg',
            'application/x-compressed': './assets/images/ft_ic_archive.svg',
            'application/x-zip-compressed': './assets/images/ft_ic_archive.svg',
            'application/zip': './assets/images/ft_ic_archive.svg',
            'application/x-tar': './assets/images/ft_ic_archive.svg',
            'application/vnd.apple.keynote': './assets/images/ft_ic_presentation.svg',
            'application/vnd.apple.pages': './assets/images/ft_ic_document.svg',
            'application/vnd.apple.numbers': './assets/images/ft_ic_spreadsheet.svg',
            'application/vnd.visio': './assets/images/ft_ic_document.svg',
            'application/wordperfect': './assets/images/ft_ic_document.svg',
            'application/x-cpio': './assets/images/ft_ic_document.svg',
            folder: './assets/images/ft_ic_folder.svg',
            smartFolder: './assets/images/ft_ic_smart_folder.svg',
            ruleFolder: './assets/images/ft_ic_folder_rule.svg',
            linkFolder: './assets/images/ft_ic_folder_shortcut_link.svg',
            'disable/folder': './assets/images/ft_ic_folder_disable.svg',
            selected: './assets/images/ft_ic_selected.svg',
            'dynamic-feed': './assets/images/dynamic_feed-24px.svg',
            'ic-process': './assets/images/ic-process.svg',
            'save-as': './assets/images/save-as.svg',
            save: './assets/images/save.svg',
            task: './assets/images/task.svg',
            'multipart/related': './assets/images/ft_ic_website.svg'
        };
        Object.keys(this.mimeTypeIcons).forEach((key) => {
            const url = sanitizer.bypassSecurityTrustResourceUrl(this.mimeTypeIcons[key]);
            matIconRegistry.addSvgIcon(key, url);
            matIconRegistry.addSvgIconInNamespace('adf', key, url);
        });
    }
    /**
     * Gets a thumbnail URL for a MIME type.
     *
     * @param mimeType MIME type for the thumbnail
     * @returns URL string
     */
    getMimeTypeIcon(mimeType) {
        const icon = this.mimeTypeIcons[mimeType];
        return (icon || DEFAULT_ICON);
    }
    /**
     * Gets a "miscellaneous" thumbnail URL for types with no other icon defined.
     *
     * @returns URL string
     */
    getDefaultMimeTypeIcon() {
        return DEFAULT_ICON;
    }
}
ThumbnailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ThumbnailService, deps: [{ token: i1$3.MatIconRegistry }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
ThumbnailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ThumbnailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ThumbnailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.MatIconRegistry }, { type: i1$2.DomSanitizer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MimeTypeIconPipe {
    constructor(thumbnailService) {
        this.thumbnailService = thumbnailService;
    }
    transform(text) {
        return this.thumbnailService.getMimeTypeIcon(text);
    }
}
MimeTypeIconPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MimeTypeIconPipe, deps: [{ token: ThumbnailService }], target: i0.ɵɵFactoryTarget.Pipe });
MimeTypeIconPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MimeTypeIconPipe, name: "adfMimeTypeIcon" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MimeTypeIconPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfMimeTypeIcon'
                }]
        }], ctorParameters: function () { return [{ type: ThumbnailService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_NON_PREVIEW_CONFIG = {
    enableDownloadPrompt: false,
    enableDownloadPromptReminder: false,
    downloadPromptDelay: 50,
    downloadPromptReminderDelay: 30
};
class ViewerComponent {
    constructor(el, dialog, viewUtilsService, appConfigService) {
        this.el = el;
        this.dialog = dialog;
        this.viewUtilsService = viewUtilsService;
        this.appConfigService = appConfigService;
        /** If you want to load an external file that does not come from ACS you
         * can use this URL to specify where to load the file from.
         */
        this.urlFile = '';
        /** Hide or show the viewer */
        this.showViewer = true;
        /** Allows `back` navigation */
        this.allowGoBack = true;
        /** Toggles the 'Full Screen' feature. */
        this.allowFullScreen = true;
        /** Hide or show the toolbar */
        this.showToolbar = true;
        /** If `true` then show the Viewer as a full page over the current content.
         * Otherwise fit inside the parent div.
         */
        this.overlayMode = false;
        /** Toggles before/next navigation. You can use the arrow buttons to navigate
         * between documents in the collection.
         */
        this.allowNavigate = false;
        /** Toggles the "before" ("<") button. Requires `allowNavigate` to be enabled. */
        this.canNavigateBefore = true;
        /** Toggles the next (">") button. Requires `allowNavigate` to be enabled. */
        this.canNavigateNext = true;
        /** Allow the left the sidebar. */
        this.allowLeftSidebar = false;
        /** Allow the right sidebar. */
        this.allowRightSidebar = false;
        /** Toggles right sidebar visibility. Requires `allowRightSidebar` to be set to `true`. */
        this.showRightSidebar = false;
        /** Toggles left sidebar visibility. Requires `allowLeftSidebar` to be set to `true`. */
        this.showLeftSidebar = false;
        /** The template for the right sidebar. The template context contains the loaded node data. */
        this.sidebarRightTemplate = null;
        /** The template for the left sidebar. The template context contains the loaded node data. */
        this.sidebarLeftTemplate = null;
        /** Enable when where is possible the editing functionalities  */
        this.readOnly = true;
        /** media subtitles for the media player*/
        this.tracks = [];
        /**
         * Context object available for binding by the local sidebarRightTemplate with let declarations.
         */
        this.sidebarRightTemplateContext = null;
        /**
         * Context object available for binding by the local sidebarLeftTemplate with let declarations.
         */
        this.sidebarLeftTemplateContext = null;
        /**
         * Enable dialog box to allow user to download the previewed file, in case the preview is not responding for a set period of time.
         * */
        this.enableDownloadPrompt = false;
        /**
         * Enable reminder dialogs to prompt user to download the file, in case the preview is not responding for a set period of time.
         * */
        this.enableDownloadPromptReminder = false;
        /**
         * Initial time in seconds to wait before giving the first prompt to user to download the file
         * */
        this.downloadPromptDelay = 50;
        /**
         * Time in seconds to wait before giving the second and consequent reminders to the user to download the file.
         * */
        this.downloadPromptReminderDelay = 15;
        /**
         * Emitted when user clicks on download button on download prompt dialog.
         * */
        this.downloadFile = new EventEmitter();
        /** Emitted when user clicks 'Navigate Before' ("<") button. */
        this.navigateBefore = new EventEmitter();
        /** Emitted when user clicks 'Navigate Next' (">") button. */
        this.navigateNext = new EventEmitter();
        /** Emitted when the viewer close */
        this.showViewerChange = new EventEmitter();
        /** Emitted when the img is submitted in the img viewer. */
        this.submitFile = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.closeViewer = true;
        this.keyDown$ = fromEvent(document, 'keydown');
        this.isDialogVisible = false;
    }
    ngOnChanges(changes) {
        const { blobFile, urlFile } = changes;
        if (blobFile?.currentValue) {
            this.mimeType = blobFile.currentValue.type;
        }
        if (urlFile?.currentValue) {
            this.fileName = this.fileName ? this.fileName : this.viewUtilsService.getFilenameFromUrl(urlFile.currentValue);
        }
    }
    ngOnInit() {
        this.closeOverlayManager();
        this.configureAndInitDownloadPrompt();
    }
    closeOverlayManager() {
        this.dialog.afterOpened.pipe(skipWhile(() => !this.overlayMode), takeUntil(this.onDestroy$)).subscribe(() => this.closeViewer = false);
        this.dialog.afterAllClosed.pipe(skipWhile(() => !this.overlayMode), takeUntil(this.onDestroy$)).subscribe(() => this.closeViewer = true);
        this.keyDown$.pipe(skipWhile(() => !this.overlayMode), filter((e) => e.keyCode === 27), takeUntil(this.onDestroy$)).subscribe((event) => {
            event.preventDefault();
            if (this.closeViewer) {
                this.onClose();
            }
        });
    }
    onNavigateBeforeClick(event) {
        this.navigateBefore.next(event);
    }
    onNavigateNextClick(event) {
        this.navigateNext.next(event);
    }
    /**
     * close the viewer
     */
    onClose() {
        this.showViewer = false;
        this.showViewerChange.emit(this.showViewer);
    }
    toggleRightSidebar() {
        this.showRightSidebar = !this.showRightSidebar;
    }
    toggleLeftSidebar() {
        this.showLeftSidebar = !this.showLeftSidebar;
    }
    handleKeyboardEvent(event) {
        if (event && event.defaultPrevented) {
            return;
        }
        const key = event.keyCode;
        // Left arrow
        if (key === 37 && this.canNavigateBefore) {
            event.preventDefault();
            this.onNavigateBeforeClick(event);
        }
        // Right arrow
        if (key === 39 && this.canNavigateNext) {
            event.preventDefault();
            this.onNavigateNextClick(event);
        }
        // Ctrl+F
        if (key === 70 && event.ctrlKey) {
            event.preventDefault();
            this.enterFullScreen();
        }
    }
    /**
     * Triggers full screen mode with a main content area displayed.
     */
    enterFullScreen() {
        if (this.allowFullScreen) {
            const container = this.el.nativeElement.querySelector('.adf-viewer__fullscreen-container');
            if (container) {
                if (container.requestFullscreen) {
                    container.requestFullscreen();
                }
                else if (container.webkitRequestFullscreen) {
                    container.webkitRequestFullscreen();
                }
                else if (container.mozRequestFullScreen) {
                    container.mozRequestFullScreen();
                }
                else if (container.msRequestFullscreen) {
                    container.msRequestFullscreen();
                }
            }
        }
    }
    onSubmitFile(newImageBlob) {
        this.submitFile.emit(newImageBlob);
    }
    ngOnDestroy() {
        this.clearDownloadPromptTimeouts();
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    configureAndInitDownloadPrompt() {
        this.configureDownloadPromptProperties();
        if (this.enableDownloadPrompt) {
            this.initDownloadPrompt();
        }
    }
    configureDownloadPromptProperties() {
        const nonResponsivePreviewConfig = this.appConfigService.get('viewer', DEFAULT_NON_PREVIEW_CONFIG);
        this.enableDownloadPrompt = nonResponsivePreviewConfig.enableDownloadPrompt;
        this.enableDownloadPromptReminder = nonResponsivePreviewConfig.enableDownloadPromptReminder;
        this.downloadPromptDelay = nonResponsivePreviewConfig.downloadPromptDelay;
        this.downloadPromptReminderDelay = nonResponsivePreviewConfig.downloadPromptReminderDelay;
    }
    initDownloadPrompt() {
        this.downloadPromptTimer = window.setTimeout(() => {
            this.showOrClearDownloadPrompt();
        }, this.downloadPromptDelay * 1000);
    }
    showOrClearDownloadPrompt() {
        if (!this.urlFile) {
            this.showDownloadPrompt();
        }
        else {
            this.clearDownloadPromptTimeouts();
        }
    }
    clearDownloadPromptTimeouts() {
        if (this.downloadPromptTimer) {
            clearTimeout(this.downloadPromptTimer);
        }
        if (this.downloadPromptReminderTimer) {
            clearTimeout(this.downloadPromptReminderTimer);
        }
    }
    showDownloadPrompt() {
        if (!this.isDialogVisible) {
            this.isDialogVisible = true;
            this.dialog.open(DownloadPromptDialogComponent, { disableClose: true }).afterClosed().pipe(first()).subscribe((result) => {
                this.isDialogVisible = false;
                if (result === DownloadPromptActions.DOWNLOAD) {
                    this.downloadFile.emit();
                    this.onClose();
                }
                else if (result === DownloadPromptActions.WAIT) {
                    if (this.enableDownloadPromptReminder) {
                        this.clearDownloadPromptTimeouts();
                        this.downloadPromptReminderTimer = window.setTimeout(() => {
                            this.showOrClearDownloadPrompt();
                        }, this.downloadPromptReminderDelay * 1000);
                    }
                }
            });
        }
    }
}
ViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerComponent, deps: [{ token: i0.ElementRef }, { token: i1$4.MatDialog }, { token: ViewUtilService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
ViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ViewerComponent, selector: "adf-viewer", inputs: { urlFile: "urlFile", blobFile: "blobFile", fileName: "fileName", showViewer: "showViewer", allowGoBack: "allowGoBack", allowFullScreen: "allowFullScreen", showToolbar: "showToolbar", overlayMode: "overlayMode", allowNavigate: "allowNavigate", canNavigateBefore: "canNavigateBefore", canNavigateNext: "canNavigateNext", allowLeftSidebar: "allowLeftSidebar", allowRightSidebar: "allowRightSidebar", showRightSidebar: "showRightSidebar", showLeftSidebar: "showLeftSidebar", sidebarRightTemplate: "sidebarRightTemplate", sidebarLeftTemplate: "sidebarLeftTemplate", readOnly: "readOnly", tracks: "tracks", mimeType: "mimeType", sidebarRightTemplateContext: "sidebarRightTemplateContext", sidebarLeftTemplateContext: "sidebarLeftTemplateContext" }, outputs: { downloadFile: "downloadFile", navigateBefore: "navigateBefore", navigateNext: "navigateNext", showViewerChange: "showViewerChange", submitFile: "submitFile" }, host: { listeners: { "document:keyup": "handleKeyboardEvent($event)" }, classAttribute: "adf-viewer" }, providers: [ViewUtilService], queries: [{ propertyName: "toolbar", first: true, predicate: ViewerToolbarComponent, descendants: true }, { propertyName: "sidebar", first: true, predicate: ViewerSidebarComponent, descendants: true }, { propertyName: "mnuOpenWith", first: true, predicate: ViewerOpenWithComponent, descendants: true }, { propertyName: "mnuMoreActions", first: true, predicate: ViewerMoreActionsComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"showViewer\"\n     class=\"adf-viewer-container\"\n     [class.adf-viewer-overlay-container]=\"overlayMode\"\n     [class.adf-viewer-inline-container]=\"!overlayMode\">\n\n    <div class=\"adf-viewer-content\"\n         [cdkTrapFocus]=\"overlayMode\"\n         cdkTrapFocusAutoCapture>\n        <ng-content select=\"adf-viewer-toolbar\"></ng-content>\n        <ng-container *ngIf=\"showToolbar && !toolbar\">\n            <adf-toolbar id=\"adf-viewer-toolbar\" class=\"adf-viewer-toolbar\">\n                <adf-toolbar-title>\n\n                    <ng-container *ngIf=\"allowLeftSidebar\">\n                        <button mat-icon-button\n                                [attr.aria-expanded]=\"showLeftSidebar\"\n                                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.INFO' | translate\"\n                                title=\"{{ 'ADF_VIEWER.ACTIONS.INFO' | translate }}\"\n                                data-automation-id=\"adf-toolbar-left-sidebar\"\n                                [color]=\"showLeftSidebar ? 'accent' : null\"\n                                (click)=\"toggleLeftSidebar()\">\n                            <mat-icon>info_outline</mat-icon>\n                        </button>\n                    </ng-container>\n\n                    <button *ngIf=\"allowGoBack\"\n                            class=\"adf-viewer-close-button\"\n                            data-automation-id=\"adf-toolbar-back\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.CLOSE' | translate\"\n                            mat-icon-button\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.CLOSE' | translate }}\"\n                            (click)=\"onClose()\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </adf-toolbar-title>\n\n                <div class=\"adf-viewer__file-title\">\n                    <button *ngIf=\"allowNavigate && canNavigateBefore\"\n                            data-automation-id=\"adf-toolbar-pref-file\"\n                            mat-icon-button\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.PREV_FILE' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.PREV_FILE' | translate }}\"\n                            (click)=\"onNavigateBeforeClick($event)\">\n                        <mat-icon>navigate_before</mat-icon>\n                    </button>\n                    <img class=\"adf-viewer__mimeicon\"\n                         [alt]=\"mimeType\"\n                         [src]=\"mimeType | adfMimeTypeIcon\"\n                         data-automation-id=\"adf-file-thumbnail\">\n                    <span class=\"adf-viewer__display-name\"\n                          id=\"adf-viewer-display-name\">{{ fileName }}</span>\n                    <button *ngIf=\"allowNavigate && canNavigateNext\"\n                            data-automation-id=\"adf-toolbar-next-file\"\n                            mat-icon-button\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.NEXT_FILE' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.NEXT_FILE' | translate }}\"\n                            (click)=\"onNavigateNextClick($event)\">\n                        <mat-icon>navigate_next</mat-icon>\n                    </button>\n                </div>\n\n                <ng-content select=\"adf-viewer-toolbar-actions\"></ng-content>\n\n                <ng-container *ngIf=\"mnuOpenWith\"\n                              data-automation-id='adf-toolbar-custom-btn'>\n                    <button id=\"adf-viewer-openwith\"\n                            mat-button\n                            [matMenuTriggerFor]=\"mnuOpenWith\"\n                            data-automation-id=\"adf-toolbar-open-with\">\n                        <span>{{ 'ADF_VIEWER.ACTIONS.OPEN_WITH' | translate }}</span>\n                        <mat-icon>arrow_drop_down</mat-icon>\n                    </button>\n                    <mat-menu #mnuOpenWith=\"matMenu\"\n                              [overlapTrigger]=\"false\">\n                        <ng-content select=\"adf-viewer-open-with\"></ng-content>\n                    </mat-menu>\n                </ng-container>\n\n                <adf-toolbar-divider></adf-toolbar-divider>\n\n                <ng-content select=\"adf-viewer-toolbar-custom-actions\"></ng-content>\n\n                <button id=\"adf-viewer-fullscreen\"\n                        *ngIf=\"allowFullScreen\"\n                        mat-icon-button\n                        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.FULLSCREEN' | translate\"\n                        title=\"{{ 'ADF_VIEWER.ACTIONS.FULLSCREEN' | translate }}\"\n                        data-automation-id=\"adf-toolbar-fullscreen\"\n                        (click)=\"enterFullScreen()\">\n                    <mat-icon>fullscreen</mat-icon>\n                </button>\n\n                <ng-container *ngIf=\"allowRightSidebar\">\n                    <adf-toolbar-divider></adf-toolbar-divider>\n\n                    <button mat-icon-button\n                            [attr.aria-expanded]=\"showRightSidebar\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.INFO' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.INFO' | translate }}\"\n                            data-automation-id=\"adf-toolbar-sidebar\"\n                            [color]=\"showRightSidebar ? 'accent' : null\"\n                            (click)=\"toggleRightSidebar()\">\n                        <mat-icon>info_outline</mat-icon>\n                    </button>\n\n                </ng-container>\n\n                <ng-container *ngIf=\"mnuMoreActions\">\n                    <button id=\"adf-viewer-moreactions\"\n                            mat-icon-button\n                            [matMenuTriggerFor]=\"mnuMoreActions\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.MORE_ACTIONS' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.MORE_ACTIONS' | translate }}\"\n                            data-automation-id=\"adf-toolbar-more-actions\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #mnuMoreActions=\"matMenu\"\n                              [overlapTrigger]=\"false\">\n                        <ng-content select=\"adf-viewer-more-actions\"></ng-content>\n                    </mat-menu>\n                </ng-container>\n\n            </adf-toolbar>\n        </ng-container>\n\n        <div class=\"adf-viewer-sidebars\">\n\n            <ng-container *ngIf=\"allowRightSidebar && showRightSidebar\">\n                <div class=\"adf-viewer__sidebar adf-viewer__sidebar__right\"\n                     id=\"adf-right-sidebar\">\n                    <ng-container *ngIf=\"sidebarRightTemplate\">\n                        <ng-container *ngTemplateOutlet=\"sidebarRightTemplate;context:sidebarRightTemplateContext\">\n                        </ng-container>\n                    </ng-container>\n                    <ng-content *ngIf=\"!sidebarRightTemplate\"\n                                select=\"adf-viewer-sidebar\"></ng-content>\n                </div>\n            </ng-container>\n\n            <ng-container *ngIf=\"allowLeftSidebar && showLeftSidebar\">\n                <div class=\"adf-viewer__sidebar adf-viewer__sidebar__left\"\n                     id=\"adf-left-sidebar\">\n                    <ng-container *ngIf=\"sidebarLeftTemplate\">\n                        <ng-container *ngTemplateOutlet=\"sidebarLeftTemplate;context:sidebarLeftTemplateContext\">\n                        </ng-container>\n                    </ng-container>\n                    <ng-content *ngIf=\"!sidebarLeftTemplate\"\n                                select=\"adf-viewer-sidebar\"></ng-content>\n                </div>\n            </ng-container>\n\n            <adf-viewer-render\n                (close)=\"onClose()\"\n                [mimeType]=\"mimeType\"\n                [fileName]=\"fileName\"\n                [blobFile]=\"blobFile\"\n                [readOnly]=\"readOnly\"\n                (submitFile)=\"onSubmitFile($event)\"\n                [urlFile]=\"urlFile\"\n                (isSaving)=\"allowNavigate = !$event\"\n                [tracks]=\"tracks\">\n            </adf-viewer-render>\n\n        </div>\n    </div>\n</div>\n", styles: [".adf-full-screen,.adf-viewer-inline-container,.adf-viewer-container .adf-viewer-content,.adf-viewer-container .adf-viewer-layout,.adf-viewer-container .adf-viewer-layout-content{width:100%;height:100%;background-color:var(--adf-theme-background-card-color)}.adf-viewer{position:absolute;width:100%;height:100%}.adf-viewer .mat-toolbar{color:var(--adf-theme-foreground-text-color-054)}.adf-viewer .mat-toolbar .adf-toolbar-title{width:auto}.adf-viewer-main{width:0}.adf-viewer__mimeicon{vertical-align:middle;height:18px;width:18px}.adf-viewer-toolbar .mat-toolbar{background-color:var(--adf-theme-background-card-color-087)}.adf-viewer__file-title{text-align:center;flex:1 1 auto}.adf-viewer__display-name{font-size:var(--theme-subheading-2-font-size);opacity:.87;line-height:1.5;letter-spacing:-.4px;font-weight:400;font-style:normal;font-stretch:normal;max-width:400px;text-overflow:ellipsis;overflow:hidden;display:inline-block;vertical-align:middle;color:var(--adf-theme-foreground-text-color)}.adf-viewer-container .adf-viewer-layout-content{position:relative;overflow-y:hidden;overflow-x:hidden;z-index:1;background-color:var(--theme-background-color);display:flex;flex-direction:row;flex-wrap:wrap;flex:1}.adf-viewer-container .adf-viewer-layout-content>div{display:flex;flex-flow:row wrap;margin:0 auto;align-items:stretch;height:100%}.adf-viewer-container .adf-viewer-layout{display:flex;flex-direction:row;overflow-y:auto;overflow-x:hidden;position:relative}.adf-viewer-container .adf-viewer-content{flex:1;flex-direction:column;display:flex}.adf-viewer-container .adf-viewer-content>div{height:0}.adf-viewer-overlay-container .adf-viewer-content{position:fixed;top:0;left:0;z-index:1000}.adf-viewer-sidebars{display:flex;flex:1 1 auto}.adf-viewer-sidebars .adf-viewer__sidebar{width:350px;display:block;padding:0;background-color:var(--theme-background-color);box-shadow:0 2px 4px 0 var(--adf-theme-foreground-text-color-027);overflow:auto}.adf-viewer-sidebars .adf-viewer__sidebar__right{border-left:1px solid var(--adf-theme-foreground-text-color-007);order:4}.adf-viewer-sidebars .adf-viewer__sidebar__left{border-right:1px solid var(--adf-theme-foreground-text-color-007);order:1}.adf-viewer-sidebars adf-viewer-render{order:1;flex:1 1 auto;display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: ToolbarComponent, selector: "adf-toolbar", inputs: ["title", "color"] }, { kind: "component", type: ToolbarTitleComponent, selector: "adf-toolbar-title" }, { kind: "component", type: ToolbarDividerComponent, selector: "adf-toolbar-divider" }, { kind: "directive", type: i11.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "component", type: ViewerRenderComponent, selector: "adf-viewer-render", inputs: ["urlFile", "blobFile", "allowFullScreen", "allowThumbnails", "thumbnailsTemplate", "mimeType", "fileName", "isLoading", "readOnly", "tracks"], outputs: ["extensionChange", "submitFile", "close", "isSaving"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: MimeTypeIconPipe, name: "adfMimeTypeIcon" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-viewer', host: { class: 'adf-viewer' }, encapsulation: ViewEncapsulation.None, providers: [ViewUtilService], template: "<div *ngIf=\"showViewer\"\n     class=\"adf-viewer-container\"\n     [class.adf-viewer-overlay-container]=\"overlayMode\"\n     [class.adf-viewer-inline-container]=\"!overlayMode\">\n\n    <div class=\"adf-viewer-content\"\n         [cdkTrapFocus]=\"overlayMode\"\n         cdkTrapFocusAutoCapture>\n        <ng-content select=\"adf-viewer-toolbar\"></ng-content>\n        <ng-container *ngIf=\"showToolbar && !toolbar\">\n            <adf-toolbar id=\"adf-viewer-toolbar\" class=\"adf-viewer-toolbar\">\n                <adf-toolbar-title>\n\n                    <ng-container *ngIf=\"allowLeftSidebar\">\n                        <button mat-icon-button\n                                [attr.aria-expanded]=\"showLeftSidebar\"\n                                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.INFO' | translate\"\n                                title=\"{{ 'ADF_VIEWER.ACTIONS.INFO' | translate }}\"\n                                data-automation-id=\"adf-toolbar-left-sidebar\"\n                                [color]=\"showLeftSidebar ? 'accent' : null\"\n                                (click)=\"toggleLeftSidebar()\">\n                            <mat-icon>info_outline</mat-icon>\n                        </button>\n                    </ng-container>\n\n                    <button *ngIf=\"allowGoBack\"\n                            class=\"adf-viewer-close-button\"\n                            data-automation-id=\"adf-toolbar-back\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.CLOSE' | translate\"\n                            mat-icon-button\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.CLOSE' | translate }}\"\n                            (click)=\"onClose()\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </adf-toolbar-title>\n\n                <div class=\"adf-viewer__file-title\">\n                    <button *ngIf=\"allowNavigate && canNavigateBefore\"\n                            data-automation-id=\"adf-toolbar-pref-file\"\n                            mat-icon-button\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.PREV_FILE' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.PREV_FILE' | translate }}\"\n                            (click)=\"onNavigateBeforeClick($event)\">\n                        <mat-icon>navigate_before</mat-icon>\n                    </button>\n                    <img class=\"adf-viewer__mimeicon\"\n                         [alt]=\"mimeType\"\n                         [src]=\"mimeType | adfMimeTypeIcon\"\n                         data-automation-id=\"adf-file-thumbnail\">\n                    <span class=\"adf-viewer__display-name\"\n                          id=\"adf-viewer-display-name\">{{ fileName }}</span>\n                    <button *ngIf=\"allowNavigate && canNavigateNext\"\n                            data-automation-id=\"adf-toolbar-next-file\"\n                            mat-icon-button\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.NEXT_FILE' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.NEXT_FILE' | translate }}\"\n                            (click)=\"onNavigateNextClick($event)\">\n                        <mat-icon>navigate_next</mat-icon>\n                    </button>\n                </div>\n\n                <ng-content select=\"adf-viewer-toolbar-actions\"></ng-content>\n\n                <ng-container *ngIf=\"mnuOpenWith\"\n                              data-automation-id='adf-toolbar-custom-btn'>\n                    <button id=\"adf-viewer-openwith\"\n                            mat-button\n                            [matMenuTriggerFor]=\"mnuOpenWith\"\n                            data-automation-id=\"adf-toolbar-open-with\">\n                        <span>{{ 'ADF_VIEWER.ACTIONS.OPEN_WITH' | translate }}</span>\n                        <mat-icon>arrow_drop_down</mat-icon>\n                    </button>\n                    <mat-menu #mnuOpenWith=\"matMenu\"\n                              [overlapTrigger]=\"false\">\n                        <ng-content select=\"adf-viewer-open-with\"></ng-content>\n                    </mat-menu>\n                </ng-container>\n\n                <adf-toolbar-divider></adf-toolbar-divider>\n\n                <ng-content select=\"adf-viewer-toolbar-custom-actions\"></ng-content>\n\n                <button id=\"adf-viewer-fullscreen\"\n                        *ngIf=\"allowFullScreen\"\n                        mat-icon-button\n                        [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.FULLSCREEN' | translate\"\n                        title=\"{{ 'ADF_VIEWER.ACTIONS.FULLSCREEN' | translate }}\"\n                        data-automation-id=\"adf-toolbar-fullscreen\"\n                        (click)=\"enterFullScreen()\">\n                    <mat-icon>fullscreen</mat-icon>\n                </button>\n\n                <ng-container *ngIf=\"allowRightSidebar\">\n                    <adf-toolbar-divider></adf-toolbar-divider>\n\n                    <button mat-icon-button\n                            [attr.aria-expanded]=\"showRightSidebar\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.INFO' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.INFO' | translate }}\"\n                            data-automation-id=\"adf-toolbar-sidebar\"\n                            [color]=\"showRightSidebar ? 'accent' : null\"\n                            (click)=\"toggleRightSidebar()\">\n                        <mat-icon>info_outline</mat-icon>\n                    </button>\n\n                </ng-container>\n\n                <ng-container *ngIf=\"mnuMoreActions\">\n                    <button id=\"adf-viewer-moreactions\"\n                            mat-icon-button\n                            [matMenuTriggerFor]=\"mnuMoreActions\"\n                            [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.MORE_ACTIONS' | translate\"\n                            title=\"{{ 'ADF_VIEWER.ACTIONS.MORE_ACTIONS' | translate }}\"\n                            data-automation-id=\"adf-toolbar-more-actions\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #mnuMoreActions=\"matMenu\"\n                              [overlapTrigger]=\"false\">\n                        <ng-content select=\"adf-viewer-more-actions\"></ng-content>\n                    </mat-menu>\n                </ng-container>\n\n            </adf-toolbar>\n        </ng-container>\n\n        <div class=\"adf-viewer-sidebars\">\n\n            <ng-container *ngIf=\"allowRightSidebar && showRightSidebar\">\n                <div class=\"adf-viewer__sidebar adf-viewer__sidebar__right\"\n                     id=\"adf-right-sidebar\">\n                    <ng-container *ngIf=\"sidebarRightTemplate\">\n                        <ng-container *ngTemplateOutlet=\"sidebarRightTemplate;context:sidebarRightTemplateContext\">\n                        </ng-container>\n                    </ng-container>\n                    <ng-content *ngIf=\"!sidebarRightTemplate\"\n                                select=\"adf-viewer-sidebar\"></ng-content>\n                </div>\n            </ng-container>\n\n            <ng-container *ngIf=\"allowLeftSidebar && showLeftSidebar\">\n                <div class=\"adf-viewer__sidebar adf-viewer__sidebar__left\"\n                     id=\"adf-left-sidebar\">\n                    <ng-container *ngIf=\"sidebarLeftTemplate\">\n                        <ng-container *ngTemplateOutlet=\"sidebarLeftTemplate;context:sidebarLeftTemplateContext\">\n                        </ng-container>\n                    </ng-container>\n                    <ng-content *ngIf=\"!sidebarLeftTemplate\"\n                                select=\"adf-viewer-sidebar\"></ng-content>\n                </div>\n            </ng-container>\n\n            <adf-viewer-render\n                (close)=\"onClose()\"\n                [mimeType]=\"mimeType\"\n                [fileName]=\"fileName\"\n                [blobFile]=\"blobFile\"\n                [readOnly]=\"readOnly\"\n                (submitFile)=\"onSubmitFile($event)\"\n                [urlFile]=\"urlFile\"\n                (isSaving)=\"allowNavigate = !$event\"\n                [tracks]=\"tracks\">\n            </adf-viewer-render>\n\n        </div>\n    </div>\n</div>\n", styles: [".adf-full-screen,.adf-viewer-inline-container,.adf-viewer-container .adf-viewer-content,.adf-viewer-container .adf-viewer-layout,.adf-viewer-container .adf-viewer-layout-content{width:100%;height:100%;background-color:var(--adf-theme-background-card-color)}.adf-viewer{position:absolute;width:100%;height:100%}.adf-viewer .mat-toolbar{color:var(--adf-theme-foreground-text-color-054)}.adf-viewer .mat-toolbar .adf-toolbar-title{width:auto}.adf-viewer-main{width:0}.adf-viewer__mimeicon{vertical-align:middle;height:18px;width:18px}.adf-viewer-toolbar .mat-toolbar{background-color:var(--adf-theme-background-card-color-087)}.adf-viewer__file-title{text-align:center;flex:1 1 auto}.adf-viewer__display-name{font-size:var(--theme-subheading-2-font-size);opacity:.87;line-height:1.5;letter-spacing:-.4px;font-weight:400;font-style:normal;font-stretch:normal;max-width:400px;text-overflow:ellipsis;overflow:hidden;display:inline-block;vertical-align:middle;color:var(--adf-theme-foreground-text-color)}.adf-viewer-container .adf-viewer-layout-content{position:relative;overflow-y:hidden;overflow-x:hidden;z-index:1;background-color:var(--theme-background-color);display:flex;flex-direction:row;flex-wrap:wrap;flex:1}.adf-viewer-container .adf-viewer-layout-content>div{display:flex;flex-flow:row wrap;margin:0 auto;align-items:stretch;height:100%}.adf-viewer-container .adf-viewer-layout{display:flex;flex-direction:row;overflow-y:auto;overflow-x:hidden;position:relative}.adf-viewer-container .adf-viewer-content{flex:1;flex-direction:column;display:flex}.adf-viewer-container .adf-viewer-content>div{height:0}.adf-viewer-overlay-container .adf-viewer-content{position:fixed;top:0;left:0;z-index:1000}.adf-viewer-sidebars{display:flex;flex:1 1 auto}.adf-viewer-sidebars .adf-viewer__sidebar{width:350px;display:block;padding:0;background-color:var(--theme-background-color);box-shadow:0 2px 4px 0 var(--adf-theme-foreground-text-color-027);overflow:auto}.adf-viewer-sidebars .adf-viewer__sidebar__right{border-left:1px solid var(--adf-theme-foreground-text-color-007);order:4}.adf-viewer-sidebars .adf-viewer__sidebar__left{border-right:1px solid var(--adf-theme-foreground-text-color-007);order:1}.adf-viewer-sidebars adf-viewer-render{order:1;flex:1 1 auto;display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$4.MatDialog }, { type: ViewUtilService }, { type: AppConfigService }]; }, propDecorators: { toolbar: [{
                type: ContentChild,
                args: [ViewerToolbarComponent]
            }], sidebar: [{
                type: ContentChild,
                args: [ViewerSidebarComponent]
            }], mnuOpenWith: [{
                type: ContentChild,
                args: [ViewerOpenWithComponent]
            }], mnuMoreActions: [{
                type: ContentChild,
                args: [ViewerMoreActionsComponent]
            }], urlFile: [{
                type: Input
            }], blobFile: [{
                type: Input
            }], fileName: [{
                type: Input
            }], showViewer: [{
                type: Input
            }], allowGoBack: [{
                type: Input
            }], allowFullScreen: [{
                type: Input
            }], showToolbar: [{
                type: Input
            }], overlayMode: [{
                type: Input
            }], allowNavigate: [{
                type: Input
            }], canNavigateBefore: [{
                type: Input
            }], canNavigateNext: [{
                type: Input
            }], allowLeftSidebar: [{
                type: Input
            }], allowRightSidebar: [{
                type: Input
            }], showRightSidebar: [{
                type: Input
            }], showLeftSidebar: [{
                type: Input
            }], sidebarRightTemplate: [{
                type: Input
            }], sidebarLeftTemplate: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], tracks: [{
                type: Input
            }], mimeType: [{
                type: Input
            }], sidebarRightTemplateContext: [{
                type: Input
            }], sidebarLeftTemplateContext: [{
                type: Input
            }], downloadFile: [{
                type: Output
            }], navigateBefore: [{
                type: Output
            }], navigateNext: [{
                type: Output
            }], showViewerChange: [{
                type: Output
            }], submitFile: [{
                type: Output
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerExtensionDirective {
    constructor(viewerComponent) {
        this.viewerComponent = viewerComponent;
        this.onDestroy$ = new Subject();
    }
    ngAfterContentInit() {
        this.templateModel = { template: this.template, isVisible: false };
        this.viewerComponent.extensionTemplates.push(this.templateModel);
        this.viewerComponent.extensionChange
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(fileExtension => {
            this.templateModel.isVisible = this.isVisible(fileExtension);
        });
        if (this.supportedExtensions instanceof Array) {
            this.supportedExtensions.forEach((extension) => {
                this.viewerComponent.externalExtensions.push(extension);
            });
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    /**
     * check if the current extension in the viewer is compatible with this extension checking against supportedExtensions
     */
    isVisible(fileExtension) {
        let supportedExtension;
        if (this.supportedExtensions && (this.supportedExtensions instanceof Array)) {
            supportedExtension = this.supportedExtensions.find((extension) => extension.toLowerCase() === fileExtension);
        }
        return !!supportedExtension;
    }
}
ViewerExtensionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerExtensionDirective, deps: [{ token: ViewerRenderComponent }], target: i0.ɵɵFactoryTarget.Directive });
ViewerExtensionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ViewerExtensionDirective, selector: "adf-viewer-extension", inputs: { urlFileContent: "urlFileContent", extension: "extension", supportedExtensions: "supportedExtensions" }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerExtensionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-viewer-extension'
                }]
        }], ctorParameters: function () { return [{ type: ViewerRenderComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], urlFileContent: [{
                type: Input
            }], extension: [{
                type: Input
            }], supportedExtensions: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ToolbarModule {
}
ToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ToolbarModule, declarations: [ToolbarComponent,
        ToolbarTitleComponent,
        ToolbarDividerComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule], exports: [ToolbarComponent,
        ToolbarTitleComponent,
        ToolbarDividerComponent] });
ToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule
                    ],
                    declarations: [
                        ToolbarComponent,
                        ToolbarTitleComponent,
                        ToolbarDividerComponent
                    ],
                    exports: [
                        ToolbarComponent,
                        ToolbarTitleComponent,
                        ToolbarDividerComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoApiService {
    constructor(appConfig, storageService) {
        this.appConfig = appConfig;
        this.storageService = storageService;
        this.alfrescoApiInitialized = new ReplaySubject(1);
        this.excludedErrorUrl = ['api/enterprise/system/properties'];
    }
    getInstance() {
        return this.alfrescoApi;
    }
    async load(config) {
        this.currentAppConfig = config;
        if (config.authType === 'OAUTH') {
            await this.mapAlfrescoApiOpenIdConfig();
        }
        this.initAlfrescoApiWithConfig();
        this.alfrescoApiInitialized.next(true);
    }
    async reset() {
        this.getCurrentAppConfig();
        if (this.currentAppConfig.authType === 'OAUTH') {
            await this.mapAlfrescoApiOpenIdConfig();
        }
        this.initAlfrescoApiWithConfig();
    }
    getAuthWithFixedOriginLocation() {
        const oauth = this.appConfig.oauth2;
        if (oauth) {
            oauth.redirectUri = window.location.origin + window.location.pathname;
            oauth.redirectUriLogout = window.location.origin + window.location.pathname;
        }
        return oauth;
    }
    async mapAlfrescoApiOpenIdConfig() {
        this.idpConfig = await this.appConfig.loadWellKnown(this.currentAppConfig.oauth2.host);
        this.currentAppConfig.oauth2.tokenUrl = this.idpConfig.token_endpoint;
        this.currentAppConfig.oauth2.authorizationUrl = this.idpConfig.authorization_endpoint;
        this.currentAppConfig.oauth2.logoutUrl = this.idpConfig.end_session_endpoint;
        this.currentAppConfig.oauth2.userinfoEndpoint = this.idpConfig.userinfo_endpoint;
    }
    getCurrentAppConfig() {
        const oauth = this.getAuthWithFixedOriginLocation();
        this.currentAppConfig = new AlfrescoApiConfig({
            provider: this.appConfig.get(AppConfigValues.PROVIDERS),
            hostEcm: this.appConfig.get(AppConfigValues.ECMHOST),
            hostBpm: this.appConfig.get(AppConfigValues.BPMHOST),
            authType: this.appConfig.get(AppConfigValues.AUTHTYPE, 'BASIC'),
            contextRootBpm: this.appConfig.get(AppConfigValues.CONTEXTROOTBPM),
            contextRoot: this.appConfig.get(AppConfigValues.CONTEXTROOTECM),
            disableCsrf: this.appConfig.get(AppConfigValues.DISABLECSRF),
            withCredentials: this.appConfig.get(AppConfigValues.AUTH_WITH_CREDENTIALS, false),
            domainPrefix: this.appConfig.get(AppConfigValues.STORAGE_PREFIX),
            oauth2: oauth
        });
    }
    initAlfrescoApi() {
        this.getCurrentAppConfig();
        this.initAlfrescoApiWithConfig();
    }
    initAlfrescoApiWithConfig() {
        if (this.alfrescoApi && this.isDifferentConfig(this.lastConfig, this.currentAppConfig)) {
            this.alfrescoApi.setConfig(this.currentAppConfig);
        }
        else {
            this.alfrescoApi = this.createInstance(this.currentAppConfig);
        }
        this.lastConfig = this.currentAppConfig;
    }
    createInstance(config) {
        return new AlfrescoApi(config);
    }
    isDifferentConfig(lastConfig, newConfig) {
        return JSON.stringify(lastConfig) !== JSON.stringify(newConfig);
    }
    isExcludedErrorListener(currentFullPath) {
        const formattedPath = currentFullPath.replace(this.lastConfig.hostBpm + '/' + this.lastConfig.contextRootBpm, '');
        return this.excludedErrorUrl.includes(formattedPath);
    }
}
AlfrescoApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiService, deps: [{ token: AppConfigService }, { token: StorageService }], target: i0.ɵɵFactoryTarget.Injectable });
AlfrescoApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: StorageService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var UserPreferenceValues;
(function (UserPreferenceValues) {
    UserPreferenceValues["PaginationSize"] = "paginationSize";
    UserPreferenceValues["Locale"] = "locale";
    UserPreferenceValues["SupportedPageSizes"] = "supportedPageSizes";
    UserPreferenceValues["ExpandedSideNavStatus"] = "expandedSidenav";
})(UserPreferenceValues || (UserPreferenceValues = {}));
class UserPreferencesService {
    constructor(translate, appConfig, storage, alfrescoApiService) {
        this.translate = translate;
        this.appConfig = appConfig;
        this.storage = storage;
        this.alfrescoApiService = alfrescoApiService;
        this.defaults = {
            paginationSize: 25,
            supportedPageSizes: [5, 10, 15, 20],
            locale: 'en',
            expandedSidenav: true
        };
        this.userPreferenceStatus = this.defaults;
        this.alfrescoApiService.alfrescoApiInitialized.pipe(filter(status => status)).subscribe(this.initUserPreferenceStatus.bind(this));
        this.onChangeSubject = new BehaviorSubject(this.userPreferenceStatus);
        this.onChange = this.onChangeSubject.asObservable();
    }
    initUserPreferenceStatus() {
        this.initUserLanguage();
        this.set(UserPreferenceValues.PaginationSize, this.paginationSize);
        this.set(UserPreferenceValues.SupportedPageSizes, JSON.stringify(this.supportedPageSizes));
    }
    initUserLanguage() {
        if (this.locale || this.appConfig.get(UserPreferenceValues.Locale)) {
            const locale = this.locale || this.getDefaultLocale();
            this.set(UserPreferenceValues.Locale, locale);
            this.set('textOrientation', this.getLanguageByKey(locale).direction || 'ltr');
        }
        else {
            const locale = this.locale || this.getDefaultLocale();
            this.setWithoutStore(UserPreferenceValues.Locale, locale);
            this.setWithoutStore('textOrientation', this.getLanguageByKey(locale).direction || 'ltr');
        }
    }
    /**
     * Sets up a callback to notify when a property has changed.
     *
     * @param property The property to watch
     * @returns Notification callback
     */
    select(property) {
        return this.onChange
            .pipe(map((userPreferenceStatus) => userPreferenceStatus[property]), distinctUntilChanged());
    }
    /**
     * Gets a preference property.
     *
     * @param property Name of the property
     * @param defaultValue Default to return if the property is not found
     * @returns Preference property
     */
    get(property, defaultValue) {
        const key = this.getPropertyKey(property);
        const value = this.storage.getItem(key);
        if (value === undefined || value === null) {
            return defaultValue;
        }
        return value;
    }
    /**
     * Sets a preference property.
     *
     * @param property Name of the property
     * @param value New value for the property
     */
    set(property, value) {
        if (!property) {
            return;
        }
        this.storage.setItem(this.getPropertyKey(property), value);
        this.userPreferenceStatus[property] = value;
        this.onChangeSubject.next(this.userPreferenceStatus);
    }
    /**
     * Sets a preference property.
     *
     * @param property Name of the property
     * @param value New value for the property
     */
    setWithoutStore(property, value) {
        if (!property) {
            return;
        }
        this.userPreferenceStatus[property] = value;
        this.onChangeSubject.next(this.userPreferenceStatus);
    }
    /**
     * Check if an item is present in the storage
     *
     * @param property Name of the property
     * @returns True if the item is present, false otherwise
     */
    hasItem(property) {
        if (!property) {
            return false;
        }
        return this.storage.hasItem(this.getPropertyKey(property));
    }
    /**
     * Gets the active storage prefix for preferences.
     *
     * @returns Storage prefix
     */
    getStoragePrefix() {
        return this.storage.getItem('USER_PROFILE') || 'GUEST';
    }
    /**
     * Sets the active storage prefix for preferences.
     *
     * @param value Name of the prefix
     */
    setStoragePrefix(value) {
        this.storage.setItem('USER_PROFILE', value || 'GUEST');
        this.initUserPreferenceStatus();
    }
    /**
     * Gets the full property key with prefix.
     *
     * @param property The property name
     * @returns Property key
     */
    getPropertyKey(property) {
        return `${this.getStoragePrefix()}__${property}`;
    }
    /**
     * Gets an array containing the available page sizes.
     *
     * @returns Array of page size values
     */
    get supportedPageSizes() {
        const supportedPageSizes = this.get(UserPreferenceValues.SupportedPageSizes);
        if (supportedPageSizes) {
            return JSON.parse(supportedPageSizes);
        }
        else {
            return this.appConfig.get('pagination.supportedPageSizes', this.defaults.supportedPageSizes);
        }
    }
    set supportedPageSizes(value) {
        this.set(UserPreferenceValues.SupportedPageSizes, JSON.stringify(value));
    }
    /** Pagination size. */
    set paginationSize(value) {
        this.set(UserPreferenceValues.PaginationSize, value);
    }
    get paginationSize() {
        const paginationSize = this.get(UserPreferenceValues.PaginationSize);
        if (paginationSize) {
            return Number(paginationSize);
        }
        else {
            return Number(this.appConfig.get('pagination.size', this.defaults.paginationSize));
        }
    }
    /** Current locale setting. */
    get locale() {
        return this.get(UserPreferenceValues.Locale);
    }
    set locale(value) {
        this.set(UserPreferenceValues.Locale, value);
    }
    /**
     * Gets the default locale.
     *
     * @returns Default locale language code
     */
    getDefaultLocale() {
        return this.appConfig.get(UserPreferenceValues.Locale) || this.translate.getBrowserCultureLang() || 'en';
    }
    getLanguageByKey(key) {
        return (this.appConfig
            .get(AppConfigValues.APP_CONFIG_LANGUAGES_KEY, [{ key: 'en' }])
            .find((language) => key.includes(language.key)) || { key: 'en' });
    }
}
UserPreferencesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserPreferencesService, deps: [{ token: i3.TranslateService }, { token: AppConfigService }, { token: StorageService }, { token: AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
UserPreferencesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserPreferencesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserPreferencesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.TranslateService }, { type: AppConfigService }, { type: StorageService }, { type: AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TRANSLATION_PROVIDER = new InjectionToken('Injection token for translation providers.');
class TranslationService {
    constructor(translate, userPreferencesService, providers) {
        this.translate = translate;
        this.customLoader = this.translate.currentLoader;
        this.defaultLang = 'en';
        translate.setDefaultLang(this.defaultLang);
        this.customLoader.setDefaultLang(this.defaultLang);
        if (providers && providers.length > 0) {
            for (const provider of providers) {
                this.addTranslationFolder(provider.name, provider.source);
            }
        }
        userPreferencesService.select(UserPreferenceValues.Locale).subscribe((locale) => {
            if (locale) {
                this.userLang = locale;
                this.use(this.userLang);
            }
        });
    }
    /**
     * Adds a new folder of translation source files.
     *
     * @param name Name for the translation provider
     * @param path Path to the folder
     */
    addTranslationFolder(name = '', path = '') {
        if (!this.customLoader.providerRegistered(name)) {
            this.customLoader.registerProvider(name, path);
            if (this.userLang) {
                this.loadTranslation(this.userLang, this.defaultLang);
            }
            else {
                this.loadTranslation(this.defaultLang);
            }
        }
    }
    /**
     * Loads a translation file.
     *
     * @param lang Language code for the language to load
     * @param fallback Language code to fall back to if the first one was unavailable
     */
    loadTranslation(lang, fallback) {
        this.translate.getTranslation(lang).subscribe(() => {
            this.translate.use(lang);
            this.onTranslationChanged(lang);
        }, () => {
            if (fallback && fallback !== lang) {
                this.loadTranslation(fallback);
            }
        });
    }
    /**
     * Triggers a notification callback when the translation language changes.
     *
     * @param lang The new language code
     */
    onTranslationChanged(lang) {
        this.translate.onTranslationChange.next({
            lang,
            translations: this.customLoader.getFullTranslationJSON(lang)
        });
    }
    /**
     * Sets the target language for translations.
     *
     * @param lang Code name for the language
     * @returns Translations available for the language
     */
    use(lang) {
        this.customLoader.init(lang);
        return this.translate.use(lang);
    }
    /**
     * Gets the translation for the supplied key.
     *
     * @param key Key to translate
     * @param interpolateParams String(s) to be interpolated into the main message
     * @returns Translated text
     */
    get(key, interpolateParams) {
        return this.translate.get(key, interpolateParams);
    }
    /**
     * Directly returns the translation for the supplied key.
     *
     * @param key Key to translate
     * @param interpolateParams String(s) to be interpolated into the main message
     * @returns Translated text
     */
    instant(key, interpolateParams) {
        return key ? this.translate.instant(key, interpolateParams) : '';
    }
}
TranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationService, deps: [{ token: i3.TranslateService }, { token: UserPreferencesService }, { token: TRANSLATION_PROVIDER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
TranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.TranslateService }, { type: UserPreferencesService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [TRANSLATION_PROVIDER]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileSizePipe {
    constructor(translation) {
        this.translation = translation;
    }
    transform(paramByte, decimals = 2) {
        if (paramByte == null) {
            return '';
        }
        const bytes = parseInt(paramByte, 10);
        if (isNaN(bytes)) {
            return '';
        }
        if (bytes === 0) {
            return '0 ' + this.translation.instant('CORE.FILE_SIZE.BYTES');
        }
        const k = 1024;
        const dm = decimals || 2;
        const sizes = ['BYTES', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const i18nSize = this.translation.instant(`CORE.FILE_SIZE.${sizes[i]}`);
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + i18nSize;
    }
}
FileSizePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileSizePipe, deps: [{ token: TranslationService }], target: i0.ɵɵFactoryTarget.Pipe });
FileSizePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FileSizePipe, name: "adfFileSize", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfFileSize',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HighlightTransformService {
    /**
     * Searches for `search` string(s) within `text` and highlights all occurrences.
     *
     * @param text Text to search within
     * @param search Text pattern to search for
     * @param wrapperClass CSS class used to provide highlighting style
     * @returns New text along with boolean value to indicate whether anything was highlighted
     */
    highlight(text, search, wrapperClass = 'adf-highlight') {
        let isMatching = false;
        let result = text;
        if (search && text) {
            let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
            pattern = pattern.split(' ').filter((t) => t.length > 0).join('|');
            const regex = new RegExp(pattern, 'gi');
            result = text.replace(/<[^>]+>/g, '').replace(regex, (match) => {
                isMatching = true;
                return `<span class="${wrapperClass}">${match}</span>`;
            });
            return { text: result, changed: isMatching };
        }
        else {
            return { text: result, changed: isMatching };
        }
    }
}
HighlightTransformService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightTransformService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HighlightTransformService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightTransformService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightTransformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HighlightPipe {
    constructor(highlightTransformService) {
        this.highlightTransformService = highlightTransformService;
    }
    transform(text, search) {
        const highlightTransformResult = this.highlightTransformService.highlight(text, search);
        return highlightTransformResult.text;
    }
}
HighlightPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightPipe, deps: [{ token: HighlightTransformService }], target: i0.ɵɵFactoryTarget.Pipe });
HighlightPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: HighlightPipe, name: "highlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'highlight'
                }]
        }], ctorParameters: function () { return [{ type: HighlightTransformService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TimeAgoPipe {
    constructor(userPreferenceService, appConfig) {
        this.userPreferenceService = userPreferenceService;
        this.appConfig = appConfig;
        this.onDestroy$ = new Subject();
        this.userPreferenceService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => {
            this.defaultLocale = locale || TimeAgoPipe.DEFAULT_LOCALE;
        });
        this.defaultDateTimeFormat = this.appConfig.get('dateValues.defaultDateTimeFormat', TimeAgoPipe.DEFAULT_DATE_TIME_FORMAT);
    }
    transform(value, locale) {
        if (value !== null && value !== undefined) {
            const actualLocale = locale || this.defaultLocale;
            const then = moment(value);
            const diff = moment().locale(actualLocale).diff(then, 'days');
            if (diff > 7) {
                const datePipe = new DatePipe(actualLocale);
                return datePipe.transform(value, this.defaultDateTimeFormat);
            }
            else {
                return then.locale(actualLocale).fromNow();
            }
        }
        return '';
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
TimeAgoPipe.DEFAULT_LOCALE = 'en-US';
TimeAgoPipe.DEFAULT_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
TimeAgoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TimeAgoPipe, deps: [{ token: UserPreferencesService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Pipe });
TimeAgoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: TimeAgoPipe, name: "adfTimeAgo" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TimeAgoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfTimeAgo'
                }]
        }], ctorParameters: function () { return [{ type: UserPreferencesService }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InitialUsernamePipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(user, className = '', delimiter = '') {
        let safeHtml = '';
        if (user) {
            const initialResult = this.getInitialUserName(user.firstName || user.displayName || user.username, user.lastName, delimiter);
            safeHtml = this.sanitized.bypassSecurityTrustHtml(`<div data-automation-id="user-initials-image" class="${className}">${initialResult}</div>`);
        }
        return safeHtml;
    }
    getInitialUserName(firstName, lastName, delimiter) {
        firstName = (firstName ? firstName[0] : '');
        lastName = (lastName ? lastName[0] : '');
        return firstName + delimiter + lastName;
    }
}
InitialUsernamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InitialUsernamePipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
InitialUsernamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: InitialUsernamePipe, name: "usernameInitials" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InitialUsernamePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'usernameInitials'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FullNamePipe {
    transform(user) {
        return this.buildFullName(user) ? this.buildFullName(user) : this.buildFromUsernameOrEmail(user);
    }
    buildFullName(user) {
        const fullName = [];
        fullName.push(user?.firstName);
        fullName.push(user?.lastName);
        return fullName.join(' ').trim();
    }
    buildFromUsernameOrEmail(user) {
        return (user?.username || user?.email) ?? '';
    }
}
FullNamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FullNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FullNamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FullNamePipe, name: "fullName" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FullNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'fullName' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormatSpacePipe {
    transform(inputValue, replaceChar = '_', lowerCase = true) {
        let transformedString = '';
        if (inputValue) {
            transformedString = lowerCase ? inputValue.trim().split(' ').join(replaceChar).toLocaleLowerCase() :
                inputValue.trim().split(' ').join(replaceChar);
        }
        return transformedString;
    }
}
FormatSpacePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormatSpacePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FormatSpacePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FormatSpacePipe, name: "formatSpace" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormatSpacePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'formatSpace'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileTypePipe {
    transform(value) {
        if (value == null) {
            return '';
        }
        else {
            const fileInfo = value.substring(value.lastIndexOf('/') + 1).replace(/\.[a-z]+/, '');
            return fileInfo.split('_').pop();
        }
    }
}
FileTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FileTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FileTypePipe, name: "fileType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fileType',
                    pure: true
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiValuePipe {
    transform(values, valueSeparator = MultiValuePipe.DEFAULT_SEPARATOR) {
        if (values && values instanceof Array) {
            return values.join(valueSeparator);
        }
        return values;
    }
}
MultiValuePipe.DEFAULT_SEPARATOR = ', ';
MultiValuePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MultiValuePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MultiValuePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MultiValuePipe, name: "multiValue" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MultiValuePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'multiValue' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LocalizedDatePipe {
    constructor(userPreferenceService, appConfig) {
        this.userPreferenceService = userPreferenceService;
        this.appConfig = appConfig;
        this.defaultLocale = LocalizedDatePipe.DEFAULT_LOCALE;
        this.defaultFormat = LocalizedDatePipe.DEFAULT_DATE_FORMAT;
        this.onDestroy$ = new Subject();
        if (this.userPreferenceService) {
            this.userPreferenceService
                .select(UserPreferenceValues.Locale)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(locale => {
                if (locale) {
                    this.defaultLocale = locale;
                }
            });
        }
        if (this.appConfig) {
            this.defaultFormat = this.appConfig.get('dateValues.defaultDateFormat', LocalizedDatePipe.DEFAULT_DATE_FORMAT);
        }
    }
    transform(value, format, locale) {
        const actualFormat = format || this.defaultFormat;
        const actualLocale = locale || this.defaultLocale;
        const datePipe = new DatePipe(actualLocale);
        return datePipe.transform(value, actualFormat);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
LocalizedDatePipe.DEFAULT_LOCALE = 'en-US';
LocalizedDatePipe.DEFAULT_DATE_FORMAT = 'mediumDate';
LocalizedDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocalizedDatePipe, deps: [{ token: UserPreferencesService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Pipe });
LocalizedDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: LocalizedDatePipe, name: "adfLocalizedDate", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocalizedDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfLocalizedDate',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: UserPreferencesService }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DecimalNumberPipe {
    constructor(userPreferenceService, appConfig) {
        this.userPreferenceService = userPreferenceService;
        this.appConfig = appConfig;
        this.defaultLocale = DecimalNumberPipe.DEFAULT_LOCALE;
        this.defaultMinIntegerDigits = DecimalNumberPipe.DEFAULT_MIN_INTEGER_DIGITS;
        this.defaultMinFractionDigits = DecimalNumberPipe.DEFAULT_MIN_FRACTION_DIGITS;
        this.defaultMaxFractionDigits = DecimalNumberPipe.DEFAULT_MAX_FRACTION_DIGITS;
        this.onDestroy$ = new Subject();
        if (this.userPreferenceService) {
            this.userPreferenceService.select(UserPreferenceValues.Locale)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((locale) => {
                if (locale) {
                    this.defaultLocale = locale;
                }
            });
        }
        if (this.appConfig) {
            this.defaultMinIntegerDigits = this.appConfig.get('decimalValues.minIntegerDigits', DecimalNumberPipe.DEFAULT_MIN_INTEGER_DIGITS);
            this.defaultMinFractionDigits = this.appConfig.get('decimalValues.minFractionDigits', DecimalNumberPipe.DEFAULT_MIN_FRACTION_DIGITS);
            this.defaultMaxFractionDigits = this.appConfig.get('decimalValues.maxFractionDigits', DecimalNumberPipe.DEFAULT_MAX_FRACTION_DIGITS);
        }
    }
    transform(value, digitsInfo, locale) {
        const actualMinIntegerDigits = digitsInfo && digitsInfo.minIntegerDigits ? digitsInfo.minIntegerDigits : this.defaultMinIntegerDigits;
        const actualMinFractionDigits = digitsInfo && digitsInfo.minFractionDigits ? digitsInfo.minFractionDigits : this.defaultMinFractionDigits;
        const actualMaxFractionDigits = digitsInfo && digitsInfo.maxFractionDigits ? digitsInfo.maxFractionDigits : this.defaultMaxFractionDigits;
        const actualDigitsInfo = `${actualMinIntegerDigits}.${actualMinFractionDigits}-${actualMaxFractionDigits}`;
        const actualLocale = locale || this.defaultLocale;
        const decimalPipe = new DecimalPipe(actualLocale);
        return decimalPipe.transform(value, actualDigitsInfo);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
DecimalNumberPipe.DEFAULT_LOCALE = 'en-US';
DecimalNumberPipe.DEFAULT_MIN_INTEGER_DIGITS = 1;
DecimalNumberPipe.DEFAULT_MIN_FRACTION_DIGITS = 0;
DecimalNumberPipe.DEFAULT_MAX_FRACTION_DIGITS = 2;
DecimalNumberPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DecimalNumberPipe, deps: [{ token: UserPreferencesService }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Pipe });
DecimalNumberPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DecimalNumberPipe, name: "adfDecimalNumber", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DecimalNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfDecimalNumber',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: UserPreferencesService }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LocalizedRolePipe {
    constructor(translationService) {
        this.translationService = translationService;
    }
    transform(value) {
        if (value) {
            const key = `ADF.ROLES.${value.toUpperCase()}`;
            const translation = this.translationService.instant(key);
            if (translation) {
                return translation;
            }
        }
        return value;
    }
}
LocalizedRolePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocalizedRolePipe, deps: [{ token: TranslationService }], target: i0.ɵɵFactoryTarget.Pipe });
LocalizedRolePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: LocalizedRolePipe, name: "adfLocalizedRole" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocalizedRolePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfLocalizedRole'
                }]
        }], ctorParameters: function () { return [{ type: TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MomentDatePipe {
    transform(value, dateFormat) {
        return moment(value, dateFormat);
    }
}
MomentDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MomentDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MomentDatePipe, name: "adfMomentDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'adfMomentDate' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MomentDateTimePipe {
    transform(value, dateFormat) {
        return moment(value, dateFormat)
            .add(moment(value, dateFormat).utcOffset(), 'minutes');
    }
}
MomentDateTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDateTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MomentDateTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MomentDateTimePipe, name: "adfMomentDateTime" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MomentDateTimePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'adfMomentDateTime' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FilterStringPipe {
    transform(value = '', filterBy = '') {
        const testResult = filterBy ?
            value.toLowerCase().indexOf(filterBy.toLowerCase()) > -1 :
            true;
        return testResult ? value : '';
    }
}
FilterStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FilterStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FilterStringPipe, name: "filterString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterStringPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'filterString' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FilterOutArrayObjectsByPropPipe {
    transform(values, filterKey, filterValue) {
        return (values ?? []).filter(value => value[filterKey] !== filterValue);
    }
}
FilterOutArrayObjectsByPropPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterOutArrayObjectsByPropPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FilterOutArrayObjectsByPropPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FilterOutArrayObjectsByPropPipe, name: "filterOutEvery" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterOutArrayObjectsByPropPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'filterOutEvery' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PipeModule {
}
PipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: PipeModule, declarations: [FileSizePipe,
        HighlightPipe,
        TimeAgoPipe,
        MimeTypeIconPipe,
        InitialUsernamePipe,
        FullNamePipe,
        FormatSpacePipe,
        FileTypePipe,
        MultiValuePipe,
        LocalizedDatePipe,
        DecimalNumberPipe,
        LocalizedRolePipe,
        MomentDatePipe,
        MomentDateTimePipe,
        FilterStringPipe,
        FilterOutArrayObjectsByPropPipe], imports: [CommonModule,
        TranslateModule], exports: [FileSizePipe,
        HighlightPipe,
        TimeAgoPipe,
        MimeTypeIconPipe,
        InitialUsernamePipe,
        FullNamePipe,
        FormatSpacePipe,
        FileTypePipe,
        MultiValuePipe,
        LocalizedDatePipe,
        DecimalNumberPipe,
        LocalizedRolePipe,
        MomentDatePipe,
        MomentDateTimePipe,
        FilterStringPipe,
        FilterOutArrayObjectsByPropPipe] });
PipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PipeModule, providers: [
        FileSizePipe,
        HighlightPipe,
        TimeAgoPipe,
        MimeTypeIconPipe,
        InitialUsernamePipe,
        FormatSpacePipe,
        FileTypePipe,
        MultiValuePipe,
        LocalizedDatePipe,
        DecimalNumberPipe,
        LocalizedRolePipe,
        MomentDatePipe,
        MomentDateTimePipe,
        FilterStringPipe,
        FilterOutArrayObjectsByPropPipe
    ], imports: [CommonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule
                    ],
                    declarations: [
                        FileSizePipe,
                        HighlightPipe,
                        TimeAgoPipe,
                        MimeTypeIconPipe,
                        InitialUsernamePipe,
                        FullNamePipe,
                        FormatSpacePipe,
                        FileTypePipe,
                        MultiValuePipe,
                        LocalizedDatePipe,
                        DecimalNumberPipe,
                        LocalizedRolePipe,
                        MomentDatePipe,
                        MomentDateTimePipe,
                        FilterStringPipe,
                        FilterOutArrayObjectsByPropPipe
                    ],
                    providers: [
                        FileSizePipe,
                        HighlightPipe,
                        TimeAgoPipe,
                        MimeTypeIconPipe,
                        InitialUsernamePipe,
                        FormatSpacePipe,
                        FileTypePipe,
                        MultiValuePipe,
                        LocalizedDatePipe,
                        DecimalNumberPipe,
                        LocalizedRolePipe,
                        MomentDatePipe,
                        MomentDateTimePipe,
                        FilterStringPipe,
                        FilterOutArrayObjectsByPropPipe
                    ],
                    exports: [
                        FileSizePipe,
                        HighlightPipe,
                        TimeAgoPipe,
                        MimeTypeIconPipe,
                        InitialUsernamePipe,
                        FullNamePipe,
                        FormatSpacePipe,
                        FileTypePipe,
                        MultiValuePipe,
                        LocalizedDatePipe,
                        DecimalNumberPipe,
                        LocalizedRolePipe,
                        MomentDatePipe,
                        MomentDateTimePipe,
                        FilterStringPipe,
                        FilterOutArrayObjectsByPropPipe
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HighlightDirective {
    constructor(el, renderer, highlightTransformService) {
        this.el = el;
        this.renderer = renderer;
        this.highlightTransformService = highlightTransformService;
        /** Class selector for highlightable elements. */
        this.selector = '';
        /** Text to highlight. */
        this.search = '';
        /** CSS class used to apply highlighting. */
        this.classToApply = 'adf-highlight';
    }
    ngAfterViewChecked() {
        this.highlight();
    }
    highlight(search = this.search, selector = this.selector, classToApply = this.classToApply) {
        if (search && selector) {
            const elements = this.el.nativeElement.querySelectorAll(selector);
            elements.forEach((element) => {
                const highlightTransformResult = this.highlightTransformService.highlight(element.innerHTML, search, classToApply);
                if (highlightTransformResult.changed) {
                    this.renderer.setProperty(element, 'innerHTML', highlightTransformResult.text);
                }
            });
        }
    }
}
HighlightDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: HighlightTransformService }], target: i0.ɵɵFactoryTarget.Directive });
HighlightDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: HighlightDirective, selector: "[adf-highlight]", inputs: { selector: ["adf-highlight-selector", "selector"], search: ["adf-highlight", "search"], classToApply: ["adf-highlight-class", "classToApply"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-highlight]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: HighlightTransformService }]; }, propDecorators: { selector: [{
                type: Input,
                args: ['adf-highlight-selector']
            }], search: [{
                type: Input,
                args: ['adf-highlight']
            }], classToApply: [{
                type: Input,
                args: ['adf-highlight-class']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JwtHelperService {
    constructor(storageService) {
        this.storageService = storageService;
    }
    /**
     * Decodes a JSON web token into a JS object.
     *
     * @param token Token in encoded form
     * @returns Decoded token data object
     */
    decodeToken(token) {
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }
        const decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token');
        }
        return JSON.parse(decoded);
    }
    urlBase64Decode(token) {
        let output = token.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw new Error('Illegal base64url string!');
            }
        }
        return decodeURIComponent(escape(window.atob(output)));
    }
    /**
     * Gets a named value from the user access or id token.
     *
     * @param key Key name of the field to retrieve
     * @returns Value from the token
     */
    getValueFromLocalToken(key) {
        return this.getValueFromToken(this.getAccessToken(), key) || this.getValueFromToken(this.getIdToken(), key);
    }
    /**
     * Gets a named value from the user access token.
     *
     * @param key Key name of the field to retrieve
     * @returns Value from the token
     */
    getValueFromLocalAccessToken(key) {
        return this.getValueFromToken(this.getAccessToken(), key);
    }
    /**
     * Gets access token
     *
     * @returns access token
     */
    getAccessToken() {
        return this.storageService.getItem(JwtHelperService.USER_ACCESS_TOKEN);
    }
    /**
     * Gets a named value from the user id token.
     *
     * @param key Key name of the field to retrieve
     * @returns Value from the token
     */
    getValueFromLocalIdToken(key) {
        return this.getValueFromToken(this.getIdToken(), key);
    }
    /**
     * Gets id token
     *
     * @returns id token
     */
    getIdToken() {
        return this.storageService.getItem(JwtHelperService.USER_ID_TOKEN);
    }
    /**
     * Gets a named value from the user access token.
     *
     * @param accessToken your SSO access token where the value is encode
     * @param key Key name of the field to retrieve
     * @returns Value from the token
     */
    getValueFromToken(token, key) {
        let value;
        if (token) {
            const tokenPayload = this.decodeToken(token);
            value = tokenPayload[key];
        }
        return value;
    }
    /**
     * Gets realm roles.
     *
     * @returns Array of realm roles
     */
    getRealmRoles() {
        const access = this.getValueFromLocalAccessToken(JwtHelperService.REALM_ACCESS);
        return access ? access['roles'] : [];
    }
    /**
     * Gets Client roles.
     *
     * @returns Array of client roles
     */
    getClientRoles(clientName) {
        const clientRole = this.getValueFromLocalAccessToken(JwtHelperService.RESOURCE_ACCESS)[clientName];
        return clientRole ? clientRole['roles'] : [];
    }
    /**
     * Checks for single realm role.
     *
     * @param role Role name to check
     * @returns True if it contains given role, false otherwise
     */
    hasRealmRole(role) {
        let hasRole = false;
        if (this.getAccessToken()) {
            const realmRoles = this.getRealmRoles();
            hasRole = realmRoles.some((currentRole) => currentRole === role);
        }
        return hasRole;
    }
    /**
     * Checks for realm roles.
     *
     * @param rolesToCheck List of role names to check
     * @returns True if it contains at least one of the given roles, false otherwise
     */
    hasRealmRoles(rolesToCheck) {
        return rolesToCheck.some((currentRole) => this.hasRealmRole(currentRole));
    }
    /**
     * Checks for client roles.
     *
     * @param clientName Targeted client name
     * @param rolesToCheck List of role names to check
     * @returns True if it contains at least one of the given roles, false otherwise
     */
    hasRealmRolesForClientRole(clientName, rolesToCheck) {
        return rolesToCheck.some((currentRole) => this.hasClientRole(clientName, currentRole));
    }
    /**
     * Checks for client role.
     *
     * @param clientName Targeted client name
     * @param role Role name to check
     * @returns True if it contains given role, false otherwise
     */
    hasClientRole(clientName, role) {
        let hasRole = false;
        if (this.getAccessToken()) {
            const clientRoles = this.getClientRoles(clientName);
            hasRole = clientRoles.some((currentRole) => currentRole === role);
        }
        return hasRole;
    }
}
JwtHelperService.USER_NAME = 'name';
JwtHelperService.FAMILY_NAME = 'family_name';
JwtHelperService.GIVEN_NAME = 'given_name';
JwtHelperService.USER_EMAIL = 'email';
JwtHelperService.USER_ACCESS_TOKEN = 'access_token';
JwtHelperService.USER_ID_TOKEN = 'id_token';
JwtHelperService.REALM_ACCESS = 'realm_access';
JwtHelperService.RESOURCE_ACCESS = 'resource_access';
JwtHelperService.USER_PREFERRED_USERNAME = 'preferred_username';
JwtHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JwtHelperService, deps: [{ token: StorageService }], target: i0.ɵɵFactoryTarget.Injectable });
JwtHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JwtHelperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JwtHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: StorageService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CookieService {
    constructor() {
        this.cookieEnabled = false;
        // for certain scenarios Chrome may say 'true' but have cookies still disabled
        if (navigator.cookieEnabled === false) {
            this.cookieEnabled = false;
        }
        this.setItem('test-cookie', 'test');
        this.cookieEnabled = document.cookie.indexOf('test-cookie') >= 0;
        this.deleteCookie('test-cookie');
    }
    /**
     * Checks if cookies are enabled.
     *
     * @returns True if enabled, false otherwise
     */
    isEnabled() {
        return this.cookieEnabled;
    }
    /**
     * Retrieves a cookie by its key.
     *
     * @param key Key to identify the cookie
     * @returns The cookie data or null if it is not found
     */
    getItem(key) {
        const regexp = new RegExp('(?:' + key + '|;\s*' + key + ')=(.*?)(?:;|$)', 'g');
        const result = regexp.exec(document.cookie);
        return (result === null) ? null : result[1];
    }
    /**
     * Sets a cookie.
     *
     * @param key Key to identify the cookie
     * @param data Data value to set for the cookie
     * @param expiration Expiration date of the data
     * @param path "Pathname" to store the cookie
     */
    setItem(key, data, expiration = null, path = null) {
        document.cookie = `${key}=${data}` +
            (expiration ? ';expires=' + expiration.toUTCString() : '') +
            (path ? `;path=${path}` : ';path=/');
    }
    /**
     * Delete a cookie Key.
     *
     * @param key Key to identify the cookie
     * @param path "Pathname" to store the cookie
     */
    deleteCookie(key, path = null) {
        document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;' +
            (path ? `;path=${path}` : ';path=/');
    }
    /** Placeholder for testing purposes - do not use. */
    clear() {
        /* placeholder for testing purposes */
    }
}
CookieService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CookieService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const REMEMBER_ME_COOKIE_KEY = 'ALFRESCO_REMEMBER_ME';
const REMEMBER_ME_UNTIL = 1000 * 60 * 60 * 24 * 30;
class BaseAuthenticationService {
    constructor() {
        this.alfrescoApi = inject(AlfrescoApiService);
        this.appConfig = inject(AppConfigService);
        this.cookie = inject(CookieService);
        this.logService = inject(LogService);
        this.bearerExcludedUrls = ['resources/', 'assets/', 'auth/realms', 'idp/'];
        this.redirectUrl = null;
        this.onLogin = new ReplaySubject(1);
        this.onLogout = new ReplaySubject(1);
    }
    get peopleApi() {
        this._peopleApi = this._peopleApi ?? new PeopleApi(this.alfrescoApi.getInstance());
        return this._peopleApi;
    }
    get profileApi() {
        this._profileApi = this._profileApi ?? new UserProfileApi(this.alfrescoApi.getInstance());
        return this._profileApi;
    }
    getBearerExcludedUrls() {
        return this.bearerExcludedUrls;
    }
    /**
     * Adds the auth token to an HTTP header using the 'bearer' scheme.
     *
     * @param headersArg Header that will receive the token
     * @returns The new header with the token added
     */
    addTokenToHeader(headersArg) {
        return new Observable((observer) => {
            let headers = headersArg;
            if (!headers) {
                headers = new HttpHeaders();
            }
            try {
                const header = this.getAuthHeaders(headers);
                observer.next(header);
                observer.complete();
            }
            catch (error) {
                observer.error(error);
            }
        });
    }
    getAuthHeaders(header) {
        const authType = this.appConfig.get(AppConfigValues.AUTHTYPE, 'BASIC');
        switch (authType) {
            case 'OAUTH':
                return this.addBearerToken(header);
            case 'BASIC':
                return this.addBasicAuth(header);
            default:
                return header;
        }
    }
    addBearerToken(header) {
        const token = this.getToken();
        if (!token) {
            return header;
        }
        return header.set('Authorization', 'bearer ' + token);
    }
    addBasicAuth(header) {
        const ticket = this.getTicketEcmBase64();
        if (!ticket) {
            return header;
        }
        return header.set('Authorization', ticket);
    }
    /**
     * Gets the ECM username.
     *
     * @returns The ECM username
     */
    getEcmUsername() {
        return this.alfrescoApi.getInstance().getEcmUsername();
    }
    /**
     * Gets the BPM username
     *
     * @returns The BPM username
     */
    getBpmUsername() {
        return this.alfrescoApi.getInstance().getBpmUsername();
    }
    isPublicUrl() {
        return this.alfrescoApi.getInstance().isPublicUrl();
    }
    /**
     * Does the provider support ECM?
     *
     * @returns True if supported, false otherwise
     */
    isECMProvider() {
        return this.alfrescoApi.getInstance().isEcmConfiguration();
    }
    /**
     * Does the provider support BPM?
     *
     * @returns True if supported, false otherwise
     */
    isBPMProvider() {
        return this.alfrescoApi.getInstance().isBpmConfiguration();
    }
    /**
     * Does the provider support both ECM and BPM?
     *
     * @returns True if both are supported, false otherwise
     */
    isALLProvider() {
        return this.alfrescoApi.getInstance().isEcmBpmConfiguration();
    }
    /**
     * Gets the ECM ticket stored in the Storage.
     *
     * @returns The ticket or `null` if none was found
     */
    getTicketEcm() {
        return this.alfrescoApi.getInstance()?.getTicketEcm();
    }
    /**
     * Gets the BPM ticket stored in the Storage.
     *
     * @returns The ticket or `null` if none was found
     */
    getTicketBpm() {
        return this.alfrescoApi.getInstance()?.getTicketBpm();
    }
    /**
     * Gets the BPM ticket from the Storage in Base 64 format.
     *
     * @returns The ticket or `null` if none was found
     */
    getTicketEcmBase64() {
        const ticket = this.alfrescoApi.getInstance()?.getTicketEcm();
        if (ticket) {
            return 'Basic ' + btoa(ticket);
        }
        return null;
    }
    /**
     * Gets information about the user currently logged into APS.
     *
     * @returns User information
     */
    getBpmLoggedUser() {
        return from(this.profileApi.getProfile());
    }
    /**
     * Prints an error message in the console browser
     *
     * @param error Error message
     * @returns Object representing the error message
     */
    handleError(error) {
        this.logService.error('Error when logging in', error);
        return throwError(error || 'Server error');
    }
    /**
     * Does kerberos enabled?
     *
     * @returns True if enabled, false otherwise
     */
    isKerberosEnabled() {
        return this.appConfig.get(AppConfigValues.AUTH_WITH_CREDENTIALS, false);
    }
    /**
     * Saves the "remember me" cookie as either a long-life cookie or a session cookie.
     *
     * @param rememberMe Enables a long-life cookie
     */
    saveRememberMeCookie(rememberMe) {
        let expiration = null;
        if (rememberMe) {
            expiration = new Date();
            const time = expiration.getTime();
            const expireTime = time + REMEMBER_ME_UNTIL;
            expiration.setTime(expireTime);
        }
        this.cookie.setItem(REMEMBER_ME_COOKIE_KEY, '1', expiration, null);
    }
    /**
     * Checks whether the "remember me" cookie was set or not.
     *
     * @returns True if set, false otherwise
     */
    isRememberMeSet() {
        return this.cookie.getItem(REMEMBER_ME_COOKIE_KEY) !== null;
    }
    setRedirect(url) {
        this.redirectUrl = url;
    }
    /** Gets the URL to redirect to after login.
     *
     * @returns The redirect URL
     */
    getRedirect() {
        const provider = this.appConfig.get(AppConfigValues.PROVIDERS);
        return this.hasValidRedirection(provider) ? this.redirectUrl.url : null;
    }
    hasValidRedirection(provider) {
        return this.redirectUrl && (this.redirectUrl.provider === provider || this.hasSelectedProviderAll(provider));
    }
    hasSelectedProviderAll(provider) {
        return this.redirectUrl && (this.redirectUrl.provider === 'ALL' || provider === 'ALL');
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthenticationService extends BaseAuthenticationService {
    constructor() {
        super();
        this.storageService = inject(StorageService);
        this.supportCodeFlow = false;
        this.alfrescoApi.alfrescoApiInitialized.subscribe(() => {
            this.alfrescoApi.getInstance().reply('logged-in', () => {
                this.onLogin.next();
            });
        });
    }
    /**
     * Checks if the user logged in.
     *
     * @returns True if logged in, false otherwise
     */
    isLoggedIn() {
        if (!this.isOauth() && this.cookie.isEnabled() && !this.isRememberMeSet()) {
            return false;
        }
        return this.alfrescoApi.getInstance().isLoggedIn();
    }
    isLoggedInWith(provider) {
        if (provider === 'BPM') {
            return this.isBpmLoggedIn();
        }
        else if (provider === 'ECM') {
            return this.isEcmLoggedIn();
        }
        else {
            return this.isLoggedIn();
        }
    }
    /**
     * Does the provider support OAuth?
     *
     * @returns True if supported, false otherwise
     */
    isOauth() {
        return this.alfrescoApi.getInstance().isOauthConfiguration();
    }
    /**
     * Logs the user in.
     *
     * @param username Username for the login
     * @param password Password for the login
     * @param rememberMe Stores the user's login details if true
     * @returns Object with auth type ("ECM", "BPM" or "ALL") and auth ticket
     */
    login(username, password, rememberMe = false) {
        return from(this.alfrescoApi.getInstance().login(username, password)).pipe(map((response) => {
            this.saveRememberMeCookie(rememberMe);
            this.onLogin.next(response);
            return {
                type: this.appConfig.get(AppConfigValues.PROVIDERS),
                ticket: response
            };
        }), catchError((err) => this.handleError(err)));
    }
    /**
     * Logs the user in with SSO
     */
    ssoImplicitLogin() {
        this.alfrescoApi.getInstance().implicitLogin();
    }
    /**
     * Logs the user out.
     *
     * @returns Response event called when logout is complete
     */
    logout() {
        return from(this.callApiLogout()).pipe(tap((response) => {
            this.onLogout.next(response);
            return response;
        }), catchError((err) => this.handleError(err)));
    }
    callApiLogout() {
        if (this.alfrescoApi.getInstance()) {
            return this.alfrescoApi.getInstance().logout();
        }
        return Promise.resolve();
    }
    /**
     * Checks if the user is logged in on an ECM provider.
     *
     * @returns True if logged in, false otherwise
     */
    isEcmLoggedIn() {
        if (this.isECMProvider() || this.isALLProvider()) {
            if (!this.isOauth() && this.cookie.isEnabled() && !this.isRememberMeSet()) {
                return false;
            }
            return this.alfrescoApi.getInstance().isEcmLoggedIn();
        }
        return false;
    }
    /**
     * Checks if the user is logged in on a BPM provider.
     *
     * @returns True if logged in, false otherwise
     */
    isBpmLoggedIn() {
        if (this.isBPMProvider() || this.isALLProvider()) {
            if (!this.isOauth() && this.cookie.isEnabled() && !this.isRememberMeSet()) {
                return false;
            }
            return this.alfrescoApi.getInstance().isBpmLoggedIn();
        }
        return false;
    }
    isImplicitFlow() {
        return !!this.appConfig.oauth2?.implicitFlow;
    }
    isAuthCodeFlow() {
        return false;
    }
    /**
     * Gets the auth token.
     *
     * @returns Auth token string
     */
    getToken() {
        return this.storageService.getItem(JwtHelperService.USER_ACCESS_TOKEN);
    }
    reset() { }
}
AuthenticationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthenticationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AuthenticationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthenticationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthenticationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LogoutDirective {
    constructor(elementRef, renderer, router, appConfig, auth) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.router = router;
        this.appConfig = appConfig;
        this.auth = auth;
        /** Enable redirecting after logout */
        this.enableRedirect = true;
    }
    ngOnInit() {
        if (this.elementRef.nativeElement) {
            this.renderer.listen(this.elementRef.nativeElement, 'click', (evt) => {
                evt.preventDefault();
                this.logout();
            });
        }
    }
    getRedirectUri() {
        if (this.redirectUri === undefined) {
            return this.appConfig.get('loginRoute', '/login');
        }
        return this.redirectUri;
    }
    logout() {
        this.auth.logout().subscribe(() => this.redirectToUri(), () => this.redirectToUri());
    }
    redirectToUri() {
        if (this.enableRedirect && !this.auth.isOauth()) {
            const redirectRoute = this.getRedirectUri();
            this.router.navigate([redirectRoute]);
        }
    }
}
LogoutDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LogoutDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i2$4.Router }, { token: AppConfigService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Directive });
LogoutDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LogoutDirective, selector: "[adf-logout]", inputs: { redirectUri: "redirectUri", enableRedirect: "enableRedirect" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LogoutDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-logout]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i2$4.Router }, { type: AppConfigService }, { type: AuthenticationService }]; }, propDecorators: { redirectUri: [{
                type: Input
            }], enableRedirect: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadDirective {
    constructor(el, renderer, ngZone) {
        this.el = el;
        this.renderer = renderer;
        this.ngZone = ngZone;
        /** Enables/disables uploading. */
        this.enabled = true;
        /** Upload mode. Can be "drop" (receives dropped files) or "click"
         * (clicking opens a file dialog). Both modes can be active at once.
         */
        this.mode = ['drop']; // click|drop
        this.isDragging = false;
        this.cssClassName = 'adf-upload__dragging';
        this.element = el.nativeElement;
    }
    ngOnInit() {
        if (this.isClickMode() && this.renderer) {
            const inputUpload = this.renderer.createElement('input');
            this.upload = this.el.nativeElement.parentElement.appendChild(inputUpload);
            this.upload.type = 'file';
            this.upload.style.display = 'none';
            this.upload.addEventListener('change', (event) => this.onSelectFiles(event));
            if (this.multiple) {
                this.upload.setAttribute('multiple', '');
            }
            if (this.accept) {
                this.upload.setAttribute('accept', this.accept);
            }
            if (this.directory) {
                this.upload.setAttribute('webkitdirectory', '');
            }
        }
        if (this.isDropMode()) {
            this.ngZone.runOutsideAngular(() => {
                this.element.addEventListener('dragenter', this.onDragEnter.bind(this));
                this.element.addEventListener('dragover', this.onDragOver.bind(this));
                this.element.addEventListener('dragleave', this.onDragLeave.bind(this));
                this.element.addEventListener('drop', this.onDrop.bind(this));
            });
        }
    }
    ngOnDestroy() {
        this.element.removeEventListener('dragenter', this.onDragEnter);
        this.element.removeEventListener('dragover', this.onDragOver);
        this.element.removeEventListener('dragleave', this.onDragLeave);
        this.element.removeEventListener('drop', this.onDrop);
    }
    onClick(event) {
        if (this.isClickMode() && this.upload) {
            event.preventDefault();
            this.upload.click();
        }
    }
    onDragEnter(event) {
        if (this.isDropMode()) {
            event.dataTransfer.dropEffect = 'copy';
            this.element.classList.add(this.cssClassName);
            this.isDragging = true;
        }
    }
    onDragOver(event) {
        event.preventDefault();
        if (this.isDropMode()) {
            event.dataTransfer.dropEffect = 'copy';
            this.element.classList.add(this.cssClassName);
            this.isDragging = true;
        }
        return false;
    }
    onDragLeave() {
        if (this.isDropMode()) {
            this.element.classList.remove(this.cssClassName);
            this.isDragging = false;
        }
    }
    onDrop(event) {
        if (this.isDropMode()) {
            event.stopPropagation();
            event.preventDefault();
            this.element.classList.remove(this.cssClassName);
            this.isDragging = false;
            const dataTransfer = this.getDataTransfer(event);
            if (dataTransfer) {
                this.getFilesDropped(dataTransfer).then((files) => {
                    this.onUploadFiles(files);
                });
            }
        }
        return false;
    }
    onUploadFiles(files) {
        if (this.enabled && files.length > 0) {
            const customEvent = new CustomEvent('upload-files', {
                detail: {
                    sender: this,
                    data: this.data,
                    files
                },
                bubbles: true
            });
            this.el.nativeElement.dispatchEvent(customEvent);
        }
    }
    hasMode(mode) {
        return this.enabled && mode && this.mode && this.mode.indexOf(mode) > -1;
    }
    isDropMode() {
        return this.hasMode('drop');
    }
    isClickMode() {
        return this.hasMode('click');
    }
    getDataTransfer(event) {
        if (event && event.dataTransfer) {
            return event.dataTransfer;
        }
        if (event && event.originalEvent && event.originalEvent.dataTransfer) {
            return event.originalEvent.dataTransfer;
        }
        return null;
    }
    /**
     * Extract files from the DataTransfer object used to hold the data that is being dragged during a drag and drop operation.
     *
     * @param dataTransfer DataTransfer object
     */
    getFilesDropped(dataTransfer) {
        return new Promise((resolve) => {
            const iterations = [];
            if (dataTransfer) {
                const items = dataTransfer.items;
                if (items) {
                    for (let i = 0; i < items.length; i++) {
                        if (typeof items[i].webkitGetAsEntry !== 'undefined') {
                            const item = items[i].webkitGetAsEntry();
                            if (item) {
                                if (item.isFile) {
                                    iterations.push(Promise.resolve({
                                        entry: item,
                                        file: items[i].getAsFile(),
                                        relativeFolder: '/'
                                    }));
                                }
                                else if (item.isDirectory) {
                                    iterations.push(new Promise((resolveFolder) => {
                                        FileUtils.flatten(item).then((files) => resolveFolder(files));
                                    }));
                                }
                            }
                        }
                        else {
                            iterations.push(Promise.resolve({
                                entry: null,
                                file: items[i].getAsFile(),
                                relativeFolder: '/'
                            }));
                        }
                    }
                }
                else {
                    // safari or FF
                    const files = FileUtils
                        .toFileArray(dataTransfer.files)
                        .map((file) => ({
                        entry: null,
                        file,
                        relativeFolder: '/'
                    }));
                    iterations.push(Promise.resolve(files));
                }
            }
            Promise.all(iterations).then((result) => {
                resolve(result.reduce((a, b) => a.concat(b), []));
            });
        });
    }
    /**
     * Invoked when user selects files or folders by means of File Dialog
     *
     * @param event DOM event
     */
    onSelectFiles(event) {
        if (this.isClickMode()) {
            const input = event.currentTarget;
            const files = FileUtils.toFileArray(input.files);
            this.onUploadFiles(files.map((file) => ({
                entry: null,
                file,
                relativeFolder: '/'
            })));
            event.target.value = '';
        }
    }
}
UploadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
UploadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: UploadDirective, selector: "[adf-upload]", inputs: { enabled: ["adf-upload", "enabled"], data: ["adf-upload-data", "data"], mode: "mode", multiple: "multiple", accept: "accept", directory: "directory" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-upload]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { enabled: [{
                type: Input,
                args: ['adf-upload']
            }], data: [{
                type: Input,
                args: ['adf-upload-data']
            }], mode: [{
                type: Input
            }], multiple: [{
                type: Input
            }], accept: [{
                type: Input
            }], directory: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TooltipCardComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.image = '';
        this.text = '';
        this.htmlContent = '';
        this.width = '300';
    }
    sanitizedHtmlContent() {
        return this.sanitizer.sanitize(SecurityContext.HTML, this.htmlContent);
    }
}
TooltipCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TooltipCardComponent, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
TooltipCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TooltipCardComponent, selector: "adf-tooltip-card-component", inputs: { image: "image", text: "text", htmlContent: "htmlContent", width: "width" }, ngImport: i0, template: "<div @tooltip class=\"adf-tooltip-card\" [style.width.px]=\"width\">\n    <img *ngIf=\"image \" [src]=\"image\" [width]=\"width\" alt=\"{{text}}\">\n    <hr *ngIf=\"image\" />\n    <p *ngIf=\"text\">{{text}}</p>\n    <div *ngIf=\"htmlContent\" [innerHTML]=\"sanitizedHtmlContent()\" class=\"adf-tooltip-card-content\"></div>\n</div>\n", styles: [":host{display:block}div.adf-tooltip-card{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;background-color:var(--adf-theme-background-card-color);border:1px solid var(--theme-primary-color);padding:12px;border-radius:6px}div.adf-tooltip-card p,div.adf-tooltip-card div{font-size:var(--theme-caption-font-size);color:var(--adf-theme-foreground-text-color-075);margin:0}div.adf-tooltip-card hr{border:1px solid var(--theme-primary-color);margin:6px 0}div.adf-tooltip-card img{border-radius:6px}::ng-deep .cdk-overlay-connected-position-bounding-box{margin-top:10px!important}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
        trigger('tooltip', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(200, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate(200, style({ opacity: 0 }))
            ])
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TooltipCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tooltip-card-component', animations: [
                        trigger('tooltip', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate(200, style({ opacity: 1 }))
                            ]),
                            transition(':leave', [
                                animate(200, style({ opacity: 0 }))
                            ])
                        ])
                    ], template: "<div @tooltip class=\"adf-tooltip-card\" [style.width.px]=\"width\">\n    <img *ngIf=\"image \" [src]=\"image\" [width]=\"width\" alt=\"{{text}}\">\n    <hr *ngIf=\"image\" />\n    <p *ngIf=\"text\">{{text}}</p>\n    <div *ngIf=\"htmlContent\" [innerHTML]=\"sanitizedHtmlContent()\" class=\"adf-tooltip-card-content\"></div>\n</div>\n", styles: [":host{display:block}div.adf-tooltip-card{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;background-color:var(--adf-theme-background-card-color);border:1px solid var(--theme-primary-color);padding:12px;border-radius:6px}div.adf-tooltip-card p,div.adf-tooltip-card div{font-size:var(--theme-caption-font-size);color:var(--adf-theme-foreground-text-color-075);margin:0}div.adf-tooltip-card hr{border:1px solid var(--theme-primary-color);margin:6px 0}div.adf-tooltip-card img{border-radius:6px}::ng-deep .cdk-overlay-connected-position-bounding-box{margin-top:10px!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; }, propDecorators: { image: [{
                type: Input
            }], text: [{
                type: Input
            }], htmlContent: [{
                type: Input
            }], width: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TooltipCardDirective {
    constructor(overlay, overlayPositionBuilder, elementRef) {
        this.overlay = overlay;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.elementRef = elementRef;
        this.text = '';
        this.image = '';
        this.width = '300';
        this.htmlContent = '';
        this.originX = 'start';
        this.originY = 'top';
        this.overlayX = 'start';
        this.overlayY = 'bottom';
        this.offsetX = 0;
        this.offsetY = -8;
    }
    ngOnDestroy() {
        this.hide();
    }
    ngOnInit() {
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([{
                originX: this.originX,
                originY: this.originY,
                overlayX: this.overlayX,
                overlayY: this.overlayY,
                offsetY: this.offsetY,
                offsetX: this.offsetX
            }]);
        this.overlayRef = this.overlay.create({ positionStrategy });
    }
    show() {
        const tooltipRef = this.overlayRef.attach(new ComponentPortal(TooltipCardComponent));
        tooltipRef.instance.text = this.text;
        tooltipRef.instance.image = this.image;
        tooltipRef.instance.width = this.width;
        tooltipRef.instance.htmlContent = this.htmlContent;
    }
    hide() {
        this.overlayRef.detach();
    }
}
TooltipCardDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TooltipCardDirective, deps: [{ token: i1$5.Overlay }, { token: i1$5.OverlayPositionBuilder }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TooltipCardDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: TooltipCardDirective, selector: "[adf-tooltip-card]", inputs: { text: ["adf-tooltip-card", "text"], image: "image", width: "width", htmlContent: "htmlContent", originX: "originX", originY: "originY", overlayX: "overlayX", overlayY: "overlayY", offsetX: "offsetX", offsetY: "offsetY" }, host: { listeners: { "mouseenter": "show()", "mouseleave": "hide()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TooltipCardDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-tooltip-card]' }]
        }], ctorParameters: function () { return [{ type: i1$5.Overlay }, { type: i1$5.OverlayPositionBuilder }, { type: i0.ElementRef }]; }, propDecorators: { text: [{
                type: Input,
                args: ['adf-tooltip-card']
            }], image: [{
                type: Input
            }], width: [{
                type: Input
            }], htmlContent: [{
                type: Input
            }], originX: [{
                type: Input
            }], originY: [{
                type: Input
            }], overlayX: [{
                type: Input
            }], overlayY: [{
                type: Input
            }], offsetX: [{
                type: Input
            }], offsetY: [{
                type: Input
            }], show: [{
                type: HostListener,
                args: ['mouseenter']
            }], hide: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SELECT_ITEM_HEIGHT_EM = 3;
class InfiniteSelectScrollDirective {
    constructor(matSelect) {
        this.matSelect = matSelect;
        /** Emitted when scroll reaches the last item. */
        this.scrollEnd = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.itemHeightToWaitBeforeLoadNext = 0;
    }
    ngAfterViewInit() {
        this.matSelect.openedChange
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((opened) => {
            if (opened) {
                this.itemHeightToWaitBeforeLoadNext = (this.getItemHeight() * (InfiniteSelectScrollDirective.MAX_ITEMS / 2));
                this.matSelect.panel.nativeElement.addEventListener('scroll', (event) => this.handleScrollEvent(event));
            }
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    handleScrollEvent(event) {
        if (this.isScrollInNextFetchArea(event)) {
            this.scrollEnd.emit(event);
        }
    }
    isScrollInNextFetchArea(event) {
        const target = event.target;
        return target.scrollTop >= (target.scrollHeight - target.offsetHeight - this.itemHeightToWaitBeforeLoadNext);
    }
    getItemHeight() {
        return parseFloat(getComputedStyle(this.matSelect.panel.nativeElement).fontSize || '0') * SELECT_ITEM_HEIGHT_EM;
    }
}
InfiniteSelectScrollDirective.MAX_ITEMS = 50;
InfiniteSelectScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfiniteSelectScrollDirective, deps: [{ token: MatSelect }], target: i0.ɵɵFactoryTarget.Directive });
InfiniteSelectScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InfiniteSelectScrollDirective, selector: "[adf-infinite-select-scroll]", outputs: { scrollEnd: "scrollEnd" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfiniteSelectScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-infinite-select-scroll]'
                }]
        }], ctorParameters: function () { return [{ type: i1$6.MatSelect, decorators: [{
                    type: Inject,
                    args: [MatSelect]
                }] }]; }, propDecorators: { scrollEnd: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DirectiveModule {
}
DirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DirectiveModule, declarations: [HighlightDirective,
        LogoutDirective,
        UploadDirective,
        TooltipCardDirective,
        TooltipCardComponent,
        InfiniteSelectScrollDirective], imports: [CommonModule,
        MaterialModule,
        OverlayModule], exports: [HighlightDirective,
        LogoutDirective,
        UploadDirective,
        TooltipCardDirective,
        InfiniteSelectScrollDirective] });
DirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectiveModule, imports: [CommonModule,
        MaterialModule,
        OverlayModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        OverlayModule
                    ],
                    declarations: [
                        HighlightDirective,
                        LogoutDirective,
                        UploadDirective,
                        TooltipCardDirective,
                        TooltipCardComponent,
                        InfiniteSelectScrollDirective
                    ],
                    exports: [
                        HighlightDirective,
                        LogoutDirective,
                        UploadDirective,
                        TooltipCardDirective,
                        InfiniteSelectScrollDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ViewerModule {
}
ViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ViewerModule, declarations: [PdfPasswordDialogComponent,
        ViewerRenderComponent,
        ImgViewerComponent,
        TxtViewerComponent,
        MediaPlayerComponent,
        PdfViewerComponent,
        PdfThumbComponent,
        PdfThumbListComponent,
        ViewerExtensionDirective,
        UnknownFormatComponent,
        ViewerToolbarComponent,
        ViewerSidebarComponent,
        ViewerOpenWithComponent,
        ViewerMoreActionsComponent,
        ViewerToolbarActionsComponent,
        ViewerComponent,
        ViewerToolbarCustomActionsComponent,
        DownloadPromptDialogComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ToolbarModule,
        PipeModule,
        DirectiveModule,
        A11yModule,
        ExtensionsModule], exports: [ViewerRenderComponent,
        ImgViewerComponent,
        TxtViewerComponent,
        MediaPlayerComponent,
        PdfViewerComponent,
        PdfPasswordDialogComponent,
        PdfThumbComponent,
        PdfThumbListComponent,
        ViewerExtensionDirective,
        UnknownFormatComponent,
        ViewerToolbarComponent,
        ViewerSidebarComponent,
        ViewerOpenWithComponent,
        ViewerMoreActionsComponent,
        ViewerToolbarActionsComponent,
        ViewerComponent,
        ViewerToolbarCustomActionsComponent] });
ViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ToolbarModule,
        PipeModule,
        DirectiveModule,
        A11yModule,
        ExtensionsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ToolbarModule,
                        PipeModule,
                        DirectiveModule,
                        A11yModule,
                        ExtensionsModule
                    ],
                    declarations: [
                        PdfPasswordDialogComponent,
                        ViewerRenderComponent,
                        ImgViewerComponent,
                        TxtViewerComponent,
                        MediaPlayerComponent,
                        PdfViewerComponent,
                        PdfThumbComponent,
                        PdfThumbListComponent,
                        ViewerExtensionDirective,
                        UnknownFormatComponent,
                        ViewerToolbarComponent,
                        ViewerSidebarComponent,
                        ViewerOpenWithComponent,
                        ViewerMoreActionsComponent,
                        ViewerToolbarActionsComponent,
                        ViewerComponent,
                        ViewerToolbarCustomActionsComponent,
                        DownloadPromptDialogComponent
                    ],
                    exports: [
                        ViewerRenderComponent,
                        ImgViewerComponent,
                        TxtViewerComponent,
                        MediaPlayerComponent,
                        PdfViewerComponent,
                        PdfPasswordDialogComponent,
                        PdfThumbComponent,
                        PdfThumbListComponent,
                        ViewerExtensionDirective,
                        UnknownFormatComponent,
                        ViewerToolbarComponent,
                        ViewerSidebarComponent,
                        ViewerOpenWithComponent,
                        ViewerMoreActionsComponent,
                        ViewerToolbarActionsComponent,
                        ViewerComponent,
                        ViewerToolbarCustomActionsComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PaginationModel {
    constructor(input) {
        if (input) {
            this.count = input.count;
            this.hasMoreItems = input.hasMoreItems ? input.hasMoreItems : false;
            this.merge = input.merge ? input.merge : false;
            this.totalItems = input.totalItems;
            this.skipCount = input.skipCount;
            this.maxItems = input.maxItems;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_PAGINATION = {
    skipCount: 0,
    maxItems: 25,
    totalItems: 0,
    count: 0,
    hasMoreItems: false
};
class PaginationComponent {
    constructor(elementRef, renderer, cdr, userPreferencesService, translate) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdr = cdr;
        this.userPreferencesService = userPreferencesService;
        this.translate = translate;
        this._isEmpty = true;
        this._hasItems = false;
        /** Emitted when pagination changes in any way. */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        /** Emitted when the page number changes. */
        this.changePageNumber = new EventEmitter();
        /** Emitted when the page size changes. */
        this.changePageSize = new EventEmitter();
        /** Emitted when the next page is requested. */
        this.nextPage = new EventEmitter();
        /** Emitted when the previous page is requested. */
        this.prevPage = new EventEmitter();
        this.onDestroy$ = new Subject();
    }
    get pagination() {
        return this._pagination;
    }
    /** Pagination object. */
    set pagination(value) {
        value = value || DEFAULT_PAGINATION;
        this._pagination = value;
        this._hasItems = value && value.count > 0;
        this._isEmpty = !this.hasItems;
        // TODO: Angular 10 workaround for HostBinding bug
        if (this._isEmpty) {
            this.renderer.addClass(this.elementRef.nativeElement, 'adf-pagination__empty');
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, 'adf-pagination__empty');
        }
        this.cdr.detectChanges();
    }
    ngOnInit() {
        this.userPreferencesService
            .select(UserPreferenceValues.PaginationSize)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(maxItems => {
            this.pagination = {
                ...DEFAULT_PAGINATION,
                ...this.pagination,
                maxItems
            };
        });
        if (!this.supportedPageSizes) {
            this.supportedPageSizes = this.userPreferencesService.supportedPageSizes;
        }
        if (this.target) {
            this.target.pagination
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(pagination => {
                if (pagination.count === 0 && !this.isFirstPage) {
                    this.goPrevious();
                }
                this.pagination = {
                    ...pagination
                };
            });
        }
        if (!this.pagination) {
            this.pagination = {
                ...DEFAULT_PAGINATION
            };
        }
    }
    get lastPage() {
        const { maxItems, totalItems } = this.pagination;
        return (totalItems && maxItems)
            ? Math.ceil(totalItems / maxItems)
            : 1;
    }
    get current() {
        const { maxItems, skipCount } = this.pagination;
        return (skipCount && maxItems)
            ? Math.floor(skipCount / maxItems) + 1
            : 1;
    }
    get isLastPage() {
        if (!this.pagination.totalItems && this.pagination.hasMoreItems) {
            return false;
        }
        return this.current === this.lastPage;
    }
    get isFirstPage() {
        return this.current === 1;
    }
    get next() {
        return this.isLastPage ? this.current : this.current + 1;
    }
    get previous() {
        return this.isFirstPage ? 1 : this.current - 1;
    }
    get hasItems() {
        return this._hasItems;
    }
    // TODO: not working correctly in Angular 10
    // @HostBinding('class.adf-pagination__empty')
    get isEmpty() {
        return this._isEmpty;
    }
    get range() {
        const { skipCount, maxItems, totalItems } = this.pagination;
        let start = 0;
        if (totalItems || totalItems !== 0) {
            start = skipCount + 1;
        }
        const end = this.isLastPage ? totalItems : skipCount + maxItems;
        return [start, end];
    }
    get pages() {
        return Array(this.lastPage)
            .fill('n')
            .map((_, index) => (index + 1));
    }
    get limitedPages() {
        if (this.lastPage <= 100) {
            return this.pages;
        }
        const twentyItems = Array.from(Array(20));
        return [
            1,
            ...twentyItems.map((_, i) => this.current - i - 1).reverse(),
            this.current,
            ...twentyItems.map((_, i) => this.current + i + 1),
            this.lastPage
        ].filter((value, index, array) => value > 0 && value <= this.lastPage && !array.slice(0, index).includes(value));
    }
    get itemRangeText() {
        const rangeString = this.range.join('-');
        let translation = this.translate.instant('CORE.PAGINATION.ITEMS_RANGE', {
            range: rangeString,
            total: this.pagination.totalItems
        });
        if (!this.pagination.totalItems) {
            translation = translation.substr(0, translation.indexOf(rangeString) + rangeString.length);
        }
        return translation;
    }
    goNext() {
        if (this.hasItems) {
            const maxItems = this.pagination.maxItems;
            const skipCount = (this.next - 1) * maxItems;
            this.pagination = {
                ...this.pagination,
                skipCount
            };
            this.handlePaginationEvent('NEXT_PAGE');
        }
    }
    goPrevious() {
        if (this.hasItems) {
            const maxItems = this.pagination.maxItems;
            const skipCount = (this.previous - 1) * maxItems;
            this.pagination = {
                ...this.pagination,
                skipCount
            };
            this.handlePaginationEvent('PREV_PAGE');
        }
    }
    onChangePageNumber(pageNumber) {
        if (this.hasItems) {
            const maxItems = this.pagination.maxItems;
            const skipCount = (pageNumber - 1) * maxItems;
            this.pagination = {
                ...this.pagination,
                skipCount
            };
            this.handlePaginationEvent('CHANGE_PAGE_NUMBER');
        }
    }
    onChangePageSize(maxItems) {
        this.pagination = {
            ...this.pagination,
            skipCount: 0,
            maxItems
        };
        this.userPreferencesService.paginationSize = maxItems;
        this.handlePaginationEvent('CHANGE_PAGE_SIZE');
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    handlePaginationEvent(action) {
        const paginationModel = { ...this.pagination };
        if (action === 'NEXT_PAGE') {
            this.nextPage.emit(paginationModel);
        }
        if (action === 'PREV_PAGE') {
            this.prevPage.emit(paginationModel);
        }
        if (action === 'CHANGE_PAGE_NUMBER') {
            this.changePageNumber.emit(paginationModel);
        }
        if (action === 'CHANGE_PAGE_SIZE') {
            this.changePageSize.emit(paginationModel);
        }
        this.change.emit(paginationModel);
        if (this.target) {
            this.target.updatePagination(paginationModel);
        }
    }
}
PaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PaginationComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: UserPreferencesService }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
PaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PaginationComponent, selector: "adf-pagination", inputs: { target: "target", supportedPageSizes: "supportedPageSizes", pagination: "pagination" }, outputs: { change: "change", changePageNumber: "changePageNumber", changePageSize: "changePageSize", nextPage: "nextPage", prevPage: "prevPage" }, host: { classAttribute: "adf-pagination" }, ngImport: i0, template: "<ng-container *ngIf=\"hasItems\">\n    <div class=\"adf-pagination__block adf-pagination__range-block\" aria-live=\"polite\">\n        <span class=\"adf-pagination__range\">\n            {{ itemRangeText }}\n        </span>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__perpage-block\">\n        <span>\n            {{ 'CORE.PAGINATION.ITEMS_PER_PAGE' | translate }}\n        </span>\n\n        <span class=\"adf-pagination__max-items\">\n            {{ pagination.maxItems }}\n        </span>\n\n        <button\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.ITEMS_PER_PAGE' | translate\"\n            [matMenuTriggerFor]=\"pageSizeMenu\">\n            <mat-icon>arrow_drop_down</mat-icon>\n        </button>\n\n        <mat-menu #pageSizeMenu=\"matMenu\" class=\"adf-pagination__page-selector\">\n            <button\n                mat-menu-item\n                *ngFor=\"let pageSize of supportedPageSizes\"\n                (click)=\"onChangePageSize(pageSize)\">\n                {{ pageSize }}\n            </button>\n        </mat-menu>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__actualinfo-block\">\n        <span class=\"adf-pagination__current-page\">\n            {{ 'CORE.PAGINATION.CURRENT_PAGE' | translate: { number: current } }}\n        </span>\n\n        <button\n            mat-icon-button\n            data-automation-id=\"page-selector\"\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.CURRENT_PAGE' | translate\"\n            [matMenuTriggerFor]=\"pagesMenu\"\n            *ngIf=\"lastPage > 1\">\n            <mat-icon>arrow_drop_down</mat-icon>\n        </button>\n\n        <div *ngIf=\"pagination.totalItems\">\n            <span class=\"adf-pagination__total-pages\">\n                {{ 'CORE.PAGINATION.TOTAL_PAGES' | translate: { total: lastPage } }}\n            </span>\n        </div>\n\n        <mat-menu #pagesMenu=\"matMenu\" class=\"adf-pagination__page-selector\">\n            <button\n                mat-menu-item\n                *ngFor=\"let pageNumber of limitedPages\"\n                (click)=\"onChangePageNumber(pageNumber)\">\n                {{ pageNumber }}\n            </button>\n        </mat-menu>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__controls-block\">\n        <button\n            class=\"adf-pagination__previous-button\"\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.PREVIOUS_PAGE' | translate\"\n            [disabled]=\"isFirstPage\"\n            (click)=\"goPrevious()\">\n            <mat-icon>keyboard_arrow_left</mat-icon>\n        </button>\n\n        <button\n            class=\"adf-pagination__next-button\"\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.NEXT_PAGE' | translate\"\n            [disabled]=\"isLastPage\"\n            (click)=\"goNext()\">\n            <mat-icon>keyboard_arrow_right</mat-icon>\n        </button>\n    </div>\n</ng-container>\n", styles: [".adf-pagination{display:flex;border-top:none;height:48px;line-height:20px;color:var(--adf-theme-foreground-text-color)}.adf-pagination__block{display:flex;align-items:center;padding:0 8px;border-right:none}.adf-pagination__block:first-child{flex:1 1 auto;padding-left:24px}.adf-pagination__block:last-child{border-right-width:0}@media (max-width: 599.9px){.adf-pagination{flex-wrap:wrap;padding:0 16px;justify-content:space-between}.adf-pagination__range-block,.adf-pagination__perpage-block{display:none}.adf-pagination__actualinfo-block{border-right:none}.adf-pagination__controls-block{padding-right:0}}.adf-pagination__max-items{margin-left:10px}.adf-pagination__max-items,.adf-pagination__current-page{margin-right:5px}.adf-pagination__max-items,.adf-pagination__max-items+button,.adf-pagination__current-page,.adf-pagination__current-page+button{color:var(--adf-theme-foreground-text-color)}.adf-pagination__max-items+button,.adf-pagination__current-page+button{margin-left:-10px}.adf-pagination__previous-button,.adf-pagination__next-button{margin:0 5px}.adf-pagination__page-selector{max-height:250px!important}.adf-pagination.adf-pagination__empty{border-top:none;height:48px}.adf-pagination button[mat-icon-button]{width:32px;height:32px;line-height:32px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-pagination', host: { class: 'adf-pagination' }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"hasItems\">\n    <div class=\"adf-pagination__block adf-pagination__range-block\" aria-live=\"polite\">\n        <span class=\"adf-pagination__range\">\n            {{ itemRangeText }}\n        </span>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__perpage-block\">\n        <span>\n            {{ 'CORE.PAGINATION.ITEMS_PER_PAGE' | translate }}\n        </span>\n\n        <span class=\"adf-pagination__max-items\">\n            {{ pagination.maxItems }}\n        </span>\n\n        <button\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.ITEMS_PER_PAGE' | translate\"\n            [matMenuTriggerFor]=\"pageSizeMenu\">\n            <mat-icon>arrow_drop_down</mat-icon>\n        </button>\n\n        <mat-menu #pageSizeMenu=\"matMenu\" class=\"adf-pagination__page-selector\">\n            <button\n                mat-menu-item\n                *ngFor=\"let pageSize of supportedPageSizes\"\n                (click)=\"onChangePageSize(pageSize)\">\n                {{ pageSize }}\n            </button>\n        </mat-menu>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__actualinfo-block\">\n        <span class=\"adf-pagination__current-page\">\n            {{ 'CORE.PAGINATION.CURRENT_PAGE' | translate: { number: current } }}\n        </span>\n\n        <button\n            mat-icon-button\n            data-automation-id=\"page-selector\"\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.CURRENT_PAGE' | translate\"\n            [matMenuTriggerFor]=\"pagesMenu\"\n            *ngIf=\"lastPage > 1\">\n            <mat-icon>arrow_drop_down</mat-icon>\n        </button>\n\n        <div *ngIf=\"pagination.totalItems\">\n            <span class=\"adf-pagination__total-pages\">\n                {{ 'CORE.PAGINATION.TOTAL_PAGES' | translate: { total: lastPage } }}\n            </span>\n        </div>\n\n        <mat-menu #pagesMenu=\"matMenu\" class=\"adf-pagination__page-selector\">\n            <button\n                mat-menu-item\n                *ngFor=\"let pageNumber of limitedPages\"\n                (click)=\"onChangePageNumber(pageNumber)\">\n                {{ pageNumber }}\n            </button>\n        </mat-menu>\n    </div>\n\n    <div class=\"adf-pagination__block adf-pagination__controls-block\">\n        <button\n            class=\"adf-pagination__previous-button\"\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.PREVIOUS_PAGE' | translate\"\n            [disabled]=\"isFirstPage\"\n            (click)=\"goPrevious()\">\n            <mat-icon>keyboard_arrow_left</mat-icon>\n        </button>\n\n        <button\n            class=\"adf-pagination__next-button\"\n            mat-icon-button\n            [attr.aria-label]=\"'CORE.PAGINATION.ARIA.NEXT_PAGE' | translate\"\n            [disabled]=\"isLastPage\"\n            (click)=\"goNext()\">\n            <mat-icon>keyboard_arrow_right</mat-icon>\n        </button>\n    </div>\n</ng-container>\n", styles: [".adf-pagination{display:flex;border-top:none;height:48px;line-height:20px;color:var(--adf-theme-foreground-text-color)}.adf-pagination__block{display:flex;align-items:center;padding:0 8px;border-right:none}.adf-pagination__block:first-child{flex:1 1 auto;padding-left:24px}.adf-pagination__block:last-child{border-right-width:0}@media (max-width: 599.9px){.adf-pagination{flex-wrap:wrap;padding:0 16px;justify-content:space-between}.adf-pagination__range-block,.adf-pagination__perpage-block{display:none}.adf-pagination__actualinfo-block{border-right:none}.adf-pagination__controls-block{padding-right:0}}.adf-pagination__max-items{margin-left:10px}.adf-pagination__max-items,.adf-pagination__current-page{margin-right:5px}.adf-pagination__max-items,.adf-pagination__max-items+button,.adf-pagination__current-page,.adf-pagination__current-page+button{color:var(--adf-theme-foreground-text-color)}.adf-pagination__max-items+button,.adf-pagination__current-page+button{margin-left:-10px}.adf-pagination__previous-button,.adf-pagination__next-button{margin:0 5px}.adf-pagination__page-selector{max-height:250px!important}.adf-pagination.adf-pagination__empty{border-top:none;height:48px}.adf-pagination button[mat-icon-button]{width:32px;height:32px;line-height:32px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: UserPreferencesService }, { type: i3.TranslateService }]; }, propDecorators: { target: [{
                type: Input
            }], supportedPageSizes: [{
                type: Input
            }], pagination: [{
                type: Input
            }], change: [{
                type: Output
            }], changePageNumber: [{
                type: Output
            }], changePageSize: [{
                type: Output
            }], nextPage: [{
                type: Output
            }], prevPage: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InfinitePaginationComponent {
    constructor(cdr, userPreferencesService) {
        this.cdr = cdr;
        this.userPreferencesService = userPreferencesService;
        this.onDestroy$ = new Subject();
        /** Is a new page loading? */
        this.isLoading = false;
        /** Emitted when the "Load More" button is clicked. */
        this.loadMore = new EventEmitter();
        this.pagination = InfinitePaginationComponent.DEFAULT_PAGINATION;
        this.requestPaginationModel = {
            skipCount: 0,
            merge: true
        };
    }
    /** Component that provides custom pagination support. */
    set target(target) {
        if (target) {
            this._target = target;
            target.pagination
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(pagination => {
                this.isLoading = false;
                this.pagination = pagination;
                if (!this.pagination.hasMoreItems) {
                    this.pagination.hasMoreItems = false;
                }
                this.cdr.detectChanges();
            });
        }
    }
    get target() {
        return this._target;
    }
    ngOnInit() {
        this.userPreferencesService
            .select(UserPreferenceValues.PaginationSize)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((pageSize) => {
            this.pageSize = this.pageSize || pageSize;
            this.requestPaginationModel.maxItems = this.pageSize;
        });
    }
    onLoadMore() {
        this.requestPaginationModel.skipCount = 0;
        this.requestPaginationModel.merge = false;
        this.requestPaginationModel.maxItems += this.pageSize;
        this.loadMore.next(this.requestPaginationModel);
        if (this._target) {
            this.isLoading = true;
            this._target.updatePagination(this.requestPaginationModel);
        }
    }
    reset() {
        this.pagination.skipCount = 0;
        this.pagination.maxItems = this.pageSize;
        if (this._target) {
            this._target.updatePagination(this.pagination);
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
InfinitePaginationComponent.DEFAULT_PAGINATION = new PaginationModel({
    skipCount: 0,
    maxItems: 25,
    totalItems: 0
});
InfinitePaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfinitePaginationComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
InfinitePaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InfinitePaginationComponent, selector: "adf-infinite-pagination", inputs: { target: "target", pageSize: "pageSize", isLoading: ["loading", "isLoading"] }, outputs: { loadMore: "loadMore" }, host: { classAttribute: "infinite-adf-pagination" }, ngImport: i0, template: "<div *ngIf=\"pagination?.hasMoreItems || isLoading\" class=\"adf-infinite-pagination\">\n\n    <button mat-button\n        *ngIf=\"!isLoading\"\n        class=\"adf-infinite-pagination-load-more\"\n        (click)=\"onLoadMore()\"\n        data-automation-id=\"adf-infinite-pagination-button\">\n            <ng-content></ng-content>\n    </button>\n\n    <mat-progress-bar *ngIf=\"isLoading\"\n        mode=\"indeterminate\"\n        class=\"adf-infinite-pagination-spinner\"\n        data-automation-id=\"adf-infinite-pagination-spinner\"\n        [attr.aria-label]=\"'DATA_LOADING' | translate\"></mat-progress-bar>\n</div>\n", styles: [".adf-infinite-pagination{display:flex;justify-content:space-around;min-height:56px}.adf-infinite-pagination-load-more{margin-bottom:10px;margin-top:10px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i8.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfinitePaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-infinite-pagination', host: { class: 'infinite-adf-pagination' }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"pagination?.hasMoreItems || isLoading\" class=\"adf-infinite-pagination\">\n\n    <button mat-button\n        *ngIf=\"!isLoading\"\n        class=\"adf-infinite-pagination-load-more\"\n        (click)=\"onLoadMore()\"\n        data-automation-id=\"adf-infinite-pagination-button\">\n            <ng-content></ng-content>\n    </button>\n\n    <mat-progress-bar *ngIf=\"isLoading\"\n        mode=\"indeterminate\"\n        class=\"adf-infinite-pagination-spinner\"\n        data-automation-id=\"adf-infinite-pagination-spinner\"\n        [attr.aria-label]=\"'DATA_LOADING' | translate\"></mat-progress-bar>\n</div>\n", styles: [".adf-infinite-pagination{display:flex;justify-content:space-around;min-height:56px}.adf-infinite-pagination-load-more{margin-bottom:10px;margin-top:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: UserPreferencesService }]; }, propDecorators: { target: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], isLoading: [{
                type: Input,
                args: ['loading']
            }], loadMore: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PaginationModule {
}
PaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: PaginationModule, declarations: [InfinitePaginationComponent,
        PaginationComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule], exports: [InfinitePaginationComponent,
        PaginationComponent] });
PaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PaginationModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule
                    ],
                    declarations: [
                        InfinitePaginationComponent,
                        PaginationComponent
                    ],
                    exports: [
                        InfinitePaginationComponent,
                        PaginationComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginErrorEvent {
    constructor(err) {
        this.err = err;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginSubmitEvent {
    constructor(_values) {
        this._defaultPrevented = false;
        this._values = _values;
    }
    get values() {
        return this._values;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    preventDefault() {
        this._defaultPrevented = true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginSuccessEvent {
    constructor(token, username, password) {
        this.token = token;
        this.username = username;
        this.password = password;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var LoginSteps;
(function (LoginSteps) {
    LoginSteps[LoginSteps["Landing"] = 0] = "Landing";
    LoginSteps[LoginSteps["Checking"] = 1] = "Checking";
    LoginSteps[LoginSteps["Welcome"] = 2] = "Welcome";
})(LoginSteps || (LoginSteps = {}));
class LoginComponent {
    constructor(_fb, authService, translateService, router, appConfig, userPreferences, route, sanitizer, alfrescoApiService) {
        this._fb = _fb;
        this.authService = authService;
        this.translateService = translateService;
        this.router = router;
        this.appConfig = appConfig;
        this.userPreferences = userPreferences;
        this.route = route;
        this.sanitizer = sanitizer;
        this.alfrescoApiService = alfrescoApiService;
        this.isPasswordShow = false;
        /**
         * Should the `Remember me` checkbox be shown? When selected, this
         * option will remember the logged-in user after the browser is closed
         * to avoid logging in repeatedly.
         */
        this.showRememberMe = true;
        /** Should the extra actions (`Need Help`, `Register`, etc) be shown? */
        this.showLoginActions = true;
        /** Sets the URL of the NEED HELP link in the footer. */
        this.needHelpLink = '';
        /** Sets the URL of the REGISTER link in the footer. */
        this.registerLink = '';
        /** Path to a custom logo image. */
        this.logoImageUrl = './assets/images/alfresco-logo.svg';
        /** Path to a custom background image. */
        this.backgroundImageUrl = './assets/images/background.svg';
        /** The copyright text below the login box. */
        this.copyrightText = '\u00A9 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.';
        /** Route to redirect to on successful login. */
        this.successRoute = null;
        /** Emitted when the login is successful. */
        this.success = new EventEmitter();
        /** Emitted when the login fails. */
        this.error = new EventEmitter();
        /** Emitted when the login form is submitted. */
        this.executeSubmit = new EventEmitter();
        this.implicitFlow = false;
        this.isError = false;
        this.actualLoginStep = LoginSteps.Landing;
        this.LoginSteps = LoginSteps;
        this.rememberMe = true;
        this.minLength = 2;
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.initFormError();
        this.initFormFieldsDefault();
        this.initFormFieldsMessages();
        this.successRoute = this.appConfig.get('successRoute', this.successRoute);
        if (this.authService.isLoggedIn()) {
            this.router.navigate([this.successRoute]);
        }
        else {
            if (this.authService.isOauth()) {
                const oauth = this.appConfig.oauth2;
                if (oauth && oauth.silentLogin) {
                    this.redirectToImplicitLogin();
                }
                else if (oauth && oauth.implicitFlow) {
                    this.implicitFlow = true;
                }
            }
            this.route.queryParams.subscribe((params) => {
                const url = params['redirectUrl'];
                const provider = this.appConfig.get(AppConfigValues.PROVIDERS);
                this.authService.setRedirect({ provider, url });
            });
        }
        if (this.fieldsValidation) {
            this.form = this._fb.group(this.fieldsValidation);
        }
        this.form.valueChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(data => this.onValueChanged(data));
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    submit() {
        this.onSubmit(this.form.value);
    }
    redirectToImplicitLogin() {
        this.alfrescoApiService.getInstance().oauth2Auth.implicitLogin();
    }
    /**
     * Method called on submit form
     *
     * @param values
     * @param event
     */
    onSubmit(values) {
        this.disableError();
        const args = new LoginSubmitEvent({
            controls: { username: this.form.controls.username }
        });
        this.executeSubmit.emit(args);
        if (!args.defaultPrevented) {
            this.actualLoginStep = LoginSteps.Checking;
            this.performLogin(values);
        }
    }
    implicitLogin() {
        if (this.authService.isLoggedIn()) {
            this.router.navigate([this.successRoute]);
        }
        this.authService.ssoImplicitLogin();
    }
    /**
     * The method check the error in the form and push the error in the formError object
     *
     * @param data
     */
    onValueChanged(data) {
        this.disableError();
        for (const field in this.formError) {
            if (field) {
                this.formError[field] = '';
                const hasError = (this.form.controls[field].errors && data[field] !== '') ||
                    (this.form.controls[field].dirty &&
                        !this.form.controls[field].valid);
                if (hasError) {
                    for (const key in this.form.controls[field].errors) {
                        if (key) {
                            const message = this._message[field][key];
                            if (message && message.value) {
                                const translated = this.translateService.instant(message.value, message.params);
                                this.formError[field] += translated;
                            }
                        }
                    }
                }
            }
        }
    }
    performLogin(values) {
        this.authService
            .login(values.username, values.password, this.rememberMe)
            .subscribe((token) => {
            const redirectUrl = this.authService.getRedirect();
            this.actualLoginStep = LoginSteps.Welcome;
            this.userPreferences.setStoragePrefix(values.username);
            values.password = null;
            this.success.emit(new LoginSuccessEvent(token, values.username, null));
            if (redirectUrl) {
                this.authService.setRedirect(null);
                this.router.navigateByUrl(redirectUrl);
            }
            else if (this.successRoute) {
                this.router.navigate([this.successRoute]);
            }
        }, (err) => {
            this.actualLoginStep = LoginSteps.Landing;
            this.displayErrorMessage(err);
            this.isError = true;
            this.error.emit(new LoginErrorEvent(err));
        });
    }
    /**
     * Check and display the right error message in the UI
     */
    displayErrorMessage(err) {
        if (err.error &&
            err.error.crossDomain &&
            err.error.message.indexOf('Access-Control-Allow-Origin') !== -1) {
            this.errorMsg = err.error.message;
        }
        else if (err.status === 403 &&
            err.message.indexOf('Invalid CSRF-token') !== -1) {
            this.errorMsg = 'LOGIN.MESSAGES.LOGIN-ERROR-CSRF';
        }
        else if (err.status === 403 &&
            err.message.indexOf('The system is currently in read-only mode') !==
                -1) {
            this.errorMsg = 'LOGIN.MESSAGES.LOGIN-ECM-LICENSE';
        }
        else {
            this.errorMsg = 'LOGIN.MESSAGES.LOGIN-ERROR-CREDENTIALS';
        }
    }
    /**
     * Add a custom form error for a field
     *
     * @param field
     * @param msg
     */
    addCustomFormError(field, msg) {
        this.formError[field] += msg;
    }
    /**
     * Add a custom validation rule error for a field
     *
     * @param field
     * @param ruleId - i.e. required | minlength | maxlength
     * @param msg
     */
    addCustomValidationError(field, ruleId, msg, params) {
        this._message[field][ruleId] = {
            value: msg,
            params
        };
    }
    /**
     * Display and hide the password value.
     */
    toggleShowPassword(event) {
        event.stopPropagation();
        this.isPasswordShow = !this.isPasswordShow;
    }
    /**
     * The method return if a field is valid or not
     *
     * @param field
     */
    isErrorStyle(field) {
        return !field.valid && field.dirty && !field.pristine;
    }
    /**
     * Trim username
     */
    trimUsername(event) {
        event.target.value = event.target.value.trim();
    }
    getBackgroundUrlImageUrl() {
        return this.sanitizer.bypassSecurityTrustStyle(`url(${this.backgroundImageUrl})`);
    }
    /**
     * Default formError values
     */
    initFormError() {
        this.formError = {
            username: '',
            password: ''
        };
    }
    /**
     * Init form fields messages
     */
    initFormFieldsMessages() {
        this._message = {
            username: {
                required: {
                    value: 'LOGIN.MESSAGES.USERNAME-REQUIRED'
                },
                minlength: {
                    value: 'LOGIN.MESSAGES.USERNAME-MIN',
                    params: {
                        minLength: this.minLength
                    }
                }
            },
            password: {
                required: {
                    value: 'LOGIN.MESSAGES.PASSWORD-REQUIRED'
                }
            }
        };
    }
    initFormFieldsDefault() {
        this.form = this._fb.group({
            username: ['', Validators.compose([Validators.required, Validators.minLength(this.minLength)])],
            password: ['', Validators.required]
        });
    }
    /**
     * Disable the error flag
     */
    disableError() {
        this.isError = false;
        this.initFormError();
    }
}
LoginComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginComponent, deps: [{ token: i7.UntypedFormBuilder }, { token: AuthenticationService }, { token: TranslationService }, { token: i2$4.Router }, { token: AppConfigService }, { token: UserPreferencesService }, { token: i2$4.ActivatedRoute }, { token: i1$2.DomSanitizer }, { token: AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Component });
LoginComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LoginComponent, selector: "adf-login", inputs: { showRememberMe: "showRememberMe", showLoginActions: "showLoginActions", needHelpLink: "needHelpLink", registerLink: "registerLink", logoImageUrl: "logoImageUrl", backgroundImageUrl: "backgroundImageUrl", copyrightText: "copyrightText", fieldsValidation: "fieldsValidation", successRoute: "successRoute" }, outputs: { success: "success", error: "error", executeSubmit: "executeSubmit" }, host: { classAttribute: "adf-login" }, ngImport: i0, template: "<div class=\"adf-login-content\" [style.background-image]=\"getBackgroundUrlImageUrl()\">\n    <div class=\"adf-ie11FixerParent\">\n        <div class=\"adf-ie11FixerChild\">\n\n            <mat-card class=\"adf-login-card-wide\">\n                <form \n                    id=\"adf-login-form\"\n                    [formGroup]=\"form\"\n                    autocomplete=\"off\"\n                    (submit)=\"onSubmit(form.value)\">\n                    <mat-card-header>\n                        <mat-card-title>\n                            <div class=\"adf-alfresco-logo\">\n                                <!--HEADER TEMPLATE-->\n                                <ng-template \n                                    *ngIf=\"headerTemplate\"\n                                    ngFor\n                                    [ngForOf]=\"[data]\"\n                                    [ngForTemplate]=\"headerTemplate\">\n                                </ng-template>\n                                <img \n                                    *ngIf=\"!headerTemplate\"\n                                    id=\"adf-login-img-logo\"\n                                    class=\"adf-img-logo\"\n                                    [src]=\"logoImageUrl\"\n                                    alt=\"{{'LOGIN.LOGO' | translate }}\">\n                            </div>\n                        </mat-card-title>\n                    </mat-card-header>\n\n                    <mat-card-content class=\"adf-login-controls\">\n\n                        <!--ERRORS AREA-->\n                        <div class=\"adf-error-container\">\n                            <div\n                                *ngIf=\"isError\"\n                                id=\"login-error\"\n                                data-automation-id=\"login-error\"\n                                class=\"adf-error  adf-error-message\">\n                                <mat-icon class=\"adf-error-icon\">warning</mat-icon>\n                                <span class=\"adf-login-error-message\">\n                                    {{errorMsg | translate }}\n                                </span>\n                            </div>\n                        </div>\n\n                        <div *ngIf=\"!implicitFlow\">\n\n                            <!--USERNAME FIELD-->\n                            <div \n                                class=\"adf-login__field\"\n                                [ngClass]=\"{'adf-is-invalid': isErrorStyle(form.controls.username)}\">\n                                <mat-form-field\n                                    class=\"adf-full-width\"\n                                    floatPlaceholder=\"never\"\n                                    color=\"primary\">\n                                    <input\n                                        matInput\n                                        type=\"text\"\n                                        class=\"adf-full-width\"\n                                        formControlName=\"username\"\n                                        id=\"username\"\n                                        data-automation-id=\"username\"\n                                        placeholder=\"{{'LOGIN.LABEL.USERNAME' | translate }}\"\n                                        autocapitalize=\"none\"\n                                        (blur)=\"trimUsername($event)\">\n                                </mat-form-field>\n                                <span\n                                    *ngIf=\"formError['username']\"\n                                    class=\"adf-login-validation\"\n                                    for=\"username\">\n                                    <span\n                                        id=\"username-error\"\n                                        class=\"adf-login-error\"\n                                        data-automation-id=\"username-error\">\n                                            {{formError['username'] | translate}}\n                                    </span>\n                                </span>\n                            </div>\n\n                            <!--PASSWORD FIELD-->\n                            <div class=\"adf-login__field\">\n                                <mat-form-field\n                                    class=\"adf-full-width\"\n                                    floatPlaceholder=\"never\"\n                                    color=\"primary\">\n                                        <input\n                                            matInput\n                                            placeholder=\"{{'LOGIN.LABEL.PASSWORD' | translate }}\"\n                                            [type]=\"isPasswordShow ? 'text' : 'password'\"\n                                            formControlName=\"password\"\n                                            id=\"password\"\n                                            data-automation-id=\"password\">\n                                        <button\n                                            matSuffix\n                                            mat-icon-button\n                                            type=\"button\"\n                                            [attr.aria-label]=\"(isPasswordShow ? 'LOGIN.ARIA-LABEL.HIDE-PASSWORD' : 'LOGIN.ARIA-LABEL.SHOW-PASSWORD') | translate\"\n                                            (click)=\"toggleShowPassword($event)\"\n                                            (keyup.enter)=\"toggleShowPassword($event)\"\n                                            [attr.data-automation-id]=\"isPasswordShow ? 'hide_password' : 'show_password'\">\n                                                <mat-icon class=\"adf-login-password-icon\">\n                                                    {{ isPasswordShow ? 'visibility' : 'visibility_off' }}\n                                                </mat-icon>\n                                        </button>\n                                </mat-form-field>\n                                <span\n                                    class=\"adf-login-validation\"\n                                    for=\"password\"\n                                    *ngIf=\"formError['password']\">\n                                        <span\n                                            id=\"password-required\"\n                                            class=\"adf-login-error\"\n                                            data-automation-id=\"password-required\">\n                                                {{formError['password'] | translate}}\n                                        </span>\n                                </span>\n                            </div>\n\n                            <!--CUSTOM CONTENT-->\n                            <ng-content></ng-content>\n\n                            <br>\n                            <button\n                                type=\"submit\"\n                                id=\"login-button\"\n                                class=\"adf-login-button\"\n                                mat-raised-button\n                                color=\"accent\"\n                                [class.adf-isChecking]=\"actualLoginStep === LoginSteps.Checking\"\n                                [class.adf-isWelcome]=\"actualLoginStep === LoginSteps.Welcome\"\n                                data-automation-id=\"login-button\"\n                                [disabled]=\"!form.valid\"\n                                [attr.aria-label]=\"'LOGIN.BUTTON.LOGIN' | translate\">\n                                    <span\n                                        *ngIf=\"actualLoginStep === LoginSteps.Landing\"\n                                        class=\"adf-login-button-label\">\n                                            {{'LOGIN.BUTTON.LOGIN' | translate }}\n                                    </span>\n                                    <div \n                                        *ngIf=\"actualLoginStep === LoginSteps.Checking\"\n                                        class=\"adf-interactive-login-label\">\n                                            <span class=\"adf-login-button-label\">\n                                                {{ 'LOGIN.BUTTON.CHECKING' | translate}}\n                                            </span>\n                                            <div class=\"adf-login-spinner-container\">\n                                                <mat-spinner \n                                                    id=\"checking-spinner\"\n                                                    class=\"adf-login-checking-spinner\"\n                                                    [diameter]=\"25\">\n                                                </mat-spinner>\n                                            </div>\n                                    </div>\n                                    <div\n                                        *ngIf=\"actualLoginStep === LoginSteps.Welcome\"\n                                        class=\"adf-interactive-login-label\">\n                                            <span class=\"adf-login-button-label\">{{ 'LOGIN.BUTTON.WELCOME' | translate }}</span>\n                                            <mat-icon class=\"adf-welcome-icon\">done</mat-icon>\n                                    </div>\n                            </button>\n                            <div *ngIf=\"showRememberMe\" class=\"adf-login__remember-me\">\n                                <mat-checkbox\n                                    id=\"adf-login-remember\"\n                                    color=\"primary\"\n                                    class=\"adf-login-remember-me\"\n                                    [checked]=\"rememberMe\"\n                                    (change)=\"rememberMe = !rememberMe\">\n                                        {{ 'LOGIN.LABEL.REMEMBER' | translate }}\n                                </mat-checkbox>\n                            </div>\n                        </div>\n                        <div *ngIf=\"implicitFlow\">\n                            <button\n                                type=\"button\"\n                                (click)=\"implicitLogin()\"\n                                id=\"login-button-sso\"\n                                [attr.aria-label]=\"'LOGIN.BUTTON.SSO' | translate\"\n                                class=\"adf-login-button\"\n                                mat-raised-button color=\"primary\"\n                                data-automation-id=\"login-button-sso\">\n                                    <span class=\"adf-login-button-label\">{{ 'LOGIN.BUTTON.SSO' | translate }}</span>\n                            </button>\n                        </div>\n                    </mat-card-content>\n\n                    <mat-card-actions *ngIf=\"footerTemplate || showLoginActions\">\n\n                        <div class=\"adf-login-action-container\">\n                            <!--FOOTER TEMPLATE-->\n                            <ng-template\n                                *ngIf=\"footerTemplate\"\n                                ngFor\n                                [ngForOf]=\"[data]\"\n                                [ngForTemplate]=\"footerTemplate\">\n                            </ng-template>\n                            <div class=\"adf-login-action\" *ngIf=\"!footerTemplate && showLoginActions\">\n                                <div id=\"adf-login-action-left\" class=\"adf-login-action-left\">\n                                    <a href=\"{{needHelpLink}}\">{{'LOGIN.ACTION.HELP' | translate }}</a>\n                                </div>\n                                <div id=\"adf-login-action-right\" class=\"adf-login-action-right\">\n                                    <a href=\"{{registerLink}}\">{{'LOGIN.ACTION.REGISTER' | translate }}</a>\n                                </div>\n                            </div>\n                        </div>\n                    </mat-card-actions>\n                </form>\n            </mat-card>\n\n            <div class=\"adf-copyright\" data-automation-id=\"login-copyright\">\n                {{ copyrightText }}\n            </div>\n\n        </div>\n    </div>\n</div>\n", styles: [".adf-login{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-login-content{background-size:cover;background-position:center;min-height:100%;min-width:320px;display:flex;justify-content:center;flex-direction:column}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.adf-login-content{display:table;width:100%;height:100%}}.adf-login-content .adf-ie11FixerParent{margin-top:16px;min-width:320px}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.adf-login-content .adf-ie11FixerParent{display:table-cell;vertical-align:middle;width:100%;padding-top:16px}}.adf-login-content .adf-ie11FixerChild{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.adf-login-content .adf-show{display:block!important}.adf-login-content .adf-hide{display:none!important}.adf-login-content .adf-icon-inline{position:absolute;display:block;top:31%;left:82%;width:30px;overflow:hidden}.adf-login-content .adf-login-card-wide{border-radius:8px;background-color:var(--adf-theme-background-dialog-color);box-shadow:0 2px 2px #0000003d,0 0 2px #0000001f;width:450px;min-width:320px;padding:21px 64px 34px;box-sizing:border-box}@media (max-width: 482px){.adf-login-content .adf-login-card-wide{width:calc(100% - 32px)}}.adf-login-content .adf-error-container{height:45px}.adf-login-content .adf-error-message{display:flex;flex-direction:row;justify-content:flex-start;color:var(--theme-warn-color);padding:0;margin-bottom:4px;font-size:var(--theme-caption-font-size)}.adf-login-content .adf-error-message .adf-error-icon{margin-right:10px}.adf-login-content .mat-card-header-text{margin:0 auto}.adf-login-content .adf-img-logo{display:block;margin-left:auto;margin-right:auto}.adf-login-content .adf-alfresco-logo{padding:24px 16px}.adf-login-content .adf-alfresco-logo img{max-height:58px}.adf-login-content .adf-login-button{width:100%;height:36px;line-height:normal;box-shadow:none}.adf-login-content .adf-login-button .mat-button-wrapper{display:inline-flex}.adf-login-content .adf-login-button-label{color:var(--theme-accent-color-default-contrast)}.adf-login-content .adf-login-button.adf-isChecking{background-color:#e0f7fa}.adf-login-content .adf-login-button.adf-isChecking .adf-login-button-label{color:var(--theme-primary-color)}.adf-login-content .adf-login-button.adf-isWelcome{background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast)}.adf-login-content .adf-login-button.adf-isWelcome .adf-welcome-icon{margin:5px 0 0 10px}.adf-login-content .adf-interactive-login-label{display:flex;flex-direction:row;line-height:38px;justify-content:center}.adf-login-content .adf-login-spinner-container{margin-left:15px;margin-top:5px}.adf-login-content .adf-login-checking-spinner>svg>circle{stroke-width:16%!important}.adf-login-content .adf-login-controls{padding:0 0 26px;overflow:visible;width:100%}.adf-login-content .adf-login-action{margin-top:20px;display:flex;flex-direction:row;justify-content:space-between}.adf-login-content .adf-login-action-left a,.adf-login-content .adf-login-action-right a{text-decoration:none}.adf-login-content .adf-is-active{background-color:transparent;font-size:var(--theme-caption-font-size);font-weight:400;line-height:1.33;color:var(--theme-warn-color)}.adf-login-content .adf-copyright{min-width:320px;text-align:center;padding:16px 0;font-size:var(--theme-caption-font-size);opacity:.54}.adf-login-content .mat-form-field .adf-login-password-icon.mat-icon{color:var(--adf-theme-foreground-text-color)}.adf-login-content .adf-login__field .mat-form-field-wrapper{margin:1em 0 0;font-size:var(--theme-subheading-2-font-size)}.adf-login-content .adf-login__field input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px var(--adf-theme-background-dialog-color) inset;-webkit-text-fill-color:var(--adf-theme-foreground-text-color)!important}.adf-login-content .adf-login-validation{background-color:transparent;color:var(--theme-warn-color);font-size:var(--theme-caption-font-size)}.adf-login-content .adf-login-error{color:var(--theme-warn-color);position:absolute;font-size:var(--theme-caption-font-size);margin-top:-12px;display:block}.adf-login-content .adf-full-width{width:100%}.adf-login-content .adf-login__remember-me{padding-top:22px}.adf-login-content .adf-login__remember-me .mat-checkbox-label{opacity:.87}.adf-login-content .adf-login__field{display:block;margin-left:auto;margin-right:auto;padding-bottom:18px}.adf-login-content .adf-login-remember-me{color:var(--adf-theme-foreground-text-color)!important}.adf-login-content .adf-login-action-container{border-top:1px solid rgba(0,0,0,.1);margin-top:23px}\n"], dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i10.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "component", type: i10.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i10.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i10.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "directive", type: i10.MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { kind: "component", type: i2$5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i5.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i7.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i7.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i7.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-login', encapsulation: ViewEncapsulation.None, host: { class: 'adf-login' }, template: "<div class=\"adf-login-content\" [style.background-image]=\"getBackgroundUrlImageUrl()\">\n    <div class=\"adf-ie11FixerParent\">\n        <div class=\"adf-ie11FixerChild\">\n\n            <mat-card class=\"adf-login-card-wide\">\n                <form \n                    id=\"adf-login-form\"\n                    [formGroup]=\"form\"\n                    autocomplete=\"off\"\n                    (submit)=\"onSubmit(form.value)\">\n                    <mat-card-header>\n                        <mat-card-title>\n                            <div class=\"adf-alfresco-logo\">\n                                <!--HEADER TEMPLATE-->\n                                <ng-template \n                                    *ngIf=\"headerTemplate\"\n                                    ngFor\n                                    [ngForOf]=\"[data]\"\n                                    [ngForTemplate]=\"headerTemplate\">\n                                </ng-template>\n                                <img \n                                    *ngIf=\"!headerTemplate\"\n                                    id=\"adf-login-img-logo\"\n                                    class=\"adf-img-logo\"\n                                    [src]=\"logoImageUrl\"\n                                    alt=\"{{'LOGIN.LOGO' | translate }}\">\n                            </div>\n                        </mat-card-title>\n                    </mat-card-header>\n\n                    <mat-card-content class=\"adf-login-controls\">\n\n                        <!--ERRORS AREA-->\n                        <div class=\"adf-error-container\">\n                            <div\n                                *ngIf=\"isError\"\n                                id=\"login-error\"\n                                data-automation-id=\"login-error\"\n                                class=\"adf-error  adf-error-message\">\n                                <mat-icon class=\"adf-error-icon\">warning</mat-icon>\n                                <span class=\"adf-login-error-message\">\n                                    {{errorMsg | translate }}\n                                </span>\n                            </div>\n                        </div>\n\n                        <div *ngIf=\"!implicitFlow\">\n\n                            <!--USERNAME FIELD-->\n                            <div \n                                class=\"adf-login__field\"\n                                [ngClass]=\"{'adf-is-invalid': isErrorStyle(form.controls.username)}\">\n                                <mat-form-field\n                                    class=\"adf-full-width\"\n                                    floatPlaceholder=\"never\"\n                                    color=\"primary\">\n                                    <input\n                                        matInput\n                                        type=\"text\"\n                                        class=\"adf-full-width\"\n                                        formControlName=\"username\"\n                                        id=\"username\"\n                                        data-automation-id=\"username\"\n                                        placeholder=\"{{'LOGIN.LABEL.USERNAME' | translate }}\"\n                                        autocapitalize=\"none\"\n                                        (blur)=\"trimUsername($event)\">\n                                </mat-form-field>\n                                <span\n                                    *ngIf=\"formError['username']\"\n                                    class=\"adf-login-validation\"\n                                    for=\"username\">\n                                    <span\n                                        id=\"username-error\"\n                                        class=\"adf-login-error\"\n                                        data-automation-id=\"username-error\">\n                                            {{formError['username'] | translate}}\n                                    </span>\n                                </span>\n                            </div>\n\n                            <!--PASSWORD FIELD-->\n                            <div class=\"adf-login__field\">\n                                <mat-form-field\n                                    class=\"adf-full-width\"\n                                    floatPlaceholder=\"never\"\n                                    color=\"primary\">\n                                        <input\n                                            matInput\n                                            placeholder=\"{{'LOGIN.LABEL.PASSWORD' | translate }}\"\n                                            [type]=\"isPasswordShow ? 'text' : 'password'\"\n                                            formControlName=\"password\"\n                                            id=\"password\"\n                                            data-automation-id=\"password\">\n                                        <button\n                                            matSuffix\n                                            mat-icon-button\n                                            type=\"button\"\n                                            [attr.aria-label]=\"(isPasswordShow ? 'LOGIN.ARIA-LABEL.HIDE-PASSWORD' : 'LOGIN.ARIA-LABEL.SHOW-PASSWORD') | translate\"\n                                            (click)=\"toggleShowPassword($event)\"\n                                            (keyup.enter)=\"toggleShowPassword($event)\"\n                                            [attr.data-automation-id]=\"isPasswordShow ? 'hide_password' : 'show_password'\">\n                                                <mat-icon class=\"adf-login-password-icon\">\n                                                    {{ isPasswordShow ? 'visibility' : 'visibility_off' }}\n                                                </mat-icon>\n                                        </button>\n                                </mat-form-field>\n                                <span\n                                    class=\"adf-login-validation\"\n                                    for=\"password\"\n                                    *ngIf=\"formError['password']\">\n                                        <span\n                                            id=\"password-required\"\n                                            class=\"adf-login-error\"\n                                            data-automation-id=\"password-required\">\n                                                {{formError['password'] | translate}}\n                                        </span>\n                                </span>\n                            </div>\n\n                            <!--CUSTOM CONTENT-->\n                            <ng-content></ng-content>\n\n                            <br>\n                            <button\n                                type=\"submit\"\n                                id=\"login-button\"\n                                class=\"adf-login-button\"\n                                mat-raised-button\n                                color=\"accent\"\n                                [class.adf-isChecking]=\"actualLoginStep === LoginSteps.Checking\"\n                                [class.adf-isWelcome]=\"actualLoginStep === LoginSteps.Welcome\"\n                                data-automation-id=\"login-button\"\n                                [disabled]=\"!form.valid\"\n                                [attr.aria-label]=\"'LOGIN.BUTTON.LOGIN' | translate\">\n                                    <span\n                                        *ngIf=\"actualLoginStep === LoginSteps.Landing\"\n                                        class=\"adf-login-button-label\">\n                                            {{'LOGIN.BUTTON.LOGIN' | translate }}\n                                    </span>\n                                    <div \n                                        *ngIf=\"actualLoginStep === LoginSteps.Checking\"\n                                        class=\"adf-interactive-login-label\">\n                                            <span class=\"adf-login-button-label\">\n                                                {{ 'LOGIN.BUTTON.CHECKING' | translate}}\n                                            </span>\n                                            <div class=\"adf-login-spinner-container\">\n                                                <mat-spinner \n                                                    id=\"checking-spinner\"\n                                                    class=\"adf-login-checking-spinner\"\n                                                    [diameter]=\"25\">\n                                                </mat-spinner>\n                                            </div>\n                                    </div>\n                                    <div\n                                        *ngIf=\"actualLoginStep === LoginSteps.Welcome\"\n                                        class=\"adf-interactive-login-label\">\n                                            <span class=\"adf-login-button-label\">{{ 'LOGIN.BUTTON.WELCOME' | translate }}</span>\n                                            <mat-icon class=\"adf-welcome-icon\">done</mat-icon>\n                                    </div>\n                            </button>\n                            <div *ngIf=\"showRememberMe\" class=\"adf-login__remember-me\">\n                                <mat-checkbox\n                                    id=\"adf-login-remember\"\n                                    color=\"primary\"\n                                    class=\"adf-login-remember-me\"\n                                    [checked]=\"rememberMe\"\n                                    (change)=\"rememberMe = !rememberMe\">\n                                        {{ 'LOGIN.LABEL.REMEMBER' | translate }}\n                                </mat-checkbox>\n                            </div>\n                        </div>\n                        <div *ngIf=\"implicitFlow\">\n                            <button\n                                type=\"button\"\n                                (click)=\"implicitLogin()\"\n                                id=\"login-button-sso\"\n                                [attr.aria-label]=\"'LOGIN.BUTTON.SSO' | translate\"\n                                class=\"adf-login-button\"\n                                mat-raised-button color=\"primary\"\n                                data-automation-id=\"login-button-sso\">\n                                    <span class=\"adf-login-button-label\">{{ 'LOGIN.BUTTON.SSO' | translate }}</span>\n                            </button>\n                        </div>\n                    </mat-card-content>\n\n                    <mat-card-actions *ngIf=\"footerTemplate || showLoginActions\">\n\n                        <div class=\"adf-login-action-container\">\n                            <!--FOOTER TEMPLATE-->\n                            <ng-template\n                                *ngIf=\"footerTemplate\"\n                                ngFor\n                                [ngForOf]=\"[data]\"\n                                [ngForTemplate]=\"footerTemplate\">\n                            </ng-template>\n                            <div class=\"adf-login-action\" *ngIf=\"!footerTemplate && showLoginActions\">\n                                <div id=\"adf-login-action-left\" class=\"adf-login-action-left\">\n                                    <a href=\"{{needHelpLink}}\">{{'LOGIN.ACTION.HELP' | translate }}</a>\n                                </div>\n                                <div id=\"adf-login-action-right\" class=\"adf-login-action-right\">\n                                    <a href=\"{{registerLink}}\">{{'LOGIN.ACTION.REGISTER' | translate }}</a>\n                                </div>\n                            </div>\n                        </div>\n                    </mat-card-actions>\n                </form>\n            </mat-card>\n\n            <div class=\"adf-copyright\" data-automation-id=\"login-copyright\">\n                {{ copyrightText }}\n            </div>\n\n        </div>\n    </div>\n</div>\n", styles: [".adf-login{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-login-content{background-size:cover;background-position:center;min-height:100%;min-width:320px;display:flex;justify-content:center;flex-direction:column}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.adf-login-content{display:table;width:100%;height:100%}}.adf-login-content .adf-ie11FixerParent{margin-top:16px;min-width:320px}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.adf-login-content .adf-ie11FixerParent{display:table-cell;vertical-align:middle;width:100%;padding-top:16px}}.adf-login-content .adf-ie11FixerChild{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.adf-login-content .adf-show{display:block!important}.adf-login-content .adf-hide{display:none!important}.adf-login-content .adf-icon-inline{position:absolute;display:block;top:31%;left:82%;width:30px;overflow:hidden}.adf-login-content .adf-login-card-wide{border-radius:8px;background-color:var(--adf-theme-background-dialog-color);box-shadow:0 2px 2px #0000003d,0 0 2px #0000001f;width:450px;min-width:320px;padding:21px 64px 34px;box-sizing:border-box}@media (max-width: 482px){.adf-login-content .adf-login-card-wide{width:calc(100% - 32px)}}.adf-login-content .adf-error-container{height:45px}.adf-login-content .adf-error-message{display:flex;flex-direction:row;justify-content:flex-start;color:var(--theme-warn-color);padding:0;margin-bottom:4px;font-size:var(--theme-caption-font-size)}.adf-login-content .adf-error-message .adf-error-icon{margin-right:10px}.adf-login-content .mat-card-header-text{margin:0 auto}.adf-login-content .adf-img-logo{display:block;margin-left:auto;margin-right:auto}.adf-login-content .adf-alfresco-logo{padding:24px 16px}.adf-login-content .adf-alfresco-logo img{max-height:58px}.adf-login-content .adf-login-button{width:100%;height:36px;line-height:normal;box-shadow:none}.adf-login-content .adf-login-button .mat-button-wrapper{display:inline-flex}.adf-login-content .adf-login-button-label{color:var(--theme-accent-color-default-contrast)}.adf-login-content .adf-login-button.adf-isChecking{background-color:#e0f7fa}.adf-login-content .adf-login-button.adf-isChecking .adf-login-button-label{color:var(--theme-primary-color)}.adf-login-content .adf-login-button.adf-isWelcome{background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast)}.adf-login-content .adf-login-button.adf-isWelcome .adf-welcome-icon{margin:5px 0 0 10px}.adf-login-content .adf-interactive-login-label{display:flex;flex-direction:row;line-height:38px;justify-content:center}.adf-login-content .adf-login-spinner-container{margin-left:15px;margin-top:5px}.adf-login-content .adf-login-checking-spinner>svg>circle{stroke-width:16%!important}.adf-login-content .adf-login-controls{padding:0 0 26px;overflow:visible;width:100%}.adf-login-content .adf-login-action{margin-top:20px;display:flex;flex-direction:row;justify-content:space-between}.adf-login-content .adf-login-action-left a,.adf-login-content .adf-login-action-right a{text-decoration:none}.adf-login-content .adf-is-active{background-color:transparent;font-size:var(--theme-caption-font-size);font-weight:400;line-height:1.33;color:var(--theme-warn-color)}.adf-login-content .adf-copyright{min-width:320px;text-align:center;padding:16px 0;font-size:var(--theme-caption-font-size);opacity:.54}.adf-login-content .mat-form-field .adf-login-password-icon.mat-icon{color:var(--adf-theme-foreground-text-color)}.adf-login-content .adf-login__field .mat-form-field-wrapper{margin:1em 0 0;font-size:var(--theme-subheading-2-font-size)}.adf-login-content .adf-login__field input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px var(--adf-theme-background-dialog-color) inset;-webkit-text-fill-color:var(--adf-theme-foreground-text-color)!important}.adf-login-content .adf-login-validation{background-color:transparent;color:var(--theme-warn-color);font-size:var(--theme-caption-font-size)}.adf-login-content .adf-login-error{color:var(--theme-warn-color);position:absolute;font-size:var(--theme-caption-font-size);margin-top:-12px;display:block}.adf-login-content .adf-full-width{width:100%}.adf-login-content .adf-login__remember-me{padding-top:22px}.adf-login-content .adf-login__remember-me .mat-checkbox-label{opacity:.87}.adf-login-content .adf-login__field{display:block;margin-left:auto;margin-right:auto;padding-bottom:18px}.adf-login-content .adf-login-remember-me{color:var(--adf-theme-foreground-text-color)!important}.adf-login-content .adf-login-action-container{border-top:1px solid rgba(0,0,0,.1);margin-top:23px}\n"] }]
        }], ctorParameters: function () { return [{ type: i7.UntypedFormBuilder }, { type: AuthenticationService }, { type: TranslationService }, { type: i2$4.Router }, { type: AppConfigService }, { type: UserPreferencesService }, { type: i2$4.ActivatedRoute }, { type: i1$2.DomSanitizer }, { type: AlfrescoApiService }]; }, propDecorators: { showRememberMe: [{
                type: Input
            }], showLoginActions: [{
                type: Input
            }], needHelpLink: [{
                type: Input
            }], registerLink: [{
                type: Input
            }], logoImageUrl: [{
                type: Input
            }], backgroundImageUrl: [{
                type: Input
            }], copyrightText: [{
                type: Input
            }], fieldsValidation: [{
                type: Input
            }], successRoute: [{
                type: Input
            }], success: [{
                type: Output
            }], error: [{
                type: Output
            }], executeSubmit: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class LoginHeaderDirective {
    constructor(alfrescoLoginComponent) {
        this.alfrescoLoginComponent = alfrescoLoginComponent;
    }
    ngAfterContentInit() {
        this.alfrescoLoginComponent.headerTemplate = this.template;
    }
}
LoginHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginHeaderDirective, deps: [{ token: LoginComponent }], target: i0.ɵɵFactoryTarget.Directive });
LoginHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LoginHeaderDirective, selector: "adf-login-header, login-header", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-login-header, login-header'
                }]
        }], ctorParameters: function () { return [{ type: LoginComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class LoginFooterDirective {
    constructor(alfrescoLoginComponent) {
        this.alfrescoLoginComponent = alfrescoLoginComponent;
    }
    ngAfterContentInit() {
        this.alfrescoLoginComponent.footerTemplate = this.template;
    }
}
LoginFooterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginFooterDirective, deps: [{ token: LoginComponent }], target: i0.ɵɵFactoryTarget.Directive });
LoginFooterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LoginFooterDirective, selector: "adf-login-footer, login-footer", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-login-footer, login-footer'
                }]
        }], ctorParameters: function () { return [{ type: LoginComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginDialogPanelComponent {
    constructor() {
        /** Emitted when the login succeeds. */
        this.success = new EventEmitter();
    }
    submitForm() {
        this.login.submit();
    }
    onLoginSuccess(event) {
        this.success.emit(event);
    }
    isValid() {
        return this.login && this.login.form ? this.login.form.valid : false;
    }
}
LoginDialogPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginDialogPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoginDialogPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LoginDialogPanelComponent, selector: "adf-login-dialog-panel", outputs: { success: "success" }, viewQueries: [{ propertyName: "login", first: true, predicate: ["adfLogin"], descendants: true, static: true }], ngImport: i0, template: "<div>\n    <adf-login #adfLogin\n               class=\"adf-panel-login-dialog-component\"\n               [showRememberMe]=\"false\"\n               [showLoginActions]=\"false\"\n               [backgroundImageUrl]=\"''\"\n               (success)=\"onLoginSuccess($event)\">\n        <adf-login-header><ng-template></ng-template></adf-login-header>\n        <adf-login-footer><ng-template></ng-template></adf-login-footer>\n    </adf-login>\n</div>\n", styles: [".adf-panel-login-dialog-component .adf-login-content .mat-card-actions,.adf-panel-login-dialog-component .adf-login-content .adf-login-button,.adf-panel-login-dialog-component .adf-login-content .adf-login__remember-me,.adf-panel-login-dialog-component .adf-login-content .adf-copyright{display:none}\n"], dependencies: [{ kind: "component", type: LoginComponent, selector: "adf-login", inputs: ["showRememberMe", "showLoginActions", "needHelpLink", "registerLink", "logoImageUrl", "backgroundImageUrl", "copyrightText", "fieldsValidation", "successRoute"], outputs: ["success", "error", "executeSubmit"] }, { kind: "directive", type: LoginFooterDirective, selector: "adf-login-footer, login-footer" }, { kind: "directive", type: LoginHeaderDirective, selector: "adf-login-header, login-header" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginDialogPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-login-dialog-panel', encapsulation: ViewEncapsulation.None, template: "<div>\n    <adf-login #adfLogin\n               class=\"adf-panel-login-dialog-component\"\n               [showRememberMe]=\"false\"\n               [showLoginActions]=\"false\"\n               [backgroundImageUrl]=\"''\"\n               (success)=\"onLoginSuccess($event)\">\n        <adf-login-header><ng-template></ng-template></adf-login-header>\n        <adf-login-footer><ng-template></ng-template></adf-login-footer>\n    </adf-login>\n</div>\n", styles: [".adf-panel-login-dialog-component .adf-login-content .mat-card-actions,.adf-panel-login-dialog-component .adf-login-content .adf-login-button,.adf-panel-login-dialog-component .adf-login-content .adf-login__remember-me,.adf-panel-login-dialog-component .adf-login-content .adf-copyright{display:none}\n"] }]
        }], propDecorators: { success: [{
                type: Output
            }], login: [{
                type: ViewChild,
                args: ['adfLogin', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginDialogComponent {
    constructor(data) {
        this.data = data;
        this.buttonActionName = '';
        this.buttonActionName = data.actionName ? `LOGIN.DIALOG.${data.actionName.toUpperCase()}` : 'LOGIN.DIALOG.CHOOSE';
    }
    close() {
        this.data.logged.complete();
    }
    submitForm() {
        this.loginPanel.submitForm();
    }
    onLoginSuccess(event) {
        this.data.logged.next(event);
        this.close();
    }
    isFormValid() {
        return this.loginPanel ? this.loginPanel.isValid() : false;
    }
}
LoginDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginDialogComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
LoginDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LoginDialogComponent, selector: "adf-login-dialog", viewQueries: [{ propertyName: "loginPanel", first: true, predicate: ["adfLoginPanel"], descendants: true, static: true }], ngImport: i0, template: "<header\n    mat-dialog-title\n    data-automation-id=\"login-dialog-title\">\n        {{data?.title}}\n</header>\n\n<mat-dialog-content class=\"adf-login-dialog-content\">\n    <adf-login-dialog-panel #adfLoginPanel (success)=\"onLoginSuccess($event)\">\n    </adf-login-dialog-panel>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button (click)=\"close()\" \n        data-automation-id=\"login-dialog-actions-cancel\">\n            {{ 'LOGIN.DIALOG.CANCEL' | translate }}\n    </button>\n\n    <button\n        mat-button\n        class=\"choose-action\"\n        data-automation-id=\"login-dialog-actions-perform\"\n        [disabled]=\"!isFormValid()\"\n        (click)=\"submitForm()\">\n            {{ buttonActionName | translate}}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-login-dialog-content adf-login .adf-login-content .adf-login-card-wide{padding:0;box-shadow:none}\n"], dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$4.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: LoginDialogPanelComponent, selector: "adf-login-dialog-panel", outputs: ["success"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-login-dialog', encapsulation: ViewEncapsulation.None, template: "<header\n    mat-dialog-title\n    data-automation-id=\"login-dialog-title\">\n        {{data?.title}}\n</header>\n\n<mat-dialog-content class=\"adf-login-dialog-content\">\n    <adf-login-dialog-panel #adfLoginPanel (success)=\"onLoginSuccess($event)\">\n    </adf-login-dialog-panel>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button (click)=\"close()\" \n        data-automation-id=\"login-dialog-actions-cancel\">\n            {{ 'LOGIN.DIALOG.CANCEL' | translate }}\n    </button>\n\n    <button\n        mat-button\n        class=\"choose-action\"\n        data-automation-id=\"login-dialog-actions-perform\"\n        [disabled]=\"!isFormValid()\"\n        (click)=\"submitForm()\">\n            {{ buttonActionName | translate}}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-login-dialog-content adf-login .adf-login-content .adf-login-card-wide{padding:0;box-shadow:none}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { loginPanel: [{
                type: ViewChild,
                args: ['adfLoginPanel', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LoginModule {
}
LoginModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LoginModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: LoginModule, declarations: [LoginComponent,
        LoginFooterDirective,
        LoginHeaderDirective,
        LoginDialogComponent,
        LoginDialogPanelComponent], imports: [RouterModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        TranslateModule], exports: [LoginComponent,
        LoginFooterDirective,
        LoginHeaderDirective,
        LoginDialogComponent,
        LoginDialogPanelComponent] });
LoginModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginModule, imports: [RouterModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoginModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule,
                        MaterialModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CommonModule,
                        TranslateModule
                    ],
                    declarations: [
                        LoginComponent,
                        LoginFooterDirective,
                        LoginHeaderDirective,
                        LoginDialogComponent,
                        LoginDialogPanelComponent
                    ],
                    exports: [
                        LoginComponent,
                        LoginFooterDirective,
                        LoginHeaderDirective,
                        LoginDialogComponent,
                        LoginDialogPanelComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class LanguageService {
    constructor(appConfigService, userPreferencesService) {
        this.userPreferencesService = userPreferencesService;
        this.languages = new BehaviorSubject([
            { key: 'de', label: 'Deutsch' },
            { key: 'en', label: 'English' },
            { key: 'es', label: 'Español' },
            { key: 'fr', label: 'Français' },
            { key: 'it', label: 'Italiano' },
            { key: 'ja', label: '日本語' },
            { key: 'nb', label: 'Bokmål' },
            { key: 'nl', label: 'Nederlands' },
            { key: 'pt-BR', label: 'Português (Brasil)' },
            { key: 'ru', label: 'Русский' },
            { key: 'zh-CN', label: '中文简体' },
            { key: 'cs', label: 'Čeština' },
            { key: 'da', label: 'Dansk' },
            { key: 'fi', label: 'Suomi' },
            { key: 'pl', label: 'Polski' },
            { key: 'sv', label: 'Svenska' },
            { key: 'ar', label: 'العربية', direction: 'rtl' }
        ]);
        this.languages$ = this.languages.asObservable();
        const customLanguages = appConfigService.get(AppConfigValues.APP_CONFIG_LANGUAGES_KEY);
        this.setLanguages(customLanguages);
    }
    changeLanguage(language) {
        this.userPreferencesService.locale = language.key;
        this.userPreferencesService.set('textOrientation', language.direction || 'ltr');
    }
    setLanguages(items) {
        if (items?.length > 0) {
            this.languages.next(items);
        }
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageService, deps: [{ token: AppConfigService }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LanguageMenuComponent {
    constructor(languageService) {
        this.languageService = languageService;
        /** Emitted when the language change */
        this.changedLanguage = new EventEmitter();
        this.languages$ = languageService.languages$;
    }
    changeLanguage(language) {
        this.changedLanguage.emit(language);
        this.languageService.changeLanguage(language);
    }
}
LanguageMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuComponent, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
LanguageMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LanguageMenuComponent, selector: "adf-language-menu", outputs: { changedLanguage: "changedLanguage" }, ngImport: i0, template: `
        <button
            mat-menu-item
            *ngFor="let language of languages$ | async"
            [attr.lang]="language.key"
            (click)="changeLanguage(language)">{{language.label}}</button>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i3$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-language-menu',
                    template: `
        <button
            mat-menu-item
            *ngFor="let language of languages$ | async"
            [attr.lang]="language.key"
            (click)="changeLanguage(language)">{{language.label}}</button>
    `
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; }, propDecorators: { changedLanguage: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LanguagePickerComponent {
    constructor() {
        this.changedLanguage = new EventEmitter();
    }
}
LanguagePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguagePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LanguagePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LanguagePickerComponent, selector: "adf-picker-button", outputs: { changedLanguage: "changedLanguage" }, ngImport: i0, template: `
        <button mat-menu-item [matMenuTriggerFor]="langMenu">
            <mat-icon>language</mat-icon>
            {{ 'ADF.LANGUAGE' | translate }}
        </button>
        <mat-menu #langMenu="matMenu">
            <adf-language-menu (changedLanguage)="changedLanguage.emit($event)"></adf-language-menu>
        </mat-menu>
    `, isInline: true, dependencies: [{ kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: LanguageMenuComponent, selector: "adf-language-menu", outputs: ["changedLanguage"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguagePickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-picker-button',
                    template: `
        <button mat-menu-item [matMenuTriggerFor]="langMenu">
            <mat-icon>language</mat-icon>
            {{ 'ADF.LANGUAGE' | translate }}
        </button>
        <mat-menu #langMenu="matMenu">
            <adf-language-menu (changedLanguage)="changedLanguage.emit($event)"></adf-language-menu>
        </mat-menu>
    `
                }]
        }], propDecorators: { changedLanguage: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LanguageMenuModule {
}
LanguageMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LanguageMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuModule, declarations: [LanguageMenuComponent,
        LanguagePickerComponent], imports: [CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule], exports: [LanguageMenuComponent,
        LanguagePickerComponent,
        MatMenuModule,
        MatIconModule,
        MatButtonModule] });
LanguageMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuModule, imports: [CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule, MatMenuModule,
        MatIconModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LanguageMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatMenuModule,
                        MatIconModule,
                        MatButtonModule,
                        TranslateModule
                    ],
                    declarations: [
                        LanguageMenuComponent,
                        LanguagePickerComponent
                    ],
                    exports: [
                        LanguageMenuComponent,
                        LanguagePickerComponent,
                        MatMenuModule,
                        MatIconModule,
                        MatButtonModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InfoDrawerLayoutComponent {
    constructor() {
        /** The visibility of the header. */
        this.showHeader = true;
    }
}
InfoDrawerLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InfoDrawerLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerLayoutComponent, selector: "adf-info-drawer-layout", inputs: { showHeader: "showHeader" }, host: { classAttribute: "adf-info-drawer-layout" }, ngImport: i0, template: "<div *ngIf=\"showHeader\" class=\"adf-info-drawer-layout-header\">\n    <div class=\"adf-info-drawer-layout-header-title\">\n        <ng-content select=\"[info-drawer-title]\"></ng-content>\n    </div>\n    <div class=\"adf-info-drawer-layout-header-buttons\">\n        <ng-content select=\"[info-drawer-buttons]\"></ng-content>\n    </div>\n</div>\n<div class=\"adf-info-drawer-layout-content\">\n    <ng-content select=\"[info-drawer-content]\"></ng-content>\n</div>\n", styles: [".adf-info-drawer{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-info-drawer-layout{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;overflow:auto;width:100%;background-color:var(--theme-background-color);box-shadow:0 2px 4px #00000045}.adf-info-drawer-layout .mat-tab-label{font-weight:700;text-align:left;color:var(--theme-accent-color);text-transform:uppercase;opacity:1}.adf-info-drawer-layout .mat-tab-label-active{color:var(--theme-primary-color)}.adf-info-drawer-layout-header{padding:13px 0 0 23px;display:flex;justify-content:space-between;margin-bottom:40px}.adf-info-drawer-layout-header-buttons{padding-right:18px}.adf-info-drawer-layout-header-buttons mat-icon{cursor:pointer}.adf-info-drawer-layout-header-title{width:197px;height:32px;font-size:var(--theme-title-font-size);line-height:1.6;letter-spacing:-.5px;text-align:left;color:var(--adf-theme-foreground-text-color-054)}.adf-info-drawer-layout-header-title>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.adf-info-drawer-layout-content{padding:10px}.adf-info-drawer-layout-content>*{margin-bottom:20px;display:block}.adf-info-drawer-layout-content>*:last-child{margin-bottom:0}.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-empty,.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-no-permission{margin:0;padding:24px;color:var(--adf-theme-foreground-text-color-054);text-align:center;display:flex;flex-direction:column}.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-empty-icon,.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-no-permission-icon{width:48px;height:48px;font-size:48px;margin:0 auto 24px;display:block}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-info-drawer-layout', encapsulation: ViewEncapsulation.None, host: { class: 'adf-info-drawer-layout' }, template: "<div *ngIf=\"showHeader\" class=\"adf-info-drawer-layout-header\">\n    <div class=\"adf-info-drawer-layout-header-title\">\n        <ng-content select=\"[info-drawer-title]\"></ng-content>\n    </div>\n    <div class=\"adf-info-drawer-layout-header-buttons\">\n        <ng-content select=\"[info-drawer-buttons]\"></ng-content>\n    </div>\n</div>\n<div class=\"adf-info-drawer-layout-content\">\n    <ng-content select=\"[info-drawer-content]\"></ng-content>\n</div>\n", styles: [".adf-info-drawer{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-info-drawer-layout{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;overflow:auto;width:100%;background-color:var(--theme-background-color);box-shadow:0 2px 4px #00000045}.adf-info-drawer-layout .mat-tab-label{font-weight:700;text-align:left;color:var(--theme-accent-color);text-transform:uppercase;opacity:1}.adf-info-drawer-layout .mat-tab-label-active{color:var(--theme-primary-color)}.adf-info-drawer-layout-header{padding:13px 0 0 23px;display:flex;justify-content:space-between;margin-bottom:40px}.adf-info-drawer-layout-header-buttons{padding-right:18px}.adf-info-drawer-layout-header-buttons mat-icon{cursor:pointer}.adf-info-drawer-layout-header-title{width:197px;height:32px;font-size:var(--theme-title-font-size);line-height:1.6;letter-spacing:-.5px;text-align:left;color:var(--adf-theme-foreground-text-color-054)}.adf-info-drawer-layout-header-title>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.adf-info-drawer-layout-content{padding:10px}.adf-info-drawer-layout-content>*{margin-bottom:20px;display:block}.adf-info-drawer-layout-content>*:last-child{margin-bottom:0}.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-empty,.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-no-permission{margin:0;padding:24px;color:var(--adf-theme-foreground-text-color-054);text-align:center;display:flex;flex-direction:column}.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-empty-icon,.adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content .adf-manage-versions-no-permission-icon{width:48px;height:48px;font-size:48px;margin:0 auto 24px;display:block}\n"] }]
        }], propDecorators: { showHeader: [{
                type: Input
            }] } });
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class InfoDrawerTitleDirective {
}
InfoDrawerTitleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
InfoDrawerTitleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerTitleDirective, selector: "[adf-info-drawer-title], [info-drawer-title]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerTitleDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-info-drawer-title], [info-drawer-title]' }]
        }] });
class InfoDrawerButtonsDirective {
}
InfoDrawerButtonsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerButtonsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
InfoDrawerButtonsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerButtonsDirective, selector: "[adf-info-drawer-buttons], [info-drawer-buttons]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerButtonsDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-info-drawer-buttons], [info-drawer-buttons]' }]
        }] });
class InfoDrawerContentDirective {
}
InfoDrawerContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
InfoDrawerContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerContentDirective, selector: "[adf-info-drawer-content], [info-drawer-content]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerContentDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-info-drawer-content], [info-drawer-content]' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InfoDrawerTabComponent {
    constructor() {
        /** The title of the tab (string or translation key). */
        this.label = '';
        /** Icon to render for the tab. */
        this.icon = null;
    }
}
InfoDrawerTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerTabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InfoDrawerTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerTabComponent, selector: "adf-info-drawer-tab", inputs: { label: "label", icon: "icon" }, viewQueries: [{ propertyName: "content", first: true, predicate: TemplateRef, descendants: true, static: true }], ngImport: i0, template: '<ng-template><ng-content></ng-content></ng-template>', isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerTabComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-info-drawer-tab',
                    template: '<ng-template><ng-content></ng-content></ng-template>',
                    encapsulation: ViewEncapsulation.None
                }]
        }], propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], content: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }] } });
class InfoDrawerComponent {
    constructor() {
        /** The title of the info drawer (string or translation key). */
        this.title = null;
        /** The selected index tab. */
        this.selectedIndex = 0;
        /** The visibility of the header. */
        this.showHeader = true;
        /** Emitted when the currently active tab changes. */
        this.currentTab = new EventEmitter();
    }
    onKeyDown(event) {
        event.stopPropagation();
    }
    onKeyUp(event) {
        event.stopPropagation();
    }
    showTabLayout() {
        return this.contentBlocks.length > 0;
    }
    onTabChange(event) {
        this.currentTab.emit(event.index);
    }
}
InfoDrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InfoDrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InfoDrawerComponent, selector: "adf-info-drawer", inputs: { title: "title", selectedIndex: "selectedIndex", showHeader: "showHeader" }, outputs: { currentTab: "currentTab" }, host: { listeners: { "keydown": "onKeyDown($event)", "keyup": "onKeyUp($event)" }, classAttribute: "adf-info-drawer" }, queries: [{ propertyName: "contentBlocks", predicate: InfoDrawerTabComponent }], ngImport: i0, template: "<adf-info-drawer-layout [showHeader]=\"showHeader\">\n    <div role=\"heading\" aria-level=\"1\" *ngIf=\"title\" info-drawer-title>{{ title | translate }}</div>\n    <ng-content *ngIf=\"!title\" info-drawer-title select=\"[info-drawer-title]\"></ng-content>\n\n    <ng-content info-drawer-buttons select=\"[info-drawer-buttons]\"></ng-content>\n\n    <ng-container info-drawer-content *ngIf=\"showTabLayout(); then tabLayout else singleLayout\"></ng-container>\n\n    <ng-template #tabLayout>\n        <mat-tab-group [(selectedIndex)]=\"selectedIndex\" class=\"adf-info-drawer-tabs\" (selectedTabChange)=\"onTabChange($event)\">\n            <mat-tab *ngFor=\"let contentBlock of contentBlocks\"\n                [label]=\"contentBlock.label | translate\"\n                class=\"adf-info-drawer-tab\">\n\n                <ng-template mat-tab-label>\n                    <mat-icon *ngIf=\"contentBlock.icon\">{{ contentBlock.icon }}</mat-icon>\n                    <span *ngIf=\"contentBlock.label\">{{ contentBlock.label | translate }}</span>\n                </ng-template>\n\n                <ng-container *ngTemplateOutlet=\"contentBlock.content\"></ng-container>\n            </mat-tab>\n        </mat-tab-group>\n    </ng-template>\n\n    <ng-template #singleLayout>\n        <ng-content select=\"[info-drawer-content]\"></ng-content>\n    </ng-template>\n</adf-info-drawer-layout>\n", styles: [".adf-info-drawer{display:block}.adf-info-drawer .mat-tab-label{min-width:0}.adf-info-drawer .adf-info-drawer-layout-content{padding:0}.adf-info-drawer .adf-info-drawer-layout-content>:not(.adf-info-drawer-tabs){padding:10px}.adf-info-drawer .adf-info-drawer-layout-content>:not(.adf-info-drawer-tabs)>*{margin-bottom:20px;display:block}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content>*{margin-bottom:20px;display:block}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content>*:last-child{margin-bottom:0}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-label{flex-grow:1}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-label .mat-icon+span{padding-left:5px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-ink-bar{height:4px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body{padding:10px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content{overflow:initial}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "directive", type: i2$6.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: InfoDrawerLayoutComponent, selector: "adf-info-drawer-layout", inputs: ["showHeader"] }, { kind: "directive", type: InfoDrawerTitleDirective, selector: "[adf-info-drawer-title], [info-drawer-title]" }, { kind: "directive", type: InfoDrawerContentDirective, selector: "[adf-info-drawer-content], [info-drawer-content]" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-info-drawer', encapsulation: ViewEncapsulation.None, host: { class: 'adf-info-drawer' }, template: "<adf-info-drawer-layout [showHeader]=\"showHeader\">\n    <div role=\"heading\" aria-level=\"1\" *ngIf=\"title\" info-drawer-title>{{ title | translate }}</div>\n    <ng-content *ngIf=\"!title\" info-drawer-title select=\"[info-drawer-title]\"></ng-content>\n\n    <ng-content info-drawer-buttons select=\"[info-drawer-buttons]\"></ng-content>\n\n    <ng-container info-drawer-content *ngIf=\"showTabLayout(); then tabLayout else singleLayout\"></ng-container>\n\n    <ng-template #tabLayout>\n        <mat-tab-group [(selectedIndex)]=\"selectedIndex\" class=\"adf-info-drawer-tabs\" (selectedTabChange)=\"onTabChange($event)\">\n            <mat-tab *ngFor=\"let contentBlock of contentBlocks\"\n                [label]=\"contentBlock.label | translate\"\n                class=\"adf-info-drawer-tab\">\n\n                <ng-template mat-tab-label>\n                    <mat-icon *ngIf=\"contentBlock.icon\">{{ contentBlock.icon }}</mat-icon>\n                    <span *ngIf=\"contentBlock.label\">{{ contentBlock.label | translate }}</span>\n                </ng-template>\n\n                <ng-container *ngTemplateOutlet=\"contentBlock.content\"></ng-container>\n            </mat-tab>\n        </mat-tab-group>\n    </ng-template>\n\n    <ng-template #singleLayout>\n        <ng-content select=\"[info-drawer-content]\"></ng-content>\n    </ng-template>\n</adf-info-drawer-layout>\n", styles: [".adf-info-drawer{display:block}.adf-info-drawer .mat-tab-label{min-width:0}.adf-info-drawer .adf-info-drawer-layout-content{padding:0}.adf-info-drawer .adf-info-drawer-layout-content>:not(.adf-info-drawer-tabs){padding:10px}.adf-info-drawer .adf-info-drawer-layout-content>:not(.adf-info-drawer-tabs)>*{margin-bottom:20px;display:block}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content>*{margin-bottom:20px;display:block}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content>*:last-child{margin-bottom:0}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-label{flex-grow:1}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-label .mat-icon+span{padding-left:5px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-ink-bar{height:4px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body{padding:10px}.adf-info-drawer .adf-info-drawer-layout-content .adf-info-drawer-tabs .mat-tab-body-content{overflow:initial}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], currentTab: [{
                type: Output
            }], contentBlocks: [{
                type: ContentChildren,
                args: [InfoDrawerTabComponent]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onKeyUp: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InfoDrawerModule {
}
InfoDrawerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InfoDrawerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerModule, declarations: [InfoDrawerLayoutComponent,
        InfoDrawerTabComponent,
        InfoDrawerComponent,
        InfoDrawerTitleDirective,
        InfoDrawerButtonsDirective,
        InfoDrawerContentDirective], imports: [CommonModule,
        MatTabsModule,
        MatIconModule,
        MatCardModule,
        TranslateModule], exports: [InfoDrawerLayoutComponent,
        InfoDrawerTabComponent,
        InfoDrawerComponent,
        InfoDrawerTitleDirective,
        InfoDrawerButtonsDirective,
        InfoDrawerContentDirective,
        MatTabsModule,
        MatCardModule,
        MatIconModule] });
InfoDrawerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerModule, imports: [CommonModule,
        MatTabsModule,
        MatIconModule,
        MatCardModule,
        TranslateModule, MatTabsModule,
        MatCardModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InfoDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatTabsModule,
                        MatIconModule,
                        MatCardModule,
                        TranslateModule
                    ],
                    declarations: [
                        InfoDrawerLayoutComponent,
                        InfoDrawerTabComponent,
                        InfoDrawerComponent,
                        InfoDrawerTitleDirective,
                        InfoDrawerButtonsDirective,
                        InfoDrawerContentDirective
                    ],
                    exports: [
                        InfoDrawerLayoutComponent,
                        InfoDrawerTabComponent,
                        InfoDrawerComponent,
                        InfoDrawerTitleDirective,
                        InfoDrawerButtonsDirective,
                        InfoDrawerContentDirective,
                        MatTabsModule,
                        MatCardModule,
                        MatIconModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityUserInfoComponent {
    constructor() {
        /** Custom path for the background banner image for APS users. */
        this.bpmBackgroundImage = './assets/images/bpm-background.png';
        /** Custom choice for opening the menu at the bottom. Can be `before` or `after`. */
        this.menuPositionX = 'after';
        /** Custom choice for opening the menu at the bottom. Can be `above` or `below`. */
        this.menuPositionY = 'below';
        /** Shows/hides the username next to the user info button. */
        this.showName = true;
        /** When the username is shown, this defines its position relative to the user info button.
         * Can be `right` or `left`.
         */
        this.namePosition = 'right';
        this.destroy$ = new Subject();
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    onKeyPress(event) {
        this.closeUserModal(event);
    }
    closeUserModal($event) {
        if ($event.keyCode === 27) {
            this.trigger.closeMenu();
        }
    }
    stopClosing(event) {
        event.stopPropagation();
    }
    get showOnRight() {
        return this.namePosition === 'right';
    }
    get canShow() {
        return this.isLoggedIn && !!this.identityUser;
    }
}
IdentityUserInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdentityUserInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: IdentityUserInfoComponent, selector: "adf-identity-user-info", inputs: { isLoggedIn: "isLoggedIn", identityUser: "identityUser", bpmBackgroundImage: "bpmBackgroundImage", menuPositionX: "menuPositionX", menuPositionY: "menuPositionY", showName: "showName", namePosition: "namePosition" }, viewQueries: [{ propertyName: "trigger", first: true, predicate: MatMenuTrigger, descendants: true }], ngImport: i0, template: "<div \n    id=\"userinfo_container\" \n    [class.adf-userinfo-name-right]=\"showOnRight\" \n    (keyup)=\"onKeyPress($event)\"\n    class=\"adf-userinfo-container\" \n    *ngIf=\"isLoggedIn\"\n>\n    <span *ngIf=\"showName\" id=\"adf-userinfo-identity-name-display\" class=\"adf-userinfo-name\">\n        {{identityUser | fullName}}\n    </span>\n    <button mat-button [matMenuTriggerFor]=\"menu\" class=\"adf-userinfo-menu_button\"\n            data-automation-id=\"adf-user-profile\">\n        <div class=\"adf-userinfo-button-profile\" id=\"user-profile\">\n            <div id=\"identity-user-image\">\n                <div [innerHTML]=\"identityUser | usernameInitials:'adf-userinfo-pic'\"></div>\n            </div>\n        </div>\n    </button>\n    <mat-menu #menu=\"matMenu\" id=\"user-profile-lists\" [xPosition]=\"menuPositionX\" [yPosition]=\"menuPositionY\"\n              [overlapTrigger]=\"false\" class=\"adf-userinfo-menu\">\n        <mat-tab-group id=\"tab-group-env\" (click)=\"stopClosing($event)\" selectedIndex=\"0\" role=\"menuitem\"\n                       class=\"adf-userinfo-tab adf-hide-tab\">\n            <mat-tab id=\"identity-panel\" role=\"dialog\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + bpmBackgroundImage + ')'\">\n                        <div class=\"adf-userinfo-title\" id=\"identity-username\">{{identityUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"identity-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{identityUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\"\n                                      id=\"identity-email\"> {{identityUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                      {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n        </mat-tab-group>\n    </mat-menu>\n</div>\n", styles: [".adf-userinfo-container{display:flex;align-items:center;padding:0 5px}.adf-userinfo-name-right{flex-direction:row-reverse}.adf-userinfo-name{padding:0 5px}@media screen and (max-width: 959px){.adf-userinfo-name{display:none}}.adf-userinfo-pic{background:var(--adf-theme-primary-300);display:inline-block;width:40px;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px}.adf-userinfo-profile-image{background:var(--adf-theme-primary-300);text-align:center;border-radius:90%;width:40px;height:40px;margin-right:0;cursor:pointer;vertical-align:middle;margin-left:0}.adf-userinfo-profile-container{display:inline-block}.adf-userinfo-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-userinfo-tab .mat-tab-header{align-self:center;width:100%;min-width:250px}.adf-userinfo-tab .mat-tab-label{flex:auto;font-weight:500;font-size:var(--theme-body-1-font-size);text-transform:uppercase;line-height:48px;text-align:center}.adf-userinfo-card-header{align-items:center;display:flex;justify-content:stretch;line-height:normal;height:100px;box-sizing:border-box}.adf-userinfo-card.mat-card{padding:0}.adf-userinfo-supporting-text{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;overflow:hidden;padding:32px;column-count:2;display:flex;justify-content:space-between}@media screen and (max-width: 599px){.adf-userinfo-supporting-text{padding:10px}}.adf-userinfo-title{font-size:var(--theme-title-font-size)}.adf-userinfo__detail-profile{align-items:flex-start;font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;display:block;padding:0;margin:0}.adf-userinfo__detail-title{text-overflow:ellipsis;font-size:var(--theme-subheading-2-font-size);font-weight:400;letter-spacing:.04em;line-height:20px;align-items:flex-start}.adf-userinfo__secondary-info{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;align-items:flex-end}.adf-userinfo-profile-picture{background:var(--adf-theme-primary-300);background-size:cover;border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px}.adf-userinfo-profile-initials{text-transform:uppercase;background-size:cover;background-color:var(--adf-theme-primary-300);border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px;font-size:35px;font-weight:400;letter-spacing:0;line-height:78px;overflow:hidden;display:flex;justify-content:space-around}.adf-userinfo-button-profile{display:inline-block;border:0;vertical-align:middle}.adf-userinfo-detail{text-align:left}.adf-hide-tab .mat-tab-label-active{display:none!important}@media only screen and (min-device-width: 480px){.mat-menu-panel.adf-userinfo-menu{max-height:450px;min-width:450px;overflow:auto;padding:0}}.mat-menu-panel.adf-userinfo-menu .mat-menu-content{padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "component", type: i10.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "component", type: i10.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i10.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: InitialUsernamePipe, name: "usernameInitials" }, { kind: "pipe", type: FullNamePipe, name: "fullName" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-identity-user-info', encapsulation: ViewEncapsulation.None, template: "<div \n    id=\"userinfo_container\" \n    [class.adf-userinfo-name-right]=\"showOnRight\" \n    (keyup)=\"onKeyPress($event)\"\n    class=\"adf-userinfo-container\" \n    *ngIf=\"isLoggedIn\"\n>\n    <span *ngIf=\"showName\" id=\"adf-userinfo-identity-name-display\" class=\"adf-userinfo-name\">\n        {{identityUser | fullName}}\n    </span>\n    <button mat-button [matMenuTriggerFor]=\"menu\" class=\"adf-userinfo-menu_button\"\n            data-automation-id=\"adf-user-profile\">\n        <div class=\"adf-userinfo-button-profile\" id=\"user-profile\">\n            <div id=\"identity-user-image\">\n                <div [innerHTML]=\"identityUser | usernameInitials:'adf-userinfo-pic'\"></div>\n            </div>\n        </div>\n    </button>\n    <mat-menu #menu=\"matMenu\" id=\"user-profile-lists\" [xPosition]=\"menuPositionX\" [yPosition]=\"menuPositionY\"\n              [overlapTrigger]=\"false\" class=\"adf-userinfo-menu\">\n        <mat-tab-group id=\"tab-group-env\" (click)=\"stopClosing($event)\" selectedIndex=\"0\" role=\"menuitem\"\n                       class=\"adf-userinfo-tab adf-hide-tab\">\n            <mat-tab id=\"identity-panel\" role=\"dialog\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + bpmBackgroundImage + ')'\">\n                        <div class=\"adf-userinfo-title\" id=\"identity-username\">{{identityUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"identity-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{identityUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\"\n                                      id=\"identity-email\"> {{identityUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                      {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n        </mat-tab-group>\n    </mat-menu>\n</div>\n", styles: [".adf-userinfo-container{display:flex;align-items:center;padding:0 5px}.adf-userinfo-name-right{flex-direction:row-reverse}.adf-userinfo-name{padding:0 5px}@media screen and (max-width: 959px){.adf-userinfo-name{display:none}}.adf-userinfo-pic{background:var(--adf-theme-primary-300);display:inline-block;width:40px;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px}.adf-userinfo-profile-image{background:var(--adf-theme-primary-300);text-align:center;border-radius:90%;width:40px;height:40px;margin-right:0;cursor:pointer;vertical-align:middle;margin-left:0}.adf-userinfo-profile-container{display:inline-block}.adf-userinfo-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-userinfo-tab .mat-tab-header{align-self:center;width:100%;min-width:250px}.adf-userinfo-tab .mat-tab-label{flex:auto;font-weight:500;font-size:var(--theme-body-1-font-size);text-transform:uppercase;line-height:48px;text-align:center}.adf-userinfo-card-header{align-items:center;display:flex;justify-content:stretch;line-height:normal;height:100px;box-sizing:border-box}.adf-userinfo-card.mat-card{padding:0}.adf-userinfo-supporting-text{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;overflow:hidden;padding:32px;column-count:2;display:flex;justify-content:space-between}@media screen and (max-width: 599px){.adf-userinfo-supporting-text{padding:10px}}.adf-userinfo-title{font-size:var(--theme-title-font-size)}.adf-userinfo__detail-profile{align-items:flex-start;font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;display:block;padding:0;margin:0}.adf-userinfo__detail-title{text-overflow:ellipsis;font-size:var(--theme-subheading-2-font-size);font-weight:400;letter-spacing:.04em;line-height:20px;align-items:flex-start}.adf-userinfo__secondary-info{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;align-items:flex-end}.adf-userinfo-profile-picture{background:var(--adf-theme-primary-300);background-size:cover;border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px}.adf-userinfo-profile-initials{text-transform:uppercase;background-size:cover;background-color:var(--adf-theme-primary-300);border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px;font-size:35px;font-weight:400;letter-spacing:0;line-height:78px;overflow:hidden;display:flex;justify-content:space-around}.adf-userinfo-button-profile{display:inline-block;border:0;vertical-align:middle}.adf-userinfo-detail{text-align:left}.adf-hide-tab .mat-tab-label-active{display:none!important}@media only screen and (min-device-width: 480px){.mat-menu-panel.adf-userinfo-menu{max-height:450px;min-width:450px;overflow:auto;padding:0}}.mat-menu-panel.adf-userinfo-menu .mat-menu-content{padding:0}\n"] }]
        }], propDecorators: { trigger: [{
                type: ViewChild,
                args: [MatMenuTrigger]
            }], isLoggedIn: [{
                type: Input
            }], identityUser: [{
                type: Input
            }], bpmBackgroundImage: [{
                type: Input
            }], menuPositionX: [{
                type: Input
            }], menuPositionY: [{
                type: Input
            }], showName: [{
                type: Input
            }], namePosition: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityUserInfoModule {
}
IdentityUserInfoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdentityUserInfoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoModule, declarations: [IdentityUserInfoComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatCardModule,
        TranslateModule,
        PipeModule], exports: [IdentityUserInfoComponent] });
IdentityUserInfoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoModule, imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatCardModule,
        TranslateModule,
        PipeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserInfoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IdentityUserInfoComponent],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatMenuModule,
                        MatTabsModule,
                        MatCardModule,
                        TranslateModule,
                        PipeModule
                    ],
                    exports: [IdentityUserInfoComponent]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataColumnComponent {
    constructor() {
        /** Id of the Column */
        this.id = '';
        /** Value type for the column. Possible settings are 'text', 'image',
         * 'date', 'fileSize', 'location', and 'json'.
         */
        this.type = 'text';
        /** Toggles ability to sort by this column, for example by clicking the column header. */
        this.sortable = true;
        /** Enable drag and drop for header column */
        this.draggable = false;
        /** Hide column */
        this.isHidden = false;
        /** Display title of the column, typically used for column headers. You can use the
         * i18n resource key to get it translated automatically.
         */
        this.title = '';
        /**  Toggles the editing support of the column data. */
        this.editable = false;
        /**  Enable or disable cell focus */
        this.focus = true;
    }
    ngOnInit() {
        if (!this.srTitle && this.key === '$thumbnail') {
            this.srTitle = 'Thumbnail';
        }
    }
}
DataColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DataColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DataColumnComponent, selector: "data-column", inputs: { id: "id", key: "key", customData: "customData", type: "type", format: "format", sortable: "sortable", draggable: "draggable", isHidden: "isHidden", title: "title", formatTooltip: "formatTooltip", srTitle: ["sr-title", "srTitle"], cssClass: ["class", "cssClass"], copyContent: "copyContent", editable: "editable", focus: "focus", sortingKey: "sortingKey" }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'data-column',
                    template: ''
                }]
        }], propDecorators: { id: [{
                type: Input
            }], key: [{
                type: Input
            }], customData: [{
                type: Input
            }], type: [{
                type: Input
            }], format: [{
                type: Input
            }], sortable: [{
                type: Input
            }], draggable: [{
                type: Input
            }], isHidden: [{
                type: Input
            }], title: [{
                type: Input
            }], template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], formatTooltip: [{
                type: Input
            }], srTitle: [{
                type: Input,
                args: ['sr-title']
            }], cssClass: [{
                type: Input,
                args: ['class']
            }], copyContent: [{
                type: Input
            }], editable: [{
                type: Input
            }], focus: [{
                type: Input
            }], sortingKey: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataColumnListComponent {
}
DataColumnListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DataColumnListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DataColumnListComponent, selector: "data-columns", queries: [{ propertyName: "columns", predicate: DataColumnComponent }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'data-columns',
                    template: ''
                }]
        }], propDecorators: { columns: [{
                type: ContentChildren,
                args: [DataColumnComponent]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DateColumnHeaderComponent {
    constructor(columnComponent) {
        this.columnComponent = columnComponent;
    }
    ngAfterContentInit() {
        if (this.columnComponent) {
            this.columnComponent.header = this.header;
        }
    }
}
DateColumnHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateColumnHeaderComponent, deps: [{ token: DataColumnComponent }], target: i0.ɵɵFactoryTarget.Component });
DateColumnHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DateColumnHeaderComponent, selector: "adf-data-column-header", queries: [{ propertyName: "header", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateColumnHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-data-column-header',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: DataColumnComponent }]; }, propDecorators: { header: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Base cancellable event implementation */
class BaseEvent {
    constructor() {
        this.isDefaultPrevented = false;
    }
    get defaultPrevented() {
        return this.isDefaultPrevented;
    }
    preventDefault() {
        this.isDefaultPrevented = true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Base container for any event which takes place in the DOM  */
class BaseUIEvent extends BaseEvent {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataRowEvent extends BaseUIEvent {
    constructor(value, domEvent, sender) {
        super();
        this.value = value;
        this.event = domEvent;
        this.sender = sender;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataSorting {
    constructor(key, direction) {
        this.key = key;
        this.direction = direction;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Simple implementation of the DataRow interface.
class ObjectDataRow {
    constructor(obj, isSelected = false) {
        this.obj = obj;
        this.isSelected = isSelected;
        if (!obj) {
            throw new Error('Object source not found');
        }
    }
    getValue(key) {
        return ObjectUtils.getValue(this.obj, key);
    }
    hasValue(key) {
        return this.getValue(key) !== undefined;
    }
    imageErrorResolver() {
        return '';
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Simple implementation of the DataColumn interface.
class ObjectDataColumn {
    constructor(input) {
        this.id = input.id ?? '';
        this.key = input.key;
        this.type = input.type || 'text';
        this.format = input.format;
        this.sortable = input.sortable;
        this.title = input.title;
        this.srTitle = input.srTitle;
        this.cssClass = input.cssClass;
        this.template = input.template;
        this.copyContent = input.copyContent;
        this.focus = input.focus;
        this.sortingKey = input.sortingKey;
        this.header = input.header;
        this.draggable = input.draggable ?? false;
        this.isHidden = input.isHidden ?? false;
        this.customData = input.customData;
        this.width = input.width;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Simple implementation of the DataTableAdapter interface.
class ObjectDataTableAdapter {
    constructor(data = [], schema = []) {
        this._rows = [];
        this._columns = [];
        if (data && data.length > 0) {
            this._rows = data.map((item) => new ObjectDataRow(item));
        }
        if (schema && schema.length > 0) {
            this._columns = schema.map((item) => new ObjectDataColumn(item));
            // Sort by first sortable or just first column
            const sortable = this._columns.filter((column) => column.sortable);
            if (sortable.length > 0) {
                this.sort(sortable[0].key, 'asc');
            }
        }
        this.rowsChanged = new Subject();
    }
    static generateSchema(data) {
        const schema = [];
        if (data && data.length) {
            const rowToExaminate = data[0];
            if (typeof rowToExaminate === 'object') {
                for (const key in rowToExaminate) {
                    if (rowToExaminate.hasOwnProperty(key)) {
                        schema.push({
                            type: 'text',
                            key,
                            title: key,
                            sortable: false
                        });
                    }
                }
            }
        }
        return schema;
    }
    getColumnType(_row, col) {
        return col.type;
    }
    getRows() {
        return this._rows;
    }
    setRows(rows) {
        this._rows = rows || [];
        this.sort();
        this.rowsChanged.next(this._rows);
    }
    getColumns() {
        return this._columns;
    }
    setColumns(columns) {
        this._columns = columns || [];
    }
    getValue(row, col, resolver) {
        if (!row) {
            throw new Error('Row not found');
        }
        if (!col) {
            throw new Error('Column not found');
        }
        if (resolver) {
            return resolver(row, col);
        }
        const value = row.getValue(col.key);
        if (col.type === 'icon') {
            const icon = row.getValue(col.key);
            return icon;
        }
        return value;
    }
    getSorting() {
        return this._sorting;
    }
    setSorting(sorting) {
        this._sorting = sorting;
        if (sorting && sorting.key) {
            this._rows.sort((a, b) => {
                let left = a.getValue(sorting.key);
                let right = b.getValue(sorting.key);
                if (typeof left === 'number' && typeof right === 'number') {
                    return sorting.direction === 'asc' ? left - right : right - left;
                }
                else {
                    if (left) {
                        left = (left instanceof Date) ? left.valueOf().toString() : left.toString();
                    }
                    else {
                        left = '';
                    }
                    if (right) {
                        right = (right instanceof Date) ? right.valueOf().toString() : right.toString();
                    }
                    else {
                        right = '';
                    }
                    return sorting.direction === 'asc'
                        ? left.localeCompare(right)
                        : right.localeCompare(left);
                }
            });
        }
    }
    sort(key, direction) {
        const sorting = this._sorting || new DataSorting();
        if (key) {
            sorting.key = key;
            sorting.direction = direction || 'asc';
        }
        this.setSorting(sorting);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataCellEventModel {
    constructor(row, col, actions) {
        this.row = row;
        this.col = col;
        this.actions = actions || [];
    }
}
class DataCellEvent extends BaseEvent {
    constructor(row, col, actions) {
        super();
        this.value = new DataCellEventModel(row, col, actions);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataRowActionModel {
    constructor(row, action) {
        this.row = row;
        this.action = action;
    }
}
class DataRowActionEvent extends BaseEvent {
    // backwards compatibility with 1.2.0 and earlier
    get args() {
        return this.value;
    }
    constructor(row, action) {
        super();
        this.value = new DataRowActionModel(row, action);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DropZoneDirective {
    constructor(elementRef, ngZone) {
        this.ngZone = ngZone;
        this.dropTarget = 'cell';
        this.element = elementRef.nativeElement;
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.element.addEventListener('dragenter', this.onDragEnter.bind(this));
            this.element.addEventListener('dragover', this.onDragOver.bind(this));
            this.element.addEventListener('drop', this.onDrop.bind(this));
        });
    }
    ngOnDestroy() {
        this.element.removeEventListener('dragenter', this.onDragEnter);
        this.element.removeEventListener('dragover', this.onDragOver);
        this.element.removeEventListener('drop', this.onDrop);
    }
    onDragEnter(event) {
        const domEvent = this.dispatchDomEvent(event, 'dragenter');
        if (domEvent.defaultPrevented) {
            event.dataTransfer.dropEffect = 'copy';
            event.preventDefault();
            event.stopPropagation();
        }
    }
    onDragOver(event) {
        const domEvent = this.dispatchDomEvent(event, 'dragover');
        if (domEvent.defaultPrevented) {
            event.dataTransfer.dropEffect = 'copy';
            event.preventDefault();
            event.stopPropagation();
        }
    }
    onDrop(event) {
        const domEvent = this.dispatchDomEvent(event, 'drop');
        if (domEvent.defaultPrevented) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    dispatchDomEvent(originalEvent, eventName) {
        const domEvent = new CustomEvent(`${this.dropTarget}-${eventName}`, {
            detail: {
                target: this.dropTarget,
                event: originalEvent,
                column: this.dropColumn,
                row: this.dropRow
            },
            bubbles: true
        });
        this.element.dispatchEvent(domEvent);
        return domEvent;
    }
}
DropZoneDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropZoneDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
DropZoneDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: DropZoneDirective, selector: "[adf-drop-zone]", inputs: { dropTarget: "dropTarget", dropRow: "dropRow", dropColumn: "dropColumn" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropZoneDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-drop-zone]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { dropTarget: [{
                type: Input
            }], dropRow: [{
                type: Input
            }], dropColumn: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataTableRowComponent {
    constructor(element) {
        this.element = element;
        this.disabled = false;
        this.select = new EventEmitter();
    }
    get isSelected() {
        if (!this.row) {
            return false;
        }
        return this.row.isSelected;
    }
    get isAriaSelected() {
        if (!this.row) {
            return false;
        }
        return this.row.isSelected;
    }
    get ariaLabel() {
        if (!this.row) {
            return null;
        }
        if (this.row.isSelected) {
            return this.row.getValue('name') + ' selected' || '';
        }
        else {
            return this.row.getValue('name') || '';
        }
    }
    get tabindex() {
        return this.disabled ? null : 0;
    }
    onKeyDown(event) {
        if (event.target.tagName === this.element.nativeElement.tagName) {
            event.preventDefault();
            this.select.emit(event);
        }
    }
    focus() {
        this.element.nativeElement.focus();
    }
}
DataTableRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableRowComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DataTableRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DataTableRowComponent, selector: "adf-datatable-row", inputs: { row: "row", disabled: "disabled" }, outputs: { select: "select" }, host: { attributes: { "tabindex": "0", "role": "row" }, listeners: { "keydown.space": "onKeyDown($event)" }, properties: { "class.adf-is-selected": "this.isSelected", "attr.aria-selected": "this.isAriaSelected", "attr.aria-label": "this.ariaLabel", "attr.tabindex": "this.tabindex" }, classAttribute: "adf-datatable-row" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-datatable-row',
                    template: `<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'adf-datatable-row',
                        tabindex: '0',
                        role: 'row'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { row: [{
                type: Input
            }], disabled: [{
                type: Input
            }], select: [{
                type: Output
            }], isSelected: [{
                type: HostBinding,
                args: ['class.adf-is-selected']
            }], isAriaSelected: [{
                type: HostBinding,
                args: ['attr.aria-selected']
            }], ariaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContextMenuOverlayRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
    }
    close() {
        this.overlayRef.dispose();
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CONTEXT_MENU_DATA = new InjectionToken('CONTEXT_MENU_DATA');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const contextMenuAnimation = [
    state('void', style({
        opacity: 0,
        transform: 'scale(0.01, 0.01)'
    })),
    transition('void => *', sequence([
        query('.mat-menu-content', style({ opacity: 0 })),
        animate('100ms linear', style({ opacity: 1, transform: 'scale(1, 0.5)' })),
        group([
            query('.mat-menu-content', animate('400ms cubic-bezier(0.55, 0, 0.55, 0.2)', style({ opacity: 1 }))),
            animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ transform: 'scale(1, 1)' }))
        ])
    ])),
    transition('* => void', animate('150ms 50ms linear', style({ opacity: 0 })))
];

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContextMenuListComponent {
    constructor(contextMenuOverlayRef, data) {
        this.contextMenuOverlayRef = contextMenuOverlayRef;
        this.data = data;
        this.links = this.data;
    }
    handleKeydownEscape(event) {
        if (event) {
            this.contextMenuOverlayRef.close();
        }
    }
    handleKeydownEvent(event) {
        if (event) {
            const keyCode = event.keyCode;
            if (keyCode === UP_ARROW || keyCode === DOWN_ARROW) {
                this.keyManager.onKeydown(event);
            }
        }
    }
    onMenuItemClick(event, menuItem) {
        if (menuItem && menuItem.model && menuItem.model.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        menuItem.subject.next(menuItem);
        this.contextMenuOverlayRef.close();
    }
    ngAfterViewInit() {
        this.keyManager = new FocusKeyManager(this.items);
        this.keyManager.setFirstItemActive();
    }
}
ContextMenuListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuListComponent, deps: [{ token: ContextMenuOverlayRef }, { token: CONTEXT_MENU_DATA, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ContextMenuListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContextMenuListComponent, selector: "adf-context-menu", host: { attributes: { "role": "menu" }, listeners: { "document:keydown.Escape": "handleKeydownEscape($event)", "document:keydown": "handleKeydownEvent($event)" }, classAttribute: "adf-context-menu" }, viewQueries: [{ propertyName: "items", predicate: MatMenuItem, descendants: true }], ngImport: i0, template: `
        <div mat-menu class="mat-menu-panel" @panelAnimation>
            <div id="adf-context-menu-content" class="mat-menu-content">
                <ng-container *ngFor="let link of links">
                    <button *ngIf="link.model?.visible"
                            [attr.data-automation-id]="'context-'+((link.title || link.model?.title) | translate)"
                            mat-menu-item
                            [disabled]="link.model?.disabled"
                            (click)="onMenuItemClick($event, link)">
                        <mat-icon *ngIf="link.model?.icon">{{ link.model.icon }}</mat-icon>
                        <span>{{ (link.title || link.model?.title) | translate }}</span>
                    </button>
                </ng-container>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], animations: [
        trigger('panelAnimation', contextMenuAnimation)
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-context-menu',
                    template: `
        <div mat-menu class="mat-menu-panel" @panelAnimation>
            <div id="adf-context-menu-content" class="mat-menu-content">
                <ng-container *ngFor="let link of links">
                    <button *ngIf="link.model?.visible"
                            [attr.data-automation-id]="'context-'+((link.title || link.model?.title) | translate)"
                            mat-menu-item
                            [disabled]="link.model?.disabled"
                            (click)="onMenuItemClick($event, link)">
                        <mat-icon *ngIf="link.model?.icon">{{ link.model.icon }}</mat-icon>
                        <span>{{ (link.title || link.model?.title) | translate }}</span>
                    </button>
                </ng-container>
            </div>
        </div>
    `,
                    host: {
                        role: 'menu',
                        class: 'adf-context-menu'
                    },
                    encapsulation: ViewEncapsulation.None,
                    animations: [
                        trigger('panelAnimation', contextMenuAnimation)
                    ]
                }]
        }], ctorParameters: function () { return [{ type: ContextMenuOverlayRef, decorators: [{
                    type: Inject,
                    args: [ContextMenuOverlayRef]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CONTEXT_MENU_DATA]
                }] }]; }, propDecorators: { items: [{
                type: ViewChildren,
                args: [MatMenuItem]
            }], handleKeydownEscape: [{
                type: HostListener,
                args: ['document:keydown.Escape', ['$event']]
            }], handleKeydownEvent: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_CONFIG = {
    panelClass: 'cdk-overlay-pane',
    backdropClass: 'cdk-overlay-transparent-backdrop',
    hasBackdrop: true
};
class ContextMenuOverlayService {
    constructor(injector, overlay) {
        this.injector = injector;
        this.overlay = overlay;
    }
    open(config) {
        const overlayConfig = { ...DEFAULT_CONFIG, ...config };
        const overlay = this.createOverlay(overlayConfig);
        const overlayRef = new ContextMenuOverlayRef(overlay);
        this.attachDialogContainer(overlay, config, overlayRef);
        overlay.backdropClick().subscribe(() => overlayRef.close());
        // prevent native contextmenu on overlay element if config.hasBackdrop is true
        if (overlayConfig.hasBackdrop) {
            // eslint-disable-next-line no-underscore-dangle
            overlay._backdropElement
                .addEventListener('contextmenu', (event) => {
                event.preventDefault();
                // eslint-disable-next-line no-underscore-dangle
                overlay._backdropClick.next(null);
            }, true);
        }
        return overlayRef;
    }
    createOverlay(config) {
        const overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    }
    attachDialogContainer(overlay, config, contextMenuOverlayRef) {
        const injector = this.createInjector(config, contextMenuOverlayRef);
        const containerPortal = new ComponentPortal(ContextMenuListComponent, null, injector);
        const containerRef = overlay.attach(containerPortal);
        return containerRef.instance;
    }
    createInjector(config, contextMenuOverlayRef) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(ContextMenuOverlayRef, contextMenuOverlayRef);
        injectionTokens.set(CONTEXT_MENU_DATA, config.data);
        return new PortalInjector(this.injector, injectionTokens);
    }
    getOverlayConfig(config) {
        const { clientY, clientX } = config.source;
        const fakeElement = {
            getBoundingClientRect: () => ({
                bottom: clientY,
                height: 0,
                left: clientX,
                right: clientX,
                top: clientY,
                width: 0
            })
        };
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(new ElementRef(fakeElement))
            .withPositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            }]);
        const overlayConfig = new OverlayConfig({
            hasBackdrop: config.hasBackdrop,
            backdropClass: config.backdropClass,
            panelClass: config.panelClass,
            scrollStrategy: this.overlay.scrollStrategies.close(),
            positionStrategy
        });
        return overlayConfig;
    }
}
ContextMenuOverlayService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuOverlayService, deps: [{ token: i0.Injector }, { token: i1$5.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
ContextMenuOverlayService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuOverlayService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuOverlayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1$5.Overlay }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContextMenuDirective {
    constructor(contextMenuService) {
        this.contextMenuService = contextMenuService;
        /** Is the menu enabled? */
        this.enabled = false;
    }
    onShowContextMenu(event) {
        if (this.enabled) {
            if (event) {
                event.preventDefault();
            }
            if (this.links && this.links.length > 0) {
                this.contextMenuService.open({
                    source: event,
                    data: this.links
                });
            }
        }
    }
}
ContextMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuDirective, deps: [{ token: ContextMenuOverlayService }], target: i0.ɵɵFactoryTarget.Directive });
ContextMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ContextMenuDirective, selector: "[adf-context-menu]", inputs: { links: ["adf-context-menu", "links"], enabled: ["adf-context-menu-enabled", "enabled"] }, host: { listeners: { "contextmenu": "onShowContextMenu($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-context-menu]'
                }]
        }], ctorParameters: function () { return [{ type: ContextMenuOverlayService }]; }, propDecorators: { links: [{
                type: Input,
                args: ['adf-context-menu']
            }], enabled: [{
                type: Input,
                args: ['adf-context-menu-enabled']
            }], onShowContextMenu: [{
                type: HostListener,
                args: ['contextmenu', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IconComponent {
    constructor() {
        this._value = '';
        this._isCustom = false;
    }
    get value() {
        return this._value;
    }
    /** Icon value, which can be either a ligature name or a custom icon in the format `[namespace]:[name]`. */
    set value(value) {
        this._value = value || 'settings';
        this._isCustom = this._value.includes(':');
    }
    get isCustom() {
        return this._isCustom;
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: IconComponent, selector: "adf-icon", inputs: { color: "color", fontSet: "fontSet", value: "value" }, host: { classAttribute: "adf-icon" }, ngImport: i0, template: "<ng-container *ngIf=\"isCustom; else: default\">\n  <mat-icon [color]=\"color\" [svgIcon]=\"value\" aria-hidden=\"true\"></mat-icon>\n</ng-container>\n\n<ng-template #default>\n  <mat-icon [fontSet]=\"fontSet\" [color]=\"color\" aria-hidden=\"true\">{{ value }}</mat-icon>\n</ng-template>\n", styles: [".adf-icon{display:inline-flex;vertical-align:middle}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-icon', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: { class: 'adf-icon' }, template: "<ng-container *ngIf=\"isCustom; else: default\">\n  <mat-icon [color]=\"color\" [svgIcon]=\"value\" aria-hidden=\"true\"></mat-icon>\n</ng-container>\n\n<ng-template #default>\n  <mat-icon [fontSet]=\"fontSet\" [color]=\"color\" aria-hidden=\"true\">{{ value }}</mat-icon>\n</ng-template>\n", styles: [".adf-icon{display:inline-flex;vertical-align:middle}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], fontSet: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ResizableDirective {
    constructor(renderer, element, zone) {
        this.renderer = renderer;
        this.element = element;
        this.zone = zone;
        /**
         * Emitted when the mouse is pressed and a resize event is about to begin.
         */
        this.resizeStart = new EventEmitter();
        /**
         * Emitted when the mouse is dragged after a resize event has started.
         */
        this.resizing = new EventEmitter();
        /**
         * Emitted when the mouse is released after a resize event.
         */
        this.resizeEnd = new EventEmitter();
        this.mouseup = new Subject();
        this.mousedown = new Subject();
        this.mousemove = new Subject();
        this.destroy$ = new Subject();
        this.pointerDown = new Observable((observer) => {
            zone.runOutsideAngular(() => {
                this.unlistenMouseDown = renderer.listen('document', 'mousedown', (event) => {
                    observer.next(event);
                });
            });
        }).pipe(share());
        this.pointerMove = new Observable((observer) => {
            zone.runOutsideAngular(() => {
                this.unlistenMouseMove = renderer.listen('document', 'mousemove', (event) => {
                    observer.next(event);
                });
            });
        }).pipe(share());
        this.pointerUp = new Observable((observer) => {
            zone.runOutsideAngular(() => {
                this.unlistenMouseUp = renderer.listen('document', 'mouseup', (event) => {
                    observer.next(event);
                });
            });
        }).pipe(share());
    }
    ngOnInit() {
        const mousedown$ = merge(this.pointerDown, this.mousedown);
        const mousemove$ = merge(this.pointerMove, this.mousemove);
        const mouseup$ = merge(this.pointerUp, this.mouseup);
        const mousedrag = mousedown$
            .pipe(mergeMap(({ clientX = 0 }) => merge(mousemove$.pipe(take(1)).pipe(map((coords) => [, coords])), mousemove$.pipe(pairwise()))
            .pipe(map(([previousCoords = {}, newCoords = {}]) => [
            { clientX: previousCoords.clientX - clientX },
            { clientX: newCoords.clientX - clientX }
        ]))
            .pipe(filter(([previousCoords = {}, newCoords = {}]) => Math.ceil(previousCoords.clientX) !== Math.ceil(newCoords.clientX)))
            .pipe(map(([, newCoords]) => ({
            clientX: Math.round(newCoords.clientX)
        })))
            .pipe(takeUntil(merge(mouseup$, mousedown$)))))
            .pipe(filter(() => !!this.currentRect));
        mousedrag
            .pipe(map(({ clientX }) => this.getNewBoundingRectangle(this.startingRect, clientX)))
            .subscribe((rectangle) => {
            if (this.resizing.observers.length > 0) {
                this.zone.run(() => {
                    this.resizing.emit({ rectangle });
                });
            }
            this.currentRect = rectangle;
        });
        mousedown$
            .pipe(map(({ resize = false }) => resize), filter((resize) => resize), takeUntil(this.destroy$))
            .subscribe(() => {
            const startingRect = this.getElementRect(this.element);
            this.startingRect = startingRect;
            this.currentRect = startingRect;
            this.renderer.setStyle(document.body, 'cursor', 'col-resize');
            if (this.resizeStart.observers.length > 0) {
                this.zone.run(() => {
                    this.resizeStart.emit({
                        rectangle: this.getNewBoundingRectangle(this.startingRect, 0)
                    });
                });
            }
        });
        mouseup$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            if (this.currentRect) {
                this.renderer.setStyle(document.body, 'cursor', '');
                if (this.resizeEnd.observers.length > 0) {
                    this.zone.run(() => {
                        this.resizeEnd.emit({ rectangle: this.currentRect });
                    });
                }
                this.startingRect = null;
                this.currentRect = null;
            }
        });
    }
    ngOnDestroy() {
        this.mousedown.complete();
        this.mousemove.complete();
        this.mouseup.complete();
        this.unlistenMouseDown && this.unlistenMouseDown();
        this.unlistenMouseMove && this.unlistenMouseMove();
        this.unlistenMouseUp && this.unlistenMouseUp();
        this.destroy$.next();
    }
    getNewBoundingRectangle({ top, bottom, left, right }, clientX) {
        const updatedRight = Math.round(right + clientX);
        return {
            top,
            left,
            bottom,
            right: updatedRight,
            width: updatedRight - left
        };
    }
    getElementRect({ nativeElement }) {
        const { height = 0, width = 0, top = 0, bottom = 0, right = 0, left = 0 } = nativeElement.getBoundingClientRect();
        return {
            top,
            left,
            right,
            width,
            height,
            bottom,
            scrollTop: nativeElement.scrollTop,
            scrollLeft: nativeElement.scrollLeft
        };
    }
}
ResizableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizableDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
ResizableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ResizableDirective, selector: "[adf-resizable]", outputs: { resizeStart: "resizeStart", resizing: "resizing", resizeEnd: "resizeEnd" }, exportAs: ["adf-resizable"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-resizable]',
                    exportAs: 'adf-resizable'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { resizeStart: [{
                type: Output
            }], resizing: [{
                type: Output
            }], resizeEnd: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ResizeHandleDirective {
    constructor(renderer, element, zone) {
        this.renderer = renderer;
        this.element = element;
        this.zone = zone;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.zone.runOutsideAngular(() => {
            this.unlistenMouseDown = this.renderer.listen(this.element.nativeElement, 'mousedown', (mouseDownEvent) => {
                this.onMousedown(mouseDownEvent);
            });
        });
    }
    ngOnDestroy() {
        this.unlistenMouseDown && this.unlistenMouseDown();
        this.unlistenMouseMove && this.unlistenMouseMove();
        this.unlistenMouseUp && this.unlistenMouseUp();
        this.destroy$.next();
    }
    onMousedown(event) {
        if (event.cancelable) {
            event.preventDefault();
        }
        if (!this.unlistenMouseMove) {
            this.unlistenMouseMove = this.renderer.listen(this.element.nativeElement, 'mousemove', (mouseMoveEvent) => {
                this.onMousemove(mouseMoveEvent);
            });
        }
        this.unlistenMouseUp = this.renderer.listen('document', 'mouseup', (mouseUpEvent) => {
            this.onMouseup(mouseUpEvent);
        });
        this.resizableContainer.mousedown.next({ ...event, resize: true });
    }
    onMouseup(event) {
        this.unlistenMouseMove && this.unlistenMouseMove();
        this.unlistenMouseUp();
        this.resizableContainer.mouseup.next(event);
    }
    onMousemove(event) {
        this.resizableContainer.mousemove.next(event);
    }
}
ResizeHandleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizeHandleDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
ResizeHandleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ResizeHandleDirective, selector: "[adf-resize-handle]", inputs: { resizableContainer: "resizableContainer" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizeHandleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-resize-handle]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { resizableContainer: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataTableService {
    constructor() {
        /**
         * Publish/subscribe to events related to row updates.
         */
        this.rowUpdate = new Subject();
    }
}
DataTableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DataTableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableService, decorators: [{
            type: Injectable
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["INFO"] = "info";
    NOTIFICATION_TYPE["WARN"] = "warning";
    NOTIFICATION_TYPE["ERROR"] = "error";
    NOTIFICATION_TYPE["RECURSIVE"] = "recursive";
})(NOTIFICATION_TYPE || (NOTIFICATION_TYPE = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const rootInitiator = {
    key: '*',
    displayName: 'SYSTEM'
};
const info = (messages, initiator = rootInitiator) => ({
    type: NOTIFICATION_TYPE.INFO,
    icon: 'info',
    datetime: new Date(),
    initiator,
    messages: [].concat(messages)
});
const warning = (messages, initiator = rootInitiator) => ({
    type: NOTIFICATION_TYPE.WARN,
    icon: 'warning',
    datetime: new Date(),
    initiator,
    messages: [].concat(messages)
});
const error = (messages, initiator = rootInitiator) => ({
    type: NOTIFICATION_TYPE.ERROR,
    icon: 'error',
    datetime: new Date(),
    initiator,
    messages: [].concat(messages)
});

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SnackbarContentComponent {
    constructor(snackBarRef, data) {
        this.snackBarRef = snackBarRef;
        this.data = data;
        if (!data) {
            this.data = { message: '' };
        }
    }
    onIconClicked() {
        this.data.callActionOnIconClick ? this.snackBarRef.dismissWithAction() : this.snackBarRef.dismiss();
    }
}
SnackbarContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentComponent, deps: [{ token: i1$7.MatSnackBarRef }, { token: MAT_SNACK_BAR_DATA }], target: i0.ɵɵFactoryTarget.Component });
SnackbarContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SnackbarContentComponent, selector: "adf-snackbar-content", host: { classAttribute: "mat-simple-snackbar" }, ngImport: i0, template: "<p class=\"adf-snackbar-message-content\" data-automation-id=\"adf-snackbar-message-content\" aria-hidden=\"true\"><mat-icon *ngIf=\"data.decorativeIcon\" data-automation-id=\"adf-snackbar-decorative-icon\">{{ data.decorativeIcon }}</mat-icon>{{ data.message }}</p>\n<div *ngIf=\"data.showAction\" class=\"adf-snackbar-message-content-action\" aria-hidden=\"true\">\n    <button mat-button (click)=\"snackBarRef.dismissWithAction()\" *ngIf=\"data.actionLabel\" class=\"adf-snackbar-message-content-action-button\"\n            data-automation-id=\"adf-snackbar-message-content-action-button\">\n        {{data.actionLabel}}\n    </button>\n    <button mat-button *ngIf=\"data.actionIcon\" (click)=\"onIconClicked()\" class=\"adf-snackbar-message-content-action-icon\"\n            [attr.aria-label]=\"data.actionIconAriaLabel | translate\">\n        <mat-icon>{{ data.actionIcon }}</mat-icon>\n    </button>\n</div>\n", styles: [":host{display:flex;align-items:center;justify-content:space-between}:host .adf-snackbar-message-content{display:flex;align-items:center;margin:0}:host .adf-snackbar-message-content mat-icon{margin-right:8px}:host .adf-snackbar-message-content-action{margin-left:24px}:host .adf-snackbar-message-content-action .mat-button{min-width:0;margin:-8px}:host .adf-snackbar-message-content-action .mat-button.adf-snackbar-message-content-action-button{margin-right:8px}:host .adf-snackbar-message-content-action .mat-button.adf-snackbar-message-content-action-icon{padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-snackbar-content', host: {
                        class: 'mat-simple-snackbar'
                    }, template: "<p class=\"adf-snackbar-message-content\" data-automation-id=\"adf-snackbar-message-content\" aria-hidden=\"true\"><mat-icon *ngIf=\"data.decorativeIcon\" data-automation-id=\"adf-snackbar-decorative-icon\">{{ data.decorativeIcon }}</mat-icon>{{ data.message }}</p>\n<div *ngIf=\"data.showAction\" class=\"adf-snackbar-message-content-action\" aria-hidden=\"true\">\n    <button mat-button (click)=\"snackBarRef.dismissWithAction()\" *ngIf=\"data.actionLabel\" class=\"adf-snackbar-message-content-action-button\"\n            data-automation-id=\"adf-snackbar-message-content-action-button\">\n        {{data.actionLabel}}\n    </button>\n    <button mat-button *ngIf=\"data.actionIcon\" (click)=\"onIconClicked()\" class=\"adf-snackbar-message-content-action-icon\"\n            [attr.aria-label]=\"data.actionIconAriaLabel | translate\">\n        <mat-icon>{{ data.actionIcon }}</mat-icon>\n    </button>\n</div>\n", styles: [":host{display:flex;align-items:center;justify-content:space-between}:host .adf-snackbar-message-content{display:flex;align-items:center;margin:0}:host .adf-snackbar-message-content mat-icon{margin-right:8px}:host .adf-snackbar-message-content-action{margin-left:24px}:host .adf-snackbar-message-content-action .mat-button{min-width:0;margin:-8px}:host .adf-snackbar-message-content-action .mat-button.adf-snackbar-message-content-action-button{margin-right:8px}:host .adf-snackbar-message-content-action .mat-button.adf-snackbar-message-content-action-icon{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$7.MatSnackBarRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SnackbarContentModule {
}
SnackbarContentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SnackbarContentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentModule, declarations: [SnackbarContentComponent], imports: [CommonModule,
        MatIconModule,
        MatSnackBarModule,
        MatButtonModule,
        TranslateModule], exports: [SnackbarContentComponent] });
SnackbarContentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentModule, imports: [CommonModule,
        MatIconModule,
        MatSnackBarModule,
        MatButtonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SnackbarContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatSnackBarModule,
                        MatButtonModule,
                        TranslateModule
                    ],
                    declarations: [
                        SnackbarContentComponent
                    ],
                    exports: [
                        SnackbarContentComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INFO_SNACK_CLASS = 'adf-info-snackbar';
const WARN_SNACK_CLASS = 'adf-warning-snackbar';
const ERROR_SNACK_CLASS = 'adf-error-snackbar';
class NotificationService {
    constructor(snackBar, translationService) {
        this.snackBar = snackBar;
        this.translationService = translationService;
        this.notifications$ = new Subject();
    }
    /**
     * Opens a SnackBar notification to show a message.
     *
     * @param message The message (or resource key) to show.
     * @param config Time before notification disappears after being shown or MatSnackBarConfig object
     * @param interpolateArgs The interpolation parameters to add for the translation
     * @returns Information/control object for the SnackBar
     */
    openSnackMessage(message, config, interpolateArgs) {
        return this.dispatchNotification(message, null, config, interpolateArgs);
    }
    /**
     * Opens a SnackBar notification with a message and a response button.
     *
     * @param message The message (or resource key) to show.
     * @param action Caption for the response button
     * @param config Time before notification disappears after being shown or MatSnackBarConfig object
     * @param interpolateArgs The interpolation parameters to add for the translation
     * @returns Information/control object for the SnackBar
     */
    openSnackMessageAction(message, action, config, interpolateArgs) {
        return this.dispatchNotification(message, action, config, interpolateArgs);
    }
    /**
     * Rase error message
     *
     * @param message Text message or translation key for the message.
     * @param action Action name
     * @param interpolateArgs The interpolation parameters to add for the translation
     * @param showAction True if action should be visible, false if not. Default: true.
     */
    showError(message, action, interpolateArgs, showAction = true) {
        return this.dispatchNotification(message, action, {
            panelClass: ERROR_SNACK_CLASS,
            data: {
                showAction
            }
        }, interpolateArgs);
    }
    /**
     * Rase info message
     *
     * @param message Text message or translation key for the message.
     * @param action Action name
     * @param interpolateArgs The interpolation parameters to add for the translation
     * @param showAction True if action should be visible, false if not. Default: true.
     */
    showInfo(message, action, interpolateArgs, showAction = true) {
        return this.dispatchNotification(message, action, {
            panelClass: INFO_SNACK_CLASS,
            data: {
                showAction
            }
        }, interpolateArgs);
    }
    /**
     * Rase warning message
     *
     * @param message Text message or translation key for the message.
     * @param action Action name
     * @param interpolateArgs The interpolation parameters to add for the translation
     * @param showAction True if action should be visible, false if not. Default: true.
     */
    showWarning(message, action, interpolateArgs, showAction = true) {
        return this.dispatchNotification(message, action, {
            panelClass: WARN_SNACK_CLASS,
            data: {
                showAction
            }
        }, interpolateArgs);
    }
    /**
     *  dismiss the notification snackbar
     */
    dismissSnackMessageAction() {
        return this.snackBar.dismiss();
    }
    /**
     * Push new notification to Notification History
     *
     * @param notification - Notification model to be pushed.
     */
    pushToNotificationHistory(notification) {
        this.notifications$.next(notification);
    }
    dispatchNotification(message, action, config, interpolateArgs) {
        const translatedMessage = this.translationService.instant(message, interpolateArgs);
        const translatedAction = this.translationService.instant(action, interpolateArgs);
        const createNotification = this.getNotificationCreator(config);
        this.notifications$.next(createNotification(translatedMessage));
        return this.snackBar.openFromComponent(SnackbarContentComponent, {
            ...(typeof config === 'number' && { duration: config }),
            panelClass: INFO_SNACK_CLASS,
            ...((typeof config === 'object') ? config : {}),
            data: {
                actionLabel: translatedAction,
                actionIcon: 'close',
                actionIconAriaLabel: 'CLOSE',
                message: translatedMessage,
                showAction: true,
                callActionOnIconClick: false,
                ...((typeof config === 'object') ? config.data : {})
            }
        });
    }
    getNotificationCreator(config) {
        let panelClass = null;
        if (typeof config === 'object') {
            panelClass = Array.isArray(config.panelClass) ? config.panelClass[0] : config.panelClass;
        }
        switch (panelClass) {
            case ERROR_SNACK_CLASS:
                return error;
            case WARN_SNACK_CLASS:
                return warning;
            default:
                return info;
        }
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationService, deps: [{ token: i1$7.MatSnackBar }, { token: TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$7.MatSnackBar }, { type: TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ClipboardService {
    constructor(document, logService, notificationService) {
        this.document = document;
        this.logService = logService;
        this.notificationService = notificationService;
    }
    /**
     * Checks if the target element can have its text copied.
     *
     * @param target Target HTML element
     * @returns True if the text can be copied, false otherwise
     */
    isTargetValid(target) {
        if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
            return !target.hasAttribute('disabled');
        }
        return false;
    }
    /**
     * Copies text from an HTML element to the clipboard.
     *
     * @param target HTML element to be copied
     * @param message Snackbar message to alert when copying happens
     */
    copyToClipboard(target, message) {
        if (this.isTargetValid(target)) {
            try {
                target.select();
                target.setSelectionRange(0, target.value.length);
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(target.value);
                }
                else {
                    this.document.execCommand('copy');
                }
                this.notify(message);
            }
            catch (error) {
                this.logService.error(error);
            }
        }
    }
    /**
     * Copies a text string to the clipboard.
     *
     * @param content Text to copy
     * @param message Snackbar message to alert when copying happens
     */
    copyContentToClipboard(content, message) {
        try {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(content);
            }
            else {
                document.addEventListener('copy', (e) => {
                    e.clipboardData.setData('text/plain', (content));
                    e.preventDefault();
                    document.removeEventListener('copy', null);
                });
                document.execCommand('copy');
            }
            this.notify(message);
        }
        catch (error) {
            this.logService.error(error);
        }
    }
    notify(message) {
        if (message) {
            this.notificationService.openSnackMessage(message);
        }
    }
}
ClipboardService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardService, deps: [{ token: DOCUMENT }, { token: LogService }, { token: NotificationService }], target: i0.ɵɵFactoryTarget.Injectable });
ClipboardService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: LogService }, { type: NotificationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ClipboardDirective {
    constructor(clipboardService, viewContainerRef, resolver) {
        this.clipboardService = clipboardService;
        this.viewContainerRef = viewContainerRef;
        this.resolver = resolver;
    }
    showTooltip() {
        if (this.placeholder) {
            const componentFactory = this.resolver.resolveComponentFactory(ClipboardComponent);
            const componentRef = this.viewContainerRef.createComponent(componentFactory).instance;
            componentRef.placeholder = this.placeholder;
        }
    }
    closeTooltip() {
        this.viewContainerRef.remove();
    }
    copyToClipboard(event) {
        event.preventDefault();
        event.stopPropagation();
        const isValidTarget = this.clipboardService.isTargetValid(this.target);
        if (isValidTarget) {
            this.clipboardService.copyToClipboard(this.target, this.message);
        }
        else {
            this.copyContentToClipboard(this.viewContainerRef.element.nativeElement.innerHTML);
        }
    }
    copyContentToClipboard(content) {
        this.clipboardService.copyContentToClipboard(content, this.message);
    }
}
ClipboardDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardDirective, deps: [{ token: ClipboardService }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive });
ClipboardDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ClipboardDirective, selector: "[adf-clipboard]", inputs: { placeholder: ["adf-clipboard", "placeholder"], target: "target", message: ["clipboard-notification", "message"] }, host: { listeners: { "mouseenter": "showTooltip()", "mouseleave": "closeTooltip()", "keydown.enter": "copyToClipboard($event)", "click": "copyToClipboard($event)" } }, exportAs: ["adfClipboard"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-clipboard]',
                    exportAs: 'adfClipboard'
                }]
        }], ctorParameters: function () { return [{ type: ClipboardService }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { placeholder: [{
                type: Input,
                args: ['adf-clipboard']
            }], target: [{
                type: Input
            }], message: [{
                type: Input,
                args: ['clipboard-notification']
            }], showTooltip: [{
                type: HostListener,
                args: ['mouseenter']
            }], closeTooltip: [{
                type: HostListener,
                args: ['mouseleave']
            }], copyToClipboard: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }, {
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class ClipboardComponent {
    ngOnInit() {
        this.placeholder = this.placeholder || 'CLIPBOARD.CLICK_TO_COPY';
    }
}
ClipboardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ClipboardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ClipboardComponent, selector: "adf-copy-content-tooltip", ngImport: i0, template: `<span class='adf-copy-tooltip'>{{ placeholder | translate }} </span>`, isInline: true, dependencies: [{ kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-copy-content-tooltip',
                    template: `<span class='adf-copy-tooltip'>{{ placeholder | translate }} </span>`,
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataTableCellComponent {
    constructor(dataTableService) {
        this.dataTableService = dataTableService;
        this.value$ = new BehaviorSubject('');
        /** Custom resolver function which is used to parse dynamic column objects */
        this.resolverFn = null;
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.updateValue();
        if (this.dataTableService) {
            this.dataTableService.rowUpdate
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(data => {
                if (data && data.id) {
                    if (this.row.id === data.id) {
                        if (this.row.obj && data.obj) {
                            this.row.obj = data.obj;
                            this.row['cache'][this.column.key] = this.column.key.split('.').reduce((source, key) => source ? source[key] : '', data.obj);
                            this.updateValue();
                        }
                    }
                }
            });
        }
    }
    updateValue() {
        if (this.column && this.column.key && this.row && this.data) {
            const value = this.data.getValue(this.row, this.column, this.resolverFn);
            this.value$.next(value);
            if (!this.tooltip) {
                this.tooltip = value;
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
DataTableCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableCellComponent, deps: [{ token: DataTableService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DataTableCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DataTableCellComponent, selector: "adf-datatable-cell", inputs: { data: "data", column: "column", row: "row", copyContent: "copyContent", tooltip: "tooltip", resolverFn: "resolverFn" }, host: { classAttribute: "adf-datatable-content-cell" }, ngImport: i0, template: `
        <ng-container>
            <span *ngIf="copyContent; else defaultCell"
                  adf-clipboard="CLIPBOARD.CLICK_TO_COPY"
                  [clipboard-notification]="'CLIPBOARD.SUCCESS_COPY'"
                  [attr.aria-label]="value$ | async"
                  [title]="tooltip"
                  class="adf-datatable-cell-value"
            >{{ value$ | async }}</span>
        </ng-container>
        <ng-template #defaultCell>
            <span
                [title]="tooltip"
                class="adf-datatable-cell-value"
            >{{ value$ | async }}</span>
        </ng-template>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ClipboardDirective, selector: "[adf-clipboard]", inputs: ["adf-clipboard", "target", "clipboard-notification"], exportAs: ["adfClipboard"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-datatable-cell',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
        <ng-container>
            <span *ngIf="copyContent; else defaultCell"
                  adf-clipboard="CLIPBOARD.CLICK_TO_COPY"
                  [clipboard-notification]="'CLIPBOARD.SUCCESS_COPY'"
                  [attr.aria-label]="value$ | async"
                  [title]="tooltip"
                  class="adf-datatable-cell-value"
            >{{ value$ | async }}</span>
        </ng-container>
        <ng-template #defaultCell>
            <span
                [title]="tooltip"
                class="adf-datatable-cell-value"
            >{{ value$ | async }}</span>
        </ng-template>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-datatable-content-cell' }
                }]
        }], ctorParameters: function () { return [{ type: DataTableService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], column: [{
                type: Input
            }], row: [{
                type: Input
            }], copyContent: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], resolverFn: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DateCellComponent extends DataTableCellComponent {
    constructor(userPreferenceService, dataTableService, appConfig) {
        super(dataTableService);
        this.dateFormat = appConfig.get('dateValues.defaultDateFormat', DateCellComponent.DATE_FORMAT);
        this.tooltipDateFormat = appConfig.get('dateValues.defaultTooltipDateFormat', DateCellComponent.DATE_FORMAT);
        if (userPreferenceService) {
            userPreferenceService
                .select(UserPreferenceValues.Locale)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(locale => this.currentLocale = locale);
        }
    }
    get format() {
        if (this.column) {
            return this.column.format || this.dateFormat;
        }
        return this.dateFormat;
    }
}
DateCellComponent.DATE_FORMAT = 'medium';
DateCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateCellComponent, deps: [{ token: UserPreferencesService }, { token: DataTableService, optional: true }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
DateCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DateCellComponent, selector: "adf-date-cell", host: { classAttribute: "adf-date-cell adf-datatable-content-cell" }, usesInheritance: true, ngImport: i0, template: `
        <ng-container>
            <span
                title="{{ tooltip | adfLocalizedDate: 'medium' }}"
                class="adf-datatable-cell-value"
                *ngIf="format === 'timeAgo'; else standard_date">
                {{ value$ | async | adfTimeAgo: currentLocale }}
            </span>
        </ng-container>
        <ng-template #standard_date>
            <span
                class="adf-datatable-cell-value"
                title="{{ tooltip | adfLocalizedDate: tooltipDateFormat }}">
                {{ value$ | async | adfLocalizedDate: format }}
            </span>
        </ng-template>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: TimeAgoPipe, name: "adfTimeAgo" }, { kind: "pipe", type: LocalizedDatePipe, name: "adfLocalizedDate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-date-cell',
                    template: `
        <ng-container>
            <span
                title="{{ tooltip | adfLocalizedDate: 'medium' }}"
                class="adf-datatable-cell-value"
                *ngIf="format === 'timeAgo'; else standard_date">
                {{ value$ | async | adfTimeAgo: currentLocale }}
            </span>
        </ng-container>
        <ng-template #standard_date>
            <span
                class="adf-datatable-cell-value"
                title="{{ tooltip | adfLocalizedDate: tooltipDateFormat }}">
                {{ value$ | async | adfLocalizedDate: format }}
            </span>
        </ng-template>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-date-cell adf-datatable-content-cell' }
                }]
        }], ctorParameters: function () { return [{ type: UserPreferencesService }, { type: DataTableService, decorators: [{
                    type: Optional
                }] }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileSizeCellComponent extends DataTableCellComponent {
    constructor(dataTableService) {
        super(dataTableService);
    }
}
FileSizeCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileSizeCellComponent, deps: [{ token: DataTableService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
FileSizeCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FileSizeCellComponent, selector: "adf-filesize-cell", host: { classAttribute: "adf-filesize-cell" }, usesInheritance: true, ngImport: i0, template: `
        <ng-container *ngIf="(value$ | async | adfFileSize) as fileSize">
            <span
                [title]="tooltip"
                >{{ fileSize }}</span
            >
        </ng-container>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FileSizePipe, name: "adfFileSize" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileSizeCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-filesize-cell',
                    template: `
        <ng-container *ngIf="(value$ | async | adfFileSize) as fileSize">
            <span
                [title]="tooltip"
                >{{ fileSize }}</span
            >
        </ng-container>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-filesize-cell' }
                }]
        }], ctorParameters: function () { return [{ type: DataTableService, decorators: [{
                    type: Optional
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LocationCellComponent extends DataTableCellComponent {
    constructor(dataTableService) {
        super(dataTableService);
    }
    /** @override */
    ngOnInit() {
        if (this.column && this.column.key && this.row && this.data) {
            const path = this.data.getValue(this.row, this.column, this.resolverFn);
            if (path && path.name && path.elements) {
                this.value$.next(path.name.split('/').pop());
                if (!this.tooltip) {
                    this.tooltip = path.name;
                }
                const parent = path.elements[path.elements.length - 1];
                this.link = [this.column.format, parent.id];
            }
        }
    }
}
LocationCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocationCellComponent, deps: [{ token: DataTableService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
LocationCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LocationCellComponent, selector: "adf-location-cell", inputs: { link: "link" }, host: { classAttribute: "adf-location-cell adf-datatable-content-cell" }, usesInheritance: true, ngImport: i0, template: `
        <ng-container>
            <a href="" [title]="tooltip" [routerLink]="link">
                {{ value$ | async }}
            </a>
        </ng-container>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2$4.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LocationCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-location-cell',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
        <ng-container>
            <a href="" [title]="tooltip" [routerLink]="link">
                {{ value$ | async }}
            </a>
        </ng-container>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-location-cell adf-datatable-content-cell' }
                }]
        }], ctorParameters: function () { return [{ type: DataTableService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { link: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EditJsonDialogComponent {
    constructor(settings) {
        this.settings = settings;
        this.editable = false;
        this.title = 'JSON';
        this.value = '';
    }
    ngOnInit() {
        if (this.settings) {
            this.editable = this.settings.editable;
            this.value = this.settings.value || '';
            this.title = this.settings.title || 'JSON';
        }
    }
}
EditJsonDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
EditJsonDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: EditJsonDialogComponent, selector: "ng-component", inputs: { value: "value" }, host: { classAttribute: "adf-edit-json-dialog" }, ngImport: i0, template: "<h1 mat-dialog-title>{{ title | translate }}</h1>\n<mat-dialog-content>\n    <textarea [(ngModel)]=\"value\" [attr.readonly]=\"!editable ? true : null\"></textarea>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n    <button mat-button mat-dialog-close cdkFocusInitial>\n        {{ 'CORE.DIALOG.EDIT_JSON.CLOSE' | translate }}\n    </button>\n    <button *ngIf=\"editable\" mat-button [mat-dialog-close]=\"value\">\n        {{ 'CORE.DIALOG.EDIT_JSON.UPDATE' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-edit-json-dialog .mat-dialog-content{height:300px;overflow:hidden}.adf-edit-json-dialog textarea{resize:none;width:100%;height:100%;margin:0;padding:0;box-sizing:border-box}.adf-edit-json-dialog textarea:focus{outline:none}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i1$4.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$4.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogComponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, host: { class: 'adf-edit-json-dialog' }, template: "<h1 mat-dialog-title>{{ title | translate }}</h1>\n<mat-dialog-content>\n    <textarea [(ngModel)]=\"value\" [attr.readonly]=\"!editable ? true : null\"></textarea>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n    <button mat-button mat-dialog-close cdkFocusInitial>\n        {{ 'CORE.DIALOG.EDIT_JSON.CLOSE' | translate }}\n    </button>\n    <button *ngIf=\"editable\" mat-button [mat-dialog-close]=\"value\">\n        {{ 'CORE.DIALOG.EDIT_JSON.UPDATE' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-edit-json-dialog .mat-dialog-content{height:300px;overflow:hidden}.adf-edit-json-dialog textarea{resize:none;width:100%;height:100%;margin:0;padding:0;box-sizing:border-box}.adf-edit-json-dialog textarea:focus{outline:none}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JsonCellComponent extends DataTableCellComponent {
    constructor(dialog, dataTableService) {
        super(dataTableService);
        this.dialog = dialog;
        /** Editable JSON. */
        this.editable = false;
    }
    ngOnInit() {
        if (this.column && this.column.key && this.row && this.data) {
            this.value$.next(this.data.getValue(this.row, this.column, this.resolverFn));
        }
    }
    view() {
        const rawValue = this.data.getValue(this.row, this.column, this.resolverFn);
        const value = typeof rawValue === 'object'
            ? JSON.stringify(rawValue || {}, null, 2)
            : rawValue;
        const settings = {
            title: this.column.title,
            editable: this.editable,
            value
        };
        this.dialog.open(EditJsonDialogComponent, {
            data: settings,
            minWidth: '50%',
            minHeight: '50%'
        }).afterClosed().subscribe(( /*result: string*/) => {
            if (typeof rawValue === 'object') {
                // todo: update cell value as object
            }
            else {
                // todo: update cell value as string
            }
        });
    }
}
JsonCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JsonCellComponent, deps: [{ token: i1$4.MatDialog }, { token: DataTableService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
JsonCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: JsonCellComponent, selector: "adf-json-cell", inputs: { editable: "editable" }, host: { classAttribute: "adf-datatable-content-cell" }, usesInheritance: true, ngImport: i0, template: `
        <ng-container *ngIf="value$ | async as value; else editEmpty">
            <button mat-button color="primary" (click)="view()">json</button>
        </ng-container>

        <ng-template #editEmpty>
            <button *ngIf="editable" mat-button color="primary" (click)="view()">json</button>
        </ng-template>
    `, isInline: true, styles: [".adf-datatable-json-cell{white-space:pre-wrap;word-wrap:break-word}.adf-datatable-cell-value{position:relative}\n"], dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JsonCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-json-cell', changeDetection: ChangeDetectionStrategy.OnPush, template: `
        <ng-container *ngIf="value$ | async as value; else editEmpty">
            <button mat-button color="primary" (click)="view()">json</button>
        </ng-container>

        <ng-template #editEmpty>
            <button *ngIf="editable" mat-button color="primary" (click)="view()">json</button>
        </ng-template>
    `, encapsulation: ViewEncapsulation.None, host: { class: 'adf-datatable-content-cell' }, styles: [".adf-datatable-json-cell{white-space:pre-wrap;word-wrap:break-word}.adf-datatable-cell-value{position:relative}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialog }, { type: DataTableService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { editable: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var DisplayMode;
(function (DisplayMode) {
    DisplayMode["List"] = "list";
    DisplayMode["Gallery"] = "gallery";
})(DisplayMode || (DisplayMode = {}));
// eslint-disable-next-line no-shadow
var ShowHeaderMode;
(function (ShowHeaderMode) {
    ShowHeaderMode["Never"] = "never";
    ShowHeaderMode["Always"] = "always";
    ShowHeaderMode["Data"] = "data";
})(ShowHeaderMode || (ShowHeaderMode = {}));
class DataTableComponent {
    constructor(elementRef, differs, matIconRegistry, sanitizer) {
        this.elementRef = elementRef;
        this.matIconRegistry = matIconRegistry;
        this.sanitizer = sanitizer;
        /** Selects the display mode of the table. Can be "list" or "gallery". */
        this.display = DisplayMode.List;
        /** The rows that the datatable will show. */
        this.rows = [];
        /** Define the sort order of the datatable. Possible values are :
         * [`created`, `desc`], [`created`, `asc`], [`due`, `desc`], [`due`, `asc`]
         */
        this.sorting = [];
        /** The columns that the datatable will show. */
        this.columns = [];
        /** Row selection mode. Can be none, `single` or `multiple`. For `multiple` mode,
         * you can use Cmd (macOS) or Ctrl (Win) modifier key to toggle selection for multiple rows.
         */
        this.selectionMode = 'single'; // none|single|multiple
        /** Toggles multiple row selection, which renders checkboxes at the beginning of each row. */
        this.multiselect = false;
        /** Toggles main data table action column. */
        this.mainTableAction = true;
        /** Toggles the data actions column. */
        this.actions = false;
        /** Toggles the main datatable action. */
        this.showMainDatatableActions = false;
        /** Position of the actions dropdown menu. Can be "left" or "right". */
        this.actionsPosition = 'right'; // left|right
        /** Toggles whether the actions dropdown should only be visible if the row is hovered over or the dropdown menu is open. */
        this.actionsVisibleOnHover = false;
        /** Toggles custom context menu for the component. */
        this.contextMenu = false;
        /** The CSS class to apply to every row. */
        this.rowStyleClass = '';
        /** Toggles the header. */
        this.showHeader = ShowHeaderMode.Data;
        /** Toggles the sticky header mode. */
        this.stickyHeader = false;
        /** Emitted when the user clicks a row. */
        this.rowClick = new EventEmitter();
        /** Emitted when the user double-clicks a row. */
        this.rowDblClick = new EventEmitter();
        /** Emitted before the context menu is displayed for a row. */
        this.showRowContextMenu = new EventEmitter();
        /** Emitted before the actions menu is displayed for a row. */
        this.showRowActionsMenu = new EventEmitter();
        /** Emitted when the user executes a row action. */
        this.executeRowAction = new EventEmitter();
        /** Emitted when the column order is changed. */
        this.columnOrderChanged = new EventEmitter();
        /** Emitted when the column width is changed. */
        this.columnsWidthChanged = new EventEmitter();
        /** Flag that indicates if the datatable is in loading state and needs to show the
         * loading template (see the docs to learn how to configure a loading template).
         */
        this.loading = false;
        /** Flag that indicates if the datatable should show the "no permission" template. */
        this.noPermission = false;
        /**
         * Should the items for the row actions menu be cached for reuse after they are loaded
         * the first time?
         */
        this.rowMenuCacheEnabled = true;
        /**
         * Custom resolver function which is used to parse dynamic column objects
         * see the docs to learn how to configure a resolverFn.
         */
        this.resolverFn = null;
        /**
         * Flag that indicate if the datatable allow the use facet widget search for filtering.
         */
        this.allowFiltering = false;
        /**
         * Flag that indicates if the datatable allows column resizing.
         */
        this.isResizingEnabled = false;
        this.isSelectAllIndeterminate = false;
        this.isSelectAllChecked = false;
        this.selection = new Array();
        this.selectedRowId = '';
        this.isDraggingHeaderColumn = false;
        this.hoveredHeaderColumnIndex = -1;
        this.isResizing = false;
        /** This array of fake rows fix the flex layout for the gallery view */
        this.fakeRows = [];
        this.rowMenuCache = {};
        this.subscriptions = [];
        if (differs) {
            this.differ = differs.find([]).create(null);
        }
        this.click$ = new Observable((observer) => this.clickObserver = observer)
            .pipe(share());
    }
    onKeydown(event) {
        this.keyManager.onKeydown(event);
    }
    ngOnInit() {
        this.registerDragHandleIcon();
    }
    ngAfterContentInit() {
        if (this.columnList) {
            this.subscriptions.push(this.columnList.columns.changes.subscribe(() => {
                this.setTableSchema();
            }));
        }
        this.datatableLayoutFix();
        this.setTableSchema();
    }
    ngAfterViewInit() {
        this.keyManager = new FocusKeyManager(this.rowsList)
            .withWrap()
            .skipPredicate(item => item.disabled);
    }
    ngOnChanges(changes) {
        this.initAndSubscribeClickStream();
        if (this.selectedRowId) {
            this.setRowAsContextSource();
        }
        const dataChanges = changes['data'];
        const rowChanges = changes['rows'];
        const columnChanges = changes['columns'];
        if (this.isPropertyChanged(dataChanges) || this.isPropertyChanged(rowChanges) || this.isPropertyChanged(columnChanges)) {
            if (this.isTableEmpty()) {
                this.initTable();
            }
            else {
                if (dataChanges) {
                    this.data = changes['data'].currentValue;
                    this.resetSelection();
                }
                if (rowChanges) {
                    this.setTableRows(changes['rows'].currentValue);
                    this.setTableSorting(this.sorting);
                }
                if (columnChanges) {
                    this.setTableColumns(changes['columns'].currentValue);
                }
            }
            return;
        }
        if (changes.selectionMode && !changes.selectionMode.isFirstChange()) {
            this.resetSelection();
            this.emitRowSelectionEvent('row-unselect', null);
        }
        if (this.isPropertyChanged(changes['sorting'])) {
            this.setTableSorting(changes['sorting'].currentValue);
        }
        if (this.isPropertyChanged(changes['display'])) {
            this.datatableLayoutFix();
        }
    }
    isColumnSortActive(column) {
        if (!column || !this.data.getSorting()) {
            return false;
        }
        return column.key === this.data.getSorting().key;
    }
    onDropHeaderColumn(event) {
        const allColumns = this.data.getColumns();
        const shownColumns = allColumns.filter(column => !column.isHidden);
        const hiddenColumns = allColumns.filter(column => column.isHidden);
        moveItemInArray(shownColumns, event.previousIndex, event.currentIndex);
        const allColumnsWithNewOrder = [...shownColumns, ...hiddenColumns];
        this.setTableColumns(allColumnsWithNewOrder);
        this.columnOrderChanged.emit(allColumnsWithNewOrder);
        this.isDraggingHeaderColumn = false;
    }
    ngDoCheck() {
        const changes = this.differ.diff(this.rows);
        if (changes) {
            this.setTableRows(this.rows);
        }
    }
    isPropertyChanged(property) {
        return !!(property && property.currentValue);
    }
    convertToRowsData(rows) {
        return rows.map((row) => new ObjectDataRow(row, row.isSelected));
    }
    convertToColumnsData(columns) {
        return columns.map((column) => new ObjectDataColumn(column));
    }
    convertToDataSorting(sorting) {
        if (sorting && sorting.length > 0) {
            return new DataSorting(sorting[0], sorting[1]);
        }
        return null;
    }
    initAndSubscribeClickStream() {
        this.unsubscribeClickStream();
        const singleClickStream = this.click$
            .pipe(buffer(this.click$.pipe(debounceTime(250))), map((list) => list), filter((x) => x.length === 1));
        this.singleClickStreamSub = singleClickStream.subscribe((dataRowEvents) => {
            const event = dataRowEvents[0];
            this.handleRowSelection(event.value, event.event);
            this.rowClick.emit(event);
            if (!event.defaultPrevented) {
                this.elementRef.nativeElement.dispatchEvent(new CustomEvent('row-click', {
                    detail: event,
                    bubbles: true
                }));
            }
        });
        const multiClickStream = this.click$
            .pipe(buffer(this.click$.pipe(debounceTime(250))), map((list) => list), filter((x) => x.length >= 2));
        this.multiClickStreamSub = multiClickStream.subscribe((dataRowEvents) => {
            const event = dataRowEvents[0];
            this.rowDblClick.emit(event);
            if (!event.defaultPrevented) {
                this.elementRef.nativeElement.dispatchEvent(new CustomEvent('row-dblclick', {
                    detail: event,
                    bubbles: true
                }));
            }
        });
    }
    unsubscribeClickStream() {
        if (this.singleClickStreamSub) {
            this.singleClickStreamSub.unsubscribe();
            this.singleClickStreamSub = null;
        }
        if (this.multiClickStreamSub) {
            this.multiClickStreamSub.unsubscribe();
            this.multiClickStreamSub = null;
        }
    }
    initTable() {
        const runtimeColumns = this.getRuntimeColumns();
        this.data = new ObjectDataTableAdapter(this.rows, runtimeColumns);
        this.setTableSorting(this.sorting);
        this.resetSelection();
        this.rowMenuCache = {};
    }
    isTableEmpty() {
        return this.data === undefined || this.data === null;
    }
    setTableRows(rows) {
        if (this.data) {
            this.resetSelection();
            const rowsData = this.convertToRowsData(rows);
            this.data.setRows(rowsData);
        }
    }
    setTableColumns(columns) {
        if (this.data) {
            this.resetSelection();
            const columnsData = this.convertToColumnsData(columns);
            this.data.setColumns(columnsData);
        }
    }
    getRuntimeColumns() {
        return [
            ...(this.columns || []),
            ...this.getSchemaFromHtml()
        ];
    }
    setTableSchema() {
        const columns = this.getRuntimeColumns();
        if (this.data && columns.length > 0) {
            this.data.setColumns(columns);
        }
    }
    setTableSorting(sorting) {
        if (this.data) {
            this.data.setSorting(this.convertToDataSorting(sorting));
        }
    }
    getSchemaFromHtml() {
        let schema = [];
        if (this.columnList && this.columnList.columns && this.columnList.columns.length > 0) {
            schema = this.columnList.columns.map((c) => c);
        }
        return schema;
    }
    onRowClick(row, mouseEvent) {
        if (mouseEvent) {
            mouseEvent.preventDefault();
        }
        if (row) {
            const rowIndex = this.data.getRows().indexOf(row) + (this.isHeaderListVisible() ? 1 : 0);
            this.keyManager.setActiveItem(rowIndex);
            const dataRowEvent = new DataRowEvent(row, mouseEvent, this);
            this.clickObserver.next(dataRowEvent);
        }
    }
    onEnterKeyPressed(row, e) {
        if (row) {
            this.handleRowSelection(row, e);
        }
    }
    isHeaderListVisible() {
        return this.isHeaderVisible() && this.display === DisplayMode.List;
    }
    handleRowSelection(row, e) {
        if (this.data) {
            if (this.isSingleSelectionMode()) {
                this.resetSelection();
                this.selectRow(row, true);
                this.emitRowSelectionEvent('row-select', row);
            }
            if (this.isMultiSelectionMode()) {
                const modifier = e && (e.metaKey || e.ctrlKey);
                let newValue;
                if (this.selection.length === 1) {
                    newValue = !row.isSelected;
                }
                else {
                    newValue = modifier ? !row.isSelected : true;
                }
                const domEventName = newValue ? 'row-select' : 'row-unselect';
                if (!modifier) {
                    this.resetSelection();
                }
                this.selectRow(row, newValue);
                this.emitRowSelectionEvent(domEventName, row);
            }
        }
    }
    resetSelection() {
        if (this.data) {
            const rows = this.data.getRows();
            if (rows && rows.length > 0) {
                rows.forEach((r) => r.isSelected = false);
            }
            this.selection = [];
        }
        this.isSelectAllChecked = false;
    }
    onRowDblClick(row, event) {
        if (event) {
            event.preventDefault();
        }
        const dataRowEvent = new DataRowEvent(row, event, this);
        this.clickObserver.next(dataRowEvent);
    }
    onRowEnterKeyDown(row, keyboardEvent) {
        if (keyboardEvent.key === 'Enter') {
            this.onKeyboardNavigate(row, keyboardEvent);
        }
    }
    onRowKeyUp(row, keyboardEvent) {
        const event = new CustomEvent('row-keyup', {
            detail: {
                row,
                keyboardEvent,
                sender: this
            },
            bubbles: true
        });
        this.elementRef.nativeElement.dispatchEvent(event);
        if (event.defaultPrevented) {
            keyboardEvent.preventDefault();
        }
    }
    onKeyboardNavigate(row, keyboardEvent) {
        if (keyboardEvent) {
            keyboardEvent.preventDefault();
        }
        const event = new DataRowEvent(row, keyboardEvent, this);
        this.rowDblClick.emit(event);
        this.elementRef.nativeElement.dispatchEvent(new CustomEvent('row-dblclick', {
            detail: event,
            bubbles: true
        }));
    }
    isValidClickEvent(event) {
        if (event instanceof MouseEvent) {
            return event.eventPhase === event.BUBBLING_PHASE;
        }
        else if (event instanceof KeyboardEvent) {
            return event.eventPhase === event.AT_TARGET;
        }
        return false;
    }
    onColumnHeaderClick(column, event) {
        if (this.isValidClickEvent(event) && column && column.sortable) {
            const current = this.data.getSorting();
            let newDirection = 'asc';
            if (current && column.key === current.key) {
                newDirection = current.direction?.toLowerCase() === 'asc' ? 'desc' : 'asc';
            }
            this.sorting = [column.key, newDirection];
            this.data.setSorting(new DataSorting(column.key, newDirection));
            this.emitSortingChangedEvent(column.key, column.sortingKey, newDirection);
        }
        this.keyManager.updateActiveItem(0);
    }
    onSelectAllClick(matCheckboxChange) {
        this.isSelectAllChecked = matCheckboxChange.checked;
        this.isSelectAllIndeterminate = false;
        if (this.multiselect) {
            const rows = this.data.getRows();
            if (rows && rows.length > 0) {
                for (let i = 0; i < rows.length; i++) {
                    this.selectRow(rows[i], matCheckboxChange.checked);
                }
            }
            const domEventName = matCheckboxChange.checked ? 'row-select' : 'row-unselect';
            const row = this.selection.length > 0 ? this.selection[0] : null;
            this.emitRowSelectionEvent(domEventName, row);
        }
    }
    onCheckboxChange(row, event) {
        const newValue = event.checked;
        this.selectRow(row, newValue);
        const domEventName = newValue ? 'row-select' : 'row-unselect';
        this.emitRowSelectionEvent(domEventName, row);
        this.checkSelectAllCheckboxState();
    }
    checkSelectAllCheckboxState() {
        if (this.multiselect) {
            let numberOfSelectedRows = 0;
            const rows = this.data.getRows();
            rows.forEach((row) => {
                if (row.isSelected) {
                    numberOfSelectedRows++;
                }
            });
            if (numberOfSelectedRows === rows.length) {
                this.isSelectAllChecked = true;
                this.isSelectAllIndeterminate = false;
            }
            else if (numberOfSelectedRows > 0 && numberOfSelectedRows < rows.length) {
                this.isSelectAllChecked = false;
                this.isSelectAllIndeterminate = true;
            }
            else {
                this.isSelectAllChecked = false;
                this.isSelectAllIndeterminate = false;
            }
        }
    }
    onImageLoadingError(event, row) {
        if (event) {
            const element = event.target;
            if (this.fallbackThumbnail) {
                element.src = this.fallbackThumbnail;
            }
            else {
                element.src = row.imageErrorResolver(event);
            }
        }
    }
    isIconValue(row, col) {
        if (row && col) {
            const value = row.getValue(col.key);
            return value && value.startsWith('material-icons://');
        }
        return false;
    }
    asIconValue(row, col) {
        if (this.isIconValue(row, col)) {
            const value = row.getValue(col.key) || '';
            return value.replace('material-icons://', '');
        }
        return null;
    }
    iconAltTextKey(value) {
        return value ? 'ICONS.' + value.substring(value.lastIndexOf('/') + 1).replace(/\.[a-z]+/, '') : '';
    }
    isColumnSorted(col, direction) {
        if (col && direction) {
            const sorting = this.data.getSorting();
            return sorting && sorting.key === col.key && sorting.direction.toLocaleLowerCase() === direction;
        }
        return false;
    }
    getContextMenuActions(row, col) {
        const event = new DataCellEvent(row, col, []);
        this.showRowContextMenu.emit(event);
        return event.value.actions;
    }
    getRowActions(row, col) {
        const id = row.getValue('id');
        if (!this.rowMenuCache[id]) {
            const event = new DataCellEvent(row, col, []);
            this.showRowActionsMenu.emit(event);
            if (!this.rowMenuCacheEnabled) {
                return this.getVisibleActions(event.value.actions);
            }
            this.rowMenuCache[id] = event.value.actions;
        }
        return this.getVisibleActions(this.rowMenuCache[id]);
    }
    getVisibleActions(actions) {
        return actions.filter((action) => action.visible || action.visible === undefined);
    }
    onExecuteRowAction(row, action) {
        if (action.disabled || action.disabled) {
            event.stopPropagation();
        }
        else {
            this.executeRowAction.emit(new DataRowActionEvent(row, action));
        }
    }
    getHideActionsWithoutHoverClass(actionsMenuTrigger) {
        return { 'adf-datatable-hide-actions-without-hover': this.actionsVisibleOnHover && !actionsMenuTrigger.menuOpen };
    }
    rowAllowsDrop(row) {
        return row.isDropTarget === true;
    }
    hasSelectionMode() {
        return this.isSingleSelectionMode() || this.isMultiSelectionMode();
    }
    isSingleSelectionMode() {
        return this.selectionMode && this.selectionMode.toLowerCase() === 'single';
    }
    isMultiSelectionMode() {
        return this.selectionMode && this.selectionMode.toLowerCase() === 'multiple';
    }
    getRowStyle(row) {
        row.cssClass = row.cssClass ? row.cssClass : '';
        this.rowStyleClass = this.rowStyleClass ? this.rowStyleClass : '';
        const contextMenuSourceClass = row.isContextMenuSource ? 'adf-context-menu-source' : '';
        return `${row.cssClass} ${this.rowStyleClass} ${contextMenuSourceClass}`;
    }
    markRowAsContextMenuSource(selectedRow) {
        this.selectedRowId = selectedRow.id ? selectedRow.id : '';
        this.data.getRows().forEach((row) => row.isContextMenuSource = false);
        selectedRow.isContextMenuSource = true;
    }
    setRowAsContextSource() {
        const selectedRow = this.data.getRows().find((row) => this.selectedRowId === row.id);
        if (selectedRow) {
            selectedRow.isContextMenuSource = true;
        }
    }
    getSortingKey() {
        if (this.data.getSorting()) {
            return this.data.getSorting().key;
        }
        return null;
    }
    selectRow(row, value) {
        if (row) {
            row.isSelected = value;
            const idx = row?.id ? this.findSelectionById(row.id) : this.selection.indexOf(row);
            if (value) {
                if (idx < 0) {
                    this.selection.push(row);
                }
            }
            else {
                if (idx > -1) {
                    this.selection.splice(idx, 1);
                }
            }
        }
    }
    findSelectionById(id) {
        return this.selection.findIndex(selection => selection?.id === id);
    }
    getCellTooltip(row, col) {
        if (row && col && col.formatTooltip) {
            const result = col.formatTooltip(row, col);
            if (result) {
                return result;
            }
        }
        return null;
    }
    getSortableColumns() {
        return this.data.getColumns().filter((column) => column.sortable === true);
    }
    isEmpty() {
        return this.data.getRows().length === 0;
    }
    isHeaderVisible() {
        let headerVisibility;
        if (this.showHeader === ShowHeaderMode.Data) {
            headerVisibility = !this.loading && !this.noPermission && !this.isEmpty();
        }
        else if (this.showHeader === ShowHeaderMode.Always) {
            headerVisibility = !this.loading && !this.noPermission;
        }
        else if (this.showHeader === ShowHeaderMode.Never) {
            headerVisibility = false;
        }
        return headerVisibility;
    }
    isStickyHeaderEnabled() {
        return this.stickyHeader && this.isHeaderVisible();
    }
    emitRowSelectionEvent(name, row) {
        const domEvent = new CustomEvent(name, {
            detail: {
                row,
                selection: this.selection
            },
            bubbles: true
        });
        this.elementRef.nativeElement.dispatchEvent(domEvent);
    }
    emitSortingChangedEvent(key, sortingKey, direction) {
        const domEvent = new CustomEvent('sorting-changed', {
            detail: {
                key,
                sortingKey,
                direction
            },
            bubbles: true
        });
        this.elementRef.nativeElement.dispatchEvent(domEvent);
    }
    ngOnDestroy() {
        this.unsubscribeClickStream();
        this.subscriptions.forEach((s) => s.unsubscribe());
        this.subscriptions = [];
        if (this.dataRowsChanged) {
            this.dataRowsChanged.unsubscribe();
            this.dataRowsChanged = null;
        }
    }
    datatableLayoutFix() {
        const maxGalleryRows = 25;
        if (this.display === 'gallery') {
            for (let i = 0; i < maxGalleryRows; i++) {
                this.fakeRows.push('');
            }
        }
        else {
            this.fakeRows = [];
        }
    }
    getNameColumnValue() {
        return this.data.getColumns().find((el) => el.key.includes('name'));
    }
    getAutomationValue(row) {
        const name = this.getNameColumnValue();
        return name ? row.getValue(name.key) : '';
    }
    getAriaSort(column) {
        if (!this.isColumnSortActive(column)) {
            return 'ADF-DATATABLE.ACCESSIBILITY.SORT_NONE';
        }
        return this.isColumnSorted(column, 'asc') ?
            'ADF-DATATABLE.ACCESSIBILITY.SORT_ASCENDING' :
            'ADF-DATATABLE.ACCESSIBILITY.SORT_DESCENDING';
    }
    getSortLiveAnnouncement(column) {
        if (!this.isColumnSortActive(column)) {
            return 'ADF-DATATABLE.ACCESSIBILITY.SORT_DEFAULT';
        }
        return this.isColumnSorted(column, 'asc') ?
            'ADF-DATATABLE.ACCESSIBILITY.SORT_ASCENDING_BY' :
            'ADF-DATATABLE.ACCESSIBILITY.SORT_DESCENDING_BY';
    }
    registerDragHandleIcon() {
        const iconUrl = this.sanitizer.bypassSecurityTrustResourceUrl('./assets/images/drag_indicator_24px.svg');
        this.matIconRegistry.addSvgIconInNamespace('adf', 'drag_indicator', iconUrl);
    }
    onResizing({ rectangle: { width } }, colIndex) {
        const timeoutId = setTimeout(() => {
            const allColumns = this.data.getColumns().filter(column => !column.isHidden);
            allColumns[colIndex].width = width;
            this.data.setColumns(allColumns);
            if (!this.isResizing) {
                clearTimeout(timeoutId);
            }
        });
    }
    onResizingEnd() {
        this.isResizing = false;
        this.updateColumnsWidths();
    }
    getFlexValue({ width = 0 }) {
        return `0 1 ${width < DataTableComponent.MINIMUM_COLUMN_SIZE ? DataTableComponent.MINIMUM_COLUMN_SIZE : width}px`;
    }
    updateColumnsWidths() {
        const allColumns = this.data.getColumns();
        const headerContainer = document.querySelector('.adf-datatable-header');
        if (headerContainer) {
            const headerContainerColumns = headerContainer.querySelectorAll('.adf-datatable-cell-header');
            headerContainerColumns.forEach((column, index) => {
                if (allColumns[index]) {
                    allColumns[index].width = column.offsetWidth ?? DataTableComponent.MINIMUM_COLUMN_SIZE;
                }
            });
        }
        this.data.setColumns(allColumns);
        this.columnsWidthChanged.emit(allColumns);
    }
}
DataTableComponent.MINIMUM_COLUMN_SIZE = 100;
DataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableComponent, deps: [{ token: i0.ElementRef }, { token: i0.IterableDiffers }, { token: i1$3.MatIconRegistry }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
DataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DataTableComponent, selector: "adf-datatable", inputs: { data: "data", display: "display", rows: "rows", sorting: "sorting", columns: "columns", selectionMode: "selectionMode", multiselect: "multiselect", mainTableAction: "mainTableAction", actions: "actions", showMainDatatableActions: "showMainDatatableActions", actionsPosition: "actionsPosition", actionsVisibleOnHover: "actionsVisibleOnHover", fallbackThumbnail: "fallbackThumbnail", contextMenu: "contextMenu", rowStyle: "rowStyle", rowStyleClass: "rowStyleClass", showHeader: "showHeader", stickyHeader: "stickyHeader", loading: "loading", noPermission: "noPermission", rowMenuCacheEnabled: "rowMenuCacheEnabled", resolverFn: "resolverFn", allowFiltering: "allowFiltering", isResizingEnabled: "isResizingEnabled" }, outputs: { rowClick: "rowClick", rowDblClick: "rowDblClick", showRowContextMenu: "showRowContextMenu", showRowActionsMenu: "showRowActionsMenu", executeRowAction: "executeRowAction", columnOrderChanged: "columnOrderChanged", columnsWidthChanged: "columnsWidthChanged" }, host: { listeners: { "keyup": "onKeydown($event)" }, classAttribute: "adf-datatable" }, queries: [{ propertyName: "columnList", first: true, predicate: DataColumnListComponent, descendants: true }], viewQueries: [{ propertyName: "rowsList", predicate: DataTableRowComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n    role=\"grid\"\n    *ngIf=\"data\" class=\"adf-full-width\"\n    [class.adf-datatable-card]=\"display === 'gallery'\"\n    [class.adf-datatable-list]=\"display === 'list'\"\n    [class.adf-sticky-header]=\"isStickyHeaderEnabled()\"\n    [class.adf-datatable--empty]=\"(isEmpty() && !isHeaderVisible()) || loading\"\n    [class.adf-datatable--empty--header-visible]=\"isEmpty() && isHeaderVisible()\">\n    <div *ngIf=\"isHeaderVisible()\" class=\"adf-datatable-header\" role=\"rowgroup\" [ngClass]=\"{ 'adf-sr-only': !isHeaderVisible() }\">\n        <adf-datatable-row\n            cdkDropList\n            cdkDropListOrientation=\"horizontal\"\n            data-automation-id=\"datatable-row-header\"\n            [disabled]=\"!isHeaderVisible()\"\n            class=\"adf-datatable-row\"\n            *ngIf=\"display === 'list'\"\n            role=\"row\">\n\n            <!-- Actions (left) -->\n            <div *ngIf=\"actions && actionsPosition === 'left'\" class=\"adf-actions-column adf-datatable-cell-header\">\n                <span class=\"adf-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.ACTIONS' | translate }}</span>\n            </div>\n\n            <!-- Columns -->\n            <div *ngIf=\"multiselect\" class=\"adf-datatable-cell-header adf-datatable-checkbox\">\n                <mat-checkbox [indeterminate]=\"isSelectAllIndeterminate\" [checked]=\"isSelectAllChecked\" (change)=\"onSelectAllClick($event)\" class=\"adf-checkbox-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.SELECT_ALL' | translate }}</mat-checkbox>\n            </div>\n\n            <div class=\"adf-datatable-cell--{{col.type || 'text'}} {{col.cssClass}} adf-datatable-cell-header\"\n                 *ngFor=\"\n                    let col of (data.getColumns() | filterOutEvery:'isHidden':true);\n                    let columnIndex = index\"\n                 [attr.data-automation-id]=\"'auto_id_' + col.key\"\n                 [ngClass]=\"{\n                    'adf-sortable': col.sortable,\n                    'adf-datatable__cursor--pointer': !isResizing,\n                    'adf-datatable__header--sorted-asc': isColumnSorted(col, 'asc'),\n                    'adf-datatable__header--sorted-desc': isColumnSorted(col, 'desc')}\"\n                 [ngStyle]=\"(col.width) && {'flex': getFlexValue(col)}\"\n                 [attr.aria-label]=\"col.title | translate\"\n                 (click)=\"onColumnHeaderClick(col, $event)\"\n                 (keyup.enter)=\"onColumnHeaderClick(col, $event)\"\n                 role=\"columnheader\"\n                 [attr.tabindex]=\"isHeaderVisible() ? 0 : null\"\n                 [attr.aria-sort]=\"col.sortable ? (getAriaSort(col) | translate) : null\"\n                 cdkDrag\n                 cdkDragBoundary=\"adf-datatable-row\"\n                 cdkDragLockAxis=\"x\"\n                 (cdkDragStarted)=\"isDraggingHeaderColumn = true\"\n                 (cdkDragDropped)=\"onDropHeaderColumn($event)\"\n                 [cdkDragDisabled]=\"!col.draggable\"\n                 (mouseenter)=\"hoveredHeaderColumnIndex = columnIndex\"\n                 (mouseleave)=\"hoveredHeaderColumnIndex = -1\"\n                 adf-drop-zone dropTarget=\"header\" [dropColumn]=\"col\">\n\n                <div\n                    adf-resizable\n                    #resizableElement=\"adf-resizable\"\n                    (resizing)=\"onResizing($event, columnIndex)\"\n                    (resizeStart)=\"isResizing = true\"\n                    (resizeEnd)=\"onResizingEnd()\"\n                    [attr.data-automation-id]=\"'auto_header_content_id_' + col.key\"\n                    class=\"adf-datatable-cell-header-content\"\n                    [ngClass]=\"{ 'adf-datatable-cell-header-content--hovered':\n                        hoveredHeaderColumnIndex === columnIndex &&\n                        !isDraggingHeaderColumn &&\n                        !isResizing }\"\n                >\n                    <span\n                        *ngIf=\"hoveredHeaderColumnIndex === columnIndex && col.draggable && !isResizing\"\n                        class=\"adf-datatable-cell-header-drag-icon-placeholder\"\n                        [attr.data-automation-id]=\"'adf-datatable-cell-header-drag-icon-placeholder-'+col.key\"\n                    ></span>\n\n                    <ng-container *ngIf=\"!col.header\">\n                        <span *ngIf=\"col.title\" class=\"adf-datatable-cell-value\">{{col.title | translate}}</span>\n\n                        <span *ngIf=\"col.title && col.sortable && isDraggingHeaderColumn\" class=\"adf-sr-only\" aria-live=\"polite\">\n                            {{ getSortLiveAnnouncement(col) | translate: { string: col.title | translate } }}\n                        </span>\n\n                        <span *ngIf=\"!col.title && !col.sortable && !headerFilterTemplate\" [attr.title]=\"'ADF-DATATABLE.ACCESSIBILITY.EMPTY_HEADER' | translate\"></span>\n                    </ng-container>\n\n                    <div *ngIf=\"col.header\" class=\"adf-datatable-cell-value\">\n                        <ng-template [ngTemplateOutlet]=\"col.header\" [ngTemplateOutletContext]=\"{$implicit: col}\"></ng-template>\n                    </div>\n\n                    <ng-template *ngIf=\"allowFiltering\" [ngTemplateOutlet]=\"headerFilterTemplate\" [ngTemplateOutletContext]=\"{$implicit: col}\"></ng-template>\n\n                    <span\n                        [class.adf-datatable__header--sorted-asc]=\"isColumnSorted(col, 'asc')\"\n                        [class.adf-datatable__header--sorted-desc]=\"isColumnSorted(col, 'desc')\">\n                    </span>\n                </div>\n                <div\n                    *ngIf=\"isResizingEnabled\"\n                    adf-resize-handle\n                    class=\"adf-datatable__resize-handle\"\n                    [resizableContainer]=\"resizableElement\">\n                    <div class=\"adf-datatable__resize-handle--divider\"></div>\n                </div>\n                <div\n                    *ngIf=\"col.draggable\"\n                    cdkDragHandle\n                    [ngClass]=\"{ 'adf-datatable-cell-header-drag-icon': !isResizing }\"\n                >\n                    <adf-icon\n                        *ngIf=\"hoveredHeaderColumnIndex === columnIndex && !isResizing\"\n                        value=\"adf:drag_indicator\"\n                        [attr.data-automation-id]=\"'adf-datatable-cell-header-drag-icon-'+col.key\">\n                    </adf-icon>\n                </div>\n\n                <div class=\"adf-drop-header-cell-placeholder\" *cdkDragPlaceholder></div>\n            </div>\n\n            <!-- Header actions (right) -->\n            <div\n                *ngIf=\"(actions && actionsPosition === 'right') ||\n                       (mainActionTemplate && showMainDatatableActions)\"\n                class=\"adf-actions-column adf-datatable-cell-header adf-datatable__actions-cell\"\n            >\n                <ng-container *ngIf=\"mainActionTemplate\">\n                    <button\n                        data-automation-id=\"adf-datatable-main-menu-button\"\n                        mat-icon-button\n                        #mainMenuTrigger=\"matMenuTrigger\"\n                        [matMenuTriggerFor]=\"mainMenu\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n\n                    <mat-menu #mainMenu>\n                        <ng-container\n                            [ngTemplateOutlet]=\"mainActionTemplate\"\n                            [ngTemplateOutletContext]=\"{\n                                $implicit: mainMenuTrigger\n                            }\">\n                        </ng-container>\n                    </mat-menu>\n                    <span class=\"adf-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.ACTIONS' | translate }}</span>\n                </ng-container>\n            </div>\n\n        </adf-datatable-row>\n        <mat-form-field *ngIf=\"display === 'gallery' && isHeaderVisible()\">\n            <mat-select [value]=\"getSortingKey()\" [attr.data-automation-id]=\"'grid-view-sorting'\">\n                <mat-option *ngFor=\"let col of getSortableColumns()\"\n                            [value]=\"col.key\"\n                            [attr.data-automation-id]=\"'grid-view-sorting-'+col.title\"\n                            (click)=\"onColumnHeaderClick(col, $event)\"\n                            (keyup.enter)=\"onColumnHeaderClick(col, $event)\">\n                    {{ col.title | translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n    </div>\n\n    <div\n        class=\"adf-datatable-body\"\n        [ngClass]=\"{ 'adf-blur-datatable-body': isDraggingHeaderColumn || isResizing }\"\n        role=\"rowgroup\">\n        <ng-container *ngIf=\"!loading && !noPermission\">\n            <adf-datatable-row *ngFor=\"let row of data.getRows(); let idx = index\"\n                [row]=\"row\"\n                (select)=\"onEnterKeyPressed(row, $event)\"\n                (keyup)=\"onRowKeyUp(row, $event)\"\n                (keydown)=\"onRowEnterKeyDown(row, $event)\"\n                [adf-upload]=\"rowAllowsDrop(row)\"\n                [adf-upload-data]=\"row\"\n                [ngStyle]=\"rowStyle\"\n                [ngClass]=\"getRowStyle(row)\"\n                [attr.data-automation-id]=\"'datatable-row-' + idx\"\n                (contextmenu)=\"markRowAsContextMenuSource(row)\">\n                <!-- Actions (left) -->\n                <div *ngIf=\"actions && actionsPosition === 'left'\" role=\"gridcell\" class=\"adf-datatable-cell\">\n                    <button mat-icon-button [matMenuTriggerFor]=\"menu\" #actionsMenuTrigger=\"matMenuTrigger\"\n                            [ngClass]=\"getHideActionsWithoutHoverClass(actionsMenuTrigger)\"\n                            [title]=\"'ADF-DATATABLE.CONTENT-ACTIONS.TOOLTIP' | translate\"\n                            [attr.id]=\"'action_menu_left_' + idx\"\n                            [attr.data-automation-id]=\"'action_menu_' + idx\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #menu=\"matMenu\">\n                        <button mat-menu-item *ngFor=\"let action of getRowActions(row)\"\n                                [attr.data-automation-id]=\"action.title\"\n                                [disabled]=\"action.disabled\"\n                                (click)=\"onExecuteRowAction(row, action)\">\n                            <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon>\n                            <span>{{ action.title | translate }}</span>\n                        </button>\n                    </mat-menu>\n                </div>\n\n                <div *ngIf=\"multiselect\" class=\"adf-datatable-cell adf-datatable-checkbox\">\n                    <mat-checkbox\n                        [checked]=\"row.isSelected\"\n                        [attr.aria-checked]=\"row.isSelected\"\n                        role=\"checkbox\"\n                        (change)=\"onCheckboxChange(row, $event)\"\n                        class=\"adf-checkbox-sr-only\">\n                        {{ 'ADF-DATATABLE.ACCESSIBILITY.SELECT_FILE' | translate }}\n                    </mat-checkbox>\n                </div>\n                <div *ngFor=\"let col of (data.getColumns() | filterOutEvery:'isHidden':true);\"\n                     role=\"gridcell\"\n                     class=\"adf-datatable-cell adf-datatable-cell--{{col.type || 'text'}} {{col.cssClass}}\"\n                     [attr.title]=\"col.title | translate\"\n                     [attr.data-automation-id]=\"getAutomationValue(row)\"\n                     [attr.aria-selected]=\"row.isSelected ? true : false\"\n                     [attr.aria-label]=\"col.title ? (col.title | translate) : null\"\n                     (click)=\"onRowClick(row, $event)\"\n                     (keydown.enter)=\"onEnterKeyPressed(row, $any($event))\"\n                     [adf-context-menu]=\"getContextMenuActions(row, col)\"\n                     [adf-context-menu-enabled]=\"contextMenu\"\n                     adf-drop-zone dropTarget=\"cell\" [dropColumn]=\"col\" [dropRow]=\"row\"\n                     [ngStyle]=\"(col.width) && {'flex': getFlexValue(col)}\">\n                    <div *ngIf=\"!col.template\" class=\"adf-datatable-cell-container\">\n                        <ng-container [ngSwitch]=\"data.getColumnType(row, col)\">\n                            <div *ngSwitchCase=\"'image'\" class=\"adf-cell-value\">\n                                <mat-icon *ngIf=\"isIconValue(row, col); else no_iconvalue\">{{ asIconValue(row, col) }}\n                                </mat-icon>\n                                <ng-template #no_iconvalue>\n                                    <mat-icon class=\"adf-datatable-selected\"\n                                              *ngIf=\"row.isSelected && !multiselect; else no_selected_row\" svgIcon=\"selected\">\n                                    </mat-icon>\n                                    <ng-template #no_selected_row>\n                                        <img class=\"adf-datatable-center-img-ie\"\n                                            [attr.aria-label]=\"(data.getValue(row, col) | fileType) === 'disable' ?\n                                                ('ADF-DATATABLE.ACCESSIBILITY.ICON_DISABLED' | translate) :\n                                                'ADF-DATATABLE.ACCESSIBILITY.ICON_TEXT' | translate:{\n                                                    type: 'ADF-DATATABLE.FILE_TYPE.' + (data.getValue(row, col) | fileType | uppercase) | translate\n                                                }\"\n                                            [attr.alt]=\"(data.getValue(row, col) | fileType) === 'disable' ?\n                                                ('ADF-DATATABLE.ACCESSIBILITY.ICON_DISABLED' | translate) :\n                                                'ADF-DATATABLE.ACCESSIBILITY.ICON_TEXT' | translate:{\n                                                        type: 'ADF-DATATABLE.FILE_TYPE.' + (data.getValue(row, col) | fileType | uppercase) | translate\n                                                }\"\n                                            src=\"{{ data.getValue(row, col) }}\"\n                                            (error)=\"onImageLoadingError($event, row)\">\n                                    </ng-template>\n                                </ng-template>\n                            </div>\n                            <div *ngSwitchCase=\"'icon'\" class=\"adf-cell-value\">\n                                <mat-icon>{{ data.getValue(row, col) }}</mat-icon>\n                            </div>\n                            <div *ngSwitchCase=\"'date'\" class=\"adf-cell-value\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\"\n                                 [attr.data-automation-id]=\"'date_' + (data.getValue(row, col, resolverFn) | adfLocalizedDate: 'medium') \">\n                                <adf-date-cell class=\"adf-datatable-center-date-column-ie\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-date-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'location'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\"  class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'location' + data.getValue(row, col, resolverFn)\">\n                                <adf-location-cell\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-location-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'fileSize'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'fileSize_' + data.getValue(row, col, resolverFn)\">\n                                <adf-filesize-cell class=\"adf-datatable-center-size-column-ie\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-filesize-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'text'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'text_' + data.getValue(row, col, resolverFn)\">\n                                <adf-datatable-cell\n                                    [copyContent]=\"col.copyContent\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-datatable-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'json'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\">\n                                <adf-json-cell\n                                    [editable]=\"col.editable\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [row]=\"row\">\n                                </adf-json-cell>\n                            </div>\n                            <span *ngSwitchDefault class=\"adf-cell-value\">\n                    <!-- empty cell for unknown column type -->\n                    </span>\n                        </ng-container>\n                    </div>\n                    <div *ngIf=\"col.template\" class=\"adf-datatable-cell-container\">\n                        <div class=\"adf-cell-value\" [attr.tabindex]=\"col.focus ? 0 : null\">\n                            <ng-container\n                                [ngTemplateOutlet]=\"col.template\"\n                                [ngTemplateOutletContext]=\"{ $implicit: { data: data, row: row, col: col }, value: data.getValue(row, col, resolverFn) }\">\n                            </ng-container>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Row actions (right) -->\n                <div *ngIf=\"\n                        (actions && actionsPosition === 'right') ||\n                        (mainActionTemplate && showMainDatatableActions)\"\n                     role=\"gridcell\"\n                     class=\"adf-datatable-cell adf-datatable__actions-cell adf-datatable-center-actions-column-ie\">\n\n                    <ng-container *ngIf=\"(actions && actionsPosition === 'right')\">\n                        <button mat-icon-button [matMenuTriggerFor]=\"menu\" #actionsMenuTrigger=\"matMenuTrigger\"\n                                [ngClass]=\"getHideActionsWithoutHoverClass(actionsMenuTrigger)\"\n                                [attr.aria-label]=\"'ADF-DATATABLE.ACCESSIBILITY.ROW_OPTION_BUTTON' | translate\"\n                                [title]=\"'ADF-DATATABLE.CONTENT-ACTIONS.TOOLTIP' | translate\"\n                                [attr.id]=\"'action_menu_right_' + idx\"\n                                [attr.data-automation-id]=\"'action_menu_' + idx\">\n                            <mat-icon>more_vert</mat-icon>\n                        </button>\n                        <mat-menu #menu=\"matMenu\">\n                            <button mat-menu-item *ngFor=\"let action of getRowActions(row)\"\n                                    [attr.data-automation-id]=\"action.title\"\n                                    [attr.aria-label]=\"action.title | translate\"\n                                    [disabled]=\"action.disabled\"\n                                    (click)=\"onExecuteRowAction(row, action)\">\n                                <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon>\n                                <span>{{ action.title | translate }}</span>\n                            </button>\n                        </mat-menu>\n                    </ng-container>\n                </div>\n            </adf-datatable-row>\n            <div *ngIf=\"isEmpty()\"\n                 role=\"row\"\n                 [class.adf-datatable-row]=\"display === 'list'\"\n                 [class.adf-datatable-card-empty]=\"display === 'gallery'\">\n                <div class=\"adf-no-content-container adf-datatable-cell\" role=\"gridcell\">\n                    <ng-template *ngIf=\"noContentTemplate\"\n                                 ngFor [ngForOf]=\"[data]\"\n                                 [ngForTemplate]=\"noContentTemplate\">\n                    </ng-template>\n                    <ng-content select=\"adf-empty-list\"></ng-content>\n                </div>\n            </div>\n            <div *ngFor=\"let row of fakeRows\"\n                 class=\"adf-datatable-row adf-datatable-row-empty-card\">\n            </div>\n        </ng-container>\n        <div *ngIf=\"!loading && noPermission\"\n             role=\"row\"\n             [class.adf-datatable-row]=\"display === 'list'\"\n             [class.adf-datatable-card-permissions]=\"display === 'gallery'\"\n             class=\"adf-no-permission__row\">\n            <div class=\"adf-no-permission__cell adf-no-content-container adf-datatable-cell\">\n                <ng-template *ngIf=\"noPermissionTemplate\"\n                             ngFor [ngForOf]=\"[data]\"\n                             [ngForTemplate]=\"noPermissionTemplate\">\n                </ng-template>\n            </div>\n        </div>\n        <div *ngIf=\"loading\"\n             [class.adf-datatable-row]=\"display === 'list'\"\n             [class.adf-datatable-card-loading]=\"display === 'gallery'\">\n            <div class=\"adf-no-content-container adf-datatable-cell\">\n                <ng-template *ngIf=\"loadingTemplate\"\n                             ngFor [ngForOf]=\"[data]\"\n                             [ngForTemplate]=\"loadingTemplate\">\n                </ng-template>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: [".adf-datatable{overflow-y:scroll;height:100%}.adf-datatable .adf-full-width{width:100%}.adf-datatable__resize-handle{padding:0 2px}.adf-datatable__resize-handle--divider{padding:24px 0;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable__resize-handle:hover{cursor:col-resize}.adf-datatable__cursor--pointer:hover{cursor:pointer}.adf-datatable-card{border:1px solid var(--adf-theme-foreground-divider-color)}.adf-datatable-card .adf-datatable-body{flex-flow:row wrap;display:flex;width:100%;justify-content:space-evenly;align-content:flex-start;align-items:flex-start}.adf-datatable-card .adf-datatable-body .adf-datatable-row{transition:all .3s ease;position:relative;display:flex;flex-direction:column;flex:0 1 24%;width:288px!important;max-width:288px!important;min-width:288px!important;height:200px;overflow:hidden!important;margin:6px;padding:15px;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}.adf-datatable-card .adf-datatable-body .adf-datatable-row:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.adf-datatable-card .adf-datatable-body .adf-datatable-row-empty-card{height:0!important;padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0}.adf-datatable-card .adf-datatable-body .adf-is-selected{background:var(--adf-theme-primary-100);padding-bottom:31px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-permission{width:100%;min-height:250px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-permission .adf-datatable-cell{height:240px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-card-loading{width:100%;min-height:250px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-loading .adf-datatable-cell{height:240px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-card-empty{width:100%;min-height:380px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-empty .adf-datatable-cell{height:370px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-cell--image{margin-left:8px}.adf-datatable-card .adf-datatable-body .adf-datatable-cell{text-align:left;flex:0 1 24%;height:136px!important;white-space:normal;text-overflow:ellipsis;overflow:hidden;outline:none}.adf-datatable-card .adf-datatable-body .adf-datatable-cell:before{margin-left:10px;text-align:left;content:attr(title);color:var(--adf-theme-foreground-text-color-054);float:left;width:140px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.adf-datatable-card .adf-datatable-body .adf-datatable-cell .adf-datatable-cell-value{display:block;overflow:hidden;text-overflow:ellipsis}.adf-datatable-card .adf-datatable-body .adf-datatable__actions-cell{position:absolute;height:42px!important;width:42px!important;right:0;top:4px}.adf-datatable-card .adf-datatable-body .adf-datatable-row:not(:hover) .adf-datatable-hide-actions-without-hover{display:none}.adf-datatable-card .adf-datatable-body .adf-image-table-cell{margin:8px;padding:4px;overflow:visible;border-bottom:1px solid var(--adf-theme-foreground-divider-color)}.adf-datatable-card .adf-datatable-body .adf-image-table-cell .adf-datatable-cell-container{float:left;width:42px}.adf-datatable-card .adf-datatable-body .adf-image-table-cell:after{margin:2px;content:attr(filename);float:left;width:140px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.adf-datatable-card .adf-datatable-body .adf-datatable-checkbox{margin:8px}.adf-datatable-card .adf-datatable-header{margin-right:18px;float:right}.adf-datatable-list{display:flex;flex-direction:column;background-color:var(--adf-theme-background-card-color);border:1px solid var(--adf-theme-foreground-text-color-007);box-sizing:border-box;overflow-x:auto}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-center-size-column-ie{padding-top:17px}.adf-datatable-list .adf-datatable-center-actions-column-ie{padding-top:7px!important}.adf-datatable-list .adf-datatable-center-date-column-ie{position:relative!important}.adf-datatable-list .adf-datatable-center-date-column-ie .adf-datatable-cell-value{width:100%}.adf-datatable-list .adf-datatable-center-img-ie{padding:0;min-width:0;width:24px;height:56px}}.adf-datatable-list .adf-datatable-header{display:flex;flex-direction:column;width:-moz-fit-content;width:fit-content;min-width:100%;box-sizing:border-box}.adf-datatable-list .adf-datatable-header .adf-datatable-row:hover,.adf-datatable-list .adf-datatable-header .adf-datatable-row:focus{background-color:inherit}.adf-datatable-list .adf-datatable-cell{color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-datatable-row:hover,.adf-datatable-list .adf-datatable-row:focus{background-color:var(--adf-theme-background-hover-color)}.adf-datatable-list .adf-datatable-row:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-datatable-list .adf-datatable-row .adf-cell-value:focus,.adf-datatable-list .adf-datatable-row .adf-datatable-cell-header:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-datatable-list .adf-blur-datatable-body{filter:blur(3px)}.adf-datatable-list .adf-datatable-body{display:flex;flex-direction:column;background-color:inherit;width:-moz-fit-content;width:fit-content;min-width:100%}.adf-datatable-list .adf-datatable-body .adf-datatable-row{transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background-color;border-top:1px solid var(--adf-theme-foreground-text-color-007);min-height:var(--theme-display-3-font-size);cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.adf-datatable-list .adf-datatable-body .adf-datatable-row.adf-is-selected,.adf-datatable-list .adf-datatable-body .adf-datatable-row.adf-is-selected:hover{background-color:var(--adf-theme-background-selected-button-color)}.adf-datatable-list .adf-datatable-body .adf-datatable-row:last-child{border-bottom:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable-list .adf-datatable-row{display:flex;align-items:center;padding-left:15px;padding-right:15px}.adf-datatable-list .adf-datatable-row .adf-datatable-checkbox{max-width:65px;width:65px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-row .adf-datatable-checkbox{padding-top:15px}}.adf-datatable-list .adf-datatable-cell,.adf-datatable-list .adf-datatable-cell-header{text-align:left;box-sizing:border-box;min-width:65px}.adf-datatable-list .adf-datatable-cell--text,.adf-datatable-list .adf-datatable-cell-header--text{text-align:left;position:relative}.adf-datatable-list .adf-datatable-cell--date,.adf-datatable-list .adf-datatable-cell-header--date{text-align:left}.adf-datatable-list .adf-datatable-cell--number,.adf-datatable-list .adf-datatable-cell-header--number{text-align:right}.adf-datatable-list .adf-datatable-cell--image,.adf-datatable-list .adf-datatable-cell--icon,.adf-datatable-list .adf-datatable-cell-header--image,.adf-datatable-list .adf-datatable-cell-header--icon{padding-left:24px;padding-right:24px;width:65px;min-width:65px;text-align:left}.adf-datatable-list .adf-datatable-cell--fileSize,.adf-datatable-list .adf-datatable-cell-header--fileSize{min-width:65px}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-1,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-1{flex-grow:1}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-2,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-2{flex-grow:2}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-3,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-3{flex-grow:3}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-4,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-4{flex-grow:4}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-5,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-5{flex-grow:5}.adf-datatable-list .adf-datatable-cell-header.adf-no-grow-cell,.adf-datatable-list .adf-datatable-cell.adf-no-grow-cell{flex-grow:0;min-width:100px}.adf-datatable-list .adf-datatable-cell,.adf-datatable-list .adf-datatable-cell-header{flex:1;padding:0;align-items:center;display:flex;min-height:inherit}.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-container,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-container{overflow:hidden;min-height:inherit;align-items:center;display:flex;width:100%;padding:0 10px}.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-value{word-break:break-word;padding-right:10px;display:block}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-value{padding:17px 10px 10px}}.adf-datatable-list .adf-datatable-cell--fileSize .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header--fileSize .adf-datatable-cell-value{padding:0 10px 0 0}.adf-datatable-list .adf-cell-value{display:flex;min-height:inherit;align-items:center;word-break:break-all;width:100%}.adf-datatable-list .adf-datatable__actions-cell,.adf-datatable-list .adf-datatable-cell--image{max-width:65px;display:flex}.adf-datatable-list .adf-datatable__actions-cell .adf-cell-value,.adf-datatable-list .adf-datatable-cell--image .adf-cell-value{width:unset}.adf-datatable-list .adf-datatable-row:not(:hover) .adf-datatable-hide-actions-without-hover{display:none}.adf-datatable-list .adf-datatable-cell--image{max-width:65px}.adf-datatable-list .adf-location-cell a{text-decoration:none;color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-location-cell a:hover{color:var(--theme-accent-500);text-decoration:underline}.adf-datatable-list .adf-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.adf-datatable-list .adf-is-selected{background:var(--adf-theme-primary-100)}.adf-datatable-list .adf-datatable-link{text-decoration:none;color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-datatable-link:hover{color:var(--theme-accent-500);text-decoration:underline}.adf-datatable-list .adf-dynamic-column .adf-datatable-link:hover{text-decoration:none}.adf-datatable-list .adf-dynamic-column .adf-datatable-link:hover .adf-datatable-cell-value{text-decoration:underline}.adf-datatable-list .adf-ellipsis-cell{position:sticky;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.adf-datatable-list .adf-ellipsis-cell.adf-datatable-cell-header,.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell{max-width:calc(100% - .1px);overflow:hidden;text-overflow:ellipsis}.adf-datatable-list .adf-ellipsis-cell.adf-datatable-cell-header .adf-datatable-cell-value,.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell .adf-datatable-cell-value{overflow:hidden;text-overflow:ellipsis}.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell{overflow:unset;position:absolute}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-ellipsis-cell .adf-cell-value{top:100%}}.adf-datatable-list .adf-ellipsis-cell>div:after{content:attr(title);overflow:hidden;height:0;display:block}.adf-datatable-list .adf-no-content-container{padding:0!important;border:none!important;width:100%;justify-content:center}.adf-datatable-list .adf-no-content-container>img{width:100%}.adf-datatable-list .adf-loading-content-container{padding:0!important;width:100%}.adf-datatable-list .adf-loading-content-container>img{width:100%}.adf-datatable-list .adf-no-permission__row:hover{cursor:default;background-color:inherit}.adf-datatable-list .adf-no-permission__cell{padding:0!important}.adf-datatable-list .adf-hidden{display:none}@media all and (max-width: 768px){.adf-datatable-list .adf-desktop-only{display:none!important}}@media (max-device-width: 768px){.adf-datatable-list .adf-desktop-only{display:none!important}}.adf-datatable-cell-header{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;position:relative;display:flex;align-items:center;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;min-height:var(--theme-display-3-font-size)!important;font-size:var(--theme-caption-font-size);color:var(--adf-theme-foreground-text-color);box-sizing:border-box}.adf-datatable-cell-header.adf-sortable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;display:flex;align-items:center}.adf-datatable-cell-header .adf-datatable__header--sorted-asc,.adf-datatable-cell-header .adf-datatable__header--sorted-desc{color:var(--adf-theme-foreground-text-color)}.adf-datatable-cell-header .adf-datatable__header--sorted-asc:after,.adf-datatable-cell-header .adf-datatable__header--sorted-desc:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:var(--theme-headline-font-size);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:\"liga\";font-size:var(--theme-subheading-2-font-size);content:\"\\e5d8\";left:5px;right:5px;position:relative;vertical-align:sub}.adf-datatable-cell-header .adf-datatable__header--sorted-desc:after{content:\"\\e5db\"}.adf-datatable-cell-header .adf-datatable-cell--fileSize.adf-datatable__header--sorted-asc:before,.adf-datatable-cell-header .adf-datatable-cell--fileSize.adf-datatable__header--sorted-desc:before{left:-3px;right:-3px}.adf-datatable-cell-header.adf-datatable-checkbox{display:flex;align-items:center}.adf-datatable-cell-header .adf-datatable-cell-header-content{display:flex;flex-grow:1;align-items:center;margin:0 2px;padding:0 8px;column-gap:5px}.adf-datatable-cell-header .adf-datatable-cell-header-content .adf-datatable-cell-header-drag-icon-placeholder{min-width:15px}.adf-datatable-cell-header .adf-datatable-cell-header-content--hovered{background-color:var(--adf-theme-background-hover-color);border-radius:6px}.adf-datatable-cell-header .adf-datatable-cell-header-drag-icon{position:absolute;top:0;bottom:0;left:3px;margin:auto;color:#ccc;cursor:move;width:24px;height:24px}.adf-datatable-cell-header .adf-datatable-cell-value{padding:10px 0!important;line-height:24px;word-break:break-word}.adf-drop-header-cell-placeholder{display:flex;flex:1;flex-grow:1;background:var(--adf-theme-background-hover-color);border:dotted 1px rgba(0,0,0,.25);min-height:55px;transition:transform .25s cubic-bezier(0,0,.2,1)}.adf-datatable-cell-header.adf-ellipsis-cell .adf-datatable-cell-header-content{white-space:nowrap;overflow:hidden}.adf-datatable-cell-header.adf-ellipsis-cell .adf-datatable-cell-header-content--hovered .adf-datatable-cell-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cdk-drag-preview.adf-datatable-cell-header{border-radius:6px;background-color:var(--theme-background-color);transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.adf-checkbox-sr-only .mat-checkbox-label{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.adf-sticky-header{border-top:0;height:100%}.adf-sticky-header .adf-datatable-header{display:block;margin-right:0;border-top:1px solid var(--adf-theme-foreground-text-color-007);border-bottom:1px solid var(--adf-theme-foreground-text-color-007)}.adf-sticky-header .adf-datatable-body{display:block;flex:1;overflow-y:scroll;margin-top:-1px}.adf-upload__dragging>div{border-top:1px dashed var(--theme-accent-color-a200)!important;border-bottom:1px dashed var(--theme-accent-color-a200)!important}.adf-upload__dragging>div:first-child{border-left:1px dashed var(--theme-accent-color-a200)}.adf-upload__dragging>div:last-child{border-right:1px dashed var(--theme-accent-color-a200)!important}.adf-datatable--empty{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;justify-content:center;align-items:center;height:inherit}.adf-datatable--empty .adf-datatable-body .adf-datatable-row{height:100%;background-color:var(--adf-theme-background-card-color);border:none!important}.adf-datatable--empty .adf-datatable-body .adf-datatable-row:hover,.adf-datatable--empty .adf-datatable-body .adf-datatable-row:focus{background-color:unset;cursor:default}.adf-datatable--empty--header-visible .adf-datatable-header{border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable--empty--header-visible .adf-datatable-body{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;justify-content:center;align-items:center}.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row{height:100%;background-color:var(--adf-theme-background-card-color);border:none!important}.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row:hover,.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row:focus{background-color:unset;cursor:default}@media screen and (max-width: 380px){.adf-datatable-header{max-height:50%}}\n"], dependencies: [{ kind: "component", type: i2$7.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i2$5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i1$6.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: ContextMenuDirective, selector: "[adf-context-menu]", inputs: ["adf-context-menu", "adf-context-menu-enabled"] }, { kind: "directive", type: UploadDirective, selector: "[adf-upload]", inputs: ["adf-upload", "adf-upload-data", "mode", "multiple", "accept", "directory"] }, { kind: "directive", type: i12.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i12.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i12.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "directive", type: i12.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "component", type: IconComponent, selector: "adf-icon", inputs: ["color", "fontSet", "value"] }, { kind: "directive", type: ResizableDirective, selector: "[adf-resizable]", outputs: ["resizeStart", "resizing", "resizeEnd"], exportAs: ["adf-resizable"] }, { kind: "directive", type: ResizeHandleDirective, selector: "[adf-resize-handle]", inputs: ["resizableContainer"] }, { kind: "component", type: DataTableCellComponent, selector: "adf-datatable-cell", inputs: ["data", "column", "row", "copyContent", "tooltip", "resolverFn"] }, { kind: "component", type: DataTableRowComponent, selector: "adf-datatable-row", inputs: ["row", "disabled"], outputs: ["select"] }, { kind: "component", type: DateCellComponent, selector: "adf-date-cell" }, { kind: "component", type: FileSizeCellComponent, selector: "adf-filesize-cell" }, { kind: "component", type: LocationCellComponent, selector: "adf-location-cell", inputs: ["link"] }, { kind: "component", type: JsonCellComponent, selector: "adf-json-cell", inputs: ["editable"] }, { kind: "directive", type: DropZoneDirective, selector: "[adf-drop-zone]", inputs: ["dropTarget", "dropRow", "dropColumn"] }, { kind: "pipe", type: i1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: FileTypePipe, name: "fileType" }, { kind: "pipe", type: LocalizedDatePipe, name: "adfLocalizedDate" }, { kind: "pipe", type: FilterOutArrayObjectsByPropPipe, name: "filterOutEvery" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-datatable', encapsulation: ViewEncapsulation.None, host: { class: 'adf-datatable' }, template: "<div\n    role=\"grid\"\n    *ngIf=\"data\" class=\"adf-full-width\"\n    [class.adf-datatable-card]=\"display === 'gallery'\"\n    [class.adf-datatable-list]=\"display === 'list'\"\n    [class.adf-sticky-header]=\"isStickyHeaderEnabled()\"\n    [class.adf-datatable--empty]=\"(isEmpty() && !isHeaderVisible()) || loading\"\n    [class.adf-datatable--empty--header-visible]=\"isEmpty() && isHeaderVisible()\">\n    <div *ngIf=\"isHeaderVisible()\" class=\"adf-datatable-header\" role=\"rowgroup\" [ngClass]=\"{ 'adf-sr-only': !isHeaderVisible() }\">\n        <adf-datatable-row\n            cdkDropList\n            cdkDropListOrientation=\"horizontal\"\n            data-automation-id=\"datatable-row-header\"\n            [disabled]=\"!isHeaderVisible()\"\n            class=\"adf-datatable-row\"\n            *ngIf=\"display === 'list'\"\n            role=\"row\">\n\n            <!-- Actions (left) -->\n            <div *ngIf=\"actions && actionsPosition === 'left'\" class=\"adf-actions-column adf-datatable-cell-header\">\n                <span class=\"adf-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.ACTIONS' | translate }}</span>\n            </div>\n\n            <!-- Columns -->\n            <div *ngIf=\"multiselect\" class=\"adf-datatable-cell-header adf-datatable-checkbox\">\n                <mat-checkbox [indeterminate]=\"isSelectAllIndeterminate\" [checked]=\"isSelectAllChecked\" (change)=\"onSelectAllClick($event)\" class=\"adf-checkbox-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.SELECT_ALL' | translate }}</mat-checkbox>\n            </div>\n\n            <div class=\"adf-datatable-cell--{{col.type || 'text'}} {{col.cssClass}} adf-datatable-cell-header\"\n                 *ngFor=\"\n                    let col of (data.getColumns() | filterOutEvery:'isHidden':true);\n                    let columnIndex = index\"\n                 [attr.data-automation-id]=\"'auto_id_' + col.key\"\n                 [ngClass]=\"{\n                    'adf-sortable': col.sortable,\n                    'adf-datatable__cursor--pointer': !isResizing,\n                    'adf-datatable__header--sorted-asc': isColumnSorted(col, 'asc'),\n                    'adf-datatable__header--sorted-desc': isColumnSorted(col, 'desc')}\"\n                 [ngStyle]=\"(col.width) && {'flex': getFlexValue(col)}\"\n                 [attr.aria-label]=\"col.title | translate\"\n                 (click)=\"onColumnHeaderClick(col, $event)\"\n                 (keyup.enter)=\"onColumnHeaderClick(col, $event)\"\n                 role=\"columnheader\"\n                 [attr.tabindex]=\"isHeaderVisible() ? 0 : null\"\n                 [attr.aria-sort]=\"col.sortable ? (getAriaSort(col) | translate) : null\"\n                 cdkDrag\n                 cdkDragBoundary=\"adf-datatable-row\"\n                 cdkDragLockAxis=\"x\"\n                 (cdkDragStarted)=\"isDraggingHeaderColumn = true\"\n                 (cdkDragDropped)=\"onDropHeaderColumn($event)\"\n                 [cdkDragDisabled]=\"!col.draggable\"\n                 (mouseenter)=\"hoveredHeaderColumnIndex = columnIndex\"\n                 (mouseleave)=\"hoveredHeaderColumnIndex = -1\"\n                 adf-drop-zone dropTarget=\"header\" [dropColumn]=\"col\">\n\n                <div\n                    adf-resizable\n                    #resizableElement=\"adf-resizable\"\n                    (resizing)=\"onResizing($event, columnIndex)\"\n                    (resizeStart)=\"isResizing = true\"\n                    (resizeEnd)=\"onResizingEnd()\"\n                    [attr.data-automation-id]=\"'auto_header_content_id_' + col.key\"\n                    class=\"adf-datatable-cell-header-content\"\n                    [ngClass]=\"{ 'adf-datatable-cell-header-content--hovered':\n                        hoveredHeaderColumnIndex === columnIndex &&\n                        !isDraggingHeaderColumn &&\n                        !isResizing }\"\n                >\n                    <span\n                        *ngIf=\"hoveredHeaderColumnIndex === columnIndex && col.draggable && !isResizing\"\n                        class=\"adf-datatable-cell-header-drag-icon-placeholder\"\n                        [attr.data-automation-id]=\"'adf-datatable-cell-header-drag-icon-placeholder-'+col.key\"\n                    ></span>\n\n                    <ng-container *ngIf=\"!col.header\">\n                        <span *ngIf=\"col.title\" class=\"adf-datatable-cell-value\">{{col.title | translate}}</span>\n\n                        <span *ngIf=\"col.title && col.sortable && isDraggingHeaderColumn\" class=\"adf-sr-only\" aria-live=\"polite\">\n                            {{ getSortLiveAnnouncement(col) | translate: { string: col.title | translate } }}\n                        </span>\n\n                        <span *ngIf=\"!col.title && !col.sortable && !headerFilterTemplate\" [attr.title]=\"'ADF-DATATABLE.ACCESSIBILITY.EMPTY_HEADER' | translate\"></span>\n                    </ng-container>\n\n                    <div *ngIf=\"col.header\" class=\"adf-datatable-cell-value\">\n                        <ng-template [ngTemplateOutlet]=\"col.header\" [ngTemplateOutletContext]=\"{$implicit: col}\"></ng-template>\n                    </div>\n\n                    <ng-template *ngIf=\"allowFiltering\" [ngTemplateOutlet]=\"headerFilterTemplate\" [ngTemplateOutletContext]=\"{$implicit: col}\"></ng-template>\n\n                    <span\n                        [class.adf-datatable__header--sorted-asc]=\"isColumnSorted(col, 'asc')\"\n                        [class.adf-datatable__header--sorted-desc]=\"isColumnSorted(col, 'desc')\">\n                    </span>\n                </div>\n                <div\n                    *ngIf=\"isResizingEnabled\"\n                    adf-resize-handle\n                    class=\"adf-datatable__resize-handle\"\n                    [resizableContainer]=\"resizableElement\">\n                    <div class=\"adf-datatable__resize-handle--divider\"></div>\n                </div>\n                <div\n                    *ngIf=\"col.draggable\"\n                    cdkDragHandle\n                    [ngClass]=\"{ 'adf-datatable-cell-header-drag-icon': !isResizing }\"\n                >\n                    <adf-icon\n                        *ngIf=\"hoveredHeaderColumnIndex === columnIndex && !isResizing\"\n                        value=\"adf:drag_indicator\"\n                        [attr.data-automation-id]=\"'adf-datatable-cell-header-drag-icon-'+col.key\">\n                    </adf-icon>\n                </div>\n\n                <div class=\"adf-drop-header-cell-placeholder\" *cdkDragPlaceholder></div>\n            </div>\n\n            <!-- Header actions (right) -->\n            <div\n                *ngIf=\"(actions && actionsPosition === 'right') ||\n                       (mainActionTemplate && showMainDatatableActions)\"\n                class=\"adf-actions-column adf-datatable-cell-header adf-datatable__actions-cell\"\n            >\n                <ng-container *ngIf=\"mainActionTemplate\">\n                    <button\n                        data-automation-id=\"adf-datatable-main-menu-button\"\n                        mat-icon-button\n                        #mainMenuTrigger=\"matMenuTrigger\"\n                        [matMenuTriggerFor]=\"mainMenu\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n\n                    <mat-menu #mainMenu>\n                        <ng-container\n                            [ngTemplateOutlet]=\"mainActionTemplate\"\n                            [ngTemplateOutletContext]=\"{\n                                $implicit: mainMenuTrigger\n                            }\">\n                        </ng-container>\n                    </mat-menu>\n                    <span class=\"adf-sr-only\">{{ 'ADF-DATATABLE.ACCESSIBILITY.ACTIONS' | translate }}</span>\n                </ng-container>\n            </div>\n\n        </adf-datatable-row>\n        <mat-form-field *ngIf=\"display === 'gallery' && isHeaderVisible()\">\n            <mat-select [value]=\"getSortingKey()\" [attr.data-automation-id]=\"'grid-view-sorting'\">\n                <mat-option *ngFor=\"let col of getSortableColumns()\"\n                            [value]=\"col.key\"\n                            [attr.data-automation-id]=\"'grid-view-sorting-'+col.title\"\n                            (click)=\"onColumnHeaderClick(col, $event)\"\n                            (keyup.enter)=\"onColumnHeaderClick(col, $event)\">\n                    {{ col.title | translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n    </div>\n\n    <div\n        class=\"adf-datatable-body\"\n        [ngClass]=\"{ 'adf-blur-datatable-body': isDraggingHeaderColumn || isResizing }\"\n        role=\"rowgroup\">\n        <ng-container *ngIf=\"!loading && !noPermission\">\n            <adf-datatable-row *ngFor=\"let row of data.getRows(); let idx = index\"\n                [row]=\"row\"\n                (select)=\"onEnterKeyPressed(row, $event)\"\n                (keyup)=\"onRowKeyUp(row, $event)\"\n                (keydown)=\"onRowEnterKeyDown(row, $event)\"\n                [adf-upload]=\"rowAllowsDrop(row)\"\n                [adf-upload-data]=\"row\"\n                [ngStyle]=\"rowStyle\"\n                [ngClass]=\"getRowStyle(row)\"\n                [attr.data-automation-id]=\"'datatable-row-' + idx\"\n                (contextmenu)=\"markRowAsContextMenuSource(row)\">\n                <!-- Actions (left) -->\n                <div *ngIf=\"actions && actionsPosition === 'left'\" role=\"gridcell\" class=\"adf-datatable-cell\">\n                    <button mat-icon-button [matMenuTriggerFor]=\"menu\" #actionsMenuTrigger=\"matMenuTrigger\"\n                            [ngClass]=\"getHideActionsWithoutHoverClass(actionsMenuTrigger)\"\n                            [title]=\"'ADF-DATATABLE.CONTENT-ACTIONS.TOOLTIP' | translate\"\n                            [attr.id]=\"'action_menu_left_' + idx\"\n                            [attr.data-automation-id]=\"'action_menu_' + idx\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #menu=\"matMenu\">\n                        <button mat-menu-item *ngFor=\"let action of getRowActions(row)\"\n                                [attr.data-automation-id]=\"action.title\"\n                                [disabled]=\"action.disabled\"\n                                (click)=\"onExecuteRowAction(row, action)\">\n                            <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon>\n                            <span>{{ action.title | translate }}</span>\n                        </button>\n                    </mat-menu>\n                </div>\n\n                <div *ngIf=\"multiselect\" class=\"adf-datatable-cell adf-datatable-checkbox\">\n                    <mat-checkbox\n                        [checked]=\"row.isSelected\"\n                        [attr.aria-checked]=\"row.isSelected\"\n                        role=\"checkbox\"\n                        (change)=\"onCheckboxChange(row, $event)\"\n                        class=\"adf-checkbox-sr-only\">\n                        {{ 'ADF-DATATABLE.ACCESSIBILITY.SELECT_FILE' | translate }}\n                    </mat-checkbox>\n                </div>\n                <div *ngFor=\"let col of (data.getColumns() | filterOutEvery:'isHidden':true);\"\n                     role=\"gridcell\"\n                     class=\"adf-datatable-cell adf-datatable-cell--{{col.type || 'text'}} {{col.cssClass}}\"\n                     [attr.title]=\"col.title | translate\"\n                     [attr.data-automation-id]=\"getAutomationValue(row)\"\n                     [attr.aria-selected]=\"row.isSelected ? true : false\"\n                     [attr.aria-label]=\"col.title ? (col.title | translate) : null\"\n                     (click)=\"onRowClick(row, $event)\"\n                     (keydown.enter)=\"onEnterKeyPressed(row, $any($event))\"\n                     [adf-context-menu]=\"getContextMenuActions(row, col)\"\n                     [adf-context-menu-enabled]=\"contextMenu\"\n                     adf-drop-zone dropTarget=\"cell\" [dropColumn]=\"col\" [dropRow]=\"row\"\n                     [ngStyle]=\"(col.width) && {'flex': getFlexValue(col)}\">\n                    <div *ngIf=\"!col.template\" class=\"adf-datatable-cell-container\">\n                        <ng-container [ngSwitch]=\"data.getColumnType(row, col)\">\n                            <div *ngSwitchCase=\"'image'\" class=\"adf-cell-value\">\n                                <mat-icon *ngIf=\"isIconValue(row, col); else no_iconvalue\">{{ asIconValue(row, col) }}\n                                </mat-icon>\n                                <ng-template #no_iconvalue>\n                                    <mat-icon class=\"adf-datatable-selected\"\n                                              *ngIf=\"row.isSelected && !multiselect; else no_selected_row\" svgIcon=\"selected\">\n                                    </mat-icon>\n                                    <ng-template #no_selected_row>\n                                        <img class=\"adf-datatable-center-img-ie\"\n                                            [attr.aria-label]=\"(data.getValue(row, col) | fileType) === 'disable' ?\n                                                ('ADF-DATATABLE.ACCESSIBILITY.ICON_DISABLED' | translate) :\n                                                'ADF-DATATABLE.ACCESSIBILITY.ICON_TEXT' | translate:{\n                                                    type: 'ADF-DATATABLE.FILE_TYPE.' + (data.getValue(row, col) | fileType | uppercase) | translate\n                                                }\"\n                                            [attr.alt]=\"(data.getValue(row, col) | fileType) === 'disable' ?\n                                                ('ADF-DATATABLE.ACCESSIBILITY.ICON_DISABLED' | translate) :\n                                                'ADF-DATATABLE.ACCESSIBILITY.ICON_TEXT' | translate:{\n                                                        type: 'ADF-DATATABLE.FILE_TYPE.' + (data.getValue(row, col) | fileType | uppercase) | translate\n                                                }\"\n                                            src=\"{{ data.getValue(row, col) }}\"\n                                            (error)=\"onImageLoadingError($event, row)\">\n                                    </ng-template>\n                                </ng-template>\n                            </div>\n                            <div *ngSwitchCase=\"'icon'\" class=\"adf-cell-value\">\n                                <mat-icon>{{ data.getValue(row, col) }}</mat-icon>\n                            </div>\n                            <div *ngSwitchCase=\"'date'\" class=\"adf-cell-value\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\"\n                                 [attr.data-automation-id]=\"'date_' + (data.getValue(row, col, resolverFn) | adfLocalizedDate: 'medium') \">\n                                <adf-date-cell class=\"adf-datatable-center-date-column-ie\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-date-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'location'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\"  class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'location' + data.getValue(row, col, resolverFn)\">\n                                <adf-location-cell\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-location-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'fileSize'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'fileSize_' + data.getValue(row, col, resolverFn)\">\n                                <adf-filesize-cell class=\"adf-datatable-center-size-column-ie\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-filesize-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'text'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\"\n                                 [attr.data-automation-id]=\"'text_' + data.getValue(row, col, resolverFn)\">\n                                <adf-datatable-cell\n                                    [copyContent]=\"col.copyContent\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [row]=\"row\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [tooltip]=\"getCellTooltip(row, col)\">\n                                </adf-datatable-cell>\n                            </div>\n                            <div *ngSwitchCase=\"'json'\" [attr.tabindex]=\"data.getValue(row, col, resolverFn)? 0 : -1\" class=\"adf-cell-value\">\n                                <adf-json-cell\n                                    [editable]=\"col.editable\"\n                                    [data]=\"data\"\n                                    [column]=\"col\"\n                                    [resolverFn]=\"resolverFn\"\n                                    [row]=\"row\">\n                                </adf-json-cell>\n                            </div>\n                            <span *ngSwitchDefault class=\"adf-cell-value\">\n                    <!-- empty cell for unknown column type -->\n                    </span>\n                        </ng-container>\n                    </div>\n                    <div *ngIf=\"col.template\" class=\"adf-datatable-cell-container\">\n                        <div class=\"adf-cell-value\" [attr.tabindex]=\"col.focus ? 0 : null\">\n                            <ng-container\n                                [ngTemplateOutlet]=\"col.template\"\n                                [ngTemplateOutletContext]=\"{ $implicit: { data: data, row: row, col: col }, value: data.getValue(row, col, resolverFn) }\">\n                            </ng-container>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Row actions (right) -->\n                <div *ngIf=\"\n                        (actions && actionsPosition === 'right') ||\n                        (mainActionTemplate && showMainDatatableActions)\"\n                     role=\"gridcell\"\n                     class=\"adf-datatable-cell adf-datatable__actions-cell adf-datatable-center-actions-column-ie\">\n\n                    <ng-container *ngIf=\"(actions && actionsPosition === 'right')\">\n                        <button mat-icon-button [matMenuTriggerFor]=\"menu\" #actionsMenuTrigger=\"matMenuTrigger\"\n                                [ngClass]=\"getHideActionsWithoutHoverClass(actionsMenuTrigger)\"\n                                [attr.aria-label]=\"'ADF-DATATABLE.ACCESSIBILITY.ROW_OPTION_BUTTON' | translate\"\n                                [title]=\"'ADF-DATATABLE.CONTENT-ACTIONS.TOOLTIP' | translate\"\n                                [attr.id]=\"'action_menu_right_' + idx\"\n                                [attr.data-automation-id]=\"'action_menu_' + idx\">\n                            <mat-icon>more_vert</mat-icon>\n                        </button>\n                        <mat-menu #menu=\"matMenu\">\n                            <button mat-menu-item *ngFor=\"let action of getRowActions(row)\"\n                                    [attr.data-automation-id]=\"action.title\"\n                                    [attr.aria-label]=\"action.title | translate\"\n                                    [disabled]=\"action.disabled\"\n                                    (click)=\"onExecuteRowAction(row, action)\">\n                                <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon>\n                                <span>{{ action.title | translate }}</span>\n                            </button>\n                        </mat-menu>\n                    </ng-container>\n                </div>\n            </adf-datatable-row>\n            <div *ngIf=\"isEmpty()\"\n                 role=\"row\"\n                 [class.adf-datatable-row]=\"display === 'list'\"\n                 [class.adf-datatable-card-empty]=\"display === 'gallery'\">\n                <div class=\"adf-no-content-container adf-datatable-cell\" role=\"gridcell\">\n                    <ng-template *ngIf=\"noContentTemplate\"\n                                 ngFor [ngForOf]=\"[data]\"\n                                 [ngForTemplate]=\"noContentTemplate\">\n                    </ng-template>\n                    <ng-content select=\"adf-empty-list\"></ng-content>\n                </div>\n            </div>\n            <div *ngFor=\"let row of fakeRows\"\n                 class=\"adf-datatable-row adf-datatable-row-empty-card\">\n            </div>\n        </ng-container>\n        <div *ngIf=\"!loading && noPermission\"\n             role=\"row\"\n             [class.adf-datatable-row]=\"display === 'list'\"\n             [class.adf-datatable-card-permissions]=\"display === 'gallery'\"\n             class=\"adf-no-permission__row\">\n            <div class=\"adf-no-permission__cell adf-no-content-container adf-datatable-cell\">\n                <ng-template *ngIf=\"noPermissionTemplate\"\n                             ngFor [ngForOf]=\"[data]\"\n                             [ngForTemplate]=\"noPermissionTemplate\">\n                </ng-template>\n            </div>\n        </div>\n        <div *ngIf=\"loading\"\n             [class.adf-datatable-row]=\"display === 'list'\"\n             [class.adf-datatable-card-loading]=\"display === 'gallery'\">\n            <div class=\"adf-no-content-container adf-datatable-cell\">\n                <ng-template *ngIf=\"loadingTemplate\"\n                             ngFor [ngForOf]=\"[data]\"\n                             [ngForTemplate]=\"loadingTemplate\">\n                </ng-template>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: [".adf-datatable{overflow-y:scroll;height:100%}.adf-datatable .adf-full-width{width:100%}.adf-datatable__resize-handle{padding:0 2px}.adf-datatable__resize-handle--divider{padding:24px 0;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable__resize-handle:hover{cursor:col-resize}.adf-datatable__cursor--pointer:hover{cursor:pointer}.adf-datatable-card{border:1px solid var(--adf-theme-foreground-divider-color)}.adf-datatable-card .adf-datatable-body{flex-flow:row wrap;display:flex;width:100%;justify-content:space-evenly;align-content:flex-start;align-items:flex-start}.adf-datatable-card .adf-datatable-body .adf-datatable-row{transition:all .3s ease;position:relative;display:flex;flex-direction:column;flex:0 1 24%;width:288px!important;max-width:288px!important;min-width:288px!important;height:200px;overflow:hidden!important;margin:6px;padding:15px;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}.adf-datatable-card .adf-datatable-body .adf-datatable-row:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.adf-datatable-card .adf-datatable-body .adf-datatable-row-empty-card{height:0!important;padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0}.adf-datatable-card .adf-datatable-body .adf-is-selected{background:var(--adf-theme-primary-100);padding-bottom:31px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-permission{width:100%;min-height:250px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-permission .adf-datatable-cell{height:240px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-card-loading{width:100%;min-height:250px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-loading .adf-datatable-cell{height:240px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-card-empty{width:100%;min-height:380px}.adf-datatable-card .adf-datatable-body .adf-datatable-card-empty .adf-datatable-cell{height:370px!important}.adf-datatable-card .adf-datatable-body .adf-datatable-cell--image{margin-left:8px}.adf-datatable-card .adf-datatable-body .adf-datatable-cell{text-align:left;flex:0 1 24%;height:136px!important;white-space:normal;text-overflow:ellipsis;overflow:hidden;outline:none}.adf-datatable-card .adf-datatable-body .adf-datatable-cell:before{margin-left:10px;text-align:left;content:attr(title);color:var(--adf-theme-foreground-text-color-054);float:left;width:140px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.adf-datatable-card .adf-datatable-body .adf-datatable-cell .adf-datatable-cell-value{display:block;overflow:hidden;text-overflow:ellipsis}.adf-datatable-card .adf-datatable-body .adf-datatable__actions-cell{position:absolute;height:42px!important;width:42px!important;right:0;top:4px}.adf-datatable-card .adf-datatable-body .adf-datatable-row:not(:hover) .adf-datatable-hide-actions-without-hover{display:none}.adf-datatable-card .adf-datatable-body .adf-image-table-cell{margin:8px;padding:4px;overflow:visible;border-bottom:1px solid var(--adf-theme-foreground-divider-color)}.adf-datatable-card .adf-datatable-body .adf-image-table-cell .adf-datatable-cell-container{float:left;width:42px}.adf-datatable-card .adf-datatable-body .adf-image-table-cell:after{margin:2px;content:attr(filename);float:left;width:140px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.adf-datatable-card .adf-datatable-body .adf-datatable-checkbox{margin:8px}.adf-datatable-card .adf-datatable-header{margin-right:18px;float:right}.adf-datatable-list{display:flex;flex-direction:column;background-color:var(--adf-theme-background-card-color);border:1px solid var(--adf-theme-foreground-text-color-007);box-sizing:border-box;overflow-x:auto}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-center-size-column-ie{padding-top:17px}.adf-datatable-list .adf-datatable-center-actions-column-ie{padding-top:7px!important}.adf-datatable-list .adf-datatable-center-date-column-ie{position:relative!important}.adf-datatable-list .adf-datatable-center-date-column-ie .adf-datatable-cell-value{width:100%}.adf-datatable-list .adf-datatable-center-img-ie{padding:0;min-width:0;width:24px;height:56px}}.adf-datatable-list .adf-datatable-header{display:flex;flex-direction:column;width:-moz-fit-content;width:fit-content;min-width:100%;box-sizing:border-box}.adf-datatable-list .adf-datatable-header .adf-datatable-row:hover,.adf-datatable-list .adf-datatable-header .adf-datatable-row:focus{background-color:inherit}.adf-datatable-list .adf-datatable-cell{color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-datatable-row:hover,.adf-datatable-list .adf-datatable-row:focus{background-color:var(--adf-theme-background-hover-color)}.adf-datatable-list .adf-datatable-row:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-datatable-list .adf-datatable-row .adf-cell-value:focus,.adf-datatable-list .adf-datatable-row .adf-datatable-cell-header:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-datatable-list .adf-blur-datatable-body{filter:blur(3px)}.adf-datatable-list .adf-datatable-body{display:flex;flex-direction:column;background-color:inherit;width:-moz-fit-content;width:fit-content;min-width:100%}.adf-datatable-list .adf-datatable-body .adf-datatable-row{transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background-color;border-top:1px solid var(--adf-theme-foreground-text-color-007);min-height:var(--theme-display-3-font-size);cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.adf-datatable-list .adf-datatable-body .adf-datatable-row.adf-is-selected,.adf-datatable-list .adf-datatable-body .adf-datatable-row.adf-is-selected:hover{background-color:var(--adf-theme-background-selected-button-color)}.adf-datatable-list .adf-datatable-body .adf-datatable-row:last-child{border-bottom:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable-list .adf-datatable-row{display:flex;align-items:center;padding-left:15px;padding-right:15px}.adf-datatable-list .adf-datatable-row .adf-datatable-checkbox{max-width:65px;width:65px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-row .adf-datatable-checkbox{padding-top:15px}}.adf-datatable-list .adf-datatable-cell,.adf-datatable-list .adf-datatable-cell-header{text-align:left;box-sizing:border-box;min-width:65px}.adf-datatable-list .adf-datatable-cell--text,.adf-datatable-list .adf-datatable-cell-header--text{text-align:left;position:relative}.adf-datatable-list .adf-datatable-cell--date,.adf-datatable-list .adf-datatable-cell-header--date{text-align:left}.adf-datatable-list .adf-datatable-cell--number,.adf-datatable-list .adf-datatable-cell-header--number{text-align:right}.adf-datatable-list .adf-datatable-cell--image,.adf-datatable-list .adf-datatable-cell--icon,.adf-datatable-list .adf-datatable-cell-header--image,.adf-datatable-list .adf-datatable-cell-header--icon{padding-left:24px;padding-right:24px;width:65px;min-width:65px;text-align:left}.adf-datatable-list .adf-datatable-cell--fileSize,.adf-datatable-list .adf-datatable-cell-header--fileSize{min-width:65px}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-1,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-1{flex-grow:1}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-2,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-2{flex-grow:2}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-3,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-3{flex-grow:3}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-4,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-4{flex-grow:4}.adf-datatable-list .adf-datatable-cell-header.adf-expand-cell-5,.adf-datatable-list .adf-datatable-cell.adf-expand-cell-5{flex-grow:5}.adf-datatable-list .adf-datatable-cell-header.adf-no-grow-cell,.adf-datatable-list .adf-datatable-cell.adf-no-grow-cell{flex-grow:0;min-width:100px}.adf-datatable-list .adf-datatable-cell,.adf-datatable-list .adf-datatable-cell-header{flex:1;padding:0;align-items:center;display:flex;min-height:inherit}.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-container,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-container{overflow:hidden;min-height:inherit;align-items:center;display:flex;width:100%;padding:0 10px}.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-value{word-break:break-word;padding-right:10px;display:block}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-datatable-cell .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header .adf-datatable-cell-value{padding:17px 10px 10px}}.adf-datatable-list .adf-datatable-cell--fileSize .adf-datatable-cell-value,.adf-datatable-list .adf-datatable-cell-header--fileSize .adf-datatable-cell-value{padding:0 10px 0 0}.adf-datatable-list .adf-cell-value{display:flex;min-height:inherit;align-items:center;word-break:break-all;width:100%}.adf-datatable-list .adf-datatable__actions-cell,.adf-datatable-list .adf-datatable-cell--image{max-width:65px;display:flex}.adf-datatable-list .adf-datatable__actions-cell .adf-cell-value,.adf-datatable-list .adf-datatable-cell--image .adf-cell-value{width:unset}.adf-datatable-list .adf-datatable-row:not(:hover) .adf-datatable-hide-actions-without-hover{display:none}.adf-datatable-list .adf-datatable-cell--image{max-width:65px}.adf-datatable-list .adf-location-cell a{text-decoration:none;color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-location-cell a:hover{color:var(--theme-accent-500);text-decoration:underline}.adf-datatable-list .adf-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.adf-datatable-list .adf-is-selected{background:var(--adf-theme-primary-100)}.adf-datatable-list .adf-datatable-link{text-decoration:none;color:var(--adf-theme-foreground-text-color)}.adf-datatable-list .adf-datatable-link:hover{color:var(--theme-accent-500);text-decoration:underline}.adf-datatable-list .adf-dynamic-column .adf-datatable-link:hover{text-decoration:none}.adf-datatable-list .adf-dynamic-column .adf-datatable-link:hover .adf-datatable-cell-value{text-decoration:underline}.adf-datatable-list .adf-ellipsis-cell{position:sticky;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.adf-datatable-list .adf-ellipsis-cell.adf-datatable-cell-header,.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell{max-width:calc(100% - .1px);overflow:hidden;text-overflow:ellipsis}.adf-datatable-list .adf-ellipsis-cell.adf-datatable-cell-header .adf-datatable-cell-value,.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell .adf-datatable-cell-value{overflow:hidden;text-overflow:ellipsis}.adf-datatable-list .adf-ellipsis-cell .adf-datatable-content-cell{overflow:unset;position:absolute}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-datatable-list .adf-ellipsis-cell .adf-cell-value{top:100%}}.adf-datatable-list .adf-ellipsis-cell>div:after{content:attr(title);overflow:hidden;height:0;display:block}.adf-datatable-list .adf-no-content-container{padding:0!important;border:none!important;width:100%;justify-content:center}.adf-datatable-list .adf-no-content-container>img{width:100%}.adf-datatable-list .adf-loading-content-container{padding:0!important;width:100%}.adf-datatable-list .adf-loading-content-container>img{width:100%}.adf-datatable-list .adf-no-permission__row:hover{cursor:default;background-color:inherit}.adf-datatable-list .adf-no-permission__cell{padding:0!important}.adf-datatable-list .adf-hidden{display:none}@media all and (max-width: 768px){.adf-datatable-list .adf-desktop-only{display:none!important}}@media (max-device-width: 768px){.adf-datatable-list .adf-desktop-only{display:none!important}}.adf-datatable-cell-header{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;position:relative;display:flex;align-items:center;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;min-height:var(--theme-display-3-font-size)!important;font-size:var(--theme-caption-font-size);color:var(--adf-theme-foreground-text-color);box-sizing:border-box}.adf-datatable-cell-header.adf-sortable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;display:flex;align-items:center}.adf-datatable-cell-header .adf-datatable__header--sorted-asc,.adf-datatable-cell-header .adf-datatable__header--sorted-desc{color:var(--adf-theme-foreground-text-color)}.adf-datatable-cell-header .adf-datatable__header--sorted-asc:after,.adf-datatable-cell-header .adf-datatable__header--sorted-desc:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:var(--theme-headline-font-size);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:\"liga\";font-size:var(--theme-subheading-2-font-size);content:\"\\e5d8\";left:5px;right:5px;position:relative;vertical-align:sub}.adf-datatable-cell-header .adf-datatable__header--sorted-desc:after{content:\"\\e5db\"}.adf-datatable-cell-header .adf-datatable-cell--fileSize.adf-datatable__header--sorted-asc:before,.adf-datatable-cell-header .adf-datatable-cell--fileSize.adf-datatable__header--sorted-desc:before{left:-3px;right:-3px}.adf-datatable-cell-header.adf-datatable-checkbox{display:flex;align-items:center}.adf-datatable-cell-header .adf-datatable-cell-header-content{display:flex;flex-grow:1;align-items:center;margin:0 2px;padding:0 8px;column-gap:5px}.adf-datatable-cell-header .adf-datatable-cell-header-content .adf-datatable-cell-header-drag-icon-placeholder{min-width:15px}.adf-datatable-cell-header .adf-datatable-cell-header-content--hovered{background-color:var(--adf-theme-background-hover-color);border-radius:6px}.adf-datatable-cell-header .adf-datatable-cell-header-drag-icon{position:absolute;top:0;bottom:0;left:3px;margin:auto;color:#ccc;cursor:move;width:24px;height:24px}.adf-datatable-cell-header .adf-datatable-cell-value{padding:10px 0!important;line-height:24px;word-break:break-word}.adf-drop-header-cell-placeholder{display:flex;flex:1;flex-grow:1;background:var(--adf-theme-background-hover-color);border:dotted 1px rgba(0,0,0,.25);min-height:55px;transition:transform .25s cubic-bezier(0,0,.2,1)}.adf-datatable-cell-header.adf-ellipsis-cell .adf-datatable-cell-header-content{white-space:nowrap;overflow:hidden}.adf-datatable-cell-header.adf-ellipsis-cell .adf-datatable-cell-header-content--hovered .adf-datatable-cell-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cdk-drag-preview.adf-datatable-cell-header{border-radius:6px;background-color:var(--theme-background-color);transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.adf-checkbox-sr-only .mat-checkbox-label{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.adf-sticky-header{border-top:0;height:100%}.adf-sticky-header .adf-datatable-header{display:block;margin-right:0;border-top:1px solid var(--adf-theme-foreground-text-color-007);border-bottom:1px solid var(--adf-theme-foreground-text-color-007)}.adf-sticky-header .adf-datatable-body{display:block;flex:1;overflow-y:scroll;margin-top:-1px}.adf-upload__dragging>div{border-top:1px dashed var(--theme-accent-color-a200)!important;border-bottom:1px dashed var(--theme-accent-color-a200)!important}.adf-upload__dragging>div:first-child{border-left:1px dashed var(--theme-accent-color-a200)}.adf-upload__dragging>div:last-child{border-right:1px dashed var(--theme-accent-color-a200)!important}.adf-datatable--empty{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;justify-content:center;align-items:center;height:inherit}.adf-datatable--empty .adf-datatable-body .adf-datatable-row{height:100%;background-color:var(--adf-theme-background-card-color);border:none!important}.adf-datatable--empty .adf-datatable-body .adf-datatable-row:hover,.adf-datatable--empty .adf-datatable-body .adf-datatable-row:focus{background-color:unset;cursor:default}.adf-datatable--empty--header-visible .adf-datatable-header{border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-datatable--empty--header-visible .adf-datatable-body{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;justify-content:center;align-items:center}.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row{height:100%;background-color:var(--adf-theme-background-card-color);border:none!important}.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row:hover,.adf-datatable--empty--header-visible .adf-datatable-body .adf-datatable-row:focus{background-color:unset;cursor:default}@media screen and (max-width: 380px){.adf-datatable-header{max-height:50%}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.IterableDiffers }, { type: i1$3.MatIconRegistry }, { type: i1$2.DomSanitizer }]; }, propDecorators: { rowsList: [{
                type: ViewChildren,
                args: [DataTableRowComponent]
            }], columnList: [{
                type: ContentChild,
                args: [DataColumnListComponent]
            }], data: [{
                type: Input
            }], display: [{
                type: Input
            }], rows: [{
                type: Input
            }], sorting: [{
                type: Input
            }], columns: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], multiselect: [{
                type: Input
            }], mainTableAction: [{
                type: Input
            }], actions: [{
                type: Input
            }], showMainDatatableActions: [{
                type: Input
            }], actionsPosition: [{
                type: Input
            }], actionsVisibleOnHover: [{
                type: Input
            }], fallbackThumbnail: [{
                type: Input
            }], contextMenu: [{
                type: Input
            }], rowStyle: [{
                type: Input
            }], rowStyleClass: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], stickyHeader: [{
                type: Input
            }], rowClick: [{
                type: Output
            }], rowDblClick: [{
                type: Output
            }], showRowContextMenu: [{
                type: Output
            }], showRowActionsMenu: [{
                type: Output
            }], executeRowAction: [{
                type: Output
            }], columnOrderChanged: [{
                type: Output
            }], columnsWidthChanged: [{
                type: Output
            }], loading: [{
                type: Input
            }], noPermission: [{
                type: Input
            }], rowMenuCacheEnabled: [{
                type: Input
            }], resolverFn: [{
                type: Input
            }], allowFiltering: [{
                type: Input
            }], isResizingEnabled: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EmptyListComponent {
}
EmptyListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EmptyListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: EmptyListComponent, selector: "adf-empty-list", ngImport: i0, template: "<div class=\"adf-empty-list_template\">\n    <ng-content select=\"[adf-empty-list-header]\"></ng-content>\n    <ng-content select=\"[adf-empty-list-body]\"></ng-content>\n    <ng-content select=\"[adf-empty-list-footer]\"></ng-content>\n    <ng-content></ng-content>\n</div>", styles: [".adf-empty-list_template{text-align:center;margin-top:20px;margin-bottom:20px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-empty-list', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-empty-list_template\">\n    <ng-content select=\"[adf-empty-list-header]\"></ng-content>\n    <ng-content select=\"[adf-empty-list-body]\"></ng-content>\n    <ng-content select=\"[adf-empty-list-footer]\"></ng-content>\n    <ng-content></ng-content>\n</div>", styles: [".adf-empty-list_template{text-align:center;margin-top:20px;margin-bottom:20px}\n"] }]
        }] });
class EmptyListHeaderDirective {
}
EmptyListHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListHeaderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
EmptyListHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: EmptyListHeaderDirective, selector: "[adf-empty-list-header]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListHeaderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-empty-list-header]' }]
        }] });
class EmptyListBodyDirective {
}
EmptyListBodyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListBodyDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
EmptyListBodyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: EmptyListBodyDirective, selector: "[adf-empty-list-body]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListBodyDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-empty-list-body]' }]
        }] });
class EmptyListFooterDirective {
}
EmptyListFooterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListFooterDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
EmptyListFooterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: EmptyListFooterDirective, selector: "[adf-empty-list-footer]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyListFooterDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-empty-list-footer]' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ColumnsSelectorComponent {
    constructor() {
        this.columns = [];
        this.submitColumnsVisibility = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.columnItems = [];
        this.searchInputControl = new UntypedFormControl('');
        this.searchQuery = '';
    }
    ngOnInit() {
        this.mainMenuTrigger.menuOpened.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            const columns = this.columns.map(column => ({ ...column }));
            this.columnItems = this.sortColumns(columns);
        });
        this.mainMenuTrigger.menuClosed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.searchInputControl.setValue('');
        });
        this.searchInputControl.valueChanges.pipe(debounceTime(300), takeUntil(this.onDestroy$)).subscribe((searchQuery) => {
            this.searchQuery = searchQuery;
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    closeMenu() {
        this.mainMenuTrigger.closeMenu();
    }
    changeColumnVisibility(column) {
        column.isHidden = !column.isHidden;
    }
    apply() {
        this.submitColumnsVisibility.emit(this.columnItems);
        this.closeMenu();
    }
    sortColumns(columns) {
        const shownColumns = columns.filter(column => !column.isHidden);
        const hiddenColumns = columns.filter(column => column.isHidden);
        return [...shownColumns, ...hiddenColumns];
    }
}
ColumnsSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ColumnsSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ColumnsSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ColumnsSelectorComponent, selector: "adf-datatable-column-selector", inputs: { columns: "columns", mainMenuTrigger: "mainMenuTrigger" }, outputs: { submitColumnsVisibility: "submitColumnsVisibility" }, ngImport: i0, template: "<div\n    class=\"adf-columns-selector\"\n    data-automation-id=\"adf-columns-selector\"\n    (click)=\"$event.stopPropagation();\"\n>\n    <div class=\"adf-columns-selector-header\">\n        <span class=\"adf-columns-selector-header-label\">\n            {{\"ADF-DATATABLE.COLUMNS_SELECTOR.COLUMNS\" | translate}}\n        </span>\n\n        <button\n            data-automation-id=\"adf-columns-selector-close-button\"\n            mat-icon-button\n            (click)=\"closeMenu()\"\n        >\n            <mat-icon>close</mat-icon>\n        </button>\n    </div>\n\n    <mat-divider class=\"adf-columns-selector-divider\"></mat-divider>\n\n    <div class=\"adf-columns-selector-search-input-container\">\n        <mat-icon\n            class=\"adf-columns-selector-search-input-icon\">\n            search\n        </mat-icon>\n\n        <input\n            [formControl]=\"searchInputControl\"\n            class=\"adf-columns-selector-search-input\"\n            data-automation-id=\"adf-columns-selector-search-input\"\n            type=\"text\"\n            [placeholder]='\"ADF-DATATABLE.COLUMNS_SELECTOR.SEARCH\" | translate'>\n    </div>\n\n    <div class=\"adf-columns-selector-list-container\">\n        <ng-container *ngFor=\"let column of columnItems\">\n            <div\n                *ngIf=\"(column.title | translate | filterString:searchQuery) as translatedTitle\"\n                class=\"adf-columns-selector-list-item\">\n                <mat-checkbox\n                    color=\"primary\"\n                    class=\"adf-columns-selector-column-checkbox\"\n                    [attr.data-automation-id]=\"'adf-columns-selector-column-checkbox-' + column.title\"\n                    [checked]=\"!column.isHidden\"\n                    (change)=\"changeColumnVisibility(column)\">\n                    <div class=\"adf-columns-selector-list-content\">{{translatedTitle}}</div>\n                </mat-checkbox>\n            </div>\n        </ng-container>\n    </div>\n\n    <mat-divider class=\"adf-columns-selector-divider\"></mat-divider>\n\n    <div class=\"adf-columns-selector-footer\">\n        <button\n            mat-flat-button\n            data-automation-id=\"adf-columns-selector-apply-button\"\n            color=\"primary\"\n            (click)=\"apply()\">\n            {{\"ADF-DATATABLE.COLUMNS_SELECTOR.APPLY\" | translate}}\n        </button>\n    </div>\n</div>\n", styles: [".adf-columns-selector{padding:12px 0;min-width:277px}.adf-columns-selector-header{padding:0 12px;display:flex;justify-content:space-between;align-items:center}.adf-columns-selector-header-label{font-size:var(--theme-body-1-font-size)}.adf-columns-selector-list-container{max-height:350px;overflow-x:hidden;overflow-y:auto}.adf-columns-selector-list-item{margin-top:10px}.adf-columns-selector-list-item:hover{background-color:var(--adf-theme-background-hover-color)}.adf-columns-selector-list-content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;width:210px}.adf-columns-selector-column-checkbox{padding:0 20px}.adf-columns-selector-footer{padding:0 12px;display:flex;justify-content:flex-end}.adf-columns-selector-divider{margin:16px 0}.adf-columns-selector-search-input-container{padding:0 12px;position:relative;display:flex;align-items:center;margin-bottom:15px}.adf-columns-selector-search-input{padding:10px 10px 10px 29px;width:100%;outline:0;border-radius:6px;border:1px solid var(--theme-background-color);background:var(--theme-background-color)}.adf-columns-selector-search-input :focus{outline:none!important}.adf-columns-selector-search-input-icon{position:absolute;left:17px;top:10px;font-size:var(--theme-adf-icon-1-font-size)}\n"], dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i2$5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i4$1.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: FilterStringPipe, name: "filterString" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ColumnsSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-datatable-column-selector', encapsulation: ViewEncapsulation.None, template: "<div\n    class=\"adf-columns-selector\"\n    data-automation-id=\"adf-columns-selector\"\n    (click)=\"$event.stopPropagation();\"\n>\n    <div class=\"adf-columns-selector-header\">\n        <span class=\"adf-columns-selector-header-label\">\n            {{\"ADF-DATATABLE.COLUMNS_SELECTOR.COLUMNS\" | translate}}\n        </span>\n\n        <button\n            data-automation-id=\"adf-columns-selector-close-button\"\n            mat-icon-button\n            (click)=\"closeMenu()\"\n        >\n            <mat-icon>close</mat-icon>\n        </button>\n    </div>\n\n    <mat-divider class=\"adf-columns-selector-divider\"></mat-divider>\n\n    <div class=\"adf-columns-selector-search-input-container\">\n        <mat-icon\n            class=\"adf-columns-selector-search-input-icon\">\n            search\n        </mat-icon>\n\n        <input\n            [formControl]=\"searchInputControl\"\n            class=\"adf-columns-selector-search-input\"\n            data-automation-id=\"adf-columns-selector-search-input\"\n            type=\"text\"\n            [placeholder]='\"ADF-DATATABLE.COLUMNS_SELECTOR.SEARCH\" | translate'>\n    </div>\n\n    <div class=\"adf-columns-selector-list-container\">\n        <ng-container *ngFor=\"let column of columnItems\">\n            <div\n                *ngIf=\"(column.title | translate | filterString:searchQuery) as translatedTitle\"\n                class=\"adf-columns-selector-list-item\">\n                <mat-checkbox\n                    color=\"primary\"\n                    class=\"adf-columns-selector-column-checkbox\"\n                    [attr.data-automation-id]=\"'adf-columns-selector-column-checkbox-' + column.title\"\n                    [checked]=\"!column.isHidden\"\n                    (change)=\"changeColumnVisibility(column)\">\n                    <div class=\"adf-columns-selector-list-content\">{{translatedTitle}}</div>\n                </mat-checkbox>\n            </div>\n        </ng-container>\n    </div>\n\n    <mat-divider class=\"adf-columns-selector-divider\"></mat-divider>\n\n    <div class=\"adf-columns-selector-footer\">\n        <button\n            mat-flat-button\n            data-automation-id=\"adf-columns-selector-apply-button\"\n            color=\"primary\"\n            (click)=\"apply()\">\n            {{\"ADF-DATATABLE.COLUMNS_SELECTOR.APPLY\" | translate}}\n        </button>\n    </div>\n</div>\n", styles: [".adf-columns-selector{padding:12px 0;min-width:277px}.adf-columns-selector-header{padding:0 12px;display:flex;justify-content:space-between;align-items:center}.adf-columns-selector-header-label{font-size:var(--theme-body-1-font-size)}.adf-columns-selector-list-container{max-height:350px;overflow-x:hidden;overflow-y:auto}.adf-columns-selector-list-item{margin-top:10px}.adf-columns-selector-list-item:hover{background-color:var(--adf-theme-background-hover-color)}.adf-columns-selector-list-content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;width:210px}.adf-columns-selector-column-checkbox{padding:0 20px}.adf-columns-selector-footer{padding:0 12px;display:flex;justify-content:flex-end}.adf-columns-selector-divider{margin:16px 0}.adf-columns-selector-search-input-container{padding:0 12px;position:relative;display:flex;align-items:center;margin-bottom:15px}.adf-columns-selector-search-input{padding:10px 10px 10px 29px;width:100%;outline:0;border-radius:6px;border:1px solid var(--theme-background-color);background:var(--theme-background-color)}.adf-columns-selector-search-input :focus{outline:none!important}.adf-columns-selector-search-input-icon{position:absolute;left:17px;top:10px;font-size:var(--theme-adf-icon-1-font-size)}\n"] }]
        }], propDecorators: { columns: [{
                type: Input
            }], mainMenuTrigger: [{
                type: Input
            }], submitColumnsVisibility: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class DataTableSchema {
    constructor(appConfigService, presetKey, presetsModel) {
        this.appConfigService = appConfigService;
        this.presetKey = presetKey;
        this.presetsModel = presetsModel;
        this.columnsOrderedByKey = 'id';
        this.layoutPresets = {};
        this.columnsSchemaSubject$ = new ReplaySubject();
        this.isColumnSchemaCreated$ = this.columnsSchemaSubject$.asObservable();
    }
    createDatatableSchema() {
        this.loadLayoutPresets();
        if (!this.columns || this.columns.length === 0) {
            this.createColumns();
            this.columnsSchemaSubject$.next(true);
        }
        else {
            this.columnsSchemaSubject$.next(false);
        }
    }
    createColumns() {
        const allColumns = this.mergeJsonAndHtmlSchema();
        const allColumnsWithWidth = this.setColumnsWidth(allColumns);
        const columns = this.setHiddenColumns(allColumnsWithWidth);
        this.columns = this.sortColumnsByKey(columns);
    }
    loadLayoutPresets() {
        const externalSettings = this.appConfigService.get(this.presetKey, null);
        if (externalSettings) {
            this.layoutPresets = Object.assign({}, this.presetsModel, externalSettings);
        }
        else {
            this.layoutPresets = this.presetsModel;
        }
    }
    mergeJsonAndHtmlSchema() {
        const configSchemaColumns = this.getSchemaFromConfig(this.presetColumn);
        const htmlSchemaColumns = this.getSchemaFromHtml(this.columnList);
        let customSchemaColumns = [
            ...configSchemaColumns,
            ...htmlSchemaColumns
        ];
        if (customSchemaColumns.length === 0) {
            customSchemaColumns = this.getDefaultLayoutPreset();
        }
        return customSchemaColumns;
    }
    getSchemaFromHtml(columnList) {
        let schema = [];
        if (columnList && columnList.columns && columnList.columns.length > 0) {
            schema = columnList.columns.map((c) => c);
        }
        return schema;
    }
    getSchemaFromConfig(presetColumn) {
        return presetColumn ? (this.layoutPresets[presetColumn]).map((col) => new ObjectDataColumn(col)) : [];
    }
    getDefaultLayoutPreset() {
        return (this.layoutPresets['default']).map((col) => new ObjectDataColumn(col));
    }
    setPresetKey(presetKey) {
        this.presetKey = presetKey;
    }
    setPresetsModel(presetsModel) {
        this.presetsModel = presetsModel;
    }
    sortColumnsByKey(columns) {
        const defaultColumns = [...columns];
        const columnsWithProperOrder = [];
        (this.columnsOrder ?? []).forEach(columnKey => {
            const originalColumnIndex = defaultColumns.findIndex(defaultColumn => defaultColumn[this.columnsOrderedByKey] === columnKey);
            if (originalColumnIndex > -1) {
                columnsWithProperOrder.push(defaultColumns[originalColumnIndex]);
                defaultColumns.splice(originalColumnIndex, 1);
            }
        });
        return [...columnsWithProperOrder, ...defaultColumns];
    }
    setHiddenColumns(columns) {
        if (this.columnsVisibility) {
            return columns.map(column => {
                const isColumnVisible = this.columnsVisibility[column.id];
                return isColumnVisible === undefined ?
                    column :
                    { ...column, isHidden: !isColumnVisible };
            });
        }
        return columns;
    }
    setColumnsWidth(columns) {
        if (this.columnsWidths) {
            return columns.map(column => {
                const columnWidth = this.columnsWidths[column.id];
                return columnWidth === undefined ? column : { ...column, width: columnWidth };
            });
        }
        return columns;
    }
}
DataTableSchema.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableSchema, deps: "invalid", target: i0.ɵɵFactoryTarget.Directive });
DataTableSchema.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: DataTableSchema, inputs: { presetColumn: "presetColumn" }, queries: [{ propertyName: "columnList", first: true, predicate: DataColumnListComponent, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableSchema, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: undefined }, { type: undefined }]; }, propDecorators: { columnList: [{
                type: ContentChild,
                args: [DataColumnListComponent]
            }], presetColumn: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class LoadingContentTemplateDirective {
    constructor(dataTable) {
        this.dataTable = dataTable;
    }
    ngAfterContentInit() {
        if (this.dataTable) {
            this.dataTable.loadingTemplate = this.template;
        }
    }
}
LoadingContentTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoadingContentTemplateDirective, deps: [{ token: DataTableComponent }], target: i0.ɵɵFactoryTarget.Directive });
LoadingContentTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LoadingContentTemplateDirective, selector: "adf-loading-content-template, loading-content-template", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LoadingContentTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-loading-content-template, loading-content-template'
                }]
        }], ctorParameters: function () { return [{ type: DataTableComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class NoContentTemplateDirective {
    constructor(dataTable) {
        this.dataTable = dataTable;
    }
    ngAfterContentInit() {
        if (this.dataTable) {
            this.dataTable.noContentTemplate = this.template;
        }
    }
}
NoContentTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NoContentTemplateDirective, deps: [{ token: DataTableComponent }], target: i0.ɵɵFactoryTarget.Directive });
NoContentTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NoContentTemplateDirective, selector: "adf-no-content-template, no-content-template", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NoContentTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-no-content-template, no-content-template'
                }]
        }], ctorParameters: function () { return [{ type: DataTableComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class NoPermissionTemplateDirective {
    constructor(dataTable) {
        this.dataTable = dataTable;
    }
    ngAfterContentInit() {
        if (this.dataTable) {
            this.dataTable.noPermissionTemplate = this.template;
        }
    }
}
NoPermissionTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NoPermissionTemplateDirective, deps: [{ token: DataTableComponent }], target: i0.ɵɵFactoryTarget.Directive });
NoPermissionTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NoPermissionTemplateDirective, selector: "adf-no-permission-template, no-permission-template", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NoPermissionTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-no-permission-template, no-permission-template'
                }]
        }], ctorParameters: function () { return [{ type: DataTableComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HeaderFilterTemplateDirective {
    constructor(dataTable) {
        this.dataTable = dataTable;
    }
    ngAfterContentInit() {
        if (this.dataTable) {
            this.dataTable.headerFilterTemplate = this.template;
        }
    }
}
HeaderFilterTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HeaderFilterTemplateDirective, deps: [{ token: DataTableComponent }], target: i0.ɵɵFactoryTarget.Directive });
HeaderFilterTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: HeaderFilterTemplateDirective, selector: "adf-header-filter-template", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HeaderFilterTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-header-filter-template'
                }]
        }], ctorParameters: function () { return [{ type: DataTableComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0.
 * The empty-folder-content selector will be deprecated as it has been replace by
 * adf-custom-empty-content-template.
 */
class CustomEmptyContentTemplateDirective {
}
CustomEmptyContentTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomEmptyContentTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CustomEmptyContentTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: CustomEmptyContentTemplateDirective, selector: "adf-custom-empty-content-template, empty-folder-content", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomEmptyContentTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-custom-empty-content-template, empty-folder-content'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CustomLoadingContentTemplateDirective {
}
CustomLoadingContentTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomLoadingContentTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CustomLoadingContentTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: CustomLoadingContentTemplateDirective, selector: "adf-custom-loading-content-template", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomLoadingContentTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-custom-loading-content-template'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0.
 * The no-permission-content selector will be deprecated as it has been replace by
 * adf-custom-no-permission-template.
 */
class CustomNoPermissionTemplateDirective {
}
CustomNoPermissionTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomNoPermissionTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CustomNoPermissionTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: CustomNoPermissionTemplateDirective, selector: "adf-custom-no-permission-template, no-permission-content", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomNoPermissionTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-custom-no-permission-template, no-permission-content'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MainMenuDataTableTemplateDirective {
    constructor(dataTable) {
        this.dataTable = dataTable;
    }
    ngAfterContentInit() {
        if (this.dataTable) {
            this.dataTable.mainActionTemplate = this.template;
        }
    }
}
MainMenuDataTableTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MainMenuDataTableTemplateDirective, deps: [{ token: DataTableComponent }], target: i0.ɵɵFactoryTarget.Directive });
MainMenuDataTableTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: MainMenuDataTableTemplateDirective, selector: "adf-main-menu-datatable-template", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MainMenuDataTableTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-main-menu-datatable-template'
                }]
        }], ctorParameters: function () { return [{ type: DataTableComponent }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContextMenuModule {
}
ContextMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContextMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuModule, declarations: [ContextMenuDirective,
        ContextMenuListComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule], exports: [ContextMenuDirective] });
ContextMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContextMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule
                    ],
                    declarations: [
                        ContextMenuDirective,
                        ContextMenuListComponent
                    ],
                    exports: [
                        ContextMenuDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ClipboardModule {
}
ClipboardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ClipboardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ClipboardModule, declarations: [ClipboardDirective,
        ClipboardComponent], imports: [CommonModule,
        TranslateModule], exports: [ClipboardDirective] });
ClipboardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardModule, imports: [CommonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ClipboardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule
                    ],
                    declarations: [
                        ClipboardDirective,
                        ClipboardComponent
                    ],
                    exports: [
                        ClipboardDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IconModule {
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule,
        MatIconModule], exports: [IconComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconModule, imports: [CommonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule
                    ],
                    declarations: [
                        IconComponent
                    ],
                    exports: [
                        IconComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ResizableModule {
}
ResizableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ResizableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ResizableModule, declarations: [ResizableDirective, ResizeHandleDirective], exports: [ResizableDirective, ResizeHandleDirective] });
ResizableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizableModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResizableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ResizableDirective, ResizeHandleDirective],
                    exports: [ResizableDirective, ResizeHandleDirective]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataColumnModule {
}
DataColumnModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataColumnModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DataColumnModule, declarations: [DataColumnComponent,
        DataColumnListComponent,
        DateColumnHeaderComponent], imports: [CommonModule], exports: [DataColumnComponent,
        DataColumnListComponent,
        DateColumnHeaderComponent] });
DataColumnModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataColumnModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        DataColumnComponent,
                        DataColumnListComponent,
                        DateColumnHeaderComponent
                    ],
                    exports: [
                        DataColumnComponent,
                        DataColumnListComponent,
                        DateColumnHeaderComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DataTableModule {
}
DataTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DataTableModule, declarations: [DataTableComponent,
        EmptyListComponent,
        EmptyListHeaderDirective,
        EmptyListBodyDirective,
        EmptyListFooterDirective,
        DataTableCellComponent,
        DataTableRowComponent,
        DateCellComponent,
        FileSizeCellComponent,
        LocationCellComponent,
        JsonCellComponent,
        ColumnsSelectorComponent,
        NoContentTemplateDirective,
        NoPermissionTemplateDirective,
        LoadingContentTemplateDirective,
        HeaderFilterTemplateDirective,
        CustomEmptyContentTemplateDirective,
        CustomLoadingContentTemplateDirective,
        CustomNoPermissionTemplateDirective,
        MainMenuDataTableTemplateDirective,
        DropZoneDirective], imports: [RouterModule,
        MaterialModule,
        CommonModule,
        TranslateModule,
        ContextMenuModule,
        PipeModule,
        DirectiveModule,
        ClipboardModule,
        DragDropModule,
        IconModule,
        FormsModule,
        ReactiveFormsModule,
        ResizableModule,
        DataColumnModule], exports: [DataTableComponent,
        EmptyListComponent,
        EmptyListHeaderDirective,
        EmptyListBodyDirective,
        EmptyListFooterDirective,
        DataTableCellComponent,
        DataTableRowComponent,
        DateCellComponent,
        ColumnsSelectorComponent,
        FileSizeCellComponent,
        LocationCellComponent,
        JsonCellComponent,
        NoContentTemplateDirective,
        NoPermissionTemplateDirective,
        LoadingContentTemplateDirective,
        HeaderFilterTemplateDirective,
        CustomEmptyContentTemplateDirective,
        CustomLoadingContentTemplateDirective,
        CustomNoPermissionTemplateDirective,
        MainMenuDataTableTemplateDirective,
        DropZoneDirective,
        DataColumnComponent,
        DataColumnListComponent,
        DateColumnHeaderComponent] });
DataTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableModule, imports: [RouterModule,
        MaterialModule,
        CommonModule,
        TranslateModule,
        ContextMenuModule,
        PipeModule,
        DirectiveModule,
        ClipboardModule,
        DragDropModule,
        IconModule,
        FormsModule,
        ReactiveFormsModule,
        ResizableModule,
        DataColumnModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule,
                        MaterialModule,
                        CommonModule,
                        TranslateModule,
                        ContextMenuModule,
                        PipeModule,
                        DirectiveModule,
                        ClipboardModule,
                        DragDropModule,
                        IconModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ResizableModule,
                        DataColumnModule
                    ],
                    declarations: [
                        DataTableComponent,
                        EmptyListComponent,
                        EmptyListHeaderDirective,
                        EmptyListBodyDirective,
                        EmptyListFooterDirective,
                        DataTableCellComponent,
                        DataTableRowComponent,
                        DateCellComponent,
                        FileSizeCellComponent,
                        LocationCellComponent,
                        JsonCellComponent,
                        ColumnsSelectorComponent,
                        NoContentTemplateDirective,
                        NoPermissionTemplateDirective,
                        LoadingContentTemplateDirective,
                        HeaderFilterTemplateDirective,
                        CustomEmptyContentTemplateDirective,
                        CustomLoadingContentTemplateDirective,
                        CustomNoPermissionTemplateDirective,
                        MainMenuDataTableTemplateDirective,
                        DropZoneDirective
                    ],
                    exports: [
                        DataTableComponent,
                        EmptyListComponent,
                        EmptyListHeaderDirective,
                        EmptyListBodyDirective,
                        EmptyListFooterDirective,
                        DataTableCellComponent,
                        DataTableRowComponent,
                        DateCellComponent,
                        ColumnsSelectorComponent,
                        FileSizeCellComponent,
                        LocationCellComponent,
                        JsonCellComponent,
                        NoContentTemplateDirective,
                        NoPermissionTemplateDirective,
                        LoadingContentTemplateDirective,
                        HeaderFilterTemplateDirective,
                        CustomEmptyContentTemplateDirective,
                        CustomLoadingContentTemplateDirective,
                        CustomNoPermissionTemplateDirective,
                        MainMenuDataTableTemplateDirective,
                        DropZoneDirective,
                        DataColumnComponent,
                        DataColumnListComponent,
                        DateColumnHeaderComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const transformKeyToObject = (key, value) => {
    const objectLevels = key.split('.').reverse();
    return objectLevels.reduce((previousValue, currentValue) => ({ [currentValue]: previousValue }), value);
};
class CardViewUpdateService {
    constructor() {
        this.itemUpdated$ = new Subject();
        this.itemClicked$ = new Subject();
        this.updateItem$ = new Subject();
    }
    update(property, newValue) {
        this.itemUpdated$.next({
            target: property,
            changed: transformKeyToObject(property.key, newValue)
        });
    }
    clicked(property) {
        this.itemClicked$.next({
            target: property
        });
    }
    /**
     * Updates the cardview items property
     *
     * @param notification
     */
    updateElement(notification) {
        this.updateItem$.next(notification);
    }
}
CardViewUpdateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewUpdateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CardViewUpdateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewUpdateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewUpdateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class BaseCardView {
    constructor() {
        this.cardViewUpdateService = inject(CardViewUpdateService);
        this.destroy$ = new Subject();
        this.cardViewUpdateService.updateItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe((itemModel) => {
            if (this.property.key === itemModel.key) {
                this.property.value = itemModel.value;
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
BaseCardView.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseCardView, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BaseCardView.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: BaseCardView, inputs: { property: "property" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseCardView, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { property: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SEPARATOR = ', ';
const templateTypes = {
    clickableTemplate: 'clickableTemplate',
    multilineTemplate: 'multilineTemplate',
    chipsTemplate: 'chipsTemplate',
    emptyTemplate: 'emptyTemplate',
    defaultTemplate: 'defaultTemplate'
};
class CardViewTextItemComponent extends BaseCardView {
    constructor(clipboardService, translateService, cd) {
        super();
        this.clipboardService = clipboardService;
        this.translateService = translateService;
        this.cd = cd;
        this.editable = false;
        this.displayEmpty = true;
        this.copyToClipboardAction = true;
        this.useChipsForMultiValueProperty = true;
        this.multiValueSeparator = DEFAULT_SEPARATOR;
        this.textInput = new UntypedFormControl();
        this.onDestroy$ = new Subject();
    }
    ngOnChanges(changes) {
        if (changes.property && changes.property.firstChange) {
            this.textInput.valueChanges
                .pipe(filter(textInputValue => textInputValue !== this.editedValue && textInputValue !== null), debounceTime(50), takeUntil(this.onDestroy$))
                .subscribe(textInputValue => {
                this.editedValue = textInputValue;
                this.update();
            });
        }
        this.resetValue();
        this.setTemplateType();
        if (changes.editable) {
            if (this.isEditable) {
                this.textInput.enable();
            }
            else {
                this.textInput.disable();
            }
        }
    }
    setTemplateType() {
        if (this.showProperty || this.isEditable) {
            if (this.isClickable) {
                this.templateType = templateTypes.clickableTemplate;
            }
            else if (this.isChipViewEnabled) {
                this.templateType = templateTypes.chipsTemplate;
            }
            else {
                this.templateType = templateTypes.defaultTemplate;
            }
        }
        else {
            this.templateType = templateTypes.emptyTemplate;
        }
    }
    resetValue() {
        if (this.isChipViewEnabled) {
            this.editedValue = this.property.value ? Array.from(this.property.value) : [];
        }
        else {
            this.editedValue = this.property.displayValue;
            this.textInput.setValue(this.editedValue);
        }
        this.resetErrorMessages();
    }
    resetErrorMessages() {
        this.errors = [];
    }
    update() {
        this.resetErrorMessages();
        if (this.property.isValid(this.editedValue)) {
            this.property.value = this.prepareValueForUpload(this.property, this.editedValue);
            this.cardViewUpdateService.update({ ...this.property }, this.property.value);
        }
        else {
            this.errors = this.property.getValidationErrors(this.editedValue);
            this.cardViewUpdateService.update({ ...this.property }, this.editedValue);
        }
    }
    prepareValueForUpload(property, value) {
        if (property.multivalued && typeof value === 'string') {
            const listOfValues = value.split(this.multiValueSeparator.trim()).map((item) => item.trim());
            return listOfValues;
        }
        return value;
    }
    removeValueFromList(itemIndex) {
        if (Array.isArray(this.editedValue)) {
            this.editedValue.splice(itemIndex, 1);
            this.update();
            this.cd.detectChanges();
        }
    }
    addValueToList(newListItem) {
        const chipInput = newListItem.input;
        const chipValue = newListItem.value.trim() || '';
        if (typeof this.editedValue !== 'string') {
            if (chipValue) {
                this.editedValue.push(chipValue);
                this.update();
            }
            if (chipInput) {
                chipInput.value = '';
            }
        }
    }
    clicked() {
        if (typeof this.property.clickCallBack === 'function') {
            this.property.clickCallBack();
        }
        else {
            this.cardViewUpdateService.clicked(this.property);
        }
    }
    clearValue() {
        this.editedValue = '';
        this.textInput.setValue('');
        this.update();
    }
    copyToClipboard(valueToCopy) {
        if (this.copyToClipboardAction) {
            const clipboardMessage = this.translateService.instant('CORE.METADATA.ACCESSIBILITY.COPY_TO_CLIPBOARD_MESSAGE');
            this.clipboardService.copyContentToClipboard(valueToCopy, clipboardMessage);
        }
    }
    undoText(event) {
        if ((event.ctrlKey || event.metaKey) && event.code === 'KeyZ' && this.textInput.value) {
            this.textInput.setValue('');
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    get showProperty() {
        return this.displayEmpty || !this.property.isEmpty();
    }
    get showClickableIcon() {
        return this.hasIcon && this.editable;
    }
    get isEditable() {
        return this.editable && this.property.editable;
    }
    get isClickable() {
        return this.property.clickable;
    }
    get hasIcon() {
        return !!this.property.icon;
    }
    get hasErrors() {
        return (!!this.errors?.length) ?? false;
    }
    get isChipViewEnabled() {
        return this.property.multivalued && this.useChipsForMultiValueProperty;
    }
}
CardViewTextItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewTextItemComponent, deps: [{ token: ClipboardService }, { token: TranslationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
CardViewTextItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewTextItemComponent, selector: "adf-card-view-textitem", inputs: { editable: "editable", displayEmpty: "displayEmpty", copyToClipboardAction: "copyToClipboardAction", useChipsForMultiValueProperty: "useChipsForMultiValueProperty", multiValueSeparator: "multiValueSeparator" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [ngSwitch]=\"templateType\">\n    <div *ngSwitchDefault>\n        <mat-form-field class=\"adf-property-field adf-card-textitem-field\"\n            [ngClass]=\"{ 'adf-property-read-only': !isEditable, 'adf-property-field-has-error mat-form-field-invalid': isEditable && hasErrors }\"\n            [floatLabel]=\"'never'\"\n            appearance=\"standard\">\n            <mat-label *ngIf=\"showProperty || isEditable\" [attr.data-automation-id]=\"'card-textitem-label-' + property.key\" class=\"adf-property-label\">\n                {{ property.label | translate }}\n            </mat-label>\n                <input matInput\n                    *ngIf=\"!property.multiline\"\n                    class=\"adf-property-value\"\n                    title=\"{{property.label | translate }}\"\n                    [placeholder]=\"property.default\"\n                    [attr.aria-label]=\"property.label | translate\"\n                    [formControl]=\"textInput\"\n                    (dblclick)=\"copyToClipboard(property.displayValue)\"\n                    matTooltipShowDelay=\"1000\"\n                    [matTooltip]=\"'CORE.METADATA.ACTIONS.COPY_TO_CLIPBOARD' | translate\"\n                    [matTooltipDisabled]=\"isEditable\"\n                    [attr.data-automation-id]=\"'card-textitem-value-' + property.key\"\n                    (keydown)=\"undoText($event)\">\n                <textarea matInput\n                    *ngIf=\"property.multiline\"\n                    title=\"{{property.label | translate }}\"\n                    [cdkTextareaAutosize]=\"true\"\n                    [cdkAutosizeMaxRows]=\"1\"\n                    [cdkAutosizeMaxRows]=\"5\"\n                    class=\"adf-property-value\"\n                    [placeholder]=\"property.default\"\n                    [attr.aria-label]=\"property.label | translate\"\n                    [formControl]=\"textInput\"\n                    [attr.data-automation-id]=\"'card-textitem-value-' + property.key\">\n                </textarea>\n\n                <button\n                    *ngIf=\"isEditable\"\n                    matSuffix\n                    class=\"adf-textitem-clear-icon\"\n                    [attr.aria-label]=\"'CORE.METADATA.ACTIONS.CLEAR' | translate\"\n                    (click)=\"clearValue()\">\n                    <mat-icon>cancel</mat-icon>\n                </button>\n                <button\n                    *ngIf=\"isEditable\"\n                    matSuffix\n                    class=\"adf-textitem-edit-icon\"\n                    [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\">\n                    <mat-icon>mode_edit</mat-icon>\n                </button>\n\n        </mat-form-field>\n    </div>\n\n    <div *ngSwitchCase=\"'chipsTemplate'\"\n         class=\"adf-property-field adf-textitem-chip-list-container\">\n        <mat-chip-list #chipList\n            class=\"adf-textitem-chip-list\">\n            <mat-chip *ngFor=\"let propertyValue of editedValue; let idx = index\"\n                [removable]=\"isEditable\"\n                (removed)=\"removeValueFromList(idx)\">\n                {{ propertyValue }}\n                <mat-icon *ngIf=\"isEditable\"\n                    matChipRemove>cancel</mat-icon>\n            </mat-chip>\n        </mat-chip-list>\n\n        <mat-form-field *ngIf=\"isEditable\" appearance=\"standard\"\n            class=\"adf-property-field adf-textitem-chip-list-input\"\n            [ngClass]=\"{ 'adf-property-read-only': !isEditable }\"\n            [floatLabel]=\"'never'\">\n            <input matInput\n                class=\"adf-property-value\"\n                title=\"{{property.label | translate }}\"\n                [placeholder]=\"editedValue ? '' : property.default | translate\"\n                [attr.aria-label]=\"property.label | translate\"\n                [matChipInputFor]=\"chipList\"\n                [matChipInputAddOnBlur]=\"true\"\n                (matChipInputTokenEnd)=\"addValueToList($event)\"\n                [attr.data-automation-id]=\"'card-textitem-editchipinput-' + property.key\">\n            <mat-icon matSuffix\n                class=\"adf-textitem-edit-icon\">mode_edit</mat-icon>\n        </mat-form-field>\n    </div>\n\n    <div *ngSwitchCase=\"'clickableTemplate'\"\n        role=\"button\"\n        class=\"adf-textitem-clickable\"\n        [ngClass]=\"{ 'adf-property-read-only': !isEditable }\"\n        [attr.data-automation-id]=\"'card-textitem-toggle-' + property.key\"\n        (click)=\"clicked()\">\n        <mat-form-field class=\"adf-property-field adf-card-textitem-field\" appearance=\"standard\"\n            [floatLabel]=\"'never'\">\n            <mat-label *ngIf=\"showProperty || isEditable\" [attr.data-automation-id]=\"'card-textitem-label-' + property.key\" class=\"adf-property-label\">\n                {{ property.label | translate }}\n            </mat-label>\n            <input matInput\n                [type]=property.inputType\n                class=\"adf-property-value\"\n                title=\"{{property.label | translate }}\"\n                [ngClass]=\"{ 'adf-textitem-clickable-value': !isEditable }\"\n                [placeholder]=\"property.default\"\n                [attr.aria-label]=\"property.label | translate\"\n                [(ngModel)]=\"editedValue\"\n                (blur)=\"update()\"\n                (keydown.enter)=\"update()\"\n                [disabled]=\"!isEditable\"\n                [attr.data-automation-id]=\"'card-textitem-value-' + property.key\">\n            <button mat-icon-button\n                matSuffix\n                *ngIf=\"showClickableIcon\"\n                class=\"adf-textitem-action\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                [attr.data-automation-id]=\"'card-textitem-clickable-icon-' + property.key\">\n                <mat-icon class=\"adf-textitem-icon\">{{ property?.icon }}</mat-icon>\n            </button>\n        </mat-form-field>\n\n    </div>\n\n    <div *ngSwitchCase=\"'emptyTemplate'\">\n        <span class=\"adf-textitem-default-value\">{{ property.default | translate }}</span>\n    </div>\n\n    <mat-error [attr.data-automation-id]=\"'card-textitem-error-' + property.key\"\n               class=\"adf-textitem-editable-error\"\n               *ngIf=\"isEditable && hasErrors\">\n        <ul>\n            <li *ngFor=\"let error of errors\">{{ error.message | translate: error }}</li>\n        </ul>\n    </mat-error>\n</div>\n", styles: [".adf-textitem-edit-icon.mat-icon{font-size:var(--theme-subheading-2-font-size);width:16px;height:16px;color:var(--adf-theme-foreground-text-color-025)}.adf-textitem-action.mat-icon-button{width:20px;height:20px;line-height:20px;color:var(--adf-theme-foreground-text-color-025)}.adf-textitem-action:hover,.adf-textitem-action:focus{color:var(--adf-theme-foreground-text-color)}.adf-update-icon{padding-left:13px}.adf-textitem-readonly{cursor:pointer!important}.adf-textitem-readonly:hover .adf-textitem-action,.adf-textitem-readonly:focus .adf-textitem-action{color:var(--adf-theme-foreground-text-color)}.adf-textitem-chip-list-container{margin-bottom:25px!important;margin-top:6px}.adf-textitem-chip-list-container .mat-form-field-label{margin-top:6px}.adf-textitem-clickable{cursor:pointer!important;padding-top:3px}.adf-textitem-clickable .adf-textitem-edit-icon.mat-icon{line-height:16px}.adf-textitem-clickable:hover .adf-textitem-action{color:var(--adf-theme-foreground-text-color)}.adf-textitem-clickable-value{cursor:pointer!important;color:var(--theme-primary-color)!important}.adf-textitem-editable-controls{display:flex;align-items:center}.adf-textitem-editable-controls mat-icon:not(.adf-button-disabled):hover{color:var(--adf-theme-foreground-text-color);cursor:pointer!important}.adf-textitem-editable-controls mat-form-field{width:100%}.adf-textitem-editable-controls input:focus,.adf-textitem-editable-controls textarea:focus{border:1px solid var(--theme-accent-color-a200)}.adf-textitem-editable-error{font-size:var(--theme-caption-font-size);padding-top:6px}.adf-textitem-editable-error ul{margin:0;padding:0;list-style-type:none}.adf-textitem-editable-error ul li{margin:0;padding:0}.adf-textitem-default-value{color:var(--adf-theme-foreground-text-color-054)}.adf-textitem-editable .mat-form-field-wrapper{margin:0;padding-bottom:0}.adf-textitem-editable .mat-form-field-underline{display:none}.adf-textitem-editable .mat-form-field-infix{padding:0;border-top:none}.adf-textitem-editable .mat-form-field-label-wrapper{padding-top:2em;position:static}.adf-textitem-editable .mat-form-field-label{top:4px}.adf-textitem-editable .mat-input-element{font-family:inherit;position:relative;padding-top:6px}.adf-textitem-editable .mat-input-element:focus{padding:5px;left:-6px;top:0}.adf-textitem-editable input.mat-input-element{margin-bottom:2px}.adf-textitem-editable input.mat-input-element:focus{margin-bottom:-8px}.adf-textitem-scroll{overflow-x:auto;white-space:nowrap;display:block}.adf-textitem-scroll::-webkit-scrollbar{height:5px}.adf-textitem-scroll:hover::-webkit-scrollbar-thumb{display:block;background-color:var(--adf-theme-foreground-text-color-025);border-radius:2px}.adf-textitem-multiline{display:block}.adf-property-field .adf-property-clear-value,.adf-property-field .adf-textitem-edit-value{width:30px;height:30px}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon{display:block}.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon{display:none}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon,.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon{background:transparent;border:none}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon:hover,.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon:hover{cursor:pointer}.mat-form-field .mat-form-field-suffix:hover .adf-textitem-edit-icon{display:none}.mat-form-field .mat-form-field-suffix:hover .adf-textitem-clear-icon{display:block}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i7.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.CdkTextareaAutosize, selector: "textarea[cdkTextareaAutosize]", inputs: ["cdkAutosizeMinRows", "cdkAutosizeMaxRows", "cdkTextareaAutosize", "placeholder"], exportAs: ["cdkTextareaAutosize"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i10$1.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i10$1.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i10$1.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i10$1.MatChipRemove, selector: "[matChipRemove]" }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewTextItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-textitem', encapsulation: ViewEncapsulation.None, template: "<div [ngSwitch]=\"templateType\">\n    <div *ngSwitchDefault>\n        <mat-form-field class=\"adf-property-field adf-card-textitem-field\"\n            [ngClass]=\"{ 'adf-property-read-only': !isEditable, 'adf-property-field-has-error mat-form-field-invalid': isEditable && hasErrors }\"\n            [floatLabel]=\"'never'\"\n            appearance=\"standard\">\n            <mat-label *ngIf=\"showProperty || isEditable\" [attr.data-automation-id]=\"'card-textitem-label-' + property.key\" class=\"adf-property-label\">\n                {{ property.label | translate }}\n            </mat-label>\n                <input matInput\n                    *ngIf=\"!property.multiline\"\n                    class=\"adf-property-value\"\n                    title=\"{{property.label | translate }}\"\n                    [placeholder]=\"property.default\"\n                    [attr.aria-label]=\"property.label | translate\"\n                    [formControl]=\"textInput\"\n                    (dblclick)=\"copyToClipboard(property.displayValue)\"\n                    matTooltipShowDelay=\"1000\"\n                    [matTooltip]=\"'CORE.METADATA.ACTIONS.COPY_TO_CLIPBOARD' | translate\"\n                    [matTooltipDisabled]=\"isEditable\"\n                    [attr.data-automation-id]=\"'card-textitem-value-' + property.key\"\n                    (keydown)=\"undoText($event)\">\n                <textarea matInput\n                    *ngIf=\"property.multiline\"\n                    title=\"{{property.label | translate }}\"\n                    [cdkTextareaAutosize]=\"true\"\n                    [cdkAutosizeMaxRows]=\"1\"\n                    [cdkAutosizeMaxRows]=\"5\"\n                    class=\"adf-property-value\"\n                    [placeholder]=\"property.default\"\n                    [attr.aria-label]=\"property.label | translate\"\n                    [formControl]=\"textInput\"\n                    [attr.data-automation-id]=\"'card-textitem-value-' + property.key\">\n                </textarea>\n\n                <button\n                    *ngIf=\"isEditable\"\n                    matSuffix\n                    class=\"adf-textitem-clear-icon\"\n                    [attr.aria-label]=\"'CORE.METADATA.ACTIONS.CLEAR' | translate\"\n                    (click)=\"clearValue()\">\n                    <mat-icon>cancel</mat-icon>\n                </button>\n                <button\n                    *ngIf=\"isEditable\"\n                    matSuffix\n                    class=\"adf-textitem-edit-icon\"\n                    [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\">\n                    <mat-icon>mode_edit</mat-icon>\n                </button>\n\n        </mat-form-field>\n    </div>\n\n    <div *ngSwitchCase=\"'chipsTemplate'\"\n         class=\"adf-property-field adf-textitem-chip-list-container\">\n        <mat-chip-list #chipList\n            class=\"adf-textitem-chip-list\">\n            <mat-chip *ngFor=\"let propertyValue of editedValue; let idx = index\"\n                [removable]=\"isEditable\"\n                (removed)=\"removeValueFromList(idx)\">\n                {{ propertyValue }}\n                <mat-icon *ngIf=\"isEditable\"\n                    matChipRemove>cancel</mat-icon>\n            </mat-chip>\n        </mat-chip-list>\n\n        <mat-form-field *ngIf=\"isEditable\" appearance=\"standard\"\n            class=\"adf-property-field adf-textitem-chip-list-input\"\n            [ngClass]=\"{ 'adf-property-read-only': !isEditable }\"\n            [floatLabel]=\"'never'\">\n            <input matInput\n                class=\"adf-property-value\"\n                title=\"{{property.label | translate }}\"\n                [placeholder]=\"editedValue ? '' : property.default | translate\"\n                [attr.aria-label]=\"property.label | translate\"\n                [matChipInputFor]=\"chipList\"\n                [matChipInputAddOnBlur]=\"true\"\n                (matChipInputTokenEnd)=\"addValueToList($event)\"\n                [attr.data-automation-id]=\"'card-textitem-editchipinput-' + property.key\">\n            <mat-icon matSuffix\n                class=\"adf-textitem-edit-icon\">mode_edit</mat-icon>\n        </mat-form-field>\n    </div>\n\n    <div *ngSwitchCase=\"'clickableTemplate'\"\n        role=\"button\"\n        class=\"adf-textitem-clickable\"\n        [ngClass]=\"{ 'adf-property-read-only': !isEditable }\"\n        [attr.data-automation-id]=\"'card-textitem-toggle-' + property.key\"\n        (click)=\"clicked()\">\n        <mat-form-field class=\"adf-property-field adf-card-textitem-field\" appearance=\"standard\"\n            [floatLabel]=\"'never'\">\n            <mat-label *ngIf=\"showProperty || isEditable\" [attr.data-automation-id]=\"'card-textitem-label-' + property.key\" class=\"adf-property-label\">\n                {{ property.label | translate }}\n            </mat-label>\n            <input matInput\n                [type]=property.inputType\n                class=\"adf-property-value\"\n                title=\"{{property.label | translate }}\"\n                [ngClass]=\"{ 'adf-textitem-clickable-value': !isEditable }\"\n                [placeholder]=\"property.default\"\n                [attr.aria-label]=\"property.label | translate\"\n                [(ngModel)]=\"editedValue\"\n                (blur)=\"update()\"\n                (keydown.enter)=\"update()\"\n                [disabled]=\"!isEditable\"\n                [attr.data-automation-id]=\"'card-textitem-value-' + property.key\">\n            <button mat-icon-button\n                matSuffix\n                *ngIf=\"showClickableIcon\"\n                class=\"adf-textitem-action\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                [attr.data-automation-id]=\"'card-textitem-clickable-icon-' + property.key\">\n                <mat-icon class=\"adf-textitem-icon\">{{ property?.icon }}</mat-icon>\n            </button>\n        </mat-form-field>\n\n    </div>\n\n    <div *ngSwitchCase=\"'emptyTemplate'\">\n        <span class=\"adf-textitem-default-value\">{{ property.default | translate }}</span>\n    </div>\n\n    <mat-error [attr.data-automation-id]=\"'card-textitem-error-' + property.key\"\n               class=\"adf-textitem-editable-error\"\n               *ngIf=\"isEditable && hasErrors\">\n        <ul>\n            <li *ngFor=\"let error of errors\">{{ error.message | translate: error }}</li>\n        </ul>\n    </mat-error>\n</div>\n", styles: [".adf-textitem-edit-icon.mat-icon{font-size:var(--theme-subheading-2-font-size);width:16px;height:16px;color:var(--adf-theme-foreground-text-color-025)}.adf-textitem-action.mat-icon-button{width:20px;height:20px;line-height:20px;color:var(--adf-theme-foreground-text-color-025)}.adf-textitem-action:hover,.adf-textitem-action:focus{color:var(--adf-theme-foreground-text-color)}.adf-update-icon{padding-left:13px}.adf-textitem-readonly{cursor:pointer!important}.adf-textitem-readonly:hover .adf-textitem-action,.adf-textitem-readonly:focus .adf-textitem-action{color:var(--adf-theme-foreground-text-color)}.adf-textitem-chip-list-container{margin-bottom:25px!important;margin-top:6px}.adf-textitem-chip-list-container .mat-form-field-label{margin-top:6px}.adf-textitem-clickable{cursor:pointer!important;padding-top:3px}.adf-textitem-clickable .adf-textitem-edit-icon.mat-icon{line-height:16px}.adf-textitem-clickable:hover .adf-textitem-action{color:var(--adf-theme-foreground-text-color)}.adf-textitem-clickable-value{cursor:pointer!important;color:var(--theme-primary-color)!important}.adf-textitem-editable-controls{display:flex;align-items:center}.adf-textitem-editable-controls mat-icon:not(.adf-button-disabled):hover{color:var(--adf-theme-foreground-text-color);cursor:pointer!important}.adf-textitem-editable-controls mat-form-field{width:100%}.adf-textitem-editable-controls input:focus,.adf-textitem-editable-controls textarea:focus{border:1px solid var(--theme-accent-color-a200)}.adf-textitem-editable-error{font-size:var(--theme-caption-font-size);padding-top:6px}.adf-textitem-editable-error ul{margin:0;padding:0;list-style-type:none}.adf-textitem-editable-error ul li{margin:0;padding:0}.adf-textitem-default-value{color:var(--adf-theme-foreground-text-color-054)}.adf-textitem-editable .mat-form-field-wrapper{margin:0;padding-bottom:0}.adf-textitem-editable .mat-form-field-underline{display:none}.adf-textitem-editable .mat-form-field-infix{padding:0;border-top:none}.adf-textitem-editable .mat-form-field-label-wrapper{padding-top:2em;position:static}.adf-textitem-editable .mat-form-field-label{top:4px}.adf-textitem-editable .mat-input-element{font-family:inherit;position:relative;padding-top:6px}.adf-textitem-editable .mat-input-element:focus{padding:5px;left:-6px;top:0}.adf-textitem-editable input.mat-input-element{margin-bottom:2px}.adf-textitem-editable input.mat-input-element:focus{margin-bottom:-8px}.adf-textitem-scroll{overflow-x:auto;white-space:nowrap;display:block}.adf-textitem-scroll::-webkit-scrollbar{height:5px}.adf-textitem-scroll:hover::-webkit-scrollbar-thumb{display:block;background-color:var(--adf-theme-foreground-text-color-025);border-radius:2px}.adf-textitem-multiline{display:block}.adf-property-field .adf-property-clear-value,.adf-property-field .adf-textitem-edit-value{width:30px;height:30px}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon{display:block}.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon{display:none}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon,.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon{background:transparent;border:none}.mat-form-field .mat-form-field-suffix .adf-textitem-edit-icon:hover,.mat-form-field .mat-form-field-suffix .adf-textitem-clear-icon:hover{cursor:pointer}.mat-form-field .mat-form-field-suffix:hover .adf-textitem-edit-icon{display:none}.mat-form-field .mat-form-field-suffix:hover .adf-textitem-clear-icon{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: ClipboardService }, { type: TranslationService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { editable: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], copyToClipboardAction: [{
                type: Input
            }], useChipsForMultiValueProperty: [{
                type: Input
            }], multiValueSeparator: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemMatchValidator {
    constructor(expression, flags) {
        this.expression = expression;
        this.flags = flags;
        this.message = 'CORE.CARDVIEW.VALIDATORS.MATCH_VALIDATION_ERROR';
    }
    isValid(value) {
        const regex = new RegExp(this.expression, this.flags);
        return value === '' || regex.test(value);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemIntValidator {
    constructor() {
        this.message = 'CORE.CARDVIEW.VALIDATORS.INT_VALIDATION_ERROR';
    }
    isValid(value) {
        if (Array.isArray(value)) {
            return value.every(this.isIntegerNumber);
        }
        return value === '' || !isNaN(value) && this.isIntegerNumber(value) && this.isNotOnlySpace(value);
    }
    isIntegerNumber(value) {
        const parsedNumber = Number(value);
        return (parsedNumber | 0) === parsedNumber;
    }
    isNotOnlySpace(value) {
        return String(value).trim() !== '';
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemMinMaxValidator {
    constructor(minValue, maxValue) {
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.message = 'CORE.CARDVIEW.VALIDATORS.MINMAX_VALIDATION_ERROR';
        this.intValidator = new CardViewItemIntValidator();
    }
    isValid(value) {
        return this.intValidator.isValid(value) && (value >= this.minValue && value <= this.maxValue);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemLengthValidator {
    constructor(minLength, maxLength) {
        this.minLength = minLength;
        this.maxLength = maxLength;
        this.message = 'CORE.CARDVIEW.VALIDATORS.LENGTH_VALIDATION_ERROR';
    }
    isValid(value = '') {
        const stringLength = value.length;
        return stringLength >= this.minLength && stringLength <= this.maxLength;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const validators = {
    minmax: (parameters) => new CardViewItemMinMaxValidator(parameters.minValue, parameters.maxValue),
    regex: (parameters) => new CardViewItemMatchValidator(parameters.expression),
    length: (parameters) => new CardViewItemLengthValidator(parameters.minLength, parameters.maxLength)
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewBaseItemModel {
    constructor(cardViewItemProperties) {
        this.label = cardViewItemProperties.label || '';
        this.value = cardViewItemProperties.value && cardViewItemProperties.value.displayName || cardViewItemProperties.value;
        this.key = cardViewItemProperties.key;
        this.default = cardViewItemProperties.default;
        this.editable = !!cardViewItemProperties.editable;
        this.clickable = !!cardViewItemProperties.clickable;
        this.icon = cardViewItemProperties.icon || '';
        this.hint = cardViewItemProperties.hint || '';
        this.validators = cardViewItemProperties.validators || [];
        this.data = cardViewItemProperties.data || null;
        this.multivalued = !!cardViewItemProperties.multivalued;
        if (cardViewItemProperties?.constraints?.length ?? 0) {
            for (const constraint of cardViewItemProperties.constraints) {
                if (constraint.type !== 'LIST') {
                    this.validators.push(validators[constraint.type.toLowerCase()](constraint.parameters));
                }
            }
        }
    }
    isEmpty() {
        return this.value === undefined || this.value === null || this.value.length === 0;
    }
    isValid(newValue) {
        if (!this.validators.length) {
            return true;
        }
        return this.validators
            .map((validator) => validator.isValid(newValue))
            .reduce((isValidUntilNow, isValid) => isValidUntilNow && isValid, true);
    }
    getValidationErrors(value) {
        if (!this.validators.length) {
            return [];
        }
        return this.validators.filter((validator) => !validator.isValid(value)).map((validator) => validator);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewDateItemModel extends CardViewBaseItemModel {
    constructor(cardViewDateItemProperties) {
        super(cardViewDateItemProperties);
        this.type = 'date';
        if (cardViewDateItemProperties.format) {
            this.format = cardViewDateItemProperties.format;
        }
        if (cardViewDateItemProperties.locale) {
            this.locale = cardViewDateItemProperties.locale;
        }
    }
    get displayValue() {
        if (this.multivalued) {
            if (this.value) {
                return this.value.map((date) => this.transformDate(date));
            }
            else {
                return this.default ? [this.default] : [];
            }
        }
        else {
            return this.value ? this.transformDate(this.value) : this.default;
        }
    }
    transformDate(value) {
        this.localizedDatePipe = new LocalizedDatePipe();
        return this.localizedDatePipe.transform(value, this.format, this.locale);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewDateItemComponent extends BaseCardView {
    constructor(dateAdapter, userPreferencesService, appConfig, clipboardService, translateService) {
        super();
        this.dateAdapter = dateAdapter;
        this.userPreferencesService = userPreferencesService;
        this.appConfig = appConfig;
        this.clipboardService = clipboardService;
        this.translateService = translateService;
        this.editable = false;
        this.displayEmpty = true;
        this.displayClearAction = true;
        this.onDestroy$ = new Subject();
        this.dateFormat = this.appConfig.get('dateValues.defaultDateFormat');
    }
    ngOnInit() {
        this.userPreferencesService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => {
            this.dateAdapter.setLocale(locale);
            this.property.locale = locale;
        });
        this.dateAdapter.overrideDisplayFormat = 'MMM DD';
        if (this.property.value) {
            this.valueDate = moment(this.property.value, this.dateFormat);
        }
        else if (this.property.multivalued && !this.property.value) {
            this.property.value = [];
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    showProperty() {
        return this.displayEmpty || !this.property.isEmpty();
    }
    showClearAction() {
        return this.displayClearAction && (!this.property.isEmpty() || !!this.property.default);
    }
    isEditable() {
        return this.editable && this.property.editable;
    }
    showDatePicker() {
        this.datepicker.open();
    }
    onDateChanged(newDateValue) {
        if (newDateValue) {
            const momentDate = moment(newDateValue.value, this.dateFormat, true);
            if (momentDate.isValid()) {
                this.valueDate = momentDate;
                this.property.value = momentDate.toDate();
                this.update();
            }
        }
    }
    onDateClear() {
        this.valueDate = null;
        this.cardViewUpdateService.update({ ...this.property }, null);
        this.property.value = null;
        this.property.default = null;
    }
    copyToClipboard(valueToCopy) {
        const clipboardMessage = this.translateService.instant('CORE.METADATA.ACCESSIBILITY.COPY_TO_CLIPBOARD_MESSAGE');
        this.clipboardService.copyContentToClipboard(valueToCopy, clipboardMessage);
    }
    addDateToList(newDateValue) {
        if (newDateValue) {
            const momentDate = moment(newDateValue.value, this.dateFormat, true);
            if (momentDate.isValid()) {
                this.property.value.push(momentDate.toDate());
                this.update();
            }
        }
    }
    removeValueFromList(itemIndex) {
        this.property.value.splice(itemIndex, 1);
        this.update();
    }
    update() {
        this.cardViewUpdateService.update({ ...this.property }, this.property.value);
    }
}
CardViewDateItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewDateItemComponent, deps: [{ token: i2$7.DateAdapter }, { token: UserPreferencesService }, { token: AppConfigService }, { token: ClipboardService }, { token: TranslationService }], target: i0.ɵɵFactoryTarget.Component });
CardViewDateItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewDateItemComponent, selector: "adf-card-view-dateitem", inputs: { property: "property", editable: "editable", displayEmpty: "displayEmpty", displayClearAction: "displayClearAction" }, providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
    ], viewQueries: [{ propertyName: "datepicker", first: true, predicate: ["datetimePicker"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<label class=\"adf-property-label\"\n     [attr.data-automation-id]=\"'card-dateitem-label-' + property.key\"\n     *ngIf=\"showProperty() || isEditable()\"\n     [attr.for]=\"'card-view-dateitem-' + property.key\">\n    {{ property.label | translate }}\n</label>\n<div class=\"adf-property-value adf-property-value-padding-top\">\n    <span *ngIf=\"!isEditable() && !property.multivalued\"\n          [attr.data-automation-id]=\"'card-' + property.type + '-value-' + property.key\">\n        <span *ngIf=\"showProperty()\"\n              [attr.data-automation-id]=\"'card-dateitem-' + property.key\"\n              (dblclick)=\"copyToClipboard(property.displayValue)\"\n              matTooltipShowDelay=\"1000\"\n              [matTooltip]=\"'CORE.METADATA.ACTIONS.COPY_TO_CLIPBOARD' | translate\">{{ property.displayValue}}</span>\n    </span>\n    <div *ngIf=\"isEditable() && !property.multivalued\"\n         class=\"adf-dateitem-editable\">\n        <div class=\"adf-dateitem-editable-controls\">\n            <span class=\"adf-datepicker-toggle\"\n                  [attr.data-automation-id]=\"'datepicker-label-toggle-' + property.key\"\n                  (click)=\"showDatePicker()\">\n                <span *ngIf=\"showProperty(); else elseEmptyValueBlock\"\n                      [attr.data-automation-id]=\"'card-' + property.type + '-value-' + property.key\">\n                    {{ property.displayValue }}</span>\n            </span>\n\n            <mat-icon *ngIf=\"showClearAction()\"\n                      class=\"adf-date-reset-icon\"\n                      (click)=\"onDateClear()\"\n                      [attr.title]=\"'CORE.METADATA.ACTIONS.CLEAR' | translate\"\n                      [attr.data-automation-id]=\"'datepicker-date-clear-' + property.key\">\n                clear\n            </mat-icon>\n\n            <mat-datetimepicker-toggle [attr.tabindex]=\"-1\"\n                                       [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                                       [attr.data-automation-id]=\"'datepickertoggle-' + property.key\"\n                                       [for]=\"datetimePicker\">\n            </mat-datetimepicker-toggle>\n        </div>\n\n        <input class=\"adf-invisible-date-input\"\n               [attr.tabIndex]=\"-1\"\n               [matDatetimepicker]=\"datetimePicker\"\n               [value]=\"valueDate\"\n               (dateChange)=\"onDateChanged($event)\"\n               [attr.id]=\"'card-view-dateitem-' + property.key\"\n        >\n\n        <mat-datetimepicker #datetimePicker\n                            [type]=\"$any(property).type\"\n                            [timeInterval]=\"5\"\n                            [attr.data-automation-id]=\"'datepicker-' + property.key\"\n                            [startAt]=\"valueDate\">\n        </mat-datetimepicker>\n    </div>\n    <ng-template #elseEmptyValueBlock>\n        {{ property.default | translate }}\n    </ng-template>\n\n    <div *ngIf=\"property.multivalued\"\n         class=\"adf-property-field adf-dateitem-chip-list-container adf-dateitem-editable\">\n        <mat-chip-list #chipList\n                       class=\"adf-textitem-chip-list\">\n            <mat-chip *ngFor=\"let propertyValue of property.displayValue; let idx = index\"\n                      [removable]=\"isEditable()\"\n                      (removed)=\"removeValueFromList(idx)\">\n                {{ propertyValue }}\n                <mat-icon *ngIf=\"isEditable()\"\n                          matChipRemove>cancel</mat-icon>\n            </mat-chip>\n        </mat-chip-list>\n\n        <mat-form-field *ngIf=\"isEditable()\"\n                        class=\"adf-property-field adf-dateitem-editable-controls\"\n                        [floatLabel]=\"'never'\"\n                        (click)=\"showDatePicker()\">\n            <input matInput\n                   class=\"adf-invisible-date-input\"\n                   [attr.tabIndex]=\"-1\"\n                   [matDatetimepicker]=\"datetimePicker\"\n                   (dateChange)=\"addDateToList($event)\"\n                   [attr.id]=\"'card-view-dateitem-' + property.key\"\n            >\n            <mat-datetimepicker-toggle [attr.tabindex]=\"-1\"\n                                       matSuffix\n                                       [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                                       [attr.data-automation-id]=\"'datepickertoggle-' + property.key\"\n                                       [for]=\"datetimePicker\">\n            </mat-datetimepicker-toggle>\n\n            <mat-datetimepicker #datetimePicker\n                                [type]=\"$any(property).type\"\n                                [timeInterval]=\"5\"\n                                [attr.data-automation-id]=\"'datepicker-' + property.key\"\n                                [startAt]=\"valueDate\">\n            </mat-datetimepicker>\n        </mat-form-field>\n    </div>\n</div>\n", styles: [".adf-invisible-date-input{height:2px;width:0;overflow:hidden;opacity:0;border:none;margin:0;padding:0;float:right}.adf-dateitem-chip-list-container.adf-property-field{margin-bottom:-7px!important;border-bottom:0;cursor:pointer}.adf-dateitem-chip-list-container.adf-property-field .adf-dateitem-editable-controls{margin-top:15px}.adf-dateitem-chip-list-container.adf-property-field .mat-datetimepicker-toggle{position:absolute;right:0;top:-20px}.adf-dateitem-editable{cursor:pointer;border-bottom:1px solid var(--adf-theme-foreground-text-color-042);padding-bottom:6px}.adf-dateitem-editable-controls{display:flex;align-items:center;justify-content:space-between}.adf-dateitem-editable-controls button.mat-icon-button{line-height:20px;height:20px;width:20px}.adf-dateitem-editable-controls mat-icon{width:16px;height:16px;opacity:.5}.adf-dateitem-editable-controls:hover mat-icon{opacity:1}.adf-dateitem-editable-controls .adf-datepicker-toggle{flex:1 0 auto}.adf-dateitem-editable-controls mat-icon.adf-date-reset-icon{line-height:10px;font-size:var(--theme-subheading-2-font-size);width:16px;height:16px;position:relative;top:4px;padding-left:8px;opacity:.3}.adf-dateitem-editable-controls:hover mat-icon.adf-date-reset-icon{opacity:1}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10$1.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i10$1.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i10$1.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i11$1.MatDatetimepickerComponent, selector: "mat-datetimepicker", inputs: ["multiYearSelector", "twelvehour", "startView", "mode", "timeInterval", "ariaNextMonthLabel", "ariaPrevMonthLabel", "ariaNextYearLabel", "ariaPrevYearLabel", "preventSameDateTimeSelection", "panelClass", "startAt", "openOnFocus", "type", "touchUi", "disabled"], outputs: ["selectedChanged", "opened", "closed", "viewChanged"], exportAs: ["matDatetimepicker"] }, { kind: "component", type: i11$1.MatDatetimepickerToggleComponent, selector: "mat-datetimepicker-toggle", inputs: ["for", "disabled"], exportAs: ["matDatetimepickerToggle"] }, { kind: "directive", type: i11$1.MatDatetimepickerInputDirective, selector: "input[matDatetimepicker]", inputs: ["matDatetimepicker", "matDatepickerFilter", "value", "min", "max", "disabled"], outputs: ["dateChange", "dateInput"], exportAs: ["matDatepickerInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewDateItemComponent, decorators: [{
            type: Component,
            args: [{ providers: [
                        { provide: DateAdapter, useClass: MomentDateAdapter },
                        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
                        { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
                        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
                    ], selector: 'adf-card-view-dateitem', encapsulation: ViewEncapsulation.None, template: "<label class=\"adf-property-label\"\n     [attr.data-automation-id]=\"'card-dateitem-label-' + property.key\"\n     *ngIf=\"showProperty() || isEditable()\"\n     [attr.for]=\"'card-view-dateitem-' + property.key\">\n    {{ property.label | translate }}\n</label>\n<div class=\"adf-property-value adf-property-value-padding-top\">\n    <span *ngIf=\"!isEditable() && !property.multivalued\"\n          [attr.data-automation-id]=\"'card-' + property.type + '-value-' + property.key\">\n        <span *ngIf=\"showProperty()\"\n              [attr.data-automation-id]=\"'card-dateitem-' + property.key\"\n              (dblclick)=\"copyToClipboard(property.displayValue)\"\n              matTooltipShowDelay=\"1000\"\n              [matTooltip]=\"'CORE.METADATA.ACTIONS.COPY_TO_CLIPBOARD' | translate\">{{ property.displayValue}}</span>\n    </span>\n    <div *ngIf=\"isEditable() && !property.multivalued\"\n         class=\"adf-dateitem-editable\">\n        <div class=\"adf-dateitem-editable-controls\">\n            <span class=\"adf-datepicker-toggle\"\n                  [attr.data-automation-id]=\"'datepicker-label-toggle-' + property.key\"\n                  (click)=\"showDatePicker()\">\n                <span *ngIf=\"showProperty(); else elseEmptyValueBlock\"\n                      [attr.data-automation-id]=\"'card-' + property.type + '-value-' + property.key\">\n                    {{ property.displayValue }}</span>\n            </span>\n\n            <mat-icon *ngIf=\"showClearAction()\"\n                      class=\"adf-date-reset-icon\"\n                      (click)=\"onDateClear()\"\n                      [attr.title]=\"'CORE.METADATA.ACTIONS.CLEAR' | translate\"\n                      [attr.data-automation-id]=\"'datepicker-date-clear-' + property.key\">\n                clear\n            </mat-icon>\n\n            <mat-datetimepicker-toggle [attr.tabindex]=\"-1\"\n                                       [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                                       [attr.data-automation-id]=\"'datepickertoggle-' + property.key\"\n                                       [for]=\"datetimePicker\">\n            </mat-datetimepicker-toggle>\n        </div>\n\n        <input class=\"adf-invisible-date-input\"\n               [attr.tabIndex]=\"-1\"\n               [matDatetimepicker]=\"datetimePicker\"\n               [value]=\"valueDate\"\n               (dateChange)=\"onDateChanged($event)\"\n               [attr.id]=\"'card-view-dateitem-' + property.key\"\n        >\n\n        <mat-datetimepicker #datetimePicker\n                            [type]=\"$any(property).type\"\n                            [timeInterval]=\"5\"\n                            [attr.data-automation-id]=\"'datepicker-' + property.key\"\n                            [startAt]=\"valueDate\">\n        </mat-datetimepicker>\n    </div>\n    <ng-template #elseEmptyValueBlock>\n        {{ property.default | translate }}\n    </ng-template>\n\n    <div *ngIf=\"property.multivalued\"\n         class=\"adf-property-field adf-dateitem-chip-list-container adf-dateitem-editable\">\n        <mat-chip-list #chipList\n                       class=\"adf-textitem-chip-list\">\n            <mat-chip *ngFor=\"let propertyValue of property.displayValue; let idx = index\"\n                      [removable]=\"isEditable()\"\n                      (removed)=\"removeValueFromList(idx)\">\n                {{ propertyValue }}\n                <mat-icon *ngIf=\"isEditable()\"\n                          matChipRemove>cancel</mat-icon>\n            </mat-chip>\n        </mat-chip-list>\n\n        <mat-form-field *ngIf=\"isEditable()\"\n                        class=\"adf-property-field adf-dateitem-editable-controls\"\n                        [floatLabel]=\"'never'\"\n                        (click)=\"showDatePicker()\">\n            <input matInput\n                   class=\"adf-invisible-date-input\"\n                   [attr.tabIndex]=\"-1\"\n                   [matDatetimepicker]=\"datetimePicker\"\n                   (dateChange)=\"addDateToList($event)\"\n                   [attr.id]=\"'card-view-dateitem-' + property.key\"\n            >\n            <mat-datetimepicker-toggle [attr.tabindex]=\"-1\"\n                                       matSuffix\n                                       [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                                       [attr.data-automation-id]=\"'datepickertoggle-' + property.key\"\n                                       [for]=\"datetimePicker\">\n            </mat-datetimepicker-toggle>\n\n            <mat-datetimepicker #datetimePicker\n                                [type]=\"$any(property).type\"\n                                [timeInterval]=\"5\"\n                                [attr.data-automation-id]=\"'datepicker-' + property.key\"\n                                [startAt]=\"valueDate\">\n            </mat-datetimepicker>\n        </mat-form-field>\n    </div>\n</div>\n", styles: [".adf-invisible-date-input{height:2px;width:0;overflow:hidden;opacity:0;border:none;margin:0;padding:0;float:right}.adf-dateitem-chip-list-container.adf-property-field{margin-bottom:-7px!important;border-bottom:0;cursor:pointer}.adf-dateitem-chip-list-container.adf-property-field .adf-dateitem-editable-controls{margin-top:15px}.adf-dateitem-chip-list-container.adf-property-field .mat-datetimepicker-toggle{position:absolute;right:0;top:-20px}.adf-dateitem-editable{cursor:pointer;border-bottom:1px solid var(--adf-theme-foreground-text-color-042);padding-bottom:6px}.adf-dateitem-editable-controls{display:flex;align-items:center;justify-content:space-between}.adf-dateitem-editable-controls button.mat-icon-button{line-height:20px;height:20px;width:20px}.adf-dateitem-editable-controls mat-icon{width:16px;height:16px;opacity:.5}.adf-dateitem-editable-controls:hover mat-icon{opacity:1}.adf-dateitem-editable-controls .adf-datepicker-toggle{flex:1 0 auto}.adf-dateitem-editable-controls mat-icon.adf-date-reset-icon{line-height:10px;font-size:var(--theme-subheading-2-font-size);width:16px;height:16px;position:relative;top:4px;padding-left:8px;opacity:.3}.adf-dateitem-editable-controls:hover mat-icon.adf-date-reset-icon{opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$7.DateAdapter }, { type: UserPreferencesService }, { type: AppConfigService }, { type: ClipboardService }, { type: TranslationService }]; }, propDecorators: { property: [{
                type: Input
            }], editable: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], displayClearAction: [{
                type: Input
            }], datepicker: [{
                type: ViewChild,
                args: ['datetimePicker']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewMapItemModel extends CardViewBaseItemModel {
    constructor() {
        super(...arguments);
        this.type = 'map';
    }
    get displayValue() {
        if (this.value && this.value.size > 0) {
            return this.value.values().next().value;
        }
        else {
            return this.default;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewMapItemComponent extends BaseCardView {
    constructor() {
        super(...arguments);
        this.displayEmpty = true;
    }
    showProperty() {
        return this.displayEmpty || !this.property.isEmpty();
    }
    isClickable() {
        return this.property.clickable;
    }
    clicked() {
        this.cardViewUpdateService.clicked(this.property);
    }
}
CardViewMapItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewMapItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CardViewMapItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewMapItemComponent, selector: "adf-card-view-mapitem", inputs: { property: "property", displayEmpty: "displayEmpty" }, usesInheritance: true, ngImport: i0, template: "<div [attr.data-automation-id]=\"'card-mapitem-label-' + property.key\"\n     class=\"adf-property-label\"\n     *ngIf=\"showProperty()\">{{ property.label | translate }}</div>\n<div class=\"adf-property-value adf-map-item-padding\">\n    <div>\n        <span *ngIf=\"!isClickable(); else clickableTemplate\"\n              [attr.data-automation-id]=\"'card-mapitem-value-' + property.key\">\n            <span *ngIf=\"showProperty();\">{{ property.displayValue }}</span>\n        </span>\n    </div>\n    <ng-template #clickableTemplate>\n        <span class=\"adf-mapitem-clickable-value\"\n              (click)=\"clicked()\"\n              [attr.data-automation-id]=\"'card-mapitem-value-' + property.key\">\n            <span *ngIf=\"showProperty(); else emptyValueTemplate\">{{ property.displayValue }}</span>\n        </span>\n    </ng-template>\n    <ng-template #emptyValueTemplate>\n        {{ property.default | translate }}\n    </ng-template>\n</div>\n", styles: [".adf-mapitem-clickable-value{cursor:pointer!important}.adf-map-item-padding{padding-top:6px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewMapItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-mapitem', template: "<div [attr.data-automation-id]=\"'card-mapitem-label-' + property.key\"\n     class=\"adf-property-label\"\n     *ngIf=\"showProperty()\">{{ property.label | translate }}</div>\n<div class=\"adf-property-value adf-map-item-padding\">\n    <div>\n        <span *ngIf=\"!isClickable(); else clickableTemplate\"\n              [attr.data-automation-id]=\"'card-mapitem-value-' + property.key\">\n            <span *ngIf=\"showProperty();\">{{ property.displayValue }}</span>\n        </span>\n    </div>\n    <ng-template #clickableTemplate>\n        <span class=\"adf-mapitem-clickable-value\"\n              (click)=\"clicked()\"\n              [attr.data-automation-id]=\"'card-mapitem-value-' + property.key\">\n            <span *ngIf=\"showProperty(); else emptyValueTemplate\">{{ property.displayValue }}</span>\n        </span>\n    </ng-template>\n    <ng-template #emptyValueTemplate>\n        {{ property.default | translate }}\n    </ng-template>\n</div>\n", styles: [".adf-mapitem-clickable-value{cursor:pointer!important}.adf-map-item-padding{padding-top:6px}\n"] }]
        }], propDecorators: { property: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SelectFilterInputComponent {
    constructor(matSelect) {
        this.matSelect = matSelect;
        this.change = new EventEmitter();
        this.term = '';
        this.onDestroy$ = new Subject();
    }
    onModelChange(value) {
        this.change.next(value);
    }
    ngOnInit() {
        this.change
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((val) => this.term = val);
        this.matSelect.openedChange
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((isOpened) => {
            if (isOpened) {
                this.selectFilterInput.nativeElement.focus();
            }
            else {
                this.change.next('');
            }
        });
        if (this.matSelect.ngControl) {
            this.previousSelected = this.matSelect.ngControl.value;
            this.matSelect.ngControl.valueChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((values) => {
                let restoreSelection = false;
                if (this.matSelect.multiple && Array.isArray(this.previousSelected)) {
                    if (!Array.isArray(values)) {
                        values = [];
                    }
                    const options = this.matSelect.options.map(option => option.value);
                    this.previousSelected.forEach((previous) => {
                        const isSelected = [...values, ...options].some(current => this.matSelect.compareWith(current, previous));
                        if (!isSelected) {
                            values.push(previous);
                            restoreSelection = true;
                        }
                    });
                }
                this.previousSelected = values;
                if (restoreSelection) {
                    // eslint-disable-next-line no-underscore-dangle
                    this.matSelect._onChange(values);
                }
            });
        }
    }
    reset(event) {
        if (event) {
            event.stopPropagation();
        }
        this.change.next('');
        this.selectFilterInput.nativeElement.focus();
    }
    handleKeydown($event) {
        if (this.term) {
            if ($event.keyCode === ESCAPE) {
                event.stopPropagation();
                this.change.next('');
            }
            if ($event.target.tagName === 'INPUT' && $event.keyCode === TAB) {
                event.stopPropagation();
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
SelectFilterInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SelectFilterInputComponent, deps: [{ token: MatSelect }], target: i0.ɵɵFactoryTarget.Component });
SelectFilterInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SelectFilterInputComponent, selector: "adf-select-filter-input", outputs: { change: "change" }, host: { classAttribute: "adf-select-filter-input" }, viewQueries: [{ propertyName: "selectFilterInput", first: true, predicate: ["selectFilterInput"], descendants: true, read: ElementRef }], ngImport: i0, template: "\n<div class=\"adf-select-filter-input-container\">\n    <mat-form-field>\n        <input matInput\n            autocomplete=\"off\"\n            (keydown)=\"handleKeydown($event)\"\n            [placeholder]=\"'SELECT_FILTER.INPUT.PLACEHOLDER' | translate\"\n            #selectFilterInput\n            [ngModel]=\"term\"\n            (ngModelChange)=\"onModelChange($event)\"\n            [attr.aria-label]=\"'SELECT_FILTER.INPUT.ARIA_LABEL' | translate\"\n            (change)=\"$event.stopPropagation()\"\n        />\n\n        <button mat-button\n            matSuffix\n            mat-icon-button\n            [attr.aria-label]=\"'SELECT_FILTER.BUTTON.ARIA_LABEL' | translate\"\n            *ngIf=\"term\"\n            (keydown.enter)=\"reset($event)\"\n            (click)=\"reset()\">\n            <mat-icon>close</mat-icon>\n        </button>\n    </mat-form-field>\n</div>\n", styles: [".adf-select-filter-input{height:4em;display:flex}.adf-select-filter-input .adf-select-filter-input-container{width:100%;display:flex;z-index:100;font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087);line-height:3em;height:4em;padding:5px 16px 0;background:var(--adf-theme-background-card-color)}.adf-select-filter-input .mat-form-field{width:100%}.mat-select-panel.adf-select-filter{transform:none!important;overflow-x:hidden!important;max-height:calc(256px + 4em)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SelectFilterInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-select-filter-input', host: { class: 'adf-select-filter-input' }, encapsulation: ViewEncapsulation.None, template: "\n<div class=\"adf-select-filter-input-container\">\n    <mat-form-field>\n        <input matInput\n            autocomplete=\"off\"\n            (keydown)=\"handleKeydown($event)\"\n            [placeholder]=\"'SELECT_FILTER.INPUT.PLACEHOLDER' | translate\"\n            #selectFilterInput\n            [ngModel]=\"term\"\n            (ngModelChange)=\"onModelChange($event)\"\n            [attr.aria-label]=\"'SELECT_FILTER.INPUT.ARIA_LABEL' | translate\"\n            (change)=\"$event.stopPropagation()\"\n        />\n\n        <button mat-button\n            matSuffix\n            mat-icon-button\n            [attr.aria-label]=\"'SELECT_FILTER.BUTTON.ARIA_LABEL' | translate\"\n            *ngIf=\"term\"\n            (keydown.enter)=\"reset($event)\"\n            (click)=\"reset()\">\n            <mat-icon>close</mat-icon>\n        </button>\n    </mat-form-field>\n</div>\n", styles: [".adf-select-filter-input{height:4em;display:flex}.adf-select-filter-input .adf-select-filter-input-container{width:100%;display:flex;z-index:100;font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087);line-height:3em;height:4em;padding:5px 16px 0;background:var(--adf-theme-background-card-color)}.adf-select-filter-input .mat-form-field{width:100%}.mat-select-panel.adf-select-filter{transform:none!important;overflow-x:hidden!important;max-height:calc(256px + 4em)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$6.MatSelect, decorators: [{
                    type: Inject,
                    args: [MatSelect]
                }] }]; }, propDecorators: { selectFilterInput: [{
                type: ViewChild,
                args: ['selectFilterInput', { read: ElementRef, static: false }]
            }], change: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewSelectItemComponent extends BaseCardView {
    constructor() {
        super(...arguments);
        this.appConfig = inject(AppConfigService);
        this.editable = false;
        this.displayNoneOption = true;
        this.displayEmpty = true;
        this.filter$ = new BehaviorSubject('');
        this.showInputFilter = false;
        this.onDestroy$ = new Subject();
        this.list$ = null;
    }
    ngOnChanges() {
        this.value = this.property.value;
    }
    ngOnInit() {
        this.getOptions()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((options) => {
            this.showInputFilter = options.length > this.optionsLimit;
        });
        this.list$ = this.getList();
    }
    onFilterInputChange(value) {
        this.filter$.next(value.toString());
    }
    isEditable() {
        return this.editable && this.property.editable;
    }
    getOptions() {
        return this.options$ || this.property.options$;
    }
    getList() {
        return combineLatest([this.getOptions(), this.filter$])
            .pipe(map(([items, filter]) => items.filter((item) => filter ? item.label.toLowerCase().includes(filter.toLowerCase())
            : true)), takeUntil(this.onDestroy$));
    }
    onChange(event) {
        const selectedOption = event.value !== undefined ? event.value : null;
        this.cardViewUpdateService.update({ ...this.property }, selectedOption);
        this.property.value = selectedOption;
    }
    showNoneOption() {
        return this.displayNoneOption;
    }
    get showProperty() {
        return this.displayEmpty || !this.property.isEmpty();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    get optionsLimit() {
        return this.appConfig.get('content-metadata.selectFilterLimit', CardViewSelectItemComponent.HIDE_FILTER_LIMIT);
    }
}
CardViewSelectItemComponent.HIDE_FILTER_LIMIT = 5;
CardViewSelectItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewSelectItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CardViewSelectItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewSelectItemComponent, selector: "adf-card-view-selectitem", inputs: { editable: "editable", options$: "options$", displayNoneOption: "displayNoneOption", displayEmpty: "displayEmpty" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"!property.isEmpty() || isEditable()\">\n    <div\n        [attr.data-automation-id]=\"'card-select-label-' + property.key\"\n        class=\"adf-property-label\"\n    >{{ property.label | translate }}</div>\n    <div class=\"adf-property-field\">\n        <div\n            *ngIf=\"!isEditable()\"\n            class=\"adf-select-item-padding adf-property-value\"\n            [attr.data-automation-id]=\"'select-readonly-value-' + property.key\"\n            data-automation-class=\"read-only-value\">{{ (property.displayValue | async) | translate }}\n        </div>\n        <div *ngIf=\"isEditable()\">\n            <mat-form-field class=\"adf-select-item-padding-editable adf-property-value\">\n                <mat-select\n                    [(value)]=\"value\"\n                    panelClass=\"adf-select-filter\"\n                    (selectionChange)=\"onChange($event)\"\n                    data-automation-class=\"select-box\"\n                    [aria-label]=\"property.label | translate\"\n                >\n\n                    <adf-select-filter-input *ngIf=\"showInputFilter\" (change)=\"onFilterInputChange($event)\"></adf-select-filter-input>\n\n                    <mat-option *ngIf=\"showNoneOption()\">{{ 'CORE.CARDVIEW.NONE' | translate }}</mat-option>\n                    <mat-option\n                        *ngFor=\"let option of list$ | async\"\n                        [value]=\"option.key\">\n                        {{ option.label | translate }}\n                    </mat-option>\n                </mat-select>\n            </mat-form-field>\n        </div>\n    </div>\n</ng-container>\n", styles: [".mat-form-field-type-mat-select{width:100%}.adf-select-item-padding{padding-top:6px;padding-bottom:20px}.adf-select-item-padding-editable{padding-top:6px;padding-bottom:6px}.adf-select-filter-input{background:var(--adf-theme-background-card-color);position:sticky;top:0;left:0;right:0;z-index:1}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i1$6.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i2$7.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: SelectFilterInputComponent, selector: "adf-select-filter-input", outputs: ["change"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewSelectItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-selectitem', template: "<ng-container *ngIf=\"!property.isEmpty() || isEditable()\">\n    <div\n        [attr.data-automation-id]=\"'card-select-label-' + property.key\"\n        class=\"adf-property-label\"\n    >{{ property.label | translate }}</div>\n    <div class=\"adf-property-field\">\n        <div\n            *ngIf=\"!isEditable()\"\n            class=\"adf-select-item-padding adf-property-value\"\n            [attr.data-automation-id]=\"'select-readonly-value-' + property.key\"\n            data-automation-class=\"read-only-value\">{{ (property.displayValue | async) | translate }}\n        </div>\n        <div *ngIf=\"isEditable()\">\n            <mat-form-field class=\"adf-select-item-padding-editable adf-property-value\">\n                <mat-select\n                    [(value)]=\"value\"\n                    panelClass=\"adf-select-filter\"\n                    (selectionChange)=\"onChange($event)\"\n                    data-automation-class=\"select-box\"\n                    [aria-label]=\"property.label | translate\"\n                >\n\n                    <adf-select-filter-input *ngIf=\"showInputFilter\" (change)=\"onFilterInputChange($event)\"></adf-select-filter-input>\n\n                    <mat-option *ngIf=\"showNoneOption()\">{{ 'CORE.CARDVIEW.NONE' | translate }}</mat-option>\n                    <mat-option\n                        *ngFor=\"let option of list$ | async\"\n                        [value]=\"option.key\">\n                        {{ option.label | translate }}\n                    </mat-option>\n                </mat-select>\n            </mat-form-field>\n        </div>\n    </div>\n</ng-container>\n", styles: [".mat-form-field-type-mat-select{width:100%}.adf-select-item-padding{padding-top:6px;padding-bottom:20px}.adf-select-item-padding-editable{padding-top:6px;padding-bottom:6px}.adf-select-filter-input{background:var(--adf-theme-background-card-color);position:sticky;top:0;left:0;right:0;z-index:1}\n"] }]
        }], propDecorators: { editable: [{
                type: Input
            }], options$: [{
                type: Input
            }], displayNoneOption: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewBoolItemComponent extends BaseCardView {
    isEditable() {
        return this.editable && this.property.editable;
    }
    changed(change) {
        this.cardViewUpdateService.update({ ...this.property }, change.checked);
        this.property.value = change.checked;
    }
}
CardViewBoolItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewBoolItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CardViewBoolItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewBoolItemComponent, selector: "adf-card-view-boolitem", inputs: { editable: "editable" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"!property.isEmpty() || isEditable()\">\n    <div class=\"adf-property-value\">\n        <mat-checkbox [attr.data-automation-id]=\"'card-boolean-' + property.key\"\n                      [attr.title]=\"'CORE.METADATA.ACTIONS.TOGGLE' | translate\"\n                      [checked]=\"property.displayValue\"\n                      [disabled]=\"!isEditable()\"\n                      color=\"primary\"\n                      (change)=\"changed($event)\">\n            <div [attr.data-automation-id]=\"'card-boolean-label-' + property.key\"\n                 class=\"adf-property-label\">{{ property.label | translate }}</div>\n        </mat-checkbox>\n    </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewBoolItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-boolitem', template: "<ng-container *ngIf=\"!property.isEmpty() || isEditable()\">\n    <div class=\"adf-property-value\">\n        <mat-checkbox [attr.data-automation-id]=\"'card-boolean-' + property.key\"\n                      [attr.title]=\"'CORE.METADATA.ACTIONS.TOGGLE' | translate\"\n                      [checked]=\"property.displayValue\"\n                      [disabled]=\"!isEditable()\"\n                      color=\"primary\"\n                      (change)=\"changed($event)\">\n            <div [attr.data-automation-id]=\"'card-boolean-label-' + property.key\"\n                 class=\"adf-property-label\">{{ property.label | translate }}</div>\n        </mat-checkbox>\n    </div>\n</ng-container>\n" }]
        }], propDecorators: { editable: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewKeyValuePairsItemComponent extends BaseCardView {
    constructor() {
        super(...arguments);
        this.editable = false;
    }
    ngOnChanges() {
        this.values = this.property.value || [];
        this.matTableValues = new MatTableDataSource(this.values);
    }
    isEditable() {
        return this.editable && this.property.editable;
    }
    add() {
        this.values.push({ name: '', value: '' });
    }
    remove(index) {
        this.values.splice(index, 1);
        this.save(true);
    }
    onBlur(value) {
        if (value.length) {
            this.save();
        }
    }
    save(remove) {
        const validValues = this.values.filter((i) => i.name.length && i.value.length);
        if (remove || validValues.length) {
            this.cardViewUpdateService.update({ ...this.property }, validValues);
            this.property.value = validValues;
        }
    }
}
CardViewKeyValuePairsItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewKeyValuePairsItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CardViewKeyValuePairsItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewKeyValuePairsItemComponent, selector: "adf-card-view-keyvaluepairsitem", inputs: { editable: "editable" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [attr.data-automation-id]=\"'card-key-value-pairs-label-' + property.key\"\n     class=\"adf-property-label\">{{ property.label | translate }}</div>\n<div class=\"adf-property-field\">\n\n    <div *ngIf=\"!isEditable()\"\n         class=\"adf-card-view__key-value-pairs__read-only adf-property-value\">\n        <mat-table #table\n                   [dataSource]=\"matTableValues\"\n                   class=\"mat-elevation-z8\">\n            <ng-container matColumnDef=\"name\">\n                <mat-header-cell *matHeaderCellDef>{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}\n                </mat-header-cell>\n                <mat-cell *matCellDef=\"let item\">{{item.name}}</mat-cell>\n            </ng-container>\n            <ng-container matColumnDef=\"value\">\n                <mat-header-cell *matHeaderCellDef>{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}\n                </mat-header-cell>\n                <mat-cell *matCellDef=\"let item\">{{item.value}}</mat-cell>\n            </ng-container>\n\n            <mat-header-row *matHeaderRowDef=\"['name', 'value']\"></mat-header-row>\n            <mat-row *matRowDef=\"let row; columns: ['name', 'value'];\"></mat-row>\n        </mat-table>\n    </div>\n\n\n    <div class=\"adf-card-view__key-value-pairs adf-property-value\"\n         *ngIf=\"isEditable() && values && values.length\">\n        <div class=\"adf-card-view__key-value-pairs__row\">\n            <div class=\"adf-card-view__key-value-pairs__col\">{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}</div>\n            <div class=\"adf-card-view__key-value-pairs__col\">{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}</div>\n        </div>\n\n        <div class=\"adf-card-view__key-value-pairs__row\"\n             *ngFor=\"let item of values; let i = index\">\n            <div class=\"adf-card-view__key-value-pairs__col\">\n                <mat-form-field>\n                    <input matInput\n                           placeholder=\"{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}\"\n                           (blur)=\"onBlur(item.value)\"\n                           [attr.data-automation-id]=\"'card-'+ property.key +'-name-input-' + i\"\n                           [(ngModel)]=\"values[i].name\">\n                </mat-form-field>\n            </div>\n            <div class=\"adf-card-view__key-value-pairs__col\">\n                <mat-form-field>\n                    <input matInput\n                           placeholder=\"{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}\"\n                           (blur)=\"onBlur(item.value)\"\n                           [attr.data-automation-id]=\"'card-'+ property.key +'-value-input-' + i\"\n                           [(ngModel)]=\"values[i].value\">\n                    <button matSuffix\n                            mat-icon-button\n                            (click)=\"remove(i)\"\n                            class=\"adf-card-view__key-value-pairs__remove-btn\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </mat-form-field>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"isEditable()\"\n         class=\"adf-property-value adf-card-view__key-value-pairs__add-btn-container\">\n        <button (click)=\"add()\"\n                mat-button\n                class=\"adf-card-view__key-value-pairs__add-btn\"\n                [attr.data-automation-id]=\"'card-key-value-pairs-button-' + property.key\">\n            {{ 'CORE.CARDVIEW.KEYVALUEPAIRS.ADD' | translate }}\n            <mat-icon>add</mat-icon>\n        </button>\n    </div>\n</div>\n", styles: [".adf-card-view__key-value-pairs__row{display:flex;justify-content:center}.adf-card-view__key-value-pairs__col{width:50%}.adf-card-view__key-value-pairs__col .mat-form-field{width:100%;font-size:var(--theme-body-1-font-size)}.adf-card-view__key-value-pairs__col .mat-form-field-appearance-legacy .mat-form-field-label{color:var(--adf-theme-foreground-text-color-040)!important}.adf-card-view__key-value-pairs__add-btn-container{display:flex;justify-content:center}.adf-card-view__key-value-pairs__add-btn.mat-button{margin-bottom:20px}.adf-card-view__key-value-pairs__read-only{padding-bottom:20px}.adf-card-view__key-value-pairs__read-only .mat-table{box-shadow:none}.adf-card-view__key-value-pairs__read-only .mat-header-row,.adf-card-view__key-value-pairs__read-only .mat-row{padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewKeyValuePairsItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-keyvaluepairsitem', encapsulation: ViewEncapsulation.None, template: "<div [attr.data-automation-id]=\"'card-key-value-pairs-label-' + property.key\"\n     class=\"adf-property-label\">{{ property.label | translate }}</div>\n<div class=\"adf-property-field\">\n\n    <div *ngIf=\"!isEditable()\"\n         class=\"adf-card-view__key-value-pairs__read-only adf-property-value\">\n        <mat-table #table\n                   [dataSource]=\"matTableValues\"\n                   class=\"mat-elevation-z8\">\n            <ng-container matColumnDef=\"name\">\n                <mat-header-cell *matHeaderCellDef>{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}\n                </mat-header-cell>\n                <mat-cell *matCellDef=\"let item\">{{item.name}}</mat-cell>\n            </ng-container>\n            <ng-container matColumnDef=\"value\">\n                <mat-header-cell *matHeaderCellDef>{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}\n                </mat-header-cell>\n                <mat-cell *matCellDef=\"let item\">{{item.value}}</mat-cell>\n            </ng-container>\n\n            <mat-header-row *matHeaderRowDef=\"['name', 'value']\"></mat-header-row>\n            <mat-row *matRowDef=\"let row; columns: ['name', 'value'];\"></mat-row>\n        </mat-table>\n    </div>\n\n\n    <div class=\"adf-card-view__key-value-pairs adf-property-value\"\n         *ngIf=\"isEditable() && values && values.length\">\n        <div class=\"adf-card-view__key-value-pairs__row\">\n            <div class=\"adf-card-view__key-value-pairs__col\">{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}</div>\n            <div class=\"adf-card-view__key-value-pairs__col\">{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}</div>\n        </div>\n\n        <div class=\"adf-card-view__key-value-pairs__row\"\n             *ngFor=\"let item of values; let i = index\">\n            <div class=\"adf-card-view__key-value-pairs__col\">\n                <mat-form-field>\n                    <input matInput\n                           placeholder=\"{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.NAME' | translate }}\"\n                           (blur)=\"onBlur(item.value)\"\n                           [attr.data-automation-id]=\"'card-'+ property.key +'-name-input-' + i\"\n                           [(ngModel)]=\"values[i].name\">\n                </mat-form-field>\n            </div>\n            <div class=\"adf-card-view__key-value-pairs__col\">\n                <mat-form-field>\n                    <input matInput\n                           placeholder=\"{{ 'CORE.CARDVIEW.KEYVALUEPAIRS.VALUE' | translate }}\"\n                           (blur)=\"onBlur(item.value)\"\n                           [attr.data-automation-id]=\"'card-'+ property.key +'-value-input-' + i\"\n                           [(ngModel)]=\"values[i].value\">\n                    <button matSuffix\n                            mat-icon-button\n                            (click)=\"remove(i)\"\n                            class=\"adf-card-view__key-value-pairs__remove-btn\">\n                        <mat-icon>close</mat-icon>\n                    </button>\n                </mat-form-field>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"isEditable()\"\n         class=\"adf-property-value adf-card-view__key-value-pairs__add-btn-container\">\n        <button (click)=\"add()\"\n                mat-button\n                class=\"adf-card-view__key-value-pairs__add-btn\"\n                [attr.data-automation-id]=\"'card-key-value-pairs-button-' + property.key\">\n            {{ 'CORE.CARDVIEW.KEYVALUEPAIRS.ADD' | translate }}\n            <mat-icon>add</mat-icon>\n        </button>\n    </div>\n</div>\n", styles: [".adf-card-view__key-value-pairs__row{display:flex;justify-content:center}.adf-card-view__key-value-pairs__col{width:50%}.adf-card-view__key-value-pairs__col .mat-form-field{width:100%;font-size:var(--theme-body-1-font-size)}.adf-card-view__key-value-pairs__col .mat-form-field-appearance-legacy .mat-form-field-label{color:var(--adf-theme-foreground-text-color-040)!important}.adf-card-view__key-value-pairs__add-btn-container{display:flex;justify-content:center}.adf-card-view__key-value-pairs__add-btn.mat-button{margin-bottom:20px}.adf-card-view__key-value-pairs__read-only{padding-bottom:20px}.adf-card-view__key-value-pairs__read-only .mat-table{box-shadow:none}.adf-card-view__key-value-pairs__read-only .mat-header-row,.adf-card-view__key-value-pairs__read-only .mat-row{padding:0}\n"] }]
        }], propDecorators: { editable: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getType = (type) => () => type;
class DynamicComponentResolver {
    static fromType(type) {
        return getType(type);
    }
}
class DynamicComponentMapper {
    constructor() {
        this.defaultValue = undefined;
        this.types = {};
    }
    /**
     * Gets the currently active DynamicComponentResolveFunction for a field type.
     *
     * @param type The type whose resolver you want
     * @param defaultValue Default type returned for types that are not yet mapped
     * @returns Resolver function
     */
    getComponentTypeResolver(type, defaultValue = this.defaultValue) {
        if (type) {
            return this.types[type] || DynamicComponentResolver.fromType(defaultValue);
        }
        return DynamicComponentResolver.fromType(defaultValue);
    }
    /**
     * Sets or optionally replaces a DynamicComponentResolveFunction for a field type.
     *
     * @param type The type whose resolver you want to set
     * @param resolver The new resolver function
     * @param override The new resolver will only replace an existing one if this parameter is true
     */
    setComponentTypeResolver(type, resolver, override = true) {
        if (!type) {
            throw new Error(`type is null or not defined`);
        }
        if (!resolver) {
            throw new Error(`resolver is null or not defined`);
        }
        const existing = this.types[type];
        if (existing && !override) {
            throw new Error(`already mapped, use override option if you intend replacing existing mapping.`);
        }
        this.types[type] = resolver;
    }
    /**
     * Register multiple components
     */
    register(components, override = false) {
        if (components) {
            for (const type of Object.keys(components)) {
                this.setComponentTypeResolver(type, components[type], override);
            }
        }
    }
    /**
     * Finds the component type that is needed to render a form field.
     *
     * @param model Form field model for the field to render
     * @param defaultValue Default type returned for field types that are not yet mapped.
     * @returns Component type
     */
    resolveComponentType(model, defaultValue = this.defaultValue) {
        if (model) {
            const resolver = this.getComponentTypeResolver(model.type, defaultValue);
            return resolver(model);
        }
        return defaultValue;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewArrayItemComponent extends BaseCardView {
    clicked() {
        if (this.isClickable()) {
            this.cardViewUpdateService.clicked(this.property);
        }
    }
    showClickableIcon() {
        return this.hasIcon() && this.isClickable();
    }
    hasIcon() {
        return !!this.property.icon;
    }
    displayCount() {
        return this.property.noOfItemsToDisplay ? this.property.noOfItemsToDisplay : 0;
    }
    isClickable() {
        return !!this.property.clickable;
    }
}
CardViewArrayItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewArrayItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CardViewArrayItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewArrayItemComponent, selector: "adf-card-view-arrayitem", usesInheritance: true, ngImport: i0, template: "<div [attr.data-automation-id]=\"'card-array-label-' + property.key\" class=\"adf-property-label\">{{ property.label | translate }}</div>\n<div class=\"adf-property-value adf-card-view-array-item-container\">\n    <ng-container *ngIf=\"(property.displayValue | async) as items; else elseEmptyValueBlock\">\n        <mat-chip-list *ngIf=\"items.length > 0; else elseEmptyValueBlock\" data-automation-id=\"card-arrayitem-chip-list-container\">\n            <ng-container *ngIf=\"displayCount() > 0; else withOutDisplayCount\" >\n                <mat-chip\n                    *ngFor=\"let item of items.slice(0, displayCount())\"\n                    (click)=\"clicked()\"\n                    [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                    <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                    <span>{{item?.value}}</span>\n                </mat-chip>\n                <mat-chip\n                    *ngIf=\"items.length > displayCount()\"\n                    data-automation-id=\"card-arrayitem-more-chip\"\n                    [matMenuTriggerFor]=\"menu\">\n                    <span>{{items.length - displayCount()}} {{'CORE.CARDVIEW.MORE' | translate}}</span>\n                </mat-chip>\n            </ng-container>\n            <ng-template #withOutDisplayCount>\n                <mat-chip\n                    *ngFor=\"let item of items\"\n                    (click)=\"clicked()\"\n                    [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                    <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                    <span>{{item?.value}}</span>\n                </mat-chip>\n            </ng-template>\n        </mat-chip-list>\n        <mat-menu #menu=\"matMenu\">\n            <mat-card class=\"adf-array-item-more-chip-container\">\n                <mat-card-content>\n                    <mat-chip-list>\n                        <mat-chip (click)=\"clicked()\"\n                            *ngFor=\"let item of items.slice(displayCount(), items.length)\"\n                            [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                        <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                        <span>{{item?.value}}</span>\n                        </mat-chip>\n                    </mat-chip-list>\n                </mat-card-content>\n            </mat-card>\n        </mat-menu>\n    </ng-container>\n    <ng-template #elseEmptyValueBlock>\n        <span class=\"adf-card-array-item-default\" data-automation-id=\"card-arrayitem-default\">{{ property?.default | translate }}</span>\n    </ng-template>\n    <button mat-icon-button *ngIf=\"showClickableIcon()\"\n        (click)=\"clicked()\"\n        class=\"adf-array-item-action\"\n        [attr.aria-label]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n        [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n        [attr.data-automation-id]=\"'card-array-item-clickable-icon-' + property.key\">\n        <mat-icon class=\"adf-array-item-icon\">{{property.icon}}</mat-icon>\n    </button>\n</div>\n", styles: [".adf-array-item-icon{font-size:var(--theme-subheading-2-font-size);padding-top:8px}.adf-array-item-action{color:var(--adf-theme-foreground-text-color-025)}.adf-array-item-action:hover,.adf-array-item-action:focus{color:var(--adf-theme-foreground-text-color)}.adf-card-array-item-default{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.adf-array-item-more-chip-container.mat-card{box-shadow:none;max-height:300px;overflow-y:auto}.adf-property-value .mat-chip-list{padding-top:6px}.adf-card-view-array-item-container{flex-direction:row;box-sizing:border-box;display:flex;place-content:center space-between;align-items:center}.adf-card-view-array-item-container .mat-chip:hover{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i10$1.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i10$1.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i10.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i10.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewArrayItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view-arrayitem', encapsulation: ViewEncapsulation.None, template: "<div [attr.data-automation-id]=\"'card-array-label-' + property.key\" class=\"adf-property-label\">{{ property.label | translate }}</div>\n<div class=\"adf-property-value adf-card-view-array-item-container\">\n    <ng-container *ngIf=\"(property.displayValue | async) as items; else elseEmptyValueBlock\">\n        <mat-chip-list *ngIf=\"items.length > 0; else elseEmptyValueBlock\" data-automation-id=\"card-arrayitem-chip-list-container\">\n            <ng-container *ngIf=\"displayCount() > 0; else withOutDisplayCount\" >\n                <mat-chip\n                    *ngFor=\"let item of items.slice(0, displayCount())\"\n                    (click)=\"clicked()\"\n                    [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                    <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                    <span>{{item?.value}}</span>\n                </mat-chip>\n                <mat-chip\n                    *ngIf=\"items.length > displayCount()\"\n                    data-automation-id=\"card-arrayitem-more-chip\"\n                    [matMenuTriggerFor]=\"menu\">\n                    <span>{{items.length - displayCount()}} {{'CORE.CARDVIEW.MORE' | translate}}</span>\n                </mat-chip>\n            </ng-container>\n            <ng-template #withOutDisplayCount>\n                <mat-chip\n                    *ngFor=\"let item of items\"\n                    (click)=\"clicked()\"\n                    [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                    <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                    <span>{{item?.value}}</span>\n                </mat-chip>\n            </ng-template>\n        </mat-chip-list>\n        <mat-menu #menu=\"matMenu\">\n            <mat-card class=\"adf-array-item-more-chip-container\">\n                <mat-card-content>\n                    <mat-chip-list>\n                        <mat-chip (click)=\"clicked()\"\n                            *ngFor=\"let item of items.slice(displayCount(), items.length)\"\n                            [attr.data-automation-id]=\"'card-arrayitem-chip-' + item.value\">\n                        <mat-icon *ngIf=\"item?.icon\" class=\"adf-array-item-icon\">{{item.icon}}</mat-icon>\n                        <span>{{item?.value}}</span>\n                        </mat-chip>\n                    </mat-chip-list>\n                </mat-card-content>\n            </mat-card>\n        </mat-menu>\n    </ng-container>\n    <ng-template #elseEmptyValueBlock>\n        <span class=\"adf-card-array-item-default\" data-automation-id=\"card-arrayitem-default\">{{ property?.default | translate }}</span>\n    </ng-template>\n    <button mat-icon-button *ngIf=\"showClickableIcon()\"\n        (click)=\"clicked()\"\n        class=\"adf-array-item-action\"\n        [attr.aria-label]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n        [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n        [attr.data-automation-id]=\"'card-array-item-clickable-icon-' + property.key\">\n        <mat-icon class=\"adf-array-item-icon\">{{property.icon}}</mat-icon>\n    </button>\n</div>\n", styles: [".adf-array-item-icon{font-size:var(--theme-subheading-2-font-size);padding-top:8px}.adf-array-item-action{color:var(--adf-theme-foreground-text-color-025)}.adf-array-item-action:hover,.adf-array-item-action:focus{color:var(--adf-theme-foreground-text-color)}.adf-card-array-item-default{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.adf-array-item-more-chip-container.mat-card{box-shadow:none;max-height:300px;overflow-y:auto}.adf-property-value .mat-chip-list{padding-top:6px}.adf-card-view-array-item-container{flex-direction:row;box-sizing:border-box;display:flex;place-content:center space-between;align-items:center}.adf-card-view-array-item-container .mat-chip:hover{cursor:pointer}\n"] }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardItemTypeService extends DynamicComponentMapper {
    constructor() {
        super(...arguments);
        this.defaultValue = CardViewTextItemComponent;
        this.types = {
            text: DynamicComponentResolver.fromType(CardViewTextItemComponent),
            select: DynamicComponentResolver.fromType(CardViewSelectItemComponent),
            int: DynamicComponentResolver.fromType(CardViewTextItemComponent),
            float: DynamicComponentResolver.fromType(CardViewTextItemComponent),
            date: DynamicComponentResolver.fromType(CardViewDateItemComponent),
            datetime: DynamicComponentResolver.fromType(CardViewDateItemComponent),
            bool: DynamicComponentResolver.fromType(CardViewBoolItemComponent),
            map: DynamicComponentResolver.fromType(CardViewMapItemComponent),
            keyvaluepairs: DynamicComponentResolver.fromType(CardViewKeyValuePairsItemComponent),
            array: DynamicComponentResolver.fromType(CardViewArrayItemComponent)
        };
    }
}
CardItemTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardItemTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CardItemTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardItemTypeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardItemTypeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewContentProxyDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
CardViewContentProxyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewContentProxyDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
CardViewContentProxyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: CardViewContentProxyDirective, selector: "[adf-card-view-content-proxy]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewContentProxyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-card-view-content-proxy]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemDispatcherComponent {
    constructor(cardItemTypeService) {
        this.cardItemTypeService = cardItemTypeService;
        this.displayEmpty = true;
        this.displayNoneOption = true;
        this.displayClearAction = true;
        this.copyToClipboardAction = true;
        this.useChipsForMultiValueProperty = true;
        this.multiValueSeparator = DEFAULT_SEPARATOR;
        this.loaded = false;
        this.componentReference = null;
        const dynamicLifeCycleMethods = [
            'ngOnInit',
            'ngDoCheck',
            'ngAfterContentInit',
            'ngAfterContentChecked',
            'ngAfterViewInit',
            'ngAfterViewChecked',
            'ngOnDestroy'
        ];
        dynamicLifeCycleMethods.forEach((method) => {
            this[method] = this.proxy.bind(this, method);
        });
    }
    ngOnChanges(changes) {
        if (!this.loaded) {
            this.loadComponent();
            this.loaded = true;
        }
        Object.keys(changes)
            .map((changeName) => [changeName, changes[changeName]])
            .forEach(([inputParamName, simpleChange]) => {
            this.componentReference.instance[inputParamName] = simpleChange.currentValue;
        });
        this.proxy('ngOnChanges', changes);
    }
    loadComponent() {
        const factoryClass = this.cardItemTypeService.resolveComponentType(this.property);
        this.componentReference = this.content.viewContainerRef.createComponent(factoryClass);
        this.componentReference.instance.editable = this.editable;
        this.componentReference.instance.property = this.property;
        this.componentReference.instance.displayEmpty = this.displayEmpty;
        this.componentReference.instance.displayNoneOption = this.displayNoneOption;
        this.componentReference.instance.displayClearAction = this.displayClearAction;
        this.componentReference.instance.copyToClipboardAction = this.copyToClipboardAction;
        this.componentReference.instance.useChipsForMultiValueProperty = this.useChipsForMultiValueProperty;
        this.componentReference.instance.multiValueSeparator = this.multiValueSeparator;
    }
    proxy(methodName, ...args) {
        if (this.componentReference.instance[methodName]) {
            this.componentReference.instance[methodName].apply(this.componentReference.instance, args);
        }
    }
}
CardViewItemDispatcherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewItemDispatcherComponent, deps: [{ token: CardItemTypeService }], target: i0.ɵɵFactoryTarget.Component });
CardViewItemDispatcherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewItemDispatcherComponent, selector: "adf-card-view-item-dispatcher", inputs: { property: "property", editable: "editable", displayEmpty: "displayEmpty", displayNoneOption: "displayNoneOption", displayClearAction: "displayClearAction", copyToClipboardAction: "copyToClipboardAction", useChipsForMultiValueProperty: "useChipsForMultiValueProperty", multiValueSeparator: "multiValueSeparator" }, viewQueries: [{ propertyName: "content", first: true, predicate: CardViewContentProxyDirective, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: '<ng-template adf-card-view-content-proxy></ng-template>', isInline: true, dependencies: [{ kind: "directive", type: CardViewContentProxyDirective, selector: "[adf-card-view-content-proxy]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewItemDispatcherComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-card-view-item-dispatcher',
                    template: '<ng-template adf-card-view-content-proxy></ng-template>'
                }]
        }], ctorParameters: function () { return [{ type: CardItemTypeService }]; }, propDecorators: { property: [{
                type: Input
            }], editable: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], displayNoneOption: [{
                type: Input
            }], displayClearAction: [{
                type: Input
            }], copyToClipboardAction: [{
                type: Input
            }], useChipsForMultiValueProperty: [{
                type: Input
            }], multiValueSeparator: [{
                type: Input
            }], content: [{
                type: ViewChild,
                args: [CardViewContentProxyDirective, { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewComponent {
    constructor() {
        /** Toggles whether or not to show empty items in non-editable mode. */
        this.displayEmpty = true;
        /** Toggles whether or not to display none option. */
        this.displayNoneOption = true;
        /** Toggles whether or not to display clear action. */
        this.displayClearAction = true;
        /** Toggles whether or not to enable copy to clipboard action. */
        this.copyToClipboardAction = true;
        /** Toggles whether or not to enable chips for multivalued properties. */
        this.useChipsForMultiValueProperty = true;
        /** String separator between multi-value property items. */
        this.multiValueSeparator = DEFAULT_SEPARATOR;
    }
}
CardViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CardViewComponent, selector: "adf-card-view", inputs: { properties: "properties", editable: "editable", displayEmpty: "displayEmpty", displayNoneOption: "displayNoneOption", displayClearAction: "displayClearAction", copyToClipboardAction: "copyToClipboardAction", useChipsForMultiValueProperty: "useChipsForMultiValueProperty", multiValueSeparator: "multiValueSeparator" }, ngImport: i0, template: "<div class=\"adf-property-list\">\n    <div *ngFor=\"let property of properties\">\n        <div [attr.data-automation-id]=\"'header-'+property.key\" class=\"adf-property\">\n            <adf-card-view-item-dispatcher\n                [property]=\"property\"\n                [editable]=\"editable\"\n                [displayEmpty]=\"displayEmpty\"\n                [displayNoneOption]=\"property['displayNoneOption'] !== undefined ? property['displayNoneOption'] : displayNoneOption\"\n                [displayClearAction]=\"displayClearAction\"\n                [copyToClipboardAction]=\"copyToClipboardAction\"\n                [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                [multiValueSeparator]=\"multiValueSeparator\">\n            </adf-card-view-item-dispatcher>\n        </div>\n    </div>\n</div>\n", styles: [".adf-property-list{background:var(--adf-card-view-background);border:var(--adf-card-view-border);border-color:var(--adf-card-view-border-color);border-radius:var(--adf-card-view-border-radius)}.adf-property-list .adf-property{margin-bottom:20px}.adf-property-list .adf-property .adf-property-value-padding-top{margin-top:6px}.adf-property-list .adf-property .adf-property-field{width:100%;margin-bottom:-25px}.adf-property-list .adf-property .adf-property-field .mat-form-field-infix{border-top-width:0}.adf-property-list .adf-property .adf-property-field .mat-form-field-label{margin-top:6px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: CardViewItemDispatcherComponent, selector: "adf-card-view-item-dispatcher", inputs: ["property", "editable", "displayEmpty", "displayNoneOption", "displayClearAction", "copyToClipboardAction", "useChipsForMultiValueProperty", "multiValueSeparator"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-card-view', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-property-list\">\n    <div *ngFor=\"let property of properties\">\n        <div [attr.data-automation-id]=\"'header-'+property.key\" class=\"adf-property\">\n            <adf-card-view-item-dispatcher\n                [property]=\"property\"\n                [editable]=\"editable\"\n                [displayEmpty]=\"displayEmpty\"\n                [displayNoneOption]=\"property['displayNoneOption'] !== undefined ? property['displayNoneOption'] : displayNoneOption\"\n                [displayClearAction]=\"displayClearAction\"\n                [copyToClipboardAction]=\"copyToClipboardAction\"\n                [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                [multiValueSeparator]=\"multiValueSeparator\">\n            </adf-card-view-item-dispatcher>\n        </div>\n    </div>\n</div>\n", styles: [".adf-property-list{background:var(--adf-card-view-background);border:var(--adf-card-view-border);border-color:var(--adf-card-view-border-color);border-radius:var(--adf-card-view-border-radius)}.adf-property-list .adf-property{margin-bottom:20px}.adf-property-list .adf-property .adf-property-value-padding-top{margin-top:6px}.adf-property-list .adf-property .adf-property-field{width:100%;margin-bottom:-25px}.adf-property-list .adf-property .adf-property-field .mat-form-field-infix{border-top-width:0}.adf-property-list .adf-property .adf-property-field .mat-form-field-label{margin-top:6px}\n"] }]
        }], propDecorators: { properties: [{
                type: Input
            }], editable: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], displayNoneOption: [{
                type: Input
            }], displayClearAction: [{
                type: Input
            }], copyToClipboardAction: [{
                type: Input
            }], useChipsForMultiValueProperty: [{
                type: Input
            }], multiValueSeparator: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewItemFloatValidator {
    constructor() {
        this.message = 'CORE.CARDVIEW.VALIDATORS.FLOAT_VALIDATION_ERROR';
    }
    isValid(value) {
        if (Array.isArray(value)) {
            return value.every(this.isDecimalNumber);
        }
        return value === '' || this.isDecimalNumber(value);
    }
    isDecimalNumber(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewBoolItemModel extends CardViewBaseItemModel {
    constructor(cardViewBoolItemProperties) {
        super(cardViewBoolItemProperties);
        this.type = 'bool';
        this.value = false;
        if (cardViewBoolItemProperties.value !== undefined) {
            this.value = !!JSON.parse(cardViewBoolItemProperties.value);
        }
    }
    get displayValue() {
        if (this.isEmpty()) {
            return this.default;
        }
        else {
            return this.value;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewDatetimeItemModel extends CardViewDateItemModel {
    constructor(cardViewDateItemProperties) {
        super(cardViewDateItemProperties);
        this.type = 'datetime';
        this.format = 'MMM d, y, H:mm';
        if (cardViewDateItemProperties.format) {
            this.format = cardViewDateItemProperties.format;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewTextItemModel extends CardViewBaseItemModel {
    constructor(cardViewTextItemProperties) {
        super(cardViewTextItemProperties);
        this.type = 'text';
        this.inputType = 'text';
        this.multiline = !!cardViewTextItemProperties.multiline;
        this.pipes = cardViewTextItemProperties.pipes || [];
        this.clickCallBack = cardViewTextItemProperties.clickCallBack ? cardViewTextItemProperties.clickCallBack : null;
        if (this.default && this.isEmpty()) {
            this.value = this.default;
        }
    }
    get displayValue() {
        return this.applyPipes(this.value);
    }
    applyPipes(displayValue) {
        if (this.pipes.length) {
            displayValue = this.pipes.reduce((accumulator, { pipe, params = [] }) => pipe.transform(accumulator, ...params), displayValue);
        }
        return displayValue;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewFloatItemModel extends CardViewTextItemModel {
    constructor(cardViewTextItemProperties) {
        super(cardViewTextItemProperties);
        this.type = 'float';
        this.inputType = 'number';
        this.validators.push(new CardViewItemFloatValidator());
        if (cardViewTextItemProperties.value && !cardViewTextItemProperties.multivalued) {
            this.value = parseFloat(cardViewTextItemProperties.value);
        }
    }
    get displayValue() {
        return this.applyPipes(this.value);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewIntItemModel extends CardViewTextItemModel {
    constructor(cardViewTextItemProperties) {
        super(cardViewTextItemProperties);
        this.type = 'int';
        this.inputType = 'number';
        this.validators.push(new CardViewItemIntValidator());
        if (cardViewTextItemProperties.value && !cardViewTextItemProperties.multivalued) {
            this.value = parseInt(cardViewTextItemProperties.value, 10);
        }
    }
    get displayValue() {
        return this.applyPipes(this.value);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewKeyValuePairsItemModel extends CardViewBaseItemModel {
    constructor(cardViewKeyValuePairsItemProperties) {
        super(cardViewKeyValuePairsItemProperties);
        this.type = 'keyvaluepairs';
    }
    get displayValue() {
        return this.value;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewSelectItemModel extends CardViewBaseItemModel {
    constructor(cardViewSelectItemProperties) {
        super(cardViewSelectItemProperties);
        this.type = 'select';
        this.valueFetch$ = null;
        this.displayNoneOption = cardViewSelectItemProperties.displayNoneOption !== undefined ? cardViewSelectItemProperties.displayNoneOption : true;
        this.options$ = cardViewSelectItemProperties.options$;
        this.valueFetch$ = this.options$.pipe(switchMap((options) => {
            const option = options.find((o) => o.key === this.value?.toString());
            return of(option ? option.label : '');
        }));
    }
    get displayValue() {
        return this.valueFetch$;
    }
    setValue(value) {
        this.value = value;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewArrayItemModel extends CardViewBaseItemModel {
    constructor(cardViewArrayItemProperties) {
        super(cardViewArrayItemProperties);
        this.type = 'array';
        this.noOfItemsToDisplay = cardViewArrayItemProperties.noOfItemsToDisplay;
    }
    get displayValue() {
        return this.value;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewModule {
}
CardViewModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CardViewModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CardViewModule, declarations: [CardViewComponent,
        CardViewBoolItemComponent,
        CardViewDateItemComponent,
        CardViewMapItemComponent,
        CardViewTextItemComponent,
        CardViewKeyValuePairsItemComponent,
        CardViewSelectItemComponent,
        CardViewItemDispatcherComponent,
        CardViewContentProxyDirective,
        CardViewArrayItemComponent,
        SelectFilterInputComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        MatIconModule,
        MatSelectModule,
        MatButtonModule,
        MatChipsModule,
        MatMenuModule,
        MatCardModule,
        MatDatetimepickerModule,
        MatNativeDatetimeModule,
        MatSlideToggleModule,
        MatTooltipModule], exports: [CardViewComponent,
        CardViewBoolItemComponent,
        CardViewDateItemComponent,
        CardViewMapItemComponent,
        CardViewTextItemComponent,
        CardViewSelectItemComponent,
        CardViewKeyValuePairsItemComponent,
        CardViewArrayItemComponent,
        SelectFilterInputComponent] });
CardViewModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewModule, imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        MatIconModule,
        MatSelectModule,
        MatButtonModule,
        MatChipsModule,
        MatMenuModule,
        MatCardModule,
        MatDatetimepickerModule,
        MatNativeDatetimeModule,
        MatSlideToggleModule,
        MatTooltipModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        MatCheckboxModule,
                        MatInputModule,
                        MatTableModule,
                        MatIconModule,
                        MatSelectModule,
                        MatButtonModule,
                        MatChipsModule,
                        MatMenuModule,
                        MatCardModule,
                        MatDatetimepickerModule,
                        MatNativeDatetimeModule,
                        MatSlideToggleModule,
                        MatTooltipModule
                    ],
                    declarations: [
                        CardViewComponent,
                        CardViewBoolItemComponent,
                        CardViewDateItemComponent,
                        CardViewMapItemComponent,
                        CardViewTextItemComponent,
                        CardViewKeyValuePairsItemComponent,
                        CardViewSelectItemComponent,
                        CardViewItemDispatcherComponent,
                        CardViewContentProxyDirective,
                        CardViewArrayItemComponent,
                        SelectFilterInputComponent
                    ],
                    exports: [
                        CardViewComponent,
                        CardViewBoolItemComponent,
                        CardViewDateItemComponent,
                        CardViewMapItemComponent,
                        CardViewTextItemComponent,
                        CardViewSelectItemComponent,
                        CardViewKeyValuePairsItemComponent,
                        CardViewArrayItemComponent,
                        SelectFilterInputComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormEvent {
    constructor(form) {
        this.isDefaultPrevented = false;
        this.form = form;
    }
    get defaultPrevented() {
        return this.isDefaultPrevented;
    }
    preventDefault() {
        this.isDefaultPrevented = true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormFieldEvent extends FormEvent {
    constructor(form, field) {
        super(form);
        this.field = field;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ValidateFormFieldEvent extends FormFieldEvent {
    constructor(form, field) {
        super(form, field);
        this.isValid = true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ValidateFormEvent extends FormEvent {
    constructor(form) {
        super(form);
        this.isValid = true;
        this.errorsField = [];
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class FormWidgetModel {
    constructor(form, json) {
        this.form = form;
        this.json = json;
        if (json) {
            this.fieldType = json.fieldType;
            this.id = json.id;
            this.name = json.name;
            this.type = json.type;
            this.tab = json.tab;
            this.field = json.field;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class FormFieldTypes {
    static isReadOnlyType(type) {
        return FormFieldTypes.READONLY_TYPES.includes(type);
    }
    static isContainerType(type) {
        return type === FormFieldTypes.CONTAINER || type === FormFieldTypes.GROUP;
    }
}
FormFieldTypes.CONTAINER = 'container';
FormFieldTypes.GROUP = 'group';
FormFieldTypes.DYNAMIC_TABLE = 'dynamic-table';
FormFieldTypes.TEXT = 'text';
FormFieldTypes.STRING = 'string';
FormFieldTypes.INTEGER = 'integer';
FormFieldTypes.MULTILINE_TEXT = 'multi-line-text';
FormFieldTypes.DROPDOWN = 'dropdown';
FormFieldTypes.HYPERLINK = 'hyperlink';
FormFieldTypes.RADIO_BUTTONS = 'radio-buttons';
FormFieldTypes.DISPLAY_VALUE = 'readonly';
FormFieldTypes.READONLY_TEXT = 'readonly-text';
FormFieldTypes.UPLOAD = 'upload';
FormFieldTypes.TYPEAHEAD = 'typeahead';
FormFieldTypes.FUNCTIONAL_GROUP = 'functional-group';
FormFieldTypes.PEOPLE = 'people';
FormFieldTypes.BOOLEAN = 'boolean';
FormFieldTypes.NUMBER = 'integer';
FormFieldTypes.DATE = 'date';
FormFieldTypes.AMOUNT = 'amount';
FormFieldTypes.DOCUMENT = 'document';
FormFieldTypes.DATETIME = 'datetime';
FormFieldTypes.ATTACH_FOLDER = 'select-folder';
FormFieldTypes.PROPERTIES_VIEWER = 'properties-viewer';
FormFieldTypes.ALFRESCO_FILE_VIEWER = 'file-viewer';
FormFieldTypes.VIEWER = 'base-viewer';
FormFieldTypes.DISPLAY_RICH_TEXT = 'display-rich-text';
FormFieldTypes.JSON = 'json';
FormFieldTypes.READONLY_TYPES = [
    FormFieldTypes.HYPERLINK,
    FormFieldTypes.DISPLAY_VALUE,
    FormFieldTypes.READONLY_TEXT,
    FormFieldTypes.GROUP
];

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContainerModel extends FormWidgetModel {
    constructor(field) {
        super(field.form, field.json);
        this.columns = [];
        this.isExpanded = true;
        this.rowspan = 1;
        this.colspan = 1;
        if (field) {
            this.field = field;
            this.columns = field.columns || [];
            this.isExpanded = !this.isCollapsedByDefault();
            this.colspan = field.colspan;
            this.rowspan = field.rowspan;
        }
    }
    get isVisible() {
        return this.field.isVisible;
    }
    isGroup() {
        return this.type === FormFieldTypes.GROUP;
    }
    isCollapsible() {
        let allowCollapse = false;
        if (this.isGroup() && this.field.params['allowCollapse']) {
            allowCollapse = this.field.params['allowCollapse'];
        }
        return allowCollapse;
    }
    isCollapsedByDefault() {
        let collapseByDefault = false;
        if (this.isCollapsible() && this.field.params['collapseByDefault']) {
            collapseByDefault = this.field.params['collapseByDefault'];
        }
        return collapseByDefault;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class WidgetVisibilityModel {
    constructor(json) {
        this.json = json;
        if (json) {
            this.operator = json.operator;
            this.nextCondition = new WidgetVisibilityModel(json.nextCondition);
            this.nextConditionOperator = json.nextConditionOperator;
            this.rightRestResponseId = json.rightRestResponseId;
            this.rightFormFieldId = json.rightFormFieldId;
            this.leftFormFieldId = json.leftFormFieldId;
            this.leftRestResponseId = json.leftRestResponseId;
        }
        else {
            this.json = {};
        }
    }
    get leftType() {
        if (this.leftFormFieldId) {
            return WidgetTypeEnum.field;
        }
        else if (this.leftRestResponseId) {
            return WidgetTypeEnum.variable;
        }
        else if (!!this.json.leftType) {
            return this.json.leftType;
        }
        return null;
    }
    set leftType(leftType) {
        this.json.leftType = leftType;
    }
    get leftValue() {
        if (this.json.leftValue) {
            return this.json.leftValue;
        }
        else if (this.leftFormFieldId) {
            return this.leftFormFieldId;
        }
        else {
            return this.leftRestResponseId;
        }
    }
    set leftValue(leftValue) {
        this.json.leftValue = leftValue;
    }
    get rightType() {
        if (!!this.json.rightType) {
            return this.json.rightType;
        }
        else if (this.json.rightValue) {
            return WidgetTypeEnum.value;
        }
        else if (this.rightRestResponseId) {
            return WidgetTypeEnum.variable;
        }
        else if (this.rightFormFieldId) {
            return WidgetTypeEnum.field;
        }
        return null;
    }
    set rightType(rightType) {
        this.json.rightType = rightType;
    }
    get rightValue() {
        if (this.json.rightValue) {
            return this.json.rightValue;
        }
        else if (this.rightFormFieldId) {
            return this.rightFormFieldId;
        }
        else {
            return this.rightRestResponseId;
        }
    }
    set rightValue(rightValue) {
        this.json.rightValue = rightValue;
    }
}
// eslint-disable-next-line no-shadow
var WidgetTypeEnum;
(function (WidgetTypeEnum) {
    WidgetTypeEnum["field"] = "field";
    WidgetTypeEnum["variable"] = "variable";
    WidgetTypeEnum["value"] = "value";
})(WidgetTypeEnum || (WidgetTypeEnum = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class ContainerColumnModel {
    constructor() {
        this.size = 12;
        this.fields = [];
        this.colspan = 1;
        this.rowspan = 1;
    }
    hasFields() {
        return this.fields && this.fields.length > 0;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class ErrorMessageModel {
    constructor(obj) {
        this.message = '';
        this.attributes = null;
        this.message = obj && obj.message ? obj.message : '';
        this.attributes = new Map();
    }
    isActive() {
        return !!this.message;
    }
    getAttributesAsJsonObj() {
        let result = {};
        if (this.attributes.size > 0) {
            const obj = Object.create(null);
            this.attributes.forEach((value, key) => {
                obj[key] = value;
            });
            result = JSON.stringify(obj);
        }
        return result;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const isNumberValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return false;
    }
    return !isNaN(+value);
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Maps to FormFieldRepresentation
class FormFieldModel extends FormWidgetModel {
    constructor(form, json) {
        super(form, json);
        this._readOnly = false;
        this._isValid = true;
        this._required = false;
        this.defaultDateFormat = 'D-M-YYYY';
        this.defaultDateTimeFormat = 'D-M-YYYY hh:mm A';
        this.rowspan = 1;
        this.colspan = 1;
        this.placeholder = null;
        this.tooltip = null;
        this.minLength = 0;
        this.maxLength = 0;
        this.maxDateRangeValue = 0;
        this.minDateRangeValue = 0;
        this.options = [];
        this.params = {};
        this.isVisible = true;
        this.visibilityCondition = null;
        this.enableFractions = false;
        this.currency = null;
        this.dateDisplayFormat = this.defaultDateFormat;
        this.selectionType = null;
        this.alignmentType = null;
        this.leftLabels = false;
        // container model members
        this.numberOfColumns = 1;
        this.fields = [];
        this.columns = [];
        if (json) {
            this.fieldType = json.fieldType;
            this.id = json.id;
            this.name = json.name;
            this.type = json.type;
            this.roles = json.roles;
            this._required = json.required;
            this._readOnly = json.readOnly || json.type === 'readonly';
            this.overrideId = json.overrideId;
            this.tab = json.tab;
            this.restUrl = json.restUrl;
            this.restResponsePath = json.restResponsePath;
            this.restIdProperty = json.restIdProperty;
            this.restLabelProperty = json.restLabelProperty;
            this.colspan = json.colspan;
            this.rowspan = json.rowspan;
            this.minLength = json.minLength || 0;
            this.maxLength = json.maxLength || 0;
            this.minValue = json.minValue;
            this.maxValue = json.maxValue;
            this.minDateRangeValue = json.minDateRangeValue;
            this.maxDateRangeValue = json.maxDateRangeValue;
            this.dynamicDateRangeSelection = json.dynamicDateRangeSelection;
            this.regexPattern = json.regexPattern;
            this.options = json.options || [];
            this.hasEmptyValue = json.hasEmptyValue;
            this.className = json.className;
            this.optionType = json.optionType;
            this.params = json.params || {};
            this.hyperlinkUrl = json.hyperlinkUrl;
            this.displayText = json.displayText;
            this.visibilityCondition = json.visibilityCondition ? new WidgetVisibilityModel(json.visibilityCondition) : undefined;
            this.enableFractions = json.enableFractions;
            this.currency = json.currency;
            this.dateDisplayFormat = json.dateDisplayFormat || this.getDefaultDateFormat(json);
            this._value = this.parseValue(json);
            this.validationSummary = new ErrorMessageModel();
            this.tooltip = json.tooltip;
            this.selectionType = json.selectionType;
            this.alignmentType = json.alignmentType;
            this.rule = json.rule;
            this.selectLoggedUser = json.selectLoggedUser;
            this.groupsRestriction = json.groupsRestriction?.groups;
            if (json.placeholder && json.placeholder !== '' && json.placeholder !== 'null') {
                this.placeholder = json.placeholder;
            }
            if (FormFieldTypes.isReadOnlyType(this.type)) {
                if (this.params && this.params.field) {
                    this.setValueForReadonlyType(form);
                }
            }
            if (FormFieldTypes.isContainerType(this.type)) {
                this.containerFactory(json, form);
            }
        }
        if (form?.json) {
            this.leftLabels = form.json.leftLabels || false;
        }
        const emptyOption = Array.isArray(this.options) ? this.options.find(({ id }) => id === 'empty') : undefined;
        if (this.hasEmptyValue === undefined) {
            this.hasEmptyValue = json?.hasEmptyValue ?? !!emptyOption;
        }
        if (this.options && this.options.length > 0 && this.hasEmptyValue) {
            this.emptyOption = emptyOption;
        }
        this.updateForm();
    }
    get value() {
        return this._value;
    }
    set value(v) {
        this._value = v;
        this.updateForm();
    }
    get readOnly() {
        if (this.form && this.form.readOnly) {
            return true;
        }
        return this._readOnly;
    }
    set readOnly(readOnly) {
        this._readOnly = readOnly;
        this.updateForm();
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = value;
        this.updateForm();
    }
    get isValid() {
        return this._isValid;
    }
    get hasMultipleValues() {
        return this.selectionType === 'multiple';
    }
    markAsInvalid() {
        this._isValid = false;
    }
    validate() {
        this.validationSummary = new ErrorMessageModel();
        if (!this.readOnly) {
            const validators = this.form.fieldValidators || [];
            for (const validator of validators) {
                if (!validator.validate(this)) {
                    this._isValid = false;
                    return this._isValid;
                }
            }
        }
        this._isValid = true;
        return this._isValid;
    }
    setValueForReadonlyType(form) {
        const value = this.getProcessVariableValue(this.params.field, form);
        if (value) {
            this.value = value;
        }
    }
    getDefaultDateFormat(jsonField) {
        let originalType = jsonField.type;
        if (FormFieldTypes.isReadOnlyType(jsonField.type) &&
            jsonField.params &&
            jsonField.params.field) {
            originalType = jsonField.params.field.type;
        }
        return originalType === FormFieldTypes.DATETIME ? this.defaultDateTimeFormat : this.defaultDateFormat;
    }
    isTypeaheadFieldType(type) {
        return type === 'typeahead';
    }
    getFieldNameWithLabel(name) {
        return name + '_LABEL';
    }
    getProcessVariableValue(field, form) {
        let fieldName = field.name;
        if (this.isTypeaheadFieldType(field.type)) {
            fieldName = this.getFieldNameWithLabel(field.id);
        }
        return form.getProcessVariableValue(fieldName);
    }
    containerFactory(json, form) {
        this.numberOfColumns = json.numberOfColumns || 1;
        this.fields = json.fields;
        this.rowspan = 1;
        this.colspan = 1;
        if (json.fields) {
            for (const currentField in json.fields) {
                if (json.fields.hasOwnProperty(currentField)) {
                    const col = new ContainerColumnModel();
                    const fields = (json.fields[currentField] || []).map((field) => new FormFieldModel(form, field));
                    col.fields = fields;
                    col.rowspan = json.fields[currentField].length;
                    col.fields.forEach((colFields) => {
                        this.colspan = colFields.colspan > this.colspan ? colFields.colspan : this.colspan;
                    });
                    this.rowspan = this.rowspan < col.rowspan ? col.rowspan : this.rowspan;
                    this.columns.push(col);
                }
            }
        }
    }
    parseValue(json) {
        let value = json.hasOwnProperty('value') && json.value !== undefined ? json.value : null;
        /*
         This is needed due to Activiti issue related to reading dropdown values as value string
         but saving back as object: { id: <id>, name: <name> }
         */
        if (json.type === FormFieldTypes.DROPDOWN) {
            if (json.options) {
                if (json.hasEmptyValue) {
                    const emptyOption = json.options[0];
                    if (value === '' || value === emptyOption.id || value === emptyOption.name) {
                        value = emptyOption.id;
                    }
                }
                else {
                    if (value?.id && value?.name) {
                        value = value.id;
                    }
                }
            }
            if (this.hasMultipleValues) {
                value = Array.isArray(json.value) ? json.value : [];
            }
        }
        /*
         This is needed due to Activiti issue related to reading radio button values as value string
         but saving back as object: { id: <id>, name: <name> }
         */
        if (json.type === FormFieldTypes.RADIO_BUTTONS) {
            // Activiti has a bug with default radio button value where initial selection passed as `name` value
            // so try resolving current one with a fallback to first entry via name or id
            // TODO: needs to be reported and fixed at Activiti side
            const entry = this.options.filter((opt) => opt.id === value || opt.name === value || (value && (opt.id === value.id || opt.name === value.name)));
            if (entry.length > 0) {
                value = entry[0].id;
            }
        }
        /*
         This is needed due to Activiti displaying/editing dates in d-M-YYYY format
         but storing on server in ISO8601 format (i.e. 2013-02-04T22:44:30.652Z)
         */
        if (this.isDateField(json) || this.isDateTimeField(json)) {
            if (value) {
                let dateValue;
                if (isNumberValue(value)) {
                    dateValue = moment(value);
                }
                else {
                    dateValue = this.isDateTimeField(json) ? moment.utc(value, 'YYYY-MM-DD hh:mm A') : moment.utc(value.split('T')[0], 'YYYY-M-D');
                }
                if (dateValue && dateValue.isValid()) {
                    value = dateValue.utc().format(this.dateDisplayFormat);
                }
            }
        }
        if (this.isCheckboxField(json)) {
            value = json.value === 'true' || json.value === true;
        }
        return value;
    }
    updateForm() {
        if (!this.form) {
            return;
        }
        switch (this.type) {
            case FormFieldTypes.DROPDOWN:
                if (!this.value) {
                    this.form.values[this.id] = null;
                    break;
                }
                /*
                 This is needed due to Activiti reading dropdown values as string
                 but saving back as object: { id: <id>, name: <name> }
                 */
                if (Array.isArray(this.value)) {
                    this.form.values[this.id] = this.value;
                    break;
                }
                if (typeof this.value === 'string') {
                    if (this.value === 'empty' || this.value === '') {
                        this.form.values[this.id] = null;
                        break;
                    }
                    const entry = this.options.filter((opt) => opt.id === this.value);
                    if (entry.length > 0) {
                        this.form.values[this.id] = entry[0];
                    }
                }
                break;
            case FormFieldTypes.RADIO_BUTTONS:
                const radioButton = this.options.filter((opt) => opt.id === this.value);
                if (radioButton.length > 0) {
                    this.form.values[this.id] = radioButton[0];
                }
                break;
            case FormFieldTypes.UPLOAD:
                this.form.hasUpload = true;
                if (this.value && this.value.length > 0) {
                    this.form.values[this.id] = Array.isArray(this.value) ? this.value.map((elem) => elem.id).join(',') : [this.value];
                }
                else {
                    this.form.values[this.id] = null;
                }
                break;
            case FormFieldTypes.TYPEAHEAD:
                const typeAheadEntry = this.options.filter((opt) => opt.id === this.value || opt.name === this.value);
                if (typeAheadEntry.length > 0) {
                    this.form.values[this.id] = typeAheadEntry[0];
                }
                else if (this.options.length > 0) {
                    this.form.values[this.id] = null;
                }
                break;
            case FormFieldTypes.DATE:
                if (typeof this.value === 'string' && this.value === 'today') {
                    this.value = moment(new Date()).format(this.dateDisplayFormat);
                }
                const dateValue = moment(this.value, this.dateDisplayFormat, true);
                if (dateValue && dateValue.isValid()) {
                    this.form.values[this.id] = `${dateValue.format('YYYY-MM-DD')}T00:00:00.000Z`;
                }
                else {
                    this.form.values[this.id] = null;
                    this._value = this.value;
                }
                break;
            case FormFieldTypes.DATETIME:
                if (typeof this.value === 'string' && this.value === 'now') {
                    this.value = moment(new Date()).utc().format(this.dateDisplayFormat);
                }
                const dateTimeValue = moment.utc(this.value, this.dateDisplayFormat, true);
                if (dateTimeValue && dateTimeValue.isValid()) {
                    /* cspell:disable-next-line */
                    this.form.values[this.id] = `${dateTimeValue.utc().format('YYYY-MM-DDTHH:mm:ss')}.000Z`;
                }
                else {
                    this.form.values[this.id] = null;
                    this._value = this.value;
                }
                break;
            case FormFieldTypes.NUMBER:
                this.form.values[this.id] = this.enableFractions ? parseFloat(this.value) : parseInt(this.value, 10);
                break;
            case FormFieldTypes.AMOUNT:
                this.form.values[this.id] = this.enableFractions ? parseFloat(this.value) : parseInt(this.value, 10);
                break;
            case FormFieldTypes.BOOLEAN:
                this.form.values[this.id] = (this.value !== null && this.value !== undefined) ? this.value : false;
                break;
            case FormFieldTypes.PEOPLE:
                this.form.values[this.id] = this.value ? this.value : null;
                break;
            case FormFieldTypes.FUNCTIONAL_GROUP:
                this.form.values[this.id] = this.value ? this.value : null;
                break;
            default:
                if (!FormFieldTypes.isReadOnlyType(this.type) && !this.isInvalidFieldType(this.type)) {
                    this.form.values[this.id] = this.value;
                }
        }
        this.form.onFormFieldChanged(this);
    }
    /**
     * Skip the invalid field type
     *
     * @param type
     */
    isInvalidFieldType(type) {
        return type === 'container';
    }
    getOptionName() {
        const option = this.options.find((opt) => opt.id === this.value);
        return option ? option.name : null;
    }
    hasOptions() {
        return this.options && this.options.length > 0;
    }
    isDateField(json) {
        return (json.params &&
            json.params.field &&
            json.params.field.type === FormFieldTypes.DATE) ||
            json.type === FormFieldTypes.DATE;
    }
    isDateTimeField(json) {
        return (json.params &&
            json.params.field &&
            json.params.field.type === FormFieldTypes.DATETIME) ||
            json.type === FormFieldTypes.DATETIME;
    }
    isCheckboxField(json) {
        return (json.params &&
            json.params.field &&
            json.params.field.type === FormFieldTypes.BOOLEAN) ||
            json.type === FormFieldTypes.BOOLEAN;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TabModel extends FormWidgetModel {
    constructor(form, json) {
        super(form, json);
        this.isVisible = true;
        this.fields = [];
        if (json) {
            this.title = json.title;
            this.visibilityCondition = new WidgetVisibilityModel(json.visibilityCondition);
        }
    }
    hasContent() {
        return this.fields && this.fields.length > 0;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormOutcomeModel extends FormWidgetModel {
    constructor(form, json) {
        super(form, json);
        this.isSystem = false;
        this.isSelected = false;
        this.isVisible = true;
        if (json) {
            this.isSystem = json.isSystem ? true : false;
            this.isSelected = form && json.name === form.selectedOutcome ? true : false;
            this.visibilityCondition = new WidgetVisibilityModel(json.visibilityCondition);
        }
    }
}
FormOutcomeModel.SAVE_ACTION = 'SAVE'; // Activiti 'Save' action name
FormOutcomeModel.COMPLETE_ACTION = 'COMPLETE'; // Activiti 'Complete' action name
FormOutcomeModel.START_PROCESS_ACTION = 'START PROCESS'; // Activiti 'Start Process' action name

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RequiredFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.TEXT,
            FormFieldTypes.MULTILINE_TEXT,
            FormFieldTypes.NUMBER,
            FormFieldTypes.BOOLEAN,
            FormFieldTypes.TYPEAHEAD,
            FormFieldTypes.DROPDOWN,
            FormFieldTypes.PEOPLE,
            FormFieldTypes.FUNCTIONAL_GROUP,
            FormFieldTypes.RADIO_BUTTONS,
            FormFieldTypes.UPLOAD,
            FormFieldTypes.AMOUNT,
            FormFieldTypes.DYNAMIC_TABLE,
            FormFieldTypes.DATE,
            FormFieldTypes.DATETIME,
            FormFieldTypes.ATTACH_FOLDER
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 &&
            field.required;
    }
    validate(field) {
        if (this.isSupported(field) && field.isVisible) {
            if (field.type === FormFieldTypes.DROPDOWN) {
                if (field.hasMultipleValues) {
                    return Array.isArray(field.value) && !!field.value.length;
                }
                if (field.hasEmptyValue && field.emptyOption) {
                    if (field.value === field.emptyOption.id) {
                        return false;
                    }
                }
                if (field.required && typeof field.value === 'object' && field.value && !Object.keys(field.value).length) {
                    return false;
                }
            }
            if (field.type === FormFieldTypes.RADIO_BUTTONS) {
                const option = field.options.find((opt) => opt.id === field.value);
                return !!option;
            }
            if (field.type === FormFieldTypes.UPLOAD) {
                return field.value && field.value.length > 0;
            }
            if (field.type === FormFieldTypes.DYNAMIC_TABLE) {
                return field.value && field.value instanceof Array && field.value.length > 0;
            }
            if (field.type === FormFieldTypes.BOOLEAN) {
                return !!field.value;
            }
            if (field.value === null || field.value === undefined || field.value === '') {
                return false;
            }
        }
        return true;
    }
}
class NumberFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.NUMBER,
            FormFieldTypes.AMOUNT
        ];
    }
    static isNumber(value) {
        return isNumberValue(value);
    }
    isSupported(field) {
        return field && this.supportedTypes.indexOf(field.type) > -1;
    }
    validate(field) {
        if (this.isSupported(field) && field.isVisible) {
            if (field.value === null ||
                field.value === undefined ||
                field.value === '') {
                return true;
            }
            const valueStr = '' + field.value;
            let pattern = new RegExp(/^-?\d+$/);
            if (field.enableFractions) {
                pattern = new RegExp(/^-?[0-9]+(\.[0-9]{1,2})?$/);
            }
            if (valueStr.match(pattern)) {
                return true;
            }
            field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_NUMBER';
            return false;
        }
        return true;
    }
}
class DateFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.DATE
        ];
    }
    // Validates that the input string is a valid date formatted as <dateFormat> (default D-M-YYYY)
    static isValidDate(inputDate, dateFormat = 'D-M-YYYY') {
        if (inputDate) {
            const d = moment(inputDate, dateFormat, true);
            return d.isValid();
        }
        return false;
    }
    isSupported(field) {
        return field && this.supportedTypes.indexOf(field.type) > -1;
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            if (DateFieldValidator.isValidDate(field.value, field.dateDisplayFormat)) {
                return true;
            }
            field.validationSummary.message = field.dateDisplayFormat;
            return false;
        }
        return true;
    }
}
class DateTimeFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.DATETIME
        ];
    }
    // Validates that the input string is a valid date formatted as <dateFormat> (default D-M-YYYY)
    static isValidDate(inputDate, dateFormat = 'YYYY-MM-DD HH:mm') {
        if (inputDate) {
            const d = moment(inputDate, dateFormat, true);
            return d.isValid();
        }
        return false;
    }
    isSupported(field) {
        return field && this.supportedTypes.indexOf(field.type) > -1;
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            if (DateFieldValidator.isValidDate(field.value, field.dateDisplayFormat)) {
                return true;
            }
            field.validationSummary.message = field.dateDisplayFormat;
            return false;
        }
        return true;
    }
}
class BoundaryDateFieldValidator {
    constructor() {
        this.DATE_FORMAT_CLOUD = 'YYYY-MM-DD';
        this.DATE_FORMAT = 'DD-MM-YYYY';
        this.supportedTypes = [
            FormFieldTypes.DATE
        ];
    }
    validate(field) {
        let isValid = true;
        if (this.isSupported(field) && field.value && field.isVisible) {
            const dateFormat = field.dateDisplayFormat;
            if (!DateFieldValidator.isValidDate(field.value, dateFormat)) {
                field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_DATE';
                isValid = false;
            }
            else {
                isValid = this.checkDate(field, dateFormat);
            }
        }
        return isValid;
    }
    extractDateFormat(date) {
        const brokenDownDate = date.split('-');
        return brokenDownDate[0].length === 4 ? this.DATE_FORMAT_CLOUD : this.DATE_FORMAT;
    }
}
class MinDateFieldValidator extends BoundaryDateFieldValidator {
    checkDate(field, dateFormat) {
        let isValid = true;
        // remove time and timezone info
        let fieldValueData;
        if (typeof field.value === 'string') {
            fieldValueData = moment(field.value.split('T')[0], dateFormat);
        }
        else {
            fieldValueData = field.value;
        }
        const minValueDateFormat = this.extractDateFormat(field.minValue);
        const min = moment(field.minValue, minValueDateFormat);
        if (fieldValueData.isBefore(min)) {
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_LESS_THAN`;
            field.validationSummary.attributes.set('minValue', min.format(field.dateDisplayFormat).toLocaleUpperCase());
            isValid = false;
        }
        return isValid;
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 && !!field.minValue;
    }
}
class MaxDateFieldValidator extends BoundaryDateFieldValidator {
    checkDate(field, dateFormat) {
        let isValid = true;
        // remove time and timezone info
        let fieldValueData;
        if (typeof field.value === 'string') {
            fieldValueData = moment(field.value.split('T')[0], dateFormat);
        }
        else {
            fieldValueData = field.value;
        }
        const maxValueDateFormat = this.extractDateFormat(field.maxValue);
        const max = moment(field.maxValue, maxValueDateFormat);
        if (fieldValueData.isAfter(max)) {
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_GREATER_THAN`;
            field.validationSummary.attributes.set('maxValue', max.format(field.dateDisplayFormat).toLocaleUpperCase());
            isValid = false;
        }
        return isValid;
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 && !!field.maxValue;
    }
}
class MinDateTimeFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.DATETIME
        ];
        this.MIN_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm AZ';
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 && !!field.minValue;
    }
    validate(field) {
        let isValid = true;
        if (this.isSupported(field) && field.value && field.isVisible) {
            const dateFormat = field.dateDisplayFormat;
            if (!DateFieldValidator.isValidDate(field.value, dateFormat)) {
                field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_DATE';
                isValid = false;
            }
            else {
                isValid = this.checkDateTime(field, dateFormat);
            }
        }
        return isValid;
    }
    checkDateTime(field, dateFormat) {
        let isValid = true;
        let fieldValueDate;
        if (typeof field.value === 'string') {
            fieldValueDate = moment(field.value, dateFormat);
        }
        else {
            fieldValueDate = field.value;
        }
        const min = moment(field.minValue, this.MIN_DATETIME_FORMAT);
        if (fieldValueDate.isBefore(min)) {
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_LESS_THAN`;
            field.validationSummary.attributes.set('minValue', min.format(field.dateDisplayFormat).replace(':', '-'));
            isValid = false;
        }
        return isValid;
    }
}
class MaxDateTimeFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.DATETIME
        ];
        this.MAX_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm AZ';
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 && !!field.maxValue;
    }
    validate(field) {
        let isValid = true;
        if (this.isSupported(field) && field.value && field.isVisible) {
            const dateFormat = field.dateDisplayFormat;
            if (!DateFieldValidator.isValidDate(field.value, dateFormat)) {
                field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_DATE';
                isValid = false;
            }
            else {
                isValid = this.checkDateTime(field, dateFormat);
            }
        }
        return isValid;
    }
    checkDateTime(field, dateFormat) {
        let isValid = true;
        let fieldValueDate;
        if (typeof field.value === 'string') {
            fieldValueDate = moment(field.value, dateFormat);
        }
        else {
            fieldValueDate = field.value;
        }
        const max = moment(field.maxValue, this.MAX_DATETIME_FORMAT);
        if (fieldValueDate.isAfter(max)) {
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_GREATER_THAN`;
            field.validationSummary.attributes.set('maxValue', max.format(field.dateDisplayFormat).replace(':', '-'));
            isValid = false;
        }
        return isValid;
    }
}
class MinLengthFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.TEXT,
            FormFieldTypes.MULTILINE_TEXT
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 &&
            field.minLength > 0;
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            if (field.value.length >= field.minLength) {
                return true;
            }
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.AT_LEAST_LONG`;
            field.validationSummary.attributes.set('minLength', field.minLength.toLocaleString());
            return false;
        }
        return true;
    }
}
class MaxLengthFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.TEXT,
            FormFieldTypes.MULTILINE_TEXT
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 &&
            field.maxLength > 0;
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            if (field.value.length <= field.maxLength) {
                return true;
            }
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NO_LONGER_THAN`;
            field.validationSummary.attributes.set('maxLength', field.maxLength.toLocaleString());
            return false;
        }
        return true;
    }
}
class MinValueFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.NUMBER,
            FormFieldTypes.AMOUNT
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 &&
            NumberFieldValidator.isNumber(field.minValue);
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            const value = +field.value;
            const minValue = +field.minValue;
            if (value >= minValue) {
                return true;
            }
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_LESS_THAN`;
            field.validationSummary.attributes.set('minValue', field.minValue.toLocaleString());
            return false;
        }
        return true;
    }
}
class MaxValueFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.NUMBER,
            FormFieldTypes.AMOUNT
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 &&
            NumberFieldValidator.isNumber(field.maxValue);
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            const value = +field.value;
            const maxValue = +field.maxValue;
            if (value <= maxValue) {
                return true;
            }
            field.validationSummary.message = `FORM.FIELD.VALIDATOR.NOT_GREATER_THAN`;
            field.validationSummary.attributes.set('maxValue', field.maxValue.toLocaleString());
            return false;
        }
        return true;
    }
}
class RegExFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.TEXT,
            FormFieldTypes.MULTILINE_TEXT
        ];
    }
    isSupported(field) {
        return field &&
            this.supportedTypes.indexOf(field.type) > -1 && !!field.regexPattern;
    }
    validate(field) {
        if (this.isSupported(field) && field.value && field.isVisible) {
            if (field.value.length > 0 && field.value.match(new RegExp('^' + field.regexPattern + '$'))) {
                return true;
            }
            field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_VALUE';
            return false;
        }
        return true;
    }
}
class FixedValueFieldValidator {
    constructor() {
        this.supportedTypes = [
            FormFieldTypes.TYPEAHEAD
        ];
    }
    isSupported(field) {
        return field && this.supportedTypes.indexOf(field.type) > -1;
    }
    hasValidNameOrValidId(field) {
        return this.hasValidName(field) || this.hasValidId(field);
    }
    hasValidName(field) {
        return field.options.find((item) => item.name && item.name.toLocaleLowerCase() === field.value.toLocaleLowerCase()) ? true : false;
    }
    hasValidId(field) {
        return field.options.find((item) => item.id === field.value) ? true : false;
    }
    hasStringValue(field) {
        return field.value && typeof field.value === 'string';
    }
    hasOptions(field) {
        return field.options && field.options.length > 0;
    }
    validate(field) {
        if (this.isSupported(field) && field.isVisible) {
            if (this.hasStringValue(field) && this.hasOptions(field) && !this.hasValidNameOrValidId(field)) {
                field.validationSummary.message = 'FORM.FIELD.VALIDATOR.INVALID_VALUE';
                return false;
            }
        }
        return true;
    }
}
const FORM_FIELD_VALIDATORS = [
    new RequiredFieldValidator(),
    new NumberFieldValidator(),
    new MinLengthFieldValidator(),
    new MaxLengthFieldValidator(),
    new MinValueFieldValidator(),
    new MaxValueFieldValidator(),
    new RegExFieldValidator(),
    new DateFieldValidator(),
    new DateTimeFieldValidator(),
    new MinDateFieldValidator(),
    new MaxDateFieldValidator(),
    new FixedValueFieldValidator(),
    new MinDateTimeFieldValidator(),
    new MaxDateTimeFieldValidator()
];

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormModel {
    constructor(json, formValues, readOnly = false, formService, enableFixedSpace) {
        this.formService = formService;
        this.taskName = FormModel.UNSET_TASK_NAME;
        this.fieldsCache = [];
        this.values = {};
        this.tabs = [];
        this.fields = [];
        this.outcomes = [];
        this.fieldValidators = [...FORM_FIELD_VALIDATORS];
        this.customFieldTemplates = {};
        this.readOnly = false;
        this.isValid = true;
        this.processVariables = [];
        this.variables = [];
        this.readOnly = readOnly;
        this.json = json;
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.taskId = json.taskId;
            this.taskName = json.taskName || json.name || FormModel.UNSET_TASK_NAME;
            this.processDefinitionId = json.processDefinitionId;
            this.customFieldTemplates = json.customFieldTemplates || {};
            this.selectedOutcome = json.selectedOutcome;
            this.className = json.className || '';
            this.variables = json.variables || json.formDefinition?.variables || [];
            this.processVariables = json.processVariables || [];
            this.enableFixedSpace = enableFixedSpace ? true : false;
            this.confirmMessage = json.confirmMessage || {};
            this.tabs = (json.tabs || []).map((tabJson) => new TabModel(this, tabJson));
            this.fields = this.parseRootFields(json);
            this.fieldsCache = this.getFormFields();
            if (formValues) {
                this.loadData(formValues);
            }
            this.parseOutcomes();
        }
        this.validateForm();
    }
    onFormFieldChanged(field) {
        this.validateField(field);
        if (this.formService) {
            this.formService.formFieldValueChanged.next(new FormFieldEvent(this, field));
        }
    }
    /**
     * Validates entire form and all form fields.
     *
     * @memberof FormModel
     */
    validateForm() {
        const validateFormEvent = new ValidateFormEvent(this);
        const errorsField = [];
        for (let i = 0; i < this.fieldsCache.length; i++) {
            if (!this.fieldsCache[i].validate()) {
                errorsField.push(this.fieldsCache[i]);
            }
        }
        this.isValid = errorsField.length <= 0;
        if (this.formService) {
            validateFormEvent.isValid = this.isValid;
            validateFormEvent.errorsField = errorsField;
            this.formService.validateForm.next(validateFormEvent);
        }
    }
    /**
     * Validates a specific form field, triggers form validation.
     *
     * @param field Form field to validate.
     * @memberof FormModel
     */
    validateField(field) {
        if (!field) {
            return;
        }
        const validateFieldEvent = new ValidateFormFieldEvent(this, field);
        if (this.formService) {
            this.formService.validateFormField.next(validateFieldEvent);
        }
        if (!validateFieldEvent.isValid) {
            this.markAsInvalid();
            return;
        }
        if (validateFieldEvent.defaultPrevented) {
            return;
        }
        if (!field.validate()) {
            this.markAsInvalid();
        }
        this.validateForm();
    }
    // Activiti supports 3 types of root fields: container|group|dynamic-table
    parseRootFields(json) {
        let fields = [];
        if (json.fields) {
            fields = json.fields;
        }
        else if (json.formDefinition && json.formDefinition.fields) {
            fields = json.formDefinition.fields;
        }
        const rootElements = [];
        let currentRootElement;
        for (const field of fields) {
            if (field?.type === FormFieldTypes.DYNAMIC_TABLE) {
                currentRootElement = new FormFieldModel(this, field);
            }
            else {
                currentRootElement = new ContainerModel(new FormFieldModel(this, field));
            }
            if (field.tab) {
                const tab = this.tabs.find((currentTab) => field.tab === currentTab.id);
                if (tab) {
                    tab.fields.push(currentRootElement);
                }
            }
            rootElements.push(currentRootElement);
        }
        return rootElements;
    }
    // Loads external data and overrides field values
    // Typically used when form definition and form data coming from different sources
    loadData(formValues) {
        for (const field of this.fieldsCache) {
            const variableId = `variables.${field.name}`;
            if (this.isDefined(formValues[variableId]) || this.isDefined(formValues[field.id])) {
                field.json.value = formValues[variableId] || formValues[field.id];
                field.value = field.parseValue(field.json);
            }
        }
    }
    isDefined(value) {
        return value !== undefined && value !== null;
    }
    /**
     * Returns a form variable that matches the identifier.
     *
     * @param identifier The `name` or `id` value.
     */
    getFormVariable(identifier) {
        if (identifier) {
            return this.variables.find(variable => variable.name === identifier ||
                variable.id === identifier);
        }
        return undefined;
    }
    /**
     * Returns a value of the form variable that matches the identifier.
     * Provides additional conversion of types (date, boolean).
     *
     * @param identifier The `name` or `id` value
     */
    getDefaultFormVariableValue(identifier) {
        const variable = this.getFormVariable(identifier);
        if (variable && variable.hasOwnProperty('value')) {
            return this.parseValue(variable.type, variable.value);
        }
        return undefined;
    }
    /**
     * Returns a process variable value.
     * When mapping a process variable with a form variable the mapping
     * is already resolved by the rest API with the name of variables.formVariableName
     *
     * @param name Variable name
     */
    getProcessVariableValue(name) {
        let value;
        if (this.processVariables?.length) {
            const names = [`variables.${name}`, name];
            const processVariable = this.processVariables.find(entry => names.includes(entry.name));
            if (processVariable) {
                value = this.parseValue(processVariable.type, processVariable.value);
            }
        }
        if (!value) {
            value = this.getDefaultFormVariableValue(name);
        }
        return value;
    }
    parseValue(type, value) {
        if (type && value) {
            switch (type) {
                case 'date':
                    return value
                        ? `${value}T00:00:00.000Z`
                        : undefined;
                case 'boolean':
                    return typeof value === 'string'
                        ? JSON.parse(value)
                        : value;
                default:
                    return value;
            }
        }
        return value;
    }
    hasTabs() {
        return this.tabs && this.tabs.length > 0;
    }
    hasFields() {
        return this.fields && this.fields.length > 0;
    }
    hasOutcomes() {
        return this.outcomes && this.outcomes.length > 0;
    }
    getFieldById(fieldId) {
        return this.fieldsCache.find((field) => field.id === fieldId);
    }
    getFormFields() {
        if (this.fieldsCache.length > 0) {
            return this.fieldsCache;
        }
        else {
            const formFieldModel = [];
            for (let i = 0; i < this.fields.length; i++) {
                const field = this.fields[i];
                if (field instanceof ContainerModel) {
                    formFieldModel.push(field.field);
                    field.field.columns.forEach((column) => {
                        formFieldModel.push(...column.fields);
                    });
                }
                else {
                    formFieldModel.push(field);
                }
            }
            return formFieldModel;
        }
    }
    markAsInvalid() {
        this.isValid = false;
    }
    parseOutcomes() {
        if (this.json.fields) {
            const saveOutcome = new FormOutcomeModel(this, {
                id: FormModel.SAVE_OUTCOME,
                name: 'SAVE',
                isSystem: true
            });
            const completeOutcome = new FormOutcomeModel(this, {
                id: FormModel.COMPLETE_OUTCOME,
                name: 'COMPLETE',
                isSystem: true
            });
            const startProcessOutcome = new FormOutcomeModel(this, {
                id: FormModel.START_PROCESS_OUTCOME,
                name: 'START PROCESS',
                isSystem: true
            });
            const customOutcomes = (this.json.outcomes || []).map((obj) => new FormOutcomeModel(this, obj));
            this.outcomes = [saveOutcome].concat(customOutcomes.length > 0
                ? customOutcomes
                : [completeOutcome, startProcessOutcome]);
        }
    }
    addValuesNotPresent(valuesToSetIfNotPresent) {
        this.fieldsCache.forEach(field => {
            if (valuesToSetIfNotPresent[field.id] && (!this.values[field.id] || this.isValidDropDown(field.id))) {
                this.values[field.id] = valuesToSetIfNotPresent[field.id];
                field.json.value = this.values[field.id];
                field.value = field.parseValue(field.json);
            }
        });
    }
    isValidDropDown(key) {
        const field = this.getFieldById(key);
        if (field.type === FormFieldTypes.DROPDOWN) {
            if (field.hasMultipleValues) {
                return Array.isArray(this.values[key]);
            }
            return typeof this.values[key] === 'string' ? this.values[key] === 'empty' : Object.keys(this.values[key]).length === 0;
        }
        return false;
    }
    setNodeIdValueForViewersLinkedToUploadWidget(linkedUploadWidgetContentSelected) {
        const linkedWidgetType = linkedUploadWidgetContentSelected?.options?.linkedWidgetType ?? 'uploadWidget';
        const subscribedViewers = this.fieldsCache.filter(field => linkedUploadWidgetContentSelected.uploadWidgetId === field.params[linkedWidgetType]);
        subscribedViewers.forEach(viewer => {
            this.values[viewer.id] = linkedUploadWidgetContentSelected.id;
            viewer.json.value = this.values[viewer.id];
            viewer.value = viewer.parseValue(viewer.json);
        });
    }
    changeFieldVisibility(fieldId, visibility) {
        const visibilityRule = new WidgetVisibilityModel();
        const field = this.getFieldById(fieldId);
        if (!!field) {
            visibilityRule.operator = visibility ? 'empty' : '!empty';
            visibilityRule.leftType = WidgetTypeEnum.field;
            field.visibilityCondition = visibilityRule;
            field.isVisible = visibility;
        }
    }
    changeFieldDisabled(fieldId, disabled) {
        const field = this.getFieldById(fieldId);
        if (!!field) {
            field.readOnly = this.readOnly || disabled;
        }
    }
    changeFieldRequired(fieldId, required) {
        const field = this.getFieldById(fieldId);
        if (!!field) {
            field.required = required;
        }
    }
    changeFieldValue(fieldId, value) {
        const field = this.getFieldById(fieldId);
        if (!!field) {
            field.value = value;
        }
    }
    changeVariableValue(variableId, value) {
        const variable = this.getFormVariable(variableId);
        if (!!variable) {
            variable.value = value;
        }
    }
}
FormModel.UNSET_TASK_NAME = 'Nameless task';
FormModel.SAVE_OUTCOME = '$save';
FormModel.COMPLETE_OUTCOME = '$complete';
FormModel.START_PROCESS_OUTCOME = '$startProcess';

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormService {
    constructor() {
        this.formLoaded = new Subject();
        this.formDataRefreshed = new Subject();
        this.formFieldValueChanged = new Subject();
        this.formEvents = new Subject();
        this.taskCompleted = new Subject();
        this.taskCompletedError = new Subject();
        this.taskSaved = new Subject();
        this.taskSavedError = new Subject();
        this.formContentClicked = new Subject();
        this.validateForm = new Subject();
        this.validateFormField = new Subject();
        this.validateDynamicTableRow = new Subject();
        this.executeOutcome = new Subject();
        this.updateFormValuesRequested = new Subject();
        this.formRulesEvent = new Subject();
    }
    /**
     * Parses JSON data to create a corresponding Form model.
     *
     * @param json JSON to create the form
     * @param data Values for the form fields
     * @param readOnly Should the form fields be read-only?
     * @param fixedSpace
     * @returns Form model created from input data
     */
    parseForm(json, data, readOnly = false, fixedSpace) {
        if (json) {
            const form = new FormModel(json, data, readOnly, this, fixedSpace);
            if (!json.fields) {
                form.outcomes = [
                    new FormOutcomeModel(form, {
                        id: '$save',
                        name: FormOutcomeModel.SAVE_ACTION,
                        isSystem: true
                    })
                ];
            }
            return form;
        }
        return null;
    }
}
FormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormRulesEvent extends FormFieldEvent {
    constructor(type, formEvent, event) {
        super(formEvent.form, formEvent['field']);
        this.type = type;
        this.event = event;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormOutcomeEvent {
    constructor(outcome) {
        this._defaultPrevented = false;
        this._outcome = outcome;
    }
    get outcome() {
        return this._outcome;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    preventDefault() {
        this._defaultPrevented = true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class ContentLinkModel {
    constructor(obj) {
        this.contentAvailable = obj && obj.contentAvailable;
        this.created = obj && obj.created;
        this.createdBy = obj && obj.createdBy || {};
        this.id = obj && obj.id;
        this.link = obj && obj.link;
        this.mimeType = obj && obj.mimeType;
        this.name = obj && obj.name;
        this.previewStatus = obj && obj.previewStatus;
        this.relatedContent = obj && obj.relatedContent;
        this.simpleType = obj && obj.simpleType;
        this.thumbnailStatus = obj && obj.thumbnailStatus;
        this.nodeId = obj && obj.nodeId;
    }
    hasPreviewStatus() {
        return this.previewStatus === 'supported';
    }
    isTypeImage() {
        return this.simpleType === 'image';
    }
    isTypePdf() {
        return this.simpleType === 'pdf';
    }
    isTypeDoc() {
        return this.simpleType === 'word' || this.simpleType === 'content';
    }
    isThumbnailReady() {
        return this.thumbnailStatus === 'created';
    }
    isThumbnailSupported() {
        return this.isTypeImage() || ((this.isTypePdf() || this.isTypeDoc()) && this.isThumbnailReady());
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadWidgetContentLinkModelOptions {
}
class UploadWidgetContentLinkModel extends ContentLinkModel {
    constructor(obj, uploadWidgetId, options) {
        super(obj);
        this.options = options;
        this.uploadWidgetId = uploadWidgetId;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base widget component.
 */
class WidgetComponent {
    constructor(formService) {
        this.formService = formService;
        /** Does the widget show a read-only value? (ie, can't be edited) */
        this.readOnly = false;
        /**
         * Emitted when a field value changes.
         */
        this.fieldChanged = new EventEmitter();
        this.touched = false;
    }
    hasField() {
        return !!this.field;
    }
    // Note for developers:
    // returns <any> object to be able binding it to the <element required="required"> attribute
    isRequired() {
        if (this.field && this.field.required) {
            return true;
        }
        return null;
    }
    isValid() {
        return !!this.field.validationSummary;
    }
    isTouched() {
        return this.touched;
    }
    hasValue() {
        return this.field &&
            this.field.value !== null &&
            this.field.value !== undefined;
    }
    isInvalidFieldRequired() {
        return !this.field.isValid && (!this.field.validationSummary || !this.field.value) && this.isRequired();
    }
    ngAfterViewInit() {
        this.fieldChanged.emit(this.field);
    }
    checkVisibility(field) {
        this.fieldChanged.emit(field);
    }
    onFieldChanged(field) {
        this.fieldChanged.emit(field);
        this.formService.formRulesEvent.next(new FormRulesEvent('fieldValueChanged', new FormFieldEvent(this.field?.form, this.field), null));
    }
    event(event) {
        this.formService.formEvents.next(event);
        this.formService.formRulesEvent.next(new FormRulesEvent(event?.type, new FormFieldEvent(this.field?.form, this.field), event));
    }
    markAsTouched() {
        this.touched = true;
    }
}
WidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
WidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: WidgetComponent, selector: "base-widget", inputs: { readOnly: "readOnly", field: "field" }, outputs: { fieldChanged: "fieldChanged" }, host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, ngImport: i0, template: '', isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WidgetComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'base-widget',
                    template: '',
                    host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    },
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: FormService }]; }, propDecorators: { readOnly: [{
                type: Input
            }], field: [{
                type: Input
            }], fieldChanged: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UnknownWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
    }
}
UnknownWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UnknownWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
UnknownWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UnknownWidgetComponent, selector: "unknown-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: `
            <mat-list class="adf-unknown-widget">
                <mat-list-item>
                     <mat-icon class="mat-24">error_outline</mat-icon>
                     <span class="adf-unknown-text">Unknown type: {{field.type}}</span>
                </mat-list-item>
            </mat-list>

    `, isInline: true, styles: [".adf-unknown-text{margin-left:10px;color:red}.adf-unknown-widget{margin:42px}\n"], dependencies: [{ kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i7$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i7$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UnknownWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'unknown-widget', template: `
            <mat-list class="adf-unknown-widget">
                <mat-list-item>
                     <mat-icon class="mat-24">error_outline</mat-icon>
                     <span class="adf-unknown-text">Unknown type: {{field.type}}</span>
                </mat-list-item>
            </mat-list>

    `, host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, styles: [".adf-unknown-text{margin-left:10px;color:red}.adf-unknown-widget{margin:42px}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ErrorWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
        this.translateParameters = null;
        this.subscriptAnimationState = '';
    }
    ngOnChanges(changes) {
        if (changes['required']) {
            this.required = changes.required.currentValue;
            this.subscriptAnimationState = 'enter';
        }
        if (changes['error'] && changes['error'].currentValue) {
            if (changes.error.currentValue.isActive()) {
                this.error = changes.error.currentValue;
                this.translateParameters = this.error.getAttributesAsJsonObj();
                this.subscriptAnimationState = 'enter';
            }
        }
    }
}
ErrorWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ErrorWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
ErrorWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ErrorWidgetComponent, selector: "error-widget", inputs: { error: "error", required: "required" }, host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"adf-error-container\">\n    <div *ngIf=\"error?.isActive()\" [@transitionMessages]=\"subscriptAnimationState\" class=\"adf-error\">\n        <mat-icon class=\"adf-error-icon\">error_outline</mat-icon>\n        <div class=\"adf-error-text\">{{error.message | translate:translateParameters}}</div>\n    </div>\n    <div *ngIf=\"required\" [@transitionMessages]=\"subscriptAnimationState\" class=\"adf-error\">\n        <mat-icon class=\"adf-error-icon\">error_outline</mat-icon>\n        <div class=\"adf-error-text\">{{required}}</div>\n    </div>\n</div>\n", styles: [".adf-error{display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], animations: [
        trigger('transitionMessages', [
            state('enter', style({ opacity: 1, transform: 'translateY(0%)' })),
            transition('void => enter', [
                style({ opacity: 0, transform: 'translateY(-100%)' }),
                animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)')
            ])
        ])
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ErrorWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'error-widget', animations: [
                        trigger('transitionMessages', [
                            state('enter', style({ opacity: 1, transform: 'translateY(0%)' })),
                            transition('void => enter', [
                                style({ opacity: 0, transform: 'translateY(-100%)' }),
                                animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)')
                            ])
                        ])
                    ], host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-error-container\">\n    <div *ngIf=\"error?.isActive()\" [@transitionMessages]=\"subscriptAnimationState\" class=\"adf-error\">\n        <mat-icon class=\"adf-error-icon\">error_outline</mat-icon>\n        <div class=\"adf-error-text\">{{error.message | translate:translateParameters}}</div>\n    </div>\n    <div *ngIf=\"required\" [@transitionMessages]=\"subscriptAnimationState\" class=\"adf-error\">\n        <mat-icon class=\"adf-error-icon\">error_outline</mat-icon>\n        <div class=\"adf-error-text\">{{required}}</div>\n    </div>\n</div>\n", styles: [".adf-error{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; }, propDecorators: { error: [{
                type: Input
            }], required: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ADF_AMOUNT_SETTINGS = new InjectionToken('adf-amount-settings');
class AmountWidgetComponent extends WidgetComponent {
    constructor(formService, settings) {
        super(formService);
        this.formService = formService;
        this.settings = settings;
        this.showPlaceholder = true;
        this.currency = AmountWidgetComponent.DEFAULT_CURRENCY;
    }
    get placeholder() {
        return this.showPlaceholder ? this.field.placeholder : '';
    }
    ngOnInit() {
        if (this.field) {
            if (this.field.currency) {
                this.currency = this.field.currency;
            }
            if (this.field.readOnly) {
                this.showPlaceholder = this.settings && this.settings.showReadonlyPlaceholder;
            }
        }
    }
}
AmountWidgetComponent.DEFAULT_CURRENCY = '$';
AmountWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AmountWidgetComponent, deps: [{ token: FormService }, { token: ADF_AMOUNT_SETTINGS, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AmountWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AmountWidgetComponent, selector: "amount-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-amount-widget__container adf-amount-widget {{field.className}}\"\n       [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\"\n       [class.adf-left-label-input-container]=\"field.leftLabels\">\n       <div>\n              <label class=\"adf-label\"\n                     [class.adf-left-label]=\"field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n       </div>\n       <div>\n              <mat-form-field class=\"adf-amount-widget__input\" [hideRequiredMarker]=\"true\">\n                     <span matPrefix class=\"adf-amount-widget__prefix-spacing\">{{ currency }} &nbsp;</span>\n                     <input matInput [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\"\n                            class=\"adf-input\" type=\"text\" [id]=\"field.id\" [required]=\"isRequired()\"\n                            [placeholder]=\"placeholder\" [value]=\"field.value\" [(ngModel)]=\"field.value\"\n                            (ngModelChange)=\"onFieldChanged(field)\" [disabled]=\"field.readOnly\"\n                            (blur)=\"markAsTouched()\">\n              </mat-form-field>\n              <error-widget [error]=\"field.validationSummary\"></error-widget>\n              <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\"\n                     required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n       </div>\n</div>", styles: [".adf-amount-widget{width:100%;margin-top:15px}.adf-amount-widget .adf-left-label{line-height:36px}.adf-amount-widget__input{margin-top:-15px}.adf-amount-widget__input .mat-focused{transition:none}.adf-amount-widget__input:not(.mat-focused):not(.mat-form-field-invalid) .adf-amount-widget__prefix-spacing{color:var(--adf-theme-foreground-secondary-text-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AmountWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'amount-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-amount-widget__container adf-amount-widget {{field.className}}\"\n       [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\"\n       [class.adf-left-label-input-container]=\"field.leftLabels\">\n       <div>\n              <label class=\"adf-label\"\n                     [class.adf-left-label]=\"field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n       </div>\n       <div>\n              <mat-form-field class=\"adf-amount-widget__input\" [hideRequiredMarker]=\"true\">\n                     <span matPrefix class=\"adf-amount-widget__prefix-spacing\">{{ currency }} &nbsp;</span>\n                     <input matInput [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\"\n                            class=\"adf-input\" type=\"text\" [id]=\"field.id\" [required]=\"isRequired()\"\n                            [placeholder]=\"placeholder\" [value]=\"field.value\" [(ngModel)]=\"field.value\"\n                            (ngModelChange)=\"onFieldChanged(field)\" [disabled]=\"field.readOnly\"\n                            (blur)=\"markAsTouched()\">\n              </mat-form-field>\n              <error-widget [error]=\"field.validationSummary\"></error-widget>\n              <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\"\n                     required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n       </div>\n</div>", styles: [".adf-amount-widget{width:100%;margin-top:15px}.adf-amount-widget .adf-left-label{line-height:36px}.adf-amount-widget__input{margin-top:-15px}.adf-amount-widget__input .mat-focused{transition:none}.adf-amount-widget__input:not(.mat-focused):not(.mat-form-field-invalid) .adf-amount-widget__prefix-spacing{color:var(--adf-theme-foreground-secondary-text-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ADF_AMOUNT_SETTINGS]
                }, {
                    type: Optional
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CheckboxWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
    }
}
CheckboxWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckboxWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
CheckboxWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CheckboxWidgetComponent, selector: "checkbox-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"field.className\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\">\n    <mat-checkbox\n        [id]=\"field.id\"\n        color=\"primary\"\n        [required]=\"isRequired()\"\n        [disabled]=\"field.readOnly || readOnly\"\n        [(ngModel)]=\"field.value\"\n        (ngModelChange)=\"onFieldChanged(field)\"\n        [matTooltip]=\"field.tooltip\"\n        (click)=\"markAsTouched()\"\n        matTooltipPosition=\"right\"\n        matTooltipShowDelay=\"1000\">\n        {{field.name | translate }}\n        <span class=\"adf-asterisk\" *ngIf=\"isRequired()\" >*</span>\n    </mat-checkbox>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i2$5.MatCheckboxRequiredValidator, selector: "mat-checkbox[required][formControlName],             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]" }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckboxWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'checkbox-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div [ngClass]=\"field.className\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\">\n    <mat-checkbox\n        [id]=\"field.id\"\n        color=\"primary\"\n        [required]=\"isRequired()\"\n        [disabled]=\"field.readOnly || readOnly\"\n        [(ngModel)]=\"field.value\"\n        (ngModelChange)=\"onFieldChanged(field)\"\n        [matTooltip]=\"field.tooltip\"\n        (click)=\"markAsTouched()\"\n        matTooltipPosition=\"right\"\n        matTooltipShowDelay=\"1000\">\n        {{field.name | translate }}\n        <span class=\"adf-asterisk\" *ngIf=\"isRequired()\" >*</span>\n    </mat-checkbox>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DateWidgetComponent extends WidgetComponent {
    constructor(formService, dateAdapter, userPreferencesService) {
        super(formService);
        this.formService = formService;
        this.dateAdapter = dateAdapter;
        this.userPreferencesService = userPreferencesService;
        this.DATE_FORMAT = 'DD-MM-YYYY';
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.userPreferencesService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => this.dateAdapter.setLocale(locale));
        const momentDateAdapter = this.dateAdapter;
        momentDateAdapter.overrideDisplayFormat = this.field.dateDisplayFormat;
        if (this.field) {
            if (this.field.minValue) {
                this.minDate = moment(this.field.minValue, this.DATE_FORMAT);
            }
            if (this.field.maxValue) {
                this.maxDate = moment(this.field.maxValue, this.DATE_FORMAT);
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    onDateChanged(newDateValue) {
        const date = moment(newDateValue, this.field.dateDisplayFormat, true);
        if (date.isValid()) {
            this.field.value = date.format(this.field.dateDisplayFormat);
        }
        else {
            this.field.value = newDateValue;
        }
        this.onFieldChanged(this.field);
    }
}
DateWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateWidgetComponent, deps: [{ token: FormService }, { token: i2$7.DateAdapter }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
DateWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DateWidgetComponent, selector: "date-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"{{field.className}}\" id=\"data-widget\" [class.adf-invalid]=\"!field.isValid && isTouched()\">\n    <mat-form-field class=\"adf-date-widget\" [hideRequiredMarker]=\"true\">\n        <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n        <input matInput\n               [id]=\"field.id\"\n               [value]=\"field.value\"\n               [required]=\"isRequired()\"\n               [disabled]=\"field.readOnly\"\n               (change)=\"onDateChanged($any($event).srcElement.value)\"\n               [placeholder]=\"field.placeholder\"\n               (blur)=\"markAsTouched()\">\n        <mat-datepicker-toggle  matSuffix [for]=\"datePicker\" [disabled]=\"field.readOnly\" ></mat-datepicker-toggle>\n    </mat-form-field>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n    <mat-datepicker #datePicker [touchUi]=\"true\" [startAt]=\"field.value | adfMomentDate: field.dateDisplayFormat\" [disabled]=\"field.readOnly\"></mat-datepicker>\n    <input\n        type=\"hidden\"\n        [matDatepicker]=\"datePicker\"\n        [value]=\"field.value | adfMomentDate: field.dateDisplayFormat\"\n        [min]=\"minDate\"\n        [max]=\"maxDate\"\n        [disabled]=\"field.readOnly\"\n        (dateInput)=\"onDateChanged($any($event).targetElement.value)\">\n</div>\n", styles: [".adf-date-widget .mat-form-field-suffix{top:26px}.adf-date-widget .mat-form-field-label-wrapper{top:20px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i5$2.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i5$2.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: MomentDatePipe, name: "adfMomentDate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'date-widget', providers: [
                        { provide: DateAdapter, useClass: MomentDateAdapter },
                        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
                    ], host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"{{field.className}}\" id=\"data-widget\" [class.adf-invalid]=\"!field.isValid && isTouched()\">\n    <mat-form-field class=\"adf-date-widget\" [hideRequiredMarker]=\"true\">\n        <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n        <input matInput\n               [id]=\"field.id\"\n               [value]=\"field.value\"\n               [required]=\"isRequired()\"\n               [disabled]=\"field.readOnly\"\n               (change)=\"onDateChanged($any($event).srcElement.value)\"\n               [placeholder]=\"field.placeholder\"\n               (blur)=\"markAsTouched()\">\n        <mat-datepicker-toggle  matSuffix [for]=\"datePicker\" [disabled]=\"field.readOnly\" ></mat-datepicker-toggle>\n    </mat-form-field>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n    <mat-datepicker #datePicker [touchUi]=\"true\" [startAt]=\"field.value | adfMomentDate: field.dateDisplayFormat\" [disabled]=\"field.readOnly\"></mat-datepicker>\n    <input\n        type=\"hidden\"\n        [matDatepicker]=\"datePicker\"\n        [value]=\"field.value | adfMomentDate: field.dateDisplayFormat\"\n        [min]=\"minDate\"\n        [max]=\"maxDate\"\n        [disabled]=\"field.readOnly\"\n        (dateInput)=\"onDateChanged($any($event).targetElement.value)\">\n</div>\n", styles: [".adf-date-widget .mat-form-field-suffix{top:26px}.adf-date-widget .mat-form-field-label-wrapper{top:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: i2$7.DateAdapter }, { type: UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DisplayTextWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
    }
}
DisplayTextWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DisplayTextWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
DisplayTextWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DisplayTextWidgetComponent, selector: "display-text-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\"\n    class=\"adf-display-text-widget {{field.className}}\">{{field.value | translate}}</div>\n", styles: [".adf-display-text-widget{white-space:pre-wrap}\n"], dependencies: [{ kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DisplayTextWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'display-text-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\"\n    class=\"adf-display-text-widget {{field.className}}\">{{field.value | translate}}</div>\n", styles: [".adf-display-text-widget{white-space:pre-wrap}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HyperlinkWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
        this.linkUrl = '#';
        this.linkText = null;
    }
    ngOnInit() {
        if (this.field) {
            this.linkUrl = this.getHyperlinkUrl(this.field);
            this.linkText = this.getHyperlinkText(this.field);
        }
    }
    getHyperlinkUrl(field) {
        let value = field.value || field.hyperlinkUrl;
        if (value && !/^https?:\/\//i.test(value)) {
            value = `${HyperlinkWidgetComponent.DEFAULT_HYPERLINK_SCHEME}${value}`;
        }
        return value || HyperlinkWidgetComponent.DEFAULT_HYPERLINK_URL;
    }
    getHyperlinkText(field) {
        if (field) {
            return field.displayText || field.hyperlinkUrl || field.value;
        }
        return null;
    }
}
HyperlinkWidgetComponent.DEFAULT_HYPERLINK_URL = '#';
HyperlinkWidgetComponent.DEFAULT_HYPERLINK_SCHEME = 'http://';
HyperlinkWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HyperlinkWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
HyperlinkWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: HyperlinkWidgetComponent, selector: "hyperlink-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-hyperlink-widget {{field.className}}\">\n    <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n    <div [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\">\n        <a [href]=\"linkUrl\" target=\"_blank\" rel=\"nofollow\">{{linkText}}</a>\n    </div>\n</div>\n", styles: [".adf-hyperlink-widget{padding:.4375em 0;border-top:.8438em solid transparent}.adf-hyperlink-widget a{color:var(--theme-primary-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HyperlinkWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hyperlink-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-hyperlink-widget {{field.className}}\">\n    <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n    <div [matTooltip]=\"field.tooltip\" matTooltipPosition=\"above\" matTooltipShowDelay=\"1000\">\n        <a [href]=\"linkUrl\" target=\"_blank\" rel=\"nofollow\">{{linkText}}</a>\n    </div>\n</div>\n", styles: [".adf-hyperlink-widget{padding:.4375em 0;border-top:.8438em solid transparent}.adf-hyperlink-widget a{color:var(--theme-primary-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultilineTextWidgetComponentComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
    }
}
MultilineTextWidgetComponentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MultilineTextWidgetComponentComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
MultilineTextWidgetComponentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: MultilineTextWidgetComponentComponent, selector: "multiline-text-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-multiline-text-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\">\n    <mat-form-field floatPlaceholder=\"never\" [hideRequiredMarker]=\"true\">\n        <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n        <textarea matInput class=\"adf-input\"\n                  [cdkTextareaAutosize]=\"true\"\n                  type=\"text\"\n                  rows=\"3\"\n                  [id]=\"field.id\"\n                  [required]=\"isRequired()\"\n                  [(ngModel)]=\"field.value\"\n                  (ngModelChange)=\"onFieldChanged(field)\"\n                  [disabled]=\"field.readOnly || readOnly\"\n                  [placeholder]=\"field.placeholder\"\n                  [matTooltip]=\"field.tooltip\"\n                  (blur)=\"markAsTouched()\"\n                  matTooltipPosition=\"above\"\n                  matTooltipShowDelay=\"1000\">\n        </textarea>\n    </mat-form-field>\n    <div *ngIf=\"field.maxLength > 0\" class=\"adf-multiline-word-counter\">\n        <span>{{field?.value?.length || 0}}/{{field.maxLength}}</span>\n    </div>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget class=\"adf-multiline-required-message\" *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\">\n    </error-widget>\n</div>\n\n", styles: [".adf-multiline-text-widget{width:100%}.adf-multiline-text-widget .mat-form-field-label-wrapper{top:20px}.adf-multiline-word-counter{float:right;margin-top:-20px!important;min-height:24px;min-width:1px;font-size:var(--theme-caption-font-size);line-height:14px;overflow:hidden;transition:all .3s cubic-bezier(.55,0,.55,.2);opacity:1;padding-top:5px;text-align:right;padding-right:2px;padding-left:0}.adf-multiline-required-message{display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.CdkTextareaAutosize, selector: "textarea[cdkTextareaAutosize]", inputs: ["cdkAutosizeMinRows", "cdkAutosizeMaxRows", "cdkTextareaAutosize", "placeholder"], exportAs: ["cdkTextareaAutosize"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MultilineTextWidgetComponentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'multiline-text-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-multiline-text-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\">\n    <mat-form-field floatPlaceholder=\"never\" [hideRequiredMarker]=\"true\">\n        <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n        <textarea matInput class=\"adf-input\"\n                  [cdkTextareaAutosize]=\"true\"\n                  type=\"text\"\n                  rows=\"3\"\n                  [id]=\"field.id\"\n                  [required]=\"isRequired()\"\n                  [(ngModel)]=\"field.value\"\n                  (ngModelChange)=\"onFieldChanged(field)\"\n                  [disabled]=\"field.readOnly || readOnly\"\n                  [placeholder]=\"field.placeholder\"\n                  [matTooltip]=\"field.tooltip\"\n                  (blur)=\"markAsTouched()\"\n                  matTooltipPosition=\"above\"\n                  matTooltipShowDelay=\"1000\">\n        </textarea>\n    </mat-form-field>\n    <div *ngIf=\"field.maxLength > 0\" class=\"adf-multiline-word-counter\">\n        <span>{{field?.value?.length || 0}}/{{field.maxLength}}</span>\n    </div>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n    <error-widget class=\"adf-multiline-required-message\" *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\">\n    </error-widget>\n</div>\n\n", styles: [".adf-multiline-text-widget{width:100%}.adf-multiline-text-widget .mat-form-field-label-wrapper{top:20px}.adf-multiline-word-counter{float:right;margin-top:-20px!important;min-height:24px;min-width:1px;font-size:var(--theme-caption-font-size);line-height:14px;overflow:hidden;transition:all .3s cubic-bezier(.55,0,.55,.2);opacity:1;padding-top:5px;text-align:right;padding-right:2px;padding-left:0}.adf-multiline-required-message{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NumberWidgetComponent extends WidgetComponent {
    constructor(formService, decimalNumberPipe) {
        super(formService);
        this.formService = formService;
        this.decimalNumberPipe = decimalNumberPipe;
    }
    ngOnInit() {
        if (this.field.readOnly) {
            this.displayValue = this.decimalNumberPipe.transform(this.field.value);
        }
        else {
            this.displayValue = this.field.value;
        }
    }
}
NumberWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NumberWidgetComponent, deps: [{ token: FormService }, { token: DecimalNumberPipe }], target: i0.ɵɵFactoryTarget.Component });
NumberWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NumberWidgetComponent, selector: "number-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-textfield adf-number-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n    <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n    </div>\n    <div>\n        <mat-form-field [hideRequiredMarker]=\"true\">\n            <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n            <input matInput\n                class=\"adf-input\"\n                type=\"text\"\n                pattern=\"-?[0-9]*(\\.[0-9]+)?\"\n                [id]=\"field.id\"\n                [required]=\"isRequired()\"\n                [value]=\"displayValue\"\n                [(ngModel)]=\"field.value\"\n                (ngModelChange)=\"onFieldChanged(field)\"\n                [disabled]=\"field.readOnly\"\n                [placeholder]=\"field.placeholder\"\n                [matTooltip]=\"field.tooltip\"\n                (blur)=\"markAsTouched()\"\n                matTooltipPosition=\"above\"\n                matTooltipShowDelay=\"1000\">\n        </mat-form-field>\n        <error-widget [error]=\"field.validationSummary\" ></error-widget>\n        <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n    </div>\n</div>\n", styles: [".adf-number-widget{width:100%}.adf-number-widget .mat-form-field-label-wrapper{top:20px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i7.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NumberWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'number-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-textfield adf-number-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n    <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n    </div>\n    <div>\n        <mat-form-field [hideRequiredMarker]=\"true\">\n            <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n            <input matInput\n                class=\"adf-input\"\n                type=\"text\"\n                pattern=\"-?[0-9]*(\\.[0-9]+)?\"\n                [id]=\"field.id\"\n                [required]=\"isRequired()\"\n                [value]=\"displayValue\"\n                [(ngModel)]=\"field.value\"\n                (ngModelChange)=\"onFieldChanged(field)\"\n                [disabled]=\"field.readOnly\"\n                [placeholder]=\"field.placeholder\"\n                [matTooltip]=\"field.tooltip\"\n                (blur)=\"markAsTouched()\"\n                matTooltipPosition=\"above\"\n                matTooltipShowDelay=\"1000\">\n        </mat-form-field>\n        <error-widget [error]=\"field.validationSummary\" ></error-widget>\n        <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n    </div>\n</div>\n", styles: [".adf-number-widget{width:100%}.adf-number-widget .mat-form-field-label-wrapper{top:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: DecimalNumberPipe }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputMaskDirective),
    multi: true
};
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class InputMaskDirective {
    constructor(el, render) {
        this.el = el;
        this.render = render;
        this.translationMask = {
            0: { pattern: /\d/ },
            9: { pattern: /\d/, optional: true },
            '#': { pattern: /\d/, recursive: true },
            A: { pattern: /[a-zA-Z0-9]/ },
            S: { pattern: /[a-zA-Z]/ }
        };
        this.byPassKeys = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91];
        this.invalidCharacters = [];
        this._onChange = (_) => {
        };
        this._onTouched = () => {
        };
    }
    onTextInput(event) {
        if (this.inputMask && this.inputMask.mask) {
            this.maskValue(this.el.nativeElement.value, this.el.nativeElement.selectionStart, this.inputMask.mask, this.inputMask.isReversed, event.keyCode);
        }
        else {
            this._onChange(this.el.nativeElement.value);
        }
    }
    ngOnChanges(changes) {
        if (changes['inputMask'] && changes['inputMask'].currentValue['mask']) {
            this.inputMask = changes['inputMask'].currentValue;
        }
    }
    writeValue(value) {
        this.el.nativeElement.value = value;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    maskValue(actualValue, startCaret, maskToApply, isMaskReversed, keyCode) {
        if (this.byPassKeys.indexOf(keyCode) === -1) {
            const value = this.getMasked(false, actualValue, maskToApply, isMaskReversed);
            const calculatedCaret = this.calculateCaretPosition(startCaret, actualValue, keyCode);
            this.render.setAttribute(this.el.nativeElement, 'value', value);
            this.el.nativeElement.value = value;
            this.setValue(value);
            this._onChange(value);
            this.setCaretPosition(calculatedCaret);
        }
    }
    setCaretPosition(caretPosition) {
        this.el.nativeElement.moveStart = caretPosition;
        this.el.nativeElement.moveEnd = caretPosition;
    }
    calculateCaretPosition(caretPosition, newValue, keyCode) {
        const newValueLength = newValue.length;
        const oldValue = this.getValue() || '';
        const oldValueLength = oldValue.length;
        if (keyCode === 8 && oldValue !== newValue) {
            caretPosition = caretPosition - (newValue.slice(0, caretPosition).length - oldValue.slice(0, caretPosition).length);
        }
        else if (oldValue !== newValue) {
            if (caretPosition >= oldValueLength) {
                caretPosition = newValueLength;
            }
            else {
                caretPosition = caretPosition + (newValue.slice(0, caretPosition).length - oldValue.slice(0, caretPosition).length);
            }
        }
        return caretPosition;
    }
    getMasked(skipMaskChars, val, mask, isReversed = false) {
        const buf = [];
        const value = val;
        let maskIndex = 0;
        const maskLen = mask.length;
        let valueIndex = 0;
        const valueLength = value.length;
        let offset = 1;
        let addMethod = 'push';
        let resetPos = -1;
        let lastMaskChar;
        let lastUntranslatedMaskChar;
        let check;
        if (isReversed) {
            addMethod = 'unshift';
            offset = -1;
            lastMaskChar = 0;
            maskIndex = maskLen - 1;
            valueIndex = valueLength - 1;
        }
        else {
            lastMaskChar = maskLen - 1;
        }
        check = this.isToCheck(isReversed, maskIndex, maskLen, valueIndex, valueLength);
        while (check) {
            const maskDigit = mask.charAt(maskIndex);
            const valDigit = value.charAt(valueIndex);
            const translation = this.translationMask[maskDigit];
            if (translation) {
                if (valDigit.match(translation.pattern)) {
                    buf[addMethod](valDigit);
                    if (translation.recursive) {
                        if (resetPos === -1) {
                            resetPos = maskIndex;
                        }
                        else if (maskIndex === lastMaskChar) {
                            maskIndex = resetPos - offset;
                        }
                        if (lastMaskChar === resetPos) {
                            maskIndex -= offset;
                        }
                    }
                    maskIndex += offset;
                }
                else if (valDigit === lastUntranslatedMaskChar) {
                    lastUntranslatedMaskChar = undefined;
                }
                else if (translation.optional) {
                    maskIndex += offset;
                    valueIndex -= offset;
                }
                else {
                    this.invalidCharacters.push({
                        index: valueIndex,
                        digit: valDigit,
                        translated: translation.pattern
                    });
                }
                valueIndex += offset;
            }
            else {
                if (!skipMaskChars) {
                    buf[addMethod](maskDigit);
                }
                if (valDigit === maskDigit) {
                    valueIndex += offset;
                }
                else {
                    lastUntranslatedMaskChar = maskDigit;
                }
                maskIndex += offset;
            }
            check = this.isToCheck(isReversed, maskIndex, maskLen, valueIndex, valueLength);
        }
        const lastMaskCharDigit = mask.charAt(lastMaskChar);
        if (maskLen === valueLength + 1 && !this.translationMask[lastMaskCharDigit]) {
            buf.push(lastMaskCharDigit);
        }
        return buf.join('');
    }
    isToCheck(isReversed, maskIndex, maskLen, valueIndex, valueLength) {
        let check = false;
        if (isReversed) {
            check = (maskIndex > -1) && (valueIndex > -1);
        }
        else {
            check = (maskIndex < maskLen) && (valueIndex < valueLength);
        }
        return check;
    }
    setValue(value) {
        this.value = value;
    }
    getValue() {
        return this.value;
    }
}
InputMaskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InputMaskDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
InputMaskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InputMaskDirective, selector: "[adf-text-mask], [textMask]", inputs: { inputMask: ["textMask", "inputMask"] }, host: { listeners: { "input": "onTextInput($event)", "keyup": "onTextInput($event)" } }, providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-text-mask], [textMask]',
                    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { inputMask: [{
                type: Input,
                args: ['textMask']
            }], onTextInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }, {
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TextWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
        this.formService = formService;
    }
    ngOnInit() {
        if (this.field.params) {
            this.mask = this.field.params['inputMask'];
            this.placeholder = this.field.params['inputMask'] && this.field.params['inputMaskPlaceholder'] ? this.field.params['inputMaskPlaceholder'] : this.field.placeholder;
            this.isMaskReversed = this.field.params['inputMaskReversed'] ? this.field.params['inputMaskReversed'] : false;
        }
    }
}
TextWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TextWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
TextWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TextWidgetComponent, selector: "text-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-textfield adf-text-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n     <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n     </div>\n     <div>\n         <mat-form-field [hideRequiredMarker]=\"true\">\n             <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n             <input matInput\n                    class=\"adf-input\"\n                    type=\"text\"\n                    [id]=\"field.id\"\n                    [required]=\"isRequired()\"\n                    [value]=\"field.value\"\n                    [(ngModel)]=\"field.value\"\n                    (ngModelChange)=\"onFieldChanged(field)\"\n                    [disabled]=\"field.readOnly || readOnly\"\n                    [textMask]=\"{mask: mask, isReversed: isMaskReversed}\"\n                    [placeholder]=\"placeholder\"\n                    [matTooltip]=\"field.tooltip\"\n                    (blur)=\"markAsTouched()\"\n                     matTooltipPosition=\"above\"\n                     matTooltipShowDelay=\"1000\">\n         </mat-form-field>\n         <error-widget [error]=\"field.validationSummary\"></error-widget>\n         <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n     </div>\n </div>\n", styles: [".adf-text-widget{width:100%}.adf-text-widget .mat-form-field-label-wrapper{top:20px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "directive", type: InputMaskDirective, selector: "[adf-text-mask], [textMask]", inputs: ["textMask"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TextWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'text-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-textfield adf-text-widget {{field.className}}\"\n     [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-readonly]=\"field.readOnly\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n     <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n     </div>\n     <div>\n         <mat-form-field [hideRequiredMarker]=\"true\">\n             <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n             <input matInput\n                    class=\"adf-input\"\n                    type=\"text\"\n                    [id]=\"field.id\"\n                    [required]=\"isRequired()\"\n                    [value]=\"field.value\"\n                    [(ngModel)]=\"field.value\"\n                    (ngModelChange)=\"onFieldChanged(field)\"\n                    [disabled]=\"field.readOnly || readOnly\"\n                    [textMask]=\"{mask: mask, isReversed: isMaskReversed}\"\n                    [placeholder]=\"placeholder\"\n                    [matTooltip]=\"field.tooltip\"\n                    (blur)=\"markAsTouched()\"\n                     matTooltipPosition=\"above\"\n                     matTooltipShowDelay=\"1000\">\n         </mat-form-field>\n         <error-widget [error]=\"field.validationSummary\"></error-widget>\n         <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n     </div>\n </div>\n", styles: [".adf-text-widget{width:100%}.adf-text-widget .mat-form-field-label-wrapper{top:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DateTimeWidgetComponent extends WidgetComponent {
    constructor(formService, dateAdapter, userPreferencesService) {
        super(formService);
        this.formService = formService;
        this.dateAdapter = dateAdapter;
        this.userPreferencesService = userPreferencesService;
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.userPreferencesService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => this.dateAdapter.setLocale(locale));
        const momentDateAdapter = this.dateAdapter;
        momentDateAdapter.overrideDisplayFormat = this.field.dateDisplayFormat;
        if (this.field) {
            if (this.field.minValue) {
                this.minDate = moment.utc(this.field.minValue, 'YYYY-MM-DDTHH:mm:ssZ');
            }
            if (this.field.maxValue) {
                this.maxDate = moment.utc(this.field.maxValue, 'YYYY-MM-DDTHH:mm:ssZ');
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    onDateChanged(newDateValue) {
        const date = moment(newDateValue, this.field.dateDisplayFormat, true);
        if (date.isValid()) {
            this.field.value = moment(date).utc().local().format(this.field.dateDisplayFormat);
        }
        else {
            this.field.value = newDateValue;
        }
        this.onFieldChanged(this.field);
    }
}
DateTimeWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateTimeWidgetComponent, deps: [{ token: FormService }, { token: i2$7.DateAdapter }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
DateTimeWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DateTimeWidgetComponent, selector: "date-time-widget", providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"{{field.className}}\" id=\"data-time-widget\" [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n    <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n     </div>\n    <div>\n        <mat-form-field class=\"adf-date-time-widget\" [class.adf-left-label-input-datepicker]=\"field.leftLabels\" [hideRequiredMarker]=\"true\">\n            <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n            <input matInput\n                   [id]=\"field.id\"\n                   [value]=\"field.value\"\n                   [required]=\"isRequired()\"\n                   [disabled]=\"field.readOnly\"\n                   (change)=\"onDateChanged($any($event).srcElement.value)\"\n                   [placeholder]=\"field.placeholder\"\n                   [matTooltip]=\"field.tooltip\"\n                   (blur)=\"markAsTouched()\"\n                   matTooltipPosition=\"above\"\n                   matTooltipShowDelay=\"1000\"\n                   (focus)=\"datetimePicker.open()\">\n            <mat-datetimepicker-toggle matSuffix [for]=\"datetimePicker\" [disabled]=\"field.readOnly\"></mat-datetimepicker-toggle>\n        </mat-form-field>\n        <error-widget [error]=\"field.validationSummary\"></error-widget>\n        <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n        <mat-datetimepicker #datetimePicker type=\"datetime\" [touchUi]=\"true\" [timeInterval]=\"5\" [disabled]=\"field.readOnly\"></mat-datetimepicker>\n        <input\n            type=\"hidden\"\n            [matDatetimepicker]=\"datetimePicker\"\n            [value]=\"field.value | adfMomentDate: field.dateDisplayFormat\"\n            [min]=\"minDate\"\n            [max]=\"maxDate\"\n            [disabled]=\"field.readOnly\"\n            (dateInput)=\"onDateChanged($any($event).targetElement.value)\">\n    </div>\n</div>\n", styles: [".adf-date-time-widget .mat-form-field-suffix{top:26px}.adf-date-time-widget .mat-form-field-label-wrapper{top:20px}.adf-left-label-input-datepicker .mat-form-field-suffix{top:0}.adf-left-label-input-datepicker .mat-form-field-infix{width:100%}.mat-datetimepicker-toggle{color:var(--adf-theme-foreground-icon-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i11$1.MatDatetimepickerComponent, selector: "mat-datetimepicker", inputs: ["multiYearSelector", "twelvehour", "startView", "mode", "timeInterval", "ariaNextMonthLabel", "ariaPrevMonthLabel", "ariaNextYearLabel", "ariaPrevYearLabel", "preventSameDateTimeSelection", "panelClass", "startAt", "openOnFocus", "type", "touchUi", "disabled"], outputs: ["selectedChanged", "opened", "closed", "viewChanged"], exportAs: ["matDatetimepicker"] }, { kind: "component", type: i11$1.MatDatetimepickerToggleComponent, selector: "mat-datetimepicker-toggle", inputs: ["for", "disabled"], exportAs: ["matDatetimepickerToggle"] }, { kind: "directive", type: i11$1.MatDatetimepickerInputDirective, selector: "input[matDatetimepicker]", inputs: ["matDatetimepicker", "matDatepickerFilter", "value", "min", "max", "disabled"], outputs: ["dateChange", "dateInput"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: MomentDatePipe, name: "adfMomentDate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DateTimeWidgetComponent, decorators: [{
            type: Component,
            args: [{ providers: [
                        { provide: DateAdapter, useClass: MomentDateAdapter },
                        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
                        { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
                        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
                    ], selector: 'date-time-widget', encapsulation: ViewEncapsulation.None, template: "<div class=\"{{field.className}}\" id=\"data-time-widget\" [class.adf-invalid]=\"!field.isValid && isTouched()\" [class.adf-left-label-input-container]=\"field.leftLabels\">\n    <div *ngIf=\"field.leftLabels\">\n        <label class=\"adf-label adf-left-label\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n     </div>\n    <div>\n        <mat-form-field class=\"adf-date-time-widget\" [class.adf-left-label-input-datepicker]=\"field.leftLabels\" [hideRequiredMarker]=\"true\">\n            <label class=\"adf-label\" *ngIf=\"!field.leftLabels\" [attr.for]=\"field.id\">{{field.name | translate }} ({{field.dateDisplayFormat}})<span class=\"adf-asterisk\" *ngIf=\"isRequired()\">*</span></label>\n            <input matInput\n                   [id]=\"field.id\"\n                   [value]=\"field.value\"\n                   [required]=\"isRequired()\"\n                   [disabled]=\"field.readOnly\"\n                   (change)=\"onDateChanged($any($event).srcElement.value)\"\n                   [placeholder]=\"field.placeholder\"\n                   [matTooltip]=\"field.tooltip\"\n                   (blur)=\"markAsTouched()\"\n                   matTooltipPosition=\"above\"\n                   matTooltipShowDelay=\"1000\"\n                   (focus)=\"datetimePicker.open()\">\n            <mat-datetimepicker-toggle matSuffix [for]=\"datetimePicker\" [disabled]=\"field.readOnly\"></mat-datetimepicker-toggle>\n        </mat-form-field>\n        <error-widget [error]=\"field.validationSummary\"></error-widget>\n        <error-widget *ngIf=\"isInvalidFieldRequired() && isTouched()\" required=\"{{ 'FORM.FIELD.REQUIRED' | translate }}\"></error-widget>\n        <mat-datetimepicker #datetimePicker type=\"datetime\" [touchUi]=\"true\" [timeInterval]=\"5\" [disabled]=\"field.readOnly\"></mat-datetimepicker>\n        <input\n            type=\"hidden\"\n            [matDatetimepicker]=\"datetimePicker\"\n            [value]=\"field.value | adfMomentDate: field.dateDisplayFormat\"\n            [min]=\"minDate\"\n            [max]=\"maxDate\"\n            [disabled]=\"field.readOnly\"\n            (dateInput)=\"onDateChanged($any($event).targetElement.value)\">\n    </div>\n</div>\n", styles: [".adf-date-time-widget .mat-form-field-suffix{top:26px}.adf-date-time-widget .mat-form-field-label-wrapper{top:20px}.adf-left-label-input-datepicker .mat-form-field-suffix{top:0}.adf-left-label-input-datepicker .mat-form-field-infix{width:100%}.mat-datetimepicker-toggle{color:var(--adf-theme-foreground-icon-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: i2$7.DateAdapter }, { type: UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JsonWidgetComponent extends WidgetComponent {
    constructor(formService, dialog) {
        super(formService);
        this.formService = formService;
        this.dialog = dialog;
    }
    view() {
        const rawValue = this.field.value;
        const value = typeof rawValue === 'object'
            ? JSON.stringify(rawValue || {}, null, 2)
            : rawValue;
        const settings = {
            title: this.field.name,
            editable: false,
            value
        };
        this.dialog
            .open(EditJsonDialogComponent, {
            data: settings,
            minWidth: '50%',
            minHeight: '50%'
        });
    }
}
JsonWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JsonWidgetComponent, deps: [{ token: FormService }, { token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
JsonWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: JsonWidgetComponent, selector: "ng-component", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: `
        <button mat-raised-button color="primary" (click)="view()">json</button>
    `, isInline: true, dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: JsonWidgetComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
        <button mat-raised-button color="primary" (click)="view()">json</button>
    `,
                    host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    },
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: i1$4.MatDialog }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @angular-eslint/component-selector */
class BaseViewerWidgetComponent extends WidgetComponent {
    constructor(formService) {
        super(formService);
    }
    ngOnInit() {
        if (this.field &&
            this.field.value &&
            Array.isArray(this.field.value) &&
            this.field.value.length) {
            const file = this.field.value[0];
            this.field.value = file.id;
        }
    }
}
BaseViewerWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseViewerWidgetComponent, deps: [{ token: FormService }], target: i0.ɵɵFactoryTarget.Component });
BaseViewerWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: BaseViewerWidgetComponent, selector: "base-viewer-widget", host: { listeners: { "click": "event($event)", "blur": "event($event)", "change": "event($event)", "focus": "event($event)", "focusin": "event($event)", "focusout": "event($event)", "input": "event($event)", "invalid": "event($event)", "select": "event($event)" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"adf-base-viewer-widget {{field.className}}\" [class.adf-invalid]=\"!field.isValid\"\n    [class.adf-readonly]=\"field.readOnly\">\n    <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n    <adf-viewer [urlFile]=\"field.value.urlFile\" [blobFile]=\"field.value.blobFile\" [fileName]=\"field.value.fileName\" [showViewer]=\"field.value?.blobFile || field.value?.urlFile\" [allowGoBack]=\"false\"></adf-viewer>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n</div>\n", styles: ["base-viewer-widget{height:100%;width:100%}base-viewer-widget .adf-base-viewer-widget{height:100%;width:100%}base-viewer-widget .adf-base-viewer-widget adf-viewer.adf-viewer{position:relative}base-viewer-widget .adf-base-viewer-widget adf-viewer.adf-viewer .adf-viewer-container .adf-viewer-content>div{height:90vh}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ViewerComponent, selector: "adf-viewer", inputs: ["urlFile", "blobFile", "fileName", "showViewer", "allowGoBack", "allowFullScreen", "showToolbar", "overlayMode", "allowNavigate", "canNavigateBefore", "canNavigateNext", "allowLeftSidebar", "allowRightSidebar", "showRightSidebar", "showLeftSidebar", "sidebarRightTemplate", "sidebarLeftTemplate", "readOnly", "tracks", "mimeType", "sidebarRightTemplateContext", "sidebarLeftTemplateContext"], outputs: ["downloadFile", "navigateBefore", "navigateNext", "showViewerChange", "submitFile"] }, { kind: "component", type: ErrorWidgetComponent, selector: "error-widget", inputs: ["error", "required"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseViewerWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'base-viewer-widget', host: {
                        '(click)': 'event($event)',
                        '(blur)': 'event($event)',
                        '(change)': 'event($event)',
                        '(focus)': 'event($event)',
                        '(focusin)': 'event($event)',
                        '(focusout)': 'event($event)',
                        '(input)': 'event($event)',
                        '(invalid)': 'event($event)',
                        '(select)': 'event($event)'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-base-viewer-widget {{field.className}}\" [class.adf-invalid]=\"!field.isValid\"\n    [class.adf-readonly]=\"field.readOnly\">\n    <label class=\"adf-label\" [attr.for]=\"field.id\">{{field.name | translate }}<span class=\"adf-asterisk\"\n            *ngIf=\"isRequired()\">*</span></label>\n    <adf-viewer [urlFile]=\"field.value.urlFile\" [blobFile]=\"field.value.blobFile\" [fileName]=\"field.value.fileName\" [showViewer]=\"field.value?.blobFile || field.value?.urlFile\" [allowGoBack]=\"false\"></adf-viewer>\n    <error-widget [error]=\"field.validationSummary\"></error-widget>\n</div>\n", styles: ["base-viewer-widget{height:100%;width:100%}base-viewer-widget .adf-base-viewer-widget{height:100%;width:100%}base-viewer-widget .adf-base-viewer-widget adf-viewer.adf-viewer{position:relative}base-viewer-widget .adf-base-viewer-widget adf-viewer.adf-viewer .adf-viewer-container .adf-viewer-content>div{height:90vh}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WIDGET_DIRECTIVES = [
    UnknownWidgetComponent,
    TextWidgetComponent,
    NumberWidgetComponent,
    CheckboxWidgetComponent,
    MultilineTextWidgetComponentComponent,
    HyperlinkWidgetComponent,
    DisplayTextWidgetComponent,
    DateWidgetComponent,
    AmountWidgetComponent,
    ErrorWidgetComponent,
    DateTimeWidgetComponent,
    JsonWidgetComponent,
    BaseViewerWidgetComponent
];
const MASK_DIRECTIVE = [
    InputMaskDirective
];

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable id-blacklist */
class FormRenderingService extends DynamicComponentMapper {
    constructor() {
        super(...arguments);
        this.defaultValue = UnknownWidgetComponent;
        this.types = {
            [FormFieldTypes.TEXT]: DynamicComponentResolver.fromType(TextWidgetComponent),
            [FormFieldTypes.STRING]: DynamicComponentResolver.fromType(TextWidgetComponent),
            [FormFieldTypes.INTEGER]: DynamicComponentResolver.fromType(NumberWidgetComponent),
            [FormFieldTypes.MULTILINE_TEXT]: DynamicComponentResolver.fromType(MultilineTextWidgetComponentComponent),
            [FormFieldTypes.BOOLEAN]: DynamicComponentResolver.fromType(CheckboxWidgetComponent),
            [FormFieldTypes.DATE]: DynamicComponentResolver.fromType(DateWidgetComponent),
            [FormFieldTypes.AMOUNT]: DynamicComponentResolver.fromType(AmountWidgetComponent),
            [FormFieldTypes.HYPERLINK]: DynamicComponentResolver.fromType(HyperlinkWidgetComponent),
            [FormFieldTypes.READONLY_TEXT]: DynamicComponentResolver.fromType(DisplayTextWidgetComponent),
            [FormFieldTypes.JSON]: DynamicComponentResolver.fromType(JsonWidgetComponent),
            [FormFieldTypes.DISPLAY_VALUE]: DynamicComponentResolver.fromType(TextWidgetComponent),
            [FormFieldTypes.DATETIME]: DynamicComponentResolver.fromType(DateTimeWidgetComponent),
            [FormFieldTypes.VIEWER]: DynamicComponentResolver.fromType(BaseViewerWidgetComponent)
        };
    }
}
FormRenderingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormRenderingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
FormRenderingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormRenderingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormRenderingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class WidgetVisibilityService {
    constructor(logService) {
        this.logService = logService;
    }
    refreshVisibility(form, processVarList) {
        this.form = form;
        if (processVarList) {
            this.processVarList = processVarList;
        }
        if (form && form.tabs && form.tabs.length > 0) {
            form.tabs.map((tabModel) => this.refreshEntityVisibility(tabModel));
        }
        if (form && form.outcomes && form.outcomes.length > 0) {
            form.outcomes.map((outcomeModel) => this.refreshOutcomeVisibility(outcomeModel));
        }
        if (form) {
            form.getFormFields().map((field) => this.refreshEntityVisibility(field));
        }
    }
    refreshEntityVisibility(element) {
        element.isVisible = this.isParentTabVisible(this.form, element) && this.evaluateVisibility(element.form, element.visibilityCondition);
    }
    refreshOutcomeVisibility(element) {
        element.isVisible = this.evaluateVisibility(element.form, element.visibilityCondition);
    }
    evaluateVisibility(form, visibilityObj) {
        const isLeftFieldPresent = visibilityObj && (visibilityObj.leftType || visibilityObj.leftValue);
        if (!isLeftFieldPresent || isLeftFieldPresent === 'null') {
            return true;
        }
        else {
            return this.isFieldVisible(form, visibilityObj);
        }
    }
    isFieldVisible(form, visibilityObj, accumulator = [], result = false) {
        const leftValue = this.getLeftValue(form, visibilityObj);
        const rightValue = this.getRightValue(form, visibilityObj);
        const actualResult = this.evaluateCondition(leftValue, rightValue, visibilityObj.operator);
        accumulator.push({ value: actualResult, operator: visibilityObj.nextConditionOperator });
        if (this.isValidCondition(visibilityObj.nextCondition)) {
            result = this.isFieldVisible(form, visibilityObj.nextCondition, accumulator);
        }
        else if (accumulator[0] !== undefined) {
            result = Function('"use strict";return (' +
                accumulator.map((expression) => this.transformToLiteralExpression(expression)).join('') +
                ')')();
        }
        else {
            result = actualResult;
        }
        return !!result;
    }
    transformToLiteralExpression(currentExpression) {
        const currentTransformedValue = !!currentExpression.value ? 'true' : 'false';
        return currentTransformedValue.concat(this.transformToLiteralOperator(currentExpression.operator));
    }
    transformToLiteralOperator(currentOperator) {
        switch (currentOperator) {
            case 'and':
                return '&&';
            case 'or':
                return '||';
            case 'and-not':
                return '&& !';
            case 'or-not':
                return '|| !';
            default:
                return '';
        }
    }
    getLeftValue(form, visibilityObj) {
        let leftValue = '';
        if (visibilityObj.leftType && visibilityObj.leftType === WidgetTypeEnum.variable) {
            leftValue = this.getVariableValue(form, visibilityObj.leftValue, this.processVarList);
        }
        else if (visibilityObj.leftType && visibilityObj.leftType === WidgetTypeEnum.field) {
            leftValue = this.getFormValue(form, visibilityObj.leftValue);
            if (leftValue === undefined || leftValue === '') {
                const variableValue = this.getVariableValue(form, visibilityObj.leftValue, this.processVarList);
                leftValue = !this.isInvalidValue(variableValue) ? variableValue : leftValue;
            }
        }
        return leftValue;
    }
    getRightValue(form, visibilityObj) {
        let valueFound = '';
        if (visibilityObj.rightType === WidgetTypeEnum.variable) {
            valueFound = this.getVariableValue(form, visibilityObj.rightValue, this.processVarList);
        }
        else if (visibilityObj.rightType === WidgetTypeEnum.field) {
            valueFound = this.getFormValue(form, visibilityObj.rightValue);
        }
        else {
            if (moment(visibilityObj.rightValue, 'YYYY-MM-DD', true).isValid()) {
                valueFound = visibilityObj.rightValue + 'T00:00:00.000Z';
            }
            else {
                valueFound = visibilityObj.rightValue;
            }
        }
        return valueFound;
    }
    getFormValue(form, fieldId) {
        const formField = this.getFormFieldById(form, fieldId);
        let value;
        if (this.isFormFieldValid(formField)) {
            value = this.getFieldValue(form.values, fieldId);
            if (this.isInvalidValue(value)) {
                value = this.searchValueInForm(formField, fieldId);
            }
        }
        return value;
    }
    isFormFieldValid(formField) {
        return formField && formField.isValid;
    }
    getFieldValue(valueList, fieldId) {
        let labelFilterByName;
        let valueFound;
        if (fieldId && fieldId.indexOf('_LABEL') > 0) {
            labelFilterByName = fieldId.substring(0, fieldId.length - 6);
            if (valueList[labelFilterByName]) {
                if (Array.isArray(valueList[labelFilterByName])) {
                    valueFound = valueList[labelFilterByName].map(({ name }) => name);
                }
                else {
                    valueFound = valueList[labelFilterByName].name;
                }
            }
        }
        else if (valueList[fieldId] && valueList[fieldId].id) {
            valueFound = valueList[fieldId].id;
        }
        else if (valueList[fieldId] && Array.isArray(valueList[fieldId])) {
            valueFound = valueList[fieldId].map(({ id }) => id);
        }
        else {
            valueFound = valueList[fieldId];
        }
        return valueFound;
    }
    isInvalidValue(value) {
        return value === undefined || value === null;
    }
    getFormFieldById(form, fieldId) {
        return form.getFormFields().find((formField) => this.isSearchedField(formField, fieldId));
    }
    searchValueInForm(formField, fieldId) {
        let fieldValue = '';
        if (formField) {
            fieldValue = this.getObjectValue(formField, fieldId);
            if (!fieldValue) {
                if (formField.value && formField.value.id) {
                    fieldValue = formField.value.id;
                }
                else if (!this.isInvalidValue(formField.value)) {
                    fieldValue = formField.value;
                }
            }
        }
        return fieldValue;
    }
    isParentTabVisible(form, currentFormField) {
        const containers = this.getFormTabContainers(form);
        let isVisible = true;
        containers.map((container) => {
            if (!!this.getCurrentFieldFromTabById(container, currentFormField.id)) {
                const currentTab = form.tabs.find((tab) => tab.id === container.tab);
                if (!!currentTab) {
                    isVisible = currentTab.isVisible;
                }
            }
        });
        return isVisible;
    }
    getCurrentFieldFromTabById(container, fieldId) {
        const tabFields = Object.keys(container.field.fields).map(key => container.field.fields[key]);
        let currentField;
        for (const tabField of tabFields) {
            currentField = tabField.find((tab) => tab.id === fieldId);
            if (currentField) {
                return currentField;
            }
        }
        return null;
    }
    getFormTabContainers(form) {
        if (!!form) {
            return form.fields.filter(field => field.type === 'container' && field.tab);
        }
        return [];
    }
    getObjectValue(field, fieldId) {
        let value = '';
        if (field.value && field.value.name) {
            value = field.value.name;
        }
        else if (field.options) {
            const option = field.options.find((opt) => opt.id === field.value);
            if (option) {
                value = this.getValueFromOption(fieldId, option);
            }
        }
        return value;
    }
    getValueFromOption(fieldId, option) {
        let optionValue = '';
        if (fieldId && fieldId.indexOf('_LABEL') > 0) {
            optionValue = option.name;
        }
        else {
            optionValue = option.id;
        }
        return optionValue;
    }
    isSearchedField(field, fieldId) {
        const fieldToFind = fieldId?.indexOf('_LABEL') > 0 ? fieldId.replace('_LABEL', '') : fieldId;
        return (field.id && fieldToFind) ? field.id.toUpperCase() === fieldToFind.toUpperCase() : false;
    }
    getVariableValue(form, name, processVarList) {
        const processVariableValue = this.getProcessVariableValue(name, processVarList);
        const variableDefaultValue = form.getDefaultFormVariableValue(name);
        return (processVariableValue === undefined) ? variableDefaultValue : processVariableValue;
    }
    getProcessVariableValue(name, processVarList) {
        if (processVarList) {
            const processVariable = processVarList.find(variable => variable.id === name ||
                variable.id === `variables.${name}`);
            if (processVariable) {
                return processVariable.value;
            }
        }
        return undefined;
    }
    evaluateCondition(leftValue, rightValue, operator) {
        switch (operator) {
            case '==':
                return leftValue + '' === rightValue + '';
            case '<':
                return leftValue < rightValue;
            case '!=':
                return leftValue + '' !== rightValue + '';
            case '>':
                return leftValue > rightValue;
            case '>=':
                return leftValue >= rightValue;
            case '<=':
                return leftValue <= rightValue;
            case 'empty':
                return leftValue ? leftValue === '' : true;
            case '!empty':
                return leftValue ? leftValue !== '' : false;
            case 'contains':
                return this.contains(leftValue, rightValue);
            case '!contains':
                return !this.contains(leftValue, rightValue);
            default:
                this.logService.error(`Invalid operator: ${operator}`);
                return undefined;
        }
    }
    contains(leftValue, rightValue) {
        return Array.isArray(leftValue) && Array.isArray(rightValue) && rightValue.every((element) => leftValue.includes(element));
    }
    cleanProcessVariable() {
        this.processVarList = [];
    }
    isValidCondition(condition) {
        return !!(condition && condition.operator);
    }
}
WidgetVisibilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WidgetVisibilityService, deps: [{ token: LogService }], target: i0.ɵɵFactoryTarget.Injectable });
WidgetVisibilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WidgetVisibilityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WidgetVisibilityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormFieldComponent {
    constructor(formRenderingService, componentFactoryResolver, visibilityService, compiler) {
        this.formRenderingService = formRenderingService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.visibilityService = visibilityService;
        this.compiler = compiler;
        /** Contains all the necessary data needed to determine what UI Widget
         * to use when rendering the field in the form. You would typically not
         * create this data manually but instead create the form in APS and export
         * it to get to all the `FormFieldModel` definitions.
         */
        this.field = null;
        this.focus = false;
    }
    ngOnInit() {
        const w = window;
        if (w.adf === undefined) {
            w.adf = {};
        }
        const originalField = this.getField();
        if (originalField) {
            const customTemplate = this.field.form.customFieldTemplates[originalField.type];
            if (customTemplate && this.hasController(originalField.type)) {
                const factory = this.getComponentFactorySync(originalField.type, customTemplate);
                this.componentRef = this.container.createComponent(factory);
                const instance = this.componentRef.instance;
                if (instance) {
                    instance.field = originalField;
                }
            }
            else {
                const componentType = this.formRenderingService.resolveComponentType(originalField);
                if (componentType) {
                    const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
                    this.componentRef = this.container.createComponent(factory);
                    const instance = this.componentRef.instance;
                    instance.field = this.field;
                    instance.fieldChanged.subscribe((field) => {
                        if (field && this.field.form) {
                            this.visibilityService.refreshVisibility(field.form);
                            field.form.onFormFieldChanged(field);
                        }
                    });
                }
            }
        }
    }
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }
    getField() {
        if (this.field && this.field.params) {
            const wrappedField = this.field.params.field;
            if (wrappedField && wrappedField.type) {
                return wrappedField;
            }
        }
        return this.field;
    }
    hasController(type) {
        return (adf && adf.components && adf.components[type]);
    }
    getComponentFactorySync(type, template) {
        const componentInfo = adf.components[type];
        if (componentInfo.factory) {
            return componentInfo.factory;
        }
        const metadata = {
            selector: `runtime-component-${type}`,
            template
        };
        const factory = this.createComponentFactorySync(this.compiler, metadata, componentInfo.class);
        componentInfo.factory = factory;
        return factory;
    }
    createComponentFactorySync(compiler, metadata, componentClass) {
        const cmpClass = componentClass || class RuntimeComponent {
        };
        const decoratedCmp = Component(metadata)(cmpClass);
        const moduleClass = class RuntimeComponentModule {
        };
        const decoratedNgModule = NgModule({ imports: [], declarations: [decoratedCmp] })(moduleClass);
        const module = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
        return module.componentFactories.find((x) => x.componentType === decoratedCmp);
    }
    focusToggle() {
        setTimeout(() => {
            this.focus = !this.focus;
        });
    }
}
FormFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormFieldComponent, deps: [{ token: FormRenderingService }, { token: i0.ComponentFactoryResolver }, { token: WidgetVisibilityService }, { token: i0.Compiler }], target: i0.ɵɵFactoryTarget.Component });
FormFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FormFieldComponent, selector: "adf-form-field", inputs: { field: "field" }, viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `
        <div [id]="'field-'+field?.id+'-container'"
            [style.visibility]="!field?.isVisible ? 'hidden' : 'visible'"
            [style.display]="!field?.isVisible ? 'none' : 'block'"
            [class.adf-focus]="focus"
            (focusin)="focusToggle()"
            (focusout)="focusToggle()">
            <div #container></div>
        </div>
    `, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-form-field',
                    template: `
        <div [id]="'field-'+field?.id+'-container'"
            [style.visibility]="!field?.isVisible ? 'hidden' : 'visible'"
            [style.display]="!field?.isVisible ? 'none' : 'block'"
            [class.adf-focus]="focus"
            (focusin)="focusToggle()"
            (focusout)="focusToggle()">
            <div #container></div>
        </div>
    `,
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: FormRenderingService }, { type: i0.ComponentFactoryResolver }, { type: WidgetVisibilityService }, { type: i0.Compiler }]; }, propDecorators: { container: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }], field: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class FormBaseComponent {
    constructor() {
        /** Toggle rendering of the form title. */
        this.showTitle = true;
        /** Toggle rendering of the `Complete` outcome button. */
        this.showCompleteButton = true;
        /** If true then the `Complete` outcome button is shown but it will be disabled. */
        this.disableCompleteButton = false;
        /** If true then the `Save` outcome button is shown but will be disabled. */
        this.disableSaveButton = false;
        /** If true then the `Start Process` outcome button is shown but it will be disabled. */
        this.disableStartProcessButton = false;
        /** Toggle rendering of the `Save` outcome button. */
        this.showSaveButton = true;
        /** Toggle readonly state of the form. Forces all form widgets to render as readonly if enabled. */
        this.readOnly = false;
        /** Toggle rendering of the `Refresh` button. */
        this.showRefreshButton = true;
        /** Toggle rendering of the validation icon next to the form title. */
        this.showValidationIcon = true;
        /** Emitted when the supplied form values have a validation error. */
        this.formError = new EventEmitter();
        /** Emitted when any outcome is executed. Default behaviour can be prevented
         * via `event.preventDefault()`.
         */
        this.executeOutcome = new EventEmitter();
        /**
         * Emitted when any error occurs.
         */
        this.error = new EventEmitter();
    }
    getParsedFormDefinition() {
        return this;
    }
    hasForm() {
        return !!this.form;
    }
    isTitleEnabled() {
        let titleEnabled = false;
        if (this.showTitle && this.form) {
            titleEnabled = true;
        }
        return titleEnabled;
    }
    getColorForOutcome(outcomeName) {
        return outcomeName === FormBaseComponent.COMPLETE_OUTCOME_NAME ? FormBaseComponent.COMPLETE_BUTTON_COLOR : null;
    }
    isOutcomeButtonEnabled(outcome) {
        if (this.form.readOnly) {
            return false;
        }
        if (outcome) {
            if (outcome.name === FormOutcomeModel.SAVE_ACTION) {
                return !this.disableSaveButton;
            }
            if (outcome.name === FormOutcomeModel.COMPLETE_ACTION) {
                return this.disableCompleteButton ? false : this.form.isValid;
            }
            if (outcome.name === FormOutcomeModel.START_PROCESS_ACTION) {
                return this.disableStartProcessButton ? false : this.form.isValid;
            }
            return this.form.isValid;
        }
        return false;
    }
    isOutcomeButtonVisible(outcome, isFormReadOnly) {
        if (outcome && outcome.name) {
            if (outcome.name === FormOutcomeModel.COMPLETE_ACTION) {
                return this.showCompleteButton;
            }
            if (isFormReadOnly) {
                return outcome.isSelected;
            }
            if (outcome.name === FormOutcomeModel.SAVE_ACTION) {
                return this.showSaveButton;
            }
            if (outcome.name === FormOutcomeModel.START_PROCESS_ACTION) {
                return false;
            }
            return true;
        }
        return false;
    }
    /**
     * Invoked when user clicks outcome button.
     *
     * @param outcome Form outcome model
     */
    onOutcomeClicked(outcome) {
        if (!this.readOnly && outcome && this.form) {
            if (!this.onExecuteOutcome(outcome)) {
                return false;
            }
            if (outcome.isSystem) {
                if (outcome.id === FormBaseComponent.SAVE_OUTCOME_ID) {
                    this.disableSaveButton = true;
                    this.saveTaskForm();
                    return true;
                }
                if (outcome.id === FormBaseComponent.COMPLETE_OUTCOME_ID) {
                    this.disableSaveButton = true;
                    this.disableCompleteButton = true;
                    this.completeTaskForm();
                    return true;
                }
                if (outcome.id === FormBaseComponent.START_PROCESS_OUTCOME_ID) {
                    this.completeTaskForm();
                    return true;
                }
                if (outcome.id === FormBaseComponent.CUSTOM_OUTCOME_ID) {
                    this.onTaskSaved(this.form);
                    this.storeFormAsMetadata();
                    return true;
                }
            }
            else {
                // Note: Activiti is using NAME field rather than ID for outcomes
                if (outcome.name) {
                    this.completeTaskForm(outcome.name);
                    return true;
                }
            }
        }
        return false;
    }
    handleError(err) {
        this.disableSaveButton = false;
        this.disableCompleteButton = false;
        this.error.emit(err);
    }
}
FormBaseComponent.SAVE_OUTCOME_ID = '$save';
FormBaseComponent.COMPLETE_OUTCOME_ID = '$complete';
FormBaseComponent.START_PROCESS_OUTCOME_ID = '$startProcess';
FormBaseComponent.CUSTOM_OUTCOME_ID = '$custom';
FormBaseComponent.COMPLETE_BUTTON_COLOR = 'primary';
FormBaseComponent.COMPLETE_OUTCOME_NAME = 'COMPLETE';
FormBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FormBaseComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: FormBaseComponent, inputs: { path: "path", nameNode: "nameNode", showTitle: "showTitle", showCompleteButton: "showCompleteButton", disableCompleteButton: "disableCompleteButton", disableSaveButton: "disableSaveButton", disableStartProcessButton: "disableStartProcessButton", showSaveButton: "showSaveButton", readOnly: "readOnly", showRefreshButton: "showRefreshButton", showValidationIcon: "showValidationIcon", fieldValidators: "fieldValidators" }, outputs: { formError: "formError", executeOutcome: "executeOutcome", error: "error" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormBaseComponent, decorators: [{
            type: Directive
        }], propDecorators: { path: [{
                type: Input
            }], nameNode: [{
                type: Input
            }], showTitle: [{
                type: Input
            }], showCompleteButton: [{
                type: Input
            }], disableCompleteButton: [{
                type: Input
            }], disableSaveButton: [{
                type: Input
            }], disableStartProcessButton: [{
                type: Input
            }], showSaveButton: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], showRefreshButton: [{
                type: Input
            }], showValidationIcon: [{
                type: Input
            }], fieldValidators: [{
                type: Input
            }], formError: [{
                type: Output
            }], executeOutcome: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InplaceFormInputComponent {
}
InplaceFormInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InplaceFormInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InplaceFormInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InplaceFormInputComponent, selector: "adf-inplace-form-input", inputs: { control: "control" }, ngImport: i0, template: "<div\n    class=\"adf-inplace-input-container\"\n    [ngClass]=\"{'adf-inplace-input-container-error': control.invalid && control.touched}\"\n>\n    <mat-form-field class=\"adf-inplace-input-mat-form-field\">\n        <input\n            matInput\n            [formControl]=\"control\"\n            class=\"adf-inplace-input\"\n            data-automation-id=\"adf-inplace-input\"\n        >\n\n        <mat-label data-automation-id=\"adf-inplace-input-label\">\n            <ng-content select=\"[label]\"></ng-content>\n        </mat-label>\n\n        <mat-error data-automation-id=\"adf-inplace-input-error\">\n            <ng-content select=\"[error]\"></ng-content>\n        </mat-error>\n    </mat-form-field>\n</div>\n", styles: [".adf-inplace-input-container .mat-form-field-underline{display:none}.adf-inplace-input-container .mat-form-field-infix{display:flex;border-top:0}.adf-inplace-input-container .mat-form-field-label{padding:7px}.adf-inplace-input-container-error .adf-inplace-input{border:1px solid var(--theme-warn-color)!important}.adf-inplace-input-container .adf-inplace-input-mat-form-field{width:100%}.adf-inplace-input-container .adf-inplace-input{padding:7px;border:1px solid transparent;border-radius:4px}.adf-inplace-input-container .adf-inplace-input:focus{border:1px solid var(--theme-primary-color)}.adf-inplace-input-container .adf-inplace-input:hover:not(:focus){border:1px solid var(--adf-theme-background-hover-color);background-color:var(--adf-theme-background-hover-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InplaceFormInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-inplace-form-input', encapsulation: ViewEncapsulation.None, template: "<div\n    class=\"adf-inplace-input-container\"\n    [ngClass]=\"{'adf-inplace-input-container-error': control.invalid && control.touched}\"\n>\n    <mat-form-field class=\"adf-inplace-input-mat-form-field\">\n        <input\n            matInput\n            [formControl]=\"control\"\n            class=\"adf-inplace-input\"\n            data-automation-id=\"adf-inplace-input\"\n        >\n\n        <mat-label data-automation-id=\"adf-inplace-input-label\">\n            <ng-content select=\"[label]\"></ng-content>\n        </mat-label>\n\n        <mat-error data-automation-id=\"adf-inplace-input-error\">\n            <ng-content select=\"[error]\"></ng-content>\n        </mat-error>\n    </mat-form-field>\n</div>\n", styles: [".adf-inplace-input-container .mat-form-field-underline{display:none}.adf-inplace-input-container .mat-form-field-infix{display:flex;border-top:0}.adf-inplace-input-container .mat-form-field-label{padding:7px}.adf-inplace-input-container-error .adf-inplace-input{border:1px solid var(--theme-warn-color)!important}.adf-inplace-input-container .adf-inplace-input-mat-form-field{width:100%}.adf-inplace-input-container .adf-inplace-input{padding:7px;border:1px solid transparent;border-radius:4px}.adf-inplace-input-container .adf-inplace-input:focus{border:1px solid var(--theme-primary-color)}.adf-inplace-input-container .adf-inplace-input:hover:not(:focus){border:1px solid var(--adf-theme-background-hover-color);background-color:var(--adf-theme-background-hover-color)}\n"] }]
        }], propDecorators: { control: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class StartFormCustomButtonDirective {
}
StartFormCustomButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: StartFormCustomButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
StartFormCustomButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: StartFormCustomButtonDirective, selector: "[adf-form-custom-button], [form-custom-button]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: StartFormCustomButtonDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-form-custom-button], [form-custom-button]' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormErrorEvent extends FormEvent {
    constructor(form, error) {
        super(form);
        this.error = error;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const FORM_RULES_MANAGER = new InjectionToken('form.rule.manager');
function formRulesManagerFactory(injector) {
    try {
        return injector.get(FORM_RULES_MANAGER);
    }
    catch {
        return new ByPassFormRuleManager(null);
    }
}
class FormRulesManager {
    constructor(formService) {
        this.formService = formService;
        this.onDestroy$ = new Subject();
        this.initialized = false;
    }
    initialize(formModel) {
        if (this.initialized) {
            this.destroy();
            this.onDestroy$ = new Subject();
        }
        this.formModel = formModel;
        if (!this.formModel.readOnly) {
            const rules = this.getRules();
            if (!!rules) {
                this.formService.formRulesEvent
                    .pipe(filter(event => !!event?.form?.id && event.form.id === formModel?.id), takeUntil(this.onDestroy$)).subscribe(event => {
                    this.handleRuleEvent(event, rules);
                });
                this.formService.formRulesEvent.next(new FormRulesEvent('formLoaded', new FormEvent(formModel)));
            }
        }
        this.initialized = true;
    }
    destroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
class ByPassFormRuleManager extends FormRulesManager {
    getRules() {
        return null;
    }
    handleRuleEvent() {
        return;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormRendererComponent {
    constructor(formService, formRulesManager) {
        this.formService = formService;
        this.formRulesManager = formRulesManager;
        /** Toggle debug options. */
        this.showDebugButton = false;
    }
    ngOnChanges() {
        this.formRulesManager.initialize(this.formDefinition);
    }
    ngOnDestroy() {
        this.formRulesManager.destroy();
    }
    hasTabs() {
        return this.formDefinition.tabs && this.formDefinition.tabs.length > 0;
    }
    visibleTabs() {
        return this.formDefinition.tabs.filter((tab) => tab.isVisible);
    }
    onExpanderClicked(content) {
        if (content && content.isCollapsible()) {
            content.isExpanded = !content.isExpanded;
        }
    }
    getNumberOfColumns(content) {
        return (content.json?.numberOfColumns || 1) > (content.columns?.length || 1) ?
            (content.json?.numberOfColumns || 1) :
            (content.columns?.length || 1);
    }
    /**
     * Serializes column fields
     */
    getContainerFields(content) {
        const serialisedFormFields = [];
        const maxColumnFieldsSize = this.getMaxColumnFieldSize(content);
        for (let rowIndex = 0; rowIndex < maxColumnFieldsSize; rowIndex++) {
            content?.columns.flatMap((currentColumn) => {
                if (!!currentColumn?.fields[rowIndex]) {
                    serialisedFormFields.push(currentColumn?.fields[rowIndex]);
                }
                else {
                    const firstRowElementColSpan = currentColumn?.fields[0]?.colspan;
                    if (!!firstRowElementColSpan && rowIndex > 0) {
                        for (let i = 0; i < firstRowElementColSpan; i++) {
                            serialisedFormFields.push(null);
                        }
                    }
                }
            });
        }
        return serialisedFormFields;
    }
    getMaxColumnFieldSize(content) {
        let maxFieldSize = 0;
        if (content?.columns?.length > 0) {
            maxFieldSize = content?.columns?.reduce((prevColumn, currentColumn) => currentColumn.fields.length > prevColumn?.fields?.length ? currentColumn : prevColumn)?.fields?.length;
        }
        return maxFieldSize;
    }
    /**
     * Calculate the column width based on the numberOfColumns and current field's colspan property
     *
     * @param container
     */
    getColumnWith(container) {
        const colspan = container ? container.field.colspan : 1;
        return (100 / container.field.numberOfColumns) * colspan + '';
    }
}
FormRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormRendererComponent, deps: [{ token: FormService }, { token: FormRulesManager }], target: i0.ɵɵFactoryTarget.Component });
FormRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FormRendererComponent, selector: "adf-form-renderer", inputs: { showDebugButton: "showDebugButton", formDefinition: "formDefinition" }, providers: [
        {
            provide: FormRulesManager,
            useFactory: formRulesManagerFactory,
            deps: [Injector]
        }
    ], usesOnChanges: true, ngImport: i0, template: "<div\n    id=\"adf-form-renderer\"\n    class=\"{{formDefinition.className}}\"\n    [ngClass]=\"{'adf-readonly-form': formDefinition.readOnly}\"\n>\n    <div *ngIf=\"formDefinition.hasTabs()\">\n        <div *ngIf=\"hasTabs()\" class=\"alfresco-tabs-widget\">\n            <mat-tab-group>\n                <mat-tab *ngFor=\"let tab of visibleTabs()\" [label]=\"tab.title | translate\">\n                    <ng-template *ngTemplateOutlet=\"render; context: {fieldToRender : tab.fields}\"></ng-template>\n                </mat-tab>\n            </mat-tab-group>\n        </div>\n    </div>\n\n    <div *ngIf=\"!formDefinition.hasTabs() && formDefinition.hasFields()\">\n        <ng-template *ngTemplateOutlet=\"render; context: {fieldToRender : formDefinition.fields}\"></ng-template>\n    </div>\n</div>\n\n<ng-template #render let-fieldToRender=\"fieldToRender\">\n    <div *ngFor=\"let currentRootElement of fieldToRender\">\n        <div *ngIf=\"currentRootElement.type === 'container' || currentRootElement.type === 'group'\" class=\"adf-container-widget\" [id]=\"'field-'+currentRootElement?.id+'-container'\" [hidden]=\"!currentRootElement?.isVisible\">\n            <div [hidden]=\"!currentRootElement?.isGroup()\" class=\"adf-container-widget__header\">\n                <h4 class=\"adf-container-widget__header-text\" id=\"container-header\"\n                    [class.adf-collapsible]=\"currentRootElement?.isCollapsible()\">\n                    <button *ngIf=\"currentRootElement?.isCollapsible()\"\n                            mat-icon-button\n                            class=\"mdl-button--icon\"\n                            (click)=\"onExpanderClicked(currentRootElement)\">\n                        <mat-icon>{{ currentRootElement?.isExpanded ? 'expand_more' : 'expand_less' }}</mat-icon>\n                    </button>\n                    <span (click)=\"onExpanderClicked(currentRootElement)\"\n                          [id]=\"'container-header-label-'+currentRootElement?.id\">{{currentRootElement.name | translate }}</span>\n                </h4>\n            </div>\n\n            <div *ngIf=\"currentRootElement?.form?.enableFixedSpace else fixingTemplate\">\n                <div class=\"adf-grid-list\"\n                     [ngStyle]=\"{ 'grid-template-columns': 'repeat('+getNumberOfColumns(currentRootElement) +', 1fr)'}\"\n                     *ngIf=\"currentRootElement?.isExpanded\">\n                    <div class=\"adf-grid-list-item\" *ngFor=\"let field of getContainerFields(currentRootElement)\"\n                         [ngStyle]=\"{'grid-area': 'auto / auto / span '+(field?.rowspan || 1)+' / span '+(field?.colspan || 1)}\">\n                        <adf-form-field *ngIf=\"field\" [field]=\"field\"></adf-form-field>\n                    </div>\n                </div>\n            </div>\n\n            <ng-template #fixingTemplate>\n                <section class=\"adf-grid-list-column-view\" *ngIf=\"currentRootElement?.isExpanded\">\n                    <div class=\"adf-grid-list-single-column\" *ngFor=\"let column of currentRootElement?.columns\"\n                         [style.width.%]=\"getColumnWith(currentRootElement)\">\n                        <div class=\"adf-grid-list-column-view-item\" *ngFor=\"let field of column?.fields\">\n                            <adf-form-field *ngIf=\"field\" [field]=\"field\"></adf-form-field>\n                        </div>\n                    </div>\n                </section>\n            </ng-template>\n\n        </div>\n        <div *ngIf=\"currentRootElement.type === 'dynamic-table'\" class=\"adf-container-widget\" >\n           <adf-form-field [field]=\"currentRootElement\"></adf-form-field>\n        </div>\n    </div>\n</ng-template>\n\n<!--\nFor debugging and data visualisation purposes,\nwill be removed during future revisions\n-->\n<div *ngIf=\"showDebugButton\" class=\"adf-form-debug-container\">\n    <mat-slide-toggle [(ngModel)]=\"debugMode\">Debug mode</mat-slide-toggle>\n    <div *ngIf=\"debugMode\">\n        <h4>Values</h4>\n        <pre>{{formDefinition.values | json}}</pre>\n\n        <h4>Form</h4>\n        <pre>{{formDefinition.json | json}}</pre>\n    </div>\n</div>\n", styles: [".adf-hidden{display:none}.adf-container-widget__header-text{border-bottom:1px solid rgba(0,0,0,.87);padding-bottom:10px;cursor:default;-webkit-user-select:none;user-select:none}.adf-container-widget__header-text.adf-collapsible{cursor:pointer}.adf-field-list{padding:0;list-style-type:none;width:100%;height:100%}.adf-container-widget .adf-grid-list-column-view{display:flex;align-items:flex-start;margin-right:-1%}.adf-container-widget .adf-grid-list-single-column{display:flex;flex-direction:column;align-items:flex-start;flex:1 1 auto}.adf-container-widget .adf-grid-list-column-view-item{width:100%;flex-grow:1;box-sizing:border-box;padding-left:1%;padding-right:1%}.adf-container-widget .adf-grid-list{display:grid}.adf-container-widget .adf-grid-list-item{box-sizing:border-box;padding-left:3px;padding-right:3px}@media screen and (max-width: 959px){.adf-container-widget .adf-grid-list-item{flex:1 0 100%}.adf-container-widget .adf-grid-list--column-view{flex-direction:column}.adf-container-widget .adf-grid-list-single-column{width:90%!important}.adf-container-widget .adf-grid-list-column-view-item{flex:1 0 auto}}.adf-container-widget .mat-form-field{width:100%}.adf-container-widget mat-form-field{width:100%}.adf-container-widget .mat-input-placeholder{top:1.8em!important}.adf-container-widget .mat-focused label{transform:scaleX(1);transition:transform .15s linear;background-color:.3s cubic-bezier(.55,0,.55,.2);color:var(--theme-primary-color)}.adf-container-widget .mat-focused .mat-form-field-prefix{color:var(--theme-primary-color)}.adf-container-widget .mat-grid-tile{overflow:visible;width:80%}.adf-container-widget adf-form-field{width:100%}.adf-form-container{max-width:100%!important;max-height:100%!important}.adf-form-container .mat-card{padding:16px 24px;overflow:hidden}.adf-form-container .mat-card-header-text{margin:0!important}.adf-form-container .mat-tab-body-content{overflow:hidden}.adf-form-container .mat-tab-label{font-size:var(--theme-subheading-2-font-size);line-height:var(--theme-headline-line-height);letter-spacing:-.4px;text-align:left;color:#0000008a;text-transform:uppercase}.adf-form-container .mat-ink-bar{height:4px}.adf-form-container .mat-form-field-wrapper{margin:0 12px 0 0}.adf-form-title{font-size:var(--theme-title-font-size);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.adf-form-debug-container{padding:10px}.adf-form-debug-container .adf-debug-toggle-text{padding-left:15px;cursor:pointer}.adf-form-debug-container .adf-debug-toggle-text:hover{font-weight:700}.adf-form-reload-button{position:absolute;right:12px;top:30px}.adf-form-validation-button{position:absolute;right:50px;top:39px;color:var(--theme-accent-color)}.adf-form-validation-button .adf-invalid-color{color:var(--theme-warn-color)}.adf-form-hide-button{display:none!important}.adf-task-title{text-align:center}.adf-label{width:32px;height:16px;font-size:var(--theme-caption-font-size);line-height:var(--theme-headline-line-height);text-align:left;white-space:nowrap}.adf-form-mat-card-actions{float:right;padding-bottom:25px!important;padding-right:25px!important}.adf-form-mat-card-actions .mat-button{height:36px;border-radius:5px}.adf-form-mat-card-actions .mat-button-wrapper{width:58px;height:20px;opacity:.54;font-size:var(--theme-body-2-font-size);font-weight:700}.adf-left-label-input-container{display:flex}.adf-left-label-input-container div:nth-child(2){flex:1}.adf-left-label-input-container .mat-form-field-label-wrapper{top:auto;bottom:0}.adf-left-label{line-height:64px;margin-right:15px}form-field{width:100%}form-field .mat-input-element{font-size:var(--theme-body-2-font-size);padding-top:8px;line-height:normal}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6$2.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: FormFieldComponent, selector: "adf-form-field", inputs: ["field"] }, { kind: "pipe", type: i1.JsonPipe, name: "json" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-form-renderer', providers: [
                        {
                            provide: FormRulesManager,
                            useFactory: formRulesManagerFactory,
                            deps: [Injector]
                        }
                    ], encapsulation: ViewEncapsulation.None, template: "<div\n    id=\"adf-form-renderer\"\n    class=\"{{formDefinition.className}}\"\n    [ngClass]=\"{'adf-readonly-form': formDefinition.readOnly}\"\n>\n    <div *ngIf=\"formDefinition.hasTabs()\">\n        <div *ngIf=\"hasTabs()\" class=\"alfresco-tabs-widget\">\n            <mat-tab-group>\n                <mat-tab *ngFor=\"let tab of visibleTabs()\" [label]=\"tab.title | translate\">\n                    <ng-template *ngTemplateOutlet=\"render; context: {fieldToRender : tab.fields}\"></ng-template>\n                </mat-tab>\n            </mat-tab-group>\n        </div>\n    </div>\n\n    <div *ngIf=\"!formDefinition.hasTabs() && formDefinition.hasFields()\">\n        <ng-template *ngTemplateOutlet=\"render; context: {fieldToRender : formDefinition.fields}\"></ng-template>\n    </div>\n</div>\n\n<ng-template #render let-fieldToRender=\"fieldToRender\">\n    <div *ngFor=\"let currentRootElement of fieldToRender\">\n        <div *ngIf=\"currentRootElement.type === 'container' || currentRootElement.type === 'group'\" class=\"adf-container-widget\" [id]=\"'field-'+currentRootElement?.id+'-container'\" [hidden]=\"!currentRootElement?.isVisible\">\n            <div [hidden]=\"!currentRootElement?.isGroup()\" class=\"adf-container-widget__header\">\n                <h4 class=\"adf-container-widget__header-text\" id=\"container-header\"\n                    [class.adf-collapsible]=\"currentRootElement?.isCollapsible()\">\n                    <button *ngIf=\"currentRootElement?.isCollapsible()\"\n                            mat-icon-button\n                            class=\"mdl-button--icon\"\n                            (click)=\"onExpanderClicked(currentRootElement)\">\n                        <mat-icon>{{ currentRootElement?.isExpanded ? 'expand_more' : 'expand_less' }}</mat-icon>\n                    </button>\n                    <span (click)=\"onExpanderClicked(currentRootElement)\"\n                          [id]=\"'container-header-label-'+currentRootElement?.id\">{{currentRootElement.name | translate }}</span>\n                </h4>\n            </div>\n\n            <div *ngIf=\"currentRootElement?.form?.enableFixedSpace else fixingTemplate\">\n                <div class=\"adf-grid-list\"\n                     [ngStyle]=\"{ 'grid-template-columns': 'repeat('+getNumberOfColumns(currentRootElement) +', 1fr)'}\"\n                     *ngIf=\"currentRootElement?.isExpanded\">\n                    <div class=\"adf-grid-list-item\" *ngFor=\"let field of getContainerFields(currentRootElement)\"\n                         [ngStyle]=\"{'grid-area': 'auto / auto / span '+(field?.rowspan || 1)+' / span '+(field?.colspan || 1)}\">\n                        <adf-form-field *ngIf=\"field\" [field]=\"field\"></adf-form-field>\n                    </div>\n                </div>\n            </div>\n\n            <ng-template #fixingTemplate>\n                <section class=\"adf-grid-list-column-view\" *ngIf=\"currentRootElement?.isExpanded\">\n                    <div class=\"adf-grid-list-single-column\" *ngFor=\"let column of currentRootElement?.columns\"\n                         [style.width.%]=\"getColumnWith(currentRootElement)\">\n                        <div class=\"adf-grid-list-column-view-item\" *ngFor=\"let field of column?.fields\">\n                            <adf-form-field *ngIf=\"field\" [field]=\"field\"></adf-form-field>\n                        </div>\n                    </div>\n                </section>\n            </ng-template>\n\n        </div>\n        <div *ngIf=\"currentRootElement.type === 'dynamic-table'\" class=\"adf-container-widget\" >\n           <adf-form-field [field]=\"currentRootElement\"></adf-form-field>\n        </div>\n    </div>\n</ng-template>\n\n<!--\nFor debugging and data visualisation purposes,\nwill be removed during future revisions\n-->\n<div *ngIf=\"showDebugButton\" class=\"adf-form-debug-container\">\n    <mat-slide-toggle [(ngModel)]=\"debugMode\">Debug mode</mat-slide-toggle>\n    <div *ngIf=\"debugMode\">\n        <h4>Values</h4>\n        <pre>{{formDefinition.values | json}}</pre>\n\n        <h4>Form</h4>\n        <pre>{{formDefinition.json | json}}</pre>\n    </div>\n</div>\n", styles: [".adf-hidden{display:none}.adf-container-widget__header-text{border-bottom:1px solid rgba(0,0,0,.87);padding-bottom:10px;cursor:default;-webkit-user-select:none;user-select:none}.adf-container-widget__header-text.adf-collapsible{cursor:pointer}.adf-field-list{padding:0;list-style-type:none;width:100%;height:100%}.adf-container-widget .adf-grid-list-column-view{display:flex;align-items:flex-start;margin-right:-1%}.adf-container-widget .adf-grid-list-single-column{display:flex;flex-direction:column;align-items:flex-start;flex:1 1 auto}.adf-container-widget .adf-grid-list-column-view-item{width:100%;flex-grow:1;box-sizing:border-box;padding-left:1%;padding-right:1%}.adf-container-widget .adf-grid-list{display:grid}.adf-container-widget .adf-grid-list-item{box-sizing:border-box;padding-left:3px;padding-right:3px}@media screen and (max-width: 959px){.adf-container-widget .adf-grid-list-item{flex:1 0 100%}.adf-container-widget .adf-grid-list--column-view{flex-direction:column}.adf-container-widget .adf-grid-list-single-column{width:90%!important}.adf-container-widget .adf-grid-list-column-view-item{flex:1 0 auto}}.adf-container-widget .mat-form-field{width:100%}.adf-container-widget mat-form-field{width:100%}.adf-container-widget .mat-input-placeholder{top:1.8em!important}.adf-container-widget .mat-focused label{transform:scaleX(1);transition:transform .15s linear;background-color:.3s cubic-bezier(.55,0,.55,.2);color:var(--theme-primary-color)}.adf-container-widget .mat-focused .mat-form-field-prefix{color:var(--theme-primary-color)}.adf-container-widget .mat-grid-tile{overflow:visible;width:80%}.adf-container-widget adf-form-field{width:100%}.adf-form-container{max-width:100%!important;max-height:100%!important}.adf-form-container .mat-card{padding:16px 24px;overflow:hidden}.adf-form-container .mat-card-header-text{margin:0!important}.adf-form-container .mat-tab-body-content{overflow:hidden}.adf-form-container .mat-tab-label{font-size:var(--theme-subheading-2-font-size);line-height:var(--theme-headline-line-height);letter-spacing:-.4px;text-align:left;color:#0000008a;text-transform:uppercase}.adf-form-container .mat-ink-bar{height:4px}.adf-form-container .mat-form-field-wrapper{margin:0 12px 0 0}.adf-form-title{font-size:var(--theme-title-font-size);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.adf-form-debug-container{padding:10px}.adf-form-debug-container .adf-debug-toggle-text{padding-left:15px;cursor:pointer}.adf-form-debug-container .adf-debug-toggle-text:hover{font-weight:700}.adf-form-reload-button{position:absolute;right:12px;top:30px}.adf-form-validation-button{position:absolute;right:50px;top:39px;color:var(--theme-accent-color)}.adf-form-validation-button .adf-invalid-color{color:var(--theme-warn-color)}.adf-form-hide-button{display:none!important}.adf-task-title{text-align:center}.adf-label{width:32px;height:16px;font-size:var(--theme-caption-font-size);line-height:var(--theme-headline-line-height);text-align:left;white-space:nowrap}.adf-form-mat-card-actions{float:right;padding-bottom:25px!important;padding-right:25px!important}.adf-form-mat-card-actions .mat-button{height:36px;border-radius:5px}.adf-form-mat-card-actions .mat-button-wrapper{width:58px;height:20px;opacity:.54;font-size:var(--theme-body-2-font-size);font-weight:700}.adf-left-label-input-container{display:flex}.adf-left-label-input-container div:nth-child(2){flex:1}.adf-left-label-input-container .mat-form-field-label-wrapper{top:auto;bottom:0}.adf-left-label{line-height:64px;margin-right:15px}form-field{width:100%}form-field .mat-input-element{font-size:var(--theme-body-2-font-size);padding-top:8px;line-height:normal}\n"] }]
        }], ctorParameters: function () { return [{ type: FormService }, { type: FormRulesManager }]; }, propDecorators: { showDebugButton: [{
                type: Input
            }], formDefinition: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EditJsonDialogModule {
}
EditJsonDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EditJsonDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogModule, declarations: [EditJsonDialogComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule], exports: [EditJsonDialogComponent] });
EditJsonDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogModule, imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EditJsonDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EditJsonDialogComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        MatDialogModule,
                        MatButtonModule
                    ],
                    exports: [EditJsonDialogComponent]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FormBaseModule {
}
FormBaseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormBaseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormBaseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FormBaseModule, declarations: [FormFieldComponent,
        FormRendererComponent,
        StartFormCustomButtonDirective, UnknownWidgetComponent, TextWidgetComponent, NumberWidgetComponent, CheckboxWidgetComponent, MultilineTextWidgetComponentComponent, HyperlinkWidgetComponent, DisplayTextWidgetComponent, DateWidgetComponent, AmountWidgetComponent, ErrorWidgetComponent, DateTimeWidgetComponent, JsonWidgetComponent, BaseViewerWidgetComponent, InputMaskDirective, WidgetComponent,
        InplaceFormInputComponent], imports: [CommonModule,
        A11yModule,
        DataTableModule,
        HttpClientModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        MatDatetimepickerModule,
        MatNativeDatetimeModule,
        EditJsonDialogModule,
        ViewerModule], exports: [FormFieldComponent,
        FormRendererComponent,
        StartFormCustomButtonDirective, UnknownWidgetComponent, TextWidgetComponent, NumberWidgetComponent, CheckboxWidgetComponent, MultilineTextWidgetComponentComponent, HyperlinkWidgetComponent, DisplayTextWidgetComponent, DateWidgetComponent, AmountWidgetComponent, ErrorWidgetComponent, DateTimeWidgetComponent, JsonWidgetComponent, BaseViewerWidgetComponent, InplaceFormInputComponent,
        WidgetComponent] });
FormBaseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormBaseModule, imports: [CommonModule,
        A11yModule,
        DataTableModule,
        HttpClientModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        MatDatetimepickerModule,
        MatNativeDatetimeModule,
        EditJsonDialogModule,
        ViewerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FormBaseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        A11yModule,
                        DataTableModule,
                        HttpClientModule,
                        MaterialModule,
                        TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        PipeModule,
                        MatDatetimepickerModule,
                        MatNativeDatetimeModule,
                        EditJsonDialogModule,
                        ViewerModule
                    ],
                    declarations: [
                        FormFieldComponent,
                        FormRendererComponent,
                        StartFormCustomButtonDirective,
                        ...WIDGET_DIRECTIVES,
                        ...MASK_DIRECTIVE,
                        WidgetComponent,
                        InplaceFormInputComponent
                    ],
                    exports: [
                        FormFieldComponent,
                        FormRendererComponent,
                        StartFormCustomButtonDirective,
                        ...WIDGET_DIRECTIVES,
                        InplaceFormInputComponent,
                        WidgetComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TaskProcessVariableModel {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HeaderLayoutComponent {
    constructor(appConfigService) {
        this.appConfigService = appConfigService;
        /** Toggles whether the logo will be displayed inside the header or not. */
        this.showLogo = true;
        /** The router link for the application logo, when clicked. */
        this.redirectUrl = '/';
        /**
         * Toggles whether the sidenav button will be displayed in the header
         * or not.
         */
        this.showSidenavToggle = true;
        /** The toggle icon that will be used inside header. */
        this.toggleIcon = 'menu';
        /** Emitted when the sidenav button is clicked. */
        this.clicked = new EventEmitter();
        /** expandedSidenav: Toggles the expanded state of the component. */
        this.expandedSidenav = true;
        /** The side of the page that the drawer is attached to (can be 'start' or 'end') */
        this.position = 'start';
    }
    toggleMenu() {
        this.clicked.emit(true);
        this.expandedSidenav = !this.expandedSidenav;
    }
    ngOnInit() {
        const textColor = this.appConfigService.get('headerTextColor');
        if (textColor) {
            document.documentElement.style.setProperty('--theme-header-text-color', textColor);
        }
        if (!this.logo) {
            this.logo = './assets/images/logo.png';
        }
    }
}
HeaderLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HeaderLayoutComponent, deps: [{ token: AppConfigService }], target: i0.ɵɵFactoryTarget.Component });
HeaderLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: HeaderLayoutComponent, selector: "adf-layout-header", inputs: { title: "title", logo: "logo", showLogo: "showLogo", redirectUrl: "redirectUrl", tooltip: "tooltip", color: "color", showSidenavToggle: "showSidenavToggle", toggleIcon: "toggleIcon", expandedSidenav: "expandedSidenav", position: "position" }, outputs: { clicked: "clicked" }, host: { classAttribute: "adf-layout-header" }, ngImport: i0, template: "<mat-toolbar\n    [color]=\"color\"\n    [style.background-color]=\"color\">\n    <button\n        *ngIf=\"showSidenavToggle && position === 'start'\"\n        id=\"adf-sidebar-toggle-start\"\n        data-automation-id=\"adf-menu-icon\"\n        class=\"mat-icon-button adf-menu-icon\"\n        mat-icon-button\n        (click)=\"toggleMenu()\"\n        [attr.aria-expanded]=\"expandedSidenav\"\n        [attr.aria-label]=\"'CORE.HEADER.ACCESSIBILITY.SIDEBAR_TOGGLE_BUTTON_ARIA_LABEL' | translate\">\n        <mat-icon\n            class=\"mat-icon material-icon\"\n            role=\"img\"\n            aria-hidden=\"true\">{{ toggleIcon }}</mat-icon>\n    </button>\n\n    <a *ngIf=\"showLogo\" [routerLink]=\"redirectUrl\" title=\"{{ tooltip }}\">\n        <img\n            src=\"{{ logo }}\"\n            class=\"adf-app-logo\"\n            alt=\"{{ 'CORE.HEADER.LOGO_ARIA' | translate }}\"\n        />\n    </a>\n\n    <h1\n        role=\"link\"\n        [attr.aria-label]=\"title | translate\"\n        [routerLink]=\"redirectUrl\"\n        class=\"adf-app-title\"\n        >\n        {{ title }}\n    </h1>\n\n    <ng-content></ng-content>\n\n    <button\n        *ngIf=\"showSidenavToggle && position === 'end'\"\n        id=\"adf-sidebar-toggle-end\"\n        data-automation-id=\"adf-menu-icon\"\n        class=\"mat-icon-button adf-menu-icon\"\n        mat-icon-button\n        (click)=\"toggleMenu()\"\n        [attr.aria-expanded]=\"expandedSidenav\"\n        [attr.aria-label]=\"'CORE.HEADER.ACCESSIBILITY.SIDEBAR_TOGGLE_BUTTON_ARIA_LABEL' | translate\">\n    >\n        <mat-icon\n            class=\"mat-icon material-icon\"\n            role=\"img\"\n            aria-hidden=\"true\">{{ toggleIcon }}</mat-icon>\n    </button>\n</mat-toolbar>\n", styles: ["adf-layout-header .mat-toolbar-single-row{color:var(--theme-header-text-color)!important;background-color:var(--theme-primary-color);position:relative;padding:0 24px}adf-layout-header .mat-toolbar-single-row .adf-menu-icon{position:relative;margin-right:0}adf-layout-header .mat-toolbar-single-row .adf-menu-icon .mat-icon{font-size:29px;padding:0 5px 0 0}adf-layout-header .mat-toolbar-single-row .adf-app-logo{position:relative;height:28px;vertical-align:middle;margin-top:-3px}adf-layout-header .mat-toolbar-single-row .adf-app-title{cursor:pointer;letter-spacing:-.3px;font-weight:100}adf-layout-header .mat-toolbar-single-row .adf-toolbar--spacer{flex:1 1 auto}adf-layout-header .mat-toolbar-single-row .adf-toolbar-divider{margin:0 5px}adf-layout-header .mat-toolbar-single-row .adf-toolbar-divider>div{background-color:var(--adf-theme-background-card-color)}adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{height:24px;width:2px;background-color:var(--theme-primary-color-default-contrast)}adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{flex-direction:row;padding:0}@media screen and (max-width: 599px){adf-layout-header .mat-toolbar-single-row .adf-app-logo,adf-layout-header .mat-toolbar-single-row .adf-app-title{display:none}}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-menu-icon{margin-right:-11px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-app-logo{margin-right:6px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-app-title{margin-right:6px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{margin-left:16px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{margin-left:16px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-userinfo-name{padding-left:8px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-menu-icon{margin-left:-11px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-app-logo{margin-left:6px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-app-title{margin-left:6px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{margin-right:16px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{margin-right:16px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-userinfo-name{padding-right:8px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i2$3.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "directive", type: i2$4.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { kind: "directive", type: i2$4.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: HeaderLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-layout-header', encapsulation: ViewEncapsulation.None, host: { class: 'adf-layout-header' }, template: "<mat-toolbar\n    [color]=\"color\"\n    [style.background-color]=\"color\">\n    <button\n        *ngIf=\"showSidenavToggle && position === 'start'\"\n        id=\"adf-sidebar-toggle-start\"\n        data-automation-id=\"adf-menu-icon\"\n        class=\"mat-icon-button adf-menu-icon\"\n        mat-icon-button\n        (click)=\"toggleMenu()\"\n        [attr.aria-expanded]=\"expandedSidenav\"\n        [attr.aria-label]=\"'CORE.HEADER.ACCESSIBILITY.SIDEBAR_TOGGLE_BUTTON_ARIA_LABEL' | translate\">\n        <mat-icon\n            class=\"mat-icon material-icon\"\n            role=\"img\"\n            aria-hidden=\"true\">{{ toggleIcon }}</mat-icon>\n    </button>\n\n    <a *ngIf=\"showLogo\" [routerLink]=\"redirectUrl\" title=\"{{ tooltip }}\">\n        <img\n            src=\"{{ logo }}\"\n            class=\"adf-app-logo\"\n            alt=\"{{ 'CORE.HEADER.LOGO_ARIA' | translate }}\"\n        />\n    </a>\n\n    <h1\n        role=\"link\"\n        [attr.aria-label]=\"title | translate\"\n        [routerLink]=\"redirectUrl\"\n        class=\"adf-app-title\"\n        >\n        {{ title }}\n    </h1>\n\n    <ng-content></ng-content>\n\n    <button\n        *ngIf=\"showSidenavToggle && position === 'end'\"\n        id=\"adf-sidebar-toggle-end\"\n        data-automation-id=\"adf-menu-icon\"\n        class=\"mat-icon-button adf-menu-icon\"\n        mat-icon-button\n        (click)=\"toggleMenu()\"\n        [attr.aria-expanded]=\"expandedSidenav\"\n        [attr.aria-label]=\"'CORE.HEADER.ACCESSIBILITY.SIDEBAR_TOGGLE_BUTTON_ARIA_LABEL' | translate\">\n    >\n        <mat-icon\n            class=\"mat-icon material-icon\"\n            role=\"img\"\n            aria-hidden=\"true\">{{ toggleIcon }}</mat-icon>\n    </button>\n</mat-toolbar>\n", styles: ["adf-layout-header .mat-toolbar-single-row{color:var(--theme-header-text-color)!important;background-color:var(--theme-primary-color);position:relative;padding:0 24px}adf-layout-header .mat-toolbar-single-row .adf-menu-icon{position:relative;margin-right:0}adf-layout-header .mat-toolbar-single-row .adf-menu-icon .mat-icon{font-size:29px;padding:0 5px 0 0}adf-layout-header .mat-toolbar-single-row .adf-app-logo{position:relative;height:28px;vertical-align:middle;margin-top:-3px}adf-layout-header .mat-toolbar-single-row .adf-app-title{cursor:pointer;letter-spacing:-.3px;font-weight:100}adf-layout-header .mat-toolbar-single-row .adf-toolbar--spacer{flex:1 1 auto}adf-layout-header .mat-toolbar-single-row .adf-toolbar-divider{margin:0 5px}adf-layout-header .mat-toolbar-single-row .adf-toolbar-divider>div{background-color:var(--adf-theme-background-card-color)}adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{height:24px;width:2px;background-color:var(--theme-primary-color-default-contrast)}adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{flex-direction:row;padding:0}@media screen and (max-width: 599px){adf-layout-header .mat-toolbar-single-row .adf-app-logo,adf-layout-header .mat-toolbar-single-row .adf-app-title{display:none}}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-menu-icon{margin-right:-11px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-app-logo{margin-right:6px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-app-title{margin-right:6px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{margin-left:16px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{margin-left:16px}[dir=rtl] adf-layout-header .mat-toolbar-single-row .adf-userinfo-name{padding-left:8px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-menu-icon{margin-left:-11px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-app-logo{margin-left:6px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-app-title{margin-left:6px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-header-delimiter{margin-right:16px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-userinfo-container{margin-right:16px}[dir=ltr] adf-layout-header .mat-toolbar-single-row .adf-userinfo-name{padding-right:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: AppConfigService }]; }, propDecorators: { title: [{
                type: Input
            }], logo: [{
                type: Input
            }], showLogo: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], color: [{
                type: Input
            }], showSidenavToggle: [{
                type: Input
            }], toggleIcon: [{
                type: Input
            }], clicked: [{
                type: Output
            }], expandedSidenav: [{
                type: Input
            }], position: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const sidenavAnimation = trigger('sidenavAnimation', [
    state('expanded', style({ width: '{{ width }}px' }), { params: { width: 0 } }),
    state('compact', style({ width: '{{ width }}px' }), { params: { width: 0 } }),
    transition('compact <=> expanded', animate('0.4s cubic-bezier(0.25, 0.8, 0.25, 1)'))
]);
const contentAnimation = trigger('contentAnimationLeft', [
    state('expanded', style({
        'margin-left': '{{ margin-left }}px',
        'margin-right': '{{ margin-right }}px'
    }), { params: { 'margin-left': 0, 'margin-right': 0 } }),
    state('compact', style({
        'margin-left': '{{ margin-left }}px',
        'margin-right': '{{ margin-right }}px'
    }), { params: { 'margin-left': 0, 'margin-right': 0 } }),
    transition('expanded <=> compact', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
]);

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LayoutContainerComponent {
    constructor() {
        this.hideSidenav = false;
        this.expandedSidenav = true;
        /** The side that the drawer is attached to 'start' | 'end' page */
        this.position = 'start';
        /** Layout text orientation 'ltr' | 'rtl' */
        this.direction = 'ltr';
        this.SIDENAV_STATES = { MOBILE: {}, EXPANDED: {}, COMPACT: {} };
        this.CONTENT_STATES = { MOBILE: {}, EXPANDED: {}, COMPACT: {} };
        this.onMediaQueryChange = this.onMediaQueryChange.bind(this);
    }
    ngOnInit() {
        this.SIDENAV_STATES.MOBILE = { value: 'expanded', params: { width: this.sidenavMax } };
        this.SIDENAV_STATES.EXPANDED = { value: 'expanded', params: { width: this.sidenavMax } };
        this.SIDENAV_STATES.COMPACT = { value: 'compact', params: { width: this.sidenavMin } };
        this.CONTENT_STATES.MOBILE = { value: 'expanded' };
        this.mediaQueryList.addListener(this.onMediaQueryChange);
        if (this.isMobileScreenSize) {
            this.sidenavAnimationState = this.SIDENAV_STATES.MOBILE;
            this.contentAnimationState = this.CONTENT_STATES.MOBILE;
        }
        else if (this.expandedSidenav) {
            this.sidenavAnimationState = this.SIDENAV_STATES.EXPANDED;
            this.contentAnimationState = this.toggledContentAnimation;
        }
        else {
            this.sidenavAnimationState = this.SIDENAV_STATES.COMPACT;
            this.contentAnimationState = this.toggledContentAnimation;
        }
    }
    ngOnDestroy() {
        this.mediaQueryList.removeListener(this.onMediaQueryChange);
    }
    ngOnChanges(changes) {
        if (changes && changes.direction) {
            this.contentAnimationState = this.toggledContentAnimation;
        }
    }
    toggleMenu() {
        if (this.isMobileScreenSize) {
            this.sidenav.toggle();
        }
        else {
            this.sidenavAnimationState = this.toggledSidenavAnimation;
            this.contentAnimationState = this.toggledContentAnimation;
        }
    }
    get isMobileScreenSize() {
        return this.mediaQueryList.matches;
    }
    getContentAnimationState() {
        return this.contentAnimationState;
    }
    get toggledSidenavAnimation() {
        return this.sidenavAnimationState === this.SIDENAV_STATES.EXPANDED
            ? this.SIDENAV_STATES.COMPACT
            : this.SIDENAV_STATES.EXPANDED;
    }
    get toggledContentAnimation() {
        if (this.isMobileScreenSize) {
            return this.CONTENT_STATES.MOBILE;
        }
        if (this.sidenavAnimationState === this.SIDENAV_STATES.EXPANDED) {
            if (this.position === 'start' && this.direction === 'ltr') {
                return { value: 'compact', params: { 'margin-left': this.sidenavMax } };
            }
            if (this.position === 'start' && this.direction === 'rtl') {
                return { value: 'compact', params: { 'margin-right': this.sidenavMax } };
            }
            if (this.position === 'end' && this.direction === 'ltr') {
                return { value: 'compact', params: { 'margin-right': this.sidenavMax } };
            }
            if (this.position === 'end' && this.direction === 'rtl') {
                return { value: 'compact', params: { 'margin-left': this.sidenavMax } };
            }
        }
        else {
            if (this.position === 'start' && this.direction === 'ltr') {
                return { value: 'expanded', params: { 'margin-left': this.sidenavMin } };
            }
            if (this.position === 'start' && this.direction === 'rtl') {
                return { value: 'expanded', params: { 'margin-right': this.sidenavMin } };
            }
            if (this.position === 'end' && this.direction === 'ltr') {
                return { value: 'expanded', params: { 'margin-right': this.sidenavMin } };
            }
            if (this.position === 'end' && this.direction === 'rtl') {
                return { value: 'expanded', params: { 'margin-left': this.sidenavMin } };
            }
        }
    }
    onMediaQueryChange() {
        this.sidenavAnimationState = this.SIDENAV_STATES.EXPANDED;
        this.contentAnimationState = this.toggledContentAnimation;
    }
}
LayoutContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LayoutContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LayoutContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LayoutContainerComponent, selector: "adf-layout-container", inputs: { sidenavMin: "sidenavMin", sidenavMax: "sidenavMax", mediaQueryList: "mediaQueryList", hideSidenav: "hideSidenav", expandedSidenav: "expandedSidenav", position: "position", direction: "direction" }, viewQueries: [{ propertyName: "sidenav", first: true, predicate: MatSidenav, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<mat-sidenav-container>\n    <mat-sidenav\n        [position]=\"position\"\n        [disableClose]=\"!isMobileScreenSize\"\n        [ngClass]=\"{ 'adf-sidenav--hidden': hideSidenav }\"\n        [@sidenavAnimation]=\"sidenavAnimationState\"\n        [opened]=\"!isMobileScreenSize\"\n        [mode]=\"isMobileScreenSize ? 'over' : 'side'\">\n        <ng-content sidenav select=\"[app-layout-navigation]\"></ng-content>\n    </mat-sidenav>\n\n    <div>\n        <div class=\"adf-container-full-width\" [@contentAnimationLeft]=\"getContentAnimationState()\">\n            <ng-content select=\"[app-layout-content]\"></ng-content>\n        </div>\n    </div>\n</mat-sidenav-container>\n", styles: ["adf-layout-container{display:block;width:100%;height:100%;overflow:hidden}.adf-container-full-width{width:inherit}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-container-full-width{width:100%}}.adf-sidenav--hidden{visibility:hidden!important;width:0!important;transform:unset!important;opacity:0!important}.mat-sidenav-container{display:block;width:100%;height:100%;overflow:hidden}.mat-sidenav{overflow:hidden;border-right:1px solid var(--adf-theme-foreground-text-color-007);background-color:var(--theme-background-color)}mat-sidenav-content.mat-sidenav-content,.mat-drawer-transition .mat-drawer-content{margin-left:0!important;transform:unset!important;transition-property:unset!important;transition-duration:unset!important;transition-timing-function:unset!important}mat-sidenav-content>div{display:flex;height:100%}mat-sidenav-content>div>div{flex:auto}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$8.MatSidenav, selector: "mat-sidenav", inputs: ["fixedInViewport", "fixedTopGap", "fixedBottomGap"], exportAs: ["matSidenav"] }, { kind: "component", type: i2$8.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }], animations: [sidenavAnimation, contentAnimation], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LayoutContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-layout-container', encapsulation: ViewEncapsulation.None, animations: [sidenavAnimation, contentAnimation], template: "<mat-sidenav-container>\n    <mat-sidenav\n        [position]=\"position\"\n        [disableClose]=\"!isMobileScreenSize\"\n        [ngClass]=\"{ 'adf-sidenav--hidden': hideSidenav }\"\n        [@sidenavAnimation]=\"sidenavAnimationState\"\n        [opened]=\"!isMobileScreenSize\"\n        [mode]=\"isMobileScreenSize ? 'over' : 'side'\">\n        <ng-content sidenav select=\"[app-layout-navigation]\"></ng-content>\n    </mat-sidenav>\n\n    <div>\n        <div class=\"adf-container-full-width\" [@contentAnimationLeft]=\"getContentAnimationState()\">\n            <ng-content select=\"[app-layout-content]\"></ng-content>\n        </div>\n    </div>\n</mat-sidenav-container>\n", styles: ["adf-layout-container{display:block;width:100%;height:100%;overflow:hidden}.adf-container-full-width{width:inherit}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-container-full-width{width:100%}}.adf-sidenav--hidden{visibility:hidden!important;width:0!important;transform:unset!important;opacity:0!important}.mat-sidenav-container{display:block;width:100%;height:100%;overflow:hidden}.mat-sidenav{overflow:hidden;border-right:1px solid var(--adf-theme-foreground-text-color-007);background-color:var(--theme-background-color)}mat-sidenav-content.mat-sidenav-content,.mat-drawer-transition .mat-drawer-content{margin-left:0!important;transform:unset!important;transition-property:unset!important;transition-duration:unset!important;transition-timing-function:unset!important}mat-sidenav-content>div{display:flex;height:100%}mat-sidenav-content>div>div{flex:auto}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { sidenavMin: [{
                type: Input
            }], sidenavMax: [{
                type: Input
            }], mediaQueryList: [{
                type: Input
            }], hideSidenav: [{
                type: Input
            }], expandedSidenav: [{
                type: Input
            }], position: [{
                type: Input
            }], direction: [{
                type: Input
            }], sidenav: [{
                type: ViewChild,
                args: [MatSidenav, { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidebarActionMenuComponent {
    constructor() {
        /** Width in pixels for sidebar action menu options. */
        this.width = 272;
    }
    isExpanded() {
        return this.expanded;
    }
}
SidebarActionMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarActionMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SidebarActionMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SidebarActionMenuComponent, selector: "adf-sidebar-action-menu", inputs: { title: "title", expanded: "expanded", width: "width" }, host: { classAttribute: "adf-sidebar-action-menu" }, ngImport: i0, template: "<div class=\"adf-sidebar-action-menu\">\n    <button *ngIf=\"isExpanded()\" mat-raised-button class=\"adf-sidebar-action-menu-button\" data-automation-id=\"create-button\" [matMenuTriggerFor]=\"adfSidebarMenu\">\n        <span *ngIf=\"title\" class=\"adf-sidebar-action-menu-text\">{{ title }}</span>\n        <ng-content select=\"[adf-sidebar-menu-title-icon], [sidebar-menu-title-icon]\"></ng-content>\n    </button>\n\n    <div *ngIf=\"!isExpanded()\" class=\"adf-sidebar-action-menu-icon\" [matMenuTriggerFor]=\"adfSidebarMenu\">\n        <ng-content select=\"[adf-sidebar-menu-expand-icon], [sidebar-menu-expand-icon]\"></ng-content>\n    </div>\n\n    <mat-menu #adfSidebarMenu=\"matMenu\" class=\"adf-sidebar-action-menu-panel\" [overlapTrigger]=\"false\" yPosition=\"below\">\n        <div class=\"adf-sidebar-action-menu-options\" [style.width.px]=\"width\">\n            <ng-content select=\"[adf-sidebar-menu-options], [sidebar-menu-options]\"></ng-content>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-sidebar-action-menu .mat-raised-button{width:100%;display:block;box-shadow:none!important;height:37.5px;font-weight:700;background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast)!important;border-radius:4px}.adf-sidebar-action-menu .mat-raised-button mat-icon{width:24px;height:25px;color:var(--theme-primary-color-default-contrast)!important}.adf-sidebar-action-menu-text{width:100%;height:20px;text-align:left}.adf-sidebar-action-menu-icon{margin:18px 0 0 20px;color:var(--adf-theme-foreground-text-color-054);cursor:pointer}.adf-sidebar-action-menu-icon:hover{color:var(--theme-primary-color)}.adf-sidebar-action-menu-options{text-align:left;letter-spacing:-.4px}.adf-sidebar-action-menu-options .mat-menu-item{font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087);text-align:left;line-height:1.5;letter-spacing:-.4px}.adf-sidebar-action-menu-options .mat-menu-item:hover{color:var(--theme-primary-color);opacity:inherit}.adf-sidebar-action-menu-panel{margin-top:7.5px;border-radius:2px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarActionMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-sidebar-action-menu', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: { class: 'adf-sidebar-action-menu' }, template: "<div class=\"adf-sidebar-action-menu\">\n    <button *ngIf=\"isExpanded()\" mat-raised-button class=\"adf-sidebar-action-menu-button\" data-automation-id=\"create-button\" [matMenuTriggerFor]=\"adfSidebarMenu\">\n        <span *ngIf=\"title\" class=\"adf-sidebar-action-menu-text\">{{ title }}</span>\n        <ng-content select=\"[adf-sidebar-menu-title-icon], [sidebar-menu-title-icon]\"></ng-content>\n    </button>\n\n    <div *ngIf=\"!isExpanded()\" class=\"adf-sidebar-action-menu-icon\" [matMenuTriggerFor]=\"adfSidebarMenu\">\n        <ng-content select=\"[adf-sidebar-menu-expand-icon], [sidebar-menu-expand-icon]\"></ng-content>\n    </div>\n\n    <mat-menu #adfSidebarMenu=\"matMenu\" class=\"adf-sidebar-action-menu-panel\" [overlapTrigger]=\"false\" yPosition=\"below\">\n        <div class=\"adf-sidebar-action-menu-options\" [style.width.px]=\"width\">\n            <ng-content select=\"[adf-sidebar-menu-options], [sidebar-menu-options]\"></ng-content>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-sidebar-action-menu .mat-raised-button{width:100%;display:block;box-shadow:none!important;height:37.5px;font-weight:700;background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast)!important;border-radius:4px}.adf-sidebar-action-menu .mat-raised-button mat-icon{width:24px;height:25px;color:var(--theme-primary-color-default-contrast)!important}.adf-sidebar-action-menu-text{width:100%;height:20px;text-align:left}.adf-sidebar-action-menu-icon{margin:18px 0 0 20px;color:var(--adf-theme-foreground-text-color-054);cursor:pointer}.adf-sidebar-action-menu-icon:hover{color:var(--theme-primary-color)}.adf-sidebar-action-menu-options{text-align:left;letter-spacing:-.4px}.adf-sidebar-action-menu-options .mat-menu-item{font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087);text-align:left;line-height:1.5;letter-spacing:-.4px}.adf-sidebar-action-menu-options .mat-menu-item:hover{color:var(--theme-primary-color);opacity:inherit}.adf-sidebar-action-menu-panel{margin-top:7.5px;border-radius:2px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], expanded: [{
                type: Input
            }], width: [{
                type: Input
            }] } });
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class SidebarMenuDirective {
}
SidebarMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidebarMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidebarMenuDirective, selector: "[adf-sidebar-menu-options], [sidebar-menu-options]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-sidebar-menu-options], [sidebar-menu-options]' }]
        }] });
class SidebarMenuTitleIconDirective {
}
SidebarMenuTitleIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuTitleIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidebarMenuTitleIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidebarMenuTitleIconDirective, selector: "[adf-sidebar-menu-title-icon], [sidebar-menu-title-icon]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuTitleIconDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-sidebar-menu-title-icon], [sidebar-menu-title-icon]' }]
        }] });
class SidebarMenuExpandIconDirective {
}
SidebarMenuExpandIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuExpandIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidebarMenuExpandIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidebarMenuExpandIconDirective, selector: "[adf-sidebar-menu-expand-icon], [sidebar-menu-expand-icon]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidebarMenuExpandIconDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[adf-sidebar-menu-expand-icon], [sidebar-menu-expand-icon]' }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidenavLayoutContentDirective {
}
SidenavLayoutContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidenavLayoutContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidenavLayoutContentDirective, selector: "adf-sidenav-layout-content", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-sidenav-layout-content'
                }]
        }], propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidenavLayoutHeaderDirective {
}
SidenavLayoutHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutHeaderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidenavLayoutHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidenavLayoutHeaderDirective, selector: "adf-sidenav-layout-header", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-sidenav-layout-header'
                }]
        }], propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidenavLayoutNavigationDirective {
}
SidenavLayoutNavigationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutNavigationDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SidenavLayoutNavigationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SidenavLayoutNavigationDirective, selector: "adf-sidenav-layout-navigation", queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutNavigationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'adf-sidenav-layout-navigation'
                }]
        }], propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidenavLayoutComponent {
    constructor(mediaMatcher, userPreferencesService) {
        this.mediaMatcher = mediaMatcher;
        this.userPreferencesService = userPreferencesService;
        /** The direction of the layout. 'ltr' or 'rtl' */
        this.dir = 'ltr';
        /** The side that the drawer is attached to. Possible values are 'start' and 'end'. */
        this.position = 'start';
        /** Toggles showing/hiding the navigation region. */
        this.hideSidenav = false;
        /** Should the navigation region be expanded initially? */
        this.expandedSidenav = true;
        /** Emitted when the menu toggle and the collapsed/expanded state of the sideNav changes. */
        this.expanded = new EventEmitter();
        this.templateContext = {
            toggleMenu: () => { },
            isMenuMinimized: () => this.isMenuMinimized
        };
        this.onDestroy$ = new Subject();
        this.onMediaQueryChange = this.onMediaQueryChange.bind(this);
    }
    ngOnInit() {
        const initialMenuState = !this.expandedSidenav;
        this.menuOpenStateSubject = new BehaviorSubject(initialMenuState);
        this.menuOpenState$ = this.menuOpenStateSubject.asObservable();
        const stepOver = this.stepOver || SidenavLayoutComponent.STEP_OVER;
        this.isMenuMinimized = initialMenuState;
        this.mediaQueryList = this.mediaMatcher.matchMedia(`(max-width: ${stepOver}px)`);
        this.mediaQueryList.addListener(this.onMediaQueryChange);
        this.userPreferencesService
            .select('textOrientation')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((direction) => {
            this.dir = direction;
        });
    }
    ngAfterViewInit() {
        this.templateContext.toggleMenu = this.toggleMenu.bind(this);
    }
    ngOnDestroy() {
        this.mediaQueryList.removeListener(this.onMediaQueryChange);
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    toggleMenu() {
        if (!this.mediaQueryList.matches) {
            this.isMenuMinimized = !this.isMenuMinimized;
        }
        else {
            this.isMenuMinimized = false;
        }
        this.container.toggleMenu();
        this.expanded.emit(!this.isMenuMinimized);
    }
    get isMenuMinimized() {
        return this._isMenuMinimized;
    }
    set isMenuMinimized(menuState) {
        this._isMenuMinimized = menuState;
        this.menuOpenStateSubject.next(!menuState);
    }
    get isHeaderInside() {
        return this.mediaQueryList.matches;
    }
    get headerTemplate() {
        return this?.headerDirective?.template || this.emptyTemplate;
    }
    get navigationTemplate() {
        return this?.navigationDirective?.template || this.emptyTemplate;
    }
    get contentTemplate() {
        return this?.contentDirective?.template || this.emptyTemplate;
    }
    onMediaQueryChange() {
        this.isMenuMinimized = false;
        this.expanded.emit(!this.isMenuMinimized);
    }
}
SidenavLayoutComponent.STEP_OVER = 600;
SidenavLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutComponent, deps: [{ token: i1$8.MediaMatcher }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
SidenavLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SidenavLayoutComponent, selector: "adf-sidenav-layout", inputs: { position: "position", sidenavMin: "sidenavMin", sidenavMax: "sidenavMax", stepOver: "stepOver", hideSidenav: "hideSidenav", expandedSidenav: "expandedSidenav" }, outputs: { expanded: "expanded" }, host: { classAttribute: "adf-sidenav-layout" }, queries: [{ propertyName: "headerDirective", first: true, predicate: SidenavLayoutHeaderDirective, descendants: true }, { propertyName: "navigationDirective", first: true, predicate: SidenavLayoutNavigationDirective, descendants: true }, { propertyName: "contentDirective", first: true, predicate: SidenavLayoutContentDirective, descendants: true }], viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true, static: true }, { propertyName: "emptyTemplate", first: true, predicate: ["emptyTemplate"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"adf-sidenav-layout-full-space\">\n    <ng-container *ngIf=\"!isHeaderInside\">\n        <ng-container class=\"adf-sidenav-layout-outer-header\"\n                      *ngTemplateOutlet=\"headerTemplate; context:templateContext\"></ng-container>\n    </ng-container>\n\n    <adf-layout-container #container\n                          [direction]=\"dir\"\n                          [position]=\"position\"\n                          [sidenavMin]=\"sidenavMin\"\n                          [sidenavMax]=\"sidenavMax\"\n                          [mediaQueryList]=\"mediaQueryList\"\n                          [hideSidenav]=\"hideSidenav\"\n                          [expandedSidenav]=\"expandedSidenav\"\n                          data-automation-id=\"adf-layout-container\"\n                          class=\"adf-layout__content\">\n\n        <ng-container app-layout-navigation\n                      *ngTemplateOutlet=\"navigationTemplate; context:templateContext\"></ng-container>\n\n        <ng-container app-layout-content>\n            <ng-container *ngIf=\"isHeaderInside\">\n                <ng-container *ngTemplateOutlet=\"headerTemplate; context:templateContext\"></ng-container>\n            </ng-container>\n            <ng-container *ngTemplateOutlet=\"contentTemplate; context:templateContext\"></ng-container>\n        </ng-container>\n    </adf-layout-container>\n\n    <ng-template #emptyTemplate></ng-template>\n</div>\n", styles: [".adf-sidenav-layout,.adf-sidenav-layout-full-space{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;width:100%}.adf-sidenav-layout .adf-layout__content{flex:1 1 auto}.adf-sidenav-layout router-outlet{flex:0 0}@media (max-width: 599.9px){.adf-sidenav-layout .mat-drawer{width:calc(-50px + 100vw)!important;max-width:300px!important}}.adf-sidenav-layout .mat-drawer-content{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;position:unset;overflow:auto}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: LayoutContainerComponent, selector: "adf-layout-container", inputs: ["sidenavMin", "sidenavMax", "mediaQueryList", "hideSidenav", "expandedSidenav", "position", "direction"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-sidenav-layout', encapsulation: ViewEncapsulation.None, host: { class: 'adf-sidenav-layout' }, template: "<div class=\"adf-sidenav-layout-full-space\">\n    <ng-container *ngIf=\"!isHeaderInside\">\n        <ng-container class=\"adf-sidenav-layout-outer-header\"\n                      *ngTemplateOutlet=\"headerTemplate; context:templateContext\"></ng-container>\n    </ng-container>\n\n    <adf-layout-container #container\n                          [direction]=\"dir\"\n                          [position]=\"position\"\n                          [sidenavMin]=\"sidenavMin\"\n                          [sidenavMax]=\"sidenavMax\"\n                          [mediaQueryList]=\"mediaQueryList\"\n                          [hideSidenav]=\"hideSidenav\"\n                          [expandedSidenav]=\"expandedSidenav\"\n                          data-automation-id=\"adf-layout-container\"\n                          class=\"adf-layout__content\">\n\n        <ng-container app-layout-navigation\n                      *ngTemplateOutlet=\"navigationTemplate; context:templateContext\"></ng-container>\n\n        <ng-container app-layout-content>\n            <ng-container *ngIf=\"isHeaderInside\">\n                <ng-container *ngTemplateOutlet=\"headerTemplate; context:templateContext\"></ng-container>\n            </ng-container>\n            <ng-container *ngTemplateOutlet=\"contentTemplate; context:templateContext\"></ng-container>\n        </ng-container>\n    </adf-layout-container>\n\n    <ng-template #emptyTemplate></ng-template>\n</div>\n", styles: [".adf-sidenav-layout,.adf-sidenav-layout-full-space{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;width:100%}.adf-sidenav-layout .adf-layout__content{flex:1 1 auto}.adf-sidenav-layout router-outlet{flex:0 0}@media (max-width: 599.9px){.adf-sidenav-layout .mat-drawer{width:calc(-50px + 100vw)!important;max-width:300px!important}}.adf-sidenav-layout .mat-drawer-content{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0;position:unset;overflow:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$8.MediaMatcher }, { type: UserPreferencesService }]; }, propDecorators: { position: [{
                type: Input
            }], sidenavMin: [{
                type: Input
            }], sidenavMax: [{
                type: Input
            }], stepOver: [{
                type: Input
            }], hideSidenav: [{
                type: Input
            }], expandedSidenav: [{
                type: Input
            }], expanded: [{
                type: Output
            }], headerDirective: [{
                type: ContentChild,
                args: [SidenavLayoutHeaderDirective]
            }], navigationDirective: [{
                type: ContentChild,
                args: [SidenavLayoutNavigationDirective]
            }], contentDirective: [{
                type: ContentChild,
                args: [SidenavLayoutContentDirective]
            }], container: [{
                type: ViewChild,
                args: ['container', { static: true }]
            }], emptyTemplate: [{
                type: ViewChild,
                args: ['emptyTemplate', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SidenavLayoutModule {
}
SidenavLayoutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SidenavLayoutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutModule, declarations: [SidenavLayoutHeaderDirective,
        SidenavLayoutContentDirective,
        SidenavLayoutNavigationDirective,
        SidenavLayoutComponent,
        LayoutContainerComponent,
        SidebarActionMenuComponent,
        SidebarMenuDirective,
        SidebarMenuExpandIconDirective,
        SidebarMenuTitleIconDirective,
        HeaderLayoutComponent], imports: [CommonModule,
        MaterialModule,
        RouterModule,
        TranslateModule], exports: [SidenavLayoutHeaderDirective,
        SidenavLayoutContentDirective,
        SidenavLayoutNavigationDirective,
        SidenavLayoutComponent,
        LayoutContainerComponent,
        SidebarActionMenuComponent,
        SidebarMenuDirective,
        SidebarMenuExpandIconDirective,
        SidebarMenuTitleIconDirective,
        HeaderLayoutComponent] });
SidenavLayoutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutModule, imports: [CommonModule,
        MaterialModule,
        RouterModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SidenavLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        RouterModule,
                        TranslateModule
                    ],
                    exports: [
                        SidenavLayoutHeaderDirective,
                        SidenavLayoutContentDirective,
                        SidenavLayoutNavigationDirective,
                        SidenavLayoutComponent,
                        LayoutContainerComponent,
                        SidebarActionMenuComponent,
                        SidebarMenuDirective,
                        SidebarMenuExpandIconDirective,
                        SidebarMenuTitleIconDirective,
                        HeaderLayoutComponent
                    ],
                    declarations: [
                        SidenavLayoutHeaderDirective,
                        SidenavLayoutContentDirective,
                        SidenavLayoutNavigationDirective,
                        SidenavLayoutComponent,
                        LayoutContainerComponent,
                        SidebarActionMenuComponent,
                        SidebarMenuDirective,
                        SidebarMenuExpandIconDirective,
                        SidebarMenuTitleIconDirective,
                        HeaderLayoutComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ADF_COMMENTS_SERVICE = new InjectionToken('ADF_COMMENTS_SERVICE');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CommentListComponent {
    constructor(commentsService, userPreferenceService) {
        this.commentsService = commentsService;
        this.userPreferenceService = userPreferenceService;
        /** Emitted when the user clicks on one of the comment rows. */
        this.clickRow = new EventEmitter();
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.userPreferenceService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => this.currentLocale = locale);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    selectComment(comment) {
        if (this.selectedComment) {
            this.selectedComment.isSelected = false;
        }
        comment.isSelected = true;
        this.selectedComment = comment;
        this.clickRow.emit(this.selectedComment);
    }
    getUserShortName(user) {
        let shortName = '';
        if (user) {
            if (user.firstName) {
                shortName = user.firstName[0].toUpperCase();
            }
            if (user.lastName) {
                shortName += user.lastName[0].toUpperCase();
            }
        }
        return shortName;
    }
    isPictureDefined(user) {
        return user.pictureId || user.avatarId;
    }
    getUserImage(user) {
        return this.commentsService.getUserImage(user);
    }
}
CommentListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentListComponent, deps: [{ token: ADF_COMMENTS_SERVICE }, { token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
CommentListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CommentListComponent, selector: "adf-comment-list", inputs: { comments: "comments" }, outputs: { clickRow: "clickRow" }, ngImport: i0, template: " <mat-list class=\"adf-comment-list\">\n    <mat-list-item *ngFor=\"let comment of comments\"\n                  (click)=\"selectComment(comment)\"\n                  class=\"adf-comment-list-item\"\n                  [class.adf-is-selected]=\"comment.isSelected\"\n                  id=\"adf-comment-{{comment?.id}}\">\n        <div [attr.id]=\"'comment-user-icon-' + comment.id\" class=\"adf-comment-img-container\">\n            <div\n                *ngIf=\"!isPictureDefined(comment.createdBy)\"\n                class=\"adf-comment-user-icon\">\n                {{getUserShortName(comment.createdBy)}}\n            </div>\n            <div>\n                <img [alt]=\"comment.createdBy\" *ngIf=\"isPictureDefined(comment.createdBy)\"\n                      class=\"adf-people-img\"\n                     [src]=\"getUserImage(comment.createdBy)\" />\n            </div>\n        </div>\n        <div class=\"adf-comment-contents\">\n            <div matLine [attr.id]=\"'comment-user-' + comment.id\" class=\"adf-comment-user-name\">\n                {{comment.createdBy?.firstName}} {{comment.createdBy?.lastName}}\n            </div>\n            <div matLine [attr.id]=\"'comment-message-' + comment.id\" class=\"adf-comment-message\" [innerHTML]=\"comment.message\">\n            </div>\n            <div matLine [attr.id]=\"'comment-time-' + comment.id\" class=\"adf-comment-message-time\">\n                {{ comment.created | adfTimeAgo: currentLocale }}\n            </div>\n        </div>\n    </mat-list-item>\n</mat-list>\n", styles: [".adf-is-selected{background:var(--adf-theme-primary-100)}.adf-comment-img-container{float:left;width:40px;height:100%;display:flex;align-self:flex-start;padding-top:18px}.adf-comment-list-item{white-space:initial;display:table-row-group;padding-top:12px;overflow:hidden;height:100%!important;transition:background .8s;background-position:center}.adf-comment-list-item:hover{background:var(--adf-theme-primary-100) radial-gradient(circle,transparent 1%,var(--adf-theme-primary-100) 1%) center/15000%}.adf-comment-list-item:active{background-color:var(--adf-theme-primary-300);background-size:100%;transition:background 0s}.adf-comment-user-icon{padding:10px 5px;width:30px;background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast);border-radius:50%;font-size:var(--theme-subheading-2-font-size);text-align:center;height:20px;background-size:cover}.adf-comment-user-name{float:left;width:90%;padding:2px 10px;font-weight:600;font-size:var(--theme-body-1-font-size)}.adf-comment-message{float:left;width:calc(100% - 10px);padding:2px 10px;font-style:italic;white-space:initial!important;font-size:var(--theme-body-1-font-size);letter-spacing:-.2px;line-height:1.43;color:var(--adf-theme-foreground-text-color)}.adf-comment-message-time{float:left;width:90%;padding:2px 10px;font-size:var(--theme-caption-font-size)!important;color:var(--adf-theme-foreground-text-color)}.adf-comment-contents{width:calc(100% - 10px);padding-top:12px;padding-bottom:12px;padding-left:5px}.adf-people-img{border-radius:90%;width:40px;height:40px;vertical-align:middle}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i7$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i2$7.MatLine, selector: "[mat-line], [matLine]" }, { kind: "pipe", type: TimeAgoPipe, name: "adfTimeAgo" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-comment-list', encapsulation: ViewEncapsulation.None, template: " <mat-list class=\"adf-comment-list\">\n    <mat-list-item *ngFor=\"let comment of comments\"\n                  (click)=\"selectComment(comment)\"\n                  class=\"adf-comment-list-item\"\n                  [class.adf-is-selected]=\"comment.isSelected\"\n                  id=\"adf-comment-{{comment?.id}}\">\n        <div [attr.id]=\"'comment-user-icon-' + comment.id\" class=\"adf-comment-img-container\">\n            <div\n                *ngIf=\"!isPictureDefined(comment.createdBy)\"\n                class=\"adf-comment-user-icon\">\n                {{getUserShortName(comment.createdBy)}}\n            </div>\n            <div>\n                <img [alt]=\"comment.createdBy\" *ngIf=\"isPictureDefined(comment.createdBy)\"\n                      class=\"adf-people-img\"\n                     [src]=\"getUserImage(comment.createdBy)\" />\n            </div>\n        </div>\n        <div class=\"adf-comment-contents\">\n            <div matLine [attr.id]=\"'comment-user-' + comment.id\" class=\"adf-comment-user-name\">\n                {{comment.createdBy?.firstName}} {{comment.createdBy?.lastName}}\n            </div>\n            <div matLine [attr.id]=\"'comment-message-' + comment.id\" class=\"adf-comment-message\" [innerHTML]=\"comment.message\">\n            </div>\n            <div matLine [attr.id]=\"'comment-time-' + comment.id\" class=\"adf-comment-message-time\">\n                {{ comment.created | adfTimeAgo: currentLocale }}\n            </div>\n        </div>\n    </mat-list-item>\n</mat-list>\n", styles: [".adf-is-selected{background:var(--adf-theme-primary-100)}.adf-comment-img-container{float:left;width:40px;height:100%;display:flex;align-self:flex-start;padding-top:18px}.adf-comment-list-item{white-space:initial;display:table-row-group;padding-top:12px;overflow:hidden;height:100%!important;transition:background .8s;background-position:center}.adf-comment-list-item:hover{background:var(--adf-theme-primary-100) radial-gradient(circle,transparent 1%,var(--adf-theme-primary-100) 1%) center/15000%}.adf-comment-list-item:active{background-color:var(--adf-theme-primary-300);background-size:100%;transition:background 0s}.adf-comment-user-icon{padding:10px 5px;width:30px;background-color:var(--theme-primary-color);color:var(--theme-primary-color-default-contrast);border-radius:50%;font-size:var(--theme-subheading-2-font-size);text-align:center;height:20px;background-size:cover}.adf-comment-user-name{float:left;width:90%;padding:2px 10px;font-weight:600;font-size:var(--theme-body-1-font-size)}.adf-comment-message{float:left;width:calc(100% - 10px);padding:2px 10px;font-style:italic;white-space:initial!important;font-size:var(--theme-body-1-font-size);letter-spacing:-.2px;line-height:1.43;color:var(--adf-theme-foreground-text-color)}.adf-comment-message-time{float:left;width:90%;padding:2px 10px;font-size:var(--theme-caption-font-size)!important;color:var(--adf-theme-foreground-text-color)}.adf-comment-contents{width:calc(100% - 10px);padding-top:12px;padding-bottom:12px;padding-left:5px}.adf-people-img{border-radius:90%;width:40px;height:40px;vertical-align:middle}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ADF_COMMENTS_SERVICE]
                }] }, { type: UserPreferencesService }]; }, propDecorators: { comments: [{
                type: Input
            }], clickRow: [{
                type: Output
            }] } });

class CommentsComponent {
    constructor(commentsService) {
        this.commentsService = commentsService;
        /** Are the comments read only? */
        this.readOnly = false;
        /** Emitted when an error occurs while displaying/adding a comment. */
        this.error = new EventEmitter();
        this.comments = [];
        this.beingAdded = false;
        this.comment$ = new Observable((observer) => this.commentObserver = observer)
            .pipe(share());
        this.comment$.subscribe((comment) => {
            this.comments.push(comment);
        });
    }
    ngOnChanges(changes) {
        this.id = null;
        this.id = changes['id'] ? changes['id'].currentValue : null;
        if (this.id) {
            this.loadComments();
        }
        else {
            this.resetComments();
        }
    }
    loadComments() {
        this.resetComments();
        if (!this.hasId()) {
            return;
        }
        this.commentsService.get(this.id).subscribe((comments) => {
            if (!this.isArrayInstance(comments)) {
                return;
            }
            comments = this.sortedComments(comments);
            this.addCommentsToObserver(comments);
        }, (err) => {
            this.error.emit(err);
        });
    }
    addComment() {
        if (!this.canAddComment()) {
            return;
        }
        const comment = this.sanitize(this.message);
        this.beingAdded = true;
        this.commentsService.add(this.id, comment)
            .subscribe((res) => {
            this.addToComments(res);
            this.resetMessage();
        }, (err) => {
            this.error.emit(err);
        }, () => {
            this.beingAdded = false;
        });
    }
    clearMessage(event) {
        event.stopPropagation();
        this.resetMessage();
    }
    addToComments(comment) {
        this.comments.unshift(comment);
    }
    resetMessage() {
        this.message = '';
    }
    canAddComment() {
        return this.hasId() && this.message && this.message.trim() && !this.beingAdded;
    }
    hasId() {
        return !!this.id;
    }
    isArrayInstance(entity) {
        return entity && entity instanceof Array;
    }
    sortedComments(comments) {
        return comments.sort((comment1, comment2) => {
            const date1 = new Date(comment1.created);
            const date2 = new Date(comment2.created);
            return date1 > date2 ? -1 : date1 < date2 ? 1 : 0;
        });
    }
    addCommentsToObserver(comments) {
        comments.forEach((currentComment) => {
            this.commentObserver.next(currentComment);
        });
    }
    resetComments() {
        this.comments = [];
    }
    sanitize(input) {
        return input.replace(/<[^>]+>/g, '')
            .replace(/^\s+|\s+$|\s+(?=\s)/g, '')
            .replace(/\r?\n/g, '<br/>');
    }
}
CommentsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentsComponent, deps: [{ token: ADF_COMMENTS_SERVICE }], target: i0.ɵɵFactoryTarget.Component });
CommentsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CommentsComponent, selector: "adf-comments", inputs: { id: "id", readOnly: "readOnly" }, outputs: { error: "error" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"adf-comments-container\">\n    <div id=\"comment-header\" class=\"adf-comments-header\">\n        {{'COMMENTS.HEADER' | translate: { count: comments?.length } }}\n    </div>\n    <div class=\"adf-comments-input-container\" *ngIf=\"!readOnly\">\n            <mat-form-field class=\"adf-full-width\">\n                <textarea \n                    matInput\n                    id=\"comment-input\"\n                    [attr.aria-label]=\"'COMMENTS.ADD' | translate\"\n                    placeholder=\"{{'COMMENTS.ADD' | translate}}\"\n                    [(ngModel)]=\"message\"\n                    (keydown.escape)=\"clearMessage($event)\"\n                >\n                </textarea>\n            </mat-form-field>\n\n            <div class=\"adf-comments-input-actions\">\n                <button \n                    mat-button\n                    class=\"adf-comments-input-add\"\n                    data-automation-id=\"comments-input-add\"\n                    color=\"primary\"\n                    (click)=\"addComment()\"\n                    [disabled]=\"!message\"\n                >\n                    {{ 'COMMENTS.ADD' | translate }}\n                </button>\n            </div>\n    </div>\n\n    <div *ngIf=\"comments.length > 0\">\n        <adf-comment-list [comments]=\"comments\">\n        </adf-comment-list>\n    </div>\n</div>\n", styles: [".adf-comments-container{height:100%;width:100%;overflow:auto}.adf-comments-header{padding:10px 20px;font-size:var(--theme-body-1-font-size);font-weight:600;border-bottom:1px solid var(--adf-theme-foreground-divider-color);margin:0}.adf-comments-input-container{width:calc(100% - 30px);padding:8px 15px 0;border-bottom:1px solid var(--adf-theme-foreground-divider-color)}.adf-comments-input-container textarea{resize:vertical}.adf-comments-input-actions{display:flex;justify-content:flex-end;margin-bottom:10px}.adf-full-width{width:100%}adf-comment-list{float:left;overflow:auto;height:calc(100% - 101px);width:100%}\n"], dependencies: [{ kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: CommentListComponent, selector: "adf-comment-list", inputs: ["comments"], outputs: ["clickRow"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-comments', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-comments-container\">\n    <div id=\"comment-header\" class=\"adf-comments-header\">\n        {{'COMMENTS.HEADER' | translate: { count: comments?.length } }}\n    </div>\n    <div class=\"adf-comments-input-container\" *ngIf=\"!readOnly\">\n            <mat-form-field class=\"adf-full-width\">\n                <textarea \n                    matInput\n                    id=\"comment-input\"\n                    [attr.aria-label]=\"'COMMENTS.ADD' | translate\"\n                    placeholder=\"{{'COMMENTS.ADD' | translate}}\"\n                    [(ngModel)]=\"message\"\n                    (keydown.escape)=\"clearMessage($event)\"\n                >\n                </textarea>\n            </mat-form-field>\n\n            <div class=\"adf-comments-input-actions\">\n                <button \n                    mat-button\n                    class=\"adf-comments-input-add\"\n                    data-automation-id=\"comments-input-add\"\n                    color=\"primary\"\n                    (click)=\"addComment()\"\n                    [disabled]=\"!message\"\n                >\n                    {{ 'COMMENTS.ADD' | translate }}\n                </button>\n            </div>\n    </div>\n\n    <div *ngIf=\"comments.length > 0\">\n        <adf-comment-list [comments]=\"comments\">\n        </adf-comment-list>\n    </div>\n</div>\n", styles: [".adf-comments-container{height:100%;width:100%;overflow:auto}.adf-comments-header{padding:10px 20px;font-size:var(--theme-body-1-font-size);font-weight:600;border-bottom:1px solid var(--adf-theme-foreground-divider-color);margin:0}.adf-comments-input-container{width:calc(100% - 30px);padding:8px 15px 0;border-bottom:1px solid var(--adf-theme-foreground-divider-color)}.adf-comments-input-container textarea{resize:vertical}.adf-comments-input-actions{display:flex;justify-content:flex-end;margin-bottom:10px}.adf-full-width{width:100%}adf-comment-list{float:left;overflow:auto;height:calc(100% - 101px);width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ADF_COMMENTS_SERVICE]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CommentListModule {
}
CommentListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CommentListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CommentListModule, declarations: [CommentListComponent], imports: [PipeModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatLineModule], exports: [CommentListComponent] });
CommentListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentListModule, imports: [PipeModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatLineModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PipeModule,
                        FormsModule,
                        CommonModule,
                        TranslateModule,
                        MatButtonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatListModule,
                        MatLineModule
                    ],
                    declarations: [
                        CommentListComponent
                    ],
                    exports: [
                        CommentListComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CommentsModule {
}
CommentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CommentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CommentsModule, declarations: [CommentsComponent], imports: [PipeModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatLineModule,
        CommentListModule], exports: [CommentsComponent] });
CommentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentsModule, imports: [PipeModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatLineModule,
        CommentListModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CommentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PipeModule,
                        FormsModule,
                        CommonModule,
                        TranslateModule,
                        MatButtonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatListModule,
                        MatLineModule,
                        CommentListModule
                    ],
                    declarations: [
                        CommentsComponent
                    ],
                    exports: [
                        CommentsComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ButtonsMenuComponent {
    ngAfterContentInit() {
        this.isMenuEmpty = this.buttons.length <= 0;
    }
    isMobile() {
        return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
}
ButtonsMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ButtonsMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ButtonsMenuComponent, selector: "adf-buttons-action-menu", queries: [{ propertyName: "buttons", predicate: MatMenuItem }], ngImport: i0, template: "<div id=\"adf-buttons-menu\" class=\"adf-buttons-menu\" *ngIf=\"!isMenuEmpty\">\n    <div *ngIf=\"isMobile()\">\n        <button mat-icon-button [matMenuTriggerFor]=\"editReportMenu\">\n            <mat-icon>more_vert</mat-icon>\n        </button>\n        <mat-menu #editReportMenu=\"matMenu\" class=\"adf-buttons-menu-mobile\">\n            <ng-content *ngTemplateOutlet=\"desktop\">\n            </ng-content>\n        </mat-menu>\n    </div>\n\n    <div *ngIf=\"!isMobile()\" class=\"adf-buttons-menu-desktop\">\n        <ng-content *ngTemplateOutlet=\"desktop\">\n        </ng-content>\n    </div>\n</div>\n\n<ng-template #desktop>\n    <ng-content></ng-content>\n</ng-template>", styles: [".adf-buttons-menu{margin-right:10px}.adf-buttons-menu div{display:flex}.adf-buttons-menu-mobile{margin-right:10px}.adf-buttons-menu-desktop{display:flex}.adf-buttons-menu-desktop button{color:#000;padding:0}.adf-buttons-menu-desktop button>span{display:none}.adf-buttons-menu-desktop button>mat-icon.mat-icon.material-icons{color:#000;margin:0 10px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-buttons-action-menu', encapsulation: ViewEncapsulation.None, template: "<div id=\"adf-buttons-menu\" class=\"adf-buttons-menu\" *ngIf=\"!isMenuEmpty\">\n    <div *ngIf=\"isMobile()\">\n        <button mat-icon-button [matMenuTriggerFor]=\"editReportMenu\">\n            <mat-icon>more_vert</mat-icon>\n        </button>\n        <mat-menu #editReportMenu=\"matMenu\" class=\"adf-buttons-menu-mobile\">\n            <ng-content *ngTemplateOutlet=\"desktop\">\n            </ng-content>\n        </mat-menu>\n    </div>\n\n    <div *ngIf=\"!isMobile()\" class=\"adf-buttons-menu-desktop\">\n        <ng-content *ngTemplateOutlet=\"desktop\">\n        </ng-content>\n    </div>\n</div>\n\n<ng-template #desktop>\n    <ng-content></ng-content>\n</ng-template>", styles: [".adf-buttons-menu{margin-right:10px}.adf-buttons-menu div{display:flex}.adf-buttons-menu-mobile{margin-right:10px}.adf-buttons-menu-desktop{display:flex}.adf-buttons-menu-desktop button{color:#000;padding:0}.adf-buttons-menu-desktop button>span{display:none}.adf-buttons-menu-desktop button>mat-icon.mat-icon.material-icons{color:#000;margin:0 10px}\n"] }]
        }], propDecorators: { buttons: [{
                type: ContentChildren,
                args: [MatMenuItem]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ButtonsMenuModule {
}
ButtonsMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonsMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuModule, declarations: [ButtonsMenuComponent], imports: [CommonModule,
        MatIconModule,
        MatMenuModule,
        TranslateModule], exports: [ButtonsMenuComponent, MatIconModule, MatMenuModule, MatButtonModule] });
ButtonsMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuModule, imports: [CommonModule,
        MatIconModule,
        MatMenuModule,
        TranslateModule, MatIconModule, MatMenuModule, MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ButtonsMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatMenuModule,
                        TranslateModule
                    ],
                    declarations: [ButtonsMenuComponent],
                    exports: [ButtonsMenuComponent, MatIconModule, MatMenuModule, MatButtonModule]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SortingPickerComponent {
    constructor() {
        /** Available sorting options */
        this.options = [];
        /** Current sorting direction */
        this.ascending = true;
        /** Raised each time sorting key gets changed. */
        this.valueChange = new EventEmitter();
        /** Raised each time direction gets changed. */
        this.sortingChange = new EventEmitter();
    }
    onOptionChanged(event) {
        this.selected = event.value;
        this.valueChange.emit(this.selected);
    }
    toggleSortDirection() {
        this.ascending = !this.ascending;
        this.sortingChange.emit(this.ascending);
    }
}
SortingPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SortingPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SortingPickerComponent, selector: "adf-sorting-picker", inputs: { options: "options", selected: "selected", ascending: "ascending" }, outputs: { valueChange: "valueChange", sortingChange: "sortingChange" }, host: { classAttribute: "adf-sorting-picker" }, ngImport: i0, template: "<mat-form-field floatLabel=\"always\">\n    <mat-label>{{'CORE.SEARCH.SORT_BY' | translate}}</mat-label>\n    <mat-select [(value)]=\"selected\" (selectionChange)=\"onOptionChanged($event)\">\n        <mat-option *ngFor=\"let option of options\" [value]=\"option.key\">\n            {{ option.label | translate }}\n        </mat-option>\n    </mat-select>\n</mat-form-field>\n\n<button *ngIf=\"selected\" mat-icon-button (click)=\"toggleSortDirection()\" aria-label=\"'CORE.SEARCH.TOGGLE_ASC_DESC_ORDER' | translate\">\n    <mat-icon *ngIf=\"ascending\">arrow_upward</mat-icon>\n    <mat-icon *ngIf=\"!ascending\">arrow_downward</mat-icon>\n</button>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "component", type: i1$6.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i2$7.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-sorting-picker', encapsulation: ViewEncapsulation.None, host: { class: 'adf-sorting-picker' }, template: "<mat-form-field floatLabel=\"always\">\n    <mat-label>{{'CORE.SEARCH.SORT_BY' | translate}}</mat-label>\n    <mat-select [(value)]=\"selected\" (selectionChange)=\"onOptionChanged($event)\">\n        <mat-option *ngFor=\"let option of options\" [value]=\"option.key\">\n            {{ option.label | translate }}\n        </mat-option>\n    </mat-select>\n</mat-form-field>\n\n<button *ngIf=\"selected\" mat-icon-button (click)=\"toggleSortDirection()\" aria-label=\"'CORE.SEARCH.TOGGLE_ASC_DESC_ORDER' | translate\">\n    <mat-icon *ngIf=\"ascending\">arrow_upward</mat-icon>\n    <mat-icon *ngIf=\"!ascending\">arrow_downward</mat-icon>\n</button>\n" }]
        }], propDecorators: { options: [{
                type: Input
            }], selected: [{
                type: Input
            }], ascending: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], sortingChange: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SortingPickerModule {
}
SortingPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SortingPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerModule, declarations: [SortingPickerComponent], imports: [CommonModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        TranslateModule], exports: [SortingPickerComponent] });
SortingPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerModule, imports: [CommonModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortingPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatIconModule,
                        MatSelectModule,
                        TranslateModule
                    ],
                    declarations: [
                        SortingPickerComponent
                    ],
                    exports: [
                        SortingPickerComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ErrorContentComponent {
    constructor(route, translateService) {
        this.route = route;
        this.translateService = translateService;
        /** Error code associated with this error. */
        this.errorCode = ErrorContentComponent.UNKNOWN_ERROR;
    }
    ngOnInit() {
        if (this.route) {
            this.route.params.subscribe(params => {
                const code = params['id'] || this.errorCode;
                const errorHasTranslation = this.checkErrorExists(code);
                this.errorCodeTranslated = errorHasTranslation ? code : ErrorContentComponent.UNKNOWN_ERROR;
            });
        }
    }
    checkErrorExists(errorCode) {
        const errorMessage = this.translateService.instant('ERROR_CONTENT.' + errorCode);
        return errorMessage !== ('ERROR_CONTENT.' + errorCode);
    }
}
ErrorContentComponent.UNKNOWN_ERROR = 'UNKNOWN';
ErrorContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ErrorContentComponent, deps: [{ token: i2$4.ActivatedRoute }, { token: TranslationService }], target: i0.ɵɵFactoryTarget.Component });
ErrorContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ErrorContentComponent, selector: "adf-error-content", inputs: { errorCode: "errorCode" }, host: { classAttribute: "adf-error-content" }, ngImport: i0, template: "<div class=\"adf-error-content\">\n    <p class=\"adf-error-content-code\">\n        {{ errorCodeTranslated }}\n    </p>\n    <div class=\"adf-error-content-shadow\"></div>\n    <p class=\"adf-error-content-title\">\n        {{ 'ERROR_CONTENT.' + errorCodeTranslated + '.TITLE' | translate }}\n    </p>\n    <p class=\"adf-error-content-description\">\n        {{ 'ERROR_CONTENT.' + errorCodeTranslated + '.DESCRIPTION' | translate }}\n    </p>\n    <ng-content select=\"[adf-error-content-actions]\"></ng-content>\n</div>\n", styles: [".adf-error-content{color:var(--adf-theme-foreground-text-color-054);display:flex;flex-direction:column;align-items:center}.adf-error-content-code{font-size:110px;font-weight:300;margin-top:200px;margin-bottom:45px}.adf-error-content-shadow{width:170px;height:3px;opacity:.54;box-shadow:0 10px 15px #00000063}.adf-error-content-title{font-size:46px;font-weight:400;margin-top:40px;margin-bottom:10px}.adf-error-content-description{font-size:var(--theme-headline-font-size);font-weight:400;text-align:center;width:50%;min-width:250px;margin-bottom:60px;line-height:30px}@media screen and (max-width: 959px){.adf-error-content-code{margin-top:100px;font-size:50px;margin-bottom:25px}.adf-error-content-shadow{width:100px}.adf-error-content-title{font-size:var(--theme-headline-font-size)}.adf-error-content-description{font-size:var(--theme-subheading-2-font-size)}}\n"], dependencies: [{ kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ErrorContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-error-content', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: { class: 'adf-error-content' }, template: "<div class=\"adf-error-content\">\n    <p class=\"adf-error-content-code\">\n        {{ errorCodeTranslated }}\n    </p>\n    <div class=\"adf-error-content-shadow\"></div>\n    <p class=\"adf-error-content-title\">\n        {{ 'ERROR_CONTENT.' + errorCodeTranslated + '.TITLE' | translate }}\n    </p>\n    <p class=\"adf-error-content-description\">\n        {{ 'ERROR_CONTENT.' + errorCodeTranslated + '.DESCRIPTION' | translate }}\n    </p>\n    <ng-content select=\"[adf-error-content-actions]\"></ng-content>\n</div>\n", styles: [".adf-error-content{color:var(--adf-theme-foreground-text-color-054);display:flex;flex-direction:column;align-items:center}.adf-error-content-code{font-size:110px;font-weight:300;margin-top:200px;margin-bottom:45px}.adf-error-content-shadow{width:170px;height:3px;opacity:.54;box-shadow:0 10px 15px #00000063}.adf-error-content-title{font-size:46px;font-weight:400;margin-top:40px;margin-bottom:10px}.adf-error-content-description{font-size:var(--theme-headline-font-size);font-weight:400;text-align:center;width:50%;min-width:250px;margin-bottom:60px;line-height:30px}@media screen and (max-width: 959px){.adf-error-content-code{margin-top:100px;font-size:50px;margin-bottom:25px}.adf-error-content-shadow{width:100px}.adf-error-content-title{font-size:var(--theme-headline-font-size)}.adf-error-content-description{font-size:var(--theme-subheading-2-font-size)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$4.ActivatedRoute }, { type: TranslationService }]; }, propDecorators: { errorCode: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EmptyContentComponent {
    constructor() {
        /** Material Icon to use. */
        this.icon = 'cake';
        /** String or Resource Key for the title. */
        this.title = '';
        /** String or Resource Key for the subtitle. */
        this.subtitle = '';
    }
}
EmptyContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EmptyContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: EmptyContentComponent, selector: "adf-empty-content", inputs: { icon: "icon", title: "title", subtitle: "subtitle" }, host: { classAttribute: "adf-empty-content" }, ngImport: i0, template: "<div class=\"adf-empty-content\" [title]=\"title | translate\">\n    <adf-icon class=\"adf-empty-content__icon\" [value]=\"icon\"></adf-icon>\n    <div class=\"adf-empty-content__title\">{{ title | translate }}</div>\n    <div class=\"adf-empty-content__subtitle\">{{ subtitle | translate }}</div>\n    <ng-content></ng-content>\n</div>\n", styles: [".adf-empty-content{color:var(--adf-theme-foreground-text-color-054);display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;width:100%}.adf-empty-content__icon .mat-icon{font-size:var(--theme-display-3-font-size);height:var(--theme-display-3-font-size)!important;width:var(--theme-display-3-font-size)!important}.adf-empty-content__title{font-size:var(--theme-adf-task-title-font-size);font-weight:600;line-height:0;white-space:normal;text-align:center;margin:10px 0}.adf-empty-content__subtitle,.adf-empty-content__text{font-size:var(--theme-body-1-font-size);font-weight:300;line-height:inherit;white-space:normal;text-align:center}.adf-empty-content .adf-icon{opacity:.6}\n"], dependencies: [{ kind: "component", type: IconComponent, selector: "adf-icon", inputs: ["color", "fontSet", "value"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptyContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-empty-content', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: { class: 'adf-empty-content' }, template: "<div class=\"adf-empty-content\" [title]=\"title | translate\">\n    <adf-icon class=\"adf-empty-content__icon\" [value]=\"icon\"></adf-icon>\n    <div class=\"adf-empty-content__title\">{{ title | translate }}</div>\n    <div class=\"adf-empty-content__subtitle\">{{ subtitle | translate }}</div>\n    <ng-content></ng-content>\n</div>\n", styles: [".adf-empty-content{color:var(--adf-theme-foreground-text-color-054);display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;width:100%}.adf-empty-content__icon .mat-icon{font-size:var(--theme-display-3-font-size);height:var(--theme-display-3-font-size)!important;width:var(--theme-display-3-font-size)!important}.adf-empty-content__title{font-size:var(--theme-adf-task-title-font-size);font-weight:600;line-height:0;white-space:normal;text-align:center;margin:10px 0}.adf-empty-content__subtitle,.adf-empty-content__text{font-size:var(--theme-body-1-font-size);font-weight:300;line-height:inherit;white-space:normal;text-align:center}.adf-empty-content .adf-icon{opacity:.6}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TemplateModule {
}
TemplateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TemplateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TemplateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: TemplateModule, declarations: [ErrorContentComponent, EmptyContentComponent], imports: [CommonModule, TranslateModule, IconModule], exports: [ErrorContentComponent, EmptyContentComponent, MatButtonModule] });
TemplateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TemplateModule, imports: [CommonModule, TranslateModule, IconModule, MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TemplateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslateModule, IconModule],
                    declarations: [ErrorContentComponent, EmptyContentComponent],
                    exports: [ErrorContentComponent, EmptyContentComponent, MatButtonModule]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NotificationHistoryComponent {
    constructor(notificationService, storageService, cd) {
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.cd = cd;
        /** Custom choice for opening the menu at the bottom. Can be `before` or `after`. */
        this.menuPositionX = 'after';
        /** Custom choice for opening the menu at the bottom. Can be `above` or `below`. */
        this.menuPositionY = 'below';
        /** Maximum number of notifications to display. The rest will remain hidden until load more is clicked */
        this.maxNotifications = 5;
        this.onDestroy$ = new Subject();
        this.notifications = [];
        this.paginatedNotifications = [];
    }
    ngOnInit() {
        this.notifications = JSON.parse(this.storageService.getItem(NotificationHistoryComponent.NOTIFICATION_STORAGE)) || [];
    }
    ngAfterViewInit() {
        this.notificationService.notifications$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((notification) => {
            this.addNewNotification(notification);
            this.cd.detectChanges();
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    addNewNotification(notification) {
        this.notifications.unshift(notification);
        if (this.notifications.length > NotificationHistoryComponent.MAX_NOTIFICATION_STACK_LENGTH) {
            this.notifications.shift();
        }
        this.saveNotifications();
        this.createPagination();
    }
    saveNotifications() {
        this.storageService.setItem(NotificationHistoryComponent.NOTIFICATION_STORAGE, JSON.stringify(this.notifications.filter((notification) => notification.type !== NOTIFICATION_TYPE.RECURSIVE)));
    }
    onMenuOpened() {
        this.createPagination();
    }
    onKeyPress(event) {
        this.closeUserModal(event);
    }
    closeUserModal($event) {
        if ($event.keyCode === 27) {
            this.trigger.closeMenu();
        }
    }
    markAsRead() {
        this.notifications = [];
        this.paginatedNotifications = [];
        this.storageService.removeItem(NotificationHistoryComponent.NOTIFICATION_STORAGE);
        this.createPagination();
        this.trigger.closeMenu();
    }
    createPagination() {
        this.pagination = {
            skipCount: this.maxNotifications,
            maxItems: this.maxNotifications,
            totalItems: this.notifications.length,
            hasMoreItems: this.notifications.length > this.maxNotifications
        };
        this.paginatedNotifications = this.notifications.slice(0, this.pagination.skipCount);
    }
    loadMore() {
        this.pagination.skipCount = this.pagination.maxItems + this.pagination.skipCount;
        this.pagination.hasMoreItems = this.notifications.length > this.pagination.skipCount;
        this.paginatedNotifications = this.notifications.slice(0, this.pagination.skipCount);
    }
    hasMoreNotifications() {
        return this.pagination?.hasMoreItems;
    }
    onNotificationClick(notification) {
        if (notification.clickCallBack) {
            notification.clickCallBack(notification.args);
            this.trigger.closeMenu();
        }
    }
}
NotificationHistoryComponent.MAX_NOTIFICATION_STACK_LENGTH = 100;
NotificationHistoryComponent.NOTIFICATION_STORAGE = 'notification-history';
NotificationHistoryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryComponent, deps: [{ token: NotificationService }, { token: StorageService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
NotificationHistoryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NotificationHistoryComponent, selector: "adf-notification-history", inputs: { menuPositionX: "menuPositionX", menuPositionY: "menuPositionY", maxNotifications: "maxNotifications" }, viewQueries: [{ propertyName: "trigger", first: true, predicate: MatMenuTrigger, descendants: true, static: true }], ngImport: i0, template: "<div (keyup)=\"onKeyPress($event)\">\n    <button mat-button\n            [matMenuTriggerFor]=\"menu\"\n            [attr.aria-label]=\"'NOTIFICATIONS.OPEN_HISTORY' | translate\"\n            title=\"{{ 'NOTIFICATIONS.OPEN_HISTORY' | translate }}\"\n            class=\"adf-notification-history-menu_button\"\n            id=\"adf-notification-history-open-button\"\n            (menuOpened)=\"onMenuOpened()\">\n        <mat-icon matBadge=\"&#8288;\"\n                  [matBadgeHidden]=\"!notifications.length\"\n                  matBadgeColor=\"accent\"\n                  matBadgeSize=\"small\">notifications</mat-icon>\n    </button>\n    <mat-menu #menu=\"matMenu\"\n              [xPosition]=\"menuPositionX\"\n              [yPosition]=\"menuPositionY\"\n              id=\"adf-notification-history-menu\"\n              class=\"adf-notification-history-menu\">\n\n        <div class=\"adf-notification-history-list\"\n             (click)=\"$event.stopPropagation()\">\n            <div mat-subheader role=\"menuitem\">\n                <span>{{ 'NOTIFICATIONS.TITLE' | translate }}</span>\n                <button (click)=\"markAsRead()\"\n                        id=\"adf-notification-history-mark-as-read\"\n                        mat-button\n                        color=\"accent\"\n                        *ngIf=\"notifications.length\">\n                    {{ 'NOTIFICATIONS.MARK_AS_READ' | translate }}\n                </button>\n            </div>\n\n            <mat-divider></mat-divider>\n\n            <mat-list role=\"menuitem\">\n                <ng-container *ngIf=\"notifications.length; else empty_list_template\">\n                    <mat-list-item *ngFor=\"let notification of paginatedNotifications\"\n                                   class=\"adf-notification-history-menu-item\"\n                                   (click)=\"onNotificationClick(notification)\">\n                        <div *ngIf=\"notification.initiator; else no_avatar\"\n                             matListAvatar\n                             [outerHTML]=\"notification.initiator | usernameInitials:'adf-notification-initiator-pic'\">\n                        </div>\n                        <ng-template #no_avatar>\n                            <mat-icon mat-list-icon\n                                      class=\"adf-notification-history-menu-initiator\">{{notification.icon}}</mat-icon>\n                        </ng-template>\n                        <p class=\"adf-notification-history-menu-message\"\n                           *ngFor=\"let message of notification.messages\"\n                           mat-line [matTooltip]=\"message\" matTooltipShowDelay=\"1000\">{{ message }}</p>\n                        <p class=\"adf-notification-history-menu-date\"\n                           mat-line> {{notification.datetime | adfTimeAgo}} </p>\n                    </mat-list-item>\n                </ng-container>\n                <ng-template #empty_list_template>\n                    <mat-list-item id=\"adf-notification-history-component-no-message\"\n                                   class=\"adf-notification-history-menu-no-message\">\n                        <p mat-line>{{ 'NOTIFICATIONS.NO_MESSAGE' | translate }}</p>\n                    </mat-list-item>\n                </ng-template>\n            </mat-list>\n\n            <mat-divider></mat-divider>\n\n            <div class=\"adf-notification-history-load-more\"\n                 role=\"menuitem\"\n                 *ngIf=\"hasMoreNotifications()\">\n                <button mat-button\n                        (click)=\"loadMore()\">\n                    {{ 'NOTIFICATIONS.LOAD_MORE' | translate }}\n                </button>\n            </div>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-notification-history-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-notification-history-list .mat-subheader{justify-content:space-between}.adf-notification-history-menu-item{cursor:pointer}.adf-notification-history-menu-item:focus{outline:none;background:var(--adf-theme-background-hover-color)}.adf-notification-history-menu-item:hover{background-color:var(--adf-theme-background-hover-color)}.adf-notification-history-menu-message,.adf-notification-history-menu-no-message{font-size:var(--theme-body-1-font-size)!important}.adf-notification-history-menu-date{font-size:var(--theme-caption-font-size)!important}.adf-notification-history-menu-initiator{margin:4px}.adf-notification-initiator-pic{min-width:40px;background:var(--theme-accent-color);display:inline-block;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px;color:var(--adf-theme-mat-grey-color-a200)}.adf-notification-history-load-more{display:flex;justify-content:center;padding:10px}.mat-menu-panel.adf-notification-history-menu{min-width:320px;max-height:500px}.mat-menu-panel.adf-notification-history-menu .mat-menu-content{padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i2$7.MatLine, selector: "[mat-line], [matLine]" }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i7$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i7$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i7$1.MatListAvatarCssMatStyler, selector: "[mat-list-avatar], [matListAvatar]" }, { kind: "directive", type: i7$1.MatListIconCssMatStyler, selector: "[mat-list-icon], [matListIcon]" }, { kind: "directive", type: i7$1.MatListSubheaderCssMatStyler, selector: "[mat-subheader], [matSubheader]" }, { kind: "component", type: i4$1.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "component", type: i3$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i3$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i11$2.MatBadge, selector: "[matBadge]", inputs: ["matBadgeDisabled", "matBadgeColor", "matBadgeOverlap", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }, { kind: "pipe", type: TimeAgoPipe, name: "adfTimeAgo" }, { kind: "pipe", type: InitialUsernamePipe, name: "usernameInitials" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-notification-history', encapsulation: ViewEncapsulation.None, template: "<div (keyup)=\"onKeyPress($event)\">\n    <button mat-button\n            [matMenuTriggerFor]=\"menu\"\n            [attr.aria-label]=\"'NOTIFICATIONS.OPEN_HISTORY' | translate\"\n            title=\"{{ 'NOTIFICATIONS.OPEN_HISTORY' | translate }}\"\n            class=\"adf-notification-history-menu_button\"\n            id=\"adf-notification-history-open-button\"\n            (menuOpened)=\"onMenuOpened()\">\n        <mat-icon matBadge=\"&#8288;\"\n                  [matBadgeHidden]=\"!notifications.length\"\n                  matBadgeColor=\"accent\"\n                  matBadgeSize=\"small\">notifications</mat-icon>\n    </button>\n    <mat-menu #menu=\"matMenu\"\n              [xPosition]=\"menuPositionX\"\n              [yPosition]=\"menuPositionY\"\n              id=\"adf-notification-history-menu\"\n              class=\"adf-notification-history-menu\">\n\n        <div class=\"adf-notification-history-list\"\n             (click)=\"$event.stopPropagation()\">\n            <div mat-subheader role=\"menuitem\">\n                <span>{{ 'NOTIFICATIONS.TITLE' | translate }}</span>\n                <button (click)=\"markAsRead()\"\n                        id=\"adf-notification-history-mark-as-read\"\n                        mat-button\n                        color=\"accent\"\n                        *ngIf=\"notifications.length\">\n                    {{ 'NOTIFICATIONS.MARK_AS_READ' | translate }}\n                </button>\n            </div>\n\n            <mat-divider></mat-divider>\n\n            <mat-list role=\"menuitem\">\n                <ng-container *ngIf=\"notifications.length; else empty_list_template\">\n                    <mat-list-item *ngFor=\"let notification of paginatedNotifications\"\n                                   class=\"adf-notification-history-menu-item\"\n                                   (click)=\"onNotificationClick(notification)\">\n                        <div *ngIf=\"notification.initiator; else no_avatar\"\n                             matListAvatar\n                             [outerHTML]=\"notification.initiator | usernameInitials:'adf-notification-initiator-pic'\">\n                        </div>\n                        <ng-template #no_avatar>\n                            <mat-icon mat-list-icon\n                                      class=\"adf-notification-history-menu-initiator\">{{notification.icon}}</mat-icon>\n                        </ng-template>\n                        <p class=\"adf-notification-history-menu-message\"\n                           *ngFor=\"let message of notification.messages\"\n                           mat-line [matTooltip]=\"message\" matTooltipShowDelay=\"1000\">{{ message }}</p>\n                        <p class=\"adf-notification-history-menu-date\"\n                           mat-line> {{notification.datetime | adfTimeAgo}} </p>\n                    </mat-list-item>\n                </ng-container>\n                <ng-template #empty_list_template>\n                    <mat-list-item id=\"adf-notification-history-component-no-message\"\n                                   class=\"adf-notification-history-menu-no-message\">\n                        <p mat-line>{{ 'NOTIFICATIONS.NO_MESSAGE' | translate }}</p>\n                    </mat-list-item>\n                </ng-template>\n            </mat-list>\n\n            <mat-divider></mat-divider>\n\n            <div class=\"adf-notification-history-load-more\"\n                 role=\"menuitem\"\n                 *ngIf=\"hasMoreNotifications()\">\n                <button mat-button\n                        (click)=\"loadMore()\">\n                    {{ 'NOTIFICATIONS.LOAD_MORE' | translate }}\n                </button>\n            </div>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-notification-history-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-notification-history-list .mat-subheader{justify-content:space-between}.adf-notification-history-menu-item{cursor:pointer}.adf-notification-history-menu-item:focus{outline:none;background:var(--adf-theme-background-hover-color)}.adf-notification-history-menu-item:hover{background-color:var(--adf-theme-background-hover-color)}.adf-notification-history-menu-message,.adf-notification-history-menu-no-message{font-size:var(--theme-body-1-font-size)!important}.adf-notification-history-menu-date{font-size:var(--theme-caption-font-size)!important}.adf-notification-history-menu-initiator{margin:4px}.adf-notification-initiator-pic{min-width:40px;background:var(--theme-accent-color);display:inline-block;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px;color:var(--adf-theme-mat-grey-color-a200)}.adf-notification-history-load-more{display:flex;justify-content:center;padding:10px}.mat-menu-panel.adf-notification-history-menu{min-width:320px;max-height:500px}.mat-menu-panel.adf-notification-history-menu .mat-menu-content{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: NotificationService }, { type: StorageService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { trigger: [{
                type: ViewChild,
                args: [MatMenuTrigger, { static: true }]
            }], menuPositionX: [{
                type: Input
            }], menuPositionY: [{
                type: Input
            }], maxNotifications: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AddNotificationStorybookComponent {
    constructor(notificationService) {
        this.notificationService = notificationService;
        this.infoCounter = 1;
    }
    showInfo() {
        this.notificationService.showInfo(`Example notification ${this.infoCounter}`);
        this.infoCounter++;
    }
}
AddNotificationStorybookComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddNotificationStorybookComponent, deps: [{ token: NotificationService }], target: i0.ɵɵFactoryTarget.Component });
AddNotificationStorybookComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AddNotificationStorybookComponent, selector: "adf-add-notification-storybook", ngImport: i0, template: `<button mat-raised-button (click)="showInfo()">Add Notification</button>`, isInline: true, dependencies: [{ kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddNotificationStorybookComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-add-notification-storybook',
                    template: `<button mat-raised-button (click)="showInfo()">Add Notification</button>`
                }]
        }], ctorParameters: function () { return [{ type: NotificationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NotificationHistoryModule {
}
NotificationHistoryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NotificationHistoryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryModule, declarations: [NotificationHistoryComponent,
        AddNotificationStorybookComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        PipeModule,
        PaginationModule], exports: [NotificationHistoryComponent,
        AddNotificationStorybookComponent] });
NotificationHistoryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        PipeModule,
        PaginationModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NotificationHistoryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        PipeModule,
                        PaginationModule
                    ],
                    declarations: [
                        NotificationHistoryComponent,
                        AddNotificationStorybookComponent
                    ],
                    exports: [
                        NotificationHistoryComponent,
                        AddNotificationStorybookComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BlankPageComponent {
}
BlankPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BlankPageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BlankPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: BlankPageComponent, selector: "adf-blank-page", ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BlankPageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-blank-page',
                    template: ``
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BlankPageModule {
}
BlankPageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BlankPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BlankPageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: BlankPageModule, declarations: [BlankPageComponent], exports: [BlankPageComponent] });
BlankPageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BlankPageModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BlankPageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BlankPageComponent
                    ],
                    exports: [
                        BlankPageComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const searchAnimation = trigger('transitionMessages', [
    state('active', style({
        'margin-left': '{{ margin-left }}px',
        'margin-right': '{{ margin-right }}px',
        transform: '{{ transform }}'
    }), { params: { 'margin-left': 0, 'margin-right': 0, transform: 'translateX(0%)' } }),
    state('inactive', style({
        'margin-left': '{{ margin-left }}px',
        'margin-right': '{{ margin-right }}px',
        transform: '{{ transform }}'
    }), { params: { 'margin-left': 0, 'margin-right': 0, transform: 'translateX(0%)' } }),
    state('no-animation', style({ transform: 'translateX(0%)', width: '100%' })),
    transition('active <=> inactive', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
]);

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var SearchTextStateEnum;
(function (SearchTextStateEnum) {
    SearchTextStateEnum["expanded"] = "expanded";
    SearchTextStateEnum["collapsed"] = "collapsed";
})(SearchTextStateEnum || (SearchTextStateEnum = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SEARCH_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SearchTriggerDirective),
    multi: true
};
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class SearchTriggerDirective {
    constructor(element, ngZone, changeDetectorRef, document) {
        this.element = element;
        this.ngZone = ngZone;
        this.changeDetectorRef = changeDetectorRef;
        this.document = document;
        this.onDestroy$ = new Subject();
        this.autocomplete = 'off';
        this._panelOpen = false;
        this.escapeEventStream = new Subject();
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
        if (this.escapeEventStream) {
            this.escapeEventStream = null;
        }
        if (this.closingActionsSubscription) {
            this.closingActionsSubscription.unsubscribe();
        }
    }
    get panelOpen() {
        return this._panelOpen && this.searchPanel.showPanel;
    }
    openPanel() {
        this.searchPanel.isOpen = this._panelOpen = true;
        this.closingActionsSubscription = this.subscribeToClosingActions();
    }
    closePanel() {
        if (this._panelOpen) {
            this.closingActionsSubscription.unsubscribe();
            this._panelOpen = false;
            this.searchPanel.resetResults();
            this.searchPanel.hidePanel();
            this.changeDetectorRef.detectChanges();
        }
    }
    get panelClosingActions() {
        return merge(this.escapeEventStream, this.outsideClickStream);
    }
    get outsideClickStream() {
        if (!this.document) {
            return of(null);
        }
        return merge(fromEvent(this.document, 'click'), fromEvent(this.document, 'touchend')).pipe(filter((event) => {
            const clickTarget = event.target;
            return this._panelOpen && clickTarget !== this.element.nativeElement;
        }), takeUntil(this.onDestroy$));
    }
    writeValue(value) {
        Promise.resolve(null).then(() => this.setTriggerValue(value));
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    handleKeydown(event) {
        const keyCode = event.keyCode;
        if (keyCode === ESCAPE && this.panelOpen) {
            this.escapeEventStream.next();
            event.stopPropagation();
        }
        else if (keyCode === ENTER) {
            this.escapeEventStream.next();
            event.preventDefault();
        }
    }
    handleInput(event) {
        if (document.activeElement === event.target) {
            const inputValue = event.target.value;
            this.onChange(inputValue);
            if (inputValue && this.searchPanel) {
                this.searchPanel.keyPressedStream.next(inputValue);
                this.openPanel();
            }
            else if (this.searchPanel) {
                this.searchPanel.resetResults();
                this.closePanel();
            }
        }
    }
    isPanelOptionClicked(event) {
        let isPanelOption = false;
        if (event && this.searchPanel) {
            const clickTarget = event.target;
            isPanelOption = !this.isNoResultOption() &&
                !!this.searchPanel.panel &&
                !!this.searchPanel.panel.nativeElement.contains(clickTarget);
        }
        return isPanelOption;
    }
    isNoResultOption() {
        return this.searchPanel && this.searchPanel.results.list ? this.searchPanel.results.list.entries.length === 0 : true;
    }
    subscribeToClosingActions() {
        const firstStable = this.ngZone.onStable.asObservable();
        const optionChanges = this.searchPanel.keyPressedStream.asObservable();
        return merge(firstStable, optionChanges)
            .pipe(switchMap(() => {
            this.searchPanel.setVisibility();
            return this.panelClosingActions;
        }), takeUntil(this.onDestroy$))
            .subscribe((event) => this.setValueAndClose(event));
    }
    setTriggerValue(value) {
        const toDisplay = this.searchPanel && this.searchPanel.displayWith ?
            this.searchPanel.displayWith(value) : value;
        const inputValue = toDisplay != null ? toDisplay : '';
        this.element.nativeElement.value = inputValue;
    }
    setValueAndClose(event) {
        if (this.isPanelOptionClicked(event) && !event.defaultPrevented) {
            this.setTriggerValue(event.target.textContent.trim());
            this.onChange(event.target.textContent.trim());
            this.element.nativeElement.focus();
        }
        this.closePanel();
    }
}
SearchTriggerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTriggerDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
SearchTriggerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: SearchTriggerDirective, selector: "input[searchAutocomplete], textarea[searchAutocomplete]", inputs: { searchPanel: ["searchAutocomplete", "searchPanel"], autocomplete: "autocomplete" }, host: { attributes: { "role": "combobox", "aria-autocomplete": "list" }, listeners: { "blur": "onTouched()", "input": "handleInput($event)", "keydown": "handleKeydown($event)" }, properties: { "attr.autocomplete": "autocomplete", "attr.aria-expanded": "panelOpen.toString()" } }, providers: [SEARCH_AUTOCOMPLETE_VALUE_ACCESSOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: `input[searchAutocomplete], textarea[searchAutocomplete]`,
                    host: {
                        role: 'combobox',
                        '[attr.autocomplete]': 'autocomplete',
                        'aria-autocomplete': 'list',
                        '[attr.aria-expanded]': 'panelOpen.toString()',
                        '(blur)': 'onTouched()',
                        '(input)': 'handleInput($event)',
                        '(keydown)': 'handleKeydown($event)'
                    },
                    providers: [SEARCH_AUTOCOMPLETE_VALUE_ACCESSOR]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { searchPanel: [{
                type: Input,
                args: ['searchAutocomplete']
            }], autocomplete: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchTextInputComponent {
    constructor(userPreferencesService) {
        this.userPreferencesService = userPreferencesService;
        /** Toggles auto-completion of the search input field. */
        this.autocomplete = false;
        /** Toggles whether to use an expanding search control. If false
         * then a regular input is used.
         */
        this.expandable = true;
        /** Type of the input field to render, e.g. "search" or "text" (default). */
        this.inputType = 'text';
        /** Toggles "find-as-you-type" suggestions for possible matches. */
        this.liveSearchEnabled = true;
        /** Trigger autocomplete results on input change. */
        this.searchAutocomplete = false;
        /** Search term preselected */
        this.searchTerm = '';
        /** Debounce time in milliseconds. */
        this.debounceTime = 0;
        /** Collapse search bar on submit. */
        this.collapseOnSubmit = true;
        /** Default state expanded or Collapsed. */
        this.defaultState = SearchTextStateEnum.collapsed;
        /** Toggles whether to collapse the search on blur. */
        this.collapseOnBlur = true;
        /** Toggles whether to show a clear button that closes the search */
        this.showClearButton = false;
        /** Placeholder text to show in the input field */
        this.placeholder = '';
        /** Hint label */
        this.hintLabel = '';
        /** Emitted when the search term is changed. The search term is provided
         * in the 'value' property of the returned object.  If the term is less
         * than three characters in length then it is truncated to an empty
         * string.
         */
        this.searchChange = new EventEmitter();
        /** Emitted when the search is submitted by pressing the ENTER key.
         * The search term is provided as the value of the event.
         */
        this.submit = new EventEmitter();
        /**  Emitted when the result list is selected */
        this.selectResult = new EventEmitter();
        /**  Emitted when the result list is reset */
        this.reset = new EventEmitter();
        /** Emitted when the search visibility changes. True when the search is active, false when it is inactive */
        this.searchVisibility = new EventEmitter();
        this.animationStates = {
            ltr: {
                active: { value: 'active', params: { 'margin-left': 13 } },
                inactive: { value: 'inactive', params: { transform: 'translateX(82%)' } }
            },
            rtl: {
                active: { value: 'active', params: { 'margin-right': 13 } },
                inactive: { value: 'inactive', params: { transform: 'translateX(-82%)' } }
            }
        };
        this.dir = 'ltr';
        this.onDestroy$ = new Subject();
        this.toggleSearch = new Subject();
        this.valueChange = new Subject();
        this.toggleSearch
            .pipe(debounceTime(200), takeUntil(this.onDestroy$))
            .subscribe(() => {
            if (this.expandable) {
                this.subscriptAnimationState = this.toggleAnimation();
                if (this.subscriptAnimationState.value === 'inactive') {
                    this.searchTerm = '';
                    this.reset.emit(true);
                    if (document.activeElement.id === this.searchInput.nativeElement.id) {
                        this.searchInput.nativeElement.blur();
                    }
                }
                this.emitVisibilitySearch();
            }
        });
    }
    ngOnInit() {
        this.userPreferencesService
            .select('textOrientation')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((direction) => {
            this.dir = direction;
            this.subscriptAnimationState = this.getDefaultState(this.dir);
        });
        this.subscriptAnimationState = this.getDefaultState(this.dir);
        this.setValueChangeHandler();
        this.setupFocusEventHandlers();
    }
    applySearchFocus(animationDoneEvent) {
        if (animationDoneEvent.toState === 'active' && this.isDefaultStateCollapsed()) {
            this.searchInput.nativeElement.focus();
        }
    }
    getAutoComplete() {
        return this.autocomplete ? 'on' : 'off';
    }
    toggleAnimation() {
        if (this.dir === 'ltr') {
            return this.subscriptAnimationState.value === 'inactive' ?
                { value: 'active', params: { 'margin-left': 13 } } :
                { value: 'inactive', params: { transform: 'translateX(82%)' } };
        }
        else {
            return this.subscriptAnimationState.value === 'inactive' ?
                { value: 'active', params: { 'margin-right': 13 } } :
                { value: 'inactive', params: { transform: 'translateX(-82%)' } };
        }
    }
    getDefaultState(dir) {
        if (this.dir) {
            return this.getAnimationState(dir);
        }
        return this.animationStates.ltr.inactive;
    }
    getAnimationState(dir) {
        if (this.expandable && this.isDefaultStateExpanded()) {
            return this.animationStates[dir].active;
        }
        else if (this.expandable) {
            return this.animationStates[dir].inactive;
        }
        else {
            return { value: 'no-animation' };
        }
    }
    setupFocusEventHandlers() {
        if (this.focusListener) {
            const focusEvents = this.focusListener
                .pipe(debounceTime(50), filter(($event) => this.isSearchBarActive() && ($event.type === 'blur' || $event.type === 'focusout' || $event.type === 'focus')), takeUntil(this.onDestroy$));
            this.focusSubscription = focusEvents.subscribe((event) => {
                if (event.type === 'focus') {
                    this.searchInput.nativeElement.focus();
                }
                else {
                    this.toggleSearchBar();
                }
            });
        }
    }
    setValueChangeHandler() {
        this.valueChange.pipe(debounceTime(this.debounceTime), takeUntil(this.onDestroy$)).subscribe((value) => {
            this.searchChange.emit(value);
        });
    }
    selectFirstResult($event) {
        this.selectResult.emit($event);
    }
    onBlur($event) {
        if (this.collapseOnBlur && !$event.relatedTarget) {
            this.resetSearch();
        }
    }
    inputChange($event) {
        this.valueChange.next($event);
    }
    toggleSearchBar() {
        if (this.toggleSearch) {
            this.toggleSearch.next();
        }
    }
    searchSubmit(event) {
        this.submit.emit(event);
        if (this.collapseOnSubmit) {
            this.toggleSearchBar();
        }
    }
    activateToolbar() {
        if (!this.isSearchBarActive()) {
            this.toggleSearchBar();
        }
        return false;
    }
    isSearchBarActive() {
        return this.subscriptAnimationState.value === 'active';
    }
    ngOnDestroy() {
        if (this.toggleSearch) {
            this.toggleSearch.complete();
            this.toggleSearch = null;
        }
        if (this.focusSubscription) {
            this.focusSubscription.unsubscribe();
            this.focusSubscription = null;
            this.focusListener = null;
        }
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    canShowClearSearch() {
        return this.showClearButton && this.isSearchBarActive();
    }
    resetSearch() {
        if (this.isSearchBarActive()) {
            this.toggleSearchBar();
        }
    }
    isDefaultStateCollapsed() {
        return this.defaultState === SearchTextStateEnum.collapsed;
    }
    isDefaultStateExpanded() {
        return this.defaultState === SearchTextStateEnum.expanded;
    }
    emitVisibilitySearch() {
        this.searchVisibility.emit(this.isSearchBarActive());
    }
}
SearchTextInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextInputComponent, deps: [{ token: UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
SearchTextInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchTextInputComponent, selector: "adf-search-text-input", inputs: { autocomplete: "autocomplete", expandable: "expandable", inputType: "inputType", liveSearchEnabled: "liveSearchEnabled", searchAutocomplete: "searchAutocomplete", searchTerm: "searchTerm", debounceTime: "debounceTime", focusListener: "focusListener", collapseOnSubmit: "collapseOnSubmit", defaultState: "defaultState", collapseOnBlur: "collapseOnBlur", showClearButton: "showClearButton", placeholder: "placeholder", hintLabel: "hintLabel" }, outputs: { searchChange: "searchChange", submit: "submit", selectResult: "selectResult", reset: "reset", searchVisibility: "searchVisibility" }, host: { classAttribute: "adf-search-text-input" }, viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"adf-search-container\" [attr.state]=\"subscriptAnimationState.value\">\n    <div [@transitionMessages]=\"subscriptAnimationState\"\n         (@transitionMessages.done)=\"applySearchFocus($event)\">\n        <button mat-icon-button\n                *ngIf=\"expandable\"\n                id=\"adf-search-button\"\n                class=\"adf-search-button\"\n                [title]=\"'SEARCH.BUTTON.TOOLTIP' | translate\"\n                (click)=\"toggleSearchBar()\"\n                (keyup.enter)=\"toggleSearchBar()\">\n            <mat-icon [attr.aria-label]=\"'SEARCH.BUTTON.ARIA-LABEL' | translate\">search</mat-icon>\n        </button>\n        <mat-form-field class=\"adf-input-form-field-divider\" [hintLabel]=\"hintLabel\">\n            <input matInput\n                   #searchInput\n                   [attr.aria-label]=\"'SEARCH.INPUT.ARIA-LABEL' | translate\"\n                   [attr.type]=\"inputType\"\n                   [autocomplete]=\"getAutoComplete()\"\n                   id=\"adf-control-input\"\n                   [(ngModel)]=\"searchTerm\"\n                   [placeholder]=\"placeholder\"\n                   (focus)=\"activateToolbar()\"\n                   (blur)=\"onBlur($event)\"\n                   (keyup.escape)=\"toggleSearchBar()\"\n                   (keyup.arrowdown)=\"selectFirstResult($event)\"\n                   (ngModelChange)=\"inputChange($event)\"\n                   [searchAutocomplete]=\"searchAutocomplete ? searchAutocomplete : null\"\n                   (keyup.enter)=\"searchSubmit($event)\">\n            <button mat-icon-button matSuffix\n                    data-automation-id=\"adf-clear-search-button\"\n                    class=\"adf-clear-search-button\"\n                    *ngIf=\"canShowClearSearch()\"\n                    (mousedown)=\"resetSearch()\">\n                <mat-icon>clear</mat-icon>\n            </button>\n        </mat-form-field>\n    </div>\n</div>\n", styles: [".adf-search-container{overflow:hidden!important}.adf-search-button{left:-13px}[dir=rtl] .adf-search-button{right:-13px}[dir=ltr] .adf-search-button{left:-13px}.adf-search-fixed-text{line-height:normal}.adf-input-form-field-divider{font-size:var(--theme-subheading-2-font-size)}.adf-input-form-field-divider .mat-form-field-underline,.adf-input-form-field-divider .mat-form-field-underline .mat-form-field-ripple{background-color:var(--adf-theme-primary-50)}.adf-highlight{color:var(--adf-theme-primary-900)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: SearchTriggerDirective, selector: "input[searchAutocomplete], textarea[searchAutocomplete]", inputs: ["searchAutocomplete", "autocomplete"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], animations: [searchAnimation], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-text-input', animations: [searchAnimation], encapsulation: ViewEncapsulation.None, host: {
                        class: 'adf-search-text-input'
                    }, template: "<div class=\"adf-search-container\" [attr.state]=\"subscriptAnimationState.value\">\n    <div [@transitionMessages]=\"subscriptAnimationState\"\n         (@transitionMessages.done)=\"applySearchFocus($event)\">\n        <button mat-icon-button\n                *ngIf=\"expandable\"\n                id=\"adf-search-button\"\n                class=\"adf-search-button\"\n                [title]=\"'SEARCH.BUTTON.TOOLTIP' | translate\"\n                (click)=\"toggleSearchBar()\"\n                (keyup.enter)=\"toggleSearchBar()\">\n            <mat-icon [attr.aria-label]=\"'SEARCH.BUTTON.ARIA-LABEL' | translate\">search</mat-icon>\n        </button>\n        <mat-form-field class=\"adf-input-form-field-divider\" [hintLabel]=\"hintLabel\">\n            <input matInput\n                   #searchInput\n                   [attr.aria-label]=\"'SEARCH.INPUT.ARIA-LABEL' | translate\"\n                   [attr.type]=\"inputType\"\n                   [autocomplete]=\"getAutoComplete()\"\n                   id=\"adf-control-input\"\n                   [(ngModel)]=\"searchTerm\"\n                   [placeholder]=\"placeholder\"\n                   (focus)=\"activateToolbar()\"\n                   (blur)=\"onBlur($event)\"\n                   (keyup.escape)=\"toggleSearchBar()\"\n                   (keyup.arrowdown)=\"selectFirstResult($event)\"\n                   (ngModelChange)=\"inputChange($event)\"\n                   [searchAutocomplete]=\"searchAutocomplete ? searchAutocomplete : null\"\n                   (keyup.enter)=\"searchSubmit($event)\">\n            <button mat-icon-button matSuffix\n                    data-automation-id=\"adf-clear-search-button\"\n                    class=\"adf-clear-search-button\"\n                    *ngIf=\"canShowClearSearch()\"\n                    (mousedown)=\"resetSearch()\">\n                <mat-icon>clear</mat-icon>\n            </button>\n        </mat-form-field>\n    </div>\n</div>\n", styles: [".adf-search-container{overflow:hidden!important}.adf-search-button{left:-13px}[dir=rtl] .adf-search-button{right:-13px}[dir=ltr] .adf-search-button{left:-13px}.adf-search-fixed-text{line-height:normal}.adf-input-form-field-divider{font-size:var(--theme-subheading-2-font-size)}.adf-input-form-field-divider .mat-form-field-underline,.adf-input-form-field-divider .mat-form-field-underline .mat-form-field-ripple{background-color:var(--adf-theme-primary-50)}.adf-highlight{color:var(--adf-theme-primary-900)}\n"] }]
        }], ctorParameters: function () { return [{ type: UserPreferencesService }]; }, propDecorators: { autocomplete: [{
                type: Input
            }], expandable: [{
                type: Input
            }], inputType: [{
                type: Input
            }], liveSearchEnabled: [{
                type: Input
            }], searchAutocomplete: [{
                type: Input
            }], searchTerm: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], focusListener: [{
                type: Input
            }], collapseOnSubmit: [{
                type: Input
            }], defaultState: [{
                type: Input
            }], collapseOnBlur: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], hintLabel: [{
                type: Input
            }], searchChange: [{
                type: Output
            }], submit: [{
                type: Output
            }], selectResult: [{
                type: Output
            }], reset: [{
                type: Output
            }], searchVisibility: [{
                type: Output
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchTextModule {
}
SearchTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SearchTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SearchTextModule, declarations: [SearchTextInputComponent,
        SearchTriggerDirective], imports: [CommonModule,
        TranslateModule,
        MaterialModule,
        FormsModule], exports: [SearchTextInputComponent,
        SearchTriggerDirective] });
SearchTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextModule, imports: [CommonModule,
        TranslateModule,
        MaterialModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SearchTextInputComponent,
                        SearchTriggerDirective
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        MaterialModule,
                        FormsModule
                    ],
                    exports: [
                        SearchTextInputComponent,
                        SearchTriggerDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ComponentTranslationModel {
    constructor(obj) {
        this.name = obj && obj.name;
        this.path = obj && obj.path;
        this.json = obj && obj.json || [];
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TranslateLoaderService {
    constructor(http) {
        this.http = http;
        this.prefix = 'i18n';
        this.suffix = '.json';
        this.providers = [];
        this.queue = [];
        this.defaultLang = 'en';
    }
    setDefaultLang(value) {
        this.defaultLang = value || 'en';
    }
    registerProvider(name, path) {
        const registered = this.providers.find((provider) => provider.name === name);
        if (registered) {
            registered.path = path;
        }
        else {
            this.providers.push(new ComponentTranslationModel({ name, path }));
        }
    }
    providerRegistered(name) {
        return this.providers.find((x) => x.name === name) ? true : false;
    }
    fetchLanguageFile(lang, component, fallbackUrl) {
        const translationUrl = fallbackUrl || `${component.path}/${this.prefix}/${lang}${this.suffix}?v=${Date.now()}`;
        return this.http.get(translationUrl).pipe(map((res) => {
            component.json[lang] = res;
        }), retry(3), catchError(() => {
            if (!fallbackUrl && lang.includes('-')) {
                const [langId] = lang.split('-');
                if (langId && langId !== this.defaultLang) {
                    const url = `${component.path}/${this.prefix}/${langId}${this.suffix}?v=${Date.now()}`;
                    return this.fetchLanguageFile(lang, component, url);
                }
            }
            return throwError(`Failed to load ${translationUrl}`);
        }));
    }
    getComponentToFetch(lang) {
        const observableBatch = [];
        if (!this.queue[lang]) {
            this.queue[lang] = [];
        }
        this.providers.forEach((component) => {
            if (!this.isComponentInQueue(lang, component.name)) {
                this.queue[lang].push(component.name);
                observableBatch.push(this.fetchLanguageFile(lang, component));
            }
        });
        return observableBatch;
    }
    init(lang) {
        if (this.queue[lang] === undefined) {
            this.queue[lang] = [];
        }
    }
    isComponentInQueue(lang, name) {
        return (this.queue[lang] || []).find((x) => x === name) ? true : false;
    }
    getFullTranslationJSON(lang) {
        let result = {};
        this.providers
            .slice(0)
            .sort((a, b) => {
            if (a.name === 'app') {
                return 1;
            }
            if (b.name === 'app') {
                return -1;
            }
            return a.name.localeCompare(b.name);
        })
            .forEach((model) => {
            if (model.json && model.json[lang]) {
                result = ObjectUtils.merge(result, model.json[lang]);
            }
        });
        return result;
    }
    getTranslation(lang) {
        let hasFailures = false;
        const batch = [
            ...this.getComponentToFetch(lang).map((observable) => observable.pipe(catchError((error) => {
                hasFailures = true;
                return of(error);
            })))
        ];
        return new Observable((observer) => {
            if (batch.length > 0) {
                forkJoin(batch).subscribe(() => {
                    const fullTranslation = this.getFullTranslationJSON(lang);
                    if (fullTranslation) {
                        observer.next(fullTranslation);
                    }
                    if (hasFailures) {
                        observer.error('Failed to load some resources');
                    }
                    else {
                        observer.complete();
                    }
                }, () => {
                    observer.error('Failed to load some resources');
                });
            }
            else {
                const fullTranslation = this.getFullTranslationJSON(lang);
                if (fullTranslation) {
                    observer.next(fullTranslation);
                    observer.complete();
                }
            }
        });
    }
}
TranslateLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslateLoaderService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
TranslateLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslateLoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslateLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const EXTENDIBLE_COMPONENT = new InjectionToken('extendible.component');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CommentModel {
    constructor(obj) {
        if (obj) {
            this.id = obj.id;
            this.message = obj.message;
            this.created = obj.created;
            this.createdBy = obj.createdBy;
            this.isSelected = obj.isSelected ? obj.isSelected : false;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RequestPaginationModel {
    constructor(input) {
        this.merge = false;
        if (input) {
            Object.assign(this, input);
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DecimalNumberModel {
    constructor(obj) {
        if (obj) {
            this.minIntegerDigits = obj.minIntegerDigits;
            this.minFractionDigits = obj.minFractionDigits;
            this.maxFractionDigits = obj.maxFractionDigits;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoApiMock {
    login() {
        return new Promise((resolve) => {
            resolve('TICKET_4479f4d3bb155195879bfbb8d5206f433488a1b1');
        });
    }
    logout() {
        return new Promise((resolve) => {
            resolve('logout');
        });
    }
    changeConfig() {
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CookieServiceMock extends CookieService {
    /** @override */
    isEnabled() {
        return true;
    }
    /** @override */
    getItem(key) {
        return this[key] && this[key].data || null;
    }
    /** @override */
    setItem(key, data, expiration, path) {
        this[key] = { data, expiration, path };
    }
    /** @override */
    clear() {
        Object.keys(this).forEach((key) => {
            if (this.hasOwnProperty(key) && typeof (this[key]) !== 'function') {
                this[key] = undefined;
            }
        });
    }
}
CookieServiceMock.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieServiceMock, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CookieServiceMock.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieServiceMock });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CookieServiceMock, decorators: [{
            type: Injectable
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EventMock {
    static keyDown(key) {
        const event = document.createEvent('Event');
        event.keyCode = key;
        event.initEvent('keydown');
        document.dispatchEvent(event);
    }
    static keyUp(key) {
        const event = document.createEvent('Event');
        event.keyCode = key;
        event.initEvent('keyup');
        document.dispatchEvent(event);
    }
    static resizeMobileView() {
        // todo: no longer compiles with TS 2.0.2 as innerWidth/innerHeight are readonly fields
        /*
        window.innerWidth = 320;
        window.innerHeight = 568;
        */
        window.dispatchEvent(new Event('resize'));
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TranslationMock {
    constructor() {
        this.defaultLang = 'en';
        this.translate = {
            onLangChange: new EventEmitter()
        };
    }
    addTranslationFolder() { }
    onTranslationChanged() { }
    use() { }
    loadTranslation() { }
    get(key) {
        return of(key);
    }
    instant(key) {
        return key;
    }
}
TranslationMock.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationMock, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TranslationMock.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationMock });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TranslationMock, decorators: [{
            type: Injectable
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoApiServiceMock extends AlfrescoApiService {
    constructor(appConfig, storageService) {
        super(appConfig, storageService);
        this.appConfig = appConfig;
        this.storageService = storageService;
        if (!this.alfrescoApi) {
            this.initAlfrescoApi();
        }
    }
    initialize() {
        return new Promise((resolve) => {
            this.alfrescoApiInitialized.next(true);
            resolve({});
        });
    }
}
AlfrescoApiServiceMock.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceMock, deps: [{ token: AppConfigService }, { token: StorageService }], target: i0.ɵɵFactoryTarget.Injectable });
AlfrescoApiServiceMock.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceMock });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceMock, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: StorageService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fakeForm = {
    id: 1001,
    name: 'ISSUE_FORM',
    processDefinitionId: 'ISSUE_APP:1:2504',
    processDefinitionName: 'ISSUE_APP',
    processDefinitionKey: 'ISSUE_APP',
    taskId: '7506',
    taskDefinitionKey: 'sid-F67A2996-1684-4774-855A-4591490081FD',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1498212398417',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'dropdownId',
                        name: 'Label',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'option_1',
                                name: 'test1'
                            },
                            {
                                id: 'option_2',
                                name: 'test2'
                            },
                            {
                                id: 'option_3',
                                name: 'test3'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'radio',
                        name: 'radio',
                        type: 'radio-buttons',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: [
                            {
                                id: 'option_1',
                                name: 'Option 1'
                            },
                            {
                                id: 'option_2',
                                name: 'Option 2'
                            },
                            {
                                id: 'option_3',
                                name: 'Option 3'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 2,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: '1498212413062',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'date',
                        name: 'date',
                        type: 'date',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: []
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const formDefinitionTwoTextFields = {
    id: 20,
    name: 'formTextDefinition',
    processDefinitionId: 'textDefinition:1:153',
    processDefinitionName: 'textDefinition',
    processDefinitionKey: 'textDefinition',
    taskId: '159',
    taskDefinitionKey: 'sid-D941F49F-2B04-4FBB-9B49-9E95991993E8',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1507044399260',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'firstname',
                        name: 'firstName',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'lastname',
                        name: 'lastName',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};
const formDefinitionDropdownField = {
    id: 21,
    name: 'dropdownDefinition',
    processDefinitionId: 'textDefinition:2:163',
    processDefinitionName: 'textDefinition',
    processDefinitionKey: 'textDefinition',
    taskId: '169',
    taskDefinitionKey: 'sid-D941F49F-2B04-4FBB-9B49-9E95991993E8',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1507046026940',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'country',
                        name: 'country',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'option_1',
                                name: 'united kingdom'
                            },
                            {
                                id: 'option_2',
                                name: 'italy'
                            },
                            {
                                id: 'option_3',
                                name: 'france'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: []
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};
const formDefinitionRequiredField = {
    id: 21,
    name: 'dropdownDefinition',
    processDefinitionId: 'textDefinition:2:163',
    processDefinitionName: 'textDefinition',
    processDefinitionKey: 'textDefinition',
    taskId: '169',
    taskDefinitionKey: 'sid-D941F49F-2B04-4FBB-9B49-9E95991993E8',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1507046026940',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'country',
                        name: 'country',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'option_1',
                                name: 'united kingdom'
                            },
                            {
                                id: 'option_2',
                                name: 'italy'
                            },
                            {
                                id: 'option_3',
                                name: 'france'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: []
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const formReadonlyTwoTextFields = {
    id: 22,
    name: 'formTextDefinition',
    processDefinitionId: 'textDefinition:3:182',
    processDefinitionName: 'textDefinition',
    processDefinitionKey: 'textDefinition',
    taskId: '188',
    taskDefinitionKey: 'sid-D941F49F-2B04-4FBB-9B49-9E95991993E8',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1507044399260',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'firstname',
                        name: 'firstName',
                        type: 'readonly',
                        value: 'fakeFirstName',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2,
                            field: {
                                id: 'firstname',
                                name: 'firstName',
                                type: 'text',
                                value: null,
                                required: false,
                                readOnly: false,
                                overrideId: false,
                                colspan: 1,
                                placeholder: null,
                                minLength: 0,
                                maxLength: 0,
                                minValue: null,
                                maxValue: null,
                                regexPattern: null,
                                optionType: null,
                                hasEmptyValue: null,
                                options: null,
                                restUrl: null,
                                restResponsePath: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                tab: null,
                                className: null,
                                dateDisplayFormat: null,
                                layout: null,
                                sizeX: 0,
                                sizeY: 0,
                                row: 0,
                                col: 0,
                                visibilityCondition: null
                            }
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'lastname',
                        name: 'lastName',
                        type: 'readonly',
                        value: 'fakeLastName',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1,
                            field: {
                                id: 'lastname',
                                name: 'lastName',
                                type: 'text',
                                value: null,
                                required: false,
                                readOnly: false,
                                overrideId: false,
                                colspan: 1,
                                placeholder: null,
                                minLength: 0,
                                maxLength: 0,
                                minValue: null,
                                maxValue: null,
                                regexPattern: null,
                                optionType: null,
                                hasEmptyValue: null,
                                options: null,
                                restUrl: null,
                                restResponsePath: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                tab: null,
                                className: null,
                                dateDisplayFormat: null,
                                layout: null,
                                sizeX: 0,
                                sizeY: 0,
                                row: 0,
                                col: 0,
                                visibilityCondition: null
                            }
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const formDefVisibilitiFieldDependsOnNextOne = {
    id: 19,
    processDefinitionId: 'visibility:1:148',
    processDefinitionName: 'visibility',
    processDefinitionKey: 'visibility',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1506960847579',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'country',
                        name: 'country',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'option_1',
                                name: 'france'
                            },
                            {
                                id: 'option_2',
                                name: 'uk'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: {
                            leftType: 'field',
                            leftValue: 'name',
                            operator: '==',
                            rightValue: 'italy',
                            rightFormFieldId: '',
                            rightRestResponseId: '',
                            nextConditionOperator: '',
                            nextCondition: null
                        },
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'name',
                        name: 'name',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};
const formDefVisibilitiFieldDependsOnPreviousOne = {
    id: 19,
    processDefinitionId: 'visibility:1:148',
    processDefinitionName: 'visibility',
    processDefinitionKey: 'visibility',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1506960847579',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'name',
                        name: 'name',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'country',
                        name: 'country',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'option_1',
                                name: 'france'
                            },
                            {
                                id: 'option_2',
                                name: 'uk'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: {
                            leftType: 'field',
                            leftValue: 'name',
                            operator: '==',
                            rightValue: 'italy',
                            rightFormFieldId: '',
                            rightRestResponseId: '',
                            nextConditionOperator: '',
                            nextCondition: null
                        },
                        endpoint: null,
                        requestHeaders: null
                    }
                ]
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D-M-YYYY'
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const startFormDateWidgetMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'FormFieldRepresentation',
                        id: 'date',
                        name: 'date',
                        type: 'date',
                        value: null
                    }]
            }
        }
    ]
};
const startFormNumberWidgetMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'FormFieldRepresentation',
                        id: 'number',
                        name: 'number widget',
                        type: 'integer',
                        value: null
                    }]
            }
        }
    ]
};
const startFormAmountWidgetMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'FormFieldRepresentation',
                        id: 'amount',
                        name: 'amount widget',
                        type: 'amount',
                        value: null
                    }]
            }
        }
    ]
};
const startFormRadioButtonWidgetMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'RestFieldRepresentation',
                        id: 'radio-but',
                        name: 'radio-buttons',
                        type: 'radio-buttons',
                        value: null
                    }]
            }
        }
    ]
};
const startFormTextDefinitionMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'FormFieldRepresentation',
                        id: 'mocktext',
                        name: 'mockText',
                        type: 'text',
                        value: null
                    }]
            }
        }
    ]
};
const startFormDropdownDefinitionMock = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            readOnly: false,
            fields: {
                1: [{
                        fieldType: 'RestFieldRepresentation',
                        id: 'mockTypeDropDown',
                        name: 'mock DropDown',
                        type: 'dropdown',
                        value: 'Chooseone...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        options: [
                            {
                                id: 'empty',
                                name: 'Chooseone...'
                            },
                            {
                                id: 'opt1',
                                name: 'Option-1'
                            },
                            {
                                id: 'opt2',
                                name: 'Option-2'
                            },
                            {
                                id: 'opt3',
                                name: 'Option-3'
                            },
                            {
                                id: 'opt2',
                                name: 'Option-3'
                            }
                        ]
                    }]
            }
        }
    ]
};
const startMockForm = {
    id: 4,
    name: 'Claim Review Process',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    processDefinitionName: 'ClaimReviewProcess',
    processDefinitionKey: 'ClaimReviewProcess',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'clientname',
                        name: 'ClientName',
                        type: 'text',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'policyno',
                        name: 'PolicyNo',
                        type: 'integer',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterPolicyName',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953270269,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'billAmount',
                        name: 'BillAmount',
                        type: 'integer',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterBillAmount',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'billdate',
                        name: 'BillDate',
                        type: 'date',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: 'billdate',
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953280930,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'claimtype',
                        name: 'ClaimType',
                        type: 'dropdown',
                        value: 'Chooseone...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Chooseone...'
                            },
                            {
                                id: 'cashless',
                                name: 'Cashless'
                            },
                            {
                                id: 'reimbursement',
                                name: 'Reimbursement'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'hospitalName',
                        name: 'HospitalName',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterHospitalName',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        }
    ],
    outcomes: [
        {
            id: 'approve',
            name: 'Approve'
        },
        {
            id: 'complete',
            name: 'Complete'
        },
        {
            id: 'start_process',
            name: 'Start Process'
        }
    ],
    javascriptEvents: [],
    className: '',
    style: '',
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D - M - YYYY'
};
const startMockFormWithTab = {
    id: 4,
    taskName: 'Mock Title',
    processDefinitionId: 'ClaimReviewProcess:2: 93',
    processDefinitionName: 'ClaimReviewProcess',
    processDefinitionKey: 'ClaimReviewProcess',
    tabs: [
        {
            id: 'form1',
            name: 'Tab 1'
        },
        {
            id: 'form2',
            name: 'Tab 2'
        }
    ],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953253784,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'clientname',
                        name: 'ClientName',
                        type: 'text',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'policyno',
                        name: 'PolicyNo',
                        type: 'integer',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterPolicyName',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953270269,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'billAmount',
                        name: 'BillAmount',
                        type: 'integer',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterBillAmount',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'billdate',
                        name: 'BillDate',
                        type: 'date',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: 'billdate',
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: 1497953280930,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'claimtype',
                        name: 'ClaimType',
                        type: 'dropdown',
                        value: 'Chooseone...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Chooseone...'
                            },
                            {
                                id: 'cashless',
                                name: 'Cashless'
                            },
                            {
                                id: 'reimbursement',
                                name: 'Reimbursement'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'hospitalName',
                        name: 'HospitalName',
                        type: 'text',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: 'EnterHospitalName',
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ]
            }
        }
    ],
    outcomes: [
        {
            id: 'approve',
            name: 'Approve'
        },
        {
            id: 'complete',
            name: 'Complete'
        }
    ],
    javascriptEvents: [],
    className: '',
    style: '',
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: false,
    globalDateFormat: 'D - M - YYYY'
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const formModelTabs = {
    formRepresentation: {
        id: 16,
        name: 'start event',
        description: '',
        version: 2,
        lastUpdatedBy: 4,
        lastUpdatedByFullName: 'User Test',
        lastUpdated: '2017-10-04T13:00:03.030+0000',
        stencilSetId: null,
        referenceId: null,
        formDefinition: {
            tabs: [],
            fields: [
                {
                    fieldType: 'ContainerRepresentation',
                    id: '1507037668653',
                    name: 'Label',
                    type: 'container',
                    value: null,
                    required: false,
                    readOnly: false,
                    overrideId: false,
                    colspan: 1,
                    placeholder: null,
                    minLength: 0,
                    maxLength: 0,
                    minValue: null,
                    maxValue: null,
                    regexPattern: null,
                    optionType: null,
                    hasEmptyValue: null,
                    options: null,
                    restUrl: null,
                    restResponsePath: null,
                    restIdProperty: null,
                    restLabelProperty: null,
                    tab: null,
                    className: null,
                    dateDisplayFormat: null,
                    layout: null,
                    sizeX: 2,
                    sizeY: 1,
                    row: -1,
                    col: -1,
                    visibilityCondition: null,
                    numberOfColumns: 2,
                    fields: {
                        1: [
                            {
                                fieldType: 'AmountFieldRepresentation',
                                id: 'label',
                                name: 'Label',
                                type: 'amount',
                                value: null,
                                required: false,
                                readOnly: false,
                                overrideId: false,
                                colspan: 1,
                                placeholder: null,
                                minLength: 0,
                                maxLength: 0,
                                minValue: null,
                                maxValue: null,
                                regexPattern: null,
                                optionType: null,
                                hasEmptyValue: null,
                                options: null,
                                restUrl: null,
                                restResponsePath: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                tab: null,
                                className: null,
                                params: {
                                    existingColspan: 1,
                                    maxColspan: 2
                                },
                                dateDisplayFormat: null,
                                layout: {
                                    row: -1,
                                    column: -1,
                                    colspan: 1
                                },
                                sizeX: 1,
                                sizeY: 1,
                                row: -1,
                                col: -1,
                                visibilityCondition: null,
                                enableFractions: false,
                                currency: null
                            }
                        ],
                        2: [
                            {
                                fieldType: 'FormFieldRepresentation',
                                id: 'label1',
                                name: 'Label1',
                                type: 'date',
                                value: null,
                                required: false,
                                readOnly: false,
                                overrideId: false,
                                colspan: 1,
                                placeholder: null,
                                minLength: 0,
                                maxLength: 0,
                                minValue: null,
                                maxValue: null,
                                regexPattern: null,
                                optionType: null,
                                hasEmptyValue: null,
                                options: null,
                                restUrl: null,
                                restResponsePath: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                tab: null,
                                className: null,
                                params: {
                                    existingColspan: 1,
                                    maxColspan: 1
                                },
                                dateDisplayFormat: null,
                                layout: {
                                    row: -1,
                                    column: -1,
                                    colspan: 1
                                },
                                sizeX: 1,
                                sizeY: 1,
                                row: -1,
                                col: -1,
                                visibilityCondition: null
                            }
                        ]
                    }
                },
                {
                    fieldType: 'ContainerRepresentation',
                    id: '1507037670167',
                    name: 'Label',
                    type: 'container',
                    value: null,
                    required: false,
                    readOnly: false,
                    overrideId: false,
                    colspan: 1,
                    placeholder: null,
                    minLength: 0,
                    maxLength: 0,
                    minValue: null,
                    maxValue: null,
                    regexPattern: null,
                    optionType: null,
                    hasEmptyValue: null,
                    options: null,
                    restUrl: null,
                    restResponsePath: null,
                    restIdProperty: null,
                    restLabelProperty: null,
                    tab: null,
                    className: null,
                    dateDisplayFormat: null,
                    layout: null,
                    sizeX: 2,
                    sizeY: 1,
                    row: -1,
                    col: -1,
                    visibilityCondition: null,
                    numberOfColumns: 2,
                    fields: {
                        1: [
                            {
                                fieldType: 'FormFieldRepresentation',
                                id: 'label2',
                                name: 'Label2',
                                type: 'boolean',
                                value: null,
                                required: false,
                                readOnly: false,
                                overrideId: false,
                                colspan: 1,
                                placeholder: null,
                                minLength: 0,
                                maxLength: 0,
                                minValue: null,
                                maxValue: null,
                                regexPattern: null,
                                optionType: null,
                                hasEmptyValue: null,
                                options: null,
                                restUrl: null,
                                restResponsePath: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                tab: null,
                                className: null,
                                params: {
                                    existingColspan: 1,
                                    maxColspan: 2
                                },
                                dateDisplayFormat: null,
                                layout: {
                                    row: -1,
                                    column: -1,
                                    colspan: 1
                                },
                                sizeX: 1,
                                sizeY: 1,
                                row: -1,
                                col: -1,
                                visibilityCondition: null
                            }
                        ],
                        2: []
                    }
                }
            ],
            outcomes: [],
            javascriptEvents: [],
            className: '',
            style: '',
            customFieldTemplates: {},
            metadata: {},
            variables: [],
            customFieldsValueInfo: {},
            gridsterForm: false
        }
    }
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const formTest = new FormModel({});
const fakeTaskProcessVariableModels = [
    { id: 'TEST_VAR_1', type: 'string', value: 'test_value_1' },
    { id: 'TEST_VAR_2', type: 'string', value: 'test_value_2' },
    { id: 'TEST_VAR_3', type: 'string', value: 'test_value_3' }
];
const formValues = {
    test_1: 'value_1',
    test_2: 'value_2',
    test_3: 'value_1',
    test_4: 'dropdown_id',
    test_5: 'dropdown_label',
    dropdown: { id: 'dropdown_id', name: 'dropdown_label' }
};
const fakeFormJson = {
    id: '9999',
    name: 'FORM_VISIBILITY',
    processDefinitionId: 'PROCESS_TEST:  9:  9999',
    processDefinitionName: 'PROCESS_TEST',
    processDefinitionKey: 'PROCESS_TEST',
    taskId: '999',
    taskName: 'TEST',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '000000000000000000',
            name: 'Label',
            type: 'container',
            value: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'FIELD_TEST',
                        name: 'FIELD_TEST',
                        type: 'text',
                        value: 'RIGHT_FORM_FIELD_VALUE',
                        visibilityCondition: null,
                        isVisible: true
                    },
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'FIELD_WITH_CONDITION',
                        name: 'FIELD_WITH_CONDITION',
                        type: 'text',
                        value: 'field_with_condition_value',
                        visibilityCondition: null,
                        isVisible: true
                    },
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'LEFT_FORM_FIELD_ID',
                        name: 'LEFT_FORM_FIELD_NAME',
                        type: 'text',
                        value: 'LEFT_FORM_FIELD_VALUE',
                        visibilityCondition: null,
                        isVisible: true
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'RIGHT_FORM_FIELD_ID',
                        name: 'RIGHT_FORM_FIELD_NAME',
                        type: 'text',
                        value: 'RIGHT_FORM_FIELD_VALUE',
                        visibilityCondition: null,
                        isVisible: true
                    }
                ]
            }
        }
    ],
    variables: [
        {
            id: 'e621e8ff-42a6-499c-8121-33c7c35d8641',
            name: 'age',
            type: 'integer',
            value: 11
        },
        {
            id: '4f8aa99e-8526-429c-9d99-809978489d96',
            name: 'name',
            type: 'string',
            value: 'abc'
        },
        {
            id: '0207b649-ff07-4f3a-a589-d10afa507b9b',
            name: 'dob',
            type: 'date',
            value: '2019-05-13'
        }
    ]
};
const fakeFormCheckBoxVisibilityJson = {
    referenceId: '33033',
    name: 'test_condition_form',
    description: '',
    tabs: [],
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1623514352532',
            name: 'Label',
            type: 'container',
            value: 'null',
            required: 'false',
            readOnly: 'false',
            overrideId: 'false',
            colspan: '1',
            placeholder: 'null',
            minLength: '0',
            maxLength: '0',
            minValue: 'null',
            maxValue: 'null',
            regexPattern: 'null',
            optionType: 'null',
            hasEmptyValue: 'null',
            options: 'null',
            restUrl: 'null',
            restResponsePath: 'null',
            restIdProperty: 'null',
            restLabelProperty: 'null',
            tab: 'null',
            className: 'null',
            dateDisplayFormat: 'null',
            layout: 'null',
            sizeX: '2',
            sizeY: '1',
            row: '-1',
            col: '-1',
            visibilityCondition: 'null',
            numberOfColumns: '2',
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'a',
                        name: 'A',
                        type: 'boolean',
                        value: 'null',
                        required: 'false',
                        readOnly: 'false',
                        overrideId: 'false',
                        colspan: '1',
                        placeholder: 'null',
                        minLength: '0',
                        maxLength: '0',
                        minValue: 'null',
                        maxValue: 'null',
                        regexPattern: 'null',
                        optionType: 'null',
                        hasEmptyValue: 'null',
                        options: 'null',
                        restUrl: 'null',
                        restResponsePath: 'null',
                        restIdProperty: 'null',
                        restLabelProperty: 'null',
                        tab: 'null',
                        className: 'null',
                        params: {
                            existingColspan: '1',
                            maxColspan: '2'
                        },
                        dateDisplayFormat: 'null',
                        layout: {
                            row: '-1',
                            column: '-1',
                            colspan: '1'
                        },
                        sizeX: '1',
                        sizeY: '1',
                        row: '-1',
                        col: '-1',
                        visibilityCondition: 'null'
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'b',
                        name: 'B',
                        type: 'boolean',
                        value: 'null',
                        required: 'false',
                        readOnly: 'false',
                        overrideId: 'false',
                        colspan: '1',
                        placeholder: 'null',
                        minLength: '0',
                        maxLength: '0',
                        minValue: 'null',
                        maxValue: 'null',
                        regexPattern: 'null',
                        optionType: 'null',
                        hasEmptyValue: 'null',
                        options: 'null',
                        restUrl: 'null',
                        restResponsePath: 'null',
                        restIdProperty: 'null',
                        restLabelProperty: 'null',
                        tab: 'null',
                        className: 'null',
                        params: {
                            existingColspan: '1',
                            maxColspan: '1'
                        },
                        dateDisplayFormat: 'null',
                        layout: {
                            row: '-1',
                            column: '-1',
                            colspan: '1'
                        },
                        sizeX: '1',
                        sizeY: '1',
                        row: '-1',
                        col: '-1',
                        visibilityCondition: 'null'
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: '1623514356352',
            name: 'Label',
            type: 'container',
            value: 'null',
            required: 'false',
            readOnly: 'false',
            overrideId: 'false',
            colspan: '1',
            placeholder: 'null',
            minLength: '0',
            maxLength: '0',
            minValue: 'null',
            maxValue: 'null',
            regexPattern: 'null',
            optionType: 'null',
            hasEmptyValue: 'null',
            options: 'null',
            restUrl: 'null',
            restResponsePath: 'null',
            restIdProperty: 'null',
            restLabelProperty: 'null',
            tab: 'null',
            className: 'null',
            dateDisplayFormat: 'null',
            layout: 'null',
            sizeX: '2',
            sizeY: '1',
            row: '-1',
            col: '-1',
            visibilityCondition: 'null',
            numberOfColumns: '2',
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'c',
                        name: 'C',
                        type: 'boolean',
                        value: 'null',
                        required: 'false',
                        readOnly: 'false',
                        overrideId: 'false',
                        colspan: '1',
                        placeholder: 'null',
                        minLength: '0',
                        maxLength: '0',
                        minValue: 'null',
                        maxValue: 'null',
                        regexPattern: 'null',
                        optionType: 'null',
                        hasEmptyValue: 'null',
                        options: 'null',
                        restUrl: 'null',
                        restResponsePath: 'null',
                        restIdProperty: 'null',
                        restLabelProperty: 'null',
                        tab: 'null',
                        className: 'null',
                        params: {
                            existingColspan: '1',
                            maxColspan: '2'
                        },
                        dateDisplayFormat: 'null',
                        layout: {
                            row: '-1',
                            column: '-1',
                            colspan: '1'
                        },
                        sizeX: '1',
                        sizeY: '1',
                        row: '-1',
                        col: '-1',
                        visibilityCondition: 'null'
                    }
                ],
                2: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'd',
                        name: 'D',
                        type: 'boolean',
                        value: 'null',
                        required: 'false',
                        readOnly: 'false',
                        overrideId: 'false',
                        colspan: '1',
                        placeholder: 'null',
                        minLength: '0',
                        maxLength: '0',
                        minValue: 'null',
                        maxValue: 'null',
                        regexPattern: 'null',
                        optionType: 'null',
                        hasEmptyValue: 'null',
                        options: 'null',
                        restUrl: 'null',
                        restResponsePath: 'null',
                        restIdProperty: 'null',
                        restLabelProperty: 'null',
                        tab: 'null',
                        className: 'null',
                        params: {
                            existingColspan: '1',
                            maxColspan: '1'
                        },
                        dateDisplayFormat: 'null',
                        layout: {
                            row: '-1',
                            column: '-1',
                            colspan: '1'
                        },
                        sizeX: '1',
                        sizeY: '1',
                        row: '-1',
                        col: '-1',
                        visibilityCondition: 'null'
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: '1623514409166',
            name: 'Label',
            type: 'container',
            value: 'null',
            required: 'false',
            readOnly: 'false',
            overrideId: 'false',
            colspan: '1',
            placeholder: 'null',
            minLength: '0',
            maxLength: '0',
            minValue: 'null',
            maxValue: 'null',
            regexPattern: 'null',
            optionType: 'null',
            hasEmptyValue: 'null',
            options: 'null',
            restUrl: 'null',
            restResponsePath: 'null',
            restIdProperty: 'null',
            restLabelProperty: 'null',
            tab: 'null',
            className: 'null',
            dateDisplayFormat: 'null',
            layout: 'null',
            sizeX: '2',
            sizeY: '1',
            row: '-1',
            col: '-1',
            visibilityCondition: 'null',
            numberOfColumns: '2',
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'a_b_c_d',
                        name: 'Textfield ( A && B || C && D)',
                        type: 'text',
                        value: 'null',
                        required: 'false',
                        readOnly: 'false',
                        overrideId: 'true',
                        colspan: '1',
                        placeholder: 'null',
                        minLength: '0',
                        maxLength: '0',
                        minValue: 'null',
                        maxValue: 'null',
                        regexPattern: 'null',
                        optionType: 'null',
                        hasEmptyValue: 'null',
                        options: 'null',
                        restUrl: 'null',
                        restResponsePath: 'null',
                        restIdProperty: 'null',
                        restLabelProperty: 'null',
                        tab: 'null',
                        className: 'null',
                        params: {
                            existingColspan: '1',
                            maxColspan: '2'
                        },
                        dateDisplayFormat: 'null',
                        layout: {
                            row: '-1',
                            column: '-1',
                            colspan: '1'
                        },
                        sizeX: '1',
                        sizeY: '1',
                        row: '-1',
                        col: '-1',
                        visibilityCondition: {
                            leftFormFieldId: 'a',
                            leftRestResponseId: 'null',
                            operator: '==',
                            rightValue: 'true',
                            rightType: 'null',
                            rightFormFieldId: '',
                            rightRestResponseId: '',
                            nextConditionOperator: 'and',
                            nextCondition: {
                                leftFormFieldId: 'b',
                                leftRestResponseId: 'null',
                                operator: '==',
                                rightValue: 'true',
                                rightType: 'null',
                                rightFormFieldId: '',
                                rightRestResponseId: '',
                                nextConditionOperator: 'or',
                                nextCondition: {
                                    leftFormFieldId: 'c',
                                    leftRestResponseId: 'null',
                                    operator: '==',
                                    rightValue: 'true',
                                    rightType: 'null',
                                    rightFormFieldId: '',
                                    rightRestResponseId: '',
                                    nextConditionOperator: 'and',
                                    nextCondition: {
                                        leftFormFieldId: 'd',
                                        leftRestResponseId: 'null',
                                        operator: '==',
                                        rightValue: 'true',
                                        rightType: 'null',
                                        rightFormFieldId: '',
                                        rightRestResponseId: '',
                                        nextConditionOperator: '',
                                        nextCondition: 'null'
                                    }
                                }
                            }
                        }
                    }
                ],
                2: []
            }
        }
    ],
    outcomes: [],
    javascriptEvents: [],
    className: '',
    style: '',
    customFieldTemplates: {},
    metadata: {},
    variables: [],
    customFieldsValueInfo: {},
    gridsterForm: 'false'
};
const fakeFormChainedVisibilityJson = {
    id: '8800',
    name: 'FORM_VISIBILITYl_CHAIN',
    processDefinitionId: 'PROCESS_TEST:  9:  9999',
    processDefinitionName: 'PROCESS_TEST',
    processDefinitionKey: 'PROCESS_TEST',
    taskId: '999',
    taskName: 'TEST',
    fields: [
        {
            fieldType: 'ContainerRepresentation',
            id: '1615506402205',
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'installments',
                        name: 'Installments',
                        type: 'integer',
                        value: null,
                        required: true,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null
                    }
                ],
                2: [
                    {
                        fieldType: 'RestFieldRepresentation',
                        id: 'schedule',
                        name: 'Schedule',
                        type: 'dropdown',
                        value: 'Choose one...',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: true,
                        options: [
                            {
                                id: 'empty',
                                name: 'Choose one...'
                            },
                            {
                                id: 'ANNUAL',
                                name: 'Annual'
                            },
                            {
                                id: 'QUARTERLY',
                                name: 'Quarterly'
                            },
                            {
                                id: 'MONTHLY',
                                name: 'Monthly'
                            }
                        ],
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        endpoint: null,
                        requestHeaders: null
                    }
                ]
            }
        },
        {
            fieldType: 'ContainerRepresentation',
            id: 1615506384790,
            name: 'Label',
            type: 'container',
            value: null,
            required: false,
            readOnly: false,
            overrideId: false,
            colspan: 1,
            placeholder: null,
            minLength: 0,
            maxLength: 0,
            minValue: null,
            maxValue: null,
            regexPattern: null,
            optionType: null,
            hasEmptyValue: null,
            options: null,
            restUrl: null,
            restResponsePath: null,
            restIdProperty: null,
            restLabelProperty: null,
            tab: null,
            className: null,
            dateDisplayFormat: null,
            layout: null,
            sizeX: 2,
            sizeY: 1,
            row: -1,
            col: -1,
            visibilityCondition: null,
            numberOfColumns: 2,
            fields: {
                1: [
                    {
                        fieldType: 'FormFieldRepresentation',
                        id: 'showtext',
                        name: 'Show text',
                        type: 'readonly-text',
                        value: 'This test is shown when the visibility logic is displayed.\nThis should only show under the following conditions:\nAnnual and installment > 5\nQuarterly and installment > 20\nMonthly and installment > 60',
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 2
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 1
                        },
                        sizeX: 1,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: {
                            leftFormFieldId: 'schedule',
                            leftRestResponseId: null,
                            operator: '==',
                            rightValue: 'ANNUAL',
                            rightType: null,
                            rightFormFieldId: '',
                            rightRestResponseId: '',
                            nextConditionOperator: 'and',
                            nextCondition: {
                                leftFormFieldId: 'installments',
                                leftRestResponseId: null,
                                operator: '>',
                                rightValue: 5,
                                rightType: null,
                                rightFormFieldId: '',
                                rightRestResponseId: '',
                                nextConditionOperator: 'or',
                                nextCondition: {
                                    leftFormFieldId: 'schedule',
                                    leftRestResponseId: null,
                                    operator: '==',
                                    rightValue: 'QUARTERLY',
                                    rightType: null,
                                    rightFormFieldId: '',
                                    rightRestResponseId: '',
                                    nextConditionOperator: 'and',
                                    nextCondition: {
                                        leftFormFieldId: 'installments',
                                        leftRestResponseId: null,
                                        operator: '>',
                                        rightValue: 20,
                                        rightType: null,
                                        rightFormFieldId: '',
                                        rightRestResponseId: '',
                                        nextConditionOperator: 'or',
                                        nextCondition: {
                                            leftFormFieldId: 'schedule',
                                            leftRestResponseId: null,
                                            operator: '==',
                                            rightValue: 'MONTHLY',
                                            rightType: null,
                                            rightFormFieldId: '',
                                            rightRestResponseId: '',
                                            nextConditionOperator: 'and',
                                            nextCondition: {
                                                leftFormFieldId: 'installments',
                                                leftRestResponseId: null,
                                                operator: '>',
                                                rightValue: 60,
                                                rightType: null,
                                                rightFormFieldId: '',
                                                rightRestResponseId: '',
                                                nextConditionOperator: '',
                                                nextCondition: null
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                ],
                2: []
            }
        }
    ],
    variables: [
        {
            id: 'e621e8ff-42a6-499c-8121-33c7c35d8641',
            name: 'age',
            type: 'integer',
            value: 11
        },
        {
            id: '4f8aa99e-8526-429c-9d99-809978489d96',
            name: 'name',
            type: 'string',
            value: 'abc'
        },
        {
            id: '0207b649-ff07-4f3a-a589-d10afa507b9b',
            name: 'dob',
            type: 'date',
            value: '2019-05-13'
        }
    ]
};
const complexVisibilityJsonVisible = {
    id: 47591,
    name: 'Test-visibility',
    description: '',
    version: 4,
    lastUpdatedBy: 13,
    lastUpdatedByFullName: 'romano romano',
    lastUpdated: '2019-06-11T11:  04:  36.870+0000',
    stencilSetId: 0,
    referenceId: null,
    formDefinition: {
        tabs: [],
        fields: [{
                fieldType: 'ContainerRepresentation',
                id: '1560246123312',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label',
                            name: 'Label',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label1',
                            name: 'Label1',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }]
                }
            }, {
                fieldType: 'ContainerRepresentation',
                id: '1560246128696',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label4',
                            name: 'Label4',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label3',
                            name: 'Label3',
                            type: 'text',
                            value: '',
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }]
                }
            }, {
                fieldType: 'ContainerRepresentation',
                id: '1560246126964',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label2',
                            name: 'Label2',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label5',
                            name: 'Label5',
                            type: 'boolean',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: {
                                leftFormFieldId: 'label',
                                leftRestResponseId: null,
                                operator: '==',
                                rightValue: 'aaa',
                                rightType: null,
                                rightFormFieldId: '',
                                rightRestResponseId: '',
                                nextConditionOperator: 'and',
                                nextCondition: {
                                    leftFormFieldId: 'label1',
                                    leftRestResponseId: null,
                                    operator: '!=',
                                    rightValue: 'aaa',
                                    rightType: null,
                                    rightFormFieldId: '',
                                    rightRestResponseId: '',
                                    nextConditionOperator: 'and',
                                    nextCondition: {
                                        leftFormFieldId: 'label2',
                                        leftRestResponseId: null,
                                        operator: '!empty',
                                        rightValue: null,
                                        rightType: null,
                                        rightFormFieldId: '',
                                        rightRestResponseId: '',
                                        nextConditionOperator: 'or',
                                        nextCondition: {
                                            leftFormFieldId: 'label3',
                                            leftRestResponseId: null,
                                            operator: 'empty',
                                            rightValue: null,
                                            rightType: null,
                                            rightFormFieldId: '',
                                            rightRestResponseId: '',
                                            nextConditionOperator: null,
                                            nextCondition: null
                                        }
                                    }
                                }
                            }
                        }]
                }
            }],
        outcomes: [],
        javascriptEvents: [],
        className: '',
        style: '',
        customFieldTemplates: {},
        metadata: {},
        variables: [],
        customFieldsValueInfo: {},
        gridsterForm: false
    }
};
const complexVisibilityJsonNotVisible = {
    id: 47591,
    name: 'Test-visibility',
    description: '',
    version: 4,
    lastUpdatedBy: 13,
    lastUpdatedByFullName: 'romano romano',
    lastUpdated: '2019-06-11T11:  04:  36.870+0000',
    stencilSetId: 0,
    referenceId: null,
    formDefinition: {
        tabs: [],
        fields: [{
                fieldType: 'ContainerRepresentation',
                id: '1560246123312',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label',
                            name: 'Label',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label1',
                            name: 'Label1',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }]
                }
            }, {
                fieldType: 'ContainerRepresentation',
                id: '1560246128696',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label4',
                            name: 'Label4',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label3',
                            name: 'Label3',
                            type: 'text',
                            value: 'OPSSS',
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }]
                }
            }, {
                fieldType: 'ContainerRepresentation',
                id: '1560246126964',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: null,
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label2',
                            name: 'Label2',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 2 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }],
                    2: [{
                            fieldType: 'FormFieldRepresentation',
                            id: 'label5',
                            name: 'Label5',
                            type: 'boolean',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            params: { existingColspan: 1, maxColspan: 1 },
                            dateDisplayFormat: null,
                            layout: { row: -1, column: -1, colspan: 1 },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: {
                                leftFormFieldId: 'label',
                                leftRestResponseId: null,
                                operator: '==',
                                rightValue: 'aaa',
                                rightFormFieldId: '',
                                rightRestResponseId: '',
                                nextConditionOperator: 'and',
                                nextCondition: {
                                    leftFormFieldId: 'label1',
                                    leftRestResponseId: null,
                                    operator: '!=',
                                    rightValue: 'aaa',
                                    rightFormFieldId: '',
                                    rightRestResponseId: '',
                                    nextConditionOperator: 'and',
                                    nextCondition: {
                                        leftFormFieldId: 'label2',
                                        leftRestResponseId: null,
                                        operator: '!empty',
                                        rightValue: null,
                                        rightFormFieldId: '',
                                        rightRestResponseId: '',
                                        nextConditionOperator: 'or',
                                        nextCondition: {
                                            leftFormFieldId: 'label3',
                                            leftRestResponseId: null,
                                            operator: 'empty',
                                            rightValue: null,
                                            rightFormFieldId: '',
                                            rightRestResponseId: '',
                                            nextConditionOperator: null,
                                            nextCondition: null
                                        }
                                    }
                                }
                            }
                        }]
                }
            }],
        outcomes: [],
        javascriptEvents: [],
        className: '',
        style: '',
        customFieldTemplates: {},
        metadata: {},
        variables: [],
        customFieldsValueInfo: {},
        gridsterForm: false
    }
};
const tabVisibilityJsonMock = {
    id: 45231,
    name: 'visibility-form',
    description: '',
    version: 2,
    lastUpdatedBy: 4255,
    lastUpdatedByFullName: 'first last',
    lastUpdated: '2019-08-26T08: 04: 02.091+0000',
    stencilSetId: null,
    referenceId: null,
    tabs: [
        {
            id: 'tab1',
            title: 'tab1',
            visibilityCondition: null
        },
        {
            id: 'tab2',
            title: 'Tab2',
            visibilityCondition: {
                leftFormFieldId: 'label',
                leftRestResponseId: null,
                operator: '==',
                rightValue: 'text',
                rightType: null,
                rightFormFieldId: '',
                rightRestResponseId: '',
                nextConditionOperator: '',
                nextCondition: null
            }
        }
    ],
    formDefinition: {
        fields: [
            {
                fieldType: 'ContainerRepresentation',
                id: '1566806229182',
                name: 'Label',
                type: 'container',
                value: null,
                required: false,
                readOnly: false,
                overrideId: false,
                colspan: 1,
                placeholder: null,
                minLength: 0,
                maxLength: 0,
                minValue: null,
                maxValue: null,
                regexPattern: null,
                optionType: null,
                hasEmptyValue: null,
                options: null,
                restUrl: null,
                restResponsePath: null,
                restIdProperty: null,
                restLabelProperty: null,
                tab: 'tab1',
                className: null,
                dateDisplayFormat: null,
                layout: null,
                sizeX: 2,
                sizeY: 1,
                row: -1,
                col: -1,
                visibilityCondition: null,
                numberOfColumns: 2,
                fields: {
                    1: [
                        {
                            fieldType: 'FormFieldRepresentation',
                            id: 'label',
                            name: 'Label',
                            type: 'text',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: 'tab1',
                            className: null,
                            params: {
                                existingColspan: 1,
                                maxColspan: 2
                            },
                            dateDisplayFormat: null,
                            layout: {
                                row: -1,
                                column: -1,
                                colspan: 1
                            },
                            sizeX: 1,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null
                        }
                    ],
                    2: []
                }
            }
        ],
        outcomes: [],
        javascriptEvents: [],
        className: '',
        style: '',
        customFieldTemplates: {},
        metadata: {},
        variables: [],
        customFieldsValueInfo: {},
        gridsterForm: false
    }
};
const tabInvalidFormVisibility = {
    id: 'form-0668939d-34b2-440c-ab4d-01ab8b05a881',
    name: 'tab-visibility',
    description: '',
    version: 0,
    standalone: true,
    tabs: [
        {
            id: 'a8a4718d-5019-4852-9645-bba9b8253d86',
            title: 'tab1',
            visibilityCondition: {
                leftType: 'field',
                leftValue: 'Text1',
                operator: '==',
                rightValue: 'showtab',
                rightType: 'value',
                nextConditionOperator: '',
                nextCondition: null
            }
        },
        {
            id: 'bb9033ca-55ef-432a-8120-bffc8a179ebb',
            title: 'tab2',
            visibilityCondition: null
        }
    ],
    formDefinition: {
        fields: [
            {
                id: '093270a5-6e28-4cf0-a72a-09731c0d59fd',
                name: 'Label',
                type: 'container',
                tab: 'a8a4718d-5019-4852-9645-bba9b8253d86',
                numberOfColumns: 2,
                fields: {
                    1: [
                        {
                            id: 'Number1',
                            name: 'Number1',
                            type: 'integer',
                            colspan: 1,
                            placeholder: null,
                            minValue: null,
                            maxValue: null,
                            required: false,
                            visibilityCondition: null,
                            params: {
                                existingColspan: 1,
                                maxColspan: 2
                            }
                        },
                        {
                            id: 'Number2',
                            name: 'Number2',
                            type: 'integer',
                            colspan: 1,
                            placeholder: null,
                            minValue: null,
                            maxValue: null,
                            required: false,
                            visibilityCondition: {
                                leftType: 'field',
                                leftValue: 'Text2',
                                operator: '==',
                                rightValue: 'shownumber',
                                rightType: 'value',
                                nextConditionOperator: '',
                                nextCondition: null
                            },
                            params: {
                                existingColspan: 1,
                                maxColspan: 2
                            }
                        }
                    ],
                    2: [
                        {
                            id: 'Text2',
                            name: 'Text2',
                            type: 'text',
                            required: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            regexPattern: null,
                            visibilityCondition: null,
                            params: {
                                existingColspan: 1,
                                maxColspan: 2
                            }
                        }
                    ]
                }
            },
            {
                id: 'c33579eb-3514-42cc-832d-2998d06a3eab',
                name: 'Label',
                type: 'container',
                tab: 'bb9033ca-55ef-432a-8120-bffc8a179ebb',
                numberOfColumns: 2,
                fields: {
                    1: [
                        {
                            id: 'Text1',
                            name: 'Text1',
                            type: 'text',
                            required: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            regexPattern: null,
                            visibilityCondition: null,
                            params: {
                                existingColspan: 1,
                                maxColspan: 2
                            }
                        }
                    ],
                    2: []
                }
            }
        ],
        outcomes: [],
        metadata: {},
        variables: []
    }
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDataColumnMock = (column = {}) => ({
    id: 'columnId',
    key: 'key',
    type: 'text',
    format: 'format',
    sortable: false,
    title: 'title',
    srTitle: 'srTitle',
    cssClass: 'cssClass',
    template: undefined,
    copyContent: false,
    editable: false,
    focus: false,
    sortingKey: 'sortingKey',
    header: undefined,
    draggable: false,
    isHidden: false,
    customData: undefined,
    ...column
});
const dataText = new ObjectDataTableAdapter([
    { id: '1 first' },
    { id: '2 second' },
    { id: '3 third' }
]);
const dateRows = [
    { createdOn: new Date(2016, 6, 1, 11, 8, 4) },
    { createdOn: new Date(2018, 4, 3, 12, 8, 4) },
    { createdOn: new Date(2021, 2, 3, 9, 8, 4) }
];
const dateColumns = {
    type: 'date',
    key: 'createdOn',
    title: 'Created On'
};
const locationRows = [
    {
        path: {
            elements: [
                { id: '1', name: 'path' },
                { id: '2', name: 'to' },
                { id: '3', name: 'location' }
            ],
            name: '/path/to/location-link'
        }
    }
];
const locationColumns = [
    { format: '/somewhere', type: 'location', key: 'path', title: 'Location' }
];
const dataIcon = new ObjectDataTableAdapter([
    { icon: 'alarm' },
    { icon: 'folder_open' },
    { icon: 'accessibility' }
]);
const dataSizeInBytes = new ObjectDataTableAdapter([
    { size: 12313 },
    { size: 23 },
    { size: 42421412421 }
]);

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const resetTestingModule = TestBed.resetTestingModule;
const preventAngularFromResetting = () => (TestBed.resetTestingModule = () => TestBed);
const allowAngularToReset = () => (TestBed.resetTestingModule = resetTestingModule);
const setupTestBed = (moduleDef) => {
    beforeAll((done) => {
        localStorage.clear();
        sessionStorage.clear();
        resetTestingModule();
        preventAngularFromResetting();
        TestBed.configureTestingModule(moduleDef);
        TestBed.compileComponents()
            .then(() => {
            TestBed.resetTestingModule = () => TestBed;
            done();
        })
            .catch(done.fail);
    });
    afterAll(() => allowAngularToReset());
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function directionalityConfigFactory(directionalityConfigService) {
    return () => directionalityConfigService;
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DirectionalityConfigService {
    constructor(document, rendererFactory, userPreferencesService, directionality) {
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.userPreferencesService = userPreferencesService;
        this.directionality = directionality;
        const renderer = this.rendererFactory.createRenderer(null, null);
        this.userPreferencesService
            .select('textOrientation')
            .subscribe((direction) => {
            renderer.setAttribute(this.document.body, 'dir', direction);
            this.directionality.value = direction;
        });
    }
}
DirectionalityConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectionalityConfigService, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: UserPreferencesService }, { token: i2$9.Directionality }], target: i0.ɵɵFactoryTarget.Injectable });
DirectionalityConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectionalityConfigService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DirectionalityConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: UserPreferencesService }, { type: i2$9.Directionality }]; } });

class LegacyClientFactory {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    create(apiClass) {
        return new apiClass(this.alfrescoApiService.getInstance());
    }
}
LegacyClientFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyClientFactory, deps: [{ token: AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
LegacyClientFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyClientFactory });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyClientFactory, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LegacyApiClientModule {
}
LegacyApiClientModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyApiClientModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LegacyApiClientModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: LegacyApiClientModule });
LegacyApiClientModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyApiClientModule, providers: [
        { provide: API_CLIENT_FACTORY_TOKEN, useClass: LegacyClientFactory }
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LegacyApiClientModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        { provide: API_CLIENT_FACTORY_TOKEN, useClass: LegacyClientFactory }
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function loadAppConfig(appConfigService, storageService) {
    return () => appConfigService.load().then(() => {
        storageService.prefix = appConfigService.get(AppConfigValues.STORAGE_PREFIX, '');
    });
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createAlfrescoApiInstance(angularAlfrescoApiService) {
    return () => angularAlfrescoApiService.init();
}
class AlfrescoApiLoaderService {
    constructor(appConfig, apiService) {
        this.appConfig = appConfig;
        this.apiService = apiService;
    }
    async init() {
        await this.appConfig.load();
        return this.initAngularAlfrescoApi();
    }
    async initAngularAlfrescoApi() {
        const oauth = this.appConfig.oauth2;
        if (oauth) {
            oauth.redirectUri = window.location.origin + window.location.pathname;
            oauth.redirectUriLogout = window.location.origin + window.location.pathname;
        }
        const config = new AlfrescoApiConfig({
            provider: this.appConfig.get(AppConfigValues.PROVIDERS),
            hostEcm: this.appConfig.get(AppConfigValues.ECMHOST),
            hostBpm: this.appConfig.get(AppConfigValues.BPMHOST),
            authType: this.appConfig.get(AppConfigValues.AUTHTYPE, 'BASIC'),
            contextRootBpm: this.appConfig.get(AppConfigValues.CONTEXTROOTBPM),
            contextRoot: this.appConfig.get(AppConfigValues.CONTEXTROOTECM),
            disableCsrf: this.appConfig.get(AppConfigValues.DISABLECSRF),
            withCredentials: this.appConfig.get(AppConfigValues.AUTH_WITH_CREDENTIALS, false),
            domainPrefix: this.appConfig.get(AppConfigValues.STORAGE_PREFIX),
            oauth2: oauth
        });
        await this.apiService.load(config);
    }
}
AlfrescoApiLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiLoaderService, deps: [{ token: AppConfigService }, { token: AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
AlfrescoApiLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiLoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoApiServiceWithAngularBasedHttpClient extends AlfrescoApiService {
    constructor(storage, appConfig, alfrescoApiHttpClient) {
        super(appConfig, storage);
        this.alfrescoApiHttpClient = alfrescoApiHttpClient;
    }
    createInstance(config) {
        return new AlfrescoApi(config, this.alfrescoApiHttpClient);
    }
}
AlfrescoApiServiceWithAngularBasedHttpClient.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceWithAngularBasedHttpClient, deps: [{ token: StorageService }, { token: AppConfigService }, { token: i3$3.AlfrescoApiHttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AlfrescoApiServiceWithAngularBasedHttpClient.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceWithAngularBasedHttpClient });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoApiServiceWithAngularBasedHttpClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StorageService }, { type: AppConfigService }, { type: i3$3.AlfrescoApiHttpClient }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const defaultConfig = { useAngularBasedHttpClientInAlfrescoJs: false };
class CoreModule {
    constructor(translation) {
        translation.addTranslationFolder('adf-core', 'assets/adf-core');
    }
    static forRoot(config = defaultConfig) {
        return {
            ngModule: CoreModule,
            providers: [
                TranslateStore,
                TranslateService,
                { provide: TranslateLoader, useClass: TranslateLoaderService },
                {
                    provide: APP_INITIALIZER,
                    useFactory: loadAppConfig,
                    deps: [AppConfigService, StorageService], multi: true
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: directionalityConfigFactory,
                    deps: [DirectionalityConfigService],
                    multi: true
                },
                { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
                { provide: Authentication, useClass: AuthenticationService },
                {
                    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
                    useValue: {
                        duration: 10000
                    }
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: createAlfrescoApiInstance,
                    deps: [AlfrescoApiLoaderService],
                    multi: true
                },
                ...(config.useAngularBasedHttpClientInAlfrescoJs
                    ? [{ provide: AlfrescoApiService, useClass: AlfrescoApiServiceWithAngularBasedHttpClient }]
                    : [])
            ]
        };
    }
    static forChild() {
        return {
            ngModule: CoreModule
        };
    }
}
CoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreModule, deps: [{ token: TranslationService }], target: i0.ɵɵFactoryTarget.NgModule });
CoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CoreModule, imports: [TranslateModule,
        ExtensionsModule,
        AboutModule,
        ViewerModule,
        SidenavLayoutModule,
        PipeModule,
        CommonModule,
        IdentityUserInfoModule,
        DirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        AppConfigModule,
        PaginationModule,
        ToolbarModule,
        ContextMenuModule,
        CardViewModule,
        FormBaseModule,
        CommentsModule,
        CommentListModule,
        LoginModule,
        LanguageMenuModule,
        InfoDrawerModule,
        DataTableModule,
        ButtonsMenuModule,
        TemplateModule,
        IconModule,
        SortingPickerModule,
        NotificationHistoryModule,
        SearchTextModule,
        BlankPageModule,
        LegacyApiClientModule,
        AlfrescoJsClientsModule,
        HttpClientModule, i1$1.HttpClientXsrfModule], exports: [AboutModule,
        ViewerModule,
        SidenavLayoutModule,
        PipeModule,
        CommonModule,
        DirectiveModule,
        ClipboardModule,
        FormsModule,
        IdentityUserInfoModule,
        ReactiveFormsModule,
        MaterialModule,
        AppConfigModule,
        PaginationModule,
        ToolbarModule,
        ContextMenuModule,
        CardViewModule,
        FormBaseModule,
        CommentsModule,
        CommentListModule,
        LoginModule,
        LanguageMenuModule,
        InfoDrawerModule,
        DataTableModule,
        TranslateModule,
        ButtonsMenuModule,
        TemplateModule,
        SortingPickerModule,
        IconModule,
        NotificationHistoryModule,
        SearchTextModule,
        BlankPageModule] });
CoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreModule, imports: [TranslateModule,
        ExtensionsModule,
        AboutModule,
        ViewerModule,
        SidenavLayoutModule,
        PipeModule,
        CommonModule,
        IdentityUserInfoModule,
        DirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        AppConfigModule,
        PaginationModule,
        ToolbarModule,
        ContextMenuModule,
        CardViewModule,
        FormBaseModule,
        CommentsModule,
        CommentListModule,
        LoginModule,
        LanguageMenuModule,
        InfoDrawerModule,
        DataTableModule,
        ButtonsMenuModule,
        TemplateModule,
        IconModule,
        SortingPickerModule,
        NotificationHistoryModule,
        SearchTextModule,
        BlankPageModule,
        LegacyApiClientModule,
        AlfrescoJsClientsModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'CSRF-TOKEN',
            headerName: 'X-CSRF-TOKEN'
        }), AboutModule,
        ViewerModule,
        SidenavLayoutModule,
        PipeModule,
        CommonModule,
        DirectiveModule,
        ClipboardModule,
        FormsModule,
        IdentityUserInfoModule,
        ReactiveFormsModule,
        MaterialModule,
        AppConfigModule,
        PaginationModule,
        ToolbarModule,
        ContextMenuModule,
        CardViewModule,
        FormBaseModule,
        CommentsModule,
        CommentListModule,
        LoginModule,
        LanguageMenuModule,
        InfoDrawerModule,
        DataTableModule,
        TranslateModule,
        ButtonsMenuModule,
        TemplateModule,
        SortingPickerModule,
        IconModule,
        NotificationHistoryModule,
        SearchTextModule,
        BlankPageModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule,
                        ExtensionsModule,
                        AboutModule,
                        ViewerModule,
                        SidenavLayoutModule,
                        PipeModule,
                        CommonModule,
                        IdentityUserInfoModule,
                        DirectiveModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MaterialModule,
                        AppConfigModule,
                        PaginationModule,
                        ToolbarModule,
                        ContextMenuModule,
                        CardViewModule,
                        FormBaseModule,
                        CommentsModule,
                        CommentListModule,
                        LoginModule,
                        LanguageMenuModule,
                        InfoDrawerModule,
                        DataTableModule,
                        ButtonsMenuModule,
                        TemplateModule,
                        IconModule,
                        SortingPickerModule,
                        NotificationHistoryModule,
                        SearchTextModule,
                        BlankPageModule,
                        LegacyApiClientModule,
                        AlfrescoJsClientsModule,
                        HttpClientModule,
                        HttpClientXsrfModule.withOptions({
                            cookieName: 'CSRF-TOKEN',
                            headerName: 'X-CSRF-TOKEN'
                        })
                    ],
                    exports: [
                        AboutModule,
                        ViewerModule,
                        SidenavLayoutModule,
                        PipeModule,
                        CommonModule,
                        DirectiveModule,
                        ClipboardModule,
                        FormsModule,
                        IdentityUserInfoModule,
                        ReactiveFormsModule,
                        MaterialModule,
                        AppConfigModule,
                        PaginationModule,
                        ToolbarModule,
                        ContextMenuModule,
                        CardViewModule,
                        FormBaseModule,
                        CommentsModule,
                        CommentListModule,
                        LoginModule,
                        LanguageMenuModule,
                        InfoDrawerModule,
                        DataTableModule,
                        TranslateModule,
                        ButtonsMenuModule,
                        TemplateModule,
                        SortingPickerModule,
                        IconModule,
                        NotificationHistoryModule,
                        SearchTextModule,
                        BlankPageModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AppConfigServiceMock extends AppConfigService {
    constructor(http, extensionService) {
        super(http, extensionService);
        this.config = {
            application: {
                name: 'Alfresco ADF Application'
            },
            ecmHost: 'http://{hostname}{:port}/ecm',
            bpmHost: 'http://{hostname}{:port}/bpm',
            logLevel: 'silent'
        };
    }
    load() {
        return new Promise((resolve) => {
            this.status = Status.LOADED;
            this.onDataLoaded(this.config);
            resolve(this.config);
        });
    }
}
AppConfigServiceMock.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigServiceMock, deps: [{ token: i1$1.HttpClient }, { token: i2$1.ExtensionService }], target: i0.ɵɵFactoryTarget.Injectable });
AppConfigServiceMock.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigServiceMock });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AppConfigServiceMock, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i2$1.ExtensionService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CoreTestingModule {
}
CoreTestingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CoreTestingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CoreTestingModule, imports: [NoopAnimationsModule,
        RouterTestingModule,
        HttpClientModule, i3.TranslateModule, CoreModule], exports: [NoopAnimationsModule,
        CoreModule,
        TranslateModule] });
CoreTestingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreTestingModule, providers: [
        DatePipe,
        { provide: AlfrescoApiService, useClass: AlfrescoApiServiceMock },
        { provide: AppConfigService, useClass: AppConfigServiceMock },
        { provide: TranslationService, useClass: TranslationMock },
        { provide: CookieService, useClass: CookieServiceMock },
        {
            provide: APP_INITIALIZER,
            useFactory: directionalityConfigFactory,
            deps: [DirectionalityConfigService],
            multi: true
        }
    ], imports: [NoopAnimationsModule,
        RouterTestingModule,
        HttpClientModule,
        TranslateModule.forRoot(),
        CoreModule.forRoot(), NoopAnimationsModule,
        CoreModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NoopAnimationsModule,
                        RouterTestingModule,
                        HttpClientModule,
                        TranslateModule.forRoot(),
                        CoreModule.forRoot()
                    ],
                    providers: [
                        DatePipe,
                        { provide: AlfrescoApiService, useClass: AlfrescoApiServiceMock },
                        { provide: AppConfigService, useClass: AppConfigServiceMock },
                        { provide: TranslationService, useClass: TranslationMock },
                        { provide: CookieService, useClass: CookieServiceMock },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: directionalityConfigFactory,
                            deps: [DirectionalityConfigService],
                            multi: true
                        }
                    ],
                    exports: [
                        NoopAnimationsModule,
                        CoreModule,
                        TranslateModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DemoForm {
    constructor() {
        this.easyForm = {
            formRepresentation: {
                id: 1001,
                name: 'ISSUE_FORM',
                tabs: [],
                fields: [
                    {
                        fieldType: 'ContainerRepresentation',
                        id: '1498212398417',
                        name: 'Label',
                        type: 'container',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: false,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        dateDisplayFormat: null,
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        numberOfColumns: 2,
                        fields: {
                            1: [
                                {
                                    fieldType: 'RestFieldRepresentation',
                                    id: 'label',
                                    name: 'Label',
                                    type: 'dropdown',
                                    value: 'Choose one...',
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: true,
                                    options: [
                                        {
                                            id: 'empty',
                                            name: 'Choose one...'
                                        },
                                        {
                                            id: 'option_1',
                                            name: 'test1'
                                        },
                                        {
                                            id: 'option_2',
                                            name: 'test2'
                                        },
                                        {
                                            id: 'option_3',
                                            name: 'test3'
                                        }
                                    ],
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: null,
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    endpoint: null,
                                    requestHeaders: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'Date',
                                    name: 'Date',
                                    type: 'date',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label5',
                                    name: 'Label5',
                                    type: 'boolean',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label6',
                                    name: 'Label6',
                                    type: 'boolean',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label4',
                                    name: 'Label4',
                                    type: 'integer',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'RestFieldRepresentation',
                                    id: 'label12',
                                    name: 'Label12',
                                    type: 'radio-buttons',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: [
                                        {
                                            id: 'option_1',
                                            name: 'Option 1'
                                        },
                                        {
                                            id: 'option_2',
                                            name: 'Option 2'
                                        }
                                    ],
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    endpoint: null,
                                    requestHeaders: null
                                }
                            ]
                        }
                    }
                ],
                outcomes: [],
                javascriptEvents: [],
                className: '',
                style: '',
                customFieldTemplates: {},
                metadata: {},
                variables: [
                    {
                        id: 'bfca9766-7bc1-45cc-8ecf-cdad551e36e2',
                        name: 'name1',
                        type: 'string',
                        value: ''
                    },
                    {
                        id: '3ed9f28a-dbae-463f-b991-47ef06658bb6',
                        name: 'name2',
                        type: 'string',
                        value: ''
                    },
                    {
                        id: 'a7710978-1e9c-4b54-a19c-c6267d2b19a2',
                        name: 'input02',
                        type: 'integer'
                    }
                ],
                customFieldsValueInfo: {},
                gridsterForm: false,
                globalDateFormat: 'D-M-YYYY'
            }
        };
        this.formDefinition = {
            formRepresentation: {
                id: 3003,
                name: 'demo-01',
                taskId: '7501',
                taskName: 'Demo Form 01',
                tabs: [
                    {
                        id: 'tab1',
                        title: 'Text',
                        visibilityCondition: null
                    },
                    {
                        id: 'tab2',
                        title: 'Misc',
                        visibilityCondition: null
                    }
                ],
                fields: [
                    {
                        fieldType: 'ContainerRepresentation',
                        id: '1488274019966',
                        name: 'Label',
                        type: 'container',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: null,
                        className: null,
                        dateDisplayFormat: null,
                        layout: null,
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        numberOfColumns: 2,
                        fields: {
                            1: [],
                            2: []
                        }
                    },
                    {
                        fieldType: 'ContainerRepresentation',
                        id: 'section4',
                        name: 'Section 4',
                        type: 'group',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: 'tab2',
                        className: null,
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 2
                        },
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        numberOfColumns: 2,
                        fields: {
                            1: [
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label8',
                                    name: 'Label8',
                                    type: 'people',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label13',
                                    name: 'Label13',
                                    type: 'functional-group',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label18',
                                    name: 'Label18',
                                    type: 'readonly',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label19',
                                    name: 'Label19',
                                    type: 'readonly-text',
                                    value: 'Display text as part of the form',
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                }
                            ],
                            2: [
                                {
                                    fieldType: 'HyperlinkRepresentation',
                                    id: 'label15',
                                    name: 'Label15',
                                    type: 'hyperlink',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    hyperlinkUrl: 'www.google.com',
                                    displayText: null
                                },
                                {
                                    fieldType: 'AttachFileFieldRepresentation',
                                    id: 'label16',
                                    name: 'Label16',
                                    type: 'upload',
                                    value: [],
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1,
                                        fileSource: {
                                            serviceId: 'all-file-sources',
                                            name: 'All file sources'
                                        }
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    metaDataColumnDefinitions: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label17',
                                    name: 'Label17',
                                    type: 'select-folder',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab2',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1,
                                        folderSource: {
                                            serviceId: 'alfresco-1',
                                            name: 'Alfresco 5.2 Local',
                                            metaDataAllowed: true
                                        }
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                }
                            ]
                        }
                    },
                    {
                        fieldType: 'DynamicTableRepresentation',
                        id: 'label14',
                        name: 'Label14',
                        type: 'dynamic-table',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: 'tab2',
                        className: null,
                        params: {
                            existingColspan: 1,
                            maxColspan: 1
                        },
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 2
                        },
                        sizeX: 2,
                        sizeY: 2,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        columnDefinitions: [
                            {
                                id: 'id',
                                name: 'id',
                                type: 'String',
                                value: null,
                                optionType: null,
                                options: null,
                                restResponsePath: null,
                                restUrl: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                amountCurrency: null,
                                amountEnableFractions: false,
                                required: true,
                                editable: true,
                                sortable: true,
                                visible: true,
                                endpoint: null,
                                requestHeaders: null
                            },
                            {
                                id: 'name',
                                name: 'name',
                                type: 'String',
                                value: null,
                                optionType: null,
                                options: null,
                                restResponsePath: null,
                                restUrl: null,
                                restIdProperty: null,
                                restLabelProperty: null,
                                amountCurrency: null,
                                amountEnableFractions: false,
                                required: true,
                                editable: true,
                                sortable: true,
                                visible: true,
                                endpoint: null,
                                requestHeaders: null
                            }
                        ]
                    },
                    {
                        fieldType: 'ContainerRepresentation',
                        id: 'section1',
                        name: 'Section 1',
                        type: 'group',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: 'tab1',
                        className: null,
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 2
                        },
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        numberOfColumns: 2,
                        fields: {
                            1: [
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label1',
                                    name: 'Label1',
                                    type: 'text',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label3',
                                    name: 'Label3',
                                    type: 'text',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                }
                            ],
                            2: [
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label2',
                                    name: 'Label2',
                                    type: 'multi-line-text',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 2,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                }
                            ]
                        }
                    },
                    {
                        fieldType: 'ContainerRepresentation',
                        id: 'section2',
                        name: 'Section 2',
                        type: 'group',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: 'tab1',
                        className: null,
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 2
                        },
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        numberOfColumns: 2,
                        fields: {
                            1: [
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label4',
                                    name: 'Label4',
                                    type: 'integer',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label7',
                                    name: 'Label7',
                                    type: 'date',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                }
                            ],
                            2: [
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label5',
                                    name: 'Label5',
                                    type: 'boolean',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'FormFieldRepresentation',
                                    id: 'label6',
                                    name: 'Label6',
                                    type: 'boolean',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null
                                },
                                {
                                    fieldType: 'AmountFieldRepresentation',
                                    id: 'label11',
                                    name: 'Label11',
                                    type: 'amount',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: '10',
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    enableFractions: false,
                                    currency: null
                                }
                            ]
                        }
                    },
                    {
                        fieldType: 'ContainerRepresentation',
                        id: 'section3',
                        name: 'Section 3',
                        type: 'group',
                        value: null,
                        required: false,
                        readOnly: false,
                        overrideId: false,
                        colspan: 1,
                        placeholder: null,
                        minLength: 0,
                        maxLength: 0,
                        minValue: null,
                        maxValue: null,
                        regexPattern: null,
                        optionType: null,
                        hasEmptyValue: null,
                        options: null,
                        restUrl: null,
                        restResponsePath: null,
                        restIdProperty: null,
                        restLabelProperty: null,
                        tab: 'tab1',
                        className: null,
                        dateDisplayFormat: null,
                        layout: {
                            row: -1,
                            column: -1,
                            colspan: 2
                        },
                        sizeX: 2,
                        sizeY: 1,
                        row: -1,
                        col: -1,
                        visibilityCondition: null,
                        numberOfColumns: 2,
                        fields: {
                            1: [
                                {
                                    fieldType: 'RestFieldRepresentation',
                                    id: 'label9',
                                    name: 'Label9',
                                    type: 'dropdown',
                                    value: 'Choose one...',
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: true,
                                    options: [
                                        {
                                            id: 'empty',
                                            name: 'Choose one...'
                                        }
                                    ],
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    endpoint: null,
                                    requestHeaders: null
                                },
                                {
                                    fieldType: 'RestFieldRepresentation',
                                    id: 'label12',
                                    name: 'Label12',
                                    type: 'radio-buttons',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: [
                                        {
                                            id: 'option_1',
                                            name: 'Option 1'
                                        },
                                        {
                                            id: 'option_2',
                                            name: 'Option 2'
                                        }
                                    ],
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 2
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    endpoint: null,
                                    requestHeaders: null
                                }
                            ],
                            2: [
                                {
                                    fieldType: 'RestFieldRepresentation',
                                    id: 'label10',
                                    name: 'Label10',
                                    type: 'typeahead',
                                    value: null,
                                    required: false,
                                    readOnly: false,
                                    overrideId: false,
                                    colspan: 1,
                                    placeholder: null,
                                    minLength: 0,
                                    maxLength: 0,
                                    minValue: null,
                                    maxValue: null,
                                    regexPattern: null,
                                    optionType: null,
                                    hasEmptyValue: null,
                                    options: null,
                                    restUrl: null,
                                    restResponsePath: null,
                                    restIdProperty: null,
                                    restLabelProperty: null,
                                    tab: 'tab1',
                                    className: null,
                                    params: {
                                        existingColspan: 1,
                                        maxColspan: 1
                                    },
                                    dateDisplayFormat: null,
                                    layout: {
                                        row: -1,
                                        column: -1,
                                        colspan: 1
                                    },
                                    sizeX: 1,
                                    sizeY: 1,
                                    row: -1,
                                    col: -1,
                                    visibilityCondition: null,
                                    endpoint: null,
                                    requestHeaders: null
                                }
                            ]
                        }
                    }
                ],
                outcomes: [],
                javascriptEvents: [],
                className: '',
                style: '',
                customFieldTemplates: {},
                metadata: {},
                variables: [
                    {
                        id: 'bfca9766-7bc1-45cc-8ecf-cdad551e36e2',
                        name: 'name1',
                        type: 'string',
                        value: ''
                    },
                    {
                        id: '3ed9f28a-dbae-463f-b991-47ef06658bb6',
                        name: 'name2',
                        type: 'string',
                        value: ''
                    },
                    {
                        id: 'a7710978-1e9c-4b54-a19c-c6267d2b19a2',
                        name: 'input02',
                        type: 'integer'
                    }
                ],
                gridsterForm: false,
                globalDateFormat: 'D-M-YYYY'
            }
        };
        this.simpleFormDefinition = {
            formRepresentation: {
                id: 1001,
                name: 'SIMPLE_FORM_EXAMPLE',
                description: '',
                version: 1,
                lastUpdatedBy: 2,
                lastUpdatedByFullName: 'Test01 01Test',
                lastUpdated: '2018-02-26T17:44:04.543+0000',
                stencilSetId: 0,
                referenceId: null,
                taskId: '9999',
                formDefinition: {
                    tabs: [],
                    fields: [
                        {
                            fieldType: 'ContainerRepresentation',
                            id: '1519666726245',
                            name: 'Label',
                            type: 'container',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            dateDisplayFormat: null,
                            layout: null,
                            sizeX: 2,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null,
                            numberOfColumns: 2,
                            fields: {
                                1: [
                                    {
                                        fieldType: 'RestFieldRepresentation',
                                        id: 'typeaheadField',
                                        name: 'TypeaheadField',
                                        type: 'typeahead',
                                        value: null,
                                        required: false,
                                        readOnly: false,
                                        overrideId: false,
                                        colspan: 1,
                                        placeholder: null,
                                        minLength: 0,
                                        maxLength: 0,
                                        minValue: null,
                                        maxValue: null,
                                        regexPattern: null,
                                        optionType: null,
                                        hasEmptyValue: null,
                                        options: null,
                                        restUrl: 'https://jsonplaceholder.typicode.com/users',
                                        restResponsePath: null,
                                        restIdProperty: 'id',
                                        restLabelProperty: 'name',
                                        tab: null,
                                        className: null,
                                        params: {
                                            existingColspan: 1,
                                            maxColspan: 2
                                        },
                                        dateDisplayFormat: null,
                                        layout: {
                                            row: -1,
                                            column: -1,
                                            colspan: 1
                                        },
                                        sizeX: 1,
                                        sizeY: 1,
                                        row: -1,
                                        col: -1,
                                        visibilityCondition: null,
                                        endpoint: null,
                                        requestHeaders: null
                                    }
                                ],
                                2: [
                                    {
                                        fieldType: 'RestFieldRepresentation',
                                        id: 'radioButton',
                                        name: 'RadioButtons',
                                        type: 'radio-buttons',
                                        value: null,
                                        required: false,
                                        readOnly: false,
                                        overrideId: false,
                                        colspan: 1,
                                        placeholder: null,
                                        minLength: 0,
                                        maxLength: 0,
                                        minValue: null,
                                        maxValue: null,
                                        regexPattern: null,
                                        optionType: null,
                                        hasEmptyValue: null,
                                        options: [
                                            {
                                                id: 'option_1',
                                                name: 'Option 1'
                                            },
                                            {
                                                id: 'option_2',
                                                name: 'Option 2'
                                            },
                                            {
                                                id: 'option_3',
                                                name: 'Option 3'
                                            }
                                        ],
                                        restUrl: null,
                                        restResponsePath: null,
                                        restIdProperty: null,
                                        restLabelProperty: null,
                                        tab: null,
                                        className: null,
                                        params: {
                                            existingColspan: 1,
                                            maxColspan: 1
                                        },
                                        dateDisplayFormat: null,
                                        layout: {
                                            row: -1,
                                            column: -1,
                                            colspan: 1
                                        },
                                        sizeX: 1,
                                        sizeY: 2,
                                        row: -1,
                                        col: -1,
                                        visibilityCondition: null,
                                        endpoint: null,
                                        requestHeaders: null
                                    }
                                ]
                            }
                        },
                        {
                            fieldType: 'ContainerRepresentation',
                            id: '1519666735185',
                            name: 'Label',
                            type: 'container',
                            value: null,
                            required: false,
                            readOnly: false,
                            overrideId: false,
                            colspan: 1,
                            placeholder: null,
                            minLength: 0,
                            maxLength: 0,
                            minValue: null,
                            maxValue: null,
                            regexPattern: null,
                            optionType: null,
                            hasEmptyValue: null,
                            options: null,
                            restUrl: null,
                            restResponsePath: null,
                            restIdProperty: null,
                            restLabelProperty: null,
                            tab: null,
                            className: null,
                            dateDisplayFormat: null,
                            layout: null,
                            sizeX: 2,
                            sizeY: 1,
                            row: -1,
                            col: -1,
                            visibilityCondition: null,
                            numberOfColumns: 2,
                            fields: {
                                1: [
                                    {
                                        fieldType: 'RestFieldRepresentation',
                                        id: 'selectBox',
                                        name: 'SelectBox',
                                        type: 'dropdown',
                                        value: 'Choose one...',
                                        required: false,
                                        readOnly: false,
                                        overrideId: false,
                                        colspan: 1,
                                        placeholder: null,
                                        minLength: 0,
                                        maxLength: 0,
                                        minValue: null,
                                        maxValue: null,
                                        regexPattern: null,
                                        optionType: 'manual',
                                        hasEmptyValue: true,
                                        options: [
                                            {
                                                id: 'empty',
                                                name: 'Choose one...'
                                            },
                                            {
                                                id: 'option_1',
                                                name: '1'
                                            },
                                            {
                                                id: 'option_2',
                                                name: '2'
                                            },
                                            {
                                                id: 'option_3',
                                                name: '3'
                                            }
                                        ],
                                        restUrl: null,
                                        restResponsePath: null,
                                        restIdProperty: null,
                                        restLabelProperty: null,
                                        tab: null,
                                        className: null,
                                        params: {
                                            existingColspan: 1,
                                            maxColspan: 2
                                        },
                                        dateDisplayFormat: null,
                                        layout: {
                                            row: -1,
                                            column: -1,
                                            colspan: 1
                                        },
                                        sizeX: 1,
                                        sizeY: 1,
                                        row: -1,
                                        col: -1,
                                        visibilityCondition: null,
                                        endpoint: null,
                                        requestHeaders: null
                                    }
                                ],
                                2: []
                            }
                        }
                    ],
                    outcomes: [],
                    javascriptEvents: [],
                    className: '',
                    style: '',
                    customFieldTemplates: {},
                    metadata: {},
                    variables: [
                        {
                            id: 'bfca9766-7bc1-45cc-8ecf-cdad551e36e2',
                            name: 'name1',
                            type: 'string',
                            value: ''
                        },
                        {
                            id: '3ed9f28a-dbae-463f-b991-47ef06658bb6',
                            name: 'name2',
                            type: 'string',
                            value: ''
                        },
                        {
                            id: 'a7710978-1e9c-4b54-a19c-c6267d2b19a2',
                            name: 'input02',
                            type: 'integer'
                        }
                    ],
                    customFieldsValueInfo: {},
                    gridsterForm: false
                }
            }
        };
        this.cloudFormDefinition = {
            formRepresentation: {
                id: 'text-form',
                name: 'test-start-form',
                version: 0,
                description: '',
                formDefinition: {
                    tabs: [],
                    fields: [
                        {
                            id: '1511517333638',
                            type: 'container',
                            fieldType: 'ContainerRepresentation',
                            name: 'Label',
                            tab: null,
                            numberOfColumns: 2,
                            fields: {
                                1: [
                                    {
                                        fieldType: 'FormFieldRepresentation',
                                        id: 'texttest',
                                        name: 'texttest',
                                        type: 'text',
                                        value: null,
                                        required: false,
                                        placeholder: 'text',
                                        params: {
                                            existingColspan: 2,
                                            maxColspan: 6,
                                            inputMaskReversed: true,
                                            inputMask: '0#',
                                            inputMaskPlaceholder: '(0-9)'
                                        }
                                    }
                                ],
                                2: [
                                    {
                                        fieldType: 'AttachFileFieldRepresentation',
                                        id: 'attachfiletest',
                                        name: 'attachfiletest',
                                        type: 'upload',
                                        required: true,
                                        colspan: 2,
                                        placeholder: 'attachfile',
                                        params: {
                                            existingColspan: 2,
                                            maxColspan: 2,
                                            fileSource: {
                                                serviceId: 'local-file',
                                                name: 'Local File'
                                            },
                                            multiple: true,
                                            link: false,
                                            displayableCMProperties: []
                                        },
                                        visibilityCondition: {}
                                    }
                                ]
                            }
                        },
                        {
                            id: 'c23bf7e8-d43c-48b6-86b9-56d174faec4f',
                            name: 'Label',
                            type: 'container',
                            tab: null,
                            numberOfColumns: 2,
                            fields: {
                                1: [
                                    {
                                        id: 'DisplayRichtext06jsjb',
                                        name: 'Display Rich text',
                                        type: 'display-rich-text',
                                        readOnly: false,
                                        value: {
                                            time: 1658423394276,
                                            blocks: [
                                                {
                                                    id: 'dry4RE17v_',
                                                    type: 'header',
                                                    data: {
                                                        text: 'Display Rich Text widget example',
                                                        level: 1
                                                    }
                                                },
                                                {
                                                    id: 'my1r7YmMOs',
                                                    type: 'paragraph',
                                                    data: {
                                                        text: `<font color="#000000">Is simply a redonly</font><mark class="cdx-marker">
                                                    <font color="#000000">dummy </font><b>text</b></mark><b></b><font color="#000000">
                                                    of the </font><i>printing and typesetting</i><font color="#000000"> industry.\n
                                                    </font><b><i>Lorem</i></b><font color="#000000"> Ipsum has been the industry\'s standard du</font><b>
                                                    <i>mmy text ever since the 1500s,\n                    when an unknown printer took a galley of type
                                                    and scrambled it to make a type specime</i></b><font color="#000000">n book. </font><font color="#ff1300">
                                                    It has survived not only five centuries</font><font color="#000000">,\n
                                                    but also the leap into </font><u>electronic </u><font color="#000000">typesetting,
                                                    </font><a href="#kljh">remaining </a><font color="#000000">essentially </font><b>unchanged</b><font color="#000000">.\n
                                                    It was </font><u class="cdx-underline"><font color="#0070ff">underline</font></u><font color="#000000">&nbsp;
                                                    in the 1960s with </font><u>the release of sheets</u><font color="#000000"> containing\n
                                                    </font><a href="#link">Lorem</a><font color="#000000"> Ipsum passages, and more recently with desktop
                                                    publishing software like Aldus PageMaker including versions of <span class="plus20pc">Lorem</span>,
                                                    <code class="inline-code">example of inline code</code></font>`
                                                    }
                                                },
                                                {
                                                    id: 'vgpY3obXS7',
                                                    type: 'list',
                                                    data: {
                                                        style: 'unordered',
                                                        items: [
                                                            'Unordered list example',
                                                            'Unordered list example'
                                                        ]
                                                    }
                                                },
                                                {
                                                    id: 'lWR9x3OF1M',
                                                    type: 'list',
                                                    data: {
                                                        style: 'ordered',
                                                        items: ['Ordered list example', 'Ordered list example']
                                                    }
                                                },
                                                {
                                                    id: 'aeZV7M8sU1',
                                                    type: 'code',
                                                    data: {
                                                        code: '// Code Block Example\ncatch(Exception ex){\n   // Houston, we have a problem\n}'
                                                    }
                                                }
                                            ],
                                            version: '2.25.0'
                                        },
                                        isCustomType: false,
                                        colspan: 1,
                                        rowspan: 1,
                                        visibilityCondition: null,
                                        params: {
                                            existingColspan: 1,
                                            maxColspan: 2
                                        }
                                    }
                                ],
                                2: []
                            }
                        }
                    ],
                    outcomes: [],
                    metadata: {
                        property1: 'value1',
                        property2: 'value2'
                    },
                    variables: [
                        {
                            name: 'variable1',
                            type: 'string',
                            value: 'value1'
                        },
                        {
                            name: 'variable2',
                            type: 'string',
                            value: 'value2'
                        }
                    ]
                }
            }
        };
    }
    getEasyForm() {
        return this.easyForm;
    }
    getFormDefinition() {
        return this.formDefinition;
    }
    getSimpleFormDefinition() {
        return this.simpleFormDefinition;
    }
    getFormCloudDefinition() {
        return this.cloudFormDefinition;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CoreAutomationService {
    constructor(appConfigService, alfrescoApiService, userPreferencesService, storageService, auth) {
        this.appConfigService = appConfigService;
        this.alfrescoApiService = alfrescoApiService;
        this.userPreferencesService = userPreferencesService;
        this.storageService = storageService;
        this.auth = auth;
        this.forms = new DemoForm();
    }
    setup() {
        const adfProxy = window['adf'] || {};
        adfProxy.getConfigField = (field) => this.appConfigService.get(field);
        adfProxy.setConfigField = (field, value) => {
            this.appConfigService.config[field] = JSON.parse(value);
        };
        adfProxy.setStorageItem = (key, data) => {
            this.storageService.setItem(key, data);
        };
        adfProxy.removeStorageItem = (key) => {
            this.storageService.removeItem(key);
        };
        adfProxy.getStorageItem = (key) => this.storageService.getItem(key);
        adfProxy.setUserPreference = (key, data) => {
            this.userPreferencesService.set(key, data);
        };
        adfProxy.setFormInEditor = (json) => {
            this.forms.formDefinition = JSON.parse(json);
        };
        adfProxy.setCloudFormInEditor = (json) => {
            this.forms.cloudFormDefinition = JSON.parse(json);
        };
        adfProxy.clearStorage = () => {
            this.storageService.clear();
        };
        adfProxy.apiReset = () => {
            this.alfrescoApiService.reset();
            this.auth.reset();
        };
        window['adf'] = adfProxy;
    }
}
CoreAutomationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreAutomationService, deps: [{ token: AppConfigService }, { token: AlfrescoApiService }, { token: UserPreferencesService }, { token: StorageService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
CoreAutomationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreAutomationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CoreAutomationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: AlfrescoApiService }, { type: UserPreferencesService }, { type: StorageService }, { type: AuthenticationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthBearerInterceptor {
    constructor(injector, authService) {
        this.injector = injector;
        this.authService = authService;
    }
    loadExcludedUrlsRegex() {
        const excludedUrls = this.authService.getBearerExcludedUrls();
        this.excludedUrlsRegex = excludedUrls.map((urlPattern) => new RegExp(urlPattern, 'i')) || [];
    }
    intercept(req, next) {
        this.authService = this.injector.get(AuthenticationService);
        if (!this.authService || !this.authService.getBearerExcludedUrls()) {
            return next.handle(req);
        }
        if (!this.excludedUrlsRegex) {
            this.loadExcludedUrlsRegex();
        }
        const urlRequest = req.url;
        const shallPass = this.excludedUrlsRegex.some((regex) => regex.test(urlRequest));
        if (shallPass) {
            return next.handle(req)
                .pipe(catchError((error) => throwError(error)));
        }
        return this.authService.addTokenToHeader(req.headers)
            .pipe(mergeMap((headersWithBearer) => {
            const headerWithContentType = this.appendJsonContentType(headersWithBearer);
            const kcReq = req.clone({ headers: headerWithContentType });
            return next.handle(kcReq)
                .pipe(catchError((error) => throwError(error)));
        }));
    }
    appendJsonContentType(headers) {
        // prevent adding any content type, to properly handle formData with boundary browser generated value,
        // as adding any Content-Type its going to break the upload functionality
        if (headers.get('Content-Type') === 'multipart/form-data') {
            return headers.delete('Content-Type');
        }
        if (!headers.get('Content-Type')) {
            return headers.set('Content-Type', 'application/json;charset=UTF-8');
        }
        return headers;
    }
}
AuthBearerInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthBearerInterceptor, deps: [{ token: i0.Injector }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthBearerInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthBearerInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthBearerInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: AuthenticationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthGuardBase {
    constructor() {
        this.authenticationService = inject(AuthenticationService);
        this.router = inject(Router);
        this.appConfigService = inject(AppConfigService);
        this.dialog = inject(MatDialog);
        this.storageService = inject(StorageService);
    }
    get withCredentials() {
        return this.appConfigService.get('auth.withCredentials', false);
    }
    canActivate(route, state) {
        if (this.authenticationService.isLoggedIn() && this.authenticationService.isOauth() && this.isLoginFragmentPresent()) {
            return this.redirectSSOSuccessURL();
        }
        return this.checkLogin(route, state.url);
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
    async redirectSSOSuccessURL() {
        const redirectFragment = this.storageService.getItem('loginFragment');
        if (redirectFragment && this.getLoginRoute() !== redirectFragment) {
            await this.navigate(redirectFragment);
            this.storageService.removeItem('loginFragment');
            return false;
        }
        return true;
    }
    isLoginFragmentPresent() {
        return !!this.storageService.getItem('loginFragment');
    }
    async redirectToUrl(url) {
        let urlToRedirect = `/${this.getLoginRoute()}`;
        if (!this.authenticationService.isOauth()) {
            this.authenticationService.setRedirect({
                provider: this.getProvider(),
                url
            });
            urlToRedirect = `${urlToRedirect}?redirectUrl=${url}`;
            return this.navigate(urlToRedirect);
        }
        else if (this.getOauthConfig().silentLogin && !this.authenticationService.isPublicUrl()) {
            this.authenticationService.ssoImplicitLogin();
        }
        else {
            return this.navigate(urlToRedirect);
        }
        return false;
    }
    async navigate(url) {
        this.dialog.closeAll();
        await this.router.navigateByUrl(this.router.parseUrl(url));
        return false;
    }
    getOauthConfig() {
        return this.appConfigService.oauth2;
    }
    getLoginRoute() {
        return (this.appConfigService &&
            this.appConfigService.get(AppConfigValues.LOGIN_ROUTE, 'login'));
    }
    getProvider() {
        return (this.appConfigService &&
            this.appConfigService.get(AppConfigValues.PROVIDERS, 'ALL'));
    }
    isOAuthWithoutSilentLogin() {
        const oauth = this.appConfigService.oauth2;
        return this.authenticationService.isOauth() && !!oauth && !oauth.silentLogin;
    }
    isSilentLogin() {
        const oauth = this.appConfigService.oauth2;
        ;
        return this.authenticationService.isOauth() && oauth && oauth.silentLogin;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthGuard extends AuthGuardBase {
    constructor(jwtHelperService) {
        super();
        this.jwtHelperService = jwtHelperService;
        this.ticketChangeBind = this.ticketChange.bind(this);
        window.addEventListener('storage', this.ticketChangeBind);
    }
    ticketChange(event) {
        if (event.key.includes('ticket-ECM') && event.newValue !== event.oldValue) {
            this.ticketChangeRedirect(event);
        }
        if (event.key.includes('ticket-BPM') && event.newValue !== event.oldValue) {
            this.ticketChangeRedirect(event);
        }
        if (event.key.endsWith(JwtHelperService.USER_ACCESS_TOKEN) &&
            this.jwtHelperService.getValueFromToken(event.newValue, JwtHelperService.USER_PREFERRED_USERNAME) !==
                this.jwtHelperService.getValueFromToken(event.oldValue, JwtHelperService.USER_PREFERRED_USERNAME)) {
            this.ticketChangeRedirect(event);
        }
    }
    ticketChangeRedirect(event) {
        if (event.newValue) {
            this.navigate(this.router.url);
        }
        else {
            window.location.reload();
        }
    }
    async checkLogin(_, redirectUrl) {
        if (this.authenticationService.isLoggedIn() || this.withCredentials) {
            return true;
        }
        return this.redirectToUrl(redirectUrl);
    }
}
AuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuard, deps: [{ token: JwtHelperService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: JwtHelperService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthGuardEcm extends AuthGuardBase {
    async checkLogin(_, redirectUrl) {
        if (this.authenticationService.isEcmLoggedIn() || this.withCredentials) {
            return true;
        }
        return this.redirectToUrl(redirectUrl);
    }
}
AuthGuardEcm.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardEcm, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AuthGuardEcm.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardEcm, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardEcm, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthGuardBpm extends AuthGuardBase {
    async checkLogin(_, redirectUrl) {
        if (this.authenticationService.isBpmLoggedIn() || this.withCredentials) {
            return true;
        }
        return this.redirectToUrl(redirectUrl);
    }
}
AuthGuardBpm.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardBpm, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AuthGuardBpm.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardBpm, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardBpm, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const JSON_TYPE = ['application/json'];
class OAuth2Service {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    get apiClient() {
        return this.alfrescoApiService.getInstance().oauth2Auth;
    }
    request(opts) {
        return from(this.apiClient.callCustomApi(opts.url, opts.httpMethod, opts.pathParams, opts.queryParams, {}, {}, opts.bodyParam, JSON_TYPE, JSON_TYPE, Object));
    }
    get(opts) {
        return this.request({
            ...opts,
            httpMethod: 'GET'
        });
    }
    put(opts) {
        return this.request({
            ...opts,
            httpMethod: 'PUT'
        });
    }
    post(opts) {
        return this.request({
            ...opts,
            httpMethod: 'POST'
        });
    }
    delete(opts) {
        return this.request({
            ...opts,
            httpMethod: 'DELETE'
        });
    }
}
OAuth2Service.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OAuth2Service, deps: [{ token: AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
OAuth2Service.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OAuth2Service, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OAuth2Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDENTITY_MICRO_SERVICE_INGRESS = 'identity-adapter-service';
class UserAccessService {
    constructor(jwtHelperService, appConfigService, oAuth2Service) {
        this.jwtHelperService = jwtHelperService;
        this.appConfigService = appConfigService;
        this.oAuth2Service = oAuth2Service;
    }
    async fetchUserAccess() {
        if (!this.hasFetchedAccess()) {
            if (this.hasRolesInJwt()) {
                this.fetchAccessFromJwt();
            }
            else if (this.isOauth()) {
                await this.fetchAccessFromApi();
            }
        }
    }
    fetchAccessFromJwt() {
        this.globalAccess = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.REALM_ACCESS).roles;
        this.applicationAccess = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.RESOURCE_ACCESS);
    }
    async fetchAccessFromApi() {
        const url = `${this.identityHost}/${IDENTITY_MICRO_SERVICE_INGRESS}/v1/roles`;
        const appkey = this.appConfigService.get('application.key');
        const opts = appkey ? { url, queryParams: { appkey } } : { url };
        await this.oAuth2Service.get(opts)
            .pipe(catchError(() => of({
            globalAccess: {
                roles: []
            },
            applicationAccess: []
        })))
            .toPromise()
            .then((response) => {
            this.globalAccess = response.globalAccess.roles;
            this.applicationAccess = response.applicationAccess;
        });
    }
    hasRolesInJwt() {
        return !!this.jwtHelperService.getValueFromLocalToken(JwtHelperService.REALM_ACCESS);
    }
    hasFetchedAccess() {
        return !!this.globalAccess && !!this.applicationAccess;
    }
    get identityHost() {
        return `${this.appConfigService.get('bpmHost')}`;
    }
    isOauth() {
        return this.appConfigService.get('authType') === 'OAUTH';
    }
    /**
     * Checks for global roles access.
     *
     * @param rolesToCheck List of the roles to check
     * @returns True if it contains at least one of the given roles, false otherwise
     */
    hasGlobalAccess(rolesToCheck) {
        if (rolesToCheck?.length > 0) {
            return this.globalAccess ? this.globalAccess.some((role) => rolesToCheck.includes(role)) : false;
        }
        return true;
    }
    /**
     * Checks for global roles access.
     *
     * @param appName The app name
     * @param rolesToCheck List of the roles to check
     * @returns True if it contains at least one of the given roles, false otherwise
     */
    hasApplicationAccess(appName, rolesToCheck) {
        if (rolesToCheck?.length > 0) {
            const appAccess = this.hasRolesInJwt() ? this.applicationAccess[appName] : this.applicationAccess.find((app) => app.name === appName);
            return appAccess ? appAccess.roles.some(appRole => rolesToCheck.includes(appRole)) : false;
        }
        return true;
    }
    /**
     * Resets the cached user access
     */
    resetAccess() {
        this.globalAccess = undefined;
        this.applicationAccess = undefined;
    }
}
UserAccessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserAccessService, deps: [{ token: JwtHelperService }, { token: AppConfigService }, { token: OAuth2Service }], target: i0.ɵɵFactoryTarget.Injectable });
UserAccessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserAccessService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserAccessService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: JwtHelperService }, { type: AppConfigService }, { type: OAuth2Service }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthGuardSsoRoleService {
    constructor(userAccessService, router, dialog) {
        this.userAccessService = userAccessService;
        this.router = router;
        this.dialog = dialog;
    }
    async canActivate(route) {
        await this.userAccessService.fetchUserAccess();
        let hasRealmRole = false;
        let hasClientRole = true;
        if (route.data) {
            if (route.data['roles']) {
                const rolesToCheck = route.data['roles'];
                if (rolesToCheck.length === 0) {
                    hasRealmRole = true;
                }
                else {
                    const excludedRoles = route.data['excludedRoles'] || [];
                    hasRealmRole = await this.validateRoles(rolesToCheck, excludedRoles);
                }
            }
            if (route.data['clientRoles']) {
                const clientRoleName = route.params[route.data['clientRoles']];
                const rolesToCheck = route.data['roles'];
                hasClientRole = this.userAccessService.hasApplicationAccess(clientRoleName, rolesToCheck);
            }
        }
        const hasRole = hasRealmRole && hasClientRole;
        if (!hasRole && route?.data && route.data['redirectUrl']) {
            this.router.navigate(['/' + route.data['redirectUrl']]);
        }
        if (!hasRole) {
            this.dialog.closeAll();
        }
        return hasRole;
    }
    async validateRoles(rolesToCheck, excludedRoles) {
        if (excludedRoles?.length > 0) {
            return await this.hasRoles(rolesToCheck) && !await this.hasRoles(excludedRoles);
        }
        return this.hasRoles(rolesToCheck);
    }
    async hasRoles(roles = []) {
        return this.userAccessService.hasGlobalAccess(roles);
    }
}
AuthGuardSsoRoleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardSsoRoleService, deps: [{ token: UserAccessService }, { token: i2$4.Router }, { token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
AuthGuardSsoRoleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardSsoRoleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthGuardSsoRoleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UserAccessService }, { type: i2$4.Router }, { type: i1$4.MatDialog }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityRoleService {
    constructor(http, appConfig, logService) {
        this.http = http;
        this.appConfig = appConfig;
        this.logService = logService;
        this.contextRoot = '';
        this.identityHost = '';
        this.contextRoot = this.appConfig.get('apiHost', '');
        this.identityHost = this.appConfig.get('identityHost');
    }
    /**
     * Ret all roles
     *
     * @returns List of roles
     */
    getRoles(skipCount = 0, size = 5) {
        return this.http.get(`${this.identityHost}/roles`).pipe(map(res => this.preparePaginationWithRoles(res, skipCount, size)), catchError(error => this.handleError(error)));
    }
    preparePaginationWithRoles(roles, skipCount = 0, size = 5) {
        return {
            entries: roles.slice(skipCount, skipCount + size),
            pagination: {
                skipCount,
                maxItems: size,
                count: roles.length,
                hasMoreItems: false,
                totalItems: roles.length
            }
        };
    }
    /**
     * Add new role
     *
     * @param newRole Role model
     * @returns Server result payload
     */
    addRole(newRole) {
        if (newRole) {
            const request = newRole;
            return this.http
                .post(`${this.identityHost}/roles`, request)
                .pipe(catchError(error => this.handleError(error)));
        }
        return of();
    }
    /**
     * Delete existing role
     *
     * @param deletedRole Role model
     * @returns Server result payload
     */
    deleteRole(deletedRole) {
        return this.http
            .delete(`${this.identityHost}/roles-by-id/${deletedRole.id}`)
            .pipe(catchError(error => this.handleError(error)));
    }
    /**
     * Update existing role
     *
     * @param updatedRole Role model
     * @param roleId Role id
     * @returns Server result payload
     */
    updateRole(updatedRole, roleId) {
        if (updatedRole && roleId) {
            const request = updatedRole;
            return this.http
                .put(`${this.identityHost}/roles-by-id/${roleId}`, request)
                .pipe(catchError(error => this.handleError(error)));
        }
        return of();
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
IdentityRoleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityRoleService, deps: [{ token: i1$1.HttpClient }, { token: AppConfigService }, { token: LogService }], target: i0.ɵɵFactoryTarget.Injectable });
IdentityRoleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityRoleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityRoleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: AppConfigService }, { type: LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityUserService {
    constructor(jwtHelperService, oAuth2Service, appConfigService) {
        this.jwtHelperService = jwtHelperService;
        this.oAuth2Service = oAuth2Service;
        this.appConfigService = appConfigService;
    }
    get identityHost() {
        return `${this.appConfigService.get('identityHost')}`;
    }
    buildUserUrl() {
        return `${this.identityHost}/users`;
    }
    /**
     * Gets the name and other basic details of the current user.
     *
     * @returns The user's details
     */
    getCurrentUserInfo() {
        const familyName = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.FAMILY_NAME);
        const givenName = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.GIVEN_NAME);
        const email = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.USER_EMAIL);
        const username = this.jwtHelperService.getValueFromLocalToken(JwtHelperService.USER_PREFERRED_USERNAME);
        return { firstName: givenName, lastName: familyName, email, username };
    }
    /**
     * Find users based on search input.
     *
     * @param search Search query string
     * @returns List of users
     */
    findUsersByName(search) {
        if (search === '') {
            return of([]);
        }
        const url = this.buildUserUrl();
        const queryParams = { search };
        return this.oAuth2Service.get({ url, queryParams });
    }
    /**
     * Find users based on username input.
     *
     * @param username Search query string
     * @returns List of users
     */
    findUserByUsername(username) {
        if (username === '') {
            return of([]);
        }
        const url = this.buildUserUrl();
        const queryParams = { username };
        return this.oAuth2Service.get({ url, queryParams });
    }
    /**
     * Find users based on email input.
     *
     * @param email Search query string
     * @returns List of users
     */
    findUserByEmail(email) {
        if (email === '') {
            return of([]);
        }
        const url = this.buildUserUrl();
        const queryParams = { email };
        return this.oAuth2Service.get({ url, queryParams });
    }
    /**
     * Find users based on id input.
     *
     * @param id Search query string
     * @returns users object
     */
    findUserById(id) {
        if (id === '') {
            return of([]);
        }
        const url = this.buildUserUrl() + '/' + id;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Get client roles of a user for a particular client.
     *
     * @param userId ID of the target user
     * @param clientId ID of the client app
     * @returns List of client roles
     */
    getClientRoles(userId, clientId) {
        const url = `${this.identityHost}/users/${userId}/role-mappings/clients/${clientId}/composite`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Checks whether user has access to a client app.
     *
     * @param userId ID of the target user
     * @param clientId ID of the client app
     * @returns True if the user has access, false otherwise
     */
    checkUserHasClientApp(userId, clientId) {
        return this.getClientRoles(userId, clientId).pipe(map((clientRoles) => clientRoles.length > 0));
    }
    /**
     * Checks whether a user has any of the client app roles.
     *
     * @param userId ID of the target user
     * @param clientId ID of the client app
     * @param roleNames List of role names to check for
     * @returns True if the user has one or more of the roles, false otherwise
     */
    checkUserHasAnyClientAppRole(userId, clientId, roleNames) {
        return this.getClientRoles(userId, clientId).pipe(map((clientRoles) => {
            let hasRole = false;
            if (clientRoles.length > 0) {
                roleNames.forEach((roleName) => {
                    const role = clientRoles.find(({ name }) => name === roleName);
                    if (role) {
                        hasRole = true;
                        return;
                    }
                });
            }
            return hasRole;
        }));
    }
    /**
     * Gets the client ID for an application.
     *
     * @param applicationName Name of the application
     * @returns Client ID string
     */
    getClientIdByApplicationName(applicationName) {
        const url = `${this.identityHost}/clients`;
        const queryParams = { clientId: applicationName };
        return this.oAuth2Service
            .get({ url, queryParams })
            .pipe(map((response) => response && response.length > 0 ? response[0].id : ''));
    }
    /**
     * Checks if a user has access to an application.
     *
     * @param userId ID of the user
     * @param applicationName Name of the application
     * @returns True if the user has access, false otherwise
     */
    checkUserHasApplicationAccess(userId, applicationName) {
        return this.getClientIdByApplicationName(applicationName).pipe(switchMap((clientId) => this.checkUserHasClientApp(userId, clientId)));
    }
    /**
     * Checks if a user has any application role.
     *
     * @param userId ID of the target user
     * @param applicationName Name of the application
     * @param roleNames List of role names to check for
     * @returns True if the user has one or more of the roles, false otherwise
     */
    checkUserHasAnyApplicationRole(userId, applicationName, roleNames) {
        return this.getClientIdByApplicationName(applicationName).pipe(switchMap((clientId) => this.checkUserHasAnyClientAppRole(userId, clientId, roleNames)));
    }
    /**
     * Gets details for all users.
     *
     * @returns Array of user info objects
     */
    getUsers() {
        const url = this.buildUserUrl();
        return this.oAuth2Service.get({ url });
    }
    /**
     * Gets a list of roles for a user.
     *
     * @param userId ID of the user
     * @returns Array of role info objects
     */
    getUserRoles(userId) {
        const url = `${this.identityHost}/users/${userId}/role-mappings/realm/composite`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Gets an array of users (including the current user) who have any of the roles in the supplied list.
     *
     * @param roleNames List of role names to look for
     * @returns Array of user info objects
     */
    async getUsersByRolesWithCurrentUser(roleNames) {
        const filteredUsers = [];
        if (roleNames && roleNames.length > 0) {
            const users = await this.getUsers().toPromise();
            for (let i = 0; i < users.length; i++) {
                const hasAnyRole = await this.userHasAnyRole(users[i].id, roleNames);
                if (hasAnyRole) {
                    filteredUsers.push(users[i]);
                }
            }
        }
        return filteredUsers;
    }
    /**
     * Gets an array of users (not including the current user) who have any of the roles in the supplied list.
     *
     * @param roleNames List of role names to look for
     * @returns Array of user info objects
     */
    async getUsersByRolesWithoutCurrentUser(roleNames) {
        const filteredUsers = [];
        if (roleNames && roleNames.length > 0) {
            const currentUser = this.getCurrentUserInfo();
            let users = await this.getUsers().toPromise();
            users = users.filter(({ username }) => username !== currentUser.username);
            for (let i = 0; i < users.length; i++) {
                const hasAnyRole = await this.userHasAnyRole(users[i].id, roleNames);
                if (hasAnyRole) {
                    filteredUsers.push(users[i]);
                }
            }
        }
        return filteredUsers;
    }
    async userHasAnyRole(userId, roleNames) {
        const userRoles = await this.getUserRoles(userId).toPromise();
        const hasAnyRole = roleNames.some((roleName) => {
            const filteredRoles = userRoles.filter((userRole) => userRole.name.toLocaleLowerCase() === roleName.toLocaleLowerCase());
            return filteredRoles.length > 0;
        });
        return hasAnyRole;
    }
    /**
     * Checks if a user has one of the roles from a list.
     *
     * @param userId ID of the target user
     * @param roleNames Array of roles to check for
     * @returns True if the user has one of the roles, false otherwise
     */
    checkUserHasRole(userId, roleNames) {
        return this.getUserRoles(userId).pipe(map((userRoles) => {
            let hasRole = false;
            if (userRoles && userRoles.length > 0) {
                roleNames.forEach((roleName) => {
                    const role = userRoles.find(({ name }) => roleName === name);
                    if (role) {
                        hasRole = true;
                        return;
                    }
                });
            }
            return hasRole;
        }));
    }
    /**
     * Gets details for all users.
     *
     * @returns Array of user information objects.
     */
    queryUsers(requestQuery) {
        const url = this.buildUserUrl();
        const queryParams = { first: requestQuery.first, max: requestQuery.max };
        return this.getTotalUsersCount().pipe(switchMap((totalCount) => this.oAuth2Service.get({ url, queryParams }).pipe(map((response) => ({
            entries: response,
            pagination: {
                skipCount: requestQuery.first,
                maxItems: requestQuery.max,
                count: totalCount,
                hasMoreItems: false,
                totalItems: totalCount
            }
        })))));
    }
    /**
     * Gets users total count.
     *
     * @returns Number of users count.
     */
    getTotalUsersCount() {
        const url = this.buildUserUrl() + `/count`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Creates new user.
     *
     * @param newUser Object containing the new user details.
     * @returns Empty response when the user created.
     */
    createUser(newUser) {
        const url = this.buildUserUrl();
        const bodyParam = JSON.stringify(newUser);
        return this.oAuth2Service.post({ url, bodyParam });
    }
    /**
     * Updates user details.
     *
     * @param userId Id of the user.
     * @param updatedUser Object containing the user details.
     * @returns Empty response when the user updated.
     */
    updateUser(userId, updatedUser) {
        const url = this.buildUserUrl() + '/' + userId;
        const bodyParam = JSON.stringify(updatedUser);
        return this.oAuth2Service.put({ url, bodyParam });
    }
    /**
     * Deletes User.
     *
     * @param userId Id of the  user.
     * @returns Empty response when the user deleted.
     */
    deleteUser(userId) {
        const url = this.buildUserUrl() + '/' + userId;
        return this.oAuth2Service.delete({ url });
    }
    /**
     * Changes user password.
     *
     * @param userId Id of the user.
     * @param credentials Details of user Credentials.
     * @returns Empty response when the password changed.
     */
    changePassword(userId, newPassword) {
        const url = this.buildUserUrl() + '/' + userId + '/reset-password';
        const bodyParam = JSON.stringify(newPassword);
        return this.oAuth2Service.put({ url, bodyParam });
    }
    /**
     * Gets involved groups.
     *
     * @param userId Id of the user.
     * @returns Array of involved groups information objects.
     */
    getInvolvedGroups(userId) {
        const url = this.buildUserUrl() + '/' + userId + '/groups/';
        const pathParams = { id: userId };
        return this.oAuth2Service.get({ url, pathParams });
    }
    /**
     * Joins group.
     *
     * @param joinGroupRequest Details of join group request (IdentityJoinGroupRequestModel).
     * @returns Empty response when the user joined the group.
     */
    joinGroup(joinGroupRequest) {
        const url = this.buildUserUrl() + '/' + joinGroupRequest.userId + '/groups/' + joinGroupRequest.groupId;
        const bodyParam = JSON.stringify(joinGroupRequest);
        return this.oAuth2Service.put({ url, bodyParam });
    }
    /**
     * Leaves group.
     *
     * @param userId Id of the user.
     * @param groupId Id of the  group.
     * @returns Empty response when the user left the group.
     */
    leaveGroup(userId, groupId) {
        const url = this.buildUserUrl() + '/' + userId + '/groups/' + groupId;
        return this.oAuth2Service.delete({ url });
    }
    /**
     * Gets available roles
     *
     * @param userId Id of the user.
     * @returns Array of available roles information objects
     */
    getAvailableRoles(userId) {
        const url = this.buildUserUrl() + '/' + userId + '/role-mappings/realm/available';
        return this.oAuth2Service.get({ url });
    }
    /**
     * Gets assigned roles.
     *
     * @param userId Id of the user.
     * @returns Array of assigned roles information objects
     */
    getAssignedRoles(userId) {
        const url = this.buildUserUrl() + '/' + userId + '/role-mappings/realm';
        const pathParams = { id: userId };
        return this.oAuth2Service.get({ url, pathParams });
    }
    /**
     * Gets effective roles.
     *
     * @param userId Id of the user.
     * @returns Array of composite roles information objects
     */
    getEffectiveRoles(userId) {
        const url = this.buildUserUrl() + '/' + userId + '/role-mappings/realm/composite';
        const pathParams = { id: userId };
        return this.oAuth2Service.get({ url, pathParams });
    }
    /**
     * Assigns roles to the user.
     *
     * @param userId Id of the user.
     * @param roles Array of roles.
     * @returns Empty response when the role assigned.
     */
    assignRoles(userId, roles) {
        const url = this.buildUserUrl() + '/' + userId + '/role-mappings/realm';
        const bodyParam = JSON.stringify(roles);
        return this.oAuth2Service.post({ url, bodyParam });
    }
    /**
     * Removes assigned roles.
     *
     * @param userId Id of the user.
     * @param roles Array of roles.
     * @returns Empty response when the role removed.
     */
    removeRoles(userId, removedRoles) {
        const url = this.buildUserUrl() + '/' + userId + '/role-mappings/realm';
        const bodyParam = JSON.stringify(removedRoles);
        return this.oAuth2Service.delete({ url, bodyParam });
    }
}
IdentityUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserService, deps: [{ token: JwtHelperService }, { token: OAuth2Service }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
IdentityUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: JwtHelperService }, { type: OAuth2Service }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityGroupService {
    constructor(oAuth2Service, appConfigService) {
        this.oAuth2Service = oAuth2Service;
        this.appConfigService = appConfigService;
    }
    get identityHost() {
        return `${this.appConfigService.get('identityHost')}`;
    }
    /**
     * Gets all groups.
     *
     * @returns Array of group information objects
     */
    getGroups() {
        const url = `${this.identityHost}/groups`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Gets available roles
     *
     * @param groupId Id of the group.
     * @returns Array of available roles information objects
     */
    getAvailableRoles(groupId) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/realm/available`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Gets assigned roles
     *
     * @param groupId Id of the group.
     * @returns Array of available roles
     */
    getAssignedRoles(groupId) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/realm`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Assigns roles to the group
     *
     * @param groupId The ID of the group
     * @param roles Array of roles to assign
     */
    assignRoles(groupId, roles) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/realm`;
        const bodyParam = JSON.stringify(roles);
        return this.oAuth2Service.post({ url, bodyParam });
    }
    /**
     * Removes roles from the group
     *
     * @param groupId The ID of the group
     * @param roles Array of roles to remove
     */
    removeRoles(groupId, roles) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/realm`;
        const bodyParam = JSON.stringify(roles);
        return this.oAuth2Service.delete({ url, bodyParam });
    }
    /**
     * Get effective roles
     *
     * @param groupId Id of the group
     * @returns Array of effective roles
     */
    getEffectiveRoles(groupId) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/realm/composite`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Queries groups.
     *
     * @returns Array of user information objects
     */
    queryGroups(requestQuery) {
        const url = `${this.identityHost}/groups`;
        const queryParams = { first: requestQuery.first || 0, max: requestQuery.max || 5 };
        return this.getTotalGroupsCount().pipe(switchMap((totalCount) => this.oAuth2Service.get({ url, queryParams }).pipe(map((response) => ({
            entries: response,
            pagination: {
                skipCount: requestQuery.first,
                maxItems: requestQuery.max,
                count: totalCount.count,
                hasMoreItems: false,
                totalItems: totalCount.count
            }
        })))));
    }
    /**
     * Gets groups total count.
     *
     * @returns Number of groups count.
     */
    getTotalGroupsCount() {
        const url = `${this.identityHost}/groups/count`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Creates new group.
     *
     * @param newGroup Object of containing the new group details.
     * @returns Empty response when the group created.
     */
    createGroup(newGroup) {
        const url = `${this.identityHost}/groups`;
        const bodyParam = newGroup;
        return this.oAuth2Service.post({ url, bodyParam });
    }
    /**
     * Updates group details.
     *
     * @param groupId Id of the targeted group.
     * @param updatedGroup Object of containing the group details
     * @returns Empty response when the group updated.
     */
    updateGroup(groupId, updatedGroup) {
        const url = `${this.identityHost}/groups/${groupId}`;
        const bodyParam = JSON.stringify(updatedGroup);
        return this.oAuth2Service.put({ url, bodyParam });
    }
    /**
     * Deletes Group.
     *
     * @param groupId Id of the group.
     * @returns Empty response when the group deleted.
     */
    deleteGroup(groupId) {
        const url = `${this.identityHost}/groups/${groupId}`;
        return this.oAuth2Service.delete({ url });
    }
    /**
     * Finds groups filtered by name.
     *
     * @param searchParams Object containing the name filter string
     * @returns List of group information
     */
    findGroupsByName(searchParams) {
        if (searchParams.name === '') {
            return of([]);
        }
        const url = `${this.identityHost}/groups`;
        const queryParams = { search: searchParams.name };
        return this.oAuth2Service.get({ url, queryParams });
    }
    /**
     * Gets details for a specified group.
     *
     * @param groupId Id of the target group
     * @returns Group details
     */
    getGroupRoles(groupId) {
        const url = this.buildRolesUrl(groupId);
        return this.oAuth2Service.get({ url });
    }
    /**
     * Check that a group has one or more roles from the supplied list.
     *
     * @param groupId Id of the target group
     * @param roleNames Array of role names
     * @returns True if the group has one or more of the roles, false otherwise
     */
    checkGroupHasRole(groupId, roleNames) {
        return this.getGroupRoles(groupId).pipe(map((groupRoles) => {
            let hasRole = false;
            if (groupRoles?.length > 0) {
                roleNames.forEach((roleName) => {
                    const role = groupRoles.find(({ name }) => roleName === name);
                    if (role) {
                        hasRole = true;
                        return;
                    }
                });
            }
            return hasRole;
        }));
    }
    /**
     * Gets the client Id using the app name.
     *
     * @param applicationName Name of the app
     * @returns client Id string
     */
    getClientIdByApplicationName(applicationName) {
        const url = `${this.identityHost}/clients`;
        const queryParams = { clientId: applicationName };
        return this.oAuth2Service.get({ url, queryParams }).pipe(map((response) => response && response.length > 0 ? response[0].id : ''));
    }
    /**
     * Gets client roles.
     *
     * @param groupId Id of the target group
     * @param clientId Id of the client
     * @returns List of roles
     */
    getClientRoles(groupId, clientId) {
        const url = `${this.identityHost}/groups/${groupId}/role-mappings/clients/${clientId}`;
        return this.oAuth2Service.get({ url });
    }
    /**
     * Checks if a group has a client app.
     *
     * @param groupId Id of the target group
     * @param clientId Id of the client
     * @returns True if the group has the client app, false otherwise
     */
    checkGroupHasClientApp(groupId, clientId) {
        return this.getClientRoles(groupId, clientId).pipe(map((response) => response && response.length > 0));
    }
    /**
     * Check if a group has any of the client app roles in the supplied list.
     *
     * @param groupId Id of the target group
     * @param clientId Id of the client
     * @param roleNames Array of role names to check
     * @returns True if the group has one or more of the roles, false otherwise
     */
    checkGroupHasAnyClientAppRole(groupId, clientId, roleNames) {
        return this.getClientRoles(groupId, clientId).pipe(map((clientRoles) => {
            let hasRole = false;
            if (clientRoles.length > 0) {
                roleNames.forEach((roleName) => {
                    const role = clientRoles.find(({ name }) => name === roleName);
                    if (role) {
                        hasRole = true;
                        return;
                    }
                });
            }
            return hasRole;
        }));
    }
    buildRolesUrl(groupId) {
        return `${this.identityHost}/groups/${groupId}/role-mappings/realm/composite`;
    }
}
IdentityGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityGroupService, deps: [{ token: OAuth2Service }, { token: AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
IdentityGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityGroupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IdentityGroupService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: OAuth2Service }, { type: AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This object represent the user redirection guard.*
 */
class RedirectionModel {
    constructor(obj) {
        if (obj) {
            this.provider = obj.provider;
            this.url = obj.url || null;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdentityRoleModel {
    constructor(obj) {
        if (obj) {
            this.id = obj.id || null;
            this.name = obj.name || null;
            this.description = obj.description || null;
            this.clientRole = obj.clientRole || null;
            this.composite = obj.composite || null;
            this.containerId = obj.containerId || null;
            this.scopeParamRequired = obj.scopeParamRequired || null;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide authentication/authorization through OAuth2/OIDC protocol.
 */
class AuthService {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ROUTE_DEFAULT = '/';
class AuthenticationConfirmationComponent {
    constructor(auth, _router) {
        this.auth = auth;
        this._router = _router;
        const routeStored$ = from(this.auth.loginCallback()).pipe(map((route) => route || ROUTE_DEFAULT), catchError(() => of(ROUTE_DEFAULT)));
        routeStored$.pipe(first()).subscribe((route) => {
            this._router.navigateByUrl(route, { replaceUrl: true });
        });
    }
}
AuthenticationConfirmationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthenticationConfirmationComponent, deps: [{ token: AuthService }, { token: i2$4.Router }], target: i0.ɵɵFactoryTarget.Component });
AuthenticationConfirmationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AuthenticationConfirmationComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthenticationConfirmationComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: AuthService }, { type: i2$4.Router }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const routes = [
    { path: 'view/authentication-confirmation', component: AuthenticationConfirmationComponent }
];
class AuthRoutingModule {
}
AuthRoutingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AuthRoutingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AuthRoutingModule, imports: [i2$4.RouterModule], exports: [RouterModule] });
AuthRoutingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const AUTH_MODULE_CONFIG = new InjectionToken('AUTH_MODULE_CONFIG');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function authConfigFactory(authConfigService) {
    return authConfigService.loadConfig();
}
class AuthConfigService {
    constructor(appConfigService, authModuleConfig) {
        this.appConfigService = appConfigService;
        this.authModuleConfig = authModuleConfig;
    }
    get authConfig() {
        return this._authConfig;
    }
    loadConfig() {
        return this.appConfigService.onLoad.pipe(take(1)).toPromise().then(this.loadAppConfig.bind(this));
    }
    loadAppConfig() {
        const oauth2 = this.appConfigService.oauth2;
        const origin = this.getLocationOrigin();
        const redirectUri = this.getRedirectUri();
        const authConfig = {
            oidc: oauth2.implicitFlow || oauth2.codeFlow || false,
            issuer: oauth2.host,
            redirectUri,
            silentRefreshRedirectUri: `${origin}/silent-refresh.html`,
            postLogoutRedirectUri: `${origin}/${oauth2.redirectUriLogout}`,
            clientId: oauth2.clientId,
            scope: oauth2.scope,
            dummyClientSecret: oauth2.secret || '',
            ...(oauth2.codeFlow && { responseType: 'code' })
        };
        return authConfig;
    }
    getRedirectUri() {
        // required for this package as we handle the returned token on this view, with is provided by the AuthModule
        const viewUrl = `view/authentication-confirmation`;
        const useHash = this.authModuleConfig.useHash;
        const redirectUri = useHash
            ? `${this.getLocationOrigin()}/#/${viewUrl}`
            : `${this.getLocationOrigin()}/${viewUrl}`;
        const oauth2 = this.appConfigService.oauth2;
        // handle issue from the OIDC library with hashStrategy and implicitFlow, with would append &state to the url with would lead to error
        // `cannot match any routes`, and displaying the wildcard ** error page
        return oauth2.implicitFlow && useHash ? `${redirectUri}/?` : redirectUri;
    }
    getLocationOrigin() {
        return window.location.origin;
    }
}
AuthConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthConfigService, deps: [{ token: AppConfigService }, { token: AUTH_MODULE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
AuthConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthConfigService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AUTH_MODULE_CONFIG]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OidcAuthGuard {
    constructor(auth) {
        this.auth = auth;
    }
    canActivate(_route, state) {
        return this._isAuthenticated(state);
    }
    canActivateChild(_route, state) {
        return this._isAuthenticated(state);
    }
    _isAuthenticated(state) {
        if (this.auth.authenticated) {
            return true;
        }
        const loginResult = this.auth.login(state.url);
        if (loginResult instanceof Promise) {
            return loginResult.then(() => true).catch(() => false);
        }
        return false;
    }
}
OidcAuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OidcAuthGuard, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable });
OidcAuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OidcAuthGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OidcAuthGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OIDCAuthenticationService extends BaseAuthenticationService {
    constructor() {
        super();
        this.authStorage = inject(OAuthStorage);
        this.oauthService = inject(OAuthService);
        this.authConfig = inject(AuthConfigService);
        this.auth = inject(AuthService);
        this.supportCodeFlow = true;
        this.alfrescoApi.alfrescoApiInitialized.subscribe(() => {
            this.alfrescoApi.getInstance().reply('logged-in', () => {
                this.onLogin.next();
            });
        });
    }
    isEcmLoggedIn() {
        return this.isLoggedIn();
    }
    isBpmLoggedIn() {
        return this.isLoggedIn();
    }
    isLoggedIn() {
        return this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken();
    }
    isLoggedInWith(_provider) {
        return this.isLoggedIn();
    }
    isOauth() {
        return this.appConfig.get(AppConfigValues.AUTHTYPE) === 'OAUTH';
    }
    isImplicitFlow() {
        return !!this.appConfig.oauth2?.implicitFlow;
    }
    isAuthCodeFlow() {
        return !!this.appConfig.oauth2?.codeFlow;
    }
    login(username, password, rememberMe = false) {
        return this.auth.baseAuthLogin(username, password).pipe(map((response) => {
            this.saveRememberMeCookie(rememberMe);
            this.onLogin.next(response);
            return {
                type: this.appConfig.get(AppConfigValues.PROVIDERS),
                ticket: response
            };
        }), catchError((err) => this.handleError(err)));
    }
    ssoImplicitLogin() {
        this.oauthService.initLoginFlow();
    }
    ssoCodeFlowLogin() {
        this.oauthService.initCodeFlow();
    }
    isRememberMeSet() {
        return true;
    }
    logout() {
        this.oauthService.logOut();
        return EMPTY;
    }
    getToken() {
        return this.authStorage.getItem(JwtHelperService.USER_ACCESS_TOKEN);
    }
    reset() {
        const config = this.authConfig.loadAppConfig();
        this.auth.updateIDPConfiguration(config);
        const oauth2 = this.appConfig.oauth2;
        if (config.oidc && oauth2.silentLogin) {
            this.auth.login();
        }
    }
}
OIDCAuthenticationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OIDCAuthenticationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OIDCAuthenticationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OIDCAuthenticationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: OIDCAuthenticationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const isPromise = (value) => value && typeof value.then === 'function';
class RedirectAuthService extends AuthService {
    constructor(oauthService, _oauthStorage, authConfig) {
        super();
        this.oauthService = oauthService;
        this._oauthStorage = _oauthStorage;
        this._loadDiscoveryDocumentPromise = Promise.resolve(false);
        this.authConfig = authConfig;
    }
    /** Get whether the user has valid Id/Access tokens. */
    get authenticated() {
        return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
    }
    init() {
        this.oauthService.clearHashAfterLogin = true;
        this.authenticated$ = this.oauthService.events.pipe(startWith(undefined), map(() => this.authenticated), distinctUntilChanged(), shareReplay(1));
        this.idpUnreachable$ = this.oauthService.events.pipe(filter((event) => event.type === 'discovery_document_load_error'), map((event) => event.reason));
        if (isPromise(this.authConfig)) {
            return this.authConfig.then((config) => this.configureAuth(config));
        }
        return this.configureAuth(this.authConfig);
    }
    logout() {
        this.oauthService.logOut();
    }
    ensureDiscoveryDocument() {
        this._loadDiscoveryDocumentPromise = this._loadDiscoveryDocumentPromise
            .catch(() => false)
            .then((loaded) => {
            if (!loaded) {
                return this.oauthService.loadDiscoveryDocument().then(() => true);
            }
            return true;
        });
        return this._loadDiscoveryDocumentPromise;
    }
    login(currentUrl) {
        let stateKey;
        if (currentUrl) {
            const randomValue = window.crypto.getRandomValues(new Uint32Array(1))[0];
            stateKey = `auth_state_${randomValue}${Date.now()}`;
            this._oauthStorage.setItem(stateKey, JSON.stringify(currentUrl || {}));
        }
        // initLoginFlow will initialize the login flow in either code or implicit depending on the configuration
        this.ensureDiscoveryDocument().then(() => void this.oauthService.initLoginFlow(stateKey));
    }
    baseAuthLogin(username, password) {
        this.oauthService.useHttpBasicAuth = true;
        return from(this.oauthService.fetchTokenUsingPasswordFlow(username, password)).pipe(map((response) => {
            const props = new Map();
            props.set('id_token', response.id_token);
            // for backward compatibility we need to set the response in our storage
            this.oauthService['storeAccessTokenResponse'](response.access_token, response.refresh_token, response.expires_in, response.scope, props);
            return response;
        }));
    }
    async loginCallback() {
        return this.ensureDiscoveryDocument()
            .then(() => this.oauthService.tryLogin({ preventClearHashAfterLogin: false }))
            .then(() => this._getRedirectUrl());
    }
    _getRedirectUrl() {
        const DEFAULT_REDIRECT = '/';
        const stateKey = this.oauthService.state;
        if (stateKey) {
            const stateStringified = this._oauthStorage.getItem(stateKey);
            if (stateStringified) {
                // cleanup state from storage
                this._oauthStorage.removeItem(stateKey);
                return JSON.parse(stateStringified);
            }
        }
        return DEFAULT_REDIRECT;
    }
    configureAuth(config) {
        this.oauthService.configure(config);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        if (config.sessionChecksEnabled) {
            this.oauthService.events.pipe(filter((event) => event.type === 'session_terminated')).subscribe(() => {
                this.oauthService.logOut();
            });
        }
        return this.ensureDiscoveryDocument().then(() => void this.oauthService.setupAutomaticSilentRefresh()).catch(() => {
            // catch error to prevent the app from crashing when trying to access unprotected routes
        });
    }
    updateIDPConfiguration(config) {
        this.oauthService.configure(config);
    }
}
RedirectAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RedirectAuthService, deps: [{ token: i1$9.OAuthService }, { token: i1$9.OAuthStorage }, { token: AUTH_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
RedirectAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RedirectAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RedirectAuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$9.OAuthService }, { type: i1$9.OAuthStorage }, { type: i1$9.AuthConfig, decorators: [{
                    type: Inject,
                    args: [AUTH_CONFIG]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function loginFactory(oAuthService, storage, config) {
    const service = new RedirectAuthService(oAuthService, storage, config);
    return () => service.init();
}
class AuthModule {
    static forRoot(config = { useHash: false }) {
        return {
            ngModule: AuthModule,
            providers: [{ provide: AUTH_MODULE_CONFIG, useValue: config }]
        };
    }
}
AuthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AuthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AuthModule, declarations: [AuthenticationConfirmationComponent], imports: [AuthRoutingModule, i1$9.OAuthModule] });
AuthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthModule, providers: [
        { provide: OAuthStorage, useExisting: StorageService },
        { provide: AuthGuard, useClass: OidcAuthGuard },
        { provide: AuthGuardEcm, useClass: OidcAuthGuard },
        { provide: AuthGuardBpm, useClass: OidcAuthGuard },
        { provide: AuthenticationService, useClass: OIDCAuthenticationService },
        { provide: AlfrescoApiService, useClass: AlfrescoApiServiceWithAngularBasedHttpClient },
        {
            provide: AUTH_CONFIG,
            useFactory: authConfigFactory,
            deps: [AuthConfigService]
        },
        RedirectAuthService,
        { provide: AuthService, useExisting: RedirectAuthService },
        {
            provide: APP_INITIALIZER,
            useFactory: loginFactory,
            deps: [OAuthService, OAuthStorage, AUTH_CONFIG],
            multi: true
        }
    ], imports: [AuthRoutingModule, OAuthModule.forRoot()] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AuthModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AuthenticationConfirmationComponent],
                    imports: [AuthRoutingModule, OAuthModule.forRoot()],
                    providers: [
                        { provide: OAuthStorage, useExisting: StorageService },
                        { provide: AuthGuard, useClass: OidcAuthGuard },
                        { provide: AuthGuardEcm, useClass: OidcAuthGuard },
                        { provide: AuthGuardBpm, useClass: OidcAuthGuard },
                        { provide: AuthenticationService, useClass: OIDCAuthenticationService },
                        { provide: AlfrescoApiService, useClass: AlfrescoApiServiceWithAngularBasedHttpClient },
                        {
                            provide: AUTH_CONFIG,
                            useFactory: authConfigFactory,
                            deps: [AuthConfigService]
                        },
                        RedirectAuthService,
                        { provide: AuthService, useExisting: RedirectAuthService },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: loginFactory,
                            deps: [OAuthService, OAuthStorage, AUTH_CONFIG],
                            multi: true
                        }
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PageTitleService {
    constructor(titleService, appConfig, translationService) {
        this.titleService = titleService;
        this.appConfig = appConfig;
        this.translationService = translationService;
        this.originalTitle = '';
        this.translatedTitle = '';
        translationService.translate.onLangChange.subscribe(() => this.onLanguageChanged());
        translationService.translate.onTranslationChange.subscribe(() => this.onLanguageChanged());
    }
    /**
     * Sets the page title.
     *
     * @param value The new title
     */
    setTitle(value = '') {
        this.originalTitle = value;
        this.translatedTitle = this.translationService.instant(value);
        this.updateTitle();
    }
    onLanguageChanged() {
        this.translatedTitle = this.translationService.instant(this.originalTitle);
        this.updateTitle();
    }
    updateTitle() {
        const name = this.appConfig.get('application.name') || 'Alfresco ADF Application';
        const title = this.translatedTitle ? `${this.translatedTitle} - ${name}` : `${name}`;
        this.titleService.setTitle(title);
    }
}
PageTitleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PageTitleService, deps: [{ token: i1$2.Title }, { token: AppConfigService }, { token: TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
PageTitleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PageTitleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PageTitleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Title }, { type: AppConfigService }, { type: TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SortByCategoryMapperService {
    constructor() {
        this.defaultCategories = [];
    }
    mapItems(items, defaultCategories) {
        this.defaultCategories = defaultCategories;
        const sortedItems = this.sortItems(items);
        const itemsByCategory = this.mapItemsByCategory(sortedItems);
        const itemsSortedByCategory = this.sortCategories(itemsByCategory);
        return itemsSortedByCategory;
    }
    mapItemsByCategory(items) {
        const itemsByCategoryObject = {};
        items.forEach((item) => {
            const category = this.mapItemDefaultCategory(item);
            if (!itemsByCategoryObject[category]) {
                itemsByCategoryObject[category] = [];
            }
            itemsByCategoryObject[category].push(item);
        });
        const itemsByCategory = Object.keys(itemsByCategoryObject).map((key) => {
            const category = key;
            return { category, items: itemsByCategoryObject[category] };
        });
        return itemsByCategory;
    }
    sortItems(items) {
        return items.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name));
    }
    sortCategories(itemsByCategory) {
        return itemsByCategory.sort((itemA, itemB) => {
            if (itemB.category === '' && itemA.category === '') {
                return 0;
            }
            if (itemA.category === '') {
                return 1;
            }
            if (itemB.category === '') {
                return -1;
            }
            return itemA.category.localeCompare(itemB.category);
        });
    }
    mapItemDefaultCategory(listItem) {
        const itemCategory = listItem.category;
        if (!this.isDefaultCategory(itemCategory)) {
            return (itemCategory ?? '');
        }
        return '';
    }
    isDefaultCategory(category) {
        return category ? this.defaultCategories.includes(category) : false;
    }
}
SortByCategoryMapperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortByCategoryMapperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SortByCategoryMapperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortByCategoryMapperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SortByCategoryMapperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DownloadService {
    constructor() {
        this.saveData = (() => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style.display = 'none';
            return (fileData, format, fileName) => {
                let blob = null;
                if (format === 'blob' || format === 'data') {
                    blob = new Blob([fileData], { type: 'octet/stream' });
                }
                if (format === 'object' || format === 'json') {
                    const json = JSON.stringify(fileData);
                    blob = new Blob([json], { type: 'octet/stream' });
                }
                if (blob) {
                    if (typeof window.navigator !== 'undefined' &&
                        window.navigator['msSaveOrOpenBlob']) {
                        window.navigator['msSaveOrOpenBlob'](blob, fileName);
                    }
                    else {
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                }
            };
        })();
    }
    /**
     * Invokes content download for a Blob with a file name.
     *
     * @param blob Content to download.
     * @param fileName Name of the resulting file.
     */
    downloadBlob(blob, fileName) {
        this.saveData(blob, 'blob', fileName);
    }
    /**
     * Invokes content download for a data array with a file name.
     *
     * @param data Data to download.
     * @param fileName Name of the resulting file.
     */
    downloadData(data, fileName) {
        this.saveData(data, 'data', fileName);
    }
    /**
     * Invokes content download for a JSON object with a file name.
     *
     * @param json JSON object to download.
     * @param fileName Name of the resulting file.
     */
    downloadJSON(json, fileName) {
        this.saveData(json, 'json', fileName);
    }
    /**
     * Invokes the download of the file by its URL address.
     *
     * @param url Url address pointing to the file.
     * @param fileName Name of the file download.
     */
    downloadUrl(url, fileName) {
        if (url && fileName) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.download = fileName;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
DownloadService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DownloadService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UserInfoMode;
(function (UserInfoMode) {
    UserInfoMode["ALL"] = "ALL";
    UserInfoMode["CONTENT"] = "CONTENT";
    UserInfoMode["PROCESS"] = "PROCESS";
    UserInfoMode["SSO"] = "SSO";
    UserInfoMode["CONTENT_SSO"] = "CONTENT_SSO";
})(UserInfoMode || (UserInfoMode = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ADF_AMOUNT_SETTINGS, ADF_COMMENTS_SERVICE, AboutComponent, AboutExtensionListComponent, AboutGithubLinkComponent, AboutLicenseListComponent, AboutModule, AboutPanelDirective, AboutPlatformVersionComponent, AboutRepositoryInfoComponent, AboutServerSettingsComponent, AboutStatusListComponent, AddNotificationStorybookComponent, AlfrescoApiMock, AlfrescoApiService, AlfrescoApiServiceMock, AmountWidgetComponent, AppConfigModule, AppConfigPipe, AppConfigService, AppConfigServiceMock, AppConfigValues, AuthBearerInterceptor, AuthGuard, AuthGuardBase, AuthGuardBpm, AuthGuardEcm, AuthGuardSsoRoleService, AuthModule, AuthRoutingModule, AuthService, AuthenticationConfirmationComponent, AuthenticationService, BaseEvent, BaseUIEvent, BaseViewerWidgetComponent, BlankPageComponent, BlankPageModule, BoundaryDateFieldValidator, BpmProductVersionModel, ButtonsMenuComponent, ButtonsMenuModule, ByPassFormRuleManager, CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, CardItemTypeService, CardViewArrayItemComponent, CardViewArrayItemModel, CardViewBaseItemModel, CardViewBoolItemComponent, CardViewBoolItemModel, CardViewComponent, CardViewContentProxyDirective, CardViewDateItemComponent, CardViewDateItemModel, CardViewDatetimeItemModel, CardViewFloatItemModel, CardViewIntItemModel, CardViewItemFloatValidator, CardViewItemIntValidator, CardViewItemLengthValidator, CardViewItemMatchValidator, CardViewItemMinMaxValidator, CardViewKeyValuePairsItemComponent, CardViewKeyValuePairsItemModel, CardViewMapItemComponent, CardViewMapItemModel, CardViewModule, CardViewSelectItemComponent, CardViewSelectItemModel, CardViewTextItemComponent, CardViewTextItemModel, CardViewUpdateService, CheckboxWidgetComponent, ClipboardComponent, ClipboardDirective, ClipboardModule, ClipboardService, ColumnsSelectorComponent, CommentListComponent, CommentListModule, CommentModel, CommentsComponent, CommentsModule, ContainerColumnModel, ContainerModel, ContentLinkModel, ContextMenuDirective, ContextMenuModule, ContextMenuOverlayService, CookieService, CookieServiceMock, CoreAutomationService, CoreModule, CoreTestingModule, CustomEmptyContentTemplateDirective, CustomLoadingContentTemplateDirective, CustomNoPermissionTemplateDirective, DEFAULT_PAGINATION, DataCellEvent, DataCellEventModel, DataColumnComponent, DataColumnListComponent, DataRowActionEvent, DataRowActionModel, DataRowEvent, DataSorting, DataTableCellComponent, DataTableComponent, DataTableModule, DataTableRowComponent, DataTableSchema, DataTableService, DateCellComponent, DateColumnHeaderComponent, DateFieldValidator, DateTimeFieldValidator, DateTimeWidgetComponent, DateWidgetComponent, DebugAppConfigService, DecimalNumberModel, DecimalNumberPipe, DirectiveModule, DisplayMode, DisplayTextWidgetComponent, DownloadPromptActions, DownloadPromptDialogComponent, DownloadService, DropZoneDirective, DynamicComponentMapper, DynamicComponentResolver, EXTENDIBLE_COMPONENT, EditJsonDialogComponent, EditJsonDialogModule, EmptyContentComponent, EmptyListBodyDirective, EmptyListComponent, EmptyListFooterDirective, EmptyListHeaderDirective, ErrorContentComponent, ErrorMessageModel, ErrorWidgetComponent, EventMock, FORM_FIELD_VALIDATORS, FORM_RULES_MANAGER, FileSizeCellComponent, FileSizePipe, FileTypePipe, FileUtils, FilterOutArrayObjectsByPropPipe, FilterStringPipe, FixedValueFieldValidator, FormBaseComponent, FormBaseModule, FormErrorEvent, FormEvent, FormFieldComponent, FormFieldEvent, FormFieldModel, FormFieldTypes, FormModel, FormOutcomeEvent, FormOutcomeModel, FormRendererComponent, FormRenderingService, FormRulesEvent, FormRulesManager, FormService, FormWidgetModel, FormatSpacePipe, FullNamePipe, HeaderFilterTemplateDirective, HeaderLayoutComponent, HighlightDirective, HighlightPipe, HighlightTransformService, HyperlinkWidgetComponent, IconComponent, IconModule, IdentityGroupService, IdentityRoleModel, IdentityRoleService, IdentityUserInfoComponent, IdentityUserInfoModule, IdentityUserService, ImgViewerComponent, InfinitePaginationComponent, InfiniteSelectScrollDirective, InfoDrawerButtonsDirective, InfoDrawerComponent, InfoDrawerContentDirective, InfoDrawerLayoutComponent, InfoDrawerModule, InfoDrawerTabComponent, InfoDrawerTitleDirective, InitialUsernamePipe, InplaceFormInputComponent, InputMaskDirective, JSON_TYPE, JsonCellComponent, JsonWidgetComponent, JwtHelperService, LanguageMenuComponent, LanguageMenuModule, LanguagePickerComponent, LanguageService, LayoutContainerComponent, LoadingContentTemplateDirective, LocalizedDatePipe, LocalizedRolePipe, LocationCellComponent, LogLevelsEnum, LogService, LoginComponent, LoginDialogComponent, LoginDialogPanelComponent, LoginErrorEvent, LoginFooterDirective, LoginHeaderDirective, LoginModule, LoginSubmitEvent, LoginSuccessEvent, LogoutDirective, MASK_DIRECTIVE, MOMENT_DATE_FORMATS, MainMenuDataTableTemplateDirective, MaterialModule, MaxDateFieldValidator, MaxDateTimeFieldValidator, MaxLengthFieldValidator, MaxValueFieldValidator, MediaPlayerComponent, MimeTypeIconPipe, MinDateFieldValidator, MinDateTimeFieldValidator, MinLengthFieldValidator, MinValueFieldValidator, ModuleListComponent, MomentDateAdapter, MomentDatePipe, MomentDateTimePipe, MultiValuePipe, MultilineTextWidgetComponentComponent, NOTIFICATION_TYPE, NoContentTemplateDirective, NoPermissionTemplateDirective, NotificationHistoryComponent, NotificationHistoryModule, NotificationService, NumberFieldValidator, NumberWidgetComponent, OAuth2Service, ObjectDataColumn, ObjectDataRow, ObjectDataTableAdapter, ObjectUtils, OidcAuthGuard, PackageListComponent, PageTitleService, PaginationComponent, PaginationModel, PaginationModule, PdfPasswordDialogComponent, PdfThumbComponent, PdfThumbListComponent, PdfViewerComponent, PipeModule, RedirectAuthService, RedirectionModel, RegExFieldValidator, RequestPaginationModel, RequiredFieldValidator, SEARCH_AUTOCOMPLETE_VALUE_ACCESSOR, SearchTextInputComponent, SearchTextModule, SearchTextStateEnum, SearchTriggerDirective, SelectFilterInputComponent, ShowHeaderMode, SidebarActionMenuComponent, SidebarMenuDirective, SidebarMenuExpandIconDirective, SidebarMenuTitleIconDirective, SidenavLayoutComponent, SidenavLayoutContentDirective, SidenavLayoutHeaderDirective, SidenavLayoutModule, SidenavLayoutNavigationDirective, SnackbarContentComponent, SnackbarContentModule, SortByCategoryMapperService, SortingPickerComponent, SortingPickerModule, StartFormCustomButtonDirective, Status, StorageService, StringUtils, TRANSLATION_PROVIDER, TabModel, TaskProcessVariableModel, TemplateModule, TextWidgetComponent, ThumbnailService, TimeAgoPipe, ToolbarComponent, ToolbarDividerComponent, ToolbarModule, ToolbarTitleComponent, TooltipCardDirective, TranslateLoaderService, TranslationMock, TranslationService, TxtViewerComponent, UnknownFormatComponent, UnknownWidgetComponent, UploadDirective, UploadWidgetContentLinkModel, UploadWidgetContentLinkModelOptions, UrlService, UserAccessService, UserInfoMode, UserPreferenceValues, UserPreferencesService, ValidateFormEvent, ValidateFormFieldEvent, ViewUtilService, ViewerComponent, ViewerExtensionDirective, ViewerModule, ViewerMoreActionsComponent, ViewerOpenWithComponent, ViewerRenderComponent, ViewerSidebarComponent, ViewerToolbarActionsComponent, ViewerToolbarComponent, ViewerToolbarCustomActionsComponent, WIDGET_DIRECTIVES, WidgetComponent, WidgetVisibilityService, complexVisibilityJsonNotVisible, complexVisibilityJsonVisible, dataIcon, dataSizeInBytes, dataText, dateColumns, dateRows, error, fakeForm, fakeFormChainedVisibilityJson, fakeFormCheckBoxVisibilityJson, fakeFormJson, fakeTaskProcessVariableModels, formDefVisibilitiFieldDependsOnNextOne, formDefVisibilitiFieldDependsOnPreviousOne, formDefinitionDropdownField, formDefinitionRequiredField, formDefinitionTwoTextFields, formModelTabs, formReadonlyTwoTextFields, formRulesManagerFactory, formTest, formValues, getDataColumnMock, info, isNumberValue, locationColumns, locationRows, logLevels, loginFactory, rootInitiator, searchAnimation, setupTestBed, startFormAmountWidgetMock, startFormDateWidgetMock, startFormDropdownDefinitionMock, startFormNumberWidgetMock, startFormRadioButtonWidgetMock, startFormTextDefinitionMock, startMockForm, startMockFormWithTab, tabInvalidFormVisibility, tabVisibilityJsonMock, transformKeyToObject, warning };
